
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iMXGO", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $dadb02c422dd01c9$export$ffb0004e005737fa, (v) => $dadb02c422dd01c9$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $dadb02c422dd01c9$export$34b9dba7ce09269b, (v) => $dadb02c422dd01c9$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $dadb02c422dd01c9$export$25062201e9e25d76, (v) => $dadb02c422dd01c9$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dadb02c422dd01c9$export$ffb0004e005737fa;
var $dadb02c422dd01c9$export$34b9dba7ce09269b;
var $dadb02c422dd01c9$export$25062201e9e25d76;
'use strict';

var $lldlC = parcelRequire("lldlC");
var $dadb02c422dd01c9$var$k = Symbol.for("react.element"), $dadb02c422dd01c9$var$l = Symbol.for("react.fragment"), $dadb02c422dd01c9$var$m = Object.prototype.hasOwnProperty, $dadb02c422dd01c9$var$n = $lldlC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $dadb02c422dd01c9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dadb02c422dd01c9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$dadb02c422dd01c9$var$m.call(a, b) && !$dadb02c422dd01c9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $dadb02c422dd01c9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $dadb02c422dd01c9$var$n.current
    };
}
$dadb02c422dd01c9$export$ffb0004e005737fa = $dadb02c422dd01c9$var$l;
$dadb02c422dd01c9$export$34b9dba7ce09269b = $dadb02c422dd01c9$var$q;
$dadb02c422dd01c9$export$25062201e9e25d76 = $dadb02c422dd01c9$var$q;

});
parcelRegister("lldlC", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6DiRb"));

});
parcelRegister("6DiRb", function(module, exports) {

$parcel$export(module.exports, "Children", () => $4d4503235f3369fe$export$dca3b0875bd9a954, (v) => $4d4503235f3369fe$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $4d4503235f3369fe$export$16fa2f45be04daa8, (v) => $4d4503235f3369fe$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $4d4503235f3369fe$export$ffb0004e005737fa, (v) => $4d4503235f3369fe$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $4d4503235f3369fe$export$e2c29f18771995cb, (v) => $4d4503235f3369fe$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $4d4503235f3369fe$export$221d75b3f55bb0bd, (v) => $4d4503235f3369fe$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $4d4503235f3369fe$export$5f8d39834fd61797, (v) => $4d4503235f3369fe$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $4d4503235f3369fe$export$74bf444e3cd11ea5, (v) => $4d4503235f3369fe$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $4d4503235f3369fe$export$ae55be85d98224ed, (v) => $4d4503235f3369fe$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $4d4503235f3369fe$export$e530037191fcd5d7, (v) => $4d4503235f3369fe$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $4d4503235f3369fe$export$fd42f52fd3ae1109, (v) => $4d4503235f3369fe$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $4d4503235f3369fe$export$c8a8987d4410bf2d, (v) => $4d4503235f3369fe$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $4d4503235f3369fe$export$d38cd72104c1f0e9, (v) => $4d4503235f3369fe$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $4d4503235f3369fe$export$7d1e3a5e95ceca43, (v) => $4d4503235f3369fe$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $4d4503235f3369fe$export$257a8862b851cb5b, (v) => $4d4503235f3369fe$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $4d4503235f3369fe$export$a8257692ac88316c, (v) => $4d4503235f3369fe$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $4d4503235f3369fe$export$488013bae63b21da, (v) => $4d4503235f3369fe$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $4d4503235f3369fe$export$7c73462e0d25e514, (v) => $4d4503235f3369fe$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $4d4503235f3369fe$export$7568632d0d33d16d, (v) => $4d4503235f3369fe$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $4d4503235f3369fe$export$88948ce120ea2619, (v) => $4d4503235f3369fe$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $4d4503235f3369fe$export$35808ee640e87ca7, (v) => $4d4503235f3369fe$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $4d4503235f3369fe$export$fae74005e78b1a27, (v) => $4d4503235f3369fe$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $4d4503235f3369fe$export$dc8fbce3eb94dc1e, (v) => $4d4503235f3369fe$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $4d4503235f3369fe$export$6a7bc4e911dc01cf, (v) => $4d4503235f3369fe$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $4d4503235f3369fe$export$6d9c69b0de29b591, (v) => $4d4503235f3369fe$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $4d4503235f3369fe$export$f680877a34711e37, (v) => $4d4503235f3369fe$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $4d4503235f3369fe$export$d5a552a76deda3c2, (v) => $4d4503235f3369fe$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $4d4503235f3369fe$export$aaabe4eda9ed9969, (v) => $4d4503235f3369fe$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $4d4503235f3369fe$export$e5c5a5f917a5871c, (v) => $4d4503235f3369fe$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $4d4503235f3369fe$export$1538c33de8887b59, (v) => $4d4503235f3369fe$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $4d4503235f3369fe$export$13e3392192263954, (v) => $4d4503235f3369fe$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $4d4503235f3369fe$export$b8f5890fc79d6aca, (v) => $4d4503235f3369fe$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $4d4503235f3369fe$export$60241385465d0a34, (v) => $4d4503235f3369fe$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $4d4503235f3369fe$export$306c0aa65ff9ec16, (v) => $4d4503235f3369fe$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $4d4503235f3369fe$export$7b286972b8d8ccbf, (v) => $4d4503235f3369fe$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $4d4503235f3369fe$export$83d89fbfd8236492, (v) => $4d4503235f3369fe$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4d4503235f3369fe$export$dca3b0875bd9a954;
var $4d4503235f3369fe$export$16fa2f45be04daa8;
var $4d4503235f3369fe$export$ffb0004e005737fa;
var $4d4503235f3369fe$export$e2c29f18771995cb;
var $4d4503235f3369fe$export$221d75b3f55bb0bd;
var $4d4503235f3369fe$export$5f8d39834fd61797;
var $4d4503235f3369fe$export$74bf444e3cd11ea5;
var $4d4503235f3369fe$export$ae55be85d98224ed;
var $4d4503235f3369fe$export$e530037191fcd5d7;
var $4d4503235f3369fe$export$fd42f52fd3ae1109;
var $4d4503235f3369fe$export$c8a8987d4410bf2d;
var $4d4503235f3369fe$export$d38cd72104c1f0e9;
var $4d4503235f3369fe$export$7d1e3a5e95ceca43;
var $4d4503235f3369fe$export$257a8862b851cb5b;
var $4d4503235f3369fe$export$a8257692ac88316c;
var $4d4503235f3369fe$export$488013bae63b21da;
var $4d4503235f3369fe$export$7c73462e0d25e514;
var $4d4503235f3369fe$export$7568632d0d33d16d;
var $4d4503235f3369fe$export$88948ce120ea2619;
var $4d4503235f3369fe$export$35808ee640e87ca7;
var $4d4503235f3369fe$export$fae74005e78b1a27;
var $4d4503235f3369fe$export$dc8fbce3eb94dc1e;
var $4d4503235f3369fe$export$6a7bc4e911dc01cf;
var $4d4503235f3369fe$export$6d9c69b0de29b591;
var $4d4503235f3369fe$export$f680877a34711e37;
var $4d4503235f3369fe$export$d5a552a76deda3c2;
var $4d4503235f3369fe$export$aaabe4eda9ed9969;
var $4d4503235f3369fe$export$e5c5a5f917a5871c;
var $4d4503235f3369fe$export$1538c33de8887b59;
var $4d4503235f3369fe$export$13e3392192263954;
var $4d4503235f3369fe$export$b8f5890fc79d6aca;
var $4d4503235f3369fe$export$60241385465d0a34;
var $4d4503235f3369fe$export$306c0aa65ff9ec16;
var $4d4503235f3369fe$export$7b286972b8d8ccbf;
var $4d4503235f3369fe$export$83d89fbfd8236492;
'use strict';
var $4d4503235f3369fe$var$l = Symbol.for("react.element"), $4d4503235f3369fe$var$n = Symbol.for("react.portal"), $4d4503235f3369fe$var$p = Symbol.for("react.fragment"), $4d4503235f3369fe$var$q = Symbol.for("react.strict_mode"), $4d4503235f3369fe$var$r = Symbol.for("react.profiler"), $4d4503235f3369fe$var$t = Symbol.for("react.provider"), $4d4503235f3369fe$var$u = Symbol.for("react.context"), $4d4503235f3369fe$var$v = Symbol.for("react.forward_ref"), $4d4503235f3369fe$var$w = Symbol.for("react.suspense"), $4d4503235f3369fe$var$x = Symbol.for("react.memo"), $4d4503235f3369fe$var$y = Symbol.for("react.lazy"), $4d4503235f3369fe$var$z = Symbol.iterator;
function $4d4503235f3369fe$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d4503235f3369fe$var$z && a[$4d4503235f3369fe$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d4503235f3369fe$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4d4503235f3369fe$var$C = Object.assign, $4d4503235f3369fe$var$D = {};
function $4d4503235f3369fe$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4d4503235f3369fe$var$D;
    this.updater = e || $4d4503235f3369fe$var$B;
}
$4d4503235f3369fe$var$E.prototype.isReactComponent = {};
$4d4503235f3369fe$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4d4503235f3369fe$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4d4503235f3369fe$var$F() {}
$4d4503235f3369fe$var$F.prototype = $4d4503235f3369fe$var$E.prototype;
function $4d4503235f3369fe$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4d4503235f3369fe$var$D;
    this.updater = e || $4d4503235f3369fe$var$B;
}
var $4d4503235f3369fe$var$H = $4d4503235f3369fe$var$G.prototype = new $4d4503235f3369fe$var$F;
$4d4503235f3369fe$var$H.constructor = $4d4503235f3369fe$var$G;
$4d4503235f3369fe$var$C($4d4503235f3369fe$var$H, $4d4503235f3369fe$var$E.prototype);
$4d4503235f3369fe$var$H.isPureReactComponent = !0;
var $4d4503235f3369fe$var$I = Array.isArray, $4d4503235f3369fe$var$J = Object.prototype.hasOwnProperty, $4d4503235f3369fe$var$K = {
    current: null
}, $4d4503235f3369fe$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4d4503235f3369fe$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4d4503235f3369fe$var$J.call(b, d) && !$4d4503235f3369fe$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4d4503235f3369fe$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4d4503235f3369fe$var$K.current
    };
}
function $4d4503235f3369fe$var$N(a, b) {
    return {
        $$typeof: $4d4503235f3369fe$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4d4503235f3369fe$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4d4503235f3369fe$var$l;
}
function $4d4503235f3369fe$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4d4503235f3369fe$var$P = /\/+/g;
function $4d4503235f3369fe$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4d4503235f3369fe$var$escape("" + a.key) : b.toString(36);
}
function $4d4503235f3369fe$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4d4503235f3369fe$var$l:
                case $4d4503235f3369fe$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4d4503235f3369fe$var$Q(h, 0) : d, $4d4503235f3369fe$var$I(c) ? (e = "", null != a && (e = a.replace($4d4503235f3369fe$var$P, "$&/") + "/"), $4d4503235f3369fe$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4d4503235f3369fe$var$O(c) && (c = $4d4503235f3369fe$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4d4503235f3369fe$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4d4503235f3369fe$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4d4503235f3369fe$var$Q(k, g);
        h += $4d4503235f3369fe$var$R(k, b, e, f, c);
    }
    else if (f = $4d4503235f3369fe$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4d4503235f3369fe$var$Q(k, g++), h += $4d4503235f3369fe$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4d4503235f3369fe$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4d4503235f3369fe$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4d4503235f3369fe$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4d4503235f3369fe$var$U = {
    current: null
}, $4d4503235f3369fe$var$V = {
    transition: null
}, $4d4503235f3369fe$var$W = {
    ReactCurrentDispatcher: $4d4503235f3369fe$var$U,
    ReactCurrentBatchConfig: $4d4503235f3369fe$var$V,
    ReactCurrentOwner: $4d4503235f3369fe$var$K
};
$4d4503235f3369fe$export$dca3b0875bd9a954 = {
    map: $4d4503235f3369fe$var$S,
    forEach: function(a, b, e) {
        $4d4503235f3369fe$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4d4503235f3369fe$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4d4503235f3369fe$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4d4503235f3369fe$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4d4503235f3369fe$export$16fa2f45be04daa8 = $4d4503235f3369fe$var$E;
$4d4503235f3369fe$export$ffb0004e005737fa = $4d4503235f3369fe$var$p;
$4d4503235f3369fe$export$e2c29f18771995cb = $4d4503235f3369fe$var$r;
$4d4503235f3369fe$export$221d75b3f55bb0bd = $4d4503235f3369fe$var$G;
$4d4503235f3369fe$export$5f8d39834fd61797 = $4d4503235f3369fe$var$q;
$4d4503235f3369fe$export$74bf444e3cd11ea5 = $4d4503235f3369fe$var$w;
$4d4503235f3369fe$export$ae55be85d98224ed = $4d4503235f3369fe$var$W;
$4d4503235f3369fe$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4d4503235f3369fe$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4d4503235f3369fe$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4d4503235f3369fe$var$J.call(b, f) && !$4d4503235f3369fe$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4d4503235f3369fe$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4d4503235f3369fe$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4d4503235f3369fe$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4d4503235f3369fe$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4d4503235f3369fe$export$c8a8987d4410bf2d = $4d4503235f3369fe$var$M;
$4d4503235f3369fe$export$d38cd72104c1f0e9 = function(a) {
    var b = $4d4503235f3369fe$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4d4503235f3369fe$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4d4503235f3369fe$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4d4503235f3369fe$var$v,
        render: a
    };
};
$4d4503235f3369fe$export$a8257692ac88316c = $4d4503235f3369fe$var$O;
$4d4503235f3369fe$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4d4503235f3369fe$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4d4503235f3369fe$var$T
    };
};
$4d4503235f3369fe$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4d4503235f3369fe$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4d4503235f3369fe$export$7568632d0d33d16d = function(a) {
    var b = $4d4503235f3369fe$var$V.transition;
    $4d4503235f3369fe$var$V.transition = {};
    try {
        a();
    } finally{
        $4d4503235f3369fe$var$V.transition = b;
    }
};
$4d4503235f3369fe$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$4d4503235f3369fe$export$35808ee640e87ca7 = function(a, b) {
    return $4d4503235f3369fe$var$U.current.useCallback(a, b);
};
$4d4503235f3369fe$export$fae74005e78b1a27 = function(a) {
    return $4d4503235f3369fe$var$U.current.useContext(a);
};
$4d4503235f3369fe$export$dc8fbce3eb94dc1e = function() {};
$4d4503235f3369fe$export$6a7bc4e911dc01cf = function(a) {
    return $4d4503235f3369fe$var$U.current.useDeferredValue(a);
};
$4d4503235f3369fe$export$6d9c69b0de29b591 = function(a, b) {
    return $4d4503235f3369fe$var$U.current.useEffect(a, b);
};
$4d4503235f3369fe$export$f680877a34711e37 = function() {
    return $4d4503235f3369fe$var$U.current.useId();
};
$4d4503235f3369fe$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4d4503235f3369fe$var$U.current.useImperativeHandle(a, b, e);
};
$4d4503235f3369fe$export$aaabe4eda9ed9969 = function(a, b) {
    return $4d4503235f3369fe$var$U.current.useInsertionEffect(a, b);
};
$4d4503235f3369fe$export$e5c5a5f917a5871c = function(a, b) {
    return $4d4503235f3369fe$var$U.current.useLayoutEffect(a, b);
};
$4d4503235f3369fe$export$1538c33de8887b59 = function(a, b) {
    return $4d4503235f3369fe$var$U.current.useMemo(a, b);
};
$4d4503235f3369fe$export$13e3392192263954 = function(a, b, e) {
    return $4d4503235f3369fe$var$U.current.useReducer(a, b, e);
};
$4d4503235f3369fe$export$b8f5890fc79d6aca = function(a) {
    return $4d4503235f3369fe$var$U.current.useRef(a);
};
$4d4503235f3369fe$export$60241385465d0a34 = function(a) {
    return $4d4503235f3369fe$var$U.current.useState(a);
};
$4d4503235f3369fe$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4d4503235f3369fe$var$U.current.useSyncExternalStore(a, b, e);
};
$4d4503235f3369fe$export$7b286972b8d8ccbf = function() {
    return $4d4503235f3369fe$var$U.current.useTransition();
};
$4d4503235f3369fe$export$83d89fbfd8236492 = "18.3.0";

});



parcelRegister("d95iC", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $992039f60b605604$export$ae55be85d98224ed, (v) => $992039f60b605604$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $992039f60b605604$export$d39a5bbd09211389, (v) => $992039f60b605604$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $992039f60b605604$export$882461b6382ed46c, (v) => $992039f60b605604$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $992039f60b605604$export$466bfc07425424d5, (v) => $992039f60b605604$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $992039f60b605604$export$cd75ccfd720a3cd4, (v) => $992039f60b605604$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $992039f60b605604$export$fa8d919ba61d84db, (v) => $992039f60b605604$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $992039f60b605604$export$757ceba2d55c277e, (v) => $992039f60b605604$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $992039f60b605604$export$b3890eb0ae9dca99, (v) => $992039f60b605604$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $992039f60b605604$export$502457920280e6be, (v) => $992039f60b605604$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $992039f60b605604$export$c78a37762a8d58e1, (v) => $992039f60b605604$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $992039f60b605604$export$dc54d992c10e8a18, (v) => $992039f60b605604$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $992039f60b605604$export$83d89fbfd8236492, (v) => $992039f60b605604$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $992039f60b605604$export$ae55be85d98224ed;
var $992039f60b605604$export$d39a5bbd09211389;
var $992039f60b605604$export$882461b6382ed46c;
var $992039f60b605604$export$466bfc07425424d5;
var $992039f60b605604$export$cd75ccfd720a3cd4;
var $992039f60b605604$export$fa8d919ba61d84db;
var $992039f60b605604$export$757ceba2d55c277e;
var $992039f60b605604$export$b3890eb0ae9dca99;
var $992039f60b605604$export$502457920280e6be;
var $992039f60b605604$export$c78a37762a8d58e1;
var $992039f60b605604$export$dc54d992c10e8a18;
var $992039f60b605604$export$83d89fbfd8236492;
'use strict';

var $lldlC = parcelRequire("lldlC");

var $7zDBh = parcelRequire("7zDBh");
function $992039f60b605604$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $992039f60b605604$var$da = new Set, $992039f60b605604$var$ea = {};
function $992039f60b605604$var$fa(a, b) {
    $992039f60b605604$var$ha(a, b);
    $992039f60b605604$var$ha(a + "Capture", b);
}
function $992039f60b605604$var$ha(a, b) {
    $992039f60b605604$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$992039f60b605604$var$da.add(b[a]);
}
var $992039f60b605604$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $992039f60b605604$var$ja = Object.prototype.hasOwnProperty, $992039f60b605604$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $992039f60b605604$var$la = {}, $992039f60b605604$var$ma = {};
function $992039f60b605604$var$oa(a) {
    if ($992039f60b605604$var$ja.call($992039f60b605604$var$ma, a)) return !0;
    if ($992039f60b605604$var$ja.call($992039f60b605604$var$la, a)) return !1;
    if ($992039f60b605604$var$ka.test(a)) return $992039f60b605604$var$ma[a] = !0;
    $992039f60b605604$var$la[a] = !0;
    return !1;
}
function $992039f60b605604$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $992039f60b605604$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $992039f60b605604$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $992039f60b605604$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $992039f60b605604$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $992039f60b605604$var$z[b] = new $992039f60b605604$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $992039f60b605604$var$ra = /[\-:]([a-z])/g;
function $992039f60b605604$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($992039f60b605604$var$ra, $992039f60b605604$var$sa);
    $992039f60b605604$var$z[b] = new $992039f60b605604$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($992039f60b605604$var$ra, $992039f60b605604$var$sa);
    $992039f60b605604$var$z[b] = new $992039f60b605604$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($992039f60b605604$var$ra, $992039f60b605604$var$sa);
    $992039f60b605604$var$z[b] = new $992039f60b605604$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$992039f60b605604$var$z.xlinkHref = new $992039f60b605604$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $992039f60b605604$var$z[a] = new $992039f60b605604$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $992039f60b605604$var$ta(a, b, c, d) {
    var e = $992039f60b605604$var$z.hasOwnProperty(b) ? $992039f60b605604$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $992039f60b605604$var$qa(b, c, e, d) && (c = null), d || null === e ? $992039f60b605604$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $992039f60b605604$var$ua = $lldlC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $992039f60b605604$var$va = Symbol.for("react.element"), $992039f60b605604$var$wa = Symbol.for("react.portal"), $992039f60b605604$var$ya = Symbol.for("react.fragment"), $992039f60b605604$var$za = Symbol.for("react.strict_mode"), $992039f60b605604$var$Aa = Symbol.for("react.profiler"), $992039f60b605604$var$Ba = Symbol.for("react.provider"), $992039f60b605604$var$Ca = Symbol.for("react.context"), $992039f60b605604$var$Da = Symbol.for("react.forward_ref"), $992039f60b605604$var$Ea = Symbol.for("react.suspense"), $992039f60b605604$var$Fa = Symbol.for("react.suspense_list"), $992039f60b605604$var$Ga = Symbol.for("react.memo"), $992039f60b605604$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $992039f60b605604$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $992039f60b605604$var$Ja = Symbol.iterator;
function $992039f60b605604$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $992039f60b605604$var$Ja && a[$992039f60b605604$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $992039f60b605604$var$A = Object.assign, $992039f60b605604$var$La;
function $992039f60b605604$var$Ma(a) {
    if (void 0 === $992039f60b605604$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $992039f60b605604$var$La = b && b[1] || "";
    }
    return "\n" + $992039f60b605604$var$La + a;
}
var $992039f60b605604$var$Na = !1;
function $992039f60b605604$var$Oa(a, b) {
    if (!a || $992039f60b605604$var$Na) return "";
    $992039f60b605604$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $992039f60b605604$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $992039f60b605604$var$Ma(a) : "";
}
function $992039f60b605604$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $992039f60b605604$var$Ma(a.type);
        case 16:
            return $992039f60b605604$var$Ma("Lazy");
        case 13:
            return $992039f60b605604$var$Ma("Suspense");
        case 19:
            return $992039f60b605604$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $992039f60b605604$var$Oa(a.type, !1), a;
        case 11:
            return a = $992039f60b605604$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $992039f60b605604$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $992039f60b605604$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $992039f60b605604$var$ya:
            return "Fragment";
        case $992039f60b605604$var$wa:
            return "Portal";
        case $992039f60b605604$var$Aa:
            return "Profiler";
        case $992039f60b605604$var$za:
            return "StrictMode";
        case $992039f60b605604$var$Ea:
            return "Suspense";
        case $992039f60b605604$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $992039f60b605604$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $992039f60b605604$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $992039f60b605604$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $992039f60b605604$var$Ga:
            return b = a.displayName || null, null !== b ? b : $992039f60b605604$var$Qa(a.type) || "Memo";
        case $992039f60b605604$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $992039f60b605604$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $992039f60b605604$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $992039f60b605604$var$Qa(b);
        case 8:
            return b === $992039f60b605604$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $992039f60b605604$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $992039f60b605604$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $992039f60b605604$var$Ua(a) {
    var b = $992039f60b605604$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $992039f60b605604$var$Va(a) {
    a._valueTracker || (a._valueTracker = $992039f60b605604$var$Ua(a));
}
function $992039f60b605604$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $992039f60b605604$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $992039f60b605604$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $992039f60b605604$var$Ya(a, b) {
    var c = b.checked;
    return $992039f60b605604$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $992039f60b605604$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $992039f60b605604$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $992039f60b605604$var$ab(a, b) {
    b = b.checked;
    null != b && $992039f60b605604$var$ta(a, "checked", b, !1);
}
function $992039f60b605604$var$bb(a, b) {
    $992039f60b605604$var$ab(a, b);
    var c = $992039f60b605604$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $992039f60b605604$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $992039f60b605604$var$cb(a, b.type, $992039f60b605604$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $992039f60b605604$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $992039f60b605604$var$cb(a, b, c) {
    if ("number" !== b || $992039f60b605604$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $992039f60b605604$var$eb = Array.isArray;
function $992039f60b605604$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $992039f60b605604$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $992039f60b605604$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($992039f60b605604$var$p(91));
    return $992039f60b605604$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $992039f60b605604$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($992039f60b605604$var$p(92));
            if ($992039f60b605604$var$eb(c)) {
                if (1 < c.length) throw Error($992039f60b605604$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $992039f60b605604$var$Sa(c)
    };
}
function $992039f60b605604$var$ib(a, b) {
    var c = $992039f60b605604$var$Sa(b.value), d = $992039f60b605604$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $992039f60b605604$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $992039f60b605604$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $992039f60b605604$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $992039f60b605604$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $992039f60b605604$var$mb, $992039f60b605604$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $992039f60b605604$var$mb = $992039f60b605604$var$mb || document.createElement("div");
        $992039f60b605604$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $992039f60b605604$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $992039f60b605604$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $992039f60b605604$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $992039f60b605604$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($992039f60b605604$var$pb).forEach(function(a) {
    $992039f60b605604$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $992039f60b605604$var$pb[b] = $992039f60b605604$var$pb[a];
    });
});
function $992039f60b605604$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $992039f60b605604$var$pb.hasOwnProperty(a) && $992039f60b605604$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $992039f60b605604$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $992039f60b605604$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $992039f60b605604$var$tb = $992039f60b605604$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $992039f60b605604$var$ub(a, b) {
    if (b) {
        if ($992039f60b605604$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($992039f60b605604$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($992039f60b605604$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($992039f60b605604$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($992039f60b605604$var$p(62));
    }
}
function $992039f60b605604$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $992039f60b605604$var$wb = null;
function $992039f60b605604$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $992039f60b605604$var$yb = null, $992039f60b605604$var$zb = null, $992039f60b605604$var$Ab = null;
function $992039f60b605604$var$Bb(a) {
    if (a = $992039f60b605604$var$Cb(a)) {
        if ("function" !== typeof $992039f60b605604$var$yb) throw Error($992039f60b605604$var$p(280));
        var b = a.stateNode;
        b && (b = $992039f60b605604$var$Db(b), $992039f60b605604$var$yb(a.stateNode, a.type, b));
    }
}
function $992039f60b605604$var$Eb(a) {
    $992039f60b605604$var$zb ? $992039f60b605604$var$Ab ? $992039f60b605604$var$Ab.push(a) : $992039f60b605604$var$Ab = [
        a
    ] : $992039f60b605604$var$zb = a;
}
function $992039f60b605604$var$Fb() {
    if ($992039f60b605604$var$zb) {
        var a = $992039f60b605604$var$zb, b = $992039f60b605604$var$Ab;
        $992039f60b605604$var$Ab = $992039f60b605604$var$zb = null;
        $992039f60b605604$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$992039f60b605604$var$Bb(b[a]);
    }
}
function $992039f60b605604$var$Gb(a, b) {
    return a(b);
}
function $992039f60b605604$var$Hb() {}
var $992039f60b605604$var$Ib = !1;
function $992039f60b605604$var$Jb(a, b, c) {
    if ($992039f60b605604$var$Ib) return a(b, c);
    $992039f60b605604$var$Ib = !0;
    try {
        return $992039f60b605604$var$Gb(a, b, c);
    } finally{
        if ($992039f60b605604$var$Ib = !1, null !== $992039f60b605604$var$zb || null !== $992039f60b605604$var$Ab) $992039f60b605604$var$Hb(), $992039f60b605604$var$Fb();
    }
}
function $992039f60b605604$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $992039f60b605604$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($992039f60b605604$var$p(231, b, typeof c));
    return c;
}
var $992039f60b605604$var$Lb = !1;
if ($992039f60b605604$var$ia) try {
    var $992039f60b605604$var$Mb = {};
    Object.defineProperty($992039f60b605604$var$Mb, "passive", {
        get: function() {
            $992039f60b605604$var$Lb = !0;
        }
    });
    window.addEventListener("test", $992039f60b605604$var$Mb, $992039f60b605604$var$Mb);
    window.removeEventListener("test", $992039f60b605604$var$Mb, $992039f60b605604$var$Mb);
} catch (a) {
    $992039f60b605604$var$Lb = !1;
}
function $992039f60b605604$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $992039f60b605604$var$Ob = !1, $992039f60b605604$var$Pb = null, $992039f60b605604$var$Qb = !1, $992039f60b605604$var$Rb = null, $992039f60b605604$var$Sb = {
    onError: function(a) {
        $992039f60b605604$var$Ob = !0;
        $992039f60b605604$var$Pb = a;
    }
};
function $992039f60b605604$var$Tb(a, b, c, d, e, f, g, h, k) {
    $992039f60b605604$var$Ob = !1;
    $992039f60b605604$var$Pb = null;
    $992039f60b605604$var$Nb.apply($992039f60b605604$var$Sb, arguments);
}
function $992039f60b605604$var$Ub(a, b, c, d, e, f, g, h, k) {
    $992039f60b605604$var$Tb.apply(this, arguments);
    if ($992039f60b605604$var$Ob) {
        if ($992039f60b605604$var$Ob) {
            var l = $992039f60b605604$var$Pb;
            $992039f60b605604$var$Ob = !1;
            $992039f60b605604$var$Pb = null;
        } else throw Error($992039f60b605604$var$p(198));
        $992039f60b605604$var$Qb || ($992039f60b605604$var$Qb = !0, $992039f60b605604$var$Rb = l);
    }
}
function $992039f60b605604$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $992039f60b605604$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $992039f60b605604$var$Xb(a) {
    if ($992039f60b605604$var$Vb(a) !== a) throw Error($992039f60b605604$var$p(188));
}
function $992039f60b605604$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $992039f60b605604$var$Vb(a);
        if (null === b) throw Error($992039f60b605604$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $992039f60b605604$var$Xb(e), a;
                if (f === d) return $992039f60b605604$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($992039f60b605604$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($992039f60b605604$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($992039f60b605604$var$p(190));
    }
    if (3 !== c.tag) throw Error($992039f60b605604$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $992039f60b605604$var$Zb(a) {
    a = $992039f60b605604$var$Yb(a);
    return null !== a ? $992039f60b605604$var$$b(a) : null;
}
function $992039f60b605604$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $992039f60b605604$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $992039f60b605604$var$ac = $7zDBh.unstable_scheduleCallback, $992039f60b605604$var$bc = $7zDBh.unstable_cancelCallback, $992039f60b605604$var$cc = $7zDBh.unstable_shouldYield, $992039f60b605604$var$dc = $7zDBh.unstable_requestPaint, $992039f60b605604$var$B = $7zDBh.unstable_now, $992039f60b605604$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $992039f60b605604$var$fc = $7zDBh.unstable_ImmediatePriority, $992039f60b605604$var$gc = $7zDBh.unstable_UserBlockingPriority, $992039f60b605604$var$hc = $7zDBh.unstable_NormalPriority, $992039f60b605604$var$ic = $7zDBh.unstable_LowPriority, $992039f60b605604$var$jc = $7zDBh.unstable_IdlePriority, $992039f60b605604$var$kc = null, $992039f60b605604$var$lc = null;
function $992039f60b605604$var$mc(a) {
    if ($992039f60b605604$var$lc && "function" === typeof $992039f60b605604$var$lc.onCommitFiberRoot) try {
        $992039f60b605604$var$lc.onCommitFiberRoot($992039f60b605604$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $992039f60b605604$var$oc = Math.clz32 ? Math.clz32 : $992039f60b605604$var$nc, $992039f60b605604$var$pc = Math.log, $992039f60b605604$var$qc = Math.LN2;
function $992039f60b605604$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($992039f60b605604$var$pc(a) / $992039f60b605604$var$qc | 0) | 0;
}
var $992039f60b605604$var$rc = 64, $992039f60b605604$var$sc = 4194304;
function $992039f60b605604$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $992039f60b605604$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $992039f60b605604$var$tc(h) : (f &= g, 0 !== f && (d = $992039f60b605604$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $992039f60b605604$var$tc(g) : 0 !== f && (d = $992039f60b605604$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $992039f60b605604$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $992039f60b605604$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $992039f60b605604$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $992039f60b605604$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $992039f60b605604$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $992039f60b605604$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $992039f60b605604$var$yc() {
    var a = $992039f60b605604$var$rc;
    $992039f60b605604$var$rc <<= 1;
    0 === ($992039f60b605604$var$rc & 4194240) && ($992039f60b605604$var$rc = 64);
    return a;
}
function $992039f60b605604$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $992039f60b605604$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $992039f60b605604$var$oc(b);
    a[b] = c;
}
function $992039f60b605604$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $992039f60b605604$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $992039f60b605604$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $992039f60b605604$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $992039f60b605604$var$C = 0;
function $992039f60b605604$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $992039f60b605604$var$Ec, $992039f60b605604$var$Fc, $992039f60b605604$var$Gc, $992039f60b605604$var$Hc, $992039f60b605604$var$Ic, $992039f60b605604$var$Jc = !1, $992039f60b605604$var$Kc = [], $992039f60b605604$var$Lc = null, $992039f60b605604$var$Mc = null, $992039f60b605604$var$Nc = null, $992039f60b605604$var$Oc = new Map, $992039f60b605604$var$Pc = new Map, $992039f60b605604$var$Qc = [], $992039f60b605604$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $992039f60b605604$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $992039f60b605604$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $992039f60b605604$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $992039f60b605604$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $992039f60b605604$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $992039f60b605604$var$Pc.delete(b.pointerId);
    }
}
function $992039f60b605604$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $992039f60b605604$var$Cb(b), null !== b && $992039f60b605604$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $992039f60b605604$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $992039f60b605604$var$Lc = $992039f60b605604$var$Tc($992039f60b605604$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $992039f60b605604$var$Mc = $992039f60b605604$var$Tc($992039f60b605604$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $992039f60b605604$var$Nc = $992039f60b605604$var$Tc($992039f60b605604$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $992039f60b605604$var$Oc.set(f, $992039f60b605604$var$Tc($992039f60b605604$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $992039f60b605604$var$Pc.set(f, $992039f60b605604$var$Tc($992039f60b605604$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $992039f60b605604$var$Vc(a) {
    var b = $992039f60b605604$var$Wc(a.target);
    if (null !== b) {
        var c = $992039f60b605604$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $992039f60b605604$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $992039f60b605604$var$Ic(a.priority, function() {
                        $992039f60b605604$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $992039f60b605604$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $992039f60b605604$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $992039f60b605604$var$wb = d;
            c.target.dispatchEvent(d);
            $992039f60b605604$var$wb = null;
        } else return b = $992039f60b605604$var$Cb(c), null !== b && $992039f60b605604$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $992039f60b605604$var$Zc(a, b, c) {
    $992039f60b605604$var$Xc(a) && c.delete(b);
}
function $992039f60b605604$var$$c() {
    $992039f60b605604$var$Jc = !1;
    null !== $992039f60b605604$var$Lc && $992039f60b605604$var$Xc($992039f60b605604$var$Lc) && ($992039f60b605604$var$Lc = null);
    null !== $992039f60b605604$var$Mc && $992039f60b605604$var$Xc($992039f60b605604$var$Mc) && ($992039f60b605604$var$Mc = null);
    null !== $992039f60b605604$var$Nc && $992039f60b605604$var$Xc($992039f60b605604$var$Nc) && ($992039f60b605604$var$Nc = null);
    $992039f60b605604$var$Oc.forEach($992039f60b605604$var$Zc);
    $992039f60b605604$var$Pc.forEach($992039f60b605604$var$Zc);
}
function $992039f60b605604$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $992039f60b605604$var$Jc || ($992039f60b605604$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $992039f60b605604$var$$c)));
}
function $992039f60b605604$var$bd(a) {
    function b(b) {
        return $992039f60b605604$var$ad(b, a);
    }
    if (0 < $992039f60b605604$var$Kc.length) {
        $992039f60b605604$var$ad($992039f60b605604$var$Kc[0], a);
        for(var c = 1; c < $992039f60b605604$var$Kc.length; c++){
            var d = $992039f60b605604$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $992039f60b605604$var$Lc && $992039f60b605604$var$ad($992039f60b605604$var$Lc, a);
    null !== $992039f60b605604$var$Mc && $992039f60b605604$var$ad($992039f60b605604$var$Mc, a);
    null !== $992039f60b605604$var$Nc && $992039f60b605604$var$ad($992039f60b605604$var$Nc, a);
    $992039f60b605604$var$Oc.forEach(b);
    $992039f60b605604$var$Pc.forEach(b);
    for(c = 0; c < $992039f60b605604$var$Qc.length; c++)d = $992039f60b605604$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $992039f60b605604$var$Qc.length && (c = $992039f60b605604$var$Qc[0], null === c.blockedOn);)$992039f60b605604$var$Vc(c), null === c.blockedOn && $992039f60b605604$var$Qc.shift();
}
var $992039f60b605604$var$cd = $992039f60b605604$var$ua.ReactCurrentBatchConfig, $992039f60b605604$var$dd = !0;
function $992039f60b605604$var$ed(a, b, c, d) {
    var e = $992039f60b605604$var$C, f = $992039f60b605604$var$cd.transition;
    $992039f60b605604$var$cd.transition = null;
    try {
        $992039f60b605604$var$C = 1, $992039f60b605604$var$fd(a, b, c, d);
    } finally{
        $992039f60b605604$var$C = e, $992039f60b605604$var$cd.transition = f;
    }
}
function $992039f60b605604$var$gd(a, b, c, d) {
    var e = $992039f60b605604$var$C, f = $992039f60b605604$var$cd.transition;
    $992039f60b605604$var$cd.transition = null;
    try {
        $992039f60b605604$var$C = 4, $992039f60b605604$var$fd(a, b, c, d);
    } finally{
        $992039f60b605604$var$C = e, $992039f60b605604$var$cd.transition = f;
    }
}
function $992039f60b605604$var$fd(a, b, c, d) {
    if ($992039f60b605604$var$dd) {
        var e = $992039f60b605604$var$Yc(a, b, c, d);
        if (null === e) $992039f60b605604$var$hd(a, b, d, $992039f60b605604$var$id, c), $992039f60b605604$var$Sc(a, d);
        else if ($992039f60b605604$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($992039f60b605604$var$Sc(a, d), b & 4 && -1 < $992039f60b605604$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $992039f60b605604$var$Cb(e);
                null !== f && $992039f60b605604$var$Ec(f);
                f = $992039f60b605604$var$Yc(a, b, c, d);
                null === f && $992039f60b605604$var$hd(a, b, d, $992039f60b605604$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $992039f60b605604$var$hd(a, b, d, null, c);
    }
}
var $992039f60b605604$var$id = null;
function $992039f60b605604$var$Yc(a, b, c, d) {
    $992039f60b605604$var$id = null;
    a = $992039f60b605604$var$xb(d);
    a = $992039f60b605604$var$Wc(a);
    if (null !== a) {
        if (b = $992039f60b605604$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $992039f60b605604$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $992039f60b605604$var$id = a;
    return null;
}
function $992039f60b605604$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($992039f60b605604$var$ec()){
                case $992039f60b605604$var$fc:
                    return 1;
                case $992039f60b605604$var$gc:
                    return 4;
                case $992039f60b605604$var$hc:
                case $992039f60b605604$var$ic:
                    return 16;
                case $992039f60b605604$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $992039f60b605604$var$kd = null, $992039f60b605604$var$ld = null, $992039f60b605604$var$md = null;
function $992039f60b605604$var$nd() {
    if ($992039f60b605604$var$md) return $992039f60b605604$var$md;
    var a, b = $992039f60b605604$var$ld, c = b.length, d, e = "value" in $992039f60b605604$var$kd ? $992039f60b605604$var$kd.value : $992039f60b605604$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $992039f60b605604$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $992039f60b605604$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $992039f60b605604$var$pd() {
    return !0;
}
function $992039f60b605604$var$qd() {
    return !1;
}
function $992039f60b605604$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $992039f60b605604$var$pd : $992039f60b605604$var$qd;
        this.isPropagationStopped = $992039f60b605604$var$qd;
        return this;
    }
    $992039f60b605604$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $992039f60b605604$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $992039f60b605604$var$pd);
        },
        persist: function() {},
        isPersistent: $992039f60b605604$var$pd
    });
    return b;
}
var $992039f60b605604$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $992039f60b605604$var$td = $992039f60b605604$var$rd($992039f60b605604$var$sd), $992039f60b605604$var$ud = $992039f60b605604$var$A({}, $992039f60b605604$var$sd, {
    view: 0,
    detail: 0
}), $992039f60b605604$var$vd = $992039f60b605604$var$rd($992039f60b605604$var$ud), $992039f60b605604$var$wd, $992039f60b605604$var$xd, $992039f60b605604$var$yd, $992039f60b605604$var$Ad = $992039f60b605604$var$A({}, $992039f60b605604$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $992039f60b605604$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $992039f60b605604$var$yd && ($992039f60b605604$var$yd && "mousemove" === a.type ? ($992039f60b605604$var$wd = a.screenX - $992039f60b605604$var$yd.screenX, $992039f60b605604$var$xd = a.screenY - $992039f60b605604$var$yd.screenY) : $992039f60b605604$var$xd = $992039f60b605604$var$wd = 0, $992039f60b605604$var$yd = a);
        return $992039f60b605604$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $992039f60b605604$var$xd;
    }
}), $992039f60b605604$var$Bd = $992039f60b605604$var$rd($992039f60b605604$var$Ad), $992039f60b605604$var$Cd = $992039f60b605604$var$A({}, $992039f60b605604$var$Ad, {
    dataTransfer: 0
}), $992039f60b605604$var$Dd = $992039f60b605604$var$rd($992039f60b605604$var$Cd), $992039f60b605604$var$Ed = $992039f60b605604$var$A({}, $992039f60b605604$var$ud, {
    relatedTarget: 0
}), $992039f60b605604$var$Fd = $992039f60b605604$var$rd($992039f60b605604$var$Ed), $992039f60b605604$var$Gd = $992039f60b605604$var$A({}, $992039f60b605604$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $992039f60b605604$var$Hd = $992039f60b605604$var$rd($992039f60b605604$var$Gd), $992039f60b605604$var$Id = $992039f60b605604$var$A({}, $992039f60b605604$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $992039f60b605604$var$Jd = $992039f60b605604$var$rd($992039f60b605604$var$Id), $992039f60b605604$var$Kd = $992039f60b605604$var$A({}, $992039f60b605604$var$sd, {
    data: 0
}), $992039f60b605604$var$Ld = $992039f60b605604$var$rd($992039f60b605604$var$Kd), $992039f60b605604$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $992039f60b605604$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $992039f60b605604$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $992039f60b605604$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $992039f60b605604$var$Od[a]) ? !!b[a] : !1;
}
function $992039f60b605604$var$zd() {
    return $992039f60b605604$var$Pd;
}
var $992039f60b605604$var$Qd = $992039f60b605604$var$A({}, $992039f60b605604$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $992039f60b605604$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $992039f60b605604$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $992039f60b605604$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $992039f60b605604$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $992039f60b605604$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $992039f60b605604$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $992039f60b605604$var$Rd = $992039f60b605604$var$rd($992039f60b605604$var$Qd), $992039f60b605604$var$Sd = $992039f60b605604$var$A({}, $992039f60b605604$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $992039f60b605604$var$Td = $992039f60b605604$var$rd($992039f60b605604$var$Sd), $992039f60b605604$var$Ud = $992039f60b605604$var$A({}, $992039f60b605604$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $992039f60b605604$var$zd
}), $992039f60b605604$var$Vd = $992039f60b605604$var$rd($992039f60b605604$var$Ud), $992039f60b605604$var$Wd = $992039f60b605604$var$A({}, $992039f60b605604$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $992039f60b605604$var$Xd = $992039f60b605604$var$rd($992039f60b605604$var$Wd), $992039f60b605604$var$Yd = $992039f60b605604$var$A({}, $992039f60b605604$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $992039f60b605604$var$Zd = $992039f60b605604$var$rd($992039f60b605604$var$Yd), $992039f60b605604$var$$d = [
    9,
    13,
    27,
    32
], $992039f60b605604$var$ae = $992039f60b605604$var$ia && "CompositionEvent" in window, $992039f60b605604$var$be = null;
$992039f60b605604$var$ia && "documentMode" in document && ($992039f60b605604$var$be = document.documentMode);
var $992039f60b605604$var$ce = $992039f60b605604$var$ia && "TextEvent" in window && !$992039f60b605604$var$be, $992039f60b605604$var$de = $992039f60b605604$var$ia && (!$992039f60b605604$var$ae || $992039f60b605604$var$be && 8 < $992039f60b605604$var$be && 11 >= $992039f60b605604$var$be), $992039f60b605604$var$ee = String.fromCharCode(32), $992039f60b605604$var$fe = !1;
function $992039f60b605604$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $992039f60b605604$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $992039f60b605604$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $992039f60b605604$var$ie = !1;
function $992039f60b605604$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $992039f60b605604$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $992039f60b605604$var$fe = !0;
            return $992039f60b605604$var$ee;
        case "textInput":
            return a = b.data, a === $992039f60b605604$var$ee && $992039f60b605604$var$fe ? null : a;
        default:
            return null;
    }
}
function $992039f60b605604$var$ke(a, b) {
    if ($992039f60b605604$var$ie) return "compositionend" === a || !$992039f60b605604$var$ae && $992039f60b605604$var$ge(a, b) ? (a = $992039f60b605604$var$nd(), $992039f60b605604$var$md = $992039f60b605604$var$ld = $992039f60b605604$var$kd = null, $992039f60b605604$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $992039f60b605604$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $992039f60b605604$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $992039f60b605604$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$992039f60b605604$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $992039f60b605604$var$ne(a, b, c, d) {
    $992039f60b605604$var$Eb(d);
    b = $992039f60b605604$var$oe(b, "onChange");
    0 < b.length && (c = new $992039f60b605604$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $992039f60b605604$var$pe = null, $992039f60b605604$var$qe = null;
function $992039f60b605604$var$re(a) {
    $992039f60b605604$var$se(a, 0);
}
function $992039f60b605604$var$te(a) {
    var b = $992039f60b605604$var$ue(a);
    if ($992039f60b605604$var$Wa(b)) return a;
}
function $992039f60b605604$var$ve(a, b) {
    if ("change" === a) return b;
}
var $992039f60b605604$var$we = !1;
if ($992039f60b605604$var$ia) {
    var $992039f60b605604$var$xe;
    if ($992039f60b605604$var$ia) {
        var $992039f60b605604$var$ye = "oninput" in document;
        if (!$992039f60b605604$var$ye) {
            var $992039f60b605604$var$ze = document.createElement("div");
            $992039f60b605604$var$ze.setAttribute("oninput", "return;");
            $992039f60b605604$var$ye = "function" === typeof $992039f60b605604$var$ze.oninput;
        }
        $992039f60b605604$var$xe = $992039f60b605604$var$ye;
    } else $992039f60b605604$var$xe = !1;
    $992039f60b605604$var$we = $992039f60b605604$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $992039f60b605604$var$Ae() {
    $992039f60b605604$var$pe && ($992039f60b605604$var$pe.detachEvent("onpropertychange", $992039f60b605604$var$Be), $992039f60b605604$var$qe = $992039f60b605604$var$pe = null);
}
function $992039f60b605604$var$Be(a) {
    if ("value" === a.propertyName && $992039f60b605604$var$te($992039f60b605604$var$qe)) {
        var b = [];
        $992039f60b605604$var$ne(b, $992039f60b605604$var$qe, a, $992039f60b605604$var$xb(a));
        $992039f60b605604$var$Jb($992039f60b605604$var$re, b);
    }
}
function $992039f60b605604$var$Ce(a, b, c) {
    "focusin" === a ? ($992039f60b605604$var$Ae(), $992039f60b605604$var$pe = b, $992039f60b605604$var$qe = c, $992039f60b605604$var$pe.attachEvent("onpropertychange", $992039f60b605604$var$Be)) : "focusout" === a && $992039f60b605604$var$Ae();
}
function $992039f60b605604$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $992039f60b605604$var$te($992039f60b605604$var$qe);
}
function $992039f60b605604$var$Ee(a, b) {
    if ("click" === a) return $992039f60b605604$var$te(b);
}
function $992039f60b605604$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $992039f60b605604$var$te(b);
}
function $992039f60b605604$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $992039f60b605604$var$He = "function" === typeof Object.is ? Object.is : $992039f60b605604$var$Ge;
function $992039f60b605604$var$Ie(a, b) {
    if ($992039f60b605604$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$992039f60b605604$var$ja.call(b, e) || !$992039f60b605604$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $992039f60b605604$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $992039f60b605604$var$Ke(a, b) {
    var c = $992039f60b605604$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $992039f60b605604$var$Je(c);
    }
}
function $992039f60b605604$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $992039f60b605604$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $992039f60b605604$var$Me() {
    for(var a = window, b = $992039f60b605604$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $992039f60b605604$var$Xa(a.document);
    }
    return b;
}
function $992039f60b605604$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $992039f60b605604$var$Oe(a) {
    var b = $992039f60b605604$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $992039f60b605604$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $992039f60b605604$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $992039f60b605604$var$Ke(c, f);
                var g = $992039f60b605604$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $992039f60b605604$var$Pe = $992039f60b605604$var$ia && "documentMode" in document && 11 >= document.documentMode, $992039f60b605604$var$Qe = null, $992039f60b605604$var$Re = null, $992039f60b605604$var$Se = null, $992039f60b605604$var$Te = !1;
function $992039f60b605604$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $992039f60b605604$var$Te || null == $992039f60b605604$var$Qe || $992039f60b605604$var$Qe !== $992039f60b605604$var$Xa(d) || (d = $992039f60b605604$var$Qe, "selectionStart" in d && $992039f60b605604$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $992039f60b605604$var$Se && $992039f60b605604$var$Ie($992039f60b605604$var$Se, d) || ($992039f60b605604$var$Se = d, d = $992039f60b605604$var$oe($992039f60b605604$var$Re, "onSelect"), 0 < d.length && (b = new $992039f60b605604$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $992039f60b605604$var$Qe)));
}
function $992039f60b605604$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $992039f60b605604$var$We = {
    animationend: $992039f60b605604$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $992039f60b605604$var$Ve("Animation", "AnimationIteration"),
    animationstart: $992039f60b605604$var$Ve("Animation", "AnimationStart"),
    transitionend: $992039f60b605604$var$Ve("Transition", "TransitionEnd")
}, $992039f60b605604$var$Xe = {}, $992039f60b605604$var$Ye = {};
$992039f60b605604$var$ia && ($992039f60b605604$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $992039f60b605604$var$We.animationend.animation, delete $992039f60b605604$var$We.animationiteration.animation, delete $992039f60b605604$var$We.animationstart.animation), "TransitionEvent" in window || delete $992039f60b605604$var$We.transitionend.transition);
function $992039f60b605604$var$Ze(a) {
    if ($992039f60b605604$var$Xe[a]) return $992039f60b605604$var$Xe[a];
    if (!$992039f60b605604$var$We[a]) return a;
    var b = $992039f60b605604$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $992039f60b605604$var$Ye) return $992039f60b605604$var$Xe[a] = b[c];
    return a;
}
var $992039f60b605604$var$$e = $992039f60b605604$var$Ze("animationend"), $992039f60b605604$var$af = $992039f60b605604$var$Ze("animationiteration"), $992039f60b605604$var$bf = $992039f60b605604$var$Ze("animationstart"), $992039f60b605604$var$cf = $992039f60b605604$var$Ze("transitionend"), $992039f60b605604$var$df = new Map, $992039f60b605604$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $992039f60b605604$var$ff(a, b) {
    $992039f60b605604$var$df.set(a, b);
    $992039f60b605604$var$fa(b, [
        a
    ]);
}
for(var $992039f60b605604$var$gf = 0; $992039f60b605604$var$gf < $992039f60b605604$var$ef.length; $992039f60b605604$var$gf++){
    var $992039f60b605604$var$hf = $992039f60b605604$var$ef[$992039f60b605604$var$gf], $992039f60b605604$var$jf = $992039f60b605604$var$hf.toLowerCase(), $992039f60b605604$var$kf = $992039f60b605604$var$hf[0].toUpperCase() + $992039f60b605604$var$hf.slice(1);
    $992039f60b605604$var$ff($992039f60b605604$var$jf, "on" + $992039f60b605604$var$kf);
}
$992039f60b605604$var$ff($992039f60b605604$var$$e, "onAnimationEnd");
$992039f60b605604$var$ff($992039f60b605604$var$af, "onAnimationIteration");
$992039f60b605604$var$ff($992039f60b605604$var$bf, "onAnimationStart");
$992039f60b605604$var$ff("dblclick", "onDoubleClick");
$992039f60b605604$var$ff("focusin", "onFocus");
$992039f60b605604$var$ff("focusout", "onBlur");
$992039f60b605604$var$ff($992039f60b605604$var$cf, "onTransitionEnd");
$992039f60b605604$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$992039f60b605604$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$992039f60b605604$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$992039f60b605604$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$992039f60b605604$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$992039f60b605604$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$992039f60b605604$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$992039f60b605604$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$992039f60b605604$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$992039f60b605604$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $992039f60b605604$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $992039f60b605604$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($992039f60b605604$var$lf));
function $992039f60b605604$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $992039f60b605604$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $992039f60b605604$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $992039f60b605604$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $992039f60b605604$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($992039f60b605604$var$Qb) throw a = $992039f60b605604$var$Rb, $992039f60b605604$var$Qb = !1, $992039f60b605604$var$Rb = null, a;
}
function $992039f60b605604$var$D(a, b) {
    var c = b[$992039f60b605604$var$of];
    void 0 === c && (c = b[$992039f60b605604$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($992039f60b605604$var$pf(b, a, 2, !1), c.add(d));
}
function $992039f60b605604$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $992039f60b605604$var$pf(c, a, d, b);
}
var $992039f60b605604$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $992039f60b605604$var$sf(a) {
    if (!a[$992039f60b605604$var$rf]) {
        a[$992039f60b605604$var$rf] = !0;
        $992039f60b605604$var$da.forEach(function(b) {
            "selectionchange" !== b && ($992039f60b605604$var$mf.has(b) || $992039f60b605604$var$qf(b, !1, a), $992039f60b605604$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$992039f60b605604$var$rf] || (b[$992039f60b605604$var$rf] = !0, $992039f60b605604$var$qf("selectionchange", !1, b));
    }
}
function $992039f60b605604$var$pf(a, b, c, d) {
    switch($992039f60b605604$var$jd(b)){
        case 1:
            var e = $992039f60b605604$var$ed;
            break;
        case 4:
            e = $992039f60b605604$var$gd;
            break;
        default:
            e = $992039f60b605604$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$992039f60b605604$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $992039f60b605604$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $992039f60b605604$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $992039f60b605604$var$Jb(function() {
        var d = f, e = $992039f60b605604$var$xb(c), g = [];
        a: {
            var h = $992039f60b605604$var$df.get(a);
            if (void 0 !== h) {
                var k = $992039f60b605604$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $992039f60b605604$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $992039f60b605604$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $992039f60b605604$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $992039f60b605604$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $992039f60b605604$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $992039f60b605604$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $992039f60b605604$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $992039f60b605604$var$Vd;
                        break;
                    case $992039f60b605604$var$$e:
                    case $992039f60b605604$var$af:
                    case $992039f60b605604$var$bf:
                        k = $992039f60b605604$var$Hd;
                        break;
                    case $992039f60b605604$var$cf:
                        k = $992039f60b605604$var$Xd;
                        break;
                    case "scroll":
                        k = $992039f60b605604$var$vd;
                        break;
                    case "wheel":
                        k = $992039f60b605604$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $992039f60b605604$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $992039f60b605604$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $992039f60b605604$var$Kb(w, x), null != F && t.push($992039f60b605604$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $992039f60b605604$var$wb && (n = c.relatedTarget || c.fromElement) && ($992039f60b605604$var$Wc(n) || n[$992039f60b605604$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $992039f60b605604$var$Wc(n) : null, null !== n && (J = $992039f60b605604$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $992039f60b605604$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $992039f60b605604$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $992039f60b605604$var$ue(k);
                        u = null == n ? h : $992039f60b605604$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $992039f60b605604$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $992039f60b605604$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $992039f60b605604$var$vf(F))u++;
                            for(; 0 < w - u;)t = $992039f60b605604$var$vf(t), w--;
                            for(; 0 < u - w;)x = $992039f60b605604$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $992039f60b605604$var$vf(t);
                                x = $992039f60b605604$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $992039f60b605604$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $992039f60b605604$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $992039f60b605604$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $992039f60b605604$var$ve;
                else if ($992039f60b605604$var$me(h)) {
                    if ($992039f60b605604$var$we) na = $992039f60b605604$var$Fe;
                    else {
                        na = $992039f60b605604$var$De;
                        var xa = $992039f60b605604$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $992039f60b605604$var$Ee);
                if (na && (na = na(a, d))) {
                    $992039f60b605604$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $992039f60b605604$var$cb(h, "number", h.value);
            }
            xa = d ? $992039f60b605604$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($992039f60b605604$var$me(xa) || "true" === xa.contentEditable) $992039f60b605604$var$Qe = xa, $992039f60b605604$var$Re = d, $992039f60b605604$var$Se = null;
                    break;
                case "focusout":
                    $992039f60b605604$var$Se = $992039f60b605604$var$Re = $992039f60b605604$var$Qe = null;
                    break;
                case "mousedown":
                    $992039f60b605604$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $992039f60b605604$var$Te = !1;
                    $992039f60b605604$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($992039f60b605604$var$Pe) break;
                case "keydown":
                case "keyup":
                    $992039f60b605604$var$Ue(g, c, e);
            }
            var $a;
            if ($992039f60b605604$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $992039f60b605604$var$ie ? $992039f60b605604$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($992039f60b605604$var$de && "ko" !== c.locale && ($992039f60b605604$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $992039f60b605604$var$ie && ($a = $992039f60b605604$var$nd()) : ($992039f60b605604$var$kd = e, $992039f60b605604$var$ld = "value" in $992039f60b605604$var$kd ? $992039f60b605604$var$kd.value : $992039f60b605604$var$kd.textContent, $992039f60b605604$var$ie = !0)), xa = $992039f60b605604$var$oe(d, ba), 0 < xa.length && (ba = new $992039f60b605604$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $992039f60b605604$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $992039f60b605604$var$ce ? $992039f60b605604$var$je(a, c) : $992039f60b605604$var$ke(a, c)) d = $992039f60b605604$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $992039f60b605604$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $992039f60b605604$var$se(g, b);
    });
}
function $992039f60b605604$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $992039f60b605604$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $992039f60b605604$var$Kb(a, c), null != f && d.unshift($992039f60b605604$var$tf(a, f, e)), f = $992039f60b605604$var$Kb(a, b), null != f && d.push($992039f60b605604$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $992039f60b605604$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $992039f60b605604$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $992039f60b605604$var$Kb(c, f), null != k && g.unshift($992039f60b605604$var$tf(c, k, h))) : e || (k = $992039f60b605604$var$Kb(c, f), null != k && g.push($992039f60b605604$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $992039f60b605604$var$xf = /\r\n?/g, $992039f60b605604$var$yf = /\u0000|\uFFFD/g;
function $992039f60b605604$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($992039f60b605604$var$xf, "\n").replace($992039f60b605604$var$yf, "");
}
function $992039f60b605604$var$Af(a, b, c) {
    b = $992039f60b605604$var$zf(b);
    if ($992039f60b605604$var$zf(a) !== b && c) throw Error($992039f60b605604$var$p(425));
}
function $992039f60b605604$var$Bf() {}
var $992039f60b605604$var$Cf = null, $992039f60b605604$var$Df = null;
function $992039f60b605604$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $992039f60b605604$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $992039f60b605604$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $992039f60b605604$var$Hf = "function" === typeof Promise ? Promise : void 0, $992039f60b605604$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $992039f60b605604$var$Hf ? function(a) {
    return $992039f60b605604$var$Hf.resolve(null).then(a).catch($992039f60b605604$var$If);
} : $992039f60b605604$var$Ff;
function $992039f60b605604$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $992039f60b605604$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $992039f60b605604$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $992039f60b605604$var$bd(b);
}
function $992039f60b605604$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $992039f60b605604$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $992039f60b605604$var$Nf = Math.random().toString(36).slice(2), $992039f60b605604$var$Of = "__reactFiber$" + $992039f60b605604$var$Nf, $992039f60b605604$var$Pf = "__reactProps$" + $992039f60b605604$var$Nf, $992039f60b605604$var$uf = "__reactContainer$" + $992039f60b605604$var$Nf, $992039f60b605604$var$of = "__reactEvents$" + $992039f60b605604$var$Nf, $992039f60b605604$var$Qf = "__reactListeners$" + $992039f60b605604$var$Nf, $992039f60b605604$var$Rf = "__reactHandles$" + $992039f60b605604$var$Nf;
function $992039f60b605604$var$Wc(a) {
    var b = a[$992039f60b605604$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$992039f60b605604$var$uf] || c[$992039f60b605604$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $992039f60b605604$var$Mf(a); null !== a;){
                if (c = a[$992039f60b605604$var$Of]) return c;
                a = $992039f60b605604$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $992039f60b605604$var$Cb(a) {
    a = a[$992039f60b605604$var$Of] || a[$992039f60b605604$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $992039f60b605604$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($992039f60b605604$var$p(33));
}
function $992039f60b605604$var$Db(a) {
    return a[$992039f60b605604$var$Pf] || null;
}
var $992039f60b605604$var$Sf = [], $992039f60b605604$var$Tf = -1;
function $992039f60b605604$var$Uf(a) {
    return {
        current: a
    };
}
function $992039f60b605604$var$E(a) {
    0 > $992039f60b605604$var$Tf || (a.current = $992039f60b605604$var$Sf[$992039f60b605604$var$Tf], $992039f60b605604$var$Sf[$992039f60b605604$var$Tf] = null, $992039f60b605604$var$Tf--);
}
function $992039f60b605604$var$G(a, b) {
    $992039f60b605604$var$Tf++;
    $992039f60b605604$var$Sf[$992039f60b605604$var$Tf] = a.current;
    a.current = b;
}
var $992039f60b605604$var$Vf = {}, $992039f60b605604$var$H = $992039f60b605604$var$Uf($992039f60b605604$var$Vf), $992039f60b605604$var$Wf = $992039f60b605604$var$Uf(!1), $992039f60b605604$var$Xf = $992039f60b605604$var$Vf;
function $992039f60b605604$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $992039f60b605604$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $992039f60b605604$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $992039f60b605604$var$$f() {
    $992039f60b605604$var$E($992039f60b605604$var$Wf);
    $992039f60b605604$var$E($992039f60b605604$var$H);
}
function $992039f60b605604$var$ag(a, b, c) {
    if ($992039f60b605604$var$H.current !== $992039f60b605604$var$Vf) throw Error($992039f60b605604$var$p(168));
    $992039f60b605604$var$G($992039f60b605604$var$H, b);
    $992039f60b605604$var$G($992039f60b605604$var$Wf, c);
}
function $992039f60b605604$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($992039f60b605604$var$p(108, $992039f60b605604$var$Ra(a) || "Unknown", e));
    return $992039f60b605604$var$A({}, c, d);
}
function $992039f60b605604$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $992039f60b605604$var$Vf;
    $992039f60b605604$var$Xf = $992039f60b605604$var$H.current;
    $992039f60b605604$var$G($992039f60b605604$var$H, a);
    $992039f60b605604$var$G($992039f60b605604$var$Wf, $992039f60b605604$var$Wf.current);
    return !0;
}
function $992039f60b605604$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($992039f60b605604$var$p(169));
    c ? (a = $992039f60b605604$var$bg(a, b, $992039f60b605604$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $992039f60b605604$var$E($992039f60b605604$var$Wf), $992039f60b605604$var$E($992039f60b605604$var$H), $992039f60b605604$var$G($992039f60b605604$var$H, a)) : $992039f60b605604$var$E($992039f60b605604$var$Wf);
    $992039f60b605604$var$G($992039f60b605604$var$Wf, c);
}
var $992039f60b605604$var$eg = null, $992039f60b605604$var$fg = !1, $992039f60b605604$var$gg = !1;
function $992039f60b605604$var$hg(a) {
    null === $992039f60b605604$var$eg ? $992039f60b605604$var$eg = [
        a
    ] : $992039f60b605604$var$eg.push(a);
}
function $992039f60b605604$var$ig(a) {
    $992039f60b605604$var$fg = !0;
    $992039f60b605604$var$hg(a);
}
function $992039f60b605604$var$jg() {
    if (!$992039f60b605604$var$gg && null !== $992039f60b605604$var$eg) {
        $992039f60b605604$var$gg = !0;
        var a = 0, b = $992039f60b605604$var$C;
        try {
            var c = $992039f60b605604$var$eg;
            for($992039f60b605604$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $992039f60b605604$var$eg = null;
            $992039f60b605604$var$fg = !1;
        } catch (e) {
            throw null !== $992039f60b605604$var$eg && ($992039f60b605604$var$eg = $992039f60b605604$var$eg.slice(a + 1)), $992039f60b605604$var$ac($992039f60b605604$var$fc, $992039f60b605604$var$jg), e;
        } finally{
            $992039f60b605604$var$C = b, $992039f60b605604$var$gg = !1;
        }
    }
    return null;
}
var $992039f60b605604$var$kg = [], $992039f60b605604$var$lg = 0, $992039f60b605604$var$mg = null, $992039f60b605604$var$ng = 0, $992039f60b605604$var$og = [], $992039f60b605604$var$pg = 0, $992039f60b605604$var$qg = null, $992039f60b605604$var$rg = 1, $992039f60b605604$var$sg = "";
function $992039f60b605604$var$tg(a, b) {
    $992039f60b605604$var$kg[$992039f60b605604$var$lg++] = $992039f60b605604$var$ng;
    $992039f60b605604$var$kg[$992039f60b605604$var$lg++] = $992039f60b605604$var$mg;
    $992039f60b605604$var$mg = a;
    $992039f60b605604$var$ng = b;
}
function $992039f60b605604$var$ug(a, b, c) {
    $992039f60b605604$var$og[$992039f60b605604$var$pg++] = $992039f60b605604$var$rg;
    $992039f60b605604$var$og[$992039f60b605604$var$pg++] = $992039f60b605604$var$sg;
    $992039f60b605604$var$og[$992039f60b605604$var$pg++] = $992039f60b605604$var$qg;
    $992039f60b605604$var$qg = a;
    var d = $992039f60b605604$var$rg;
    a = $992039f60b605604$var$sg;
    var e = 32 - $992039f60b605604$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $992039f60b605604$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $992039f60b605604$var$rg = 1 << 32 - $992039f60b605604$var$oc(b) + e | c << e | d;
        $992039f60b605604$var$sg = f + a;
    } else $992039f60b605604$var$rg = 1 << f | c << e | d, $992039f60b605604$var$sg = a;
}
function $992039f60b605604$var$vg(a) {
    null !== a.return && ($992039f60b605604$var$tg(a, 1), $992039f60b605604$var$ug(a, 1, 0));
}
function $992039f60b605604$var$wg(a) {
    for(; a === $992039f60b605604$var$mg;)$992039f60b605604$var$mg = $992039f60b605604$var$kg[--$992039f60b605604$var$lg], $992039f60b605604$var$kg[$992039f60b605604$var$lg] = null, $992039f60b605604$var$ng = $992039f60b605604$var$kg[--$992039f60b605604$var$lg], $992039f60b605604$var$kg[$992039f60b605604$var$lg] = null;
    for(; a === $992039f60b605604$var$qg;)$992039f60b605604$var$qg = $992039f60b605604$var$og[--$992039f60b605604$var$pg], $992039f60b605604$var$og[$992039f60b605604$var$pg] = null, $992039f60b605604$var$sg = $992039f60b605604$var$og[--$992039f60b605604$var$pg], $992039f60b605604$var$og[$992039f60b605604$var$pg] = null, $992039f60b605604$var$rg = $992039f60b605604$var$og[--$992039f60b605604$var$pg], $992039f60b605604$var$og[$992039f60b605604$var$pg] = null;
}
var $992039f60b605604$var$xg = null, $992039f60b605604$var$yg = null, $992039f60b605604$var$I = !1, $992039f60b605604$var$zg = null;
function $992039f60b605604$var$Ag(a, b) {
    var c = $992039f60b605604$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $992039f60b605604$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $992039f60b605604$var$xg = a, $992039f60b605604$var$yg = $992039f60b605604$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $992039f60b605604$var$xg = a, $992039f60b605604$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $992039f60b605604$var$qg ? {
                id: $992039f60b605604$var$rg,
                overflow: $992039f60b605604$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $992039f60b605604$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $992039f60b605604$var$xg = a, $992039f60b605604$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $992039f60b605604$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $992039f60b605604$var$Eg(a) {
    if ($992039f60b605604$var$I) {
        var b = $992039f60b605604$var$yg;
        if (b) {
            var c = b;
            if (!$992039f60b605604$var$Cg(a, b)) {
                if ($992039f60b605604$var$Dg(a)) throw Error($992039f60b605604$var$p(418));
                b = $992039f60b605604$var$Lf(c.nextSibling);
                var d = $992039f60b605604$var$xg;
                b && $992039f60b605604$var$Cg(a, b) ? $992039f60b605604$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $992039f60b605604$var$I = !1, $992039f60b605604$var$xg = a);
            }
        } else {
            if ($992039f60b605604$var$Dg(a)) throw Error($992039f60b605604$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $992039f60b605604$var$I = !1;
            $992039f60b605604$var$xg = a;
        }
    }
}
function $992039f60b605604$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $992039f60b605604$var$xg = a;
}
function $992039f60b605604$var$Gg(a) {
    if (a !== $992039f60b605604$var$xg) return !1;
    if (!$992039f60b605604$var$I) return $992039f60b605604$var$Fg(a), $992039f60b605604$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$992039f60b605604$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $992039f60b605604$var$yg)) {
        if ($992039f60b605604$var$Dg(a)) throw $992039f60b605604$var$Hg(), Error($992039f60b605604$var$p(418));
        for(; b;)$992039f60b605604$var$Ag(a, b), b = $992039f60b605604$var$Lf(b.nextSibling);
    }
    $992039f60b605604$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($992039f60b605604$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $992039f60b605604$var$yg = $992039f60b605604$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $992039f60b605604$var$yg = null;
        }
    } else $992039f60b605604$var$yg = $992039f60b605604$var$xg ? $992039f60b605604$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $992039f60b605604$var$Hg() {
    for(var a = $992039f60b605604$var$yg; a;)a = $992039f60b605604$var$Lf(a.nextSibling);
}
function $992039f60b605604$var$Ig() {
    $992039f60b605604$var$yg = $992039f60b605604$var$xg = null;
    $992039f60b605604$var$I = !1;
}
function $992039f60b605604$var$Jg(a) {
    null === $992039f60b605604$var$zg ? $992039f60b605604$var$zg = [
        a
    ] : $992039f60b605604$var$zg.push(a);
}
var $992039f60b605604$var$Kg = $992039f60b605604$var$ua.ReactCurrentBatchConfig;
function $992039f60b605604$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($992039f60b605604$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($992039f60b605604$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($992039f60b605604$var$p(284));
        if (!c._owner) throw Error($992039f60b605604$var$p(290, a));
    }
    return a;
}
function $992039f60b605604$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($992039f60b605604$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $992039f60b605604$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $992039f60b605604$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $992039f60b605604$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $992039f60b605604$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $992039f60b605604$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $992039f60b605604$var$Ha && $992039f60b605604$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $992039f60b605604$var$Lg(a, b, c), d.return = a, d;
        d = $992039f60b605604$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $992039f60b605604$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $992039f60b605604$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $992039f60b605604$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $992039f60b605604$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $992039f60b605604$var$va:
                    return c = $992039f60b605604$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $992039f60b605604$var$Lg(a, null, b), c.return = a, c;
                case $992039f60b605604$var$wa:
                    return b = $992039f60b605604$var$Sg(b, a.mode, c), b.return = a, b;
                case $992039f60b605604$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($992039f60b605604$var$eb(b) || $992039f60b605604$var$Ka(b)) return b = $992039f60b605604$var$Tg(b, a.mode, c, null), b.return = a, b;
            $992039f60b605604$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $992039f60b605604$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $992039f60b605604$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $992039f60b605604$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($992039f60b605604$var$eb(c) || $992039f60b605604$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $992039f60b605604$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $992039f60b605604$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $992039f60b605604$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $992039f60b605604$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($992039f60b605604$var$eb(d) || $992039f60b605604$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $992039f60b605604$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $992039f60b605604$var$I && $992039f60b605604$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $992039f60b605604$var$I && $992039f60b605604$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $992039f60b605604$var$I && $992039f60b605604$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $992039f60b605604$var$Ka(h);
        if ("function" !== typeof l) throw Error($992039f60b605604$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($992039f60b605604$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $992039f60b605604$var$I && $992039f60b605604$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $992039f60b605604$var$I && $992039f60b605604$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $992039f60b605604$var$I && $992039f60b605604$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $992039f60b605604$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $992039f60b605604$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $992039f60b605604$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $992039f60b605604$var$Ha && $992039f60b605604$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $992039f60b605604$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $992039f60b605604$var$ya ? (d = $992039f60b605604$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $992039f60b605604$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $992039f60b605604$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $992039f60b605604$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $992039f60b605604$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $992039f60b605604$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($992039f60b605604$var$eb(f)) return n(a, d, f, h);
            if ($992039f60b605604$var$Ka(f)) return t(a, d, f, h);
            $992039f60b605604$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $992039f60b605604$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $992039f60b605604$var$Ug = $992039f60b605604$var$Og(!0), $992039f60b605604$var$Vg = $992039f60b605604$var$Og(!1), $992039f60b605604$var$Wg = $992039f60b605604$var$Uf(null), $992039f60b605604$var$Xg = null, $992039f60b605604$var$Yg = null, $992039f60b605604$var$Zg = null;
function $992039f60b605604$var$$g() {
    $992039f60b605604$var$Zg = $992039f60b605604$var$Yg = $992039f60b605604$var$Xg = null;
}
function $992039f60b605604$var$ah(a) {
    var b = $992039f60b605604$var$Wg.current;
    $992039f60b605604$var$E($992039f60b605604$var$Wg);
    a._currentValue = b;
}
function $992039f60b605604$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $992039f60b605604$var$ch(a, b) {
    $992039f60b605604$var$Xg = a;
    $992039f60b605604$var$Zg = $992039f60b605604$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($992039f60b605604$var$dh = !0), a.firstContext = null);
}
function $992039f60b605604$var$eh(a) {
    var b = a._currentValue;
    if ($992039f60b605604$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $992039f60b605604$var$Yg) {
            if (null === $992039f60b605604$var$Xg) throw Error($992039f60b605604$var$p(308));
            $992039f60b605604$var$Yg = a;
            $992039f60b605604$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $992039f60b605604$var$Yg = $992039f60b605604$var$Yg.next = a;
    }
    return b;
}
var $992039f60b605604$var$fh = null;
function $992039f60b605604$var$gh(a) {
    null === $992039f60b605604$var$fh ? $992039f60b605604$var$fh = [
        a
    ] : $992039f60b605604$var$fh.push(a);
}
function $992039f60b605604$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $992039f60b605604$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $992039f60b605604$var$ih(a, d);
}
function $992039f60b605604$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $992039f60b605604$var$jh = !1;
function $992039f60b605604$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $992039f60b605604$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $992039f60b605604$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $992039f60b605604$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($992039f60b605604$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $992039f60b605604$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $992039f60b605604$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $992039f60b605604$var$ih(a, c);
}
function $992039f60b605604$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $992039f60b605604$var$Cc(a, c);
    }
}
function $992039f60b605604$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $992039f60b605604$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $992039f60b605604$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $992039f60b605604$var$A({}, q, r);
                            break a;
                        case 2:
                            $992039f60b605604$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $992039f60b605604$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $992039f60b605604$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($992039f60b605604$var$p(191, e));
            e.call(d);
        }
    }
}
var $992039f60b605604$var$th = {}, $992039f60b605604$var$uh = $992039f60b605604$var$Uf($992039f60b605604$var$th), $992039f60b605604$var$vh = $992039f60b605604$var$Uf($992039f60b605604$var$th), $992039f60b605604$var$wh = $992039f60b605604$var$Uf($992039f60b605604$var$th);
function $992039f60b605604$var$xh(a) {
    if (a === $992039f60b605604$var$th) throw Error($992039f60b605604$var$p(174));
    return a;
}
function $992039f60b605604$var$yh(a, b) {
    $992039f60b605604$var$G($992039f60b605604$var$wh, b);
    $992039f60b605604$var$G($992039f60b605604$var$vh, a);
    $992039f60b605604$var$G($992039f60b605604$var$uh, $992039f60b605604$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $992039f60b605604$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $992039f60b605604$var$lb(b, a);
    }
    $992039f60b605604$var$E($992039f60b605604$var$uh);
    $992039f60b605604$var$G($992039f60b605604$var$uh, b);
}
function $992039f60b605604$var$zh() {
    $992039f60b605604$var$E($992039f60b605604$var$uh);
    $992039f60b605604$var$E($992039f60b605604$var$vh);
    $992039f60b605604$var$E($992039f60b605604$var$wh);
}
function $992039f60b605604$var$Ah(a) {
    $992039f60b605604$var$xh($992039f60b605604$var$wh.current);
    var b = $992039f60b605604$var$xh($992039f60b605604$var$uh.current);
    var c = $992039f60b605604$var$lb(b, a.type);
    b !== c && ($992039f60b605604$var$G($992039f60b605604$var$vh, a), $992039f60b605604$var$G($992039f60b605604$var$uh, c));
}
function $992039f60b605604$var$Bh(a) {
    $992039f60b605604$var$vh.current === a && ($992039f60b605604$var$E($992039f60b605604$var$uh), $992039f60b605604$var$E($992039f60b605604$var$vh));
}
var $992039f60b605604$var$L = $992039f60b605604$var$Uf(0);
function $992039f60b605604$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $992039f60b605604$var$Dh = [];
function $992039f60b605604$var$Eh() {
    for(var a = 0; a < $992039f60b605604$var$Dh.length; a++)$992039f60b605604$var$Dh[a]._workInProgressVersionPrimary = null;
    $992039f60b605604$var$Dh.length = 0;
}
var $992039f60b605604$var$Fh = $992039f60b605604$var$ua.ReactCurrentDispatcher, $992039f60b605604$var$Gh = $992039f60b605604$var$ua.ReactCurrentBatchConfig, $992039f60b605604$var$Hh = 0, $992039f60b605604$var$M = null, $992039f60b605604$var$N = null, $992039f60b605604$var$O = null, $992039f60b605604$var$Ih = !1, $992039f60b605604$var$Jh = !1, $992039f60b605604$var$Kh = 0, $992039f60b605604$var$Lh = 0;
function $992039f60b605604$var$P() {
    throw Error($992039f60b605604$var$p(321));
}
function $992039f60b605604$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$992039f60b605604$var$He(a[c], b[c])) return !1;
    return !0;
}
function $992039f60b605604$var$Nh(a, b, c, d, e, f) {
    $992039f60b605604$var$Hh = f;
    $992039f60b605604$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $992039f60b605604$var$Fh.current = null === a || null === a.memoizedState ? $992039f60b605604$var$Oh : $992039f60b605604$var$Ph;
    a = c(d, e);
    if ($992039f60b605604$var$Jh) {
        f = 0;
        do {
            $992039f60b605604$var$Jh = !1;
            $992039f60b605604$var$Kh = 0;
            if (25 <= f) throw Error($992039f60b605604$var$p(301));
            f += 1;
            $992039f60b605604$var$O = $992039f60b605604$var$N = null;
            b.updateQueue = null;
            $992039f60b605604$var$Fh.current = $992039f60b605604$var$Qh;
            a = c(d, e);
        }while ($992039f60b605604$var$Jh);
    }
    $992039f60b605604$var$Fh.current = $992039f60b605604$var$Rh;
    b = null !== $992039f60b605604$var$N && null !== $992039f60b605604$var$N.next;
    $992039f60b605604$var$Hh = 0;
    $992039f60b605604$var$O = $992039f60b605604$var$N = $992039f60b605604$var$M = null;
    $992039f60b605604$var$Ih = !1;
    if (b) throw Error($992039f60b605604$var$p(300));
    return a;
}
function $992039f60b605604$var$Sh() {
    var a = 0 !== $992039f60b605604$var$Kh;
    $992039f60b605604$var$Kh = 0;
    return a;
}
function $992039f60b605604$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $992039f60b605604$var$O ? $992039f60b605604$var$M.memoizedState = $992039f60b605604$var$O = a : $992039f60b605604$var$O = $992039f60b605604$var$O.next = a;
    return $992039f60b605604$var$O;
}
function $992039f60b605604$var$Uh() {
    if (null === $992039f60b605604$var$N) {
        var a = $992039f60b605604$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $992039f60b605604$var$N.next;
    var b = null === $992039f60b605604$var$O ? $992039f60b605604$var$M.memoizedState : $992039f60b605604$var$O.next;
    if (null !== b) $992039f60b605604$var$O = b, $992039f60b605604$var$N = a;
    else {
        if (null === a) throw Error($992039f60b605604$var$p(310));
        $992039f60b605604$var$N = a;
        a = {
            memoizedState: $992039f60b605604$var$N.memoizedState,
            baseState: $992039f60b605604$var$N.baseState,
            baseQueue: $992039f60b605604$var$N.baseQueue,
            queue: $992039f60b605604$var$N.queue,
            next: null
        };
        null === $992039f60b605604$var$O ? $992039f60b605604$var$M.memoizedState = $992039f60b605604$var$O = a : $992039f60b605604$var$O = $992039f60b605604$var$O.next = a;
    }
    return $992039f60b605604$var$O;
}
function $992039f60b605604$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $992039f60b605604$var$Wh(a) {
    var b = $992039f60b605604$var$Uh(), c = b.queue;
    if (null === c) throw Error($992039f60b605604$var$p(311));
    c.lastRenderedReducer = a;
    var d = $992039f60b605604$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($992039f60b605604$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $992039f60b605604$var$M.lanes |= m;
                $992039f60b605604$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $992039f60b605604$var$He(d, b.memoizedState) || ($992039f60b605604$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $992039f60b605604$var$M.lanes |= f, $992039f60b605604$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $992039f60b605604$var$Xh(a) {
    var b = $992039f60b605604$var$Uh(), c = b.queue;
    if (null === c) throw Error($992039f60b605604$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $992039f60b605604$var$He(f, b.memoizedState) || ($992039f60b605604$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $992039f60b605604$var$Yh() {}
function $992039f60b605604$var$Zh(a, b) {
    var c = $992039f60b605604$var$M, d = $992039f60b605604$var$Uh(), e = b(), f = !$992039f60b605604$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $992039f60b605604$var$dh = !0);
    d = d.queue;
    $992039f60b605604$var$$h($992039f60b605604$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $992039f60b605604$var$O && $992039f60b605604$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $992039f60b605604$var$bi(9, $992039f60b605604$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $992039f60b605604$var$Q) throw Error($992039f60b605604$var$p(349));
        0 !== ($992039f60b605604$var$Hh & 30) || $992039f60b605604$var$di(c, b, e);
    }
    return e;
}
function $992039f60b605604$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $992039f60b605604$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $992039f60b605604$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $992039f60b605604$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $992039f60b605604$var$ei(b) && $992039f60b605604$var$fi(a);
}
function $992039f60b605604$var$ai(a, b, c) {
    return c(function() {
        $992039f60b605604$var$ei(b) && $992039f60b605604$var$fi(a);
    });
}
function $992039f60b605604$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$992039f60b605604$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $992039f60b605604$var$fi(a) {
    var b = $992039f60b605604$var$ih(a, 1);
    null !== b && $992039f60b605604$var$gi(b, a, 1, -1);
}
function $992039f60b605604$var$hi(a) {
    var b = $992039f60b605604$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $992039f60b605604$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $992039f60b605604$var$ii.bind(null, $992039f60b605604$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $992039f60b605604$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $992039f60b605604$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $992039f60b605604$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $992039f60b605604$var$ji() {
    return $992039f60b605604$var$Uh().memoizedState;
}
function $992039f60b605604$var$ki(a, b, c, d) {
    var e = $992039f60b605604$var$Th();
    $992039f60b605604$var$M.flags |= a;
    e.memoizedState = $992039f60b605604$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $992039f60b605604$var$li(a, b, c, d) {
    var e = $992039f60b605604$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $992039f60b605604$var$N) {
        var g = $992039f60b605604$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $992039f60b605604$var$Mh(d, g.deps)) {
            e.memoizedState = $992039f60b605604$var$bi(b, c, f, d);
            return;
        }
    }
    $992039f60b605604$var$M.flags |= a;
    e.memoizedState = $992039f60b605604$var$bi(1 | b, c, f, d);
}
function $992039f60b605604$var$mi(a, b) {
    return $992039f60b605604$var$ki(8390656, 8, a, b);
}
function $992039f60b605604$var$$h(a, b) {
    return $992039f60b605604$var$li(2048, 8, a, b);
}
function $992039f60b605604$var$ni(a, b) {
    return $992039f60b605604$var$li(4, 2, a, b);
}
function $992039f60b605604$var$oi(a, b) {
    return $992039f60b605604$var$li(4, 4, a, b);
}
function $992039f60b605604$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $992039f60b605604$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $992039f60b605604$var$li(4, 4, $992039f60b605604$var$pi.bind(null, b, a), c);
}
function $992039f60b605604$var$ri() {}
function $992039f60b605604$var$si(a, b) {
    var c = $992039f60b605604$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $992039f60b605604$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $992039f60b605604$var$ti(a, b) {
    var c = $992039f60b605604$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $992039f60b605604$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $992039f60b605604$var$ui(a, b, c) {
    if (0 === ($992039f60b605604$var$Hh & 21)) return a.baseState && (a.baseState = !1, $992039f60b605604$var$dh = !0), a.memoizedState = c;
    $992039f60b605604$var$He(c, b) || (c = $992039f60b605604$var$yc(), $992039f60b605604$var$M.lanes |= c, $992039f60b605604$var$rh |= c, a.baseState = !0);
    return b;
}
function $992039f60b605604$var$vi(a, b) {
    var c = $992039f60b605604$var$C;
    $992039f60b605604$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $992039f60b605604$var$Gh.transition;
    $992039f60b605604$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $992039f60b605604$var$C = c, $992039f60b605604$var$Gh.transition = d;
    }
}
function $992039f60b605604$var$wi() {
    return $992039f60b605604$var$Uh().memoizedState;
}
function $992039f60b605604$var$xi(a, b, c) {
    var d = $992039f60b605604$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($992039f60b605604$var$zi(a)) $992039f60b605604$var$Ai(b, c);
    else if (c = $992039f60b605604$var$hh(a, b, c, d), null !== c) {
        var e = $992039f60b605604$var$R();
        $992039f60b605604$var$gi(c, a, d, e);
        $992039f60b605604$var$Bi(c, b, d);
    }
}
function $992039f60b605604$var$ii(a, b, c) {
    var d = $992039f60b605604$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($992039f60b605604$var$zi(a)) $992039f60b605604$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($992039f60b605604$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $992039f60b605604$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $992039f60b605604$var$hh(a, b, e, d);
        null !== c && (e = $992039f60b605604$var$R(), $992039f60b605604$var$gi(c, a, d, e), $992039f60b605604$var$Bi(c, b, d));
    }
}
function $992039f60b605604$var$zi(a) {
    var b = a.alternate;
    return a === $992039f60b605604$var$M || null !== b && b === $992039f60b605604$var$M;
}
function $992039f60b605604$var$Ai(a, b) {
    $992039f60b605604$var$Jh = $992039f60b605604$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $992039f60b605604$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $992039f60b605604$var$Cc(a, c);
    }
}
var $992039f60b605604$var$Rh = {
    readContext: $992039f60b605604$var$eh,
    useCallback: $992039f60b605604$var$P,
    useContext: $992039f60b605604$var$P,
    useEffect: $992039f60b605604$var$P,
    useImperativeHandle: $992039f60b605604$var$P,
    useInsertionEffect: $992039f60b605604$var$P,
    useLayoutEffect: $992039f60b605604$var$P,
    useMemo: $992039f60b605604$var$P,
    useReducer: $992039f60b605604$var$P,
    useRef: $992039f60b605604$var$P,
    useState: $992039f60b605604$var$P,
    useDebugValue: $992039f60b605604$var$P,
    useDeferredValue: $992039f60b605604$var$P,
    useTransition: $992039f60b605604$var$P,
    useMutableSource: $992039f60b605604$var$P,
    useSyncExternalStore: $992039f60b605604$var$P,
    useId: $992039f60b605604$var$P,
    unstable_isNewReconciler: !1
}, $992039f60b605604$var$Oh = {
    readContext: $992039f60b605604$var$eh,
    useCallback: function(a, b) {
        $992039f60b605604$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $992039f60b605604$var$eh,
    useEffect: $992039f60b605604$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $992039f60b605604$var$ki(4194308, 4, $992039f60b605604$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $992039f60b605604$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $992039f60b605604$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $992039f60b605604$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $992039f60b605604$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $992039f60b605604$var$xi.bind(null, $992039f60b605604$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $992039f60b605604$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $992039f60b605604$var$hi,
    useDebugValue: $992039f60b605604$var$ri,
    useDeferredValue: function(a) {
        return $992039f60b605604$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $992039f60b605604$var$hi(!1), b = a[0];
        a = $992039f60b605604$var$vi.bind(null, a[1]);
        $992039f60b605604$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $992039f60b605604$var$M, e = $992039f60b605604$var$Th();
        if ($992039f60b605604$var$I) {
            if (void 0 === c) throw Error($992039f60b605604$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $992039f60b605604$var$Q) throw Error($992039f60b605604$var$p(349));
            0 !== ($992039f60b605604$var$Hh & 30) || $992039f60b605604$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $992039f60b605604$var$mi($992039f60b605604$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $992039f60b605604$var$bi(9, $992039f60b605604$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $992039f60b605604$var$Th(), b = $992039f60b605604$var$Q.identifierPrefix;
        if ($992039f60b605604$var$I) {
            var c = $992039f60b605604$var$sg;
            var d = $992039f60b605604$var$rg;
            c = (d & ~(1 << 32 - $992039f60b605604$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $992039f60b605604$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $992039f60b605604$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $992039f60b605604$var$Ph = {
    readContext: $992039f60b605604$var$eh,
    useCallback: $992039f60b605604$var$si,
    useContext: $992039f60b605604$var$eh,
    useEffect: $992039f60b605604$var$$h,
    useImperativeHandle: $992039f60b605604$var$qi,
    useInsertionEffect: $992039f60b605604$var$ni,
    useLayoutEffect: $992039f60b605604$var$oi,
    useMemo: $992039f60b605604$var$ti,
    useReducer: $992039f60b605604$var$Wh,
    useRef: $992039f60b605604$var$ji,
    useState: function() {
        return $992039f60b605604$var$Wh($992039f60b605604$var$Vh);
    },
    useDebugValue: $992039f60b605604$var$ri,
    useDeferredValue: function(a) {
        var b = $992039f60b605604$var$Uh();
        return $992039f60b605604$var$ui(b, $992039f60b605604$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $992039f60b605604$var$Wh($992039f60b605604$var$Vh)[0], b = $992039f60b605604$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $992039f60b605604$var$Yh,
    useSyncExternalStore: $992039f60b605604$var$Zh,
    useId: $992039f60b605604$var$wi,
    unstable_isNewReconciler: !1
}, $992039f60b605604$var$Qh = {
    readContext: $992039f60b605604$var$eh,
    useCallback: $992039f60b605604$var$si,
    useContext: $992039f60b605604$var$eh,
    useEffect: $992039f60b605604$var$$h,
    useImperativeHandle: $992039f60b605604$var$qi,
    useInsertionEffect: $992039f60b605604$var$ni,
    useLayoutEffect: $992039f60b605604$var$oi,
    useMemo: $992039f60b605604$var$ti,
    useReducer: $992039f60b605604$var$Xh,
    useRef: $992039f60b605604$var$ji,
    useState: function() {
        return $992039f60b605604$var$Xh($992039f60b605604$var$Vh);
    },
    useDebugValue: $992039f60b605604$var$ri,
    useDeferredValue: function(a) {
        var b = $992039f60b605604$var$Uh();
        return null === $992039f60b605604$var$N ? b.memoizedState = a : $992039f60b605604$var$ui(b, $992039f60b605604$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $992039f60b605604$var$Xh($992039f60b605604$var$Vh)[0], b = $992039f60b605604$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $992039f60b605604$var$Yh,
    useSyncExternalStore: $992039f60b605604$var$Zh,
    useId: $992039f60b605604$var$wi,
    unstable_isNewReconciler: !1
};
function $992039f60b605604$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $992039f60b605604$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $992039f60b605604$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $992039f60b605604$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $992039f60b605604$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $992039f60b605604$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $992039f60b605604$var$R(), e = $992039f60b605604$var$yi(a), f = $992039f60b605604$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $992039f60b605604$var$nh(a, f, e);
        null !== b && ($992039f60b605604$var$gi(b, a, e, d), $992039f60b605604$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $992039f60b605604$var$R(), e = $992039f60b605604$var$yi(a), f = $992039f60b605604$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $992039f60b605604$var$nh(a, f, e);
        null !== b && ($992039f60b605604$var$gi(b, a, e, d), $992039f60b605604$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $992039f60b605604$var$R(), d = $992039f60b605604$var$yi(a), e = $992039f60b605604$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $992039f60b605604$var$nh(a, e, d);
        null !== b && ($992039f60b605604$var$gi(b, a, d, c), $992039f60b605604$var$oh(b, a, d));
    }
};
function $992039f60b605604$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$992039f60b605604$var$Ie(c, d) || !$992039f60b605604$var$Ie(e, f) : !0;
}
function $992039f60b605604$var$Gi(a, b, c) {
    var d = !1, e = $992039f60b605604$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $992039f60b605604$var$eh(f) : (e = $992039f60b605604$var$Zf(b) ? $992039f60b605604$var$Xf : $992039f60b605604$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $992039f60b605604$var$Yf(a, e) : $992039f60b605604$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $992039f60b605604$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $992039f60b605604$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $992039f60b605604$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $992039f60b605604$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $992039f60b605604$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $992039f60b605604$var$eh(f) : (f = $992039f60b605604$var$Zf(b) ? $992039f60b605604$var$Xf : $992039f60b605604$var$H.current, e.context = $992039f60b605604$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($992039f60b605604$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $992039f60b605604$var$Ei.enqueueReplaceState(e, e.state, null), $992039f60b605604$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $992039f60b605604$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $992039f60b605604$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $992039f60b605604$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $992039f60b605604$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $992039f60b605604$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $992039f60b605604$var$Ni(a, b, c) {
    c = $992039f60b605604$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $992039f60b605604$var$Oi || ($992039f60b605604$var$Oi = !0, $992039f60b605604$var$Pi = d);
        $992039f60b605604$var$Li(a, b);
    };
    return c;
}
function $992039f60b605604$var$Qi(a, b, c) {
    c = $992039f60b605604$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $992039f60b605604$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $992039f60b605604$var$Li(a, b);
        "function" !== typeof d && (null === $992039f60b605604$var$Ri ? $992039f60b605604$var$Ri = new Set([
            this
        ]) : $992039f60b605604$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $992039f60b605604$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $992039f60b605604$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $992039f60b605604$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $992039f60b605604$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $992039f60b605604$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $992039f60b605604$var$mh(-1, 1), b.tag = 2, $992039f60b605604$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $992039f60b605604$var$Wi = $992039f60b605604$var$ua.ReactCurrentOwner, $992039f60b605604$var$dh = !1;
function $992039f60b605604$var$Xi(a, b, c, d) {
    b.child = null === a ? $992039f60b605604$var$Vg(b, null, c, d) : $992039f60b605604$var$Ug(b, a.child, c, d);
}
function $992039f60b605604$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $992039f60b605604$var$ch(b, e);
    d = $992039f60b605604$var$Nh(a, b, c, d, f, e);
    c = $992039f60b605604$var$Sh();
    if (null !== a && !$992039f60b605604$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $992039f60b605604$var$Zi(a, b, e);
    $992039f60b605604$var$I && c && $992039f60b605604$var$vg(b);
    b.flags |= 1;
    $992039f60b605604$var$Xi(a, b, d, e);
    return b.child;
}
function $992039f60b605604$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$992039f60b605604$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $992039f60b605604$var$bj(a, b, f, d, e);
        a = $992039f60b605604$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $992039f60b605604$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $992039f60b605604$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $992039f60b605604$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $992039f60b605604$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($992039f60b605604$var$Ie(f, d) && a.ref === b.ref) {
            if ($992039f60b605604$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($992039f60b605604$var$dh = !0);
            else return b.lanes = a.lanes, $992039f60b605604$var$Zi(a, b, e);
        }
    }
    return $992039f60b605604$var$cj(a, b, c, d, e);
}
function $992039f60b605604$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $992039f60b605604$var$G($992039f60b605604$var$ej, $992039f60b605604$var$fj), $992039f60b605604$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $992039f60b605604$var$G($992039f60b605604$var$ej, $992039f60b605604$var$fj), $992039f60b605604$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $992039f60b605604$var$G($992039f60b605604$var$ej, $992039f60b605604$var$fj);
            $992039f60b605604$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $992039f60b605604$var$G($992039f60b605604$var$ej, $992039f60b605604$var$fj), $992039f60b605604$var$fj |= d;
    $992039f60b605604$var$Xi(a, b, e, c);
    return b.child;
}
function $992039f60b605604$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $992039f60b605604$var$cj(a, b, c, d, e) {
    var f = $992039f60b605604$var$Zf(c) ? $992039f60b605604$var$Xf : $992039f60b605604$var$H.current;
    f = $992039f60b605604$var$Yf(b, f);
    $992039f60b605604$var$ch(b, e);
    c = $992039f60b605604$var$Nh(a, b, c, d, f, e);
    d = $992039f60b605604$var$Sh();
    if (null !== a && !$992039f60b605604$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $992039f60b605604$var$Zi(a, b, e);
    $992039f60b605604$var$I && d && $992039f60b605604$var$vg(b);
    b.flags |= 1;
    $992039f60b605604$var$Xi(a, b, c, e);
    return b.child;
}
function $992039f60b605604$var$hj(a, b, c, d, e) {
    if ($992039f60b605604$var$Zf(c)) {
        var f = !0;
        $992039f60b605604$var$cg(b);
    } else f = !1;
    $992039f60b605604$var$ch(b, e);
    if (null === b.stateNode) $992039f60b605604$var$ij(a, b), $992039f60b605604$var$Gi(b, c, d), $992039f60b605604$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $992039f60b605604$var$eh(l) : (l = $992039f60b605604$var$Zf(c) ? $992039f60b605604$var$Xf : $992039f60b605604$var$H.current, l = $992039f60b605604$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $992039f60b605604$var$Hi(b, g, d, l);
        $992039f60b605604$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $992039f60b605604$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $992039f60b605604$var$Wf.current || $992039f60b605604$var$jh ? ("function" === typeof m && ($992039f60b605604$var$Di(b, c, m, d), k = b.memoizedState), (h = $992039f60b605604$var$jh || $992039f60b605604$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $992039f60b605604$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $992039f60b605604$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $992039f60b605604$var$eh(k) : (k = $992039f60b605604$var$Zf(c) ? $992039f60b605604$var$Xf : $992039f60b605604$var$H.current, k = $992039f60b605604$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $992039f60b605604$var$Hi(b, g, d, k);
        $992039f60b605604$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $992039f60b605604$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $992039f60b605604$var$Wf.current || $992039f60b605604$var$jh ? ("function" === typeof y && ($992039f60b605604$var$Di(b, c, y, d), n = b.memoizedState), (l = $992039f60b605604$var$jh || $992039f60b605604$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $992039f60b605604$var$jj(a, b, c, d, f, e);
}
function $992039f60b605604$var$jj(a, b, c, d, e, f) {
    $992039f60b605604$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $992039f60b605604$var$dg(b, c, !1), $992039f60b605604$var$Zi(a, b, f);
    d = b.stateNode;
    $992039f60b605604$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $992039f60b605604$var$Ug(b, a.child, null, f), b.child = $992039f60b605604$var$Ug(b, null, h, f)) : $992039f60b605604$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $992039f60b605604$var$dg(b, c, !0);
    return b.child;
}
function $992039f60b605604$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $992039f60b605604$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $992039f60b605604$var$ag(a, b.context, !1);
    $992039f60b605604$var$yh(a, b.containerInfo);
}
function $992039f60b605604$var$lj(a, b, c, d, e) {
    $992039f60b605604$var$Ig();
    $992039f60b605604$var$Jg(e);
    b.flags |= 256;
    $992039f60b605604$var$Xi(a, b, c, d);
    return b.child;
}
var $992039f60b605604$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $992039f60b605604$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $992039f60b605604$var$oj(a, b, c) {
    var d = b.pendingProps, e = $992039f60b605604$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $992039f60b605604$var$G($992039f60b605604$var$L, e & 1);
    if (null === a) {
        $992039f60b605604$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $992039f60b605604$var$pj(g, d, 0, null), a = $992039f60b605604$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $992039f60b605604$var$nj(c), b.memoizedState = $992039f60b605604$var$mj, a) : $992039f60b605604$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $992039f60b605604$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $992039f60b605604$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $992039f60b605604$var$Pg(h, f) : (f = $992039f60b605604$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $992039f60b605604$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $992039f60b605604$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $992039f60b605604$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $992039f60b605604$var$qj(a, b) {
    b = $992039f60b605604$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $992039f60b605604$var$sj(a, b, c, d) {
    null !== d && $992039f60b605604$var$Jg(d);
    $992039f60b605604$var$Ug(b, a.child, null, c);
    a = $992039f60b605604$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $992039f60b605604$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $992039f60b605604$var$Ki(Error($992039f60b605604$var$p(422))), $992039f60b605604$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $992039f60b605604$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $992039f60b605604$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $992039f60b605604$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $992039f60b605604$var$nj(g);
        b.memoizedState = $992039f60b605604$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $992039f60b605604$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($992039f60b605604$var$p(419));
        d = $992039f60b605604$var$Ki(f, d, void 0);
        return $992039f60b605604$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($992039f60b605604$var$dh || h) {
        d = $992039f60b605604$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $992039f60b605604$var$ih(a, e), $992039f60b605604$var$gi(d, a, e, -1));
        }
        $992039f60b605604$var$tj();
        d = $992039f60b605604$var$Ki(Error($992039f60b605604$var$p(421)));
        return $992039f60b605604$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $992039f60b605604$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $992039f60b605604$var$yg = $992039f60b605604$var$Lf(e.nextSibling);
    $992039f60b605604$var$xg = b;
    $992039f60b605604$var$I = !0;
    $992039f60b605604$var$zg = null;
    null !== a && ($992039f60b605604$var$og[$992039f60b605604$var$pg++] = $992039f60b605604$var$rg, $992039f60b605604$var$og[$992039f60b605604$var$pg++] = $992039f60b605604$var$sg, $992039f60b605604$var$og[$992039f60b605604$var$pg++] = $992039f60b605604$var$qg, $992039f60b605604$var$rg = a.id, $992039f60b605604$var$sg = a.overflow, $992039f60b605604$var$qg = b);
    b = $992039f60b605604$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $992039f60b605604$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $992039f60b605604$var$bh(a.return, b, c);
}
function $992039f60b605604$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $992039f60b605604$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $992039f60b605604$var$Xi(a, b, d.children, c);
    d = $992039f60b605604$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $992039f60b605604$var$vj(a, c, b);
            else if (19 === a.tag) $992039f60b605604$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $992039f60b605604$var$G($992039f60b605604$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $992039f60b605604$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $992039f60b605604$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $992039f60b605604$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $992039f60b605604$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $992039f60b605604$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $992039f60b605604$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $992039f60b605604$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $992039f60b605604$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($992039f60b605604$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $992039f60b605604$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $992039f60b605604$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $992039f60b605604$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $992039f60b605604$var$kj(b);
            $992039f60b605604$var$Ig();
            break;
        case 5:
            $992039f60b605604$var$Ah(b);
            break;
        case 1:
            $992039f60b605604$var$Zf(b.type) && $992039f60b605604$var$cg(b);
            break;
        case 4:
            $992039f60b605604$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $992039f60b605604$var$G($992039f60b605604$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $992039f60b605604$var$G($992039f60b605604$var$L, $992039f60b605604$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $992039f60b605604$var$oj(a, b, c);
                $992039f60b605604$var$G($992039f60b605604$var$L, $992039f60b605604$var$L.current & 1);
                a = $992039f60b605604$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $992039f60b605604$var$G($992039f60b605604$var$L, $992039f60b605604$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $992039f60b605604$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $992039f60b605604$var$G($992039f60b605604$var$L, $992039f60b605604$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $992039f60b605604$var$dj(a, b, c);
    }
    return $992039f60b605604$var$Zi(a, b, c);
}
var $992039f60b605604$var$zj, $992039f60b605604$var$Aj, $992039f60b605604$var$Bj, $992039f60b605604$var$Cj;
$992039f60b605604$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$992039f60b605604$var$Aj = function() {};
$992039f60b605604$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $992039f60b605604$var$xh($992039f60b605604$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $992039f60b605604$var$Ya(a, e);
                d = $992039f60b605604$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $992039f60b605604$var$A({}, e, {
                    value: void 0
                });
                d = $992039f60b605604$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $992039f60b605604$var$gb(a, e);
                d = $992039f60b605604$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $992039f60b605604$var$Bf);
        }
        $992039f60b605604$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($992039f60b605604$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($992039f60b605604$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $992039f60b605604$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$992039f60b605604$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $992039f60b605604$var$Dj(a, b) {
    if (!$992039f60b605604$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $992039f60b605604$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $992039f60b605604$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $992039f60b605604$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $992039f60b605604$var$S(b), null;
        case 1:
            return $992039f60b605604$var$Zf(b.type) && $992039f60b605604$var$$f(), $992039f60b605604$var$S(b), null;
        case 3:
            d = b.stateNode;
            $992039f60b605604$var$zh();
            $992039f60b605604$var$E($992039f60b605604$var$Wf);
            $992039f60b605604$var$E($992039f60b605604$var$H);
            $992039f60b605604$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $992039f60b605604$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $992039f60b605604$var$zg && ($992039f60b605604$var$Fj($992039f60b605604$var$zg), $992039f60b605604$var$zg = null));
            $992039f60b605604$var$Aj(a, b);
            $992039f60b605604$var$S(b);
            return null;
        case 5:
            $992039f60b605604$var$Bh(b);
            var e = $992039f60b605604$var$xh($992039f60b605604$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $992039f60b605604$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($992039f60b605604$var$p(166));
                    $992039f60b605604$var$S(b);
                    return null;
                }
                a = $992039f60b605604$var$xh($992039f60b605604$var$uh.current);
                if ($992039f60b605604$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$992039f60b605604$var$Of] = b;
                    d[$992039f60b605604$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $992039f60b605604$var$D("cancel", d);
                            $992039f60b605604$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $992039f60b605604$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $992039f60b605604$var$lf.length; e++)$992039f60b605604$var$D($992039f60b605604$var$lf[e], d);
                            break;
                        case "source":
                            $992039f60b605604$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $992039f60b605604$var$D("error", d);
                            $992039f60b605604$var$D("load", d);
                            break;
                        case "details":
                            $992039f60b605604$var$D("toggle", d);
                            break;
                        case "input":
                            $992039f60b605604$var$Za(d, f);
                            $992039f60b605604$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $992039f60b605604$var$D("invalid", d);
                            break;
                        case "textarea":
                            $992039f60b605604$var$hb(d, f), $992039f60b605604$var$D("invalid", d);
                    }
                    $992039f60b605604$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $992039f60b605604$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $992039f60b605604$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $992039f60b605604$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $992039f60b605604$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $992039f60b605604$var$Va(d);
                            $992039f60b605604$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $992039f60b605604$var$Va(d);
                            $992039f60b605604$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $992039f60b605604$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $992039f60b605604$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$992039f60b605604$var$Of] = b;
                    a[$992039f60b605604$var$Pf] = d;
                    $992039f60b605604$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $992039f60b605604$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $992039f60b605604$var$D("cancel", a);
                                $992039f60b605604$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $992039f60b605604$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $992039f60b605604$var$lf.length; e++)$992039f60b605604$var$D($992039f60b605604$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $992039f60b605604$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $992039f60b605604$var$D("error", a);
                                $992039f60b605604$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $992039f60b605604$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $992039f60b605604$var$Za(a, d);
                                e = $992039f60b605604$var$Ya(a, d);
                                $992039f60b605604$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $992039f60b605604$var$A({}, d, {
                                    value: void 0
                                });
                                $992039f60b605604$var$D("invalid", a);
                                break;
                            case "textarea":
                                $992039f60b605604$var$hb(a, d);
                                e = $992039f60b605604$var$gb(a, d);
                                $992039f60b605604$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $992039f60b605604$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $992039f60b605604$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $992039f60b605604$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $992039f60b605604$var$ob(a, k) : "number" === typeof k && $992039f60b605604$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($992039f60b605604$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $992039f60b605604$var$D("scroll", a) : null != k && $992039f60b605604$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $992039f60b605604$var$Va(a);
                                $992039f60b605604$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $992039f60b605604$var$Va(a);
                                $992039f60b605604$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $992039f60b605604$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $992039f60b605604$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $992039f60b605604$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $992039f60b605604$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $992039f60b605604$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $992039f60b605604$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($992039f60b605604$var$p(166));
                c = $992039f60b605604$var$xh($992039f60b605604$var$wh.current);
                $992039f60b605604$var$xh($992039f60b605604$var$uh.current);
                if ($992039f60b605604$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$992039f60b605604$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $992039f60b605604$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $992039f60b605604$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $992039f60b605604$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$992039f60b605604$var$Of] = b, b.stateNode = d;
            }
            $992039f60b605604$var$S(b);
            return null;
        case 13:
            $992039f60b605604$var$E($992039f60b605604$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($992039f60b605604$var$I && null !== $992039f60b605604$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $992039f60b605604$var$Hg(), $992039f60b605604$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $992039f60b605604$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($992039f60b605604$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($992039f60b605604$var$p(317));
                        f[$992039f60b605604$var$Of] = b;
                    } else $992039f60b605604$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $992039f60b605604$var$S(b);
                    f = !1;
                } else null !== $992039f60b605604$var$zg && ($992039f60b605604$var$Fj($992039f60b605604$var$zg), $992039f60b605604$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($992039f60b605604$var$L.current & 1) ? 0 === $992039f60b605604$var$T && ($992039f60b605604$var$T = 3) : $992039f60b605604$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $992039f60b605604$var$S(b);
            return null;
        case 4:
            return $992039f60b605604$var$zh(), $992039f60b605604$var$Aj(a, b), null === a && $992039f60b605604$var$sf(b.stateNode.containerInfo), $992039f60b605604$var$S(b), null;
        case 10:
            return $992039f60b605604$var$ah(b.type._context), $992039f60b605604$var$S(b), null;
        case 17:
            return $992039f60b605604$var$Zf(b.type) && $992039f60b605604$var$$f(), $992039f60b605604$var$S(b), null;
        case 19:
            $992039f60b605604$var$E($992039f60b605604$var$L);
            f = b.memoizedState;
            if (null === f) return $992039f60b605604$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $992039f60b605604$var$Dj(f, !1);
                else {
                    if (0 !== $992039f60b605604$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $992039f60b605604$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $992039f60b605604$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $992039f60b605604$var$G($992039f60b605604$var$L, $992039f60b605604$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $992039f60b605604$var$B() > $992039f60b605604$var$Gj && (b.flags |= 128, d = !0, $992039f60b605604$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $992039f60b605604$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $992039f60b605604$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$992039f60b605604$var$I) return $992039f60b605604$var$S(b), null;
                    } else 2 * $992039f60b605604$var$B() - f.renderingStartTime > $992039f60b605604$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $992039f60b605604$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $992039f60b605604$var$B(), b.sibling = null, c = $992039f60b605604$var$L.current, $992039f60b605604$var$G($992039f60b605604$var$L, d ? c & 1 | 2 : c & 1), b;
            $992039f60b605604$var$S(b);
            return null;
        case 22:
        case 23:
            return $992039f60b605604$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($992039f60b605604$var$fj & 1073741824) && ($992039f60b605604$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $992039f60b605604$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($992039f60b605604$var$p(156, b.tag));
}
function $992039f60b605604$var$Ij(a, b) {
    $992039f60b605604$var$wg(b);
    switch(b.tag){
        case 1:
            return $992039f60b605604$var$Zf(b.type) && $992039f60b605604$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $992039f60b605604$var$zh(), $992039f60b605604$var$E($992039f60b605604$var$Wf), $992039f60b605604$var$E($992039f60b605604$var$H), $992039f60b605604$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $992039f60b605604$var$Bh(b), null;
        case 13:
            $992039f60b605604$var$E($992039f60b605604$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($992039f60b605604$var$p(340));
                $992039f60b605604$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $992039f60b605604$var$E($992039f60b605604$var$L), null;
        case 4:
            return $992039f60b605604$var$zh(), null;
        case 10:
            return $992039f60b605604$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $992039f60b605604$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $992039f60b605604$var$Jj = !1, $992039f60b605604$var$U = !1, $992039f60b605604$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $992039f60b605604$var$V = null;
function $992039f60b605604$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $992039f60b605604$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $992039f60b605604$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $992039f60b605604$var$W(a, b, d);
    }
}
var $992039f60b605604$var$Nj = !1;
function $992039f60b605604$var$Oj(a, b) {
    $992039f60b605604$var$Cf = $992039f60b605604$var$dd;
    a = $992039f60b605604$var$Me();
    if ($992039f60b605604$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $992039f60b605604$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $992039f60b605604$var$dd = !1;
    for($992039f60b605604$var$V = b; null !== $992039f60b605604$var$V;)if (b = $992039f60b605604$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $992039f60b605604$var$V = a;
    else for(; null !== $992039f60b605604$var$V;){
        b = $992039f60b605604$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $992039f60b605604$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($992039f60b605604$var$p(163));
            }
        } catch (F) {
            $992039f60b605604$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $992039f60b605604$var$V = a;
            break;
        }
        $992039f60b605604$var$V = b.return;
    }
    n = $992039f60b605604$var$Nj;
    $992039f60b605604$var$Nj = !1;
    return n;
}
function $992039f60b605604$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $992039f60b605604$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $992039f60b605604$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $992039f60b605604$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $992039f60b605604$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $992039f60b605604$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$992039f60b605604$var$Of], delete b[$992039f60b605604$var$Pf], delete b[$992039f60b605604$var$of], delete b[$992039f60b605604$var$Qf], delete b[$992039f60b605604$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $992039f60b605604$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $992039f60b605604$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $992039f60b605604$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $992039f60b605604$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $992039f60b605604$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($992039f60b605604$var$Vj(a, b, c), a = a.sibling; null !== a;)$992039f60b605604$var$Vj(a, b, c), a = a.sibling;
}
function $992039f60b605604$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($992039f60b605604$var$Wj(a, b, c), a = a.sibling; null !== a;)$992039f60b605604$var$Wj(a, b, c), a = a.sibling;
}
var $992039f60b605604$var$X = null, $992039f60b605604$var$Xj = !1;
function $992039f60b605604$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$992039f60b605604$var$Zj(a, b, c), c = c.sibling;
}
function $992039f60b605604$var$Zj(a, b, c) {
    if ($992039f60b605604$var$lc && "function" === typeof $992039f60b605604$var$lc.onCommitFiberUnmount) try {
        $992039f60b605604$var$lc.onCommitFiberUnmount($992039f60b605604$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $992039f60b605604$var$U || $992039f60b605604$var$Lj(c, b);
        case 6:
            var d = $992039f60b605604$var$X, e = $992039f60b605604$var$Xj;
            $992039f60b605604$var$X = null;
            $992039f60b605604$var$Yj(a, b, c);
            $992039f60b605604$var$X = d;
            $992039f60b605604$var$Xj = e;
            null !== $992039f60b605604$var$X && ($992039f60b605604$var$Xj ? (a = $992039f60b605604$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $992039f60b605604$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $992039f60b605604$var$X && ($992039f60b605604$var$Xj ? (a = $992039f60b605604$var$X, c = c.stateNode, 8 === a.nodeType ? $992039f60b605604$var$Kf(a.parentNode, c) : 1 === a.nodeType && $992039f60b605604$var$Kf(a, c), $992039f60b605604$var$bd(a)) : $992039f60b605604$var$Kf($992039f60b605604$var$X, c.stateNode));
            break;
        case 4:
            d = $992039f60b605604$var$X;
            e = $992039f60b605604$var$Xj;
            $992039f60b605604$var$X = c.stateNode.containerInfo;
            $992039f60b605604$var$Xj = !0;
            $992039f60b605604$var$Yj(a, b, c);
            $992039f60b605604$var$X = d;
            $992039f60b605604$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$992039f60b605604$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $992039f60b605604$var$Mj(c, b, g) : 0 !== (f & 4) && $992039f60b605604$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $992039f60b605604$var$Yj(a, b, c);
            break;
        case 1:
            if (!$992039f60b605604$var$U && ($992039f60b605604$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $992039f60b605604$var$W(c, b, h);
            }
            $992039f60b605604$var$Yj(a, b, c);
            break;
        case 21:
            $992039f60b605604$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($992039f60b605604$var$U = (d = $992039f60b605604$var$U) || null !== c.memoizedState, $992039f60b605604$var$Yj(a, b, c), $992039f60b605604$var$U = d) : $992039f60b605604$var$Yj(a, b, c);
            break;
        default:
            $992039f60b605604$var$Yj(a, b, c);
    }
}
function $992039f60b605604$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $992039f60b605604$var$Kj);
        b.forEach(function(b) {
            var d = $992039f60b605604$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $992039f60b605604$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $992039f60b605604$var$X = h.stateNode;
                        $992039f60b605604$var$Xj = !1;
                        break a;
                    case 3:
                        $992039f60b605604$var$X = h.stateNode.containerInfo;
                        $992039f60b605604$var$Xj = !0;
                        break a;
                    case 4:
                        $992039f60b605604$var$X = h.stateNode.containerInfo;
                        $992039f60b605604$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $992039f60b605604$var$X) throw Error($992039f60b605604$var$p(160));
            $992039f60b605604$var$Zj(f, g, e);
            $992039f60b605604$var$X = null;
            $992039f60b605604$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $992039f60b605604$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$992039f60b605604$var$dk(b, a), b = b.sibling;
}
function $992039f60b605604$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            if (d & 4) {
                try {
                    $992039f60b605604$var$Pj(3, a, a.return), $992039f60b605604$var$Qj(3, a);
                } catch (t) {
                    $992039f60b605604$var$W(a, a.return, t);
                }
                try {
                    $992039f60b605604$var$Pj(5, a, a.return);
                } catch (t) {
                    $992039f60b605604$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            d & 512 && null !== c && $992039f60b605604$var$Lj(c, c.return);
            break;
        case 5:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            d & 512 && null !== c && $992039f60b605604$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $992039f60b605604$var$ob(e, "");
                } catch (t) {
                    $992039f60b605604$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $992039f60b605604$var$ab(e, f);
                    $992039f60b605604$var$vb(h, g);
                    var l = $992039f60b605604$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $992039f60b605604$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $992039f60b605604$var$nb(e, q) : "children" === m ? $992039f60b605604$var$ob(e, q) : $992039f60b605604$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $992039f60b605604$var$bb(e, f);
                            break;
                        case "textarea":
                            $992039f60b605604$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $992039f60b605604$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $992039f60b605604$var$fb(e, !!f.multiple, f.defaultValue, !0) : $992039f60b605604$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$992039f60b605604$var$Pf] = f;
                } catch (t) {
                    $992039f60b605604$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($992039f60b605604$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $992039f60b605604$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $992039f60b605604$var$bd(b.containerInfo);
            } catch (t) {
                $992039f60b605604$var$W(a, a.return, t);
            }
            break;
        case 4:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            break;
        case 13:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($992039f60b605604$var$fk = $992039f60b605604$var$B()));
            d & 4 && $992039f60b605604$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($992039f60b605604$var$U = (l = $992039f60b605604$var$U) || m, $992039f60b605604$var$ck(b, a), $992039f60b605604$var$U = l) : $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($992039f60b605604$var$V = a, m = a.child; null !== m;){
                    for(q = $992039f60b605604$var$V = m; null !== $992039f60b605604$var$V;){
                        r = $992039f60b605604$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $992039f60b605604$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $992039f60b605604$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $992039f60b605604$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $992039f60b605604$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $992039f60b605604$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $992039f60b605604$var$V = y) : $992039f60b605604$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $992039f60b605604$var$rb("display", g));
                            } catch (t) {
                                $992039f60b605604$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $992039f60b605604$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $992039f60b605604$var$ck(b, a);
            $992039f60b605604$var$ek(a);
            d & 4 && $992039f60b605604$var$ak(a);
            break;
        case 21:
            break;
        default:
            $992039f60b605604$var$ck(b, a), $992039f60b605604$var$ek(a);
    }
}
function $992039f60b605604$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($992039f60b605604$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($992039f60b605604$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($992039f60b605604$var$ob(e, ""), d.flags &= -33);
                    var f = $992039f60b605604$var$Uj(a);
                    $992039f60b605604$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $992039f60b605604$var$Uj(a);
                    $992039f60b605604$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($992039f60b605604$var$p(161));
            }
        } catch (k) {
            $992039f60b605604$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $992039f60b605604$var$hk(a, b, c) {
    $992039f60b605604$var$V = a;
    $992039f60b605604$var$ik(a, b, c);
}
function $992039f60b605604$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $992039f60b605604$var$V;){
        var e = $992039f60b605604$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $992039f60b605604$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $992039f60b605604$var$U;
                h = $992039f60b605604$var$Jj;
                var l = $992039f60b605604$var$U;
                $992039f60b605604$var$Jj = g;
                if (($992039f60b605604$var$U = k) && !l) for($992039f60b605604$var$V = e; null !== $992039f60b605604$var$V;)g = $992039f60b605604$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $992039f60b605604$var$jk(e) : null !== k ? (k.return = g, $992039f60b605604$var$V = k) : $992039f60b605604$var$jk(e);
                for(; null !== f;)$992039f60b605604$var$V = f, $992039f60b605604$var$ik(f, b, c), f = f.sibling;
                $992039f60b605604$var$V = e;
                $992039f60b605604$var$Jj = h;
                $992039f60b605604$var$U = l;
            }
            $992039f60b605604$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $992039f60b605604$var$V = f) : $992039f60b605604$var$kk(a, b, c);
    }
}
function $992039f60b605604$var$kk(a) {
    for(; null !== $992039f60b605604$var$V;){
        var b = $992039f60b605604$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $992039f60b605604$var$U || $992039f60b605604$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$992039f60b605604$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $992039f60b605604$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $992039f60b605604$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $992039f60b605604$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $992039f60b605604$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($992039f60b605604$var$p(163));
                }
                $992039f60b605604$var$U || b.flags & 512 && $992039f60b605604$var$Rj(b);
            } catch (r) {
                $992039f60b605604$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $992039f60b605604$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $992039f60b605604$var$V = c;
            break;
        }
        $992039f60b605604$var$V = b.return;
    }
}
function $992039f60b605604$var$gk(a) {
    for(; null !== $992039f60b605604$var$V;){
        var b = $992039f60b605604$var$V;
        if (b === a) {
            $992039f60b605604$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $992039f60b605604$var$V = c;
            break;
        }
        $992039f60b605604$var$V = b.return;
    }
}
function $992039f60b605604$var$jk(a) {
    for(; null !== $992039f60b605604$var$V;){
        var b = $992039f60b605604$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $992039f60b605604$var$Qj(4, b);
                    } catch (k) {
                        $992039f60b605604$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $992039f60b605604$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $992039f60b605604$var$Rj(b);
                    } catch (k) {
                        $992039f60b605604$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $992039f60b605604$var$Rj(b);
                    } catch (k) {
                        $992039f60b605604$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $992039f60b605604$var$W(b, b.return, k);
        }
        if (b === a) {
            $992039f60b605604$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $992039f60b605604$var$V = h;
            break;
        }
        $992039f60b605604$var$V = b.return;
    }
}
var $992039f60b605604$var$lk = Math.ceil, $992039f60b605604$var$mk = $992039f60b605604$var$ua.ReactCurrentDispatcher, $992039f60b605604$var$nk = $992039f60b605604$var$ua.ReactCurrentOwner, $992039f60b605604$var$ok = $992039f60b605604$var$ua.ReactCurrentBatchConfig, $992039f60b605604$var$K = 0, $992039f60b605604$var$Q = null, $992039f60b605604$var$Y = null, $992039f60b605604$var$Z = 0, $992039f60b605604$var$fj = 0, $992039f60b605604$var$ej = $992039f60b605604$var$Uf(0), $992039f60b605604$var$T = 0, $992039f60b605604$var$pk = null, $992039f60b605604$var$rh = 0, $992039f60b605604$var$qk = 0, $992039f60b605604$var$rk = 0, $992039f60b605604$var$sk = null, $992039f60b605604$var$tk = null, $992039f60b605604$var$fk = 0, $992039f60b605604$var$Gj = Infinity, $992039f60b605604$var$uk = null, $992039f60b605604$var$Oi = !1, $992039f60b605604$var$Pi = null, $992039f60b605604$var$Ri = null, $992039f60b605604$var$vk = !1, $992039f60b605604$var$wk = null, $992039f60b605604$var$xk = 0, $992039f60b605604$var$yk = 0, $992039f60b605604$var$zk = null, $992039f60b605604$var$Ak = -1, $992039f60b605604$var$Bk = 0;
function $992039f60b605604$var$R() {
    return 0 !== ($992039f60b605604$var$K & 6) ? $992039f60b605604$var$B() : -1 !== $992039f60b605604$var$Ak ? $992039f60b605604$var$Ak : $992039f60b605604$var$Ak = $992039f60b605604$var$B();
}
function $992039f60b605604$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($992039f60b605604$var$K & 2) && 0 !== $992039f60b605604$var$Z) return $992039f60b605604$var$Z & -$992039f60b605604$var$Z;
    if (null !== $992039f60b605604$var$Kg.transition) return 0 === $992039f60b605604$var$Bk && ($992039f60b605604$var$Bk = $992039f60b605604$var$yc()), $992039f60b605604$var$Bk;
    a = $992039f60b605604$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $992039f60b605604$var$jd(a.type);
    return a;
}
function $992039f60b605604$var$gi(a, b, c, d) {
    if (50 < $992039f60b605604$var$yk) throw $992039f60b605604$var$yk = 0, $992039f60b605604$var$zk = null, Error($992039f60b605604$var$p(185));
    $992039f60b605604$var$Ac(a, c, d);
    if (0 === ($992039f60b605604$var$K & 2) || a !== $992039f60b605604$var$Q) a === $992039f60b605604$var$Q && (0 === ($992039f60b605604$var$K & 2) && ($992039f60b605604$var$qk |= c), 4 === $992039f60b605604$var$T && $992039f60b605604$var$Ck(a, $992039f60b605604$var$Z)), $992039f60b605604$var$Dk(a, d), 1 === c && 0 === $992039f60b605604$var$K && 0 === (b.mode & 1) && ($992039f60b605604$var$Gj = $992039f60b605604$var$B() + 500, $992039f60b605604$var$fg && $992039f60b605604$var$jg());
}
function $992039f60b605604$var$Dk(a, b) {
    var c = a.callbackNode;
    $992039f60b605604$var$wc(a, b);
    var d = $992039f60b605604$var$uc(a, a === $992039f60b605604$var$Q ? $992039f60b605604$var$Z : 0);
    if (0 === d) null !== c && $992039f60b605604$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $992039f60b605604$var$bc(c);
        if (1 === b) 0 === a.tag ? $992039f60b605604$var$ig($992039f60b605604$var$Ek.bind(null, a)) : $992039f60b605604$var$hg($992039f60b605604$var$Ek.bind(null, a)), $992039f60b605604$var$Jf(function() {
            0 === ($992039f60b605604$var$K & 6) && $992039f60b605604$var$jg();
        }), c = null;
        else {
            switch($992039f60b605604$var$Dc(d)){
                case 1:
                    c = $992039f60b605604$var$fc;
                    break;
                case 4:
                    c = $992039f60b605604$var$gc;
                    break;
                case 16:
                    c = $992039f60b605604$var$hc;
                    break;
                case 536870912:
                    c = $992039f60b605604$var$jc;
                    break;
                default:
                    c = $992039f60b605604$var$hc;
            }
            c = $992039f60b605604$var$Fk(c, $992039f60b605604$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $992039f60b605604$var$Gk(a, b) {
    $992039f60b605604$var$Ak = -1;
    $992039f60b605604$var$Bk = 0;
    if (0 !== ($992039f60b605604$var$K & 6)) throw Error($992039f60b605604$var$p(327));
    var c = a.callbackNode;
    if ($992039f60b605604$var$Hk() && a.callbackNode !== c) return null;
    var d = $992039f60b605604$var$uc(a, a === $992039f60b605604$var$Q ? $992039f60b605604$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $992039f60b605604$var$Ik(a, d);
    else {
        b = d;
        var e = $992039f60b605604$var$K;
        $992039f60b605604$var$K |= 2;
        var f = $992039f60b605604$var$Jk();
        if ($992039f60b605604$var$Q !== a || $992039f60b605604$var$Z !== b) $992039f60b605604$var$uk = null, $992039f60b605604$var$Gj = $992039f60b605604$var$B() + 500, $992039f60b605604$var$Kk(a, b);
        for(;;)try {
            $992039f60b605604$var$Lk();
            break;
        } catch (h) {
            $992039f60b605604$var$Mk(a, h);
        }
        $992039f60b605604$var$$g();
        $992039f60b605604$var$mk.current = f;
        $992039f60b605604$var$K = e;
        null !== $992039f60b605604$var$Y ? b = 0 : ($992039f60b605604$var$Q = null, $992039f60b605604$var$Z = 0, b = $992039f60b605604$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $992039f60b605604$var$xc(a), 0 !== e && (d = e, b = $992039f60b605604$var$Nk(a, e)));
        if (1 === b) throw c = $992039f60b605604$var$pk, $992039f60b605604$var$Kk(a, 0), $992039f60b605604$var$Ck(a, d), $992039f60b605604$var$Dk(a, $992039f60b605604$var$B()), c;
        if (6 === b) $992039f60b605604$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$992039f60b605604$var$Ok(e) && (b = $992039f60b605604$var$Ik(a, d), 2 === b && (f = $992039f60b605604$var$xc(a), 0 !== f && (d = f, b = $992039f60b605604$var$Nk(a, f))), 1 === b)) throw c = $992039f60b605604$var$pk, $992039f60b605604$var$Kk(a, 0), $992039f60b605604$var$Ck(a, d), $992039f60b605604$var$Dk(a, $992039f60b605604$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($992039f60b605604$var$p(345));
                case 2:
                    $992039f60b605604$var$Pk(a, $992039f60b605604$var$tk, $992039f60b605604$var$uk);
                    break;
                case 3:
                    $992039f60b605604$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $992039f60b605604$var$fk + 500 - $992039f60b605604$var$B(), 10 < b)) {
                        if (0 !== $992039f60b605604$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $992039f60b605604$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $992039f60b605604$var$Ff($992039f60b605604$var$Pk.bind(null, a, $992039f60b605604$var$tk, $992039f60b605604$var$uk), b);
                        break;
                    }
                    $992039f60b605604$var$Pk(a, $992039f60b605604$var$tk, $992039f60b605604$var$uk);
                    break;
                case 4:
                    $992039f60b605604$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $992039f60b605604$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $992039f60b605604$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $992039f60b605604$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $992039f60b605604$var$Ff($992039f60b605604$var$Pk.bind(null, a, $992039f60b605604$var$tk, $992039f60b605604$var$uk), d);
                        break;
                    }
                    $992039f60b605604$var$Pk(a, $992039f60b605604$var$tk, $992039f60b605604$var$uk);
                    break;
                case 5:
                    $992039f60b605604$var$Pk(a, $992039f60b605604$var$tk, $992039f60b605604$var$uk);
                    break;
                default:
                    throw Error($992039f60b605604$var$p(329));
            }
        }
    }
    $992039f60b605604$var$Dk(a, $992039f60b605604$var$B());
    return a.callbackNode === c ? $992039f60b605604$var$Gk.bind(null, a) : null;
}
function $992039f60b605604$var$Nk(a, b) {
    var c = $992039f60b605604$var$sk;
    a.current.memoizedState.isDehydrated && ($992039f60b605604$var$Kk(a, b).flags |= 256);
    a = $992039f60b605604$var$Ik(a, b);
    2 !== a && (b = $992039f60b605604$var$tk, $992039f60b605604$var$tk = c, null !== b && $992039f60b605604$var$Fj(b));
    return a;
}
function $992039f60b605604$var$Fj(a) {
    null === $992039f60b605604$var$tk ? $992039f60b605604$var$tk = a : $992039f60b605604$var$tk.push.apply($992039f60b605604$var$tk, a);
}
function $992039f60b605604$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$992039f60b605604$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $992039f60b605604$var$Ck(a, b) {
    b &= ~$992039f60b605604$var$rk;
    b &= ~$992039f60b605604$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $992039f60b605604$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $992039f60b605604$var$Ek(a) {
    if (0 !== ($992039f60b605604$var$K & 6)) throw Error($992039f60b605604$var$p(327));
    $992039f60b605604$var$Hk();
    var b = $992039f60b605604$var$uc(a, 0);
    if (0 === (b & 1)) return $992039f60b605604$var$Dk(a, $992039f60b605604$var$B()), null;
    var c = $992039f60b605604$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $992039f60b605604$var$xc(a);
        0 !== d && (b = d, c = $992039f60b605604$var$Nk(a, d));
    }
    if (1 === c) throw c = $992039f60b605604$var$pk, $992039f60b605604$var$Kk(a, 0), $992039f60b605604$var$Ck(a, b), $992039f60b605604$var$Dk(a, $992039f60b605604$var$B()), c;
    if (6 === c) throw Error($992039f60b605604$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $992039f60b605604$var$Pk(a, $992039f60b605604$var$tk, $992039f60b605604$var$uk);
    $992039f60b605604$var$Dk(a, $992039f60b605604$var$B());
    return null;
}
function $992039f60b605604$var$Qk(a, b) {
    var c = $992039f60b605604$var$K;
    $992039f60b605604$var$K |= 1;
    try {
        return a(b);
    } finally{
        $992039f60b605604$var$K = c, 0 === $992039f60b605604$var$K && ($992039f60b605604$var$Gj = $992039f60b605604$var$B() + 500, $992039f60b605604$var$fg && $992039f60b605604$var$jg());
    }
}
function $992039f60b605604$var$Rk(a) {
    null !== $992039f60b605604$var$wk && 0 === $992039f60b605604$var$wk.tag && 0 === ($992039f60b605604$var$K & 6) && $992039f60b605604$var$Hk();
    var b = $992039f60b605604$var$K;
    $992039f60b605604$var$K |= 1;
    var c = $992039f60b605604$var$ok.transition, d = $992039f60b605604$var$C;
    try {
        if ($992039f60b605604$var$ok.transition = null, $992039f60b605604$var$C = 1, a) return a();
    } finally{
        $992039f60b605604$var$C = d, $992039f60b605604$var$ok.transition = c, $992039f60b605604$var$K = b, 0 === ($992039f60b605604$var$K & 6) && $992039f60b605604$var$jg();
    }
}
function $992039f60b605604$var$Hj() {
    $992039f60b605604$var$fj = $992039f60b605604$var$ej.current;
    $992039f60b605604$var$E($992039f60b605604$var$ej);
}
function $992039f60b605604$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $992039f60b605604$var$Gf(c));
    if (null !== $992039f60b605604$var$Y) for(c = $992039f60b605604$var$Y.return; null !== c;){
        var d = c;
        $992039f60b605604$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $992039f60b605604$var$$f();
                break;
            case 3:
                $992039f60b605604$var$zh();
                $992039f60b605604$var$E($992039f60b605604$var$Wf);
                $992039f60b605604$var$E($992039f60b605604$var$H);
                $992039f60b605604$var$Eh();
                break;
            case 5:
                $992039f60b605604$var$Bh(d);
                break;
            case 4:
                $992039f60b605604$var$zh();
                break;
            case 13:
                $992039f60b605604$var$E($992039f60b605604$var$L);
                break;
            case 19:
                $992039f60b605604$var$E($992039f60b605604$var$L);
                break;
            case 10:
                $992039f60b605604$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $992039f60b605604$var$Hj();
        }
        c = c.return;
    }
    $992039f60b605604$var$Q = a;
    $992039f60b605604$var$Y = a = $992039f60b605604$var$Pg(a.current, null);
    $992039f60b605604$var$Z = $992039f60b605604$var$fj = b;
    $992039f60b605604$var$T = 0;
    $992039f60b605604$var$pk = null;
    $992039f60b605604$var$rk = $992039f60b605604$var$qk = $992039f60b605604$var$rh = 0;
    $992039f60b605604$var$tk = $992039f60b605604$var$sk = null;
    if (null !== $992039f60b605604$var$fh) {
        for(b = 0; b < $992039f60b605604$var$fh.length; b++)if (c = $992039f60b605604$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $992039f60b605604$var$fh = null;
    }
    return a;
}
function $992039f60b605604$var$Mk(a, b) {
    do {
        var c = $992039f60b605604$var$Y;
        try {
            $992039f60b605604$var$$g();
            $992039f60b605604$var$Fh.current = $992039f60b605604$var$Rh;
            if ($992039f60b605604$var$Ih) {
                for(var d = $992039f60b605604$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $992039f60b605604$var$Ih = !1;
            }
            $992039f60b605604$var$Hh = 0;
            $992039f60b605604$var$O = $992039f60b605604$var$N = $992039f60b605604$var$M = null;
            $992039f60b605604$var$Jh = !1;
            $992039f60b605604$var$Kh = 0;
            $992039f60b605604$var$nk.current = null;
            if (null === c || null === c.return) {
                $992039f60b605604$var$T = 1;
                $992039f60b605604$var$pk = b;
                $992039f60b605604$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $992039f60b605604$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $992039f60b605604$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $992039f60b605604$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $992039f60b605604$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $992039f60b605604$var$Si(f, l, b);
                            $992039f60b605604$var$tj();
                            break a;
                        }
                        k = Error($992039f60b605604$var$p(426));
                    }
                } else if ($992039f60b605604$var$I && h.mode & 1) {
                    var J = $992039f60b605604$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $992039f60b605604$var$Vi(J, g, h, f, b);
                        $992039f60b605604$var$Jg($992039f60b605604$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $992039f60b605604$var$Ji(k, h);
                4 !== $992039f60b605604$var$T && ($992039f60b605604$var$T = 2);
                null === $992039f60b605604$var$sk ? $992039f60b605604$var$sk = [
                    f
                ] : $992039f60b605604$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $992039f60b605604$var$Ni(f, k, b);
                            $992039f60b605604$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $992039f60b605604$var$Ri || !$992039f60b605604$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $992039f60b605604$var$Qi(f, h, b);
                                $992039f60b605604$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $992039f60b605604$var$Sk(c);
        } catch (na) {
            b = na;
            $992039f60b605604$var$Y === c && null !== c && ($992039f60b605604$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $992039f60b605604$var$Jk() {
    var a = $992039f60b605604$var$mk.current;
    $992039f60b605604$var$mk.current = $992039f60b605604$var$Rh;
    return null === a ? $992039f60b605604$var$Rh : a;
}
function $992039f60b605604$var$tj() {
    if (0 === $992039f60b605604$var$T || 3 === $992039f60b605604$var$T || 2 === $992039f60b605604$var$T) $992039f60b605604$var$T = 4;
    null === $992039f60b605604$var$Q || 0 === ($992039f60b605604$var$rh & 268435455) && 0 === ($992039f60b605604$var$qk & 268435455) || $992039f60b605604$var$Ck($992039f60b605604$var$Q, $992039f60b605604$var$Z);
}
function $992039f60b605604$var$Ik(a, b) {
    var c = $992039f60b605604$var$K;
    $992039f60b605604$var$K |= 2;
    var d = $992039f60b605604$var$Jk();
    if ($992039f60b605604$var$Q !== a || $992039f60b605604$var$Z !== b) $992039f60b605604$var$uk = null, $992039f60b605604$var$Kk(a, b);
    for(;;)try {
        $992039f60b605604$var$Tk();
        break;
    } catch (e) {
        $992039f60b605604$var$Mk(a, e);
    }
    $992039f60b605604$var$$g();
    $992039f60b605604$var$K = c;
    $992039f60b605604$var$mk.current = d;
    if (null !== $992039f60b605604$var$Y) throw Error($992039f60b605604$var$p(261));
    $992039f60b605604$var$Q = null;
    $992039f60b605604$var$Z = 0;
    return $992039f60b605604$var$T;
}
function $992039f60b605604$var$Tk() {
    for(; null !== $992039f60b605604$var$Y;)$992039f60b605604$var$Uk($992039f60b605604$var$Y);
}
function $992039f60b605604$var$Lk() {
    for(; null !== $992039f60b605604$var$Y && !$992039f60b605604$var$cc();)$992039f60b605604$var$Uk($992039f60b605604$var$Y);
}
function $992039f60b605604$var$Uk(a) {
    var b = $992039f60b605604$var$Vk(a.alternate, a, $992039f60b605604$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $992039f60b605604$var$Sk(a) : $992039f60b605604$var$Y = b;
    $992039f60b605604$var$nk.current = null;
}
function $992039f60b605604$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $992039f60b605604$var$Ej(c, b, $992039f60b605604$var$fj), null !== c) {
                $992039f60b605604$var$Y = c;
                return;
            }
        } else {
            c = $992039f60b605604$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $992039f60b605604$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $992039f60b605604$var$T = 6;
                $992039f60b605604$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $992039f60b605604$var$Y = b;
            return;
        }
        $992039f60b605604$var$Y = b = a;
    }while (null !== b);
    0 === $992039f60b605604$var$T && ($992039f60b605604$var$T = 5);
}
function $992039f60b605604$var$Pk(a, b, c) {
    var d = $992039f60b605604$var$C, e = $992039f60b605604$var$ok.transition;
    try {
        $992039f60b605604$var$ok.transition = null, $992039f60b605604$var$C = 1, $992039f60b605604$var$Wk(a, b, c, d);
    } finally{
        $992039f60b605604$var$ok.transition = e, $992039f60b605604$var$C = d;
    }
    return null;
}
function $992039f60b605604$var$Wk(a, b, c, d) {
    do $992039f60b605604$var$Hk();
    while (null !== $992039f60b605604$var$wk);
    if (0 !== ($992039f60b605604$var$K & 6)) throw Error($992039f60b605604$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($992039f60b605604$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $992039f60b605604$var$Bc(a, f);
    a === $992039f60b605604$var$Q && ($992039f60b605604$var$Y = $992039f60b605604$var$Q = null, $992039f60b605604$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $992039f60b605604$var$vk || ($992039f60b605604$var$vk = !0, $992039f60b605604$var$Fk($992039f60b605604$var$hc, function() {
        $992039f60b605604$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $992039f60b605604$var$ok.transition;
        $992039f60b605604$var$ok.transition = null;
        var g = $992039f60b605604$var$C;
        $992039f60b605604$var$C = 1;
        var h = $992039f60b605604$var$K;
        $992039f60b605604$var$K |= 4;
        $992039f60b605604$var$nk.current = null;
        $992039f60b605604$var$Oj(a, c);
        $992039f60b605604$var$dk(c, a);
        $992039f60b605604$var$Oe($992039f60b605604$var$Df);
        $992039f60b605604$var$dd = !!$992039f60b605604$var$Cf;
        $992039f60b605604$var$Df = $992039f60b605604$var$Cf = null;
        a.current = c;
        $992039f60b605604$var$hk(c, a, e);
        $992039f60b605604$var$dc();
        $992039f60b605604$var$K = h;
        $992039f60b605604$var$C = g;
        $992039f60b605604$var$ok.transition = f;
    } else a.current = c;
    $992039f60b605604$var$vk && ($992039f60b605604$var$vk = !1, $992039f60b605604$var$wk = a, $992039f60b605604$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($992039f60b605604$var$Ri = null);
    $992039f60b605604$var$mc(c.stateNode, d);
    $992039f60b605604$var$Dk(a, $992039f60b605604$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($992039f60b605604$var$Oi) throw $992039f60b605604$var$Oi = !1, a = $992039f60b605604$var$Pi, $992039f60b605604$var$Pi = null, a;
    0 !== ($992039f60b605604$var$xk & 1) && 0 !== a.tag && $992039f60b605604$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $992039f60b605604$var$zk ? $992039f60b605604$var$yk++ : ($992039f60b605604$var$yk = 0, $992039f60b605604$var$zk = a) : $992039f60b605604$var$yk = 0;
    $992039f60b605604$var$jg();
    return null;
}
function $992039f60b605604$var$Hk() {
    if (null !== $992039f60b605604$var$wk) {
        var a = $992039f60b605604$var$Dc($992039f60b605604$var$xk), b = $992039f60b605604$var$ok.transition, c = $992039f60b605604$var$C;
        try {
            $992039f60b605604$var$ok.transition = null;
            $992039f60b605604$var$C = 16 > a ? 16 : a;
            if (null === $992039f60b605604$var$wk) var d = !1;
            else {
                a = $992039f60b605604$var$wk;
                $992039f60b605604$var$wk = null;
                $992039f60b605604$var$xk = 0;
                if (0 !== ($992039f60b605604$var$K & 6)) throw Error($992039f60b605604$var$p(331));
                var e = $992039f60b605604$var$K;
                $992039f60b605604$var$K |= 4;
                for($992039f60b605604$var$V = a.current; null !== $992039f60b605604$var$V;){
                    var f = $992039f60b605604$var$V, g = f.child;
                    if (0 !== ($992039f60b605604$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($992039f60b605604$var$V = l; null !== $992039f60b605604$var$V;){
                                    var m = $992039f60b605604$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $992039f60b605604$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $992039f60b605604$var$V = q;
                                    else for(; null !== $992039f60b605604$var$V;){
                                        m = $992039f60b605604$var$V;
                                        var r = m.sibling, y = m.return;
                                        $992039f60b605604$var$Sj(m);
                                        if (m === l) {
                                            $992039f60b605604$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $992039f60b605604$var$V = r;
                                            break;
                                        }
                                        $992039f60b605604$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $992039f60b605604$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $992039f60b605604$var$V = g;
                    else b: for(; null !== $992039f60b605604$var$V;){
                        f = $992039f60b605604$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $992039f60b605604$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $992039f60b605604$var$V = x;
                            break b;
                        }
                        $992039f60b605604$var$V = f.return;
                    }
                }
                var w = a.current;
                for($992039f60b605604$var$V = w; null !== $992039f60b605604$var$V;){
                    g = $992039f60b605604$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $992039f60b605604$var$V = u;
                    else b: for(g = w; null !== $992039f60b605604$var$V;){
                        h = $992039f60b605604$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $992039f60b605604$var$Qj(9, h);
                            }
                        } catch (na) {
                            $992039f60b605604$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $992039f60b605604$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $992039f60b605604$var$V = F;
                            break b;
                        }
                        $992039f60b605604$var$V = h.return;
                    }
                }
                $992039f60b605604$var$K = e;
                $992039f60b605604$var$jg();
                if ($992039f60b605604$var$lc && "function" === typeof $992039f60b605604$var$lc.onPostCommitFiberRoot) try {
                    $992039f60b605604$var$lc.onPostCommitFiberRoot($992039f60b605604$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $992039f60b605604$var$C = c, $992039f60b605604$var$ok.transition = b;
        }
    }
    return !1;
}
function $992039f60b605604$var$Xk(a, b, c) {
    b = $992039f60b605604$var$Ji(c, b);
    b = $992039f60b605604$var$Ni(a, b, 1);
    a = $992039f60b605604$var$nh(a, b, 1);
    b = $992039f60b605604$var$R();
    null !== a && ($992039f60b605604$var$Ac(a, 1, b), $992039f60b605604$var$Dk(a, b));
}
function $992039f60b605604$var$W(a, b, c) {
    if (3 === a.tag) $992039f60b605604$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $992039f60b605604$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $992039f60b605604$var$Ri || !$992039f60b605604$var$Ri.has(d))) {
                a = $992039f60b605604$var$Ji(c, a);
                a = $992039f60b605604$var$Qi(b, a, 1);
                b = $992039f60b605604$var$nh(b, a, 1);
                a = $992039f60b605604$var$R();
                null !== b && ($992039f60b605604$var$Ac(b, 1, a), $992039f60b605604$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $992039f60b605604$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $992039f60b605604$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $992039f60b605604$var$Q === a && ($992039f60b605604$var$Z & c) === c && (4 === $992039f60b605604$var$T || 3 === $992039f60b605604$var$T && ($992039f60b605604$var$Z & 130023424) === $992039f60b605604$var$Z && 500 > $992039f60b605604$var$B() - $992039f60b605604$var$fk ? $992039f60b605604$var$Kk(a, 0) : $992039f60b605604$var$rk |= c);
    $992039f60b605604$var$Dk(a, b);
}
function $992039f60b605604$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $992039f60b605604$var$sc, $992039f60b605604$var$sc <<= 1, 0 === ($992039f60b605604$var$sc & 130023424) && ($992039f60b605604$var$sc = 4194304)));
    var c = $992039f60b605604$var$R();
    a = $992039f60b605604$var$ih(a, b);
    null !== a && ($992039f60b605604$var$Ac(a, b, c), $992039f60b605604$var$Dk(a, c));
}
function $992039f60b605604$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $992039f60b605604$var$Yk(a, c);
}
function $992039f60b605604$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($992039f60b605604$var$p(314));
    }
    null !== d && d.delete(b);
    $992039f60b605604$var$Yk(a, c);
}
var $992039f60b605604$var$Vk;
$992039f60b605604$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $992039f60b605604$var$Wf.current) $992039f60b605604$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $992039f60b605604$var$dh = !1, $992039f60b605604$var$yj(a, b, c);
            $992039f60b605604$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $992039f60b605604$var$dh = !1, $992039f60b605604$var$I && 0 !== (b.flags & 1048576) && $992039f60b605604$var$ug(b, $992039f60b605604$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $992039f60b605604$var$ij(a, b);
            a = b.pendingProps;
            var e = $992039f60b605604$var$Yf(b, $992039f60b605604$var$H.current);
            $992039f60b605604$var$ch(b, c);
            e = $992039f60b605604$var$Nh(null, b, d, a, e, c);
            var f = $992039f60b605604$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $992039f60b605604$var$Zf(d) ? (f = !0, $992039f60b605604$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $992039f60b605604$var$kh(b), e.updater = $992039f60b605604$var$Ei, b.stateNode = e, e._reactInternals = b, $992039f60b605604$var$Ii(b, d, a, c), b = $992039f60b605604$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $992039f60b605604$var$I && f && $992039f60b605604$var$vg(b), $992039f60b605604$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $992039f60b605604$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $992039f60b605604$var$Zk(d);
                a = $992039f60b605604$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $992039f60b605604$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $992039f60b605604$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $992039f60b605604$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $992039f60b605604$var$$i(null, b, d, $992039f60b605604$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($992039f60b605604$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $992039f60b605604$var$Ci(d, e), $992039f60b605604$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $992039f60b605604$var$Ci(d, e), $992039f60b605604$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $992039f60b605604$var$kj(b);
                if (null === a) throw Error($992039f60b605604$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $992039f60b605604$var$lh(a, b);
                $992039f60b605604$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $992039f60b605604$var$Ji(Error($992039f60b605604$var$p(423)), b);
                        b = $992039f60b605604$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $992039f60b605604$var$Ji(Error($992039f60b605604$var$p(424)), b);
                        b = $992039f60b605604$var$lj(a, b, d, c, e);
                        break a;
                    } else for($992039f60b605604$var$yg = $992039f60b605604$var$Lf(b.stateNode.containerInfo.firstChild), $992039f60b605604$var$xg = b, $992039f60b605604$var$I = !0, $992039f60b605604$var$zg = null, c = $992039f60b605604$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $992039f60b605604$var$Ig();
                    if (d === e) {
                        b = $992039f60b605604$var$Zi(a, b, c);
                        break a;
                    }
                    $992039f60b605604$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $992039f60b605604$var$Ah(b), null === a && $992039f60b605604$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $992039f60b605604$var$Ef(d, e) ? g = null : null !== f && $992039f60b605604$var$Ef(d, f) && (b.flags |= 32), $992039f60b605604$var$gj(a, b), $992039f60b605604$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $992039f60b605604$var$Eg(b), null;
        case 13:
            return $992039f60b605604$var$oj(a, b, c);
        case 4:
            return $992039f60b605604$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $992039f60b605604$var$Ug(b, null, d, c) : $992039f60b605604$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $992039f60b605604$var$Ci(d, e), $992039f60b605604$var$Yi(a, b, d, e, c);
        case 7:
            return $992039f60b605604$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $992039f60b605604$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $992039f60b605604$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $992039f60b605604$var$G($992039f60b605604$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($992039f60b605604$var$He(f.value, g)) {
                        if (f.children === e.children && !$992039f60b605604$var$Wf.current) {
                            b = $992039f60b605604$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $992039f60b605604$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $992039f60b605604$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($992039f60b605604$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $992039f60b605604$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $992039f60b605604$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $992039f60b605604$var$ch(b, c), e = $992039f60b605604$var$eh(e), d = d(e), b.flags |= 1, $992039f60b605604$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $992039f60b605604$var$Ci(d, b.pendingProps), e = $992039f60b605604$var$Ci(d.type, e), $992039f60b605604$var$$i(a, b, d, e, c);
        case 15:
            return $992039f60b605604$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $992039f60b605604$var$Ci(d, e), $992039f60b605604$var$ij(a, b), b.tag = 1, $992039f60b605604$var$Zf(d) ? (a = !0, $992039f60b605604$var$cg(b)) : a = !1, $992039f60b605604$var$ch(b, c), $992039f60b605604$var$Gi(b, d, e), $992039f60b605604$var$Ii(b, d, e, c), $992039f60b605604$var$jj(null, b, d, !0, a, c);
        case 19:
            return $992039f60b605604$var$xj(a, b, c);
        case 22:
            return $992039f60b605604$var$dj(a, b, c);
    }
    throw Error($992039f60b605604$var$p(156, b.tag));
};
function $992039f60b605604$var$Fk(a, b) {
    return $992039f60b605604$var$ac(a, b);
}
function $992039f60b605604$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $992039f60b605604$var$Bg(a, b, c, d) {
    return new $992039f60b605604$var$$k(a, b, c, d);
}
function $992039f60b605604$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $992039f60b605604$var$Zk(a) {
    if ("function" === typeof a) return $992039f60b605604$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $992039f60b605604$var$Da) return 11;
        if (a === $992039f60b605604$var$Ga) return 14;
    }
    return 2;
}
function $992039f60b605604$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $992039f60b605604$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $992039f60b605604$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $992039f60b605604$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $992039f60b605604$var$ya:
            return $992039f60b605604$var$Tg(c.children, e, f, b);
        case $992039f60b605604$var$za:
            g = 8;
            e |= 8;
            break;
        case $992039f60b605604$var$Aa:
            return a = $992039f60b605604$var$Bg(12, c, b, e | 2), a.elementType = $992039f60b605604$var$Aa, a.lanes = f, a;
        case $992039f60b605604$var$Ea:
            return a = $992039f60b605604$var$Bg(13, c, b, e), a.elementType = $992039f60b605604$var$Ea, a.lanes = f, a;
        case $992039f60b605604$var$Fa:
            return a = $992039f60b605604$var$Bg(19, c, b, e), a.elementType = $992039f60b605604$var$Fa, a.lanes = f, a;
        case $992039f60b605604$var$Ia:
            return $992039f60b605604$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $992039f60b605604$var$Ba:
                    g = 10;
                    break a;
                case $992039f60b605604$var$Ca:
                    g = 9;
                    break a;
                case $992039f60b605604$var$Da:
                    g = 11;
                    break a;
                case $992039f60b605604$var$Ga:
                    g = 14;
                    break a;
                case $992039f60b605604$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($992039f60b605604$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $992039f60b605604$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $992039f60b605604$var$Tg(a, b, c, d) {
    a = $992039f60b605604$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $992039f60b605604$var$pj(a, b, c, d) {
    a = $992039f60b605604$var$Bg(22, a, d, b);
    a.elementType = $992039f60b605604$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $992039f60b605604$var$Qg(a, b, c) {
    a = $992039f60b605604$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $992039f60b605604$var$Sg(a, b, c) {
    b = $992039f60b605604$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $992039f60b605604$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $992039f60b605604$var$zc(0);
    this.expirationTimes = $992039f60b605604$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $992039f60b605604$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $992039f60b605604$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $992039f60b605604$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $992039f60b605604$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $992039f60b605604$var$kh(f);
    return a;
}
function $992039f60b605604$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $992039f60b605604$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $992039f60b605604$var$dl(a) {
    if (!a) return $992039f60b605604$var$Vf;
    a = a._reactInternals;
    a: {
        if ($992039f60b605604$var$Vb(a) !== a || 1 !== a.tag) throw Error($992039f60b605604$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($992039f60b605604$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($992039f60b605604$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($992039f60b605604$var$Zf(c)) return $992039f60b605604$var$bg(a, c, b);
    }
    return b;
}
function $992039f60b605604$var$el(a, b, c, d, e, f, g, h, k) {
    a = $992039f60b605604$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $992039f60b605604$var$dl(null);
    c = a.current;
    d = $992039f60b605604$var$R();
    e = $992039f60b605604$var$yi(c);
    f = $992039f60b605604$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $992039f60b605604$var$nh(c, f, e);
    a.current.lanes = e;
    $992039f60b605604$var$Ac(a, e, d);
    $992039f60b605604$var$Dk(a, d);
    return a;
}
function $992039f60b605604$var$fl(a, b, c, d) {
    var e = b.current, f = $992039f60b605604$var$R(), g = $992039f60b605604$var$yi(e);
    c = $992039f60b605604$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $992039f60b605604$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $992039f60b605604$var$nh(e, b, g);
    null !== a && ($992039f60b605604$var$gi(a, e, g, f), $992039f60b605604$var$oh(a, e, g));
    return g;
}
function $992039f60b605604$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $992039f60b605604$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $992039f60b605604$var$il(a, b) {
    $992039f60b605604$var$hl(a, b);
    (a = a.alternate) && $992039f60b605604$var$hl(a, b);
}
function $992039f60b605604$var$jl() {
    return null;
}
var $992039f60b605604$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $992039f60b605604$var$ll(a) {
    this._internalRoot = a;
}
$992039f60b605604$var$ml.prototype.render = $992039f60b605604$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($992039f60b605604$var$p(409));
    $992039f60b605604$var$fl(a, b, null, null);
};
$992039f60b605604$var$ml.prototype.unmount = $992039f60b605604$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $992039f60b605604$var$Rk(function() {
            $992039f60b605604$var$fl(null, a, null, null);
        });
        b[$992039f60b605604$var$uf] = null;
    }
};
function $992039f60b605604$var$ml(a) {
    this._internalRoot = a;
}
$992039f60b605604$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $992039f60b605604$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $992039f60b605604$var$Qc.length && 0 !== b && b < $992039f60b605604$var$Qc[c].priority; c++);
        $992039f60b605604$var$Qc.splice(c, 0, a);
        0 === c && $992039f60b605604$var$Vc(a);
    }
};
function $992039f60b605604$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $992039f60b605604$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $992039f60b605604$var$pl() {}
function $992039f60b605604$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $992039f60b605604$var$gl(g);
                f.call(a);
            };
        }
        var g = $992039f60b605604$var$el(b, d, a, 0, null, !1, !1, "", $992039f60b605604$var$pl);
        a._reactRootContainer = g;
        a[$992039f60b605604$var$uf] = g.current;
        $992039f60b605604$var$sf(8 === a.nodeType ? a.parentNode : a);
        $992039f60b605604$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $992039f60b605604$var$gl(k);
            h.call(a);
        };
    }
    var k = $992039f60b605604$var$bl(a, 0, !1, null, null, !1, !1, "", $992039f60b605604$var$pl);
    a._reactRootContainer = k;
    a[$992039f60b605604$var$uf] = k.current;
    $992039f60b605604$var$sf(8 === a.nodeType ? a.parentNode : a);
    $992039f60b605604$var$Rk(function() {
        $992039f60b605604$var$fl(b, k, c, d);
    });
    return k;
}
function $992039f60b605604$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $992039f60b605604$var$gl(g);
                h.call(a);
            };
        }
        $992039f60b605604$var$fl(b, g, a, e);
    } else g = $992039f60b605604$var$ql(c, b, a, e, d);
    return $992039f60b605604$var$gl(g);
}
$992039f60b605604$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $992039f60b605604$var$tc(b.pendingLanes);
                0 !== c && ($992039f60b605604$var$Cc(b, c | 1), $992039f60b605604$var$Dk(b, $992039f60b605604$var$B()), 0 === ($992039f60b605604$var$K & 6) && ($992039f60b605604$var$Gj = $992039f60b605604$var$B() + 500, $992039f60b605604$var$jg()));
            }
            break;
        case 13:
            $992039f60b605604$var$Rk(function() {
                var b = $992039f60b605604$var$ih(a, 1);
                if (null !== b) {
                    var c = $992039f60b605604$var$R();
                    $992039f60b605604$var$gi(b, a, 1, c);
                }
            }), $992039f60b605604$var$il(a, 1);
    }
};
$992039f60b605604$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $992039f60b605604$var$ih(a, 134217728);
        if (null !== b) {
            var c = $992039f60b605604$var$R();
            $992039f60b605604$var$gi(b, a, 134217728, c);
        }
        $992039f60b605604$var$il(a, 134217728);
    }
};
$992039f60b605604$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $992039f60b605604$var$yi(a), c = $992039f60b605604$var$ih(a, b);
        if (null !== c) {
            var d = $992039f60b605604$var$R();
            $992039f60b605604$var$gi(c, a, b, d);
        }
        $992039f60b605604$var$il(a, b);
    }
};
$992039f60b605604$var$Hc = function() {
    return $992039f60b605604$var$C;
};
$992039f60b605604$var$Ic = function(a, b) {
    var c = $992039f60b605604$var$C;
    try {
        return $992039f60b605604$var$C = a, b();
    } finally{
        $992039f60b605604$var$C = c;
    }
};
$992039f60b605604$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $992039f60b605604$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $992039f60b605604$var$Db(d);
                        if (!e) throw Error($992039f60b605604$var$p(90));
                        $992039f60b605604$var$Wa(d);
                        $992039f60b605604$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $992039f60b605604$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $992039f60b605604$var$fb(a, !!c.multiple, b, !1);
    }
};
$992039f60b605604$var$Gb = $992039f60b605604$var$Qk;
$992039f60b605604$var$Hb = $992039f60b605604$var$Rk;
var $992039f60b605604$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $992039f60b605604$var$Cb,
        $992039f60b605604$var$ue,
        $992039f60b605604$var$Db,
        $992039f60b605604$var$Eb,
        $992039f60b605604$var$Fb,
        $992039f60b605604$var$Qk
    ]
}, $992039f60b605604$var$tl = {
    findFiberByHostInstance: $992039f60b605604$var$Wc,
    bundleType: 0,
    version: "18.3.0",
    rendererPackageName: "react-dom"
};
var $992039f60b605604$var$ul = {
    bundleType: $992039f60b605604$var$tl.bundleType,
    version: $992039f60b605604$var$tl.version,
    rendererPackageName: $992039f60b605604$var$tl.rendererPackageName,
    rendererConfig: $992039f60b605604$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $992039f60b605604$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $992039f60b605604$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $992039f60b605604$var$tl.findFiberByHostInstance || $992039f60b605604$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.0-next-8a015b68cc-20240425"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $992039f60b605604$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$992039f60b605604$var$vl.isDisabled && $992039f60b605604$var$vl.supportsFiber) try {
        $992039f60b605604$var$kc = $992039f60b605604$var$vl.inject($992039f60b605604$var$ul), $992039f60b605604$var$lc = $992039f60b605604$var$vl;
    } catch (a) {}
}
$992039f60b605604$export$ae55be85d98224ed = $992039f60b605604$var$sl;
$992039f60b605604$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$992039f60b605604$var$nl(b)) throw Error($992039f60b605604$var$p(200));
    return $992039f60b605604$var$cl(a, b, null, c);
};
$992039f60b605604$export$882461b6382ed46c = function(a, b) {
    if (!$992039f60b605604$var$nl(a)) throw Error($992039f60b605604$var$p(299));
    var c = !1, d = "", e = $992039f60b605604$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $992039f60b605604$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$992039f60b605604$var$uf] = b.current;
    $992039f60b605604$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $992039f60b605604$var$ll(b);
};
$992039f60b605604$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($992039f60b605604$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($992039f60b605604$var$p(268, a));
    }
    a = $992039f60b605604$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$992039f60b605604$export$cd75ccfd720a3cd4 = function(a) {
    return $992039f60b605604$var$Rk(a);
};
$992039f60b605604$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$992039f60b605604$var$ol(b)) throw Error($992039f60b605604$var$p(200));
    return $992039f60b605604$var$rl(null, a, b, !0, c);
};
$992039f60b605604$export$757ceba2d55c277e = function(a, b, c) {
    if (!$992039f60b605604$var$nl(a)) throw Error($992039f60b605604$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $992039f60b605604$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $992039f60b605604$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$992039f60b605604$var$uf] = b.current;
    $992039f60b605604$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $992039f60b605604$var$ml(b);
};
$992039f60b605604$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$992039f60b605604$var$ol(b)) throw Error($992039f60b605604$var$p(200));
    return $992039f60b605604$var$rl(null, a, b, !1, c);
};
$992039f60b605604$export$502457920280e6be = function(a) {
    if (!$992039f60b605604$var$ol(a)) throw Error($992039f60b605604$var$p(40));
    return a._reactRootContainer ? ($992039f60b605604$var$Rk(function() {
        $992039f60b605604$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$992039f60b605604$var$uf] = null;
        });
    }), !0) : !1;
};
$992039f60b605604$export$c78a37762a8d58e1 = $992039f60b605604$var$Qk;
$992039f60b605604$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$992039f60b605604$var$ol(c)) throw Error($992039f60b605604$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($992039f60b605604$var$p(38));
    return $992039f60b605604$var$rl(a, b, c, !1, d);
};
$992039f60b605604$export$83d89fbfd8236492 = "18.3.0-next-8a015b68cc-20240425";

});
parcelRegister("7zDBh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
'use strict';
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});



/* eslint-disable no-undef */ // eslint is wrong
var $c53f8b07b96ee0c5$exports = {};
'use strict';

$c53f8b07b96ee0c5$exports = (parcelRequire("iMXGO"));



const $fe951448db529767$export$8b6222b576e95114 = {
    isValid: true,
    errorMessage: "",
    errorPath: []
};
const $fe951448db529767$export$353f5b6fc5456de1 = (props)=>{
    //
    const renderIcon = ()=>{
        const { icon: icon, busy: busy } = props;
        if (busy) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("i", {
            className: "spin icon las la-circle-notch"
        });
        if (!icon) return;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("i", {
            className: `icon las ${icon}`
        });
    };
    const { children: children, onClick: onClick, disabled: disabled, className: className, validation: validation = $fe951448db529767$export$8b6222b576e95114, testId: testId, type: type, busy: busy, busyLabel: busyLabel, _ref: _ref, dataCy: dataCy } = props;
    const _disabled = disabled || !validation.isValid || busy;
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("button", {
        id: testId,
        disabled: _disabled,
        className: `${className ?? ""} ${_disabled ? "disabled" : ""} ${type ?? ""}`,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (_disabled) return;
            onClick();
        },
        ref: _ref,
        "data-cy": dataCy,
        children: [
            renderIcon(),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                className: "label",
                children: busy ? busyLabel ?? children : children
            })
        ]
    });
};




var $lldlC = parcelRequire("lldlC");
var $18313decae4d52e6$export$6c0517834721cef7 = /*#__PURE__*/ function(Env) {
    // ci = 'ci',
    Env["dev"] = "dev";
    Env["local"] = "local";
    Env["staging"] = "staging";
    Env["production"] = "production";
    return Env;
}({});



const $df4900d452dcf46f$var$stagingConfig = {
    env: (0, $18313decae4d52e6$export$6c0517834721cef7).staging,
    defaultBucket: "zickko-staging.firebasestorage.app",
    inboundEmailBucket: "zickko_staging_inbound_bucket",
    outboundEmailBucket: "zickko_staging_outbound_bucket"
};
const $df4900d452dcf46f$var$devConfig = {
    env: (0, $18313decae4d52e6$export$6c0517834721cef7).dev,
    defaultBucket: "zickko-dev.firebasestorage.app",
    inboundEmailBucket: "zickko_dev_inbound_bucket",
    outboundEmailBucket: "zickko_dev_outbound_bucket"
};
const $df4900d452dcf46f$var$localConfig = {
    env: (0, $18313decae4d52e6$export$6c0517834721cef7).local,
    defaultBucket: $df4900d452dcf46f$var$stagingConfig.defaultBucket,
    inboundEmailBucket: $df4900d452dcf46f$var$stagingConfig.inboundEmailBucket,
    outboundEmailBucket: $df4900d452dcf46f$var$stagingConfig.outboundEmailBucket
};
const $df4900d452dcf46f$export$2cb4986bed338027 = {
    devConfig: $df4900d452dcf46f$var$devConfig,
    localConfig: $df4900d452dcf46f$var$localConfig,
    stagingConfig: $df4900d452dcf46f$var$stagingConfig
};


const $4a77fffd00953779$export$5f7821c344028c56 = (filename)=>{
    if (!filename) return '';
    const parts = filename.split('.');
    if (parts.length >= 2) return parts.pop();
    return '';
};



const $2053062fb78c3e40$export$468988285e7bced4 = (args)=>{
    // if no filename, return fileId without any extension
    if (!args.filename) return args.fileId;
    const fileExtension = (0, $4a77fffd00953779$export$5f7821c344028c56)(args.filename);
    return `${args.fileId}.${fileExtension}`;
};


var $cc46bd24544f6a52$export$e840e8869344ca38 = /*#__PURE__*/ function(AspectRatio) {
    // none = 'none',
    AspectRatio["horizontalThin"] = "fourTwo";
    AspectRatio["horizontalRegular"] = "fourTwoPointFive";
    AspectRatio["horizontalBanner"] = "eightThree";
    AspectRatio["horizontal"] = "fourThree";
    AspectRatio["square"] = "square";
    AspectRatio["vertical"] = "fourFive";
    AspectRatio["verticalLong"] = "fourSix";
    return AspectRatio;
}({});
const $cc46bd24544f6a52$export$5fd4ea2461ed7833 = {
    id: "fourTwo",
    label: 'Horizontal Thin (4x2)',
    width: 4,
    height: 2
};
const $cc46bd24544f6a52$export$18595bb4a51a1cf8 = {
    id: "fourTwoPointFive",
    label: 'Horizontal Regular (4x2.5)',
    width: 4,
    height: 2.5
};
const $cc46bd24544f6a52$export$ba4c1c06cea58a18 = {
    id: "eightThree",
    label: 'Horizontal Banner (8x3)',
    width: 8,
    height: 3
};
const $cc46bd24544f6a52$export$641ecd0b2bc39508 = {
    id: "fourThree",
    label: 'Horizontal (4x3)',
    width: 4,
    height: 3
};
const $cc46bd24544f6a52$export$dd4f28cef696bc7d = {
    id: "square",
    label: 'Square',
    width: 1,
    height: 1
};
const $cc46bd24544f6a52$export$32f8a6eb41d46820 = {
    id: "fourFive",
    label: 'Vertical (4x5)',
    width: 4,
    height: 5
};
const $cc46bd24544f6a52$export$bfefcce60a201a45 = {
    id: "fourSix",
    label: 'Vertical Long (4x6)',
    width: 4,
    height: 6
};
const $cc46bd24544f6a52$export$e68cf46c92b3705c = [
    $cc46bd24544f6a52$export$5fd4ea2461ed7833,
    $cc46bd24544f6a52$export$18595bb4a51a1cf8,
    $cc46bd24544f6a52$export$ba4c1c06cea58a18,
    $cc46bd24544f6a52$export$641ecd0b2bc39508,
    $cc46bd24544f6a52$export$dd4f28cef696bc7d,
    $cc46bd24544f6a52$export$32f8a6eb41d46820,
    $cc46bd24544f6a52$export$bfefcce60a201a45
];
const $cc46bd24544f6a52$export$6aeb29f472fa5ded = {
    ["fourTwo"]: $cc46bd24544f6a52$export$5fd4ea2461ed7833,
    ["fourTwoPointFive"]: $cc46bd24544f6a52$export$18595bb4a51a1cf8,
    ["eightThree"]: $cc46bd24544f6a52$export$ba4c1c06cea58a18,
    ["fourThree"]: $cc46bd24544f6a52$export$641ecd0b2bc39508,
    ["square"]: $cc46bd24544f6a52$export$dd4f28cef696bc7d,
    ["fourFive"]: $cc46bd24544f6a52$export$32f8a6eb41d46820,
    ["fourSix"]: $cc46bd24544f6a52$export$bfefcce60a201a45
};


/**
 * We need our ids to be short enough and also be distributed over time.
 * We also need out ids to be neat, with just lowercase and numbers. Easy to select and to look good in the URLs.
 *
 * All ids should have a space and time component
 */ // number of milliseconds elapsed since the epoch as of 1st Nov 2023
// having a set beginning creates much smaller IDs in the time component
// as this ingores all the time that has elapsed from January 1, 1970 to the beginning which is 1st Nov 2023 in this case.
const $d0a2c8f56fdc7af2$var$beginning = 1698803666528;
// moves randomly in space - 100,000 possible values (within the space of a second)
const $d0a2c8f56fdc7af2$var$space = ()=>Math.floor(Math.random() * 100000).toString(36);
const $d0a2c8f56fdc7af2$var$time = ()=>Math.floor((Date.now() - $d0a2c8f56fdc7af2$var$beginning) / 1000).toString(36); // moves forward every second
const $d0a2c8f56fdc7af2$export$7149c6ffc9994c32 = ()=>`${$d0a2c8f56fdc7af2$var$space()}_${$d0a2c8f56fdc7af2$var$time()}`.toUpperCase();
const $d0a2c8f56fdc7af2$export$eb3f5f3fadd5e75d = ()=>`${$d0a2c8f56fdc7af2$var$time()}_${$d0a2c8f56fdc7af2$var$space()}`.toUpperCase();
const $d0a2c8f56fdc7af2$export$7fcbba9bca0e0544 = ()=>`${$d0a2c8f56fdc7af2$var$space().toUpperCase()}_${$d0a2c8f56fdc7af2$var$time()}_${$d0a2c8f56fdc7af2$var$space()}`;
const $d0a2c8f56fdc7af2$export$609c6c141bd766ba = {
    createId: $d0a2c8f56fdc7af2$export$7149c6ffc9994c32,
    createFileId: $d0a2c8f56fdc7af2$export$eb3f5f3fadd5e75d,
    createRandomPassword: $d0a2c8f56fdc7af2$export$7fcbba9bca0e0544
};


const $d95193d4ccefcd01$export$eb3f5f3fadd5e75d = (args)=>`${(0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createFileId()}.${args.extension}`;


const $53efa3a118a98115$export$82f46aa4e6535a45 = (error)=>{
    if (error instanceof Error) return error.message;
    return String(error);
};


var $cd2436cf019ecb67$exports = {};
'use strict';
Object.defineProperty($cd2436cf019ecb67$exports, '__esModule', {
    value: true
});
function $cd2436cf019ecb67$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cd2436cf019ecb67$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $cd2436cf019ecb67$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cd2436cf019ecb67$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cd2436cf019ecb67$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $cd2436cf019ecb67$var$_extends() {
    $cd2436cf019ecb67$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd2436cf019ecb67$var$_extends.apply(this, arguments);
}
function $cd2436cf019ecb67$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $cd2436cf019ecb67$var$_setPrototypeOf(subClass, superClass);
}
function $cd2436cf019ecb67$var$_getPrototypeOf(o) {
    $cd2436cf019ecb67$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cd2436cf019ecb67$var$_getPrototypeOf(o);
}
function $cd2436cf019ecb67$var$_setPrototypeOf(o, p) {
    $cd2436cf019ecb67$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cd2436cf019ecb67$var$_setPrototypeOf(o, p);
}
function $cd2436cf019ecb67$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cd2436cf019ecb67$var$_construct(Parent, args, Class) {
    if ($cd2436cf019ecb67$var$_isNativeReflectConstruct()) $cd2436cf019ecb67$var$_construct = Reflect.construct.bind();
    else $cd2436cf019ecb67$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $cd2436cf019ecb67$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $cd2436cf019ecb67$var$_construct.apply(null, arguments);
}
function $cd2436cf019ecb67$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $cd2436cf019ecb67$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $cd2436cf019ecb67$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$cd2436cf019ecb67$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $cd2436cf019ecb67$var$_construct(Class, arguments, $cd2436cf019ecb67$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $cd2436cf019ecb67$var$_setPrototypeOf(Wrapper, Class);
    };
    return $cd2436cf019ecb67$var$_wrapNativeSuper(Class);
}
function $cd2436cf019ecb67$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cd2436cf019ecb67$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cd2436cf019ecb67$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cd2436cf019ecb67$var$_arrayLikeToArray(o, minLen);
}
function $cd2436cf019ecb67$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cd2436cf019ecb67$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $cd2436cf019ecb67$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cd2436cf019ecb67$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cd2436cf019ecb67$var$_toPropertyKey(arg) {
    var key = $cd2436cf019ecb67$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $cd2436cf019ecb67$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $cd2436cf019ecb67$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $cd2436cf019ecb67$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $cd2436cf019ecb67$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $cd2436cf019ecb67$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($cd2436cf019ecb67$var$LuxonError);
/**
 * @private
 */ var $cd2436cf019ecb67$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $cd2436cf019ecb67$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($cd2436cf019ecb67$var$LuxonError);
/**
 * @private
 */ var $cd2436cf019ecb67$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $cd2436cf019ecb67$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($cd2436cf019ecb67$var$LuxonError);
/**
 * @private
 */ var $cd2436cf019ecb67$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $cd2436cf019ecb67$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($cd2436cf019ecb67$var$LuxonError);
/**
 * @private
 */ var $cd2436cf019ecb67$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $cd2436cf019ecb67$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($cd2436cf019ecb67$var$LuxonError);
/**
 * @private
 */ var $cd2436cf019ecb67$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $cd2436cf019ecb67$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($cd2436cf019ecb67$var$LuxonError);
/**
 * @private
 */ var $cd2436cf019ecb67$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $cd2436cf019ecb67$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($cd2436cf019ecb67$var$LuxonError);
/**
 * @private
 */ var $cd2436cf019ecb67$var$n = "numeric", $cd2436cf019ecb67$var$s = "short", $cd2436cf019ecb67$var$l = "long";
var $cd2436cf019ecb67$var$DATE_SHORT = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$n,
    day: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATE_MED = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$s,
    day: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATE_MED_WITH_WEEKDAY = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$s,
    day: $cd2436cf019ecb67$var$n,
    weekday: $cd2436cf019ecb67$var$s
};
var $cd2436cf019ecb67$var$DATE_FULL = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$l,
    day: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATE_HUGE = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$l,
    day: $cd2436cf019ecb67$var$n,
    weekday: $cd2436cf019ecb67$var$l
};
var $cd2436cf019ecb67$var$TIME_SIMPLE = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$TIME_WITH_SECONDS = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$TIME_WITH_SHORT_OFFSET = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n,
    timeZoneName: $cd2436cf019ecb67$var$s
};
var $cd2436cf019ecb67$var$TIME_WITH_LONG_OFFSET = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n,
    timeZoneName: $cd2436cf019ecb67$var$l
};
var $cd2436cf019ecb67$var$TIME_24_SIMPLE = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    hourCycle: "h23"
};
var $cd2436cf019ecb67$var$TIME_24_WITH_SECONDS = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n,
    hourCycle: "h23"
};
var $cd2436cf019ecb67$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n,
    hourCycle: "h23",
    timeZoneName: $cd2436cf019ecb67$var$s
};
var $cd2436cf019ecb67$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n,
    hourCycle: "h23",
    timeZoneName: $cd2436cf019ecb67$var$l
};
var $cd2436cf019ecb67$var$DATETIME_SHORT = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$n,
    day: $cd2436cf019ecb67$var$n,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$n,
    day: $cd2436cf019ecb67$var$n,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATETIME_MED = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$s,
    day: $cd2436cf019ecb67$var$n,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATETIME_MED_WITH_SECONDS = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$s,
    day: $cd2436cf019ecb67$var$n,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$s,
    day: $cd2436cf019ecb67$var$n,
    weekday: $cd2436cf019ecb67$var$s,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n
};
var $cd2436cf019ecb67$var$DATETIME_FULL = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$l,
    day: $cd2436cf019ecb67$var$n,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    timeZoneName: $cd2436cf019ecb67$var$s
};
var $cd2436cf019ecb67$var$DATETIME_FULL_WITH_SECONDS = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$l,
    day: $cd2436cf019ecb67$var$n,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n,
    timeZoneName: $cd2436cf019ecb67$var$s
};
var $cd2436cf019ecb67$var$DATETIME_HUGE = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$l,
    day: $cd2436cf019ecb67$var$n,
    weekday: $cd2436cf019ecb67$var$l,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    timeZoneName: $cd2436cf019ecb67$var$l
};
var $cd2436cf019ecb67$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $cd2436cf019ecb67$var$n,
    month: $cd2436cf019ecb67$var$l,
    day: $cd2436cf019ecb67$var$n,
    weekday: $cd2436cf019ecb67$var$l,
    hour: $cd2436cf019ecb67$var$n,
    minute: $cd2436cf019ecb67$var$n,
    second: $cd2436cf019ecb67$var$n,
    timeZoneName: $cd2436cf019ecb67$var$l
};
/**
 * @interface
 */ var $cd2436cf019ecb67$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $cd2436cf019ecb67$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $cd2436cf019ecb67$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $cd2436cf019ecb67$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $cd2436cf019ecb67$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $cd2436cf019ecb67$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $cd2436cf019ecb67$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $cd2436cf019ecb67$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $cd2436cf019ecb67$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($cd2436cf019ecb67$var$singleton$1 === null) $cd2436cf019ecb67$var$singleton$1 = new SystemZone();
                return $cd2436cf019ecb67$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($cd2436cf019ecb67$var$Zone);
var $cd2436cf019ecb67$var$dtfCache = {};
function $cd2436cf019ecb67$var$makeDTF(zone) {
    if (!$cd2436cf019ecb67$var$dtfCache[zone]) $cd2436cf019ecb67$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $cd2436cf019ecb67$var$dtfCache[zone];
}
var $cd2436cf019ecb67$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $cd2436cf019ecb67$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $cd2436cf019ecb67$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $cd2436cf019ecb67$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$cd2436cf019ecb67$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $cd2436cf019ecb67$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $cd2436cf019ecb67$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $cd2436cf019ecb67$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$cd2436cf019ecb67$var$ianaZoneCache[name]) $cd2436cf019ecb67$var$ianaZoneCache[name] = new IANAZone(name);
        return $cd2436cf019ecb67$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $cd2436cf019ecb67$var$ianaZoneCache = {};
        $cd2436cf019ecb67$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $cd2436cf019ecb67$var$parseZoneInfo(ts, format, locale, this.name);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $cd2436cf019ecb67$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $cd2436cf019ecb67$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $cd2436cf019ecb67$var$partsOffset(dtf, date) : $cd2436cf019ecb67$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $cd2436cf019ecb67$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /** @override **/ ;
    $cd2436cf019ecb67$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($cd2436cf019ecb67$var$Zone);
var $cd2436cf019ecb67$var$_excluded = [
    "base"
], $cd2436cf019ecb67$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $cd2436cf019ecb67$var$intlLFCache = {};
function $cd2436cf019ecb67$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $cd2436cf019ecb67$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $cd2436cf019ecb67$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $cd2436cf019ecb67$var$intlDTCache = {};
function $cd2436cf019ecb67$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $cd2436cf019ecb67$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $cd2436cf019ecb67$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $cd2436cf019ecb67$var$intlNumCache = {};
function $cd2436cf019ecb67$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $cd2436cf019ecb67$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $cd2436cf019ecb67$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $cd2436cf019ecb67$var$intlRelCache = {};
function $cd2436cf019ecb67$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $cd2436cf019ecb67$var$_objectWithoutPropertiesLoose(_opts, $cd2436cf019ecb67$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $cd2436cf019ecb67$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $cd2436cf019ecb67$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $cd2436cf019ecb67$var$sysLocaleCache = null;
function $cd2436cf019ecb67$var$systemLocale() {
    if ($cd2436cf019ecb67$var$sysLocaleCache) return $cd2436cf019ecb67$var$sysLocaleCache;
    else {
        $cd2436cf019ecb67$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $cd2436cf019ecb67$var$sysLocaleCache;
    }
}
var $cd2436cf019ecb67$var$weekInfoCache = {};
function $cd2436cf019ecb67$var$getCachedWeekInfo(locString) {
    var data = $cd2436cf019ecb67$var$weekInfoCache[locString];
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        $cd2436cf019ecb67$var$weekInfoCache[locString] = data;
    }
    return data;
}
function $cd2436cf019ecb67$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $cd2436cf019ecb67$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $cd2436cf019ecb67$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $cd2436cf019ecb67$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $cd2436cf019ecb67$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $cd2436cf019ecb67$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $cd2436cf019ecb67$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $cd2436cf019ecb67$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $cd2436cf019ecb67$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $cd2436cf019ecb67$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $cd2436cf019ecb67$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $cd2436cf019ecb67$var$_objectWithoutPropertiesLoose(opts, $cd2436cf019ecb67$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $cd2436cf019ecb67$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $cd2436cf019ecb67$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $cd2436cf019ecb67$var$roundTo(i, 3);
            return $cd2436cf019ecb67$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $cd2436cf019ecb67$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $cd2436cf019ecb67$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $cd2436cf019ecb67$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $cd2436cf019ecb67$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $cd2436cf019ecb67$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $cd2436cf019ecb67$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $cd2436cf019ecb67$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $cd2436cf019ecb67$var$hasRelative()) this.rtf = $cd2436cf019ecb67$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $cd2436cf019ecb67$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $cd2436cf019ecb67$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $cd2436cf019ecb67$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $cd2436cf019ecb67$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $cd2436cf019ecb67$var$systemLocale());
        var numberingSystemR = numberingSystem || $cd2436cf019ecb67$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $cd2436cf019ecb67$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $cd2436cf019ecb67$var$validateWeekSettings(weekSettings) || $cd2436cf019ecb67$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $cd2436cf019ecb67$var$sysLocaleCache = null;
        $cd2436cf019ecb67$var$intlDTCache = {};
        $cd2436cf019ecb67$var$intlNumCache = {};
        $cd2436cf019ecb67$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $cd2436cf019ecb67$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $cd2436cf019ecb67$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $cd2436cf019ecb67$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($cd2436cf019ecb67$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($cd2436cf019ecb67$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $cd2436cf019ecb67$var$listStuff(this, length, $cd2436cf019ecb67$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $cd2436cf019ecb67$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $cd2436cf019ecb67$var$listStuff(this, length, $cd2436cf019ecb67$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $cd2436cf019ecb67$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $cd2436cf019ecb67$var$listStuff(this, undefined, function() {
            return $cd2436cf019ecb67$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $cd2436cf019ecb67$var$DateTime.utc(2016, 11, 13, 9),
                    $cd2436cf019ecb67$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $cd2436cf019ecb67$var$listStuff(this, length, $cd2436cf019ecb67$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $cd2436cf019ecb67$var$DateTime.utc(-40, 1, 1),
                $cd2436cf019ecb67$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $cd2436cf019ecb67$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $cd2436cf019ecb67$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $cd2436cf019ecb67$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $cd2436cf019ecb67$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$cd2436cf019ecb67$var$hasLocaleWeekInfo()) return $cd2436cf019ecb67$var$fallbackWeekSettings;
        else return $cd2436cf019ecb67$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $cd2436cf019ecb67$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $cd2436cf019ecb67$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $cd2436cf019ecb67$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $cd2436cf019ecb67$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $cd2436cf019ecb67$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($cd2436cf019ecb67$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $cd2436cf019ecb67$var$formatOffset(this.fixed, format);
    } /** @override **/ ;
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /** @override **/ ;
    $cd2436cf019ecb67$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $cd2436cf019ecb67$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $cd2436cf019ecb67$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($cd2436cf019ecb67$var$singleton === null) $cd2436cf019ecb67$var$singleton = new FixedOffsetZone(0);
                return $cd2436cf019ecb67$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($cd2436cf019ecb67$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $cd2436cf019ecb67$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $cd2436cf019ecb67$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $cd2436cf019ecb67$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($cd2436cf019ecb67$var$Zone);
/**
 * @private
 */ function $cd2436cf019ecb67$var$normalizeZone(input, defaultZone) {
    if ($cd2436cf019ecb67$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $cd2436cf019ecb67$var$Zone) return input;
    else if ($cd2436cf019ecb67$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $cd2436cf019ecb67$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $cd2436cf019ecb67$var$FixedOffsetZone.utcInstance;
        else return $cd2436cf019ecb67$var$FixedOffsetZone.parseSpecifier(lowered) || $cd2436cf019ecb67$var$IANAZone.create(input);
    } else if ($cd2436cf019ecb67$var$isNumber(input)) return $cd2436cf019ecb67$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $cd2436cf019ecb67$var$InvalidZone(input);
}
var $cd2436cf019ecb67$var$now = function now() {
    return Date.now();
}, $cd2436cf019ecb67$var$defaultZone = "system", $cd2436cf019ecb67$var$defaultLocale = null, $cd2436cf019ecb67$var$defaultNumberingSystem = null, $cd2436cf019ecb67$var$defaultOutputCalendar = null, $cd2436cf019ecb67$var$twoDigitCutoffYear = 60, $cd2436cf019ecb67$var$throwOnInvalid, $cd2436cf019ecb67$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $cd2436cf019ecb67$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $cd2436cf019ecb67$var$Locale.resetCache();
        $cd2436cf019ecb67$var$IANAZone.resetCache();
    };
    $cd2436cf019ecb67$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $cd2436cf019ecb67$var$now;
            },
            set: function set(n) {
                $cd2436cf019ecb67$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $cd2436cf019ecb67$var$normalizeZone($cd2436cf019ecb67$var$defaultZone, $cd2436cf019ecb67$var$SystemZone.instance);
            },
            set: function set(zone) {
                $cd2436cf019ecb67$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $cd2436cf019ecb67$var$defaultLocale;
            },
            set: function set(locale) {
                $cd2436cf019ecb67$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $cd2436cf019ecb67$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $cd2436cf019ecb67$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $cd2436cf019ecb67$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $cd2436cf019ecb67$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $cd2436cf019ecb67$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $cd2436cf019ecb67$var$defaultWeekSettings = $cd2436cf019ecb67$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $cd2436cf019ecb67$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $cd2436cf019ecb67$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $cd2436cf019ecb67$var$throwOnInvalid;
            },
            set: function set(t) {
                $cd2436cf019ecb67$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $cd2436cf019ecb67$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $cd2436cf019ecb67$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $cd2436cf019ecb67$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $cd2436cf019ecb67$var$unitOutOfRange(unit, value) {
    return new $cd2436cf019ecb67$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $cd2436cf019ecb67$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $cd2436cf019ecb67$var$computeOrdinal(year, month, day) {
    return day + ($cd2436cf019ecb67$var$isLeapYear(year) ? $cd2436cf019ecb67$var$leapLadder : $cd2436cf019ecb67$var$nonLeapLadder)[month - 1];
}
function $cd2436cf019ecb67$var$uncomputeOrdinal(year, ordinal) {
    var table = $cd2436cf019ecb67$var$isLeapYear(year) ? $cd2436cf019ecb67$var$leapLadder : $cd2436cf019ecb67$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $cd2436cf019ecb67$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $cd2436cf019ecb67$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $cd2436cf019ecb67$var$computeOrdinal(year, month, day), weekday = $cd2436cf019ecb67$var$isoWeekdayToLocal($cd2436cf019ecb67$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $cd2436cf019ecb67$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $cd2436cf019ecb67$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $cd2436cf019ecb67$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $cd2436cf019ecb67$var$timeObject(gregObj));
}
function $cd2436cf019ecb67$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $cd2436cf019ecb67$var$isoWeekdayToLocal($cd2436cf019ecb67$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $cd2436cf019ecb67$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $cd2436cf019ecb67$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $cd2436cf019ecb67$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $cd2436cf019ecb67$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $cd2436cf019ecb67$var$_extends({
        year: year,
        month: month,
        day: day
    }, $cd2436cf019ecb67$var$timeObject(weekData));
}
function $cd2436cf019ecb67$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $cd2436cf019ecb67$var$computeOrdinal(year, month, day);
    return $cd2436cf019ecb67$var$_extends({
        year: year,
        ordinal: ordinal
    }, $cd2436cf019ecb67$var$timeObject(gregData));
}
function $cd2436cf019ecb67$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $cd2436cf019ecb67$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $cd2436cf019ecb67$var$_extends({
        year: year,
        month: month,
        day: day
    }, $cd2436cf019ecb67$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $cd2436cf019ecb67$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$cd2436cf019ecb67$var$isUndefined(obj.localWeekday) || !$cd2436cf019ecb67$var$isUndefined(obj.localWeekNumber) || !$cd2436cf019ecb67$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$cd2436cf019ecb67$var$isUndefined(obj.weekday) || !$cd2436cf019ecb67$var$isUndefined(obj.weekNumber) || !$cd2436cf019ecb67$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $cd2436cf019ecb67$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$cd2436cf019ecb67$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$cd2436cf019ecb67$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$cd2436cf019ecb67$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $cd2436cf019ecb67$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $cd2436cf019ecb67$var$isInteger(obj.weekYear), validWeek = $cd2436cf019ecb67$var$integerBetween(obj.weekNumber, 1, $cd2436cf019ecb67$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $cd2436cf019ecb67$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $cd2436cf019ecb67$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $cd2436cf019ecb67$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $cd2436cf019ecb67$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $cd2436cf019ecb67$var$hasInvalidOrdinalData(obj) {
    var validYear = $cd2436cf019ecb67$var$isInteger(obj.year), validOrdinal = $cd2436cf019ecb67$var$integerBetween(obj.ordinal, 1, $cd2436cf019ecb67$var$daysInYear(obj.year));
    if (!validYear) return $cd2436cf019ecb67$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $cd2436cf019ecb67$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $cd2436cf019ecb67$var$hasInvalidGregorianData(obj) {
    var validYear = $cd2436cf019ecb67$var$isInteger(obj.year), validMonth = $cd2436cf019ecb67$var$integerBetween(obj.month, 1, 12), validDay = $cd2436cf019ecb67$var$integerBetween(obj.day, 1, $cd2436cf019ecb67$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $cd2436cf019ecb67$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $cd2436cf019ecb67$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $cd2436cf019ecb67$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $cd2436cf019ecb67$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $cd2436cf019ecb67$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $cd2436cf019ecb67$var$integerBetween(minute, 0, 59), validSecond = $cd2436cf019ecb67$var$integerBetween(second, 0, 59), validMillisecond = $cd2436cf019ecb67$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $cd2436cf019ecb67$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $cd2436cf019ecb67$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $cd2436cf019ecb67$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $cd2436cf019ecb67$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $cd2436cf019ecb67$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $cd2436cf019ecb67$var$isNumber(o) {
    return typeof o === "number";
}
function $cd2436cf019ecb67$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $cd2436cf019ecb67$var$isString(o) {
    return typeof o === "string";
}
function $cd2436cf019ecb67$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $cd2436cf019ecb67$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $cd2436cf019ecb67$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $cd2436cf019ecb67$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $cd2436cf019ecb67$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $cd2436cf019ecb67$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $cd2436cf019ecb67$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $cd2436cf019ecb67$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $cd2436cf019ecb67$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$cd2436cf019ecb67$var$integerBetween(settings.firstDay, 1, 7) || !$cd2436cf019ecb67$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$cd2436cf019ecb67$var$integerBetween(v, 1, 7);
        })) throw new $cd2436cf019ecb67$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $cd2436cf019ecb67$var$integerBetween(thing, bottom, top) {
    return $cd2436cf019ecb67$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $cd2436cf019ecb67$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $cd2436cf019ecb67$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $cd2436cf019ecb67$var$parseInteger(string) {
    if ($cd2436cf019ecb67$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $cd2436cf019ecb67$var$parseFloating(string) {
    if ($cd2436cf019ecb67$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $cd2436cf019ecb67$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($cd2436cf019ecb67$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $cd2436cf019ecb67$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $cd2436cf019ecb67$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $cd2436cf019ecb67$var$daysInYear(year) {
    return $cd2436cf019ecb67$var$isLeapYear(year) ? 366 : 365;
}
function $cd2436cf019ecb67$var$daysInMonth(year, month) {
    var modMonth = $cd2436cf019ecb67$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $cd2436cf019ecb67$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $cd2436cf019ecb67$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $cd2436cf019ecb67$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $cd2436cf019ecb67$var$isoWeekdayToLocal($cd2436cf019ecb67$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $cd2436cf019ecb67$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $cd2436cf019ecb67$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $cd2436cf019ecb67$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($cd2436cf019ecb67$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $cd2436cf019ecb67$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $cd2436cf019ecb67$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $cd2436cf019ecb67$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $cd2436cf019ecb67$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $cd2436cf019ecb67$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $cd2436cf019ecb67$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $cd2436cf019ecb67$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $cd2436cf019ecb67$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($cd2436cf019ecb67$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $cd2436cf019ecb67$var$asNumber(v);
    }
    return normalized;
}
function $cd2436cf019ecb67$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $cd2436cf019ecb67$var$padStart(hours, 2) + ":" + $cd2436cf019ecb67$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $cd2436cf019ecb67$var$padStart(hours, 2) + $cd2436cf019ecb67$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $cd2436cf019ecb67$var$timeObject(obj) {
    return $cd2436cf019ecb67$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $cd2436cf019ecb67$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $cd2436cf019ecb67$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $cd2436cf019ecb67$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $cd2436cf019ecb67$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($cd2436cf019ecb67$var$monthsNarrow);
        case "short":
            return [].concat($cd2436cf019ecb67$var$monthsShort);
        case "long":
            return [].concat($cd2436cf019ecb67$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $cd2436cf019ecb67$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $cd2436cf019ecb67$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $cd2436cf019ecb67$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $cd2436cf019ecb67$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($cd2436cf019ecb67$var$weekdaysNarrow);
        case "short":
            return [].concat($cd2436cf019ecb67$var$weekdaysShort);
        case "long":
            return [].concat($cd2436cf019ecb67$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $cd2436cf019ecb67$var$meridiems = [
    "AM",
    "PM"
];
var $cd2436cf019ecb67$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $cd2436cf019ecb67$var$erasShort = [
    "BC",
    "AD"
];
var $cd2436cf019ecb67$var$erasNarrow = [
    "B",
    "A"
];
function $cd2436cf019ecb67$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($cd2436cf019ecb67$var$erasNarrow);
        case "short":
            return [].concat($cd2436cf019ecb67$var$erasShort);
        case "long":
            return [].concat($cd2436cf019ecb67$var$erasLong);
        default:
            return null;
    }
}
function $cd2436cf019ecb67$var$meridiemForDateTime(dt) {
    return $cd2436cf019ecb67$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $cd2436cf019ecb67$var$weekdayForDateTime(dt, length) {
    return $cd2436cf019ecb67$var$weekdays(length)[dt.weekday - 1];
}
function $cd2436cf019ecb67$var$monthForDateTime(dt, length) {
    return $cd2436cf019ecb67$var$months(length)[dt.month - 1];
}
function $cd2436cf019ecb67$var$eraForDateTime(dt, length) {
    return $cd2436cf019ecb67$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $cd2436cf019ecb67$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $cd2436cf019ecb67$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $cd2436cf019ecb67$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $cd2436cf019ecb67$var$_macroTokenToFormatOpts = {
    D: $cd2436cf019ecb67$var$DATE_SHORT,
    DD: $cd2436cf019ecb67$var$DATE_MED,
    DDD: $cd2436cf019ecb67$var$DATE_FULL,
    DDDD: $cd2436cf019ecb67$var$DATE_HUGE,
    t: $cd2436cf019ecb67$var$TIME_SIMPLE,
    tt: $cd2436cf019ecb67$var$TIME_WITH_SECONDS,
    ttt: $cd2436cf019ecb67$var$TIME_WITH_SHORT_OFFSET,
    tttt: $cd2436cf019ecb67$var$TIME_WITH_LONG_OFFSET,
    T: $cd2436cf019ecb67$var$TIME_24_SIMPLE,
    TT: $cd2436cf019ecb67$var$TIME_24_WITH_SECONDS,
    TTT: $cd2436cf019ecb67$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $cd2436cf019ecb67$var$TIME_24_WITH_LONG_OFFSET,
    f: $cd2436cf019ecb67$var$DATETIME_SHORT,
    ff: $cd2436cf019ecb67$var$DATETIME_MED,
    fff: $cd2436cf019ecb67$var$DATETIME_FULL,
    ffff: $cd2436cf019ecb67$var$DATETIME_HUGE,
    F: $cd2436cf019ecb67$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $cd2436cf019ecb67$var$DATETIME_MED_WITH_SECONDS,
    FFF: $cd2436cf019ecb67$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $cd2436cf019ecb67$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $cd2436cf019ecb67$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $cd2436cf019ecb67$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $cd2436cf019ecb67$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $cd2436cf019ecb67$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $cd2436cf019ecb67$var$padStart(n, p);
        var opts = $cd2436cf019ecb67$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $cd2436cf019ecb67$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $cd2436cf019ecb67$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $cd2436cf019ecb67$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $cd2436cf019ecb67$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $cd2436cf019ecb67$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $cd2436cf019ecb67$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $cd2436cf019ecb67$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $cd2436cf019ecb67$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $cd2436cf019ecb67$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $cd2436cf019ecb67$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $cd2436cf019ecb67$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $cd2436cf019ecb67$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $cd2436cf019ecb67$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $cd2436cf019ecb67$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $cd2436cf019ecb67$var$isoExtendedZone = "(?:" + $cd2436cf019ecb67$var$offsetRegex.source + "?(?:\\[(" + $cd2436cf019ecb67$var$ianaRegex.source + ")\\])?)?";
var $cd2436cf019ecb67$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $cd2436cf019ecb67$var$isoTimeRegex = RegExp("" + $cd2436cf019ecb67$var$isoTimeBaseRegex.source + $cd2436cf019ecb67$var$isoExtendedZone);
var $cd2436cf019ecb67$var$isoTimeExtensionRegex = RegExp("(?:T" + $cd2436cf019ecb67$var$isoTimeRegex.source + ")?");
var $cd2436cf019ecb67$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $cd2436cf019ecb67$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $cd2436cf019ecb67$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $cd2436cf019ecb67$var$extractISOWeekData = $cd2436cf019ecb67$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $cd2436cf019ecb67$var$extractISOOrdinalData = $cd2436cf019ecb67$var$simpleParse("year", "ordinal");
var $cd2436cf019ecb67$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $cd2436cf019ecb67$var$sqlTimeRegex = RegExp($cd2436cf019ecb67$var$isoTimeBaseRegex.source + " ?(?:" + $cd2436cf019ecb67$var$offsetRegex.source + "|(" + $cd2436cf019ecb67$var$ianaRegex.source + "))?");
var $cd2436cf019ecb67$var$sqlTimeExtensionRegex = RegExp("(?: " + $cd2436cf019ecb67$var$sqlTimeRegex.source + ")?");
function $cd2436cf019ecb67$var$int(match, pos, fallback) {
    var m = match[pos];
    return $cd2436cf019ecb67$var$isUndefined(m) ? fallback : $cd2436cf019ecb67$var$parseInteger(m);
}
function $cd2436cf019ecb67$var$extractISOYmd(match, cursor) {
    var item = {
        year: $cd2436cf019ecb67$var$int(match, cursor),
        month: $cd2436cf019ecb67$var$int(match, cursor + 1, 1),
        day: $cd2436cf019ecb67$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $cd2436cf019ecb67$var$extractISOTime(match, cursor) {
    var item = {
        hours: $cd2436cf019ecb67$var$int(match, cursor, 0),
        minutes: $cd2436cf019ecb67$var$int(match, cursor + 1, 0),
        seconds: $cd2436cf019ecb67$var$int(match, cursor + 2, 0),
        milliseconds: $cd2436cf019ecb67$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $cd2436cf019ecb67$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $cd2436cf019ecb67$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $cd2436cf019ecb67$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $cd2436cf019ecb67$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $cd2436cf019ecb67$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $cd2436cf019ecb67$var$isoTimeOnly = RegExp("^T?" + $cd2436cf019ecb67$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $cd2436cf019ecb67$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $cd2436cf019ecb67$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($cd2436cf019ecb67$var$parseFloating(yearStr)),
            months: maybeNegate($cd2436cf019ecb67$var$parseFloating(monthStr)),
            weeks: maybeNegate($cd2436cf019ecb67$var$parseFloating(weekStr)),
            days: maybeNegate($cd2436cf019ecb67$var$parseFloating(dayStr)),
            hours: maybeNegate($cd2436cf019ecb67$var$parseFloating(hourStr)),
            minutes: maybeNegate($cd2436cf019ecb67$var$parseFloating(minuteStr)),
            seconds: maybeNegate($cd2436cf019ecb67$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($cd2436cf019ecb67$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $cd2436cf019ecb67$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $cd2436cf019ecb67$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $cd2436cf019ecb67$var$untruncateYear($cd2436cf019ecb67$var$parseInteger(yearStr)) : $cd2436cf019ecb67$var$parseInteger(yearStr),
        month: $cd2436cf019ecb67$var$monthsShort.indexOf(monthStr) + 1,
        day: $cd2436cf019ecb67$var$parseInteger(dayStr),
        hour: $cd2436cf019ecb67$var$parseInteger(hourStr),
        minute: $cd2436cf019ecb67$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $cd2436cf019ecb67$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $cd2436cf019ecb67$var$weekdaysLong.indexOf(weekdayStr) + 1 : $cd2436cf019ecb67$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $cd2436cf019ecb67$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $cd2436cf019ecb67$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $cd2436cf019ecb67$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $cd2436cf019ecb67$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $cd2436cf019ecb67$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $cd2436cf019ecb67$var$FixedOffsetZone(offset)
    ];
}
function $cd2436cf019ecb67$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $cd2436cf019ecb67$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $cd2436cf019ecb67$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $cd2436cf019ecb67$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $cd2436cf019ecb67$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $cd2436cf019ecb67$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $cd2436cf019ecb67$var$FixedOffsetZone.utcInstance
    ];
}
function $cd2436cf019ecb67$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $cd2436cf019ecb67$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $cd2436cf019ecb67$var$FixedOffsetZone.utcInstance
    ];
}
var $cd2436cf019ecb67$var$isoYmdWithTimeExtensionRegex = $cd2436cf019ecb67$var$combineRegexes($cd2436cf019ecb67$var$isoYmdRegex, $cd2436cf019ecb67$var$isoTimeExtensionRegex);
var $cd2436cf019ecb67$var$isoWeekWithTimeExtensionRegex = $cd2436cf019ecb67$var$combineRegexes($cd2436cf019ecb67$var$isoWeekRegex, $cd2436cf019ecb67$var$isoTimeExtensionRegex);
var $cd2436cf019ecb67$var$isoOrdinalWithTimeExtensionRegex = $cd2436cf019ecb67$var$combineRegexes($cd2436cf019ecb67$var$isoOrdinalRegex, $cd2436cf019ecb67$var$isoTimeExtensionRegex);
var $cd2436cf019ecb67$var$isoTimeCombinedRegex = $cd2436cf019ecb67$var$combineRegexes($cd2436cf019ecb67$var$isoTimeRegex);
var $cd2436cf019ecb67$var$extractISOYmdTimeAndOffset = $cd2436cf019ecb67$var$combineExtractors($cd2436cf019ecb67$var$extractISOYmd, $cd2436cf019ecb67$var$extractISOTime, $cd2436cf019ecb67$var$extractISOOffset, $cd2436cf019ecb67$var$extractIANAZone);
var $cd2436cf019ecb67$var$extractISOWeekTimeAndOffset = $cd2436cf019ecb67$var$combineExtractors($cd2436cf019ecb67$var$extractISOWeekData, $cd2436cf019ecb67$var$extractISOTime, $cd2436cf019ecb67$var$extractISOOffset, $cd2436cf019ecb67$var$extractIANAZone);
var $cd2436cf019ecb67$var$extractISOOrdinalDateAndTime = $cd2436cf019ecb67$var$combineExtractors($cd2436cf019ecb67$var$extractISOOrdinalData, $cd2436cf019ecb67$var$extractISOTime, $cd2436cf019ecb67$var$extractISOOffset, $cd2436cf019ecb67$var$extractIANAZone);
var $cd2436cf019ecb67$var$extractISOTimeAndOffset = $cd2436cf019ecb67$var$combineExtractors($cd2436cf019ecb67$var$extractISOTime, $cd2436cf019ecb67$var$extractISOOffset, $cd2436cf019ecb67$var$extractIANAZone);
/*
 * @private
 */ function $cd2436cf019ecb67$var$parseISODate(s) {
    return $cd2436cf019ecb67$var$parse(s, [
        $cd2436cf019ecb67$var$isoYmdWithTimeExtensionRegex,
        $cd2436cf019ecb67$var$extractISOYmdTimeAndOffset
    ], [
        $cd2436cf019ecb67$var$isoWeekWithTimeExtensionRegex,
        $cd2436cf019ecb67$var$extractISOWeekTimeAndOffset
    ], [
        $cd2436cf019ecb67$var$isoOrdinalWithTimeExtensionRegex,
        $cd2436cf019ecb67$var$extractISOOrdinalDateAndTime
    ], [
        $cd2436cf019ecb67$var$isoTimeCombinedRegex,
        $cd2436cf019ecb67$var$extractISOTimeAndOffset
    ]);
}
function $cd2436cf019ecb67$var$parseRFC2822Date(s) {
    return $cd2436cf019ecb67$var$parse($cd2436cf019ecb67$var$preprocessRFC2822(s), [
        $cd2436cf019ecb67$var$rfc2822,
        $cd2436cf019ecb67$var$extractRFC2822
    ]);
}
function $cd2436cf019ecb67$var$parseHTTPDate(s) {
    return $cd2436cf019ecb67$var$parse(s, [
        $cd2436cf019ecb67$var$rfc1123,
        $cd2436cf019ecb67$var$extractRFC1123Or850
    ], [
        $cd2436cf019ecb67$var$rfc850,
        $cd2436cf019ecb67$var$extractRFC1123Or850
    ], [
        $cd2436cf019ecb67$var$ascii,
        $cd2436cf019ecb67$var$extractASCII
    ]);
}
function $cd2436cf019ecb67$var$parseISODuration(s) {
    return $cd2436cf019ecb67$var$parse(s, [
        $cd2436cf019ecb67$var$isoDuration,
        $cd2436cf019ecb67$var$extractISODuration
    ]);
}
var $cd2436cf019ecb67$var$extractISOTimeOnly = $cd2436cf019ecb67$var$combineExtractors($cd2436cf019ecb67$var$extractISOTime);
function $cd2436cf019ecb67$var$parseISOTimeOnly(s) {
    return $cd2436cf019ecb67$var$parse(s, [
        $cd2436cf019ecb67$var$isoTimeOnly,
        $cd2436cf019ecb67$var$extractISOTimeOnly
    ]);
}
var $cd2436cf019ecb67$var$sqlYmdWithTimeExtensionRegex = $cd2436cf019ecb67$var$combineRegexes($cd2436cf019ecb67$var$sqlYmdRegex, $cd2436cf019ecb67$var$sqlTimeExtensionRegex);
var $cd2436cf019ecb67$var$sqlTimeCombinedRegex = $cd2436cf019ecb67$var$combineRegexes($cd2436cf019ecb67$var$sqlTimeRegex);
var $cd2436cf019ecb67$var$extractISOTimeOffsetAndIANAZone = $cd2436cf019ecb67$var$combineExtractors($cd2436cf019ecb67$var$extractISOTime, $cd2436cf019ecb67$var$extractISOOffset, $cd2436cf019ecb67$var$extractIANAZone);
function $cd2436cf019ecb67$var$parseSQL(s) {
    return $cd2436cf019ecb67$var$parse(s, [
        $cd2436cf019ecb67$var$sqlYmdWithTimeExtensionRegex,
        $cd2436cf019ecb67$var$extractISOYmdTimeAndOffset
    ], [
        $cd2436cf019ecb67$var$sqlTimeCombinedRegex,
        $cd2436cf019ecb67$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $cd2436cf019ecb67$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $cd2436cf019ecb67$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $cd2436cf019ecb67$var$casualMatrix = $cd2436cf019ecb67$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $cd2436cf019ecb67$var$lowOrderMatrix), $cd2436cf019ecb67$var$daysInYearAccurate = 365.2425, $cd2436cf019ecb67$var$daysInMonthAccurate = 30.436875, $cd2436cf019ecb67$var$accurateMatrix = $cd2436cf019ecb67$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $cd2436cf019ecb67$var$daysInYearAccurate / 7,
        days: $cd2436cf019ecb67$var$daysInYearAccurate,
        hours: $cd2436cf019ecb67$var$daysInYearAccurate * 24,
        minutes: $cd2436cf019ecb67$var$daysInYearAccurate * 1440,
        seconds: $cd2436cf019ecb67$var$daysInYearAccurate * 86400,
        milliseconds: $cd2436cf019ecb67$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $cd2436cf019ecb67$var$daysInYearAccurate / 28,
        days: $cd2436cf019ecb67$var$daysInYearAccurate / 4,
        hours: $cd2436cf019ecb67$var$daysInYearAccurate * 24 / 4,
        minutes: $cd2436cf019ecb67$var$daysInYearAccurate * 1440 / 4,
        seconds: $cd2436cf019ecb67$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $cd2436cf019ecb67$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $cd2436cf019ecb67$var$daysInMonthAccurate / 7,
        days: $cd2436cf019ecb67$var$daysInMonthAccurate,
        hours: $cd2436cf019ecb67$var$daysInMonthAccurate * 24,
        minutes: $cd2436cf019ecb67$var$daysInMonthAccurate * 1440,
        seconds: $cd2436cf019ecb67$var$daysInMonthAccurate * 86400,
        milliseconds: $cd2436cf019ecb67$var$daysInMonthAccurate * 86400000
    }
}, $cd2436cf019ecb67$var$lowOrderMatrix);
// units ordered by size
var $cd2436cf019ecb67$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $cd2436cf019ecb67$var$reverseUnits = $cd2436cf019ecb67$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $cd2436cf019ecb67$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $cd2436cf019ecb67$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $cd2436cf019ecb67$var$Duration(conf);
}
function $cd2436cf019ecb67$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $cd2436cf019ecb67$var$_createForOfIteratorHelperLoose($cd2436cf019ecb67$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $cd2436cf019ecb67$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $cd2436cf019ecb67$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $cd2436cf019ecb67$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$cd2436cf019ecb67$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $cd2436cf019ecb67$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$cd2436cf019ecb67$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $cd2436cf019ecb67$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $cd2436cf019ecb67$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $cd2436cf019ecb67$var$accurateMatrix : $cd2436cf019ecb67$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $cd2436cf019ecb67$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $cd2436cf019ecb67$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $cd2436cf019ecb67$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $cd2436cf019ecb67$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($cd2436cf019ecb67$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $cd2436cf019ecb67$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $cd2436cf019ecb67$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $cd2436cf019ecb67$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $cd2436cf019ecb67$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $cd2436cf019ecb67$var$Invalid ? reason : new $cd2436cf019ecb67$var$Invalid(reason, explanation);
        if ($cd2436cf019ecb67$var$Settings.throwOnInvalid) throw new $cd2436cf019ecb67$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $cd2436cf019ecb67$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $cd2436cf019ecb67$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $cd2436cf019ecb67$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $cd2436cf019ecb67$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $cd2436cf019ecb67$var$INVALID$2;
        var l = $cd2436cf019ecb67$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($cd2436cf019ecb67$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($cd2436cf019ecb67$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($cd2436cf019ecb67$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $cd2436cf019ecb67$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $cd2436cf019ecb67$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $cd2436cf019ecb67$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $cd2436cf019ecb67$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $cd2436cf019ecb67$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $cd2436cf019ecb67$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($cd2436cf019ecb67$var$hasOwnProperty(dur.values, k) || $cd2436cf019ecb67$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $cd2436cf019ecb67$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $cd2436cf019ecb67$var$asNumber(fn(this.values[k], k));
        }
        return $cd2436cf019ecb67$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $cd2436cf019ecb67$var$_extends({}, this.values, $cd2436cf019ecb67$var$normalizeObject(values, Duration.normalizeUnit));
        return $cd2436cf019ecb67$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $cd2436cf019ecb67$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $cd2436cf019ecb67$var$normalizeValues(this.matrix, vals);
        return $cd2436cf019ecb67$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $cd2436cf019ecb67$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $cd2436cf019ecb67$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $cd2436cf019ecb67$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($cd2436cf019ecb67$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($cd2436cf019ecb67$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $cd2436cf019ecb67$var$normalizeValues(this.matrix, built);
        return $cd2436cf019ecb67$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $cd2436cf019ecb67$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $cd2436cf019ecb67$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $cd2436cf019ecb67$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $cd2436cf019ecb67$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $cd2436cf019ecb67$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $cd2436cf019ecb67$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $cd2436cf019ecb67$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $cd2436cf019ecb67$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $cd2436cf019ecb67$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $cd2436cf019ecb67$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $cd2436cf019ecb67$var$Invalid ? reason : new $cd2436cf019ecb67$var$Invalid(reason, explanation);
        if ($cd2436cf019ecb67$var$Settings.throwOnInvalid) throw new $cd2436cf019ecb67$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $cd2436cf019ecb67$var$friendlyDateTime(start), builtEnd = $cd2436cf019ecb67$var$friendlyDateTime(end);
        var validateError = $cd2436cf019ecb67$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $cd2436cf019ecb67$var$Duration.fromDurationLike(duration), dt = $cd2436cf019ecb67$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $cd2436cf019ecb67$var$Duration.fromDurationLike(duration), dt = $cd2436cf019ecb67$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $cd2436cf019ecb67$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $cd2436cf019ecb67$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $cd2436cf019ecb67$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $cd2436cf019ecb67$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ ;
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($cd2436cf019ecb67$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $cd2436cf019ecb67$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $cd2436cf019ecb67$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $cd2436cf019ecb67$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $cd2436cf019ecb67$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $cd2436cf019ecb67$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $cd2436cf019ecb67$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $cd2436cf019ecb67$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $cd2436cf019ecb67$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $cd2436cf019ecb67$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $cd2436cf019ecb67$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $cd2436cf019ecb67$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $cd2436cf019ecb67$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $cd2436cf019ecb67$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $cd2436cf019ecb67$var$Settings.defaultZone;
        var proto = $cd2436cf019ecb67$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $cd2436cf019ecb67$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $cd2436cf019ecb67$var$normalizeZone(input, $cd2436cf019ecb67$var$Settings.defaultZone);
    } /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ ;
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $cd2436cf019ecb67$var$Locale.create(locale)).getStartOfWeek();
    } /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ ;
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $cd2436cf019ecb67$var$Locale.create(locale)).getMinDaysInFirstWeek();
    } /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ ;
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $cd2436cf019ecb67$var$Locale.create(locale)).getWeekendDays().slice();
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $cd2436cf019ecb67$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $cd2436cf019ecb67$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $cd2436cf019ecb67$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $cd2436cf019ecb67$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $cd2436cf019ecb67$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $cd2436cf019ecb67$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $cd2436cf019ecb67$var$hasRelative(),
            localeWeek: $cd2436cf019ecb67$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $cd2436cf019ecb67$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($cd2436cf019ecb67$var$Duration.fromMillis(ms).as("days"));
}
function $cd2436cf019ecb67$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $cd2436cf019ecb67$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $cd2436cf019ecb67$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $cd2436cf019ecb67$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $cd2436cf019ecb67$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $cd2436cf019ecb67$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $cd2436cf019ecb67$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $cd2436cf019ecb67$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $cd2436cf019ecb67$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $cd2436cf019ecb67$var$hanidecChars = $cd2436cf019ecb67$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $cd2436cf019ecb67$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($cd2436cf019ecb67$var$numberingSystems.hanidec) !== -1) value += $cd2436cf019ecb67$var$hanidecChars.indexOf(str[i]);
            else for(var key in $cd2436cf019ecb67$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $cd2436cf019ecb67$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $cd2436cf019ecb67$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $cd2436cf019ecb67$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $cd2436cf019ecb67$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $cd2436cf019ecb67$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($cd2436cf019ecb67$var$parseDigits(s));
        }
    };
}
var $cd2436cf019ecb67$var$NBSP = String.fromCharCode(160);
var $cd2436cf019ecb67$var$spaceOrNBSP = "[ " + $cd2436cf019ecb67$var$NBSP + "]";
var $cd2436cf019ecb67$var$spaceOrNBSPRegExp = new RegExp($cd2436cf019ecb67$var$spaceOrNBSP, "g");
function $cd2436cf019ecb67$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($cd2436cf019ecb67$var$spaceOrNBSPRegExp, $cd2436cf019ecb67$var$spaceOrNBSP);
}
function $cd2436cf019ecb67$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($cd2436cf019ecb67$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $cd2436cf019ecb67$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($cd2436cf019ecb67$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $cd2436cf019ecb67$var$stripInsensitivities(s) === $cd2436cf019ecb67$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $cd2436cf019ecb67$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $cd2436cf019ecb67$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $cd2436cf019ecb67$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $cd2436cf019ecb67$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $cd2436cf019ecb67$var$unitForToken(token, loc) {
    var one = $cd2436cf019ecb67$var$digitRegex(loc), two = $cd2436cf019ecb67$var$digitRegex(loc, "{2}"), three = $cd2436cf019ecb67$var$digitRegex(loc, "{3}"), four = $cd2436cf019ecb67$var$digitRegex(loc, "{4}"), six = $cd2436cf019ecb67$var$digitRegex(loc, "{6}"), oneOrTwo = $cd2436cf019ecb67$var$digitRegex(loc, "{1,2}"), oneToThree = $cd2436cf019ecb67$var$digitRegex(loc, "{1,3}"), oneToSix = $cd2436cf019ecb67$var$digitRegex(loc, "{1,6}"), oneToNine = $cd2436cf019ecb67$var$digitRegex(loc, "{1,9}"), twoToFour = $cd2436cf019ecb67$var$digitRegex(loc, "{2,4}"), fourToSix = $cd2436cf019ecb67$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($cd2436cf019ecb67$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $cd2436cf019ecb67$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $cd2436cf019ecb67$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $cd2436cf019ecb67$var$intUnit(oneToSix);
            case "yy":
                return $cd2436cf019ecb67$var$intUnit(twoToFour, $cd2436cf019ecb67$var$untruncateYear);
            case "yyyy":
                return $cd2436cf019ecb67$var$intUnit(four);
            case "yyyyy":
                return $cd2436cf019ecb67$var$intUnit(fourToSix);
            case "yyyyyy":
                return $cd2436cf019ecb67$var$intUnit(six);
            // months
            case "M":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "MM":
                return $cd2436cf019ecb67$var$intUnit(two);
            case "MMM":
                return $cd2436cf019ecb67$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $cd2436cf019ecb67$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "LL":
                return $cd2436cf019ecb67$var$intUnit(two);
            case "LLL":
                return $cd2436cf019ecb67$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $cd2436cf019ecb67$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "dd":
                return $cd2436cf019ecb67$var$intUnit(two);
            // ordinals
            case "o":
                return $cd2436cf019ecb67$var$intUnit(oneToThree);
            case "ooo":
                return $cd2436cf019ecb67$var$intUnit(three);
            // time
            case "HH":
                return $cd2436cf019ecb67$var$intUnit(two);
            case "H":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "hh":
                return $cd2436cf019ecb67$var$intUnit(two);
            case "h":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "mm":
                return $cd2436cf019ecb67$var$intUnit(two);
            case "m":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "q":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "qq":
                return $cd2436cf019ecb67$var$intUnit(two);
            case "s":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "ss":
                return $cd2436cf019ecb67$var$intUnit(two);
            case "S":
                return $cd2436cf019ecb67$var$intUnit(oneToThree);
            case "SSS":
                return $cd2436cf019ecb67$var$intUnit(three);
            case "u":
                return $cd2436cf019ecb67$var$simple(oneToNine);
            case "uu":
                return $cd2436cf019ecb67$var$simple(oneOrTwo);
            case "uuu":
                return $cd2436cf019ecb67$var$intUnit(one);
            // meridiem
            case "a":
                return $cd2436cf019ecb67$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $cd2436cf019ecb67$var$intUnit(four);
            case "kk":
                return $cd2436cf019ecb67$var$intUnit(twoToFour, $cd2436cf019ecb67$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $cd2436cf019ecb67$var$intUnit(oneOrTwo);
            case "WW":
                return $cd2436cf019ecb67$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $cd2436cf019ecb67$var$intUnit(one);
            case "EEE":
                return $cd2436cf019ecb67$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $cd2436cf019ecb67$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $cd2436cf019ecb67$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $cd2436cf019ecb67$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $cd2436cf019ecb67$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $cd2436cf019ecb67$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $cd2436cf019ecb67$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $cd2436cf019ecb67$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $cd2436cf019ecb67$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $cd2436cf019ecb67$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $cd2436cf019ecb67$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $cd2436cf019ecb67$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $cd2436cf019ecb67$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $cd2436cf019ecb67$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($cd2436cf019ecb67$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $cd2436cf019ecb67$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$cd2436cf019ecb67$var$isUndefined(matches.z)) zone = $cd2436cf019ecb67$var$IANAZone.create(matches.z);
    if (!$cd2436cf019ecb67$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $cd2436cf019ecb67$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$cd2436cf019ecb67$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$cd2436cf019ecb67$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$cd2436cf019ecb67$var$isUndefined(matches.u)) matches.S = $cd2436cf019ecb67$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $cd2436cf019ecb67$var$dummyDateTimeCache = null;
function $cd2436cf019ecb67$var$getDummyDateTime() {
    if (!$cd2436cf019ecb67$var$dummyDateTimeCache) $cd2436cf019ecb67$var$dummyDateTimeCache = $cd2436cf019ecb67$var$DateTime.fromMillis(1555555555555);
    return $cd2436cf019ecb67$var$dummyDateTimeCache;
}
function $cd2436cf019ecb67$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $cd2436cf019ecb67$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $cd2436cf019ecb67$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $cd2436cf019ecb67$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $cd2436cf019ecb67$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $cd2436cf019ecb67$var$explainFromTokens(locale, input, format) {
    var tokens = $cd2436cf019ecb67$var$expandMacroTokens($cd2436cf019ecb67$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $cd2436cf019ecb67$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $cd2436cf019ecb67$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $cd2436cf019ecb67$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $cd2436cf019ecb67$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($cd2436cf019ecb67$var$hasOwnProperty(matches, "a") && $cd2436cf019ecb67$var$hasOwnProperty(matches, "H")) throw new $cd2436cf019ecb67$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $cd2436cf019ecb67$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $cd2436cf019ecb67$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $cd2436cf019ecb67$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $cd2436cf019ecb67$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($cd2436cf019ecb67$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $cd2436cf019ecb67$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $cd2436cf019ecb67$var$INVALID = "Invalid DateTime";
var $cd2436cf019ecb67$var$MAX_DATE = 8.64e15;
function $cd2436cf019ecb67$var$unsupportedZone(zone) {
    return new $cd2436cf019ecb67$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $cd2436cf019ecb67$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $cd2436cf019ecb67$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $cd2436cf019ecb67$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $cd2436cf019ecb67$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $cd2436cf019ecb67$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $cd2436cf019ecb67$var$DateTime($cd2436cf019ecb67$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $cd2436cf019ecb67$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $cd2436cf019ecb67$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $cd2436cf019ecb67$var$objToTS(obj, offset, zone) {
    return $cd2436cf019ecb67$var$fixOffset($cd2436cf019ecb67$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $cd2436cf019ecb67$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $cd2436cf019ecb67$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $cd2436cf019ecb67$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $cd2436cf019ecb67$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $cd2436cf019ecb67$var$objToLocalTS(c);
    var _fixOffset = $cd2436cf019ecb67$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $cd2436cf019ecb67$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $cd2436cf019ecb67$var$DateTime.fromObject(parsed, $cd2436cf019ecb67$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $cd2436cf019ecb67$var$DateTime.invalid(new $cd2436cf019ecb67$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $cd2436cf019ecb67$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $cd2436cf019ecb67$var$Formatter.create($cd2436cf019ecb67$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $cd2436cf019ecb67$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $cd2436cf019ecb67$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $cd2436cf019ecb67$var$padStart(o.c.month);
        c += "-";
        c += $cd2436cf019ecb67$var$padStart(o.c.day);
    } else {
        c += $cd2436cf019ecb67$var$padStart(o.c.month);
        c += $cd2436cf019ecb67$var$padStart(o.c.day);
    }
    return c;
}
function $cd2436cf019ecb67$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $cd2436cf019ecb67$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $cd2436cf019ecb67$var$padStart(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $cd2436cf019ecb67$var$padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += $cd2436cf019ecb67$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $cd2436cf019ecb67$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $cd2436cf019ecb67$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $cd2436cf019ecb67$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $cd2436cf019ecb67$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $cd2436cf019ecb67$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $cd2436cf019ecb67$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $cd2436cf019ecb67$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $cd2436cf019ecb67$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $cd2436cf019ecb67$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $cd2436cf019ecb67$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $cd2436cf019ecb67$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $cd2436cf019ecb67$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $cd2436cf019ecb67$var$InvalidUnitError(unit);
    return normalized;
}
function $cd2436cf019ecb67$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $cd2436cf019ecb67$var$normalizeUnit(unit);
    }
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $cd2436cf019ecb67$var$quickDT(obj, opts) {
    var zone = $cd2436cf019ecb67$var$normalizeZone(opts.zone, $cd2436cf019ecb67$var$Settings.defaultZone), loc = $cd2436cf019ecb67$var$Locale.fromObject(opts), tsNow = $cd2436cf019ecb67$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$cd2436cf019ecb67$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $cd2436cf019ecb67$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($cd2436cf019ecb67$var$isUndefined(obj[u])) obj[u] = $cd2436cf019ecb67$var$defaultUnitValues[u];
        }
        var invalid = $cd2436cf019ecb67$var$hasInvalidGregorianData(obj) || $cd2436cf019ecb67$var$hasInvalidTimeData(obj);
        if (invalid) return $cd2436cf019ecb67$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $cd2436cf019ecb67$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $cd2436cf019ecb67$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $cd2436cf019ecb67$var$diffRelative(start, end, opts) {
    var round = $cd2436cf019ecb67$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $cd2436cf019ecb67$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $cd2436cf019ecb67$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $cd2436cf019ecb67$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $cd2436cf019ecb67$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $cd2436cf019ecb67$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $cd2436cf019ecb67$var$Invalid("invalid input") : null) || (!zone.isValid ? $cd2436cf019ecb67$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $cd2436cf019ecb67$var$isUndefined(config.ts) ? $cd2436cf019ecb67$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $cd2436cf019ecb67$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $cd2436cf019ecb67$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $cd2436cf019ecb67$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $cd2436cf019ecb67$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $cd2436cf019ecb67$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $cd2436cf019ecb67$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $cd2436cf019ecb67$var$FixedOffsetZone.utcInstance;
        return $cd2436cf019ecb67$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $cd2436cf019ecb67$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $cd2436cf019ecb67$var$normalizeZone(options.zone, $cd2436cf019ecb67$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($cd2436cf019ecb67$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $cd2436cf019ecb67$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$cd2436cf019ecb67$var$isNumber(milliseconds)) throw new $cd2436cf019ecb67$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$cd2436cf019ecb67$var$MAX_DATE || milliseconds > $cd2436cf019ecb67$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $cd2436cf019ecb67$var$normalizeZone(options.zone, $cd2436cf019ecb67$var$Settings.defaultZone),
            loc: $cd2436cf019ecb67$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$cd2436cf019ecb67$var$isNumber(seconds)) throw new $cd2436cf019ecb67$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $cd2436cf019ecb67$var$normalizeZone(options.zone, $cd2436cf019ecb67$var$Settings.defaultZone),
            loc: $cd2436cf019ecb67$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $cd2436cf019ecb67$var$normalizeZone(opts.zone, $cd2436cf019ecb67$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($cd2436cf019ecb67$var$unsupportedZone(zoneToUse));
        var loc = $cd2436cf019ecb67$var$Locale.fromObject(opts);
        var normalized = $cd2436cf019ecb67$var$normalizeObject(obj, $cd2436cf019ecb67$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $cd2436cf019ecb67$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $cd2436cf019ecb67$var$Settings.now(), offsetProvis = !$cd2436cf019ecb67$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$cd2436cf019ecb67$var$isUndefined(normalized.ordinal), containsGregorYear = !$cd2436cf019ecb67$var$isUndefined(normalized.year), containsGregorMD = !$cd2436cf019ecb67$var$isUndefined(normalized.month) || !$cd2436cf019ecb67$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $cd2436cf019ecb67$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $cd2436cf019ecb67$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $cd2436cf019ecb67$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $cd2436cf019ecb67$var$orderedWeekUnits;
            defaultValues = $cd2436cf019ecb67$var$defaultWeekUnitValues;
            objNow = $cd2436cf019ecb67$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $cd2436cf019ecb67$var$orderedOrdinalUnits;
            defaultValues = $cd2436cf019ecb67$var$defaultOrdinalUnitValues;
            objNow = $cd2436cf019ecb67$var$gregorianToOrdinal(objNow);
        } else {
            units = $cd2436cf019ecb67$var$orderedUnits;
            defaultValues = $cd2436cf019ecb67$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $cd2436cf019ecb67$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$cd2436cf019ecb67$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $cd2436cf019ecb67$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $cd2436cf019ecb67$var$hasInvalidOrdinalData(normalized) : $cd2436cf019ecb67$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $cd2436cf019ecb67$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $cd2436cf019ecb67$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $cd2436cf019ecb67$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $cd2436cf019ecb67$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $cd2436cf019ecb67$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $cd2436cf019ecb67$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $cd2436cf019ecb67$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $cd2436cf019ecb67$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $cd2436cf019ecb67$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $cd2436cf019ecb67$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($cd2436cf019ecb67$var$isUndefined(text) || $cd2436cf019ecb67$var$isUndefined(fmt)) throw new $cd2436cf019ecb67$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $cd2436cf019ecb67$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $cd2436cf019ecb67$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $cd2436cf019ecb67$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $cd2436cf019ecb67$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $cd2436cf019ecb67$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $cd2436cf019ecb67$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $cd2436cf019ecb67$var$Invalid ? reason : new $cd2436cf019ecb67$var$Invalid(reason, explanation);
        if ($cd2436cf019ecb67$var$Settings.throwOnInvalid) throw new $cd2436cf019ecb67$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $cd2436cf019ecb67$var$formatOptsToTokens(formatOpts, $cd2436cf019ecb67$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $cd2436cf019ecb67$var$expandMacroTokens($cd2436cf019ecb67$var$Formatter.parseFormat(fmt), $cd2436cf019ecb67$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $cd2436cf019ecb67$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $cd2436cf019ecb67$var$tsToObj(ts1, o1);
        var c2 = $cd2436cf019ecb67$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $cd2436cf019ecb67$var$clone(this, {
                ts: ts1
            }),
            $cd2436cf019ecb67$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $cd2436cf019ecb67$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($cd2436cf019ecb67$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($cd2436cf019ecb67$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $cd2436cf019ecb67$var$normalizeZone(zone, $cd2436cf019ecb67$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($cd2436cf019ecb67$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $cd2436cf019ecb67$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $cd2436cf019ecb67$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $cd2436cf019ecb67$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $cd2436cf019ecb67$var$normalizeObject(values, $cd2436cf019ecb67$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $cd2436cf019ecb67$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$cd2436cf019ecb67$var$isUndefined(normalized.weekYear) || !$cd2436cf019ecb67$var$isUndefined(normalized.weekNumber) || !$cd2436cf019ecb67$var$isUndefined(normalized.weekday), containsOrdinal = !$cd2436cf019ecb67$var$isUndefined(normalized.ordinal), containsGregorYear = !$cd2436cf019ecb67$var$isUndefined(normalized.year), containsGregorMD = !$cd2436cf019ecb67$var$isUndefined(normalized.month) || !$cd2436cf019ecb67$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $cd2436cf019ecb67$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $cd2436cf019ecb67$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $cd2436cf019ecb67$var$weekToGregorian($cd2436cf019ecb67$var$_extends({}, $cd2436cf019ecb67$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$cd2436cf019ecb67$var$isUndefined(normalized.ordinal)) mixed = $cd2436cf019ecb67$var$ordinalToGregorian($cd2436cf019ecb67$var$_extends({}, $cd2436cf019ecb67$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $cd2436cf019ecb67$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($cd2436cf019ecb67$var$isUndefined(normalized.day)) mixed.day = Math.min($cd2436cf019ecb67$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $cd2436cf019ecb67$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $cd2436cf019ecb67$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $cd2436cf019ecb67$var$Duration.fromDurationLike(duration);
        return $cd2436cf019ecb67$var$clone(this, $cd2436cf019ecb67$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $cd2436cf019ecb67$var$Duration.fromDurationLike(duration).negate();
        return $cd2436cf019ecb67$var$clone(this, $cd2436cf019ecb67$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $cd2436cf019ecb67$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $cd2436cf019ecb67$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $cd2436cf019ecb67$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $cd2436cf019ecb67$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $cd2436cf019ecb67$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $cd2436cf019ecb67$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $cd2436cf019ecb67$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $cd2436cf019ecb67$var$_toISODate(this, ext);
        c += "T";
        c += $cd2436cf019ecb67$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        return $cd2436cf019ecb67$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $cd2436cf019ecb67$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $cd2436cf019ecb67$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $cd2436cf019ecb67$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $cd2436cf019ecb67$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $cd2436cf019ecb67$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $cd2436cf019ecb67$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $cd2436cf019ecb67$var$INVALID;
    } /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $cd2436cf019ecb67$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $cd2436cf019ecb67$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $cd2436cf019ecb67$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $cd2436cf019ecb67$var$maybeArray(unit).map($cd2436cf019ecb67$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $cd2436cf019ecb67$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $cd2436cf019ecb67$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $cd2436cf019ecb67$var$diffRelative(base, this.plus(padding), $cd2436cf019ecb67$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $cd2436cf019ecb67$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $cd2436cf019ecb67$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $cd2436cf019ecb67$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $cd2436cf019ecb67$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $cd2436cf019ecb67$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $cd2436cf019ecb67$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $cd2436cf019ecb67$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $cd2436cf019ecb67$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $cd2436cf019ecb67$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $cd2436cf019ecb67$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $cd2436cf019ecb67$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $cd2436cf019ecb67$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $cd2436cf019ecb67$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $cd2436cf019ecb67$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $cd2436cf019ecb67$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $cd2436cf019ecb67$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $cd2436cf019ecb67$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $cd2436cf019ecb67$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $cd2436cf019ecb67$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $cd2436cf019ecb67$var$friendlyDateTime(dateTimeish) {
    if ($cd2436cf019ecb67$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $cd2436cf019ecb67$var$isNumber(dateTimeish.valueOf())) return $cd2436cf019ecb67$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $cd2436cf019ecb67$var$DateTime.fromObject(dateTimeish);
    else throw new $cd2436cf019ecb67$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $cd2436cf019ecb67$var$VERSION = "3.4.4";
$cd2436cf019ecb67$exports.DateTime = $cd2436cf019ecb67$var$DateTime;
$cd2436cf019ecb67$exports.Duration = $cd2436cf019ecb67$var$Duration;
$cd2436cf019ecb67$exports.FixedOffsetZone = $cd2436cf019ecb67$var$FixedOffsetZone;
$cd2436cf019ecb67$exports.IANAZone = $cd2436cf019ecb67$var$IANAZone;
$cd2436cf019ecb67$exports.Info = $cd2436cf019ecb67$var$Info;
$cd2436cf019ecb67$exports.Interval = $cd2436cf019ecb67$var$Interval;
$cd2436cf019ecb67$exports.InvalidZone = $cd2436cf019ecb67$var$InvalidZone;
$cd2436cf019ecb67$exports.Settings = $cd2436cf019ecb67$var$Settings;
$cd2436cf019ecb67$exports.SystemZone = $cd2436cf019ecb67$var$SystemZone;
$cd2436cf019ecb67$exports.VERSION = $cd2436cf019ecb67$var$VERSION;
$cd2436cf019ecb67$exports.Zone = $cd2436cf019ecb67$var$Zone;


const $192916709c622e5f$export$d1dbdeee32dda451 = ()=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).now().toLocaleString((0, $cd2436cf019ecb67$exports.DateTime).DATETIME_HUGE_WITH_SECONDS);
};



const $c72fca98f475932c$var$ISO_DATE = /\d{4}-\d{1,2}-\d{1,2}/;
const $c72fca98f475932c$var$ISO_TIME_OF_DAY = /(\d{1,2}):(\d{2})\s[AP]M/;
// Display name pattern
const $c72fca98f475932c$var$DISPLAY_NAME = /^[a-z|A-Z| -]*$/;
// http://www.regular-expressions.info/email.html
const $c72fca98f475932c$var$EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $c72fca98f475932c$var$EMAIL_OPTIONAL = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// https://regexr.com/37i6s
// is empty or matches the pattern
const $c72fca98f475932c$var$URL = /^$|^(https?):\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
const $c72fca98f475932c$var$IP_ADDRESS = /^((25[0-5]|(2[0-4]|1[0-9]|[1-9]|)[0-9])(\.(?!$)|$)){4}$/;
const $c72fca98f475932c$var$HEX_CODE = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
const $c72fca98f475932c$var$ABN = /^(\d *?){11}$/;
const $c72fca98f475932c$var$LETTERS = /[a-zA-Z]/g;
const $c72fca98f475932c$var$NUMERIC = /^\d+$/;
const $c72fca98f475932c$export$ac7ce348c2237f4e = {
    ISO_DATE: $c72fca98f475932c$var$ISO_DATE,
    ISO_TIME_OF_DAY: $c72fca98f475932c$var$ISO_TIME_OF_DAY,
    EMAIL: $c72fca98f475932c$var$EMAIL,
    EMAIL_OPTIONAL: $c72fca98f475932c$var$EMAIL_OPTIONAL,
    DISPLAY_NAME: $c72fca98f475932c$var$DISPLAY_NAME,
    URL: $c72fca98f475932c$var$URL,
    IP_ADDRESS: $c72fca98f475932c$var$IP_ADDRESS,
    HEX_CODE: $c72fca98f475932c$var$HEX_CODE,
    ABN: $c72fca98f475932c$var$ABN,
    LETTERS: $c72fca98f475932c$var$LETTERS,
    NUMERIC: $c72fca98f475932c$var$NUMERIC
};


// this role cannot be owner, because the owner cannot be a member of the org
// because all members of the org will have emails with the same domain as the org
var $ca53886560c28391$export$46919bad18fb2f76 = /*#__PURE__*/ function(Role) {
    Role["admin"] = "Admin";
    Role["member"] = "Member";
    return Role;
}({});


const $393581745e27d841$var$NZ = {
    code: "NZ",
    name: "New Zealand",
    timezones: [
        "Pacific/Auckland",
        "Pacific/Chatham"
    ],
    currencyCode: "NZD",
    currencySymbol: "$",
    diallingCode: "+64"
};
const $393581745e27d841$var$AU = {
    code: "AU",
    name: "Australia",
    timezones: [
        "Australia/Sydney",
        "Australia/Hobart",
        "Australia/Melbourne",
        "Australia/Brisbane",
        "Australia/Adelaide",
        "Australia/Darwin",
        "Australia/Eucla",
        "Australia/Perth"
    ],
    currencyCode: "AUD",
    currencySymbol: "$",
    diallingCode: "+61",
    /**
   * Reference: https://www.australia.gov.au/telephone-country-and-area-codes
   */ areaCodes: [
        {
            area: "New South Wales",
            code: "02"
        },
        {
            area: "Australian Capital Territory",
            code: "02"
        },
        {
            area: "Victoria",
            code: "03"
        },
        {
            area: "Tasmania",
            code: "03"
        },
        {
            area: "Queensland",
            code: "07"
        },
        {
            area: "Western Australia",
            code: "08"
        },
        {
            area: "South Australia",
            code: "08"
        },
        {
            area: "Northern Territory",
            code: "08"
        }
    ]
};
const $393581745e27d841$var$IN = {
    code: "IN",
    name: "India",
    timezones: [
        "Asia/Kolkata"
    ],
    currencyCode: "INR",
    currencySymbol: "\u20B9",
    diallingCode: "+91"
};
const $393581745e27d841$var$US = {
    code: "US",
    name: "United States",
    currencyCode: "USD",
    currencySymbol: "$",
    timezones: [
        "America/New_York",
        "America/Detroit",
        "America/Kentucky/Louisville",
        "America/Kentucky/Monticello",
        "America/Indiana/Indianapolis",
        "America/Indiana/Vincennes",
        "America/Indiana/Winamac",
        "America/Indiana/Marengo",
        "America/Indiana/Petersburg",
        "America/Indiana/Vevay",
        "America/Chicago",
        "America/Indiana/Tell_City",
        "America/Indiana/Knox",
        "America/Menominee",
        "America/North_Dakota/Center",
        "America/North_Dakota/New_Salem",
        "America/North_Dakota/Beulah",
        "America/Denver",
        "America/Boise",
        "America/Phoenix",
        "America/Los_Angeles",
        "America/Anchorage",
        "America/Juneau",
        "America/Sitka",
        "America/Metlakatla",
        "America/Yakutat",
        "America/Nome",
        "America/Adak",
        "Pacific/Honolulu"
    ],
    diallingCode: "+1"
};
const $393581745e27d841$var$GB = {
    code: "GB",
    name: "United Kingdom",
    timezones: [
        "Europe/London"
    ],
    currencyCode: "GBP",
    currencySymbol: "\xa3",
    diallingCode: "+44"
};
const $393581745e27d841$var$countryMap = {
    AU: $393581745e27d841$var$AU,
    US: $393581745e27d841$var$US,
    GB: $393581745e27d841$var$GB,
    NZ: $393581745e27d841$var$NZ,
    IN: $393581745e27d841$var$IN
};
const $393581745e27d841$var$countryList = Object.values($393581745e27d841$var$countryMap);
const $393581745e27d841$var$countryCodes = Object.values($393581745e27d841$var$countryMap).map((country)=>country.code);
const $393581745e27d841$var$getCountryForCode = (code)=>{
    if (!code) return;
    return $393581745e27d841$var$countryList.find((country)=>country.code === code);
};
const $393581745e27d841$export$142596e469219c06 = {
    codes: $393581745e27d841$var$countryCodes,
    map: $393581745e27d841$var$countryMap,
    getForCode: $393581745e27d841$var$getCountryForCode,
    IN: $393581745e27d841$var$IN,
    AU: $393581745e27d841$var$AU,
    GB: $393581745e27d841$var$GB,
    US: $393581745e27d841$var$US,
    NZ: $393581745e27d841$var$NZ
};


// https://developers.google.com/maps/documentation/javascript/place-autocomplete#constrain-place-types
const $017dbf8c3a8e8a30$export$ecfefdb908fd0ef1 = {
    regions: [
        "(regions)"
    ]
};


// Fix typescript warnings
/// <reference types="@types/google.maps" />

/*
 * https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
 */ var $ed349f3d2d76ee95$export$ab21b5d05a7dbc68 = /*#__PURE__*/ function(GoogleGeocoderAddressComponentType) {
    /*
   * Indicates an incorporated city or town political entity.
   *
   * Used for `GooglePlace.suburb`.
   */ GoogleGeocoderAddressComponentType["Locality"] = "locality";
    /*
   * Indicates a first-order civil entity below the country level.
   * Within the United States, these administrative levels are states.
   * Not all nations exhibit these administrative levels. In most cases,
   * administrative_area_level_1 short names will closely match ISO 3166-2
   * subdivisions and other widely circulated lists; however this is not
   * guaranteed as our geocoding results are based on a variety of signals
   * and location data.
   *
   * Used for `GooglePlace.state`.
   */ GoogleGeocoderAddressComponentType["AdministrativeAreaLevel1"] = "administrative_area_level_1";
    /*
   * Indicates a postal code as used to address postal mail within the country.
   *
   * Used for `GooglePlace.postcode`.
   */ GoogleGeocoderAddressComponentType["PostalCode"] = "postal_code";
    /*
   * Indicates the national political entity, and is typically
   * the highest order type returned by the Geocoder.
   *
   * Used for `GooglePlace.country.name` and  `GooglePlace.country.code`.
   */ GoogleGeocoderAddressComponentType["Country"] = "country";
    return GoogleGeocoderAddressComponentType;
}({});


const $236a2723f65f7cf7$var$getGeoPoint = (geometry)=>{
    if (!geometry) return;
    const latitude = geometry.location?.lat();
    const longitude = geometry.location?.lng();
    if ((0, $46735892604b37f3$export$984f70f9382f5d27)(latitude) || (0, $46735892604b37f3$export$984f70f9382f5d27)(longitude)) return;
    return {
        latitude: latitude,
        longitude: longitude
    };
};
/**
 * Parses `PlaceResult` and converts it into `GooglePlace`
 * https://developers.google.com/maps/documentation/geocoding/intro#GeocodingResponses
 * https://developers.google.com/maps/documentation/javascript/geocoding
 * @param {google.maps.places.PlaceResult} args.place - Place result
 * @param {string} args.address - Address input that is used for the Autocomplete prediction
 * @returns {GooglePlace|undefined} Return GooglePlace if PlaceResult is a valid Google address, otherwise, undefined.
 */ const $236a2723f65f7cf7$var$getGooglePlace = (args)=>{
    const { placeResult: { address_components: address_components, geometry: geometry } } = args; // prettier-ignore
    // check if address components are present
    if (!address_components) {
        console.warn(`address_components is missing in ${args.placeResult}`);
        return;
    }
    const locality = $236a2723f65f7cf7$var$getAddressComponent({
        address_components: address_components,
        type: (0, $ed349f3d2d76ee95$export$ab21b5d05a7dbc68).Locality
    });
    const suburb = locality?.long_name;
    const administrativeAreaLevel1 = $236a2723f65f7cf7$var$getAddressComponent({
        address_components: address_components,
        type: (0, $ed349f3d2d76ee95$export$ab21b5d05a7dbc68).AdministrativeAreaLevel1
    });
    const state = administrativeAreaLevel1?.long_name;
    if (!state) {
        console.warn(`cannot find state in ${args.placeResult}`);
        return;
    }
    const countryComponent = $236a2723f65f7cf7$var$getAddressComponent({
        address_components: address_components,
        type: (0, $ed349f3d2d76ee95$export$ab21b5d05a7dbc68).Country
    });
    const countryName = countryComponent?.long_name;
    if (!countryName) {
        console.warn(`cannot find country name in ${countryComponent}`);
        return;
    }
    const countryCode = countryComponent?.short_name;
    if (!countryCode) {
        console.warn(`cannot find country code in ${countryComponent}`);
        return;
    }
    const country = {
        name: countryName,
        code: countryCode
    };
    const postcodeComponent = $236a2723f65f7cf7$var$getAddressComponent({
        address_components: address_components,
        type: (0, $ed349f3d2d76ee95$export$ab21b5d05a7dbc68).PostalCode
    });
    const geoPoint = $236a2723f65f7cf7$var$getGeoPoint(geometry);
    return {
        formattedAddress: args.placeResult.formatted_address,
        suburb: suburb,
        state: state,
        postcode: postcodeComponent?.long_name,
        country: country,
        geoPoint: geoPoint,
        googlePlaceId: args.placeResult.place_id
    };
};
const $236a2723f65f7cf7$var$getAddressComponent = (args)=>{
    const { address_components: address_components, type: type } = args;
    return address_components.find((component)=>component.types.includes(type));
};
function $236a2723f65f7cf7$var$getLocality(args) {
    const googlePlace = $236a2723f65f7cf7$var$getGooglePlace(args);
    if (!googlePlace) return;
    return {
        suburb: googlePlace.suburb,
        state: googlePlace.state,
        countryCode: googlePlace.country.code,
        geoPoint: googlePlace.geoPoint,
        postcode: googlePlace.postcode
    };
}
const $236a2723f65f7cf7$export$7abbf712c13acd02 = {
    getGooglePlace: $236a2723f65f7cf7$var$getGooglePlace,
    getLocality: $236a2723f65f7cf7$var$getLocality
};


/**
 * Resolution	DataType	Format	                  Example	    API	                        Component	      Field Name Suffix
 * isoDate	  string	  yyyy-MM-dd (ISO format)	  2017-04-20	luxon.DateTime.toISODate()	IsoDatePicker	  isoDate
 */ 

var $650d86d39a18247b$export$7ed5ca4f8b987938 = /*#__PURE__*/ function(DayOfWeek) {
    DayOfWeek["monday"] = "monday";
    DayOfWeek["tuesday"] = "tuesday";
    DayOfWeek["wednesday"] = "wednesday";
    DayOfWeek["thursday"] = "thursday";
    DayOfWeek["friday"] = "friday";
    DayOfWeek["saturday"] = "saturday";
    DayOfWeek["sunday"] = "sunday";
    return DayOfWeek;
}({});
const $650d86d39a18247b$export$c08790adaaf59fa6 = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
];
const $650d86d39a18247b$export$e02d8fd43da118fb = {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
};
const $650d86d39a18247b$export$2fbc63fe6a0f3bba = {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun'
};


const $bcde166b54e8e697$var$TIME_OF_DAY = 'hh:mm a';
const $bcde166b54e8e697$var$TIME_OF_DAY_24_HOURS = 'HH:mm';
const $bcde166b54e8e697$var$TIME_OF_DAY_HOUR_ONLY = 'h a';
const $bcde166b54e8e697$var$ISO_DATE = 'yyyy-MM-dd';
const $bcde166b54e8e697$var$ISO_YEAR = 'yyyy';
const $bcde166b54e8e697$var$ISO_MONTH = 'yyyy-MM';
const $bcde166b54e8e697$var$ISO_WEEK = 'yyyy-W';
const $bcde166b54e8e697$var$COLLECTION_DATE_TIME = 'ccc d LLLL - h:mm a';
const $bcde166b54e8e697$var$COLLECTION_DATE = 'ccc d LLLL';
const $bcde166b54e8e697$var$COLLECTION_TIME = 'h:mm a';
const $bcde166b54e8e697$export$57d734daf52cc272 = {
    TIME_OF_DAY: $bcde166b54e8e697$var$TIME_OF_DAY,
    TIME_OF_DAY_24_HOURS: $bcde166b54e8e697$var$TIME_OF_DAY_24_HOURS,
    TIME_OF_DAY_HOUR_ONLY: $bcde166b54e8e697$var$TIME_OF_DAY_HOUR_ONLY,
    ISO_DATE: $bcde166b54e8e697$var$ISO_DATE,
    ISO_YEAR: $bcde166b54e8e697$var$ISO_YEAR,
    ISO_MONTH: $bcde166b54e8e697$var$ISO_MONTH,
    ISO_WEEK: $bcde166b54e8e697$var$ISO_WEEK,
    COLLECTION_DATE_TIME: $bcde166b54e8e697$var$COLLECTION_DATE_TIME,
    COLLECTION_DATE: $bcde166b54e8e697$var$COLLECTION_DATE,
    COLLECTION_TIME: $bcde166b54e8e697$var$COLLECTION_TIME
};


const $0a3e1062c228cefd$var$now = (args)=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).local().setZone(args.timezone);
};
const $0a3e1062c228cefd$var$fromIsoDate = (args)=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).fromISO(args.isoDate, {
        zone: args.timezone
    });
};
const $0a3e1062c228cefd$var$fromIsoDateTimeUtc = (args)=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).fromISO(args.isoDateTimeUtc, {
        zone: args.timezone
    });
};
const $0a3e1062c228cefd$var$fromIsoDateAndTimeOfDay = (args)=>{
    const { timeOfDay: timeOfDay, isoDate: isoDate, timezone: timezone } = args;
    const timeOfDay24Hours = (0, $cd2436cf019ecb67$exports.DateTime).fromFormat(timeOfDay, (0, $bcde166b54e8e697$export$57d734daf52cc272).TIME_OF_DAY).toFormat((0, $bcde166b54e8e697$export$57d734daf52cc272).TIME_OF_DAY_24_HOURS);
    const isoDateTime = `${isoDate}T${timeOfDay24Hours}`;
    return (0, $cd2436cf019ecb67$exports.DateTime).fromISO(isoDateTime, {
        zone: timezone
    });
};
const $0a3e1062c228cefd$var$fromJsDate = (args)=>{
    const { jsDate: jsDate, timezone: timezone } = args;
    return (0, $cd2436cf019ecb67$exports.DateTime).fromJSDate(jsDate, {
        zone: timezone
    });
};
const $0a3e1062c228cefd$var$fromDuration = (args)=>{
    const { duration: duration } = args;
    const dateTimeNow = $0a3e1062c228cefd$export$2364d538c15eb8db.now(args);
    const currentDuration = (0, $cd2436cf019ecb67$exports.Duration).fromISO(duration);
    return dateTimeNow.plus(currentDuration);
};
const $0a3e1062c228cefd$var$fromTimeOfDay = (args)=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).fromFormat(args.timeOfDay, (0, $bcde166b54e8e697$export$57d734daf52cc272).TIME_OF_DAY, {
        zone: args.timezone
    });
};
const $0a3e1062c228cefd$var$fromDayOfWeek = (args)=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).fromFormat(args.dayOfWeek, "cccc", {
        zone: args.timezone
    });
};
const $0a3e1062c228cefd$var$fromDayOfWeekAndTimeOfDay = (args)=>{
    const { dayOfWeek: dayOfWeek, timeOfDay: timeOfDay, timezone: timezone } = args;
    return (0, $cd2436cf019ecb67$exports.DateTime).fromFormat(`${(0, $650d86d39a18247b$export$e02d8fd43da118fb)[dayOfWeek]} ${timeOfDay}`, "cccc h:mm a", {
        zone: timezone
    });
};
const $0a3e1062c228cefd$export$2364d538c15eb8db = {
    now: $0a3e1062c228cefd$var$now,
    fromIsoDate: $0a3e1062c228cefd$var$fromIsoDate,
    fromIsoDateTimeUtc: $0a3e1062c228cefd$var$fromIsoDateTimeUtc,
    fromIsoDateAndTimeOfDay: $0a3e1062c228cefd$var$fromIsoDateAndTimeOfDay,
    fromJsDate: $0a3e1062c228cefd$var$fromJsDate,
    fromDuration: $0a3e1062c228cefd$var$fromDuration,
    fromTimeOfDay: $0a3e1062c228cefd$var$fromTimeOfDay,
    fromDayOfWeek: $0a3e1062c228cefd$var$fromDayOfWeek,
    fromDayOfWeekAndTimeOfDay: $0a3e1062c228cefd$var$fromDayOfWeekAndTimeOfDay
};


const $6524ac5c81f18756$var$now = (args)=>{
    const { timezone: timezone } = args;
    return (0, $0a3e1062c228cefd$export$2364d538c15eb8db).now({
        timezone: timezone
    }).toISODate();
};
const $6524ac5c81f18756$var$nowLocal = ()=>{
    return (0, $0a3e1062c228cefd$export$2364d538c15eb8db).now({
        timezone: (0, $b79434791fc6a459$export$5ba2b8988138595d).forLocal()
    }).toISODate();
};
const $6524ac5c81f18756$var$fromIsoDateTimeUtc = (args)=>{
    const { isoDateTimeUtc: isoDateTimeUtc, timezone: timezone } = args;
    return (0, $0a3e1062c228cefd$export$2364d538c15eb8db).fromIsoDateTimeUtc({
        isoDateTimeUtc: isoDateTimeUtc,
        timezone: timezone
    }).toISODate();
};
const $6524ac5c81f18756$var$fromDateTime = (args)=>{
    const { dateTime: dateTime, timezone: timezone } = args;
    return dateTime.setZone(timezone).toISODate();
};
const $6524ac5c81f18756$var$fromJsDate = (args)=>{
    const { timezone: timezone } = args;
    const dateTime = (0, $0a3e1062c228cefd$export$2364d538c15eb8db).fromJsDate(args);
    return dateTime.setZone(timezone).toISODate();
};
const $6524ac5c81f18756$var$fromCurrentPlusDays = (args)=>{
    const { currentDateTime: currentDateTime, plusDays: plusDays, timezone: timezone } = args;
    // Throw error because luxon.DateTime.plus allows negative values
    if (plusDays < 0) throw Error("Plus days should be a positive number");
    return currentDateTime.setZone(timezone).plus({
        days: plusDays
    }).toISODate();
};
const $6524ac5c81f18756$var$fromIsoDateTimeUtcAndDuration = (args)=>{
    return (0, $0a3e1062c228cefd$export$2364d538c15eb8db).fromIsoDateTimeUtc(args).plus(args.durationObject).toISODate();
};
const $6524ac5c81f18756$export$3db24a247ce728bb = {
    now: $6524ac5c81f18756$var$now,
    nowLocal: $6524ac5c81f18756$var$nowLocal,
    fromIsoDateTimeUtc: $6524ac5c81f18756$var$fromIsoDateTimeUtc,
    fromDateTime: $6524ac5c81f18756$var$fromDateTime,
    fromJsDate: $6524ac5c81f18756$var$fromJsDate,
    fromCurrentPlusDays: $6524ac5c81f18756$var$fromCurrentPlusDays,
    fromIsoDateTimeUtcAndDuration: $6524ac5c81f18756$var$fromIsoDateTimeUtcAndDuration
};




const $6433917c58d3ae74$var$now = ()=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).utc().toISO();
};
const $6433917c58d3ae74$var$fromDateTime = (args)=>{
    const { dateTime: dateTime } = args;
    return dateTime.toUTC().toISO();
};
const $6433917c58d3ae74$var$fromDateAndTimeOfDay = (args)=>{
    return (0, $0a3e1062c228cefd$export$2364d538c15eb8db).fromIsoDateAndTimeOfDay(args).toUTC().toISO(); // can return null if, say, timeOfDay is ASAP
};
const $6433917c58d3ae74$var$fromDateAndTimeOfDayAndDuration = (args)=>{
    return (0, $0a3e1062c228cefd$export$2364d538c15eb8db).fromIsoDateAndTimeOfDay(args).plus(args.durationObject).toUTC().toISO(); // returns null if, say, timeOfDay is ASAP
};
const $6433917c58d3ae74$export$2e6018b2ecea9a73 = {
    now: $6433917c58d3ae74$var$now,
    fromDateTime: $6433917c58d3ae74$var$fromDateTime,
    fromDateAndTimeOfDay: $6433917c58d3ae74$var$fromDateAndTimeOfDay,
    fromDateAndTimeOfDayAndDuration: $6433917c58d3ae74$var$fromDateAndTimeOfDayAndDuration
};




const $5c3f388dde733a7e$var$fromIsoDate = (args)=>{
    const { timezone: timezone, isoDate: isoDate } = args;
    // Does not use getDateTime since it returns yesterday's date
    return (0, $cd2436cf019ecb67$exports.DateTime).fromISO(isoDate).setZone(timezone).toJSDate();
};
const $5c3f388dde733a7e$var$now = (args)=>{
    const { timezone: timezone } = args;
    return (0, $0a3e1062c228cefd$export$2364d538c15eb8db).now({
        timezone: timezone
    }).toJSDate();
};
const $5c3f388dde733a7e$export$c6ec6eb3a2fad9a1 = {
    fromIsoDate: $5c3f388dde733a7e$var$fromIsoDate,
    now: $5c3f388dde733a7e$var$now
};



const $b79434791fc6a459$var$forLocal = ()=>{
    return (0, $cd2436cf019ecb67$exports.DateTime).local().zoneName;
};
const $b79434791fc6a459$export$5ba2b8988138595d = {
    forLocal: $b79434791fc6a459$var$forLocal
};


const $d152d9c822100e0f$var$replace = (template, key, value)=>{
    const regex = `{${key}}`;
    return template.replace(new RegExp(regex, "g"), value);
};
const $d152d9c822100e0f$export$d9468344d3651243 = (template, values)=>{
    return Object.keys(values).reduce((template, key)=>{
        return $d152d9c822100e0f$var$replace(template, key, values[key]);
    }, template);
};
const $d152d9c822100e0f$export$d987ba8f1b26095e = {
    format: $d152d9c822100e0f$export$d9468344d3651243
};


class $469bdf591fa0faa8$export$52c686705963a4fc {
    constructor(template){
        /**
   * Takes a key and returns a real path that points to a specific document or collection in firestore
   */ this.path = (key)=>{
            return (0, $d152d9c822100e0f$export$d987ba8f1b26095e).format(this.template, key);
        };
        this.template = template;
    }
}



const $15fd4ed8634ba885$var$userProfiles = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`user_profiles`);
const $15fd4ed8634ba885$var$userProfile = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$userProfiles.template}/{uid}`);
const $15fd4ed8634ba885$var$orgs = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`orgs`);
const $15fd4ed8634ba885$var$org = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$orgs.template}/{orgId}`);
const $15fd4ed8634ba885$var$owners = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$org.template}/owners`);
const $15fd4ed8634ba885$var$owner = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$owners.template}/{uid}`);
const $15fd4ed8634ba885$var$ownersCollectionGroup = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`owners`);
const $15fd4ed8634ba885$var$membersCollectionGroup = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`members`);
const $15fd4ed8634ba885$var$members = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$org.template}/members`);
const $15fd4ed8634ba885$var$member = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$members.template}/{uid}`);
const $15fd4ed8634ba885$var$groups = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$org.template}/groups`);
const $15fd4ed8634ba885$var$group = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$groups.template}/{groupId}`);
const $15fd4ed8634ba885$var$domainVerifications = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`domain_verifications`);
const $15fd4ed8634ba885$var$domainVerification = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$domainVerifications.template}/{orgId}`);
const $15fd4ed8634ba885$var$mailboxes = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$org.template}/mailboxes`);
const $15fd4ed8634ba885$var$mailbox = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$mailboxes.template}/{uid}`);
//use emailkey instead
const $15fd4ed8634ba885$var$inbox = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$mailbox.template}/inbox`);
const $15fd4ed8634ba885$var$inboundEmail = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$inbox.template}/{emailId}`);
const $15fd4ed8634ba885$var$outbox = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$mailbox.template}/outbox`);
const $15fd4ed8634ba885$var$outboundEmail = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$outbox.template}/{emailId}`);
const $15fd4ed8634ba885$var$drafts = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$mailbox.template}/drafts`);
const $15fd4ed8634ba885$var$draftEmail = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$drafts.template}/{emailId}`);
const $15fd4ed8634ba885$var$trash = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$mailbox.template}/trash`);
const $15fd4ed8634ba885$var$trashEmail = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$trash.template}/{emailId}`);
const $15fd4ed8634ba885$var$archive = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$mailbox.template}/archive`);
const $15fd4ed8634ba885$var$archiveEmail = new (0, $469bdf591fa0faa8$export$52c686705963a4fc)(`${$15fd4ed8634ba885$var$archive.template}/{emailId}`);
const $15fd4ed8634ba885$export$12a1c52a4bb19f32 = {
    userProfile: $15fd4ed8634ba885$var$userProfile,
    userProfiles: $15fd4ed8634ba885$var$userProfiles,
    org: $15fd4ed8634ba885$var$org,
    orgs: $15fd4ed8634ba885$var$orgs,
    owners: $15fd4ed8634ba885$var$owners,
    owner: $15fd4ed8634ba885$var$owner,
    members: $15fd4ed8634ba885$var$members,
    member: $15fd4ed8634ba885$var$member,
    groups: $15fd4ed8634ba885$var$groups,
    group: $15fd4ed8634ba885$var$group,
    domainVerifications: $15fd4ed8634ba885$var$domainVerifications,
    domainVerification: $15fd4ed8634ba885$var$domainVerification,
    mailboxes: $15fd4ed8634ba885$var$mailboxes,
    mailbox: $15fd4ed8634ba885$var$mailbox,
    drafts: $15fd4ed8634ba885$var$drafts,
    inbox: $15fd4ed8634ba885$var$inbox,
    outbox: $15fd4ed8634ba885$var$outbox,
    trash: $15fd4ed8634ba885$var$trash,
    ownersCollectionGroup: $15fd4ed8634ba885$var$ownersCollectionGroup,
    membersCollectionGroup: $15fd4ed8634ba885$var$membersCollectionGroup,
    inboundEmail: $15fd4ed8634ba885$var$inboundEmail,
    outboundEmail: $15fd4ed8634ba885$var$outboundEmail,
    archive: $15fd4ed8634ba885$var$archive,
    archiveEmail: $15fd4ed8634ba885$var$archiveEmail,
    draftEmail: $15fd4ed8634ba885$var$draftEmail,
    trashEmail: $15fd4ed8634ba885$var$trashEmail
};


/**
 * Google cloud storage folders.
 * This file cannot create a static path because each file uploaded will have a unique ID at the end,
 * this is done for the purpose of effective caching. Meaning no 2 files uploaded will have the same path.
 *
 * All folders like profile pictures are plural because each time the user uploads a picture a new one will be uploaded, and the old one will be left as is.
 */ const $0a8d0e62beb81aa5$var$userFolder = (args)=>{
    return `users/${args.uid}`;
};
const $0a8d0e62beb81aa5$var$orgsFolder = (args)=>{
    return `orgs/${args.orgId}`;
};
const $0a8d0e62beb81aa5$var$profilePictures = (args)=>{
    return `${$0a8d0e62beb81aa5$var$userFolder(args)}/profile_pictures`;
};
const $0a8d0e62beb81aa5$var$orgLogos = (args)=>{
    return `${$0a8d0e62beb81aa5$var$orgsFolder(args)}/logos`;
};
const $0a8d0e62beb81aa5$var$mailboxFolder = (args)=>{
    return `${$0a8d0e62beb81aa5$var$orgsFolder(args)}/mailboxes/${args.uid}`;
};
const $0a8d0e62beb81aa5$var$inboundFolder = (args)=>{
    return `${$0a8d0e62beb81aa5$var$mailboxFolder(args)}/inbound/${args.emailId}`;
};
const $0a8d0e62beb81aa5$var$inboundAttachmentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$inboundFolder(args)}/attachment/${args.attachmentId}`;
};
const $0a8d0e62beb81aa5$var$inboundInlineAttachmentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$inboundFolder(args)}/inline_attachment/${args.attachmentId}`;
};
const $0a8d0e62beb81aa5$var$inboundEmailTextContentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$inboundFolder(args)}/text_content.txt`;
};
const $0a8d0e62beb81aa5$var$inboundEmailHtmlContentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$inboundFolder(args)}/html_content.html`;
};
const $0a8d0e62beb81aa5$var$outboundFolder = (args)=>{
    return `${$0a8d0e62beb81aa5$var$mailboxFolder(args)}/outbound/${args.emailId}`;
};
const $0a8d0e62beb81aa5$var$outboundAttachmentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$outboundFolder(args)}/attachment/${args.attachmentId}`;
};
const $0a8d0e62beb81aa5$var$outboundInlineAttachmentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$outboundFolder(args)}/inline_attachment/${args.attachmentId}`;
};
const $0a8d0e62beb81aa5$var$outboundEmailTextContentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$outboundFolder(args)}/text_content.txt`;
};
const $0a8d0e62beb81aa5$var$outboundEmailHtmlContentPath = (args)=>{
    return `${$0a8d0e62beb81aa5$var$outboundFolder(args)}/html_content.html`;
};
const $0a8d0e62beb81aa5$export$f5c0819de731e325 = {
    profilePictures: $0a8d0e62beb81aa5$var$profilePictures,
    orgLogos: $0a8d0e62beb81aa5$var$orgLogos,
    mailboxFolder: $0a8d0e62beb81aa5$var$mailboxFolder,
    inboundFolder: $0a8d0e62beb81aa5$var$inboundFolder,
    outboundFolder: $0a8d0e62beb81aa5$var$outboundFolder,
    inboundAttachmentPath: $0a8d0e62beb81aa5$var$inboundAttachmentPath,
    inboundInlineAttachmentPath: $0a8d0e62beb81aa5$var$inboundInlineAttachmentPath,
    inboundEmailTextContentPath: $0a8d0e62beb81aa5$var$inboundEmailTextContentPath,
    inboundEmailHtmlContentPath: $0a8d0e62beb81aa5$var$inboundEmailHtmlContentPath,
    outboundAttachmentPath: $0a8d0e62beb81aa5$var$outboundAttachmentPath,
    outboundInlineAttachmentPath: $0a8d0e62beb81aa5$var$outboundInlineAttachmentPath,
    outboundEmailTextContentPath: $0a8d0e62beb81aa5$var$outboundEmailTextContentPath,
    outboundEmailHtmlContentPath: $0a8d0e62beb81aa5$var$outboundEmailHtmlContentPath
};


const $910976a52b10d76a$export$24588512e87d8b80 = (args)=>{
    return `gs://${args.bucket}/${args.path}`;
};


const $1daa848edc266398$var$swap = (array, ai, bi)=>{
    //
    const a = array[ai];
    const b = array[bi];
    // beforeA - all elements before a
    const beforeA = array.slice(0, ai);
    // afterB - all elements after b
    const afterB = array.slice(bi + 1);
    // compose new array, note a and b are swapped
    return [
        ...beforeA,
        b,
        a,
        ...afterB
    ];
};
const $1daa848edc266398$var$prev = (currentItem, array)=>{
    // get the index of the item
    const currentItemIndex = array.findIndex((item)=>item.id === currentItem.id);
    // cannot find current item in array
    if (currentItemIndex < 0) return;
    // check if it's the first, then return undef
    if (currentItemIndex <= 0) return;
    // get next item and return
    return array[currentItemIndex - 1];
};
const $1daa848edc266398$var$next = (currentItem, array)=>{
    // get the index of the item
    const currentItemIndex = array.findIndex((item)=>item.id === currentItem.id);
    // cannot find current item in array
    if (currentItemIndex < 0) return;
    // check if it's the last, then return undef
    if (currentItemIndex >= array.length - 1) return;
    // get next item and return
    return array[currentItemIndex + 1];
};
const $1daa848edc266398$var$moveUp = (array, i)=>{
    const min = 1;
    const max = array.length - 1;
    if (i < min || i > max) return array;
    // ai - index of element to be moved down
    const ai = i - 1;
    // bi - index of element to be moved up
    const bi = i;
    return $1daa848edc266398$var$swap(array, ai, bi);
};
const $1daa848edc266398$var$moveDown = (array, i)=>{
    //
    const min = 0;
    const max = array.length - 2;
    if (i < min || i > max) return array;
    // already last element
    if (i >= array.length - 1) return array;
    // ai - index of element to be moved down
    const ai = i;
    // bi - index of the element to be moved up
    const bi = i + 1;
    return $1daa848edc266398$var$swap(array, ai, bi);
};
const $1daa848edc266398$var$remove = (array, index)=>{
    return array.filter((_, i)=>i !== index);
};
const $1daa848edc266398$var$replace = (array, index, value)=>{
    return [
        ...array.slice(0, index),
        value,
        ...array.slice(index + 1)
    ];
};
const $1daa848edc266398$var$sortByNameFn = (a, b)=>{
    var nameA = a.name.toUpperCase(); // ignore upper and lowercase
    var nameB = b.name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    // names must be equal
    return 0;
};
const $1daa848edc266398$var$sortBySortOrderFn = (a, b)=>{
    if (a.sortOrder < b.sortOrder) return -1;
    if (a.sortOrder > b.sortOrder) return 1;
    // names must be equal
    return 0;
};
const $1daa848edc266398$var$sortByName = (list)=>{
    const shallowCopy = [
        ...list
    ];
    return shallowCopy.sort($1daa848edc266398$var$sortByNameFn);
};
const $1daa848edc266398$var$sortBySortOrder = (list)=>{
    const shallowCopy = [
        ...list
    ];
    return shallowCopy.sort($1daa848edc266398$var$sortBySortOrderFn);
};
const $1daa848edc266398$export$782c92add9db11ce = {
    prev: $1daa848edc266398$var$prev,
    next: $1daa848edc266398$var$next,
    moveUp: $1daa848edc266398$var$moveUp,
    moveDown: $1daa848edc266398$var$moveDown,
    replace: $1daa848edc266398$var$replace,
    remove: $1daa848edc266398$var$remove,
    sortByName: $1daa848edc266398$var$sortByName,
    sortBySortOrder: $1daa848edc266398$var$sortBySortOrder
};


const $5f93497ef0243768$export$97964dd01d43da22 = (template, values)=>{
    //
    const buildColonPrefixedTemplateLitrals = Object.keys(values).reduce((str, key)=>{
        const pattern = new RegExp(`:${key}\\b`, "g");
        return str.replace(pattern, values[key]);
    }, template);
    // first double, then single
    const buildDoubleHandlebarsTemplateLitrals = Object.keys(values).reduce((str, key)=>{
        const pattern = new RegExp(`\{\{${key}\}\}`, "g");
        return str.replace(pattern, values[key]);
    }, buildColonPrefixedTemplateLitrals);
    const buildSingleHandlebarsTemplateLitrals = Object.keys(values).reduce((str, key)=>{
        const pattern = new RegExp(`\{${key}\}`, "g");
        return str.replace(pattern, values[key]);
    }, buildDoubleHandlebarsTemplateLitrals);
    return buildSingleHandlebarsTemplateLitrals;
};


const $48db62750359aef4$export$6b17a39e52c8ee53 = (queryParams)=>{
    if (!queryParams || !Object.keys(queryParams).length) return ``;
    const qs = Object.keys(queryParams).map((key)=>encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&");
    if (qs) return `?${qs}`;
    return ``;
};



// utility to check a type
const $46735892604b37f3$export$630801d484da15df = (o)=>{
    if (o === null) return true;
    return false;
};
const $46735892604b37f3$export$fce6876652108ab = (o)=>{
    if (o === undefined) return true;
    return false;
};
const $46735892604b37f3$export$984f70f9382f5d27 = (o)=>{
    if ($46735892604b37f3$export$fce6876652108ab(o) || $46735892604b37f3$export$630801d484da15df(o)) return true;
    return false;
};
const $46735892604b37f3$export$4e62c701997796c1 = (o)=>{
    if ($46735892604b37f3$export$fce6876652108ab(o) || $46735892604b37f3$export$630801d484da15df(o)) return false;
    return true;
};
const $46735892604b37f3$export$844ec244b1367d54 = (o)=>{
    if ($46735892604b37f3$export$984f70f9382f5d27(o)) return false;
    if (typeof o === "string") return true;
    return false;
};
const $46735892604b37f3$export$7e4aa119212bc614 = (value)=>{
    if ($46735892604b37f3$export$984f70f9382f5d27(value)) return false;
    if (Number.isFinite(value)) return true;
    return false;
};
const $46735892604b37f3$export$871608497c498473 = (o)=>{
    if ($46735892604b37f3$export$984f70f9382f5d27(o)) return false;
    if (o instanceof Date) return true;
    return false;
};
const $46735892604b37f3$export$f9ce7b637dfbe238 = (o)=>{
    if ($46735892604b37f3$export$984f70f9382f5d27(o)) return false;
    if (typeof o === "boolean") return true;
    return false;
};
const $46735892604b37f3$export$43bee75e5e14138e = (o)=>{
    if ($46735892604b37f3$export$984f70f9382f5d27(o)) return false;
    if (o instanceof Array) return true;
    return false;
};
const $46735892604b37f3$export$a6cdc56e425d0d0a = (o)=>{
    if ($46735892604b37f3$export$984f70f9382f5d27(o)) return false;
    if (o instanceof Object) return true;
    return false;
};
const $46735892604b37f3$export$8304a22d431f958 = (o)=>{
    if (!$46735892604b37f3$export$844ec244b1367d54(o)) return false;
    try {
        const url = new URL(o);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (e) {
        return false;
    }
};
const $46735892604b37f3$export$dd1bc94b04021eeb = (o)=>{
    if ($46735892604b37f3$export$984f70f9382f5d27(o)) return true;
    if ($46735892604b37f3$export$844ec244b1367d54(o)) return o.length === 0;
    if ($46735892604b37f3$export$43bee75e5e14138e(o)) return o.length === 0;
    console.error(`Called isEmpty with invalid type: ${typeof o}`);
    return true;
};


const $dbd8b3c7b3311df5$export$e103312118435c5d = (o)=>{
    // undefined or null
    if (!o) return o;
    // if array
    if ((0, $46735892604b37f3$export$43bee75e5e14138e)(o)) // first remove all undefined items from the array
    // recursively remove the undefined fields from the items in the array
    return o.filter((item)=>!(0, $46735892604b37f3$export$fce6876652108ab)(item)).map((item)=>$dbd8b3c7b3311df5$export$e103312118435c5d(item));
    // if object
    if ((0, $46735892604b37f3$export$a6cdc56e425d0d0a)(o)) return Object.fromEntries(Object.entries(o).filter(([_, value])=>!(0, $46735892604b37f3$export$fce6876652108ab)(value)).map(([key, value])=>[
            key,
            $dbd8b3c7b3311df5$export$e103312118435c5d(value)
        ]));
    // everything else
    return o;
};



const $bfcff1203c83f49a$var$success = {
    isValid: true,
    errorMessage: "",
    errorPath: []
};
const $bfcff1203c83f49a$export$80f9043b76a4e68e = {
    success: $bfcff1203c83f49a$var$success
};


const $9c7530b84c2c3796$export$369305e45de1dcc3 = {
    type: "object",
    properties: {
        messageId: {
            type: "string"
        },
        envelopeFrom: {
            type: "string"
        },
        envelopeRecipients: {
            type: "array",
            items: {
                type: "string"
            },
            minItems: 1
        }
    }
};


const $67bfddb4a12069c9$export$a8ffc15e1205507f = {
    type: "object",
    properties: {
        uid: {
            type: "string"
        },
        emailAddress: {
            type: "string"
        },
        orgId: {
            type: "string"
        },
        createdByUid: {
            type: "string"
        },
        createdIsoDateTimeUtc: {
            type: "string"
        },
        updatedIsoDateTimeUtc: {
            type: "string"
        },
        secondaryEmailAddress: {
            type: "string",
            optional: true
        },
        role: {
            type: "string"
        },
        randomPassword: {
            type: "string",
            optional: true
        },
        shouldUpdatePasswordOnLogin: {
            type: "boolean",
            optional: true
        },
        firstName: {
            type: "string"
        },
        lastName: {
            type: "string"
        },
        profilePicture: {
            type: "object",
            optional: true,
            properties: {
                id: {
                    type: "string"
                },
                path: {
                    type: "string"
                }
            }
        },
        aliasEmailAddresses: {
            type: "array",
            optional: true,
            items: {
                type: "string"
            }
        }
    }
};


const $61791b6c9f938427$export$171fdc407faccde7 = {
    type: "object",
    properties: {
        id: {
            type: "string"
        },
        groupEmailAddress: {
            type: "string"
        },
        orgId: {
            type: "string"
        },
        name: {
            type: "string"
        },
        memberUids: {
            type: "array",
            items: {
                type: "string"
            }
        }
    }
};


const $c473cdae678f7c00$export$ae4822084bb9e609 = {
    type: "object",
    properties: {
        id: {
            type: "string"
        },
        createdIsoDateTimeUtc: {
            type: "string"
        },
        updatedIsoDateTimeUtc: {
            type: "string"
        },
        name: {
            type: "string"
        },
        logo: {
            type: "object",
            optional: true,
            properties: {
                id: {
                    type: "string"
                },
                path: {
                    type: "string"
                }
            }
        },
        createdByUid: {
            type: "string"
        },
        domain: {
            type: "string"
        }
    }
};


const $c0b2a01fc8f61858$export$dda6b102f6bbd050 = {
    type: "object",
    properties: {
        uid: {
            type: "string"
        },
        emailAddress: {
            type: "string"
        },
        orgId: {
            type: "string"
        }
    }
};


const $f0e76c3b7982e37b$export$431af31f62f152ec = {
    type: "object",
    properties: {
        uid: {
            type: "string"
        },
        firstName: {
            type: "string"
        },
        lastName: {
            type: "string"
        },
        profilePicture: {
            type: "object",
            optional: true,
            properties: {
                id: {
                    type: "string"
                },
                path: {
                    type: "string"
                }
            }
        }
    }
};


const $12001c6939bd57e2$export$34a561d5510dc8e0 = (email)=>{
    if (!email.includes("@")) throw new Error("Invalid email");
    return email.split("@").pop();
};




const $a6175bcab159d914$export$f414740c43e73eea = (aspectRatio)=>{
    if (!aspectRatio) return "";
    const imageAspectRatio = Object.values((0, $cc46bd24544f6a52$export$e68cf46c92b3705c)).find((ar)=>ar.id === aspectRatio) || (0, $cc46bd24544f6a52$export$6aeb29f472fa5ded).square;
    const aspectRatioClassName = `ar-${imageAspectRatio.width}-${imageAspectRatio.height}`;
    // replace all dot to dash to prevent css compile error
    return aspectRatioClassName.replace(/[.]/g, "-");
};



const $22fc247a044a5f09$var$devConfig = {
    env: (0, $18313decae4d52e6$export$6c0517834721cef7).dev,
    apiKey: "AIzaSyAGhKS9OnLFWrUtKsi7saW0CtxNJ_737E8",
    authDomain: "zickko-dev.firebaseapp.com",
    projectId: "zickko-dev",
    storageBucket: (0, $df4900d452dcf46f$export$2cb4986bed338027).devConfig.defaultBucket,
    // storageBucket: "zickko-dev.firebasestorage.app",
    messagingSenderId: "958163738560",
    appId: "1:958163738560:web:2c50bb8fe9ed824e59b225",
    measurementId: "G-BFSD3KWEPX",
    gcsBaseUrl: "https://storage.googleapis.com",
    isCypress: false,
    imageServer: "./images",
    algolia: {
        appId: "",
        searchOnlyApiKey: "",
        talentProfileIndex: "talent_profile_index"
    },
    inboundEmailBucket: (0, $df4900d452dcf46f$export$2cb4986bed338027).devConfig.inboundEmailBucket,
    outboundEmailBucket: (0, $df4900d452dcf46f$export$2cb4986bed338027).devConfig.outboundEmailBucket
};
const $22fc247a044a5f09$var$stagingConfig = {
    env: (0, $18313decae4d52e6$export$6c0517834721cef7).staging,
    apiKey: "AIzaSyA_KadVcDd1Be6qwNUi4nNjdjMe8SKlaZA",
    authDomain: "zickko-staging.firebaseapp.com",
    projectId: "zickko-staging",
    storageBucket: (0, $df4900d452dcf46f$export$2cb4986bed338027).stagingConfig.defaultBucket,
    // storageBucket: "zickko-staging.firebasestorage.app",
    messagingSenderId: "325231543259",
    appId: "1:325231543259:web:83c3a35f75b37ad7be1dfe",
    measurementId: "G-RPHD3GS33L",
    gcsBaseUrl: "https://storage.googleapis.com",
    isCypress: false,
    imageServer: "./images",
    algolia: {
        appId: "",
        searchOnlyApiKey: "",
        talentProfileIndex: "talent_profile_index"
    },
    inboundEmailBucket: (0, $df4900d452dcf46f$export$2cb4986bed338027).stagingConfig.inboundEmailBucket,
    outboundEmailBucket: (0, $df4900d452dcf46f$export$2cb4986bed338027).stagingConfig.outboundEmailBucket
};
// using staging config for local now
const $22fc247a044a5f09$var$localConfig = {
    ...$22fc247a044a5f09$var$stagingConfig,
    env: (0, $18313decae4d52e6$export$6c0517834721cef7).local,
    storageBucket: $22fc247a044a5f09$var$stagingConfig.storageBucket,
    inboundEmailBucket: $22fc247a044a5f09$var$stagingConfig.inboundEmailBucket,
    outboundEmailBucket: $22fc247a044a5f09$var$stagingConfig.outboundEmailBucket,
    gcsBaseUrl: "http://localhost:9199",
    imageServer: "http://localhost:5002/images",
    algolia: {
        appId: "NI9RBWZF0I",
        searchOnlyApiKey: "18e823ac7924bce7dfab943052a3df05",
        talentProfileIndex: "talent_profile_index"
    }
};
// using staging config for production now
// const productionConfig: ClientConfig = {
//   ...stagingConfig,
//   env: Env.local,
// };
const $22fc247a044a5f09$var$hostname = window.location.hostname;
const $22fc247a044a5f09$var$PRODUCTION_HOSTNAMES = [
    "staging.zickko.com"
];
const $22fc247a044a5f09$var$isStaging = $22fc247a044a5f09$var$PRODUCTION_HOSTNAMES.includes($22fc247a044a5f09$var$hostname) ? true : false;
const $22fc247a044a5f09$var$isLocal = $22fc247a044a5f09$var$hostname.includes("localhost") || $22fc247a044a5f09$var$hostname.includes("127.0.0.1") || $22fc247a044a5f09$var$hostname.endsWith(".local") ? true : false;
const $22fc247a044a5f09$var$isDev = $22fc247a044a5f09$var$hostname.includes("dev-admin-portal") ? true : false;
const $22fc247a044a5f09$export$26cc430c2fed42ce = function() {
    if ($22fc247a044a5f09$var$isDev) {
        console.log(`*** Dev Mode ***`);
        return $22fc247a044a5f09$var$devConfig;
    }
    if ($22fc247a044a5f09$var$isLocal) {
        console.log(`*** LOCAL Mode ***`);
        return $22fc247a044a5f09$var$localConfig;
    }
    // if (isProduction) {
    //   console.log(`*** Production Mode ***`);
    //   return productionConfig;
    // }
    if ($22fc247a044a5f09$var$isStaging) {
        console.log(`*** STAGING Mode ***`);
        return $22fc247a044a5f09$var$stagingConfig;
    }
    console.log(`*** Default to STAGING Mode hcdftuyhkigiufytrsdiky ***`);
    return $22fc247a044a5f09$var$stagingConfig;
}();


const $b25092e0a94848be$export$492f76f65bf1bced = (image)=>{
    const suffix = `${image.path}`;
    return `${(0, $22fc247a044a5f09$export$26cc430c2fed42ce).imageServer}/${suffix}`;
};


const $8c83b7f2659cbbfc$var$LOW_RESOLUTION_IMAGE_WIDTH = 100;
const $8c83b7f2659cbbfc$export$13dff1a79c6f1d5c = (props)=>{
    //
    // const browser = useBrowser();
    const [width, setWidth] = (0, $lldlC.useState)($8c83b7f2659cbbfc$var$LOW_RESOLUTION_IMAGE_WIDTH);
    const imgRef = (0, $lldlC.useRef)(null);
    // if (!browser && !process.env.JEST_WORKER_ID) return null;
    const onLoad = ()=>{
        const element = imgRef.current;
        if (!element) return null;
        // the rendered width is less than the current width, so no need to load a fresh image
        if (element.width <= width) return null;
        // rendered width is greater than the loaded image's width, so load a bigger one
        if (width !== $8c83b7f2659cbbfc$var$LOW_RESOLUTION_IMAGE_WIDTH) return null;
        // ceil to the next 100 so that we load images only of set dimensions like 200px, 300px etc,
        // this will help greatly in reducing the number of images that are cached
        setWidth(Math.ceil(element.width / 100) * 100);
    };
    const onError = ()=>console.log(`Error loading image ${props}`);
    const { image: image, aspectRatio: aspectRatio } = props;
    if (!image) return null;
    const src = `${(0, $b25092e0a94848be$export$492f76f65bf1bced)(image)}?fit=cover&width=${width}&aspectRatio=${props.aspectRatio}`;
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "image imgix",
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
            className: (0, $a6175bcab159d914$export$f414740c43e73eea)(aspectRatio),
            src: src,
            srcSet: `${src} 1x, ${src}&dpr=2 2x, ${src}&dpr=3 3x`,
            onLoad: onLoad,
            onError: onError,
            ref: imgRef,
            onClick: (e)=>{
                e.preventDefault();
                if (props.onClick) props.onClick();
            }
        })
    });
};





var $lldlC = parcelRequire("lldlC");

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


const $59fdd18afb377ad5$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $59fdd18afb377ad5$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $59fdd18afb377ad5$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $59fdd18afb377ad5$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $59fdd18afb377ad5$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $59fdd18afb377ad5$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $59fdd18afb377ad5$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $59fdd18afb377ad5$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($59fdd18afb377ad5$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $59fdd18afb377ad5$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $59fdd18afb377ad5$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $59fdd18afb377ad5$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $59fdd18afb377ad5$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $59fdd18afb377ad5$var$stringToByteArray$1(str);
    return $59fdd18afb377ad5$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $59fdd18afb377ad5$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $59fdd18afb377ad5$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $59fdd18afb377ad5$export$c62426fdd000a97e = function(str) {
    try {
        return $59fdd18afb377ad5$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $59fdd18afb377ad5$export$6c40052bed430212(value) {
    return $59fdd18afb377ad5$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $59fdd18afb377ad5$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$59fdd18afb377ad5$var$isValidKey(prop)) continue;
        target[prop] = $59fdd18afb377ad5$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $59fdd18afb377ad5$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $59fdd18afb377ad5$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $59fdd18afb377ad5$var$getDefaultsFromGlobal = ()=>$59fdd18afb377ad5$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $59fdd18afb377ad5$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $371a3837fd81d701$exports === 'undefined' || typeof $371a3837fd81d701$exports.env === 'undefined') return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $59fdd18afb377ad5$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $59fdd18afb377ad5$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $59fdd18afb377ad5$export$212bb2fc580a90a8 = ()=>{
    try {
        return $59fdd18afb377ad5$var$getDefaultsFromGlobal() || $59fdd18afb377ad5$var$getDefaultsFromEnvVariable() || $59fdd18afb377ad5$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $59fdd18afb377ad5$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $59fdd18afb377ad5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $59fdd18afb377ad5$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $59fdd18afb377ad5$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $59fdd18afb377ad5$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $59fdd18afb377ad5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $59fdd18afb377ad5$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $59fdd18afb377ad5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $59fdd18afb377ad5$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fdd18afb377ad5$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $59fdd18afb377ad5$export$4b5284a3025a455(JSON.stringify(header)),
        $59fdd18afb377ad5$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $59fdd18afb377ad5$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $59fdd18afb377ad5$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($59fdd18afb377ad5$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $59fdd18afb377ad5$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $59fdd18afb377ad5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $59fdd18afb377ad5$export$4e09c449d6c407f7() {
    return typeof self === 'object' && self.self === self;
}
function $59fdd18afb377ad5$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $59fdd18afb377ad5$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $59fdd18afb377ad5$export$f2f6a8999f8ebd30() {
    return $59fdd18afb377ad5$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $59fdd18afb377ad5$export$7e7b1a9668aaed8() {
    const ua = $59fdd18afb377ad5$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $59fdd18afb377ad5$export$202944b2d2824246() {
    return $59fdd18afb377ad5$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $59fdd18afb377ad5$export$5d1d834fbbf8bab7() {
    return $59fdd18afb377ad5$export$588c7fdda06fbb0a.NODE_CLIENT === true || $59fdd18afb377ad5$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $59fdd18afb377ad5$export$95df08bae54cb4df() {
    return !$59fdd18afb377ad5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $59fdd18afb377ad5$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $59fdd18afb377ad5$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $59fdd18afb377ad5$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $59fdd18afb377ad5$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $59fdd18afb377ad5$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $59fdd18afb377ad5$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $59fdd18afb377ad5$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $59fdd18afb377ad5$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $59fdd18afb377ad5$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $59fdd18afb377ad5$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $59fdd18afb377ad5$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $59fdd18afb377ad5$var$replaceTemplate(template, data) {
    return template.replace($59fdd18afb377ad5$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $59fdd18afb377ad5$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $59fdd18afb377ad5$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $59fdd18afb377ad5$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $59fdd18afb377ad5$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $59fdd18afb377ad5$export$c5a53ce6a17cf18d($59fdd18afb377ad5$export$c62426fdd000a97e(parts[0]) || '');
        claims = $59fdd18afb377ad5$export$c5a53ce6a17cf18d($59fdd18afb377ad5$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $59fdd18afb377ad5$export$5f870fcca7ae6a88 = function(token) {
    const claims = $59fdd18afb377ad5$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $59fdd18afb377ad5$export$701c661ec91095f2 = function(token) {
    const claims = $59fdd18afb377ad5$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $59fdd18afb377ad5$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $59fdd18afb377ad5$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $59fdd18afb377ad5$export$fc970ed23da99565 = function(token) {
    const claims = $59fdd18afb377ad5$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fdd18afb377ad5$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $59fdd18afb377ad5$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $59fdd18afb377ad5$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $59fdd18afb377ad5$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $59fdd18afb377ad5$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($59fdd18afb377ad5$var$isObject(aProp) && $59fdd18afb377ad5$var$isObject(bProp)) {
            if (!$59fdd18afb377ad5$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $59fdd18afb377ad5$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $59fdd18afb377ad5$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $59fdd18afb377ad5$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $59fdd18afb377ad5$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $59fdd18afb377ad5$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $59fdd18afb377ad5$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $59fdd18afb377ad5$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $59fdd18afb377ad5$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $59fdd18afb377ad5$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $59fdd18afb377ad5$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($59fdd18afb377ad5$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $59fdd18afb377ad5$var$noop;
        if (observer.error === undefined) observer.error = $59fdd18afb377ad5$var$noop;
        if (observer.complete === undefined) observer.complete = $59fdd18afb377ad5$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $59fdd18afb377ad5$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $59fdd18afb377ad5$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $59fdd18afb377ad5$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $59fdd18afb377ad5$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $59fdd18afb377ad5$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $59fdd18afb377ad5$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($59fdd18afb377ad5$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $59fdd18afb377ad5$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($59fdd18afb377ad5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $59fdd18afb377ad5$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($59fdd18afb377ad5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $59fdd18afb377ad5$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $59fdd18afb377ad5$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $59fdd18afb377ad5$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $59fdd18afb377ad5$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $59fdd18afb377ad5$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $59fdd18afb377ad5$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $59fdd18afb377ad5$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $59fdd18afb377ad5$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $59fdd18afb377ad5$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $59fdd18afb377ad5$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $59fdd18afb377ad5$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $59fdd18afb377ad5$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($59fdd18afb377ad5$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $59fdd18afb377ad5$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $59fdd18afb377ad5$var$indicator(i);
}
function $59fdd18afb377ad5$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fdd18afb377ad5$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $35aa09327d546cd1$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $35aa09327d546cd1$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $59fdd18afb377ad5$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($35aa09327d546cd1$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $35aa09327d546cd1$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $35aa09327d546cd1$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $35aa09327d546cd1$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $35aa09327d546cd1$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $35aa09327d546cd1$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $35aa09327d546cd1$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $b3ab7ef8f3a0a29a$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $b3ab7ef8f3a0a29a$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($b3ab7ef8f3a0a29a$export$243e62d78d3b544d || ($b3ab7ef8f3a0a29a$export$243e62d78d3b544d = {}));
const $b3ab7ef8f3a0a29a$var$levelStringToEnum = {
    'debug': $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.DEBUG,
    'verbose': $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.VERBOSE,
    'info': $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.INFO,
    'warn': $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.WARN,
    'error': $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.ERROR,
    'silent': $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $b3ab7ef8f3a0a29a$var$defaultLogLevel = $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $b3ab7ef8f3a0a29a$var$ConsoleMethod = {
    [$b3ab7ef8f3a0a29a$export$243e62d78d3b544d.DEBUG]: 'log',
    [$b3ab7ef8f3a0a29a$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$b3ab7ef8f3a0a29a$export$243e62d78d3b544d.INFO]: 'info',
    [$b3ab7ef8f3a0a29a$export$243e62d78d3b544d.WARN]: 'warn',
    [$b3ab7ef8f3a0a29a$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $b3ab7ef8f3a0a29a$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $b3ab7ef8f3a0a29a$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $b3ab7ef8f3a0a29a$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $b3ab7ef8f3a0a29a$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $b3ab7ef8f3a0a29a$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $b3ab7ef8f3a0a29a$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $b3ab7ef8f3a0a29a$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $b3ab7ef8f3a0a29a$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $b3ab7ef8f3a0a29a$export$c622e99c0ce7b1c9(level) {
    $b3ab7ef8f3a0a29a$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $b3ab7ef8f3a0a29a$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $b3ab7ef8f3a0a29a$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $b3ab7ef8f3a0a29a$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $b3ab7ef8f3a0a29a$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $a6c43262c30cd8d1$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $a6c43262c30cd8d1$var$idbProxyableTypes;
let $a6c43262c30cd8d1$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $a6c43262c30cd8d1$var$getIdbProxyableTypes() {
    return $a6c43262c30cd8d1$var$idbProxyableTypes || ($a6c43262c30cd8d1$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $a6c43262c30cd8d1$var$getCursorAdvanceMethods() {
    return $a6c43262c30cd8d1$var$cursorAdvanceMethods || ($a6c43262c30cd8d1$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $a6c43262c30cd8d1$var$cursorRequestMap = new WeakMap();
const $a6c43262c30cd8d1$var$transactionDoneMap = new WeakMap();
const $a6c43262c30cd8d1$var$transactionStoreNamesMap = new WeakMap();
const $a6c43262c30cd8d1$var$transformCache = new WeakMap();
const $a6c43262c30cd8d1$export$407448d2b89b1813 = new WeakMap();
function $a6c43262c30cd8d1$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($a6c43262c30cd8d1$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $a6c43262c30cd8d1$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $a6c43262c30cd8d1$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $a6c43262c30cd8d1$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($a6c43262c30cd8d1$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $a6c43262c30cd8d1$var$transactionDoneMap.set(tx, done);
}
let $a6c43262c30cd8d1$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $a6c43262c30cd8d1$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $a6c43262c30cd8d1$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $a6c43262c30cd8d1$export$43caf9889c228507(callback) {
    $a6c43262c30cd8d1$var$idbProxyTraps = callback($a6c43262c30cd8d1$var$idbProxyTraps);
}
function $a6c43262c30cd8d1$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($a6c43262c30cd8d1$export$3b14a55fb2447963(this), storeNames, ...args);
        $a6c43262c30cd8d1$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($a6c43262c30cd8d1$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($a6c43262c30cd8d1$export$3b14a55fb2447963(this), args);
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b($a6c43262c30cd8d1$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b(func.apply($a6c43262c30cd8d1$export$3b14a55fb2447963(this), args));
    };
}
function $a6c43262c30cd8d1$var$transformCachableValue(value) {
    if (typeof value === 'function') return $a6c43262c30cd8d1$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $a6c43262c30cd8d1$var$cacheDonePromiseForTransaction(value);
    if ($a6c43262c30cd8d1$export$23f2a1d2818174ef(value, $a6c43262c30cd8d1$var$getIdbProxyableTypes())) return new Proxy(value, $a6c43262c30cd8d1$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $a6c43262c30cd8d1$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $a6c43262c30cd8d1$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($a6c43262c30cd8d1$var$transformCache.has(value)) return $a6c43262c30cd8d1$var$transformCache.get(value);
    const newValue = $a6c43262c30cd8d1$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $a6c43262c30cd8d1$var$transformCache.set(value, newValue);
        $a6c43262c30cd8d1$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $a6c43262c30cd8d1$export$3b14a55fb2447963 = (value)=>$a6c43262c30cd8d1$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $dcd2f819ff509019$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $dcd2f819ff509019$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $dcd2f819ff509019$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $dcd2f819ff509019$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $dcd2f819ff509019$var$cachedMethods = new Map();
function $dcd2f819ff509019$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($dcd2f819ff509019$var$cachedMethods.get(prop)) return $dcd2f819ff509019$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $dcd2f819ff509019$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $dcd2f819ff509019$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $dcd2f819ff509019$var$cachedMethods.set(prop, method);
    return method;
}
(0, $a6c43262c30cd8d1$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$dcd2f819ff509019$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$dcd2f819ff509019$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $6de42d4eacc8610d$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($6de42d4eacc8610d$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $6de42d4eacc8610d$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $6de42d4eacc8610d$var$name$p = "@firebase/app";
const $6de42d4eacc8610d$var$version$1 = "0.10.3";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6de42d4eacc8610d$var$logger = new (0, $b3ab7ef8f3a0a29a$export$efa9a398d6368992)('@firebase/app');
const $6de42d4eacc8610d$var$name$o = "@firebase/app-compat";
const $6de42d4eacc8610d$var$name$n = "@firebase/analytics-compat";
const $6de42d4eacc8610d$var$name$m = "@firebase/analytics";
const $6de42d4eacc8610d$var$name$l = "@firebase/app-check-compat";
const $6de42d4eacc8610d$var$name$k = "@firebase/app-check";
const $6de42d4eacc8610d$var$name$j = "@firebase/auth";
const $6de42d4eacc8610d$var$name$i = "@firebase/auth-compat";
const $6de42d4eacc8610d$var$name$h = "@firebase/database";
const $6de42d4eacc8610d$var$name$g = "@firebase/database-compat";
const $6de42d4eacc8610d$var$name$f = "@firebase/functions";
const $6de42d4eacc8610d$var$name$e = "@firebase/functions-compat";
const $6de42d4eacc8610d$var$name$d = "@firebase/installations";
const $6de42d4eacc8610d$var$name$c = "@firebase/installations-compat";
const $6de42d4eacc8610d$var$name$b = "@firebase/messaging";
const $6de42d4eacc8610d$var$name$a = "@firebase/messaging-compat";
const $6de42d4eacc8610d$var$name$9 = "@firebase/performance";
const $6de42d4eacc8610d$var$name$8 = "@firebase/performance-compat";
const $6de42d4eacc8610d$var$name$7 = "@firebase/remote-config";
const $6de42d4eacc8610d$var$name$6 = "@firebase/remote-config-compat";
const $6de42d4eacc8610d$var$name$5 = "@firebase/storage";
const $6de42d4eacc8610d$var$name$4 = "@firebase/storage-compat";
const $6de42d4eacc8610d$var$name$3 = "@firebase/firestore";
const $6de42d4eacc8610d$var$name$2 = "@firebase/vertexai-preview";
const $6de42d4eacc8610d$var$name$1 = "@firebase/firestore-compat";
const $6de42d4eacc8610d$var$name = "firebase";
const $6de42d4eacc8610d$var$version = "10.12.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $6de42d4eacc8610d$export$9f30fa0c10967f7f = '[DEFAULT]';
const $6de42d4eacc8610d$var$PLATFORM_LOG_STRING = {
    [$6de42d4eacc8610d$var$name$p]: 'fire-core',
    [$6de42d4eacc8610d$var$name$o]: 'fire-core-compat',
    [$6de42d4eacc8610d$var$name$m]: 'fire-analytics',
    [$6de42d4eacc8610d$var$name$n]: 'fire-analytics-compat',
    [$6de42d4eacc8610d$var$name$k]: 'fire-app-check',
    [$6de42d4eacc8610d$var$name$l]: 'fire-app-check-compat',
    [$6de42d4eacc8610d$var$name$j]: 'fire-auth',
    [$6de42d4eacc8610d$var$name$i]: 'fire-auth-compat',
    [$6de42d4eacc8610d$var$name$h]: 'fire-rtdb',
    [$6de42d4eacc8610d$var$name$g]: 'fire-rtdb-compat',
    [$6de42d4eacc8610d$var$name$f]: 'fire-fn',
    [$6de42d4eacc8610d$var$name$e]: 'fire-fn-compat',
    [$6de42d4eacc8610d$var$name$d]: 'fire-iid',
    [$6de42d4eacc8610d$var$name$c]: 'fire-iid-compat',
    [$6de42d4eacc8610d$var$name$b]: 'fire-fcm',
    [$6de42d4eacc8610d$var$name$a]: 'fire-fcm-compat',
    [$6de42d4eacc8610d$var$name$9]: 'fire-perf',
    [$6de42d4eacc8610d$var$name$8]: 'fire-perf-compat',
    [$6de42d4eacc8610d$var$name$7]: 'fire-rc',
    [$6de42d4eacc8610d$var$name$6]: 'fire-rc-compat',
    [$6de42d4eacc8610d$var$name$5]: 'fire-gcs',
    [$6de42d4eacc8610d$var$name$4]: 'fire-gcs-compat',
    [$6de42d4eacc8610d$var$name$3]: 'fire-fst',
    [$6de42d4eacc8610d$var$name$1]: 'fire-fst-compat',
    [$6de42d4eacc8610d$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$6de42d4eacc8610d$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $6de42d4eacc8610d$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $6de42d4eacc8610d$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6de42d4eacc8610d$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $6de42d4eacc8610d$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $6de42d4eacc8610d$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $6de42d4eacc8610d$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $6de42d4eacc8610d$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($6de42d4eacc8610d$export$9566bce3835c0f28.has(componentName)) {
        $6de42d4eacc8610d$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $6de42d4eacc8610d$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $6de42d4eacc8610d$export$b4e3c36c855b14b5.values())$6de42d4eacc8610d$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $6de42d4eacc8610d$export$fb03ad8d3d5c5f76.values())$6de42d4eacc8610d$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $6de42d4eacc8610d$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $6de42d4eacc8610d$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $6de42d4eacc8610d$export$9f30fa0c10967f7f) {
    $6de42d4eacc8610d$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $6de42d4eacc8610d$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $6de42d4eacc8610d$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $6de42d4eacc8610d$export$3685d89b9c3cdfaf() {
    $6de42d4eacc8610d$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6de42d4eacc8610d$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $6de42d4eacc8610d$var$ERROR_FACTORY = new (0, $59fdd18afb377ad5$export$3fa6e1b18a3b2d40)('app', 'Firebase', $6de42d4eacc8610d$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $6de42d4eacc8610d$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $6de42d4eacc8610d$var$FirebaseServerAppImpl extends $6de42d4eacc8610d$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegisry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $6de42d4eacc8610d$export$d29d5299a7137abc($6de42d4eacc8610d$var$name$p, $6de42d4eacc8610d$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $6de42d4eacc8610d$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $6de42d4eacc8610d$export$31499a9cd224b78c = $6de42d4eacc8610d$var$version;
function $6de42d4eacc8610d$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $6de42d4eacc8610d$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $59fdd18afb377ad5$export$3dfb6827a9f89756)());
    if (!options) throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $6de42d4eacc8610d$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $35aa09327d546cd1$export$436a80eea5d5c0c5)(name);
    for (const component of $6de42d4eacc8610d$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $6de42d4eacc8610d$var$FirebaseAppImpl(options, config, container);
    $6de42d4eacc8610d$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $6de42d4eacc8610d$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $59fdd18afb377ad5$export$4e09c449d6c407f7)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($6de42d4eacc8610d$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $6de42d4eacc8610d$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $35aa09327d546cd1$export$436a80eea5d5c0c5)(nameString);
    for (const component of $6de42d4eacc8610d$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $6de42d4eacc8610d$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $6de42d4eacc8610d$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $6de42d4eacc8610d$export$f9962582c9e66d99(name = $6de42d4eacc8610d$export$9f30fa0c10967f7f) {
    const app = $6de42d4eacc8610d$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $6de42d4eacc8610d$export$9f30fa0c10967f7f && (0, $59fdd18afb377ad5$export$3dfb6827a9f89756)()) return $6de42d4eacc8610d$export$c55cfd413944906d();
    if (!app) throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $6de42d4eacc8610d$export$68ddedf7d44b3bdf() {
    return Array.from($6de42d4eacc8610d$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $6de42d4eacc8610d$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($6de42d4eacc8610d$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $6de42d4eacc8610d$export$b4e3c36c855b14b5.delete(name);
    } else if ($6de42d4eacc8610d$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $6de42d4eacc8610d$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $6de42d4eacc8610d$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $6de42d4eacc8610d$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $6de42d4eacc8610d$var$logger.warn(warning.join(' '));
        return;
    }
    $6de42d4eacc8610d$export$c930050e7bb63965(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $6de42d4eacc8610d$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $b3ab7ef8f3a0a29a$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $6de42d4eacc8610d$export$c622e99c0ce7b1c9(logLevel) {
    (0, $b3ab7ef8f3a0a29a$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6de42d4eacc8610d$var$DB_NAME = 'firebase-heartbeat-database';
const $6de42d4eacc8610d$var$DB_VERSION = 1;
const $6de42d4eacc8610d$var$STORE_NAME = 'firebase-heartbeat-store';
let $6de42d4eacc8610d$var$dbPromise = null;
function $6de42d4eacc8610d$var$getDbPromise() {
    if (!$6de42d4eacc8610d$var$dbPromise) $6de42d4eacc8610d$var$dbPromise = (0, $dcd2f819ff509019$export$ca0ed41b1a2af7e)($6de42d4eacc8610d$var$DB_NAME, $6de42d4eacc8610d$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($6de42d4eacc8610d$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $6de42d4eacc8610d$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $6de42d4eacc8610d$var$dbPromise;
}
async function $6de42d4eacc8610d$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $6de42d4eacc8610d$var$getDbPromise();
        const tx = db.transaction($6de42d4eacc8610d$var$STORE_NAME);
        const result = await tx.objectStore($6de42d4eacc8610d$var$STORE_NAME).get($6de42d4eacc8610d$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $59fdd18afb377ad5$export$dd24e9cd51226c56)) $6de42d4eacc8610d$var$logger.warn(e.message);
        else {
            const idbGetError = $6de42d4eacc8610d$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $6de42d4eacc8610d$var$logger.warn(idbGetError.message);
        }
    }
}
async function $6de42d4eacc8610d$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $6de42d4eacc8610d$var$getDbPromise();
        const tx = db.transaction($6de42d4eacc8610d$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($6de42d4eacc8610d$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $6de42d4eacc8610d$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $59fdd18afb377ad5$export$dd24e9cd51226c56)) $6de42d4eacc8610d$var$logger.warn(e.message);
        else {
            const idbGetError = $6de42d4eacc8610d$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $6de42d4eacc8610d$var$logger.warn(idbGetError.message);
        }
    }
}
function $6de42d4eacc8610d$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6de42d4eacc8610d$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $6de42d4eacc8610d$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $6de42d4eacc8610d$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $6de42d4eacc8610d$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container.getProvider('platform-logger').getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $6de42d4eacc8610d$var$getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $6de42d4eacc8610d$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
        const date = $6de42d4eacc8610d$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $6de42d4eacc8610d$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $59fdd18afb377ad5$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $6de42d4eacc8610d$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $6de42d4eacc8610d$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $6de42d4eacc8610d$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($6de42d4eacc8610d$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($6de42d4eacc8610d$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $6de42d4eacc8610d$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $59fdd18afb377ad5$export$3865db50535c2055)()) return false;
        else return (0, $59fdd18afb377ad5$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $6de42d4eacc8610d$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $6de42d4eacc8610d$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $6de42d4eacc8610d$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $6de42d4eacc8610d$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $59fdd18afb377ad5$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6de42d4eacc8610d$var$registerCoreComponents(variant) {
    $6de42d4eacc8610d$export$c930050e7bb63965(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)('platform-logger', (container)=>new $6de42d4eacc8610d$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $6de42d4eacc8610d$export$c930050e7bb63965(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)('heartbeat', (container)=>new $6de42d4eacc8610d$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $6de42d4eacc8610d$export$d29d5299a7137abc($6de42d4eacc8610d$var$name$p, $6de42d4eacc8610d$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $6de42d4eacc8610d$export$d29d5299a7137abc($6de42d4eacc8610d$var$name$p, $6de42d4eacc8610d$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $6de42d4eacc8610d$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $6de42d4eacc8610d$var$registerCoreComponents('');




/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $3fab5dd6ec5d4e72$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $3fab5dd6ec5d4e72$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $3fab5dd6ec5d4e72$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $3fab5dd6ec5d4e72$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $3fab5dd6ec5d4e72$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $3fab5dd6ec5d4e72$export$697502632950e9d3 extends (0, $59fdd18afb377ad5$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($3fab5dd6ec5d4e72$var$prependCode(code), `Firebase Storage: ${message} (${$3fab5dd6ec5d4e72$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $3fab5dd6ec5d4e72$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $3fab5dd6ec5d4e72$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $3fab5dd6ec5d4e72$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($3fab5dd6ec5d4e72$export$54592d666d6ce114 || ($3fab5dd6ec5d4e72$export$54592d666d6ce114 = {}));
function $3fab5dd6ec5d4e72$var$prependCode(code) {
    return 'storage/' + code;
}
function $3fab5dd6ec5d4e72$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.UNKNOWN, message);
}
function $3fab5dd6ec5d4e72$var$objectNotFound(path) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $3fab5dd6ec5d4e72$var$quotaExceeded(bucket) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $3fab5dd6ec5d4e72$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $3fab5dd6ec5d4e72$var$unauthorizedApp() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $3fab5dd6ec5d4e72$var$unauthorized(path) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $3fab5dd6ec5d4e72$var$retryLimitExceeded() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $3fab5dd6ec5d4e72$var$canceled() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $3fab5dd6ec5d4e72$var$invalidUrl(url) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $3fab5dd6ec5d4e72$var$invalidDefaultBucket(bucket) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $3fab5dd6ec5d4e72$var$noDefaultBucket() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $3fab5dd6ec5d4e72$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $3fab5dd6ec5d4e72$var$cannotSliceBlob() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $3fab5dd6ec5d4e72$var$serverFileWrongSize() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $3fab5dd6ec5d4e72$var$noDownloadURL() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $3fab5dd6ec5d4e72$var$missingPolyFill(polyFill) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $3fab5dd6ec5d4e72$export$8f74d9881d1936fd(message) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $3fab5dd6ec5d4e72$var$appDeleted() {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $3fab5dd6ec5d4e72$export$61f54cdc36500ad(name) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $3fab5dd6ec5d4e72$var$invalidFormat(format, message) {
    return new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $3fab5dd6ec5d4e72$var$internalError(message) {
    throw new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $3fab5dd6ec5d4e72$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $3fab5dd6ec5d4e72$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $3fab5dd6ec5d4e72$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $3fab5dd6ec5d4e72$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $3fab5dd6ec5d4e72$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $3fab5dd6ec5d4e72$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $3fab5dd6ec5d4e72$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $3fab5dd6ec5d4e72$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $3fab5dd6ec5d4e72$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $3fab5dd6ec5d4e72$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3fab5dd6ec5d4e72$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $3fab5dd6ec5d4e72$var$isFunction(p) {
    return typeof p === 'function';
}
function $3fab5dd6ec5d4e72$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $3fab5dd6ec5d4e72$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $3fab5dd6ec5d4e72$var$isNativeBlob(p) {
    return $3fab5dd6ec5d4e72$var$isNativeBlobDefined() && p instanceof Blob;
}
function $3fab5dd6ec5d4e72$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $3fab5dd6ec5d4e72$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $3fab5dd6ec5d4e72$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $3fab5dd6ec5d4e72$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3fab5dd6ec5d4e72$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $3fab5dd6ec5d4e72$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error codes for requests made by the the XhrIo wrapper.
 */ var $3fab5dd6ec5d4e72$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($3fab5dd6ec5d4e72$var$ErrorCode || ($3fab5dd6ec5d4e72$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $3fab5dd6ec5d4e72$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $3fab5dd6ec5d4e72$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $3fab5dd6ec5d4e72$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $3fab5dd6ec5d4e72$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $3fab5dd6ec5d4e72$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $3fab5dd6ec5d4e72$var$ErrorCode.ABORT;
                    backoffCallback(false, new $3fab5dd6ec5d4e72$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $3fab5dd6ec5d4e72$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($3fab5dd6ec5d4e72$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $3fab5dd6ec5d4e72$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $3fab5dd6ec5d4e72$var$appDeleted() : $3fab5dd6ec5d4e72$var$canceled();
                    reject(err);
                } else {
                    const err = $3fab5dd6ec5d4e72$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $3fab5dd6ec5d4e72$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $3fab5dd6ec5d4e72$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $3fab5dd6ec5d4e72$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $3fab5dd6ec5d4e72$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $3fab5dd6ec5d4e72$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $3fab5dd6ec5d4e72$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : 'AppManager');
}
function $3fab5dd6ec5d4e72$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $3fab5dd6ec5d4e72$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $3fab5dd6ec5d4e72$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true) {
    const queryPart = $3fab5dd6ec5d4e72$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $3fab5dd6ec5d4e72$var$addGmpidHeader_(headers, appId);
    $3fab5dd6ec5d4e72$var$addAuthHeader_(headers, authToken);
    $3fab5dd6ec5d4e72$var$addVersionHeader_(headers, firebaseVersion);
    $3fab5dd6ec5d4e72$var$addAppCheckHeader_(headers, appCheckToken);
    return new $3fab5dd6ec5d4e72$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3fab5dd6ec5d4e72$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $3fab5dd6ec5d4e72$var$getBlob$1(...args) {
    const BlobBuilder1 = $3fab5dd6ec5d4e72$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($3fab5dd6ec5d4e72$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $3fab5dd6ec5d4e72$export$697502632950e9d3($3fab5dd6ec5d4e72$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $3fab5dd6ec5d4e72$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $3fab5dd6ec5d4e72$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $3fab5dd6ec5d4e72$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $3fab5dd6ec5d4e72$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $3fab5dd6ec5d4e72$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.RAW:
            return new $3fab5dd6ec5d4e72$var$StringData($3fab5dd6ec5d4e72$var$utf8Bytes_(stringData));
        case $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.BASE64:
        case $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.BASE64URL:
            return new $3fab5dd6ec5d4e72$var$StringData($3fab5dd6ec5d4e72$var$base64Bytes_(format, stringData));
        case $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.DATA_URL:
            return new $3fab5dd6ec5d4e72$var$StringData($3fab5dd6ec5d4e72$var$dataURLBytes_(stringData), $3fab5dd6ec5d4e72$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $3fab5dd6ec5d4e72$var$unknown();
}
function $3fab5dd6ec5d4e72$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $3fab5dd6ec5d4e72$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $3fab5dd6ec5d4e72$var$invalidFormat($3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $3fab5dd6ec5d4e72$var$utf8Bytes_(decoded);
}
function $3fab5dd6ec5d4e72$var$base64Bytes_(format, value) {
    switch(format){
        case $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $3fab5dd6ec5d4e72$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $3fab5dd6ec5d4e72$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $3fab5dd6ec5d4e72$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $3fab5dd6ec5d4e72$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $3fab5dd6ec5d4e72$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $3fab5dd6ec5d4e72$var$invalidFormat($3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $3fab5dd6ec5d4e72$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $3fab5dd6ec5d4e72$var$dataURLBytes_(dataUrl) {
    const parts = new $3fab5dd6ec5d4e72$var$DataURLParts(dataUrl);
    if (parts.base64) return $3fab5dd6ec5d4e72$var$base64Bytes_($3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $3fab5dd6ec5d4e72$var$percentEncodedBytes_(parts.rest);
}
function $3fab5dd6ec5d4e72$var$dataURLContentType_(dataUrl) {
    const parts = new $3fab5dd6ec5d4e72$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $3fab5dd6ec5d4e72$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($3fab5dd6ec5d4e72$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($3fab5dd6ec5d4e72$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $3fab5dd6ec5d4e72$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($3fab5dd6ec5d4e72$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7($3fab5dd6ec5d4e72$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($3fab5dd6ec5d4e72$var$isString(val)) return $3fab5dd6ec5d4e72$export$d80b9b5a2ccdd3e0($3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $3fab5dd6ec5d4e72$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($3fab5dd6ec5d4e72$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $3fab5dd6ec5d4e72$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $3fab5dd6ec5d4e72$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $3fab5dd6ec5d4e72$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3fab5dd6ec5d4e72$var$noXform_(metadata, value) {
    return value;
}
class $3fab5dd6ec5d4e72$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $3fab5dd6ec5d4e72$var$noXform_;
    }
}
let $3fab5dd6ec5d4e72$var$mappings_ = null;
function $3fab5dd6ec5d4e72$var$xformPath(fullPath) {
    if (!$3fab5dd6ec5d4e72$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $3fab5dd6ec5d4e72$var$lastComponent(fullPath);
}
function $3fab5dd6ec5d4e72$var$getMappings() {
    if ($3fab5dd6ec5d4e72$var$mappings_) return $3fab5dd6ec5d4e72$var$mappings_;
    const mappings = [];
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('bucket'));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('generation'));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('metageneration'));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $3fab5dd6ec5d4e72$var$xformPath(fullPath);
    }
    const nameMapping = new $3fab5dd6ec5d4e72$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $3fab5dd6ec5d4e72$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('timeCreated'));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('updated'));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('md5Hash', null, true));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('cacheControl', null, true));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('contentDisposition', null, true));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('contentEncoding', null, true));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('contentLanguage', null, true));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('contentType', null, true));
    mappings.push(new $3fab5dd6ec5d4e72$var$Mapping('metadata', 'customMetadata', true));
    $3fab5dd6ec5d4e72$var$mappings_ = mappings;
    return $3fab5dd6ec5d4e72$var$mappings_;
}
function $3fab5dd6ec5d4e72$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $3fab5dd6ec5d4e72$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $3fab5dd6ec5d4e72$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $3fab5dd6ec5d4e72$var$addRef(metadata, service);
    return metadata;
}
function $3fab5dd6ec5d4e72$var$fromResourceString(service, resourceString, mappings) {
    const obj = $3fab5dd6ec5d4e72$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $3fab5dd6ec5d4e72$var$fromResource(service, resource, mappings);
}
function $3fab5dd6ec5d4e72$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $3fab5dd6ec5d4e72$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$3fab5dd6ec5d4e72$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, host, protocol);
        const queryString = $3fab5dd6ec5d4e72$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $3fab5dd6ec5d4e72$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3fab5dd6ec5d4e72$var$PREFIXES_KEY = 'prefixes';
const $3fab5dd6ec5d4e72$var$ITEMS_KEY = 'items';
function $3fab5dd6ec5d4e72$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$3fab5dd6ec5d4e72$var$PREFIXES_KEY]) for (const path of resource[$3fab5dd6ec5d4e72$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $3fab5dd6ec5d4e72$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$3fab5dd6ec5d4e72$var$ITEMS_KEY]) for (const item of resource[$3fab5dd6ec5d4e72$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $3fab5dd6ec5d4e72$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $3fab5dd6ec5d4e72$var$fromResponseString(service, bucket, resourceString) {
    const obj = $3fab5dd6ec5d4e72$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $3fab5dd6ec5d4e72$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $3fab5dd6ec5d4e72$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $3fab5dd6ec5d4e72$var$handlerCheck(cndn) {
    if (!cndn) throw $3fab5dd6ec5d4e72$var$unknown();
}
function $3fab5dd6ec5d4e72$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $3fab5dd6ec5d4e72$var$fromResourceString(service, text, mappings);
        $3fab5dd6ec5d4e72$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $3fab5dd6ec5d4e72$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $3fab5dd6ec5d4e72$var$fromResponseString(service, bucket, text);
        $3fab5dd6ec5d4e72$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $3fab5dd6ec5d4e72$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $3fab5dd6ec5d4e72$var$fromResourceString(service, text, mappings);
        $3fab5dd6ec5d4e72$var$handlerCheck(metadata !== null);
        return $3fab5dd6ec5d4e72$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $3fab5dd6ec5d4e72$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $3fab5dd6ec5d4e72$var$unauthorizedApp();
            else newErr = $3fab5dd6ec5d4e72$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $3fab5dd6ec5d4e72$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $3fab5dd6ec5d4e72$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $3fab5dd6ec5d4e72$var$objectErrorHandler(location) {
    const shared = $3fab5dd6ec5d4e72$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $3fab5dd6ec5d4e72$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $3fab5dd6ec5d4e72$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, $3fab5dd6ec5d4e72$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$objectErrorHandler(location);
    return requestInfo;
}
function $3fab5dd6ec5d4e72$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, $3fab5dd6ec5d4e72$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$sharedErrorHandler(location);
    return requestInfo;
}
function $3fab5dd6ec5d4e72$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $3fab5dd6ec5d4e72$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, $3fab5dd6ec5d4e72$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$objectErrorHandler(location);
    return requestInfo;
}
function $3fab5dd6ec5d4e72$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $3fab5dd6ec5d4e72$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, $3fab5dd6ec5d4e72$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$objectErrorHandler(location);
    return requestInfo;
}
function $3fab5dd6ec5d4e72$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$objectErrorHandler(location);
    return requestInfo;
}
function $3fab5dd6ec5d4e72$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $3fab5dd6ec5d4e72$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $3fab5dd6ec5d4e72$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $3fab5dd6ec5d4e72$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $3fab5dd6ec5d4e72$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $3fab5dd6ec5d4e72$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $3fab5dd6ec5d4e72$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, $3fab5dd6ec5d4e72$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $3fab5dd6ec5d4e72$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $3fab5dd6ec5d4e72$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $3fab5dd6ec5d4e72$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $3fab5dd6ec5d4e72$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $3fab5dd6ec5d4e72$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $3fab5dd6ec5d4e72$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $3fab5dd6ec5d4e72$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $3fab5dd6ec5d4e72$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $3fab5dd6ec5d4e72$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $3fab5dd6ec5d4e72$var$handlerCheck(false);
        }
        $3fab5dd6ec5d4e72$var$handlerCheck($3fab5dd6ec5d4e72$var$isString(url));
        return url;
    }
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $3fab5dd6ec5d4e72$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $3fab5dd6ec5d4e72$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $3fab5dd6ec5d4e72$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $3fab5dd6ec5d4e72$var$handlerCheck(false);
        const size = Number(sizeString);
        $3fab5dd6ec5d4e72$var$handlerCheck(!isNaN(size));
        return new $3fab5dd6ec5d4e72$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $3fab5dd6ec5d4e72$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $3fab5dd6ec5d4e72$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $3fab5dd6ec5d4e72$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $3fab5dd6ec5d4e72$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $3fab5dd6ec5d4e72$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $3fab5dd6ec5d4e72$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $3fab5dd6ec5d4e72$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $3fab5dd6ec5d4e72$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $3fab5dd6ec5d4e72$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $3fab5dd6ec5d4e72$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $3fab5dd6ec5d4e72$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $3fab5dd6ec5d4e72$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $3fab5dd6ec5d4e72$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $3fab5dd6ec5d4e72$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3fab5dd6ec5d4e72$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $3fab5dd6ec5d4e72$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $3fab5dd6ec5d4e72$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $3fab5dd6ec5d4e72$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $3fab5dd6ec5d4e72$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $3fab5dd6ec5d4e72$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $3fab5dd6ec5d4e72$var$internalError('cannot .send() more than once');
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $3fab5dd6ec5d4e72$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $3fab5dd6ec5d4e72$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $3fab5dd6ec5d4e72$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $3fab5dd6ec5d4e72$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $3fab5dd6ec5d4e72$var$XhrTextConnection extends $3fab5dd6ec5d4e72$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $3fab5dd6ec5d4e72$var$newTextConnection() {
    return $3fab5dd6ec5d4e72$var$textFactoryOverride ? $3fab5dd6ec5d4e72$var$textFactoryOverride() : new $3fab5dd6ec5d4e72$var$XhrTextConnection();
}
class $3fab5dd6ec5d4e72$var$XhrBytesConnection extends $3fab5dd6ec5d4e72$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $3fab5dd6ec5d4e72$var$newBytesConnection() {
    return new $3fab5dd6ec5d4e72$var$XhrBytesConnection();
}
class $3fab5dd6ec5d4e72$var$XhrBlobConnection extends $3fab5dd6ec5d4e72$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $3fab5dd6ec5d4e72$var$newBlobConnection() {
    return new $3fab5dd6ec5d4e72$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $3fab5dd6ec5d4e72$export$86a2a9b92406a048 {
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $3fab5dd6ec5d4e72$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($3fab5dd6ec5d4e72$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($3fab5dd6ec5d4e72$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $3fab5dd6ec5d4e72$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $3fab5dd6ec5d4e72$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($3fab5dd6ec5d4e72$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $3fab5dd6ec5d4e72$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $3fab5dd6ec5d4e72$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $3fab5dd6ec5d4e72$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $3fab5dd6ec5d4e72$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $3fab5dd6ec5d4e72$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $3fab5dd6ec5d4e72$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $3fab5dd6ec5d4e72$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $3fab5dd6ec5d4e72$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $3fab5dd6ec5d4e72$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $3fab5dd6ec5d4e72$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $3fab5dd6ec5d4e72$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($3fab5dd6ec5d4e72$var$taskStateFromInternalTaskState(this._state)){
                case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.SUCCESS:
                    $3fab5dd6ec5d4e72$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.CANCELED:
                case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $3fab5dd6ec5d4e72$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $3fab5dd6ec5d4e72$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.RUNNING:
            case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $3fab5dd6ec5d4e72$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $3fab5dd6ec5d4e72$var$async(observer.complete.bind(observer))();
                break;
            case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.CANCELED:
            case $3fab5dd6ec5d4e72$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $3fab5dd6ec5d4e72$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $3fab5dd6ec5d4e72$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $3fab5dd6ec5d4e72$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $3fab5dd6ec5d4e72$export$adb98fff6714334) this._location = location;
        else this._location = $3fab5dd6ec5d4e72$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $3fab5dd6ec5d4e72$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $3fab5dd6ec5d4e72$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $3fab5dd6ec5d4e72$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $3fab5dd6ec5d4e72$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $3fab5dd6ec5d4e72$export$adb98fff6714334(this._location.bucket, newPath);
        return new $3fab5dd6ec5d4e72$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $3fab5dd6ec5d4e72$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $3fab5dd6ec5d4e72$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $3fab5dd6ec5d4e72$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $3fab5dd6ec5d4e72$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $3fab5dd6ec5d4e72$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $3fab5dd6ec5d4e72$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $3fab5dd6ec5d4e72$var$multipartUpload(ref.storage, ref._location, $3fab5dd6ec5d4e72$var$getMappings(), new $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $3fab5dd6ec5d4e72$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $3fab5dd6ec5d4e72$export$86a2a9b92406a048(ref, new $3fab5dd6ec5d4e72$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $3fab5dd6ec5d4e72$var$uploadString$1(ref, value, format = $3fab5dd6ec5d4e72$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $3fab5dd6ec5d4e72$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $3fab5dd6ec5d4e72$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $3fab5dd6ec5d4e72$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $3fab5dd6ec5d4e72$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $3fab5dd6ec5d4e72$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $3fab5dd6ec5d4e72$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $3fab5dd6ec5d4e72$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $3fab5dd6ec5d4e72$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $3fab5dd6ec5d4e72$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $3fab5dd6ec5d4e72$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $3fab5dd6ec5d4e72$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $3fab5dd6ec5d4e72$var$getMetadata$2(ref.storage, ref._location, $3fab5dd6ec5d4e72$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $3fab5dd6ec5d4e72$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $3fab5dd6ec5d4e72$var$updateMetadata$2(ref.storage, ref._location, metadata, $3fab5dd6ec5d4e72$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $3fab5dd6ec5d4e72$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $3fab5dd6ec5d4e72$var$getDownloadUrl(ref.storage, ref._location, $3fab5dd6ec5d4e72$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection).then((url)=>{
        if (url === null) throw $3fab5dd6ec5d4e72$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $3fab5dd6ec5d4e72$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $3fab5dd6ec5d4e72$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $3fab5dd6ec5d4e72$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $3fab5dd6ec5d4e72$var$_getChild$1(ref, childPath) {
    const newPath = $3fab5dd6ec5d4e72$var$child(ref._location.path, childPath);
    const location = new $3fab5dd6ec5d4e72$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $3fab5dd6ec5d4e72$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3fab5dd6ec5d4e72$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $3fab5dd6ec5d4e72$var$refFromURL(service, url) {
    return new $3fab5dd6ec5d4e72$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $3fab5dd6ec5d4e72$var$refFromPath(ref, path) {
    if (ref instanceof $3fab5dd6ec5d4e72$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $3fab5dd6ec5d4e72$var$noDefaultBucket();
        const reference = new $3fab5dd6ec5d4e72$var$Reference(service, service._bucket);
        if (path != null) return $3fab5dd6ec5d4e72$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $3fab5dd6ec5d4e72$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $3fab5dd6ec5d4e72$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $3fab5dd6ec5d4e72$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $3fab5dd6ec5d4e72$var$FirebaseStorageImpl) return $3fab5dd6ec5d4e72$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $3fab5dd6ec5d4e72$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $3fab5dd6ec5d4e72$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $3fab5dd6ec5d4e72$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$3fab5dd6ec5d4e72$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $3fab5dd6ec5d4e72$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $3fab5dd6ec5d4e72$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $59fdd18afb377ad5$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $3fab5dd6ec5d4e72$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $3fab5dd6ec5d4e72$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $3fab5dd6ec5d4e72$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $3fab5dd6ec5d4e72$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $3fab5dd6ec5d4e72$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $3fab5dd6ec5d4e72$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $3fab5dd6ec5d4e72$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $3fab5dd6ec5d4e72$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $3fab5dd6ec5d4e72$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $3fab5dd6ec5d4e72$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $3fab5dd6ec5d4e72$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $3fab5dd6ec5d4e72$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $3fab5dd6ec5d4e72$var$FailRequest($3fab5dd6ec5d4e72$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $3fab5dd6ec5d4e72$var$name = "@firebase/storage";
const $3fab5dd6ec5d4e72$var$version = "0.12.5";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $3fab5dd6ec5d4e72$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $3fab5dd6ec5d4e72$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $3fab5dd6ec5d4e72$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $3fab5dd6ec5d4e72$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $3fab5dd6ec5d4e72$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $3fab5dd6ec5d4e72$export$8548546c0aa631e6(ref) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $3fab5dd6ec5d4e72$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $3fab5dd6ec5d4e72$export$8837f4fc672e936d(ref, options) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $3fab5dd6ec5d4e72$export$6a265a7d315dec03(ref) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $3fab5dd6ec5d4e72$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $3fab5dd6ec5d4e72$export$39c5ed4ec960eade(ref) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$deleteObject$1(ref);
}
function $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(serviceOrRef);
    return $3fab5dd6ec5d4e72$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $3fab5dd6ec5d4e72$export$9acd24c0fce96a85(ref, childPath) {
    return $3fab5dd6ec5d4e72$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $3fab5dd6ec5d4e72$export$fbd9b57a66480737(app = (0, $6de42d4eacc8610d$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, $3fab5dd6ec5d4e72$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $59fdd18afb377ad5$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $3fab5dd6ec5d4e72$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $3fab5dd6ec5d4e72$export$9850e656f954b889(storage, host, port, options = {}) {
    $3fab5dd6ec5d4e72$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $3fab5dd6ec5d4e72$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(ref);
    return $3fab5dd6ec5d4e72$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $3fab5dd6ec5d4e72$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $3fab5dd6ec5d4e72$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $3fab5dd6ec5d4e72$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $6de42d4eacc8610d$export$31499a9cd224b78c));
}
function $3fab5dd6ec5d4e72$var$registerStorage() {
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)($3fab5dd6ec5d4e72$var$STORAGE_TYPE, $3fab5dd6ec5d4e72$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($3fab5dd6ec5d4e72$var$name, $3fab5dd6ec5d4e72$var$version, '');
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($3fab5dd6ec5d4e72$var$name, $3fab5dd6ec5d4e72$var$version, 'esm2017');
}
$3fab5dd6ec5d4e72$var$registerStorage();







// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

var $bdf27319b62b41de$var$name = "firebase";
var $bdf27319b62b41de$var$version = "10.12.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($bdf27319b62b41de$var$name, $bdf27319b62b41de$var$version, 'app');



console.log("Using Firebase Project:", (0, $22fc247a044a5f09$export$26cc430c2fed42ce).projectId);
console.log("Auth Domain:", (0, $22fc247a044a5f09$export$26cc430c2fed42ce).authDomain);
console.log("API Key:", (0, $22fc247a044a5f09$export$26cc430c2fed42ce).apiKey);
const $f335ccce9ceac24d$export$a4e2c8f07e884e = (0, $6de42d4eacc8610d$export$c55cfd413944906d)((0, $22fc247a044a5f09$export$26cc430c2fed42ce));


const $6713bbb530aa5272$export$f5b1a83e9c7f7f6c = (0, $3fab5dd6ec5d4e72$export$fbd9b57a66480737)((0, $f335ccce9ceac24d$export$a4e2c8f07e884e));
// emulator
if ((0, $22fc247a044a5f09$export$26cc430c2fed42ce).env == (0, $18313decae4d52e6$export$6c0517834721cef7).local) (0, $3fab5dd6ec5d4e72$export$9850e656f954b889)($6713bbb530aa5272$export$f5b1a83e9c7f7f6c, "127.0.0.1", 9199);


var $4d0abda1dc9c23ff$exports = {};
"use client";
"use strict";
var $4d0abda1dc9c23ff$var$Y = Object.create;
var $4d0abda1dc9c23ff$var$E = Object.defineProperty;
var $4d0abda1dc9c23ff$var$q = Object.getOwnPropertyDescriptor;
var $4d0abda1dc9c23ff$var$G = Object.getOwnPropertyNames;
var $4d0abda1dc9c23ff$var$K = Object.getPrototypeOf, $4d0abda1dc9c23ff$var$Z = Object.prototype.hasOwnProperty;
var $4d0abda1dc9c23ff$var$ee = (e, t)=>{
    for(var o in t)$4d0abda1dc9c23ff$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $4d0abda1dc9c23ff$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $4d0abda1dc9c23ff$var$G(t))!$4d0abda1dc9c23ff$var$Z.call(e, r) && r !== o && $4d0abda1dc9c23ff$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $4d0abda1dc9c23ff$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $4d0abda1dc9c23ff$var$W = (e, t, o)=>(o = e != null ? $4d0abda1dc9c23ff$var$Y($4d0abda1dc9c23ff$var$K(e)) : {}, $4d0abda1dc9c23ff$var$j(t || !e || !e.__esModule ? $4d0abda1dc9c23ff$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $4d0abda1dc9c23ff$var$te = (e)=>$4d0abda1dc9c23ff$var$j($4d0abda1dc9c23ff$var$E({}, "__esModule", {
        value: !0
    }), e);
var $4d0abda1dc9c23ff$var$Ve = {};
$4d0abda1dc9c23ff$var$ee($4d0abda1dc9c23ff$var$Ve, {
    CheckmarkIcon: ()=>$4d0abda1dc9c23ff$var$F,
    ErrorIcon: ()=>$4d0abda1dc9c23ff$var$w,
    LoaderIcon: ()=>$4d0abda1dc9c23ff$var$M,
    ToastBar: ()=>$4d0abda1dc9c23ff$var$$,
    ToastIcon: ()=>$4d0abda1dc9c23ff$var$U,
    Toaster: ()=>$4d0abda1dc9c23ff$var$J,
    default: ()=>$4d0abda1dc9c23ff$var$_e,
    resolveValue: ()=>$4d0abda1dc9c23ff$var$u,
    toast: ()=>$4d0abda1dc9c23ff$var$n,
    useToaster: ()=>$4d0abda1dc9c23ff$var$V,
    useToasterStore: ()=>$4d0abda1dc9c23ff$var$_
});
$4d0abda1dc9c23ff$exports = $4d0abda1dc9c23ff$var$te($4d0abda1dc9c23ff$var$Ve);
var $4d0abda1dc9c23ff$var$oe = (e)=>typeof e == "function", $4d0abda1dc9c23ff$var$u = (e, t)=>$4d0abda1dc9c23ff$var$oe(e) ? e(t) : e;
var $4d0abda1dc9c23ff$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $4d0abda1dc9c23ff$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $4d0abda1dc9c23ff$var$re = 20;
var $4d0abda1dc9c23ff$var$v = new Map, $4d0abda1dc9c23ff$var$se = 1e3, $4d0abda1dc9c23ff$var$X = (e)=>{
    if ($4d0abda1dc9c23ff$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $4d0abda1dc9c23ff$var$v.delete(e), $4d0abda1dc9c23ff$var$l({
            type: 4,
            toastId: e
        });
    }, $4d0abda1dc9c23ff$var$se);
    $4d0abda1dc9c23ff$var$v.set(e, t);
}, $4d0abda1dc9c23ff$var$ae = (e)=>{
    let t = $4d0abda1dc9c23ff$var$v.get(e);
    t && clearTimeout(t);
}, $4d0abda1dc9c23ff$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $4d0abda1dc9c23ff$var$re)
            };
        case 1:
            return t.toast.id && $4d0abda1dc9c23ff$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $4d0abda1dc9c23ff$var$H(e, {
                type: 1,
                toast: o
            }) : $4d0abda1dc9c23ff$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $4d0abda1dc9c23ff$var$X(s) : e.toasts.forEach((a)=>{
                $4d0abda1dc9c23ff$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $4d0abda1dc9c23ff$var$I = [], $4d0abda1dc9c23ff$var$D = {
    toasts: [],
    pausedAt: void 0
}, $4d0abda1dc9c23ff$var$l = (e)=>{
    $4d0abda1dc9c23ff$var$D = $4d0abda1dc9c23ff$var$H($4d0abda1dc9c23ff$var$D, e), $4d0abda1dc9c23ff$var$I.forEach((t)=>{
        t($4d0abda1dc9c23ff$var$D);
    });
}, $4d0abda1dc9c23ff$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $4d0abda1dc9c23ff$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("lldlC")).useState)($4d0abda1dc9c23ff$var$D);
    (0, (parcelRequire("lldlC")).useEffect)(()=>($4d0abda1dc9c23ff$var$I.push(o), ()=>{
            let r = $4d0abda1dc9c23ff$var$I.indexOf(o);
            r > -1 && $4d0abda1dc9c23ff$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $4d0abda1dc9c23ff$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $4d0abda1dc9c23ff$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $4d0abda1dc9c23ff$var$Q()
    }), $4d0abda1dc9c23ff$var$S = (e)=>(t, o)=>{
        let s = $4d0abda1dc9c23ff$var$ce(t, e, o);
        return $4d0abda1dc9c23ff$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $4d0abda1dc9c23ff$var$n = (e, t)=>$4d0abda1dc9c23ff$var$S("blank")(e, t);
$4d0abda1dc9c23ff$var$n.error = $4d0abda1dc9c23ff$var$S("error");
$4d0abda1dc9c23ff$var$n.success = $4d0abda1dc9c23ff$var$S("success");
$4d0abda1dc9c23ff$var$n.loading = $4d0abda1dc9c23ff$var$S("loading");
$4d0abda1dc9c23ff$var$n.custom = $4d0abda1dc9c23ff$var$S("custom");
$4d0abda1dc9c23ff$var$n.dismiss = (e)=>{
    $4d0abda1dc9c23ff$var$l({
        type: 3,
        toastId: e
    });
};
$4d0abda1dc9c23ff$var$n.remove = (e)=>$4d0abda1dc9c23ff$var$l({
        type: 4,
        toastId: e
    });
$4d0abda1dc9c23ff$var$n.promise = (e, t, o)=>{
    let s = $4d0abda1dc9c23ff$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($4d0abda1dc9c23ff$var$n.success($4d0abda1dc9c23ff$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $4d0abda1dc9c23ff$var$n.error($4d0abda1dc9c23ff$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $4d0abda1dc9c23ff$var$pe = (e, t)=>{
    $4d0abda1dc9c23ff$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $4d0abda1dc9c23ff$var$de = ()=>{
    $4d0abda1dc9c23ff$var$l({
        type: 5,
        time: Date.now()
    });
}, $4d0abda1dc9c23ff$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $4d0abda1dc9c23ff$var$_(e);
    (0, (parcelRequire("lldlC")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $4d0abda1dc9c23ff$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$4d0abda1dc9c23ff$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("lldlC")).useCallback)(()=>{
        o && $4d0abda1dc9c23ff$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("lldlC")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $4d0abda1dc9c23ff$var$pe,
            startPause: $4d0abda1dc9c23ff$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $4d0abda1dc9c23ff$var$T = $4d0abda1dc9c23ff$var$W((parcelRequire("lldlC")));
let $a61e4d741762d37a$var$e = {
    data: ""
}, $a61e4d741762d37a$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $a61e4d741762d37a$var$e, $a61e4d741762d37a$export$54aba348a7896325 = (e)=>{
    let r = $a61e4d741762d37a$var$t(e), l = r.data;
    return r.data = "", l;
}, $a61e4d741762d37a$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $a61e4d741762d37a$var$a = /\/\*[^]*?\*\/|  +/g, $a61e4d741762d37a$var$n = /\n+/g, $a61e4d741762d37a$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $a61e4d741762d37a$var$o(c, n) : n + "{" + $a61e4d741762d37a$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $a61e4d741762d37a$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $a61e4d741762d37a$var$o.p ? $a61e4d741762d37a$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $a61e4d741762d37a$var$c = {}, $a61e4d741762d37a$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $a61e4d741762d37a$var$s(e[r]);
        return t;
    }
    return e;
}, $a61e4d741762d37a$var$i = (e, t, r, i, p)=>{
    let u = $a61e4d741762d37a$var$s(e), d = $a61e4d741762d37a$var$c[u] || ($a61e4d741762d37a$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$a61e4d741762d37a$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $a61e4d741762d37a$var$l.exec(e.replace($a61e4d741762d37a$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($a61e4d741762d37a$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($a61e4d741762d37a$var$n, " ").trim();
            return o[0];
        })(e);
        $a61e4d741762d37a$var$c[d] = $a61e4d741762d37a$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $a61e4d741762d37a$var$c.g ? $a61e4d741762d37a$var$c.g : null;
    return r && ($a61e4d741762d37a$var$c.g = $a61e4d741762d37a$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($a61e4d741762d37a$var$c[d], t, i, f), d;
}, $a61e4d741762d37a$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $a61e4d741762d37a$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $a61e4d741762d37a$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $a61e4d741762d37a$var$i(l.unshift ? l.raw ? $a61e4d741762d37a$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $a61e4d741762d37a$var$t(r.target), r.g, r.o, r.k);
}
let $a61e4d741762d37a$var$d, $a61e4d741762d37a$var$f, $a61e4d741762d37a$var$g, $a61e4d741762d37a$export$442f1a04865e4790 = $a61e4d741762d37a$export$dbf350e5966cf602.bind({
    g: 1
}), $a61e4d741762d37a$export$d25ddfdf17c3ad3e = $a61e4d741762d37a$export$dbf350e5966cf602.bind({
    k: 1
});
function $a61e4d741762d37a$export$de27182ff8187d6c(e, t, r, l) {
    $a61e4d741762d37a$var$o.p = t, $a61e4d741762d37a$var$d = e, $a61e4d741762d37a$var$f = r, $a61e4d741762d37a$var$g = l;
}
function $a61e4d741762d37a$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $a61e4d741762d37a$var$f && $a61e4d741762d37a$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $a61e4d741762d37a$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $a61e4d741762d37a$var$g && i[0] && $a61e4d741762d37a$var$g(c), $a61e4d741762d37a$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $4d0abda1dc9c23ff$var$y = $4d0abda1dc9c23ff$var$W((parcelRequire("lldlC")));


var $4d0abda1dc9c23ff$var$me = $a61e4d741762d37a$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $4d0abda1dc9c23ff$var$ue = $a61e4d741762d37a$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $4d0abda1dc9c23ff$var$le = $a61e4d741762d37a$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $4d0abda1dc9c23ff$var$w = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$4d0abda1dc9c23ff$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$4d0abda1dc9c23ff$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$4d0abda1dc9c23ff$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $4d0abda1dc9c23ff$var$Te = $a61e4d741762d37a$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $4d0abda1dc9c23ff$var$M = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$4d0abda1dc9c23ff$var$Te} 1s linear infinite;
`;

var $4d0abda1dc9c23ff$var$fe = $a61e4d741762d37a$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $4d0abda1dc9c23ff$var$ye = $a61e4d741762d37a$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $4d0abda1dc9c23ff$var$F = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$4d0abda1dc9c23ff$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$4d0abda1dc9c23ff$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $4d0abda1dc9c23ff$var$ge = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $4d0abda1dc9c23ff$var$he = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $4d0abda1dc9c23ff$var$xe = $a61e4d741762d37a$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $4d0abda1dc9c23ff$var$be = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$4d0abda1dc9c23ff$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $4d0abda1dc9c23ff$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $4d0abda1dc9c23ff$var$y.createElement($4d0abda1dc9c23ff$var$be, null, t) : t : o === "blank" ? null : $4d0abda1dc9c23ff$var$y.createElement($4d0abda1dc9c23ff$var$he, null, $4d0abda1dc9c23ff$var$y.createElement($4d0abda1dc9c23ff$var$M, {
        ...s
    }), o !== "loading" && $4d0abda1dc9c23ff$var$y.createElement($4d0abda1dc9c23ff$var$ge, null, o === "error" ? $4d0abda1dc9c23ff$var$y.createElement($4d0abda1dc9c23ff$var$w, {
        ...s
    }) : $4d0abda1dc9c23ff$var$y.createElement($4d0abda1dc9c23ff$var$F, {
        ...s
    })));
};
var $4d0abda1dc9c23ff$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $4d0abda1dc9c23ff$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $4d0abda1dc9c23ff$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $4d0abda1dc9c23ff$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $4d0abda1dc9c23ff$var$Ee = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $4d0abda1dc9c23ff$var$Re = (0, $a61e4d741762d37a$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $4d0abda1dc9c23ff$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $4d0abda1dc9c23ff$var$R() ? [
        $4d0abda1dc9c23ff$var$Pe,
        $4d0abda1dc9c23ff$var$Oe
    ] : [
        $4d0abda1dc9c23ff$var$Se(s),
        $4d0abda1dc9c23ff$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $a61e4d741762d37a$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $a61e4d741762d37a$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $4d0abda1dc9c23ff$var$$ = $4d0abda1dc9c23ff$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $4d0abda1dc9c23ff$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $4d0abda1dc9c23ff$var$T.createElement($4d0abda1dc9c23ff$var$U, {
        toast: e
    }), c = $4d0abda1dc9c23ff$var$T.createElement($4d0abda1dc9c23ff$var$Re, {
        ...e.ariaProps
    }, $4d0abda1dc9c23ff$var$u(e.message, e));
    return $4d0abda1dc9c23ff$var$T.createElement($4d0abda1dc9c23ff$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $4d0abda1dc9c23ff$var$T.createElement($4d0abda1dc9c23ff$var$T.Fragment, null, a, c));
});


var $4d0abda1dc9c23ff$var$f = $4d0abda1dc9c23ff$var$W((parcelRequire("lldlC")));
(0, $a61e4d741762d37a$export$de27182ff8187d6c)($4d0abda1dc9c23ff$var$f.createElement);
var $4d0abda1dc9c23ff$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $4d0abda1dc9c23ff$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $4d0abda1dc9c23ff$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $4d0abda1dc9c23ff$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $4d0abda1dc9c23ff$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $4d0abda1dc9c23ff$var$ke = $a61e4d741762d37a$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $4d0abda1dc9c23ff$var$L = 16, $4d0abda1dc9c23ff$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $4d0abda1dc9c23ff$var$V(o);
    return $4d0abda1dc9c23ff$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $4d0abda1dc9c23ff$var$L,
            left: $4d0abda1dc9c23ff$var$L,
            right: $4d0abda1dc9c23ff$var$L,
            bottom: $4d0abda1dc9c23ff$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $4d0abda1dc9c23ff$var$De(g, z);
        return $4d0abda1dc9c23ff$var$f.createElement($4d0abda1dc9c23ff$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $4d0abda1dc9c23ff$var$ke : "",
            style: O
        }, p.type === "custom" ? $4d0abda1dc9c23ff$var$u(p.message, p) : r ? r(p) : $4d0abda1dc9c23ff$var$f.createElement($4d0abda1dc9c23ff$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $4d0abda1dc9c23ff$var$_e = $4d0abda1dc9c23ff$var$n;


const $b6d41c69473fd19b$var$defaultOptions = {
    duration: 5000
};
const $b6d41c69473fd19b$export$e80fa18a42ed98ef = {
    //
    info: (message, options = $b6d41c69473fd19b$var$defaultOptions)=>{
        const toastId = (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports)))(message, options);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).dismiss(toastId);
        };
    },
    success: (message, options = $b6d41c69473fd19b$var$defaultOptions)=>{
        const toastId = (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success(message, options);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).dismiss(toastId);
        };
    },
    warning: (message, options = $b6d41c69473fd19b$var$defaultOptions)=>{
        // TODO
        const toastId = (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports)))(message, options);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).dismiss(toastId);
        };
    },
    error: (message, options = $b6d41c69473fd19b$var$defaultOptions)=>{
        const toastId = (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error(message, options);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).dismiss(toastId);
        };
    },
    loading: (message, options = {})=>{
        const toastId = (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).loading(message, options);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).dismiss(toastId);
        };
    }
};


const $fce4445636ac7988$export$6c5453569d966c6d = async (args)=>{
    const { file: file, path: path, bucket: bucket, onProgress: onProgress, onSuccess: onSuccess } = args;
    const storageRef = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)((0, $6713bbb530aa5272$export$f5b1a83e9c7f7f6c), `gs://${bucket}/${path}`);
    const task = (0, $3fab5dd6ec5d4e72$export$3895d39eb7ac9b25)(storageRef, file);
    const filename = file.name || "";
    return new Promise((resolve, reject)=>{
        task.on("state_changed", (snapshot)=>{
            const percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            onProgress(percentage);
        }, (error)=>{
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(`Uploading ${filename} failed.`);
            console.error(error);
            reject();
        }, ()=>{
            // on complete
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).success(`${filename} uploaded successfully.`);
            onSuccess && onSuccess();
            resolve();
        });
    });
};


// import { toastStore } from '../toast/toastStore';


const $3b62bcaeb57932ae$export$fb792135d445702e = async (args)=>{
    //
    const { fn: asyncFn, successMessage: successMessage, loadingMessage: loadingMessage, setBusyFlag: setBusyFlag, onSuccess: onSuccess, onError: onError, onComplete: onComplete, hideToastOnError: hideToastOnError } = args;
    let hide;
    if (loadingMessage) hide = (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).loading(loadingMessage);
    try {
        setBusyFlag && setBusyFlag(true);
        const result = await asyncFn();
        successMessage && (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).success(successMessage);
        onSuccess && onSuccess(result);
        return result;
    } catch (e) {
        console.error(e);
        !hideToastOnError && (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error((0, $53efa3a118a98115$export$82f46aa4e6535a45)(e) ?? `Error: ${loadingMessage?.toLowerCase()}`);
        onError && onError(e);
    // throw e;
    } finally{
        setBusyFlag && setBusyFlag(false);
        hide && hide();
        onComplete && onComplete();
    }
};



const $017f1b60211c8504$export$b57af79a4ab2a1c6 = (props)=>{
    //
    const [progress, setProgress] = (0, $lldlC.useState)(0);
    const uploadToGcs = async (file)=>{
        //
        if ((0, $22fc247a044a5f09$export$26cc430c2fed42ce).isCypress) {
            console.log(`Skipping file upload for cypress test run`);
            props.onUploadComplete({
                id: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId(),
                path: "users/cypress_uid/images/placeholder.png",
                name: "placeholder.png"
            });
            return;
        }
        const { gcsBucket: gcsBucket, gcsFolder: gcsFolder, allowedFiles: allowedFiles } = props;
        const filename = file.name || "";
        const extension = (0, $4a77fffd00953779$export$5f7821c344028c56)(filename);
        const fileId = (0, $d95193d4ccefcd01$export$eb3f5f3fadd5e75d)({
            extension: extension
        });
        const path = `${gcsFolder}/${fileId}`;
        const isAllowed = allowedFiles.includes(extension);
        if (!isAllowed) {
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(`Please choose another file with the allowed file extension: ${allowedFiles.join(", ")}.`);
            return;
        }
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $fce4445636ac7988$export$6c5453569d966c6d)({
                    file: file,
                    path: path,
                    bucket: gcsBucket,
                    onProgress: (percentage)=>setProgress(percentage)
                }),
            loadingMessage: `Uploading ${filename}`,
            onSuccess: ()=>props.onUploadComplete({
                    id: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId(),
                    path: path,
                    name: filename
                })
        });
    };
    const onChange = (event)=>{
        event.preventDefault();
        const files = event.target.files;
        if (!files) return;
        if (files.length !== 1) {
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(`Cannot handle multiple files.`);
            return;
        }
        uploadToGcs(files.item(0));
    };
    const renderProgressBar = ()=>{
        if (progress <= 0 || progress >= 100) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("progress", {
                max: "100",
                value: progress,
                children: progress
            })
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "fileinput",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                className: "file-input",
                type: "file",
                onChange: onChange
            }),
            renderProgressBar()
        ]
    });
};


/// <reference types="@types/google.maps" />



var $lldlC = parcelRequire("lldlC");
const $1457db1558fe6fa2$export$4b815a6d90b10bec = (props)=>{
    //
    let textInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lldlC))).createRef();
    const initAutocomplete = ()=>{
        const { country: country } = props;
        if (!textInput.current) return;
        const autocomplete = new google.maps.places.Autocomplete(textInput.current, {
            componentRestrictions: country ? {
                country: country
            } : undefined,
            types: (0, $017dbf8c3a8e8a30$export$ecfefdb908fd0ef1)[props.typeFilter]
        });
        google.maps.event.addListener(autocomplete, "place_changed", ()=>{
            if (!textInput.current) return;
            const placeResult = autocomplete.getPlace();
            if (!placeResult) return;
            props.onChange(placeResult);
        });
    };
    (0, $lldlC.useEffect)(()=>{
        initAutocomplete();
    });
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
        type: "text",
        ref: textInput
    });
// return <Search type="text" ref={textInput} labelText="" placeholder={props.currentLocation} />;
};



const $1a4a414bd81c4abe$export$113551ac39cf19f3 = ({ children: children, href: href })=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
        href: href,
        children: children
    });
};





var $lldlC = parcelRequire("lldlC");
const $13dba5a0e61e7643$export$6bf0cd3a219bbade = (props)=>{
    const initialValue = (0, $46735892604b37f3$export$7e4aa119212bc614)(props.value) ? props.value : "";
    // console.log(props, initialValue);
    const [value, setValue] = (0, $lldlC.useState)(initialValue);
    const { validation: validation = (0, $bfcff1203c83f49a$export$80f9043b76a4e68e).success } = props;
    (0, $lldlC.useEffect)(()=>{
        setValue(props.value ?? "");
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
        type: "number",
        step: props.step,
        value: value,
        onChange: (e)=>{
            // always bind to the local state
            setValue(e.target.value);
            // if value is number then, call onChange
            if ((0, $46735892604b37f3$export$7e4aa119212bc614)(e.target.valueAsNumber)) {
                props.onChange(e.target.valueAsNumber);
                return;
            }
            // if value is empty string, then pass undefined
            if (e.target.value === "") {
                props.onChange();
                return;
            }
        },
        className: validation.isValid ? "valid" : "invalid",
        disabled: props.disabled,
        "data-cy": props.dataCy,
        ref: props.customRef,
        inputMode: props.inputMode ?? "numeric"
    });
};





var $lldlC = parcelRequire("lldlC");
const $e1c6fd4a02d0fbd1$export$6508682d580a3f02 = (props)=>{
    const initialValue = !(0, $46735892604b37f3$export$7e4aa119212bc614)(props.value) ? "" : props.value;
    const [value, setValue] = (0, $lldlC.useState)(initialValue);
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
        type: "number",
        step: props.step,
        value: value,
        onChange: (e)=>{
            // always bind to the local observable
            setValue(e.target.value);
            // if value is number then, call onChange
            if ((0, $46735892604b37f3$export$7e4aa119212bc614)(e.target.valueAsNumber)) {
                props.onChange(e.target.valueAsNumber);
                return;
            }
            // if value is empty string, then pass 0
            if (e.target.value === "") {
                props.onChange(undefined);
                return;
            }
        },
        className: props.validation.isValid ? "valid" : "invalid",
        disabled: props.disabled,
        "data-cy": props.dataCy,
        ref: props.customRef,
        inputMode: props.inputMode ?? "numeric"
    });
};



const $dd9a4bde12c54e88$export$8fd02ea6020a0206 = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
        className: "",
        "aria-hidden": "true",
        children: props.count
    });
};




parcelRequire("lldlC");
const $6f32961975b22fb5$export$c86715117507e8e5 = (props)=>{
    //
    const { validation: validation = (0, $bfcff1203c83f49a$export$80f9043b76a4e68e).success } = props;
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: `text-input ${!!props.prependText ? "has-prepend" : ""}`,
        children: [
            props.prependText && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "prepend-text",
                children: props.prependText
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                ref: props.customRef,
                type: props.type ?? "text",
                inputMode: props.inputMode || "text",
                maxLength: props.maxLength,
                value: props.value ?? "",
                onChange: (e)=>props.onChange(e.target.value),
                className: validation.isValid ? "valid" : "invalid",
                disabled: props.disabled,
                readOnly: props.readOnly,
                placeholder: props.placeholder,
                "data-cy": props.dataCy,
                pattern: props.pattern,
                onFocus: props.onFocus,
                onBlur: (e)=>props.onBlur && props.onBlur(e.target.value),
                onKeyDown: (e)=>{
                    if (e.key === "Enter" && props.onPressEnter) props.onPressEnter();
                }
            }),
            !props.disabled && props.showClearIcon && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "clear-icon",
                onClick: ()=>props.onChange(""),
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "/images/icon-clear-text-field.svg",
                    alt: "clear"
                })
            })
        ]
    });
};





var $lldlC = parcelRequire("lldlC");

const $76818b5c4dfcb4f7$export$614dfd408a141057 = /*#__PURE__*/ (0, $lldlC.forwardRef)((props, ref)=>{
    //
    const [list, setList] = (0, $lldlC.useState)();
    const [cursor, setCursor] = (0, $lldlC.useState)();
    const [loading, setLoading] = (0, $lldlC.useState)(false);
    const refresh = ()=>{
        setList(undefined);
        setCursor(undefined);
        fetchPage();
    };
    (0, $lldlC.useImperativeHandle)(ref, ()=>{
        return {
            refresh: refresh
        };
    }, []);
    const fetchPage = (0, $lldlC.useCallback)((cursor)=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>props.getPage(cursor),
            setBusyFlag: setLoading,
            loadingMessage: "Loading ...",
            onSuccess: (page)=>{
                const newList = [
                    ...list ?? [],
                    ...page.list
                ];
                setList(newList);
                setCursor(page.cursor);
            // props.onListUpdate?.(newList);
            }
        });
    }, [
        props.getPage
    ]);
    (0, $lldlC.useEffect)(()=>{
        fetchPage(cursor);
    }, []);
    if (list === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading ..."
    });
    if (list.length === 0) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "empty-user",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "heading",
                children: props.emptyStateHeading
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "sub-heading",
                children: props.emptyStateSubHeading
            }),
            props.renderCreateButton?.()
        ]
    });
    const renderLoadMoreButton = ()=>{
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
            disabled: loading,
            children: loading ? "Loading ..." : "Load More"
        });
    };
    // remove this item from the list
    const onDelete = (index)=>{
        return ()=>setList((0, $1daa848edc266398$export$782c92add9db11ce).remove(list, index));
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: `list-widget`,
        children: [
            props.renderHeader(),
            list.map((item, index)=>props.renderItem({
                    item: item,
                    onDelete: onDelete(index)
                }))
        ]
    });
});



parcelRequire("lldlC");

var $b483b1f2e6746e63$export$d3d950cd69e1ac66 = /*#__PURE__*/ function(ButtonType) {
    ButtonType["primary"] = "primary";
    ButtonType["success"] = "success";
    ButtonType["failure"] = "failure";
    return ButtonType;
}({});



const $2ca4aa9d03086c70$export$a7fed597f4b8afd8 = (props)=>{
    //
    const renderCancel = ()=>{
        const { cancel: cancel } = props;
        if (!cancel) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fe951448db529767$export$353f5b6fc5456de1), {
            onClick: cancel.handler,
            className: "cancel-button",
            children: cancel.label
        });
    };
    const renderSubmit = ()=>{
        const { submit: submit, validationResult: validationResult } = props;
        if (!submit) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fe951448db529767$export$353f5b6fc5456de1), {
            disabled: !validationResult.isValid,
            className: "submit-button",
            type: (0, $b483b1f2e6746e63$export$d3d950cd69e1ac66).primary,
            onClick: ()=>{
                if (!validationResult.isValid) {
                    (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(`[${validationResult.errorPath.join(".")}] ${validationResult.errorMessage}`);
                    return;
                }
                submit.handler();
            },
            dataCy: "submit",
            children: submit.label
        });
    };
    const renderButtons = ()=>{
        const { submit: submit, cancel: cancel } = props;
        if (!submit && !cancel) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "form-buttons",
            children: [
                renderSubmit(),
                renderCancel()
            ]
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: `form ${props.type} ${props.additionalClassNames}`,
        "data-cy": props.dataCy,
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "form-items",
                children: props.children
            }),
            renderButtons()
        ]
    });
};






parcelRequire("lldlC");
/**
 * Meta info displayed on the form items
 */ 
const $8a58c72a70e85dd3$export$ffe77881edc613de = ({ validation: validation, helpText: helpText })=>{
    //
    /*
  const renderErrorMessage = () => {
    if (!validation?.errorMessage) return;
    return <div className="error">{validation.errorMessage}</div>;
  };
 */ const renderHelpText = ()=>{
        if (!helpText) return;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "help",
            children: helpText
        });
    };
    //const error = renderErrorMessage();
    const help = renderHelpText();
    if (help) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "meta",
        children: help
    });
    return null;
};


const $04349e24c8c71c6e$export$a595b5d109979b0e = (props)=>{
    const { label: label, additionalClassNames: additionalClassNames } = props;
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: `form-item ${additionalClassNames}`,
        children: [
            label && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("label", {
                className: "label",
                children: label
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: `form-input`,
                children: props.children
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $8a58c72a70e85dd3$export$ffe77881edc613de), {
                ...props
            })
        ]
    });
};


const $eab53882304b0001$export$3372f74bda8eb354 = (props)=>{
    //
    const renderPreview = ()=>{
        const { value: value, gcsBucket: gcsBucket } = props;
        if (!value || !value.path) return null;
        const gcsUrl = `${(0, $22fc247a044a5f09$export$26cc430c2fed42ce).gcsBaseUrl}/${gcsBucket}/${value.path}`;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "file-download-link",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                    children: "Preview: "
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                    href: gcsUrl,
                    target: "_blank",
                    children: "Click here"
                })
            ]
        });
    };
    const { gcsBucket: gcsBucket, gcsFolder: gcsFolder, onChange: onChange, value: image, dataCy: dataCy, onClear: onClear } = props;
    const fileExtensions = [
        "pdf",
        "PDF"
    ];
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        additionalClassNames: `form-file-upload ${props.additionalClassNames}`,
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $017f1b60211c8504$export$b57af79a4ab2a1c6), {
                allowedFiles: fileExtensions,
                gcsBucket: gcsBucket,
                gcsFolder: gcsFolder,
                onUploadComplete: (fileInfo)=>onChange(fileInfo),
                dataCy: dataCy
            }),
            renderPreview(),
            onClear && image && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                className: "clear-link",
                onClick: onClear,
                children: "Remove"
            })
        ]
    });
};






const $e18054edfe651d96$export$5d665a22507d662e = (props)=>{
    //
    const renderPreview = ()=>{
        const { value: image } = props;
        if (!image || !image.path) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "image-preview",
            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $8c83b7f2659cbbfc$export$13dff1a79c6f1d5c), {
                image: image,
                aspectRatio: props.aspectRatio
            })
        });
    };
    const { gcsBucket: gcsBucket, gcsFolder: gcsFolder, onChange: onChange, value: image, dataCy: dataCy, onClear: onClear } = props;
    const fileExtensions = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "JPG",
        "JPEG",
        "PNG",
        "GIF"
    ];
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        additionalClassNames: `form-image-upload ${props.additionalClassNames}`,
        children: [
            renderPreview(),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $017f1b60211c8504$export$b57af79a4ab2a1c6), {
                allowedFiles: fileExtensions,
                gcsFolder: gcsFolder,
                gcsBucket: gcsBucket,
                onUploadComplete: (fileInfo)=>onChange(fileInfo),
                dataCy: dataCy
            }),
            onClear && image && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                className: "clear-link",
                onClick: onClear,
                children: "Remove"
            })
        ]
    });
};




const $7f0fc3b67d0d498e$export$b3fe2a21c9e9349f = (props)=>{
    //
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        additionalClassNames: `form-iso-date-picker ${props.additionalClassNames}`,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
            type: "date",
            value: props.value ?? "",
            onChange: (event)=>{
                props.onChange(event.target.value);
            }
        })
    });
};




const $e318624e4f34cea7$export$bc7b516704655842 = (props)=>{
    //
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "form-iso-month-picker",
            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                type: "month",
                value: props.value,
                onChange: (event)=>{
                    props.onChange(event.target.value);
                }
            })
        })
    });
};






const $d0c344b4b519899f$export$b0ecfc8f73737af7 = (props)=>{
    const { value: value = [], add: add } = props;
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: [
            value.map((item, index)=>props.children({
                    item: item,
                    index: index,
                    onChange: (update)=>props.onChange((0, $1daa848edc266398$export$782c92add9db11ce).replace(value, index, update)),
                    validation: props.validation?.items[index],
                    onDelete: ()=>props.onChange((0, $1daa848edc266398$export$782c92add9db11ce).remove(value, index))
                })),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                type: "button",
                onClick: ()=>props.onChange([
                        ...value,
                        add()
                    ]),
                children: "Add"
            })
        ]
    });
};






function $cdf41eff9c3e8954$var$getLocalityLabel(locality) {
    if (!locality) return "";
    return `${locality?.suburb}${locality?.suburb && ", "}${locality?.state}, ${locality?.countryCode && (0, $393581745e27d841$export$142596e469219c06).getForCode(locality.countryCode)?.name}`;
}
const $cdf41eff9c3e8954$export$a65b52db60429a80 = (props)=>{
    //
    const currentValue = $cdf41eff9c3e8954$var$getLocalityLabel(props.value);
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        label: "Locality",
        validation: props.validation,
        helpText: props.helpText,
        additionalClassNames: `form-locality-input ${props.additionalClassNames}`,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $1457db1558fe6fa2$export$4b815a6d90b10bec), {
            onChange: (placeResult)=>{
                if (!placeResult) return;
                const locality = (0, $236a2723f65f7cf7$export$7abbf712c13acd02).getLocality({
                    placeResult: placeResult
                });
                props.onChange(locality);
                console.log(locality);
            },
            typeFilter: "regions",
            currentLocation: currentValue
        })
    });
};



/**
 * https://www.npmjs.com/package/react-multi-select-component
 */ 

var $lldlC = parcelRequire("lldlC");

function $6aa68e0390eba24d$var$V(e, { insertAt: n } = {}) {
    if (!e || typeof document > "u") return;
    let t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.type = "text/css", n === "top" && t.firstChild ? t.insertBefore(r, t.firstChild) : t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
$6aa68e0390eba24d$var$V(`.rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}
`);
var $6aa68e0390eba24d$var$Me = {
    allItemsAreSelected: "All items are selected.",
    clearSearch: "Clear Search",
    clearSelected: "Clear Selected",
    noOptions: "No options",
    search: "Search",
    selectAll: "Select All",
    selectAllFiltered: "Select All (Filtered)",
    selectSomeItems: "Select...",
    create: "Create"
}, $6aa68e0390eba24d$var$De = {
    value: [],
    hasSelectAll: !0,
    className: "multi-select",
    debounceDuration: 200,
    options: []
}, $6aa68e0390eba24d$var$re = (0, (/*@__PURE__*/$parcel$interopDefault($lldlC))).createContext({}), $6aa68e0390eba24d$var$ne = ({ props: e, children: n })=>{
    let [t, r] = (0, $lldlC.useState)(e.options), a = (c)=>{
        var u;
        return ((u = e.overrideStrings) == null ? void 0 : u[c]) || $6aa68e0390eba24d$var$Me[c];
    };
    return (0, $lldlC.useEffect)(()=>{
        r(e.options);
    }, [
        e.options
    ]), (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$var$re.Provider, {
        value: {
            t: a,
            ...$6aa68e0390eba24d$var$De,
            ...e,
            options: t,
            setOptions: r
        },
        children: n
    });
}, $6aa68e0390eba24d$var$w = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lldlC))).useContext($6aa68e0390eba24d$var$re);
function $6aa68e0390eba24d$var$se(e, n) {
    let t = (0, $lldlC.useRef)(!1);
    (0, $lldlC.useEffect)(()=>{
        t.current ? e() : t.current = !0;
    }, n);
}
var $6aa68e0390eba24d$var$He = {
    when: !0,
    eventTypes: [
        "keydown"
    ]
};
function $6aa68e0390eba24d$var$R(e, n, t) {
    let r = (0, $lldlC.useMemo)(()=>Array.isArray(e) ? e : [
            e
        ], [
        e
    ]), a = Object.assign({}, $6aa68e0390eba24d$var$He, t), { when: c, eventTypes: u } = a, b = (0, $lldlC.useRef)(n), { target: s } = a;
    (0, $lldlC.useEffect)(()=>{
        b.current = n;
    });
    let p = (0, $lldlC.useCallback)((i)=>{
        r.some((l)=>i.key === l || i.code === l) && b.current(i);
    }, [
        r
    ]);
    (0, $lldlC.useEffect)(()=>{
        if (c && typeof window < "u") {
            let i = s ? s.current : window;
            return u.forEach((l)=>{
                i && i.addEventListener(l, p);
            }), ()=>{
                u.forEach((l)=>{
                    i && i.removeEventListener(l, p);
                });
            };
        }
    }, [
        c,
        u,
        r,
        s,
        n
    ]);
}
var $6aa68e0390eba24d$var$f = {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: "Space"
};
var $6aa68e0390eba24d$var$le = (e, n)=>{
    let t;
    return function(...r) {
        clearTimeout(t), t = setTimeout(()=>{
            e.apply(null, r);
        }, n);
    };
};
function $6aa68e0390eba24d$var$ie(e, n) {
    return n ? e.filter(({ label: t, value: r })=>t != null && r != null && t.toLowerCase().includes(n.toLowerCase())) : e;
}
var $6aa68e0390eba24d$var$T = ()=>(0, $c53f8b07b96ee0c5$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-search-clear-icon gray",
        children: [
            (0, $c53f8b07b96ee0c5$exports.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            (0, $c53f8b07b96ee0c5$exports.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
var $6aa68e0390eba24d$var$Ue = ({ checked: e, option: n, onClick: t, disabled: r })=>(0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: `item-renderer ${r ? "disabled" : ""}`,
        children: [
            (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                type: "checkbox",
                onChange: t,
                checked: e,
                tabIndex: -1,
                disabled: r
            }),
            (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                children: n.label
            })
        ]
    }), $6aa68e0390eba24d$var$pe = $6aa68e0390eba24d$var$Ue;
var $6aa68e0390eba24d$var$Ye = ({ itemRenderer: e = $6aa68e0390eba24d$var$pe, option: n, checked: t, tabIndex: r, disabled: a, onSelectionChanged: c, onClick: u })=>{
    let b = (0, $lldlC.useRef)(), s = (l)=>{
        p(), l.preventDefault();
    }, p = ()=>{
        a || c(!t);
    }, i = (l)=>{
        p(), u(l);
    };
    return $6aa68e0390eba24d$var$R([
        $6aa68e0390eba24d$var$f.ENTER,
        $6aa68e0390eba24d$var$f.SPACE
    ], s, {
        target: b
    }), (0, $c53f8b07b96ee0c5$exports.jsx)("label", {
        className: `select-item ${t ? "selected" : ""}`,
        role: "option",
        "aria-selected": t,
        tabIndex: r,
        ref: b,
        children: (0, $c53f8b07b96ee0c5$exports.jsx)(e, {
            option: n,
            checked: t,
            onClick: i,
            disabled: a
        })
    });
}, $6aa68e0390eba24d$export$13ef48a934230896 = $6aa68e0390eba24d$var$Ye;
var $6aa68e0390eba24d$var$ze = ({ options: e, onClick: n, skipIndex: t })=>{
    let { disabled: r, value: a, onChange: c, ItemRenderer: u } = $6aa68e0390eba24d$var$w(), b = (s, p)=>{
        r || c(p ? [
            ...a,
            s
        ] : a.filter((i)=>i.value !== s.value));
    };
    return (0, $c53f8b07b96ee0c5$exports.jsx)((0, $c53f8b07b96ee0c5$exports.Fragment), {
        children: e.map((s, p)=>{
            let i = p + t;
            return (0, $c53f8b07b96ee0c5$exports.jsx)("li", {
                children: (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$export$13ef48a934230896, {
                    tabIndex: i,
                    option: s,
                    onSelectionChanged: (l)=>b(s, l),
                    checked: !!a.find((l)=>l.value === s.value),
                    onClick: (l)=>n(l, i),
                    itemRenderer: u,
                    disabled: s.disabled || r
                })
            }, (s == null ? void 0 : s.key) || p);
        })
    });
}, $6aa68e0390eba24d$var$ue = $6aa68e0390eba24d$var$ze;
var $6aa68e0390eba24d$var$Je = ()=>{
    let { t: e, onChange: n, options: t, setOptions: r, value: a, filterOptions: c, ItemRenderer: u, disabled: b, disableSearch: s, hasSelectAll: p, ClearIcon: i, debounceDuration: l, isCreatable: L, onCreateOption: y } = $6aa68e0390eba24d$var$w(), O = (0, $lldlC.useRef)(), g = (0, $lldlC.useRef)(), [m, M] = (0, $lldlC.useState)(""), [v, K] = (0, $lldlC.useState)(t), [x, D] = (0, $lldlC.useState)(""), [E, I] = (0, $lldlC.useState)(0), W = (0, $lldlC.useCallback)($6aa68e0390eba24d$var$le((o)=>D(o), l), []), A = (0, $lldlC.useMemo)(()=>{
        let o = 0;
        return s || (o += 1), p && (o += 1), o;
    }, [
        s,
        p
    ]), _ = {
        label: e(m ? "selectAllFiltered" : "selectAll"),
        value: ""
    }, H = (o)=>{
        let d = v.filter((C)=>!C.disabled).map((C)=>C.value);
        if (o) {
            let Ae = [
                ...a.map((U)=>U.value),
                ...d
            ];
            return (c ? v : t).filter((U)=>Ae.includes(U.value));
        }
        return a.filter((C)=>!d.includes(C.value));
    }, B = (o)=>{
        let d = H(o);
        n(d);
    }, h = (o)=>{
        W(o.target.value), M(o.target.value), I(0);
    }, P = ()=>{
        var o;
        D(""), M(""), (o = g == null ? void 0 : g.current) == null || o.focus();
    }, Z = (o)=>I(o), we = (o)=>{
        switch(o.code){
            case $6aa68e0390eba24d$var$f.ARROW_UP:
                ee(-1);
                break;
            case $6aa68e0390eba24d$var$f.ARROW_DOWN:
                ee(1);
                break;
            default:
                return;
        }
        o.stopPropagation(), o.preventDefault();
    };
    $6aa68e0390eba24d$var$R([
        $6aa68e0390eba24d$var$f.ARROW_DOWN,
        $6aa68e0390eba24d$var$f.ARROW_UP
    ], we, {
        target: O
    });
    let Oe = ()=>{
        I(0);
    }, j = async ()=>{
        let o = {
            label: m,
            value: m,
            __isNew__: !0
        };
        y && (o = await y(m)), r([
            o,
            ...t
        ]), P(), n([
            ...a,
            o
        ]);
    }, Re = async ()=>c ? await c(t, x) : $6aa68e0390eba24d$var$ie(t, x), ee = (o)=>{
        let d = E + o;
        d = Math.max(0, d), d = Math.min(d, t.length + Math.max(A - 1, 0)), I(d);
    };
    (0, $lldlC.useEffect)(()=>{
        var o, d;
        (d = (o = O == null ? void 0 : O.current) == null ? void 0 : o.querySelector(`[tabIndex='${E}']`)) == null || d.focus();
    }, [
        E
    ]);
    let [ke, Ee] = (0, $lldlC.useMemo)(()=>{
        let o = v.filter((d)=>!d.disabled);
        return [
            o.every((d)=>a.findIndex((C)=>C.value === d.value) !== -1),
            o.length !== 0
        ];
    }, [
        v,
        a
    ]);
    (0, $lldlC.useEffect)(()=>{
        Re().then(K);
    }, [
        x,
        t
    ]);
    let te = (0, $lldlC.useRef)();
    $6aa68e0390eba24d$var$R([
        $6aa68e0390eba24d$var$f.ENTER
    ], j, {
        target: te
    });
    let Ie = L && m && !v.some((o)=>(o == null ? void 0 : o.value) === m);
    return (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "select-panel",
        role: "listbox",
        ref: O,
        children: [
            !s && (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "search",
                children: [
                    (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                        placeholder: e("search"),
                        type: "text",
                        "aria-describedby": e("search"),
                        onChange: h,
                        onFocus: Oe,
                        value: m,
                        ref: g,
                        tabIndex: 0
                    }),
                    (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        type: "button",
                        className: "search-clear-button",
                        hidden: !m,
                        onClick: P,
                        "aria-label": e("clearSearch"),
                        children: i || (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$var$T, {})
                    })
                ]
            }),
            (0, $c53f8b07b96ee0c5$exports.jsxs)("ul", {
                className: "options",
                children: [
                    p && Ee && (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$export$13ef48a934230896, {
                        tabIndex: A === 1 ? 0 : 1,
                        checked: ke,
                        option: _,
                        onSelectionChanged: B,
                        onClick: ()=>Z(1),
                        itemRenderer: u,
                        disabled: b
                    }),
                    v.length ? (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$var$ue, {
                        skipIndex: A,
                        options: v,
                        onClick: (o, d)=>Z(d)
                    }) : Ie ? (0, $c53f8b07b96ee0c5$exports.jsx)("li", {
                        onClick: j,
                        className: "select-item creatable",
                        tabIndex: 1,
                        ref: te,
                        children: `${e("create")} "${m}"`
                    }) : (0, $c53f8b07b96ee0c5$exports.jsx)("li", {
                        className: "no-options",
                        children: e("noOptions")
                    })
                ]
            })
        ]
    });
}, $6aa68e0390eba24d$export$9640093ec8451560 = $6aa68e0390eba24d$var$Je;
var $6aa68e0390eba24d$var$ge = ({ expanded: e })=>(0, $c53f8b07b96ee0c5$exports.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-heading-dropdown-arrow gray",
        children: (0, $c53f8b07b96ee0c5$exports.jsx)("path", {
            d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
        })
    });
var $6aa68e0390eba24d$var$xe = ()=>{
    let { t: e, value: n, options: t, valueRenderer: r } = $6aa68e0390eba24d$var$w(), a = n.length === 0, c = n.length === t.length, u = r && r(n, t);
    return a ? (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
        className: "gray",
        children: u || e("selectSomeItems")
    }) : (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
        children: u || (c ? e("allItemsAreSelected") : (()=>n.map((s)=>s.label).join(", "))())
    });
};
var $6aa68e0390eba24d$var$Se = ({ size: e = 24 })=>(0, $c53f8b07b96ee0c5$exports.jsx)("span", {
        style: {
            width: e,
            marginRight: "0.2rem"
        },
        children: (0, $c53f8b07b96ee0c5$exports.jsx)("svg", {
            width: e,
            height: e,
            className: "spinner",
            viewBox: "0 0 50 50",
            style: {
                display: "inline",
                verticalAlign: "middle"
            },
            children: (0, $c53f8b07b96ee0c5$exports.jsx)("circle", {
                cx: "25",
                cy: "25",
                r: "20",
                fill: "none",
                className: "path"
            })
        })
    });
var $6aa68e0390eba24d$var$Xe = ()=>{
    let { t: e, onMenuToggle: n, ArrowRenderer: t, shouldToggleOnHover: r, isLoading: a, disabled: c, onChange: u, labelledBy: b, value: s, isOpen: p, defaultIsOpen: i, ClearSelectedIcon: l, closeOnChangedValue: L } = $6aa68e0390eba24d$var$w();
    (0, $lldlC.useEffect)(()=>{
        L && m(!1);
    }, [
        s
    ]);
    let [y, O] = (0, $lldlC.useState)(!0), [g, m] = (0, $lldlC.useState)(i), [M, v] = (0, $lldlC.useState)(!1), K = t || $6aa68e0390eba24d$var$ge, x = (0, $lldlC.useRef)();
    $6aa68e0390eba24d$var$se(()=>{
        n && n(g);
    }, [
        g
    ]), (0, $lldlC.useEffect)(()=>{
        i === void 0 && typeof p == "boolean" && (O(!1), m(p));
    }, [
        p
    ]);
    let D = (h)=>{
        var P;
        [
            "text",
            "button"
        ].includes(h.target.type) && [
            $6aa68e0390eba24d$var$f.SPACE,
            $6aa68e0390eba24d$var$f.ENTER
        ].includes(h.code) || (y && (h.code === $6aa68e0390eba24d$var$f.ESCAPE ? (m(!1), (P = x == null ? void 0 : x.current) == null || P.focus()) : m(!0)), h.preventDefault());
    };
    $6aa68e0390eba24d$var$R([
        $6aa68e0390eba24d$var$f.ENTER,
        $6aa68e0390eba24d$var$f.ARROW_DOWN,
        $6aa68e0390eba24d$var$f.SPACE,
        $6aa68e0390eba24d$var$f.ESCAPE
    ], D, {
        target: x
    });
    let E = (h)=>{
        y && r && m(h);
    }, I = ()=>!M && v(!0), W = (h)=>{
        !h.currentTarget.contains(h.relatedTarget) && y && (v(!1), m(!1));
    }, A = ()=>E(!0), _ = ()=>E(!1), H = ()=>{
        y && m(a || c ? !1 : !g);
    }, B = (h)=>{
        h.stopPropagation(), u([]), y && m(!1);
    };
    return (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        tabIndex: 0,
        className: "dropdown-container",
        "aria-labelledby": b,
        "aria-expanded": g,
        "aria-readonly": !0,
        "aria-disabled": c,
        ref: x,
        onFocus: I,
        onBlur: W,
        onMouseEnter: A,
        onMouseLeave: _,
        children: [
            (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "dropdown-heading",
                onClick: H,
                children: [
                    (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "dropdown-heading-value",
                        children: (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$var$xe, {})
                    }),
                    a && (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$var$Se, {}),
                    s.length > 0 && l !== null && (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        type: "button",
                        className: "clear-selected-button",
                        onClick: B,
                        disabled: c,
                        "aria-label": e("clearSelected"),
                        children: l || (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$var$T, {})
                    }),
                    (0, $c53f8b07b96ee0c5$exports.jsx)(K, {
                        expanded: g
                    })
                ]
            }),
            g && (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "dropdown-content",
                children: (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "panel-content",
                    children: (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$export$9640093ec8451560, {})
                })
            })
        ]
    });
}, $6aa68e0390eba24d$export$931cbfb6bfb85fc = $6aa68e0390eba24d$var$Xe;
var $6aa68e0390eba24d$var$Ze = (e)=>(0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$var$ne, {
        props: e,
        children: (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: `rmsc ${e.className || "multi-select"}`,
            children: (0, $c53f8b07b96ee0c5$exports.jsx)($6aa68e0390eba24d$export$931cbfb6bfb85fc, {})
        })
    }), $6aa68e0390eba24d$export$1e7dfd31545b5809 = $6aa68e0390eba24d$var$Ze;



const $b88351462d7cbf9a$var$getOption = (args)=>{
    return {
        value: args.optionKey(args.option),
        label: args.optionLabel(args.option),
        key: args.optionKey(args.option)
    };
};
const $b88351462d7cbf9a$var$getOptions = (props)=>{
    return props.options.map((option)=>{
        return $b88351462d7cbf9a$var$getOption({
            ...props,
            option: option
        });
    });
};
const $b88351462d7cbf9a$var$getValue = (props)=>{
    if (!props.value) return [];
    return props.value.map((option)=>{
        return $b88351462d7cbf9a$var$getOption({
            ...props,
            option: option
        });
    });
};
const $b88351462d7cbf9a$var$getSelection = (props, value)=>{
    if (!value) return [];
    return value// filter selected items
    .map((option)=>{
        return props.options.find((o)=>props.optionKey(o) === option.value);
    })// remove undefined
    .filter((item)=>!!item);
};
const $b88351462d7cbf9a$export$8cf908d07cc79854 = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $6aa68e0390eba24d$export$1e7dfd31545b5809), {
            options: $b88351462d7cbf9a$var$getOptions(props),
            value: $b88351462d7cbf9a$var$getValue(props),
            onChange: (value)=>props.onChange($b88351462d7cbf9a$var$getSelection(props, value)),
            labelledBy: "Select"
        })
    });
};





const $95f6f898f49af09d$export$99777c0b4d685f33 = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $13dba5a0e61e7643$export$6bf0cd3a219bbade), {
            ...props
        })
    });
};





const $80478a6bc1d9e6e9$export$fa6d43a807467bab = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $e1c6fd4a02d0fbd1$export$6508682d580a3f02), {
            ...props
        })
    });
};


/**
 * https://www.npmjs.com/package/react-multi-select-component
 */ 

const $91b3ecbead03c880$var$getOption = (args)=>{
    return {
        value: args.optionKey(args.option),
        label: args.optionLabel(args.option),
        key: args.optionKey(args.option)
    };
};
const $91b3ecbead03c880$var$getOptions = (props)=>{
    return props.options.map((option)=>{
        return $91b3ecbead03c880$var$getOption({
            ...props,
            option: option
        });
    });
};
const $91b3ecbead03c880$var$getValue = (props)=>{
    if (!props.value) return;
    return props.optionKey(props.value);
};
const $91b3ecbead03c880$var$getSelection = (props, value)=>{
    if (!value) return;
    return props.options.find((o)=>props.optionKey(o) === value);
};
const $91b3ecbead03c880$export$6440c30e7d5bd2b2 = (props)=>{
    const renderEmptyOption = ()=>{
        if (props.value) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("option", {
            value: undefined
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("select", {
            value: $91b3ecbead03c880$var$getValue(props),
            onChange: (e)=>{
                const selection = $91b3ecbead03c880$var$getSelection(props, e.target.value);
                if (!selection) return;
                props.onChange(selection);
            },
            children: [
                renderEmptyOption(),
                $91b3ecbead03c880$var$getOptions(props).map((option)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("option", {
                        value: option.value,
                        children: option.label
                    }, option.key))
            ]
        })
    });
};




const $b06375eda1b29984$export$bda2a0642da02a40 = (props)=>{
    //
    const { value: value, onChange: onChange, dataCy: dataCy } = props;
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        additionalClassNames: "switch",
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("label", {
            className: "form-switch",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                    type: "checkbox",
                    checked: value,
                    onChange: (e)=>onChange(e.target.checked),
                    "data-cy": dataCy
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("i", {})
            ]
        })
    });
};




parcelRequire("lldlC");

const $900430dc06a9a624$export$a83de22056f04f06 = (props)=>{
    const { value: value, onChange: onChange, validation: validation = (0, $bfcff1203c83f49a$export$80f9043b76a4e68e).success, rows: rows, dataCy: dataCy, placeholder: placeholder, maxLength: maxLength, onPressEnter: onPressEnter, onFocus: onFocus, onBlur: onBlur, customRef: customRef } = props;
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("textarea", {
            ref: customRef,
            rows: rows ?? 3,
            value: value,
            onChange: (e)=>onChange(e.target.value),
            className: validation.isValid ? "valid" : "invalid",
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyDown: (e)=>{
                if (e.key === "Enter" && onPressEnter) onPressEnter();
            },
            "data-cy": dataCy,
            placeholder: placeholder,
            maxLength: maxLength
        })
    });
};





const $2fee28811b42ff9c$export$519cf571a2a32ad4 = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $04349e24c8c71c6e$export$a595b5d109979b0e), {
        ...props,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $6f32961975b22fb5$export$c86715117507e8e5), {
            ...props
        })
    });
};





const $40f7d7c180b4911c$export$49611b08e3b2990 = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $2fee28811b42ff9c$export$519cf571a2a32ad4), {
                ...props
            }),
            (0, $46735892604b37f3$export$8304a22d431f958)(props.value) && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "url-preview",
                style: {
                    marginTop: "-10px"
                },
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                        children: "Preview: "
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                        href: props.value,
                        target: "_blank",
                        children: props.value
                    })
                ]
            })
        ]
    });
};


// import { toastStore } from '../toast/toastStore';

var $lldlC = parcelRequire("lldlC");

const $05178562c8dc0e7e$export$d94717ae0e8aa8b = (args)=>{
    //
    const [value, setValue] = (0, $lldlC.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $lldlC.useState)();
    (0, $lldlC.useEffect)(()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            ...args,
            setBusyFlag: setIsLoading,
            onSuccess: (value)=>{
                setValue(value);
            }
        });
    }, []);
    return {
        value: value,
        isLoading: isLoading
    };
};







var $91d6616b496711f3$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $91d6616b496711f3$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $91d6616b496711f3$export$70ffa26850098d01;
var $91d6616b496711f3$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $91d6616b496711f3$export$9f5a3dfc7a9f5dd = $91d6616b496711f3$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $91d6616b496711f3$export$70ffa26850098d01 = $91d6616b496711f3$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $91d6616b496711f3$var$commonjsGlobal !== 'undefined' ? $91d6616b496711f3$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


var $b187c2c19c5bc792$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $b187c2c19c5bc792$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $b187c2c19c5bc792$export$26404658cda3ee02;
var $b187c2c19c5bc792$export$ddb1030448106742;
var $b187c2c19c5bc792$export$aa726fb96ad3e039;
var $b187c2c19c5bc792$export$3d7865934588d77e;
var $b187c2c19c5bc792$export$d4e71bc0b80dc0fb;
var $b187c2c19c5bc792$export$cbbc350c1dfc80cb;
var $b187c2c19c5bc792$export$d61e24a684f9e51;
var $b187c2c19c5bc792$export$888d0d9ab79d08fc;
var $b187c2c19c5bc792$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $b187c2c19c5bc792$var$commonjsGlobal && $b187c2c19c5bc792$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a;
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        const b = a.length;
        if (0 < b) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(let c = 1; c < arguments.length; c++){
            const d = arguments[c];
            if (ha(d)) {
                const e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(let g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    class na {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class Aa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = Ba.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var Ba = new na(()=>new Ca, (a)=>a.reset());
    class Ca {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let x, y = !1, za = new Aa, Ea = ()=>{
        const a = k.Promise.resolve(void 0);
        x = ()=>{
            a.then(Da);
        };
    };
    var Da = ()=>{
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(()=>{
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class eb extends z {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : cb(this);
        }
        N() {
            super.N();
            this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = class {
        stringify(a) {
            return k.JSON.stringify(a, void 0);
        }
        parse(a) {
            return k.JSON.parse(a, void 0);
        }
    };
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        const b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        const b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        const b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const w = P(this.g);
                var b = this.g.Ba();
                const O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            let B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        const a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    let l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            const v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            const w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            const O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            const B = a.g;
                            if (B) {
                                const ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    const db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.D);
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(const d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(let d = 0; d < b.length; d++){
            const e = a[d];
            for(let f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        let b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            const f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        const c = new vb;
        if (k.Image) {
            const d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        const c = new vb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        const d = c || "";
        try {
            nc(a, function(e, f) {
                let g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        const b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function() {
            return "include" === this.m;
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        let b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    const g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            const c = a.g, d = a.v[0] ? ()=>{} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        const b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            const e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    const e = new M(this, this.j, a);
                    let f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        const d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            let f = -1;
            for(;;){
                const g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                let m = !0;
                for(let q = 0; q < c; q++){
                    let l = e[q].g;
                    const v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        let c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            const b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $b187c2c19c5bc792$export$66869136fc133c3a = $b187c2c19c5bc792$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new hd;
    };
    $b187c2c19c5bc792$export$888d0d9ab79d08fc = $b187c2c19c5bc792$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return qb();
    };
    $b187c2c19c5bc792$export$d61e24a684f9e51 = $b187c2c19c5bc792$export$2e2bcd8739ae039.Event = I;
    $b187c2c19c5bc792$export$cbbc350c1dfc80cb = $b187c2c19c5bc792$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $b187c2c19c5bc792$export$d4e71bc0b80dc0fb = $b187c2c19c5bc792$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $b187c2c19c5bc792$export$3d7865934588d77e = $b187c2c19c5bc792$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $b187c2c19c5bc792$export$aa726fb96ad3e039 = $b187c2c19c5bc792$export$2e2bcd8739ae039.WebChannel = mb;
    $b187c2c19c5bc792$export$ddb1030448106742 = $b187c2c19c5bc792$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $b187c2c19c5bc792$export$26404658cda3ee02 = $b187c2c19c5bc792$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $b187c2c19c5bc792$var$commonjsGlobal !== 'undefined' ? $b187c2c19c5bc792$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf);
    else return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $4a6eda7d0e4e0857$export$d622b2ad8d90c771($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $fd179abe7398b4e4$require$Buffer = $8dff54558831dec9$export$a143d493d941bafc;
const $fd179abe7398b4e4$var$S = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $fd179abe7398b4e4$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $fd179abe7398b4e4$var$User.UNAUTHENTICATED = new $fd179abe7398b4e4$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$fd179abe7398b4e4$var$User.GOOGLE_CREDENTIALS = new $fd179abe7398b4e4$var$User("google-credentials-uid"), $fd179abe7398b4e4$var$User.FIRST_PARTY = new $fd179abe7398b4e4$var$User("first-party-uid"), $fd179abe7398b4e4$var$User.MOCK_USER = new $fd179abe7398b4e4$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $fd179abe7398b4e4$var$b = "10.12.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$D = new (0, $b3ab7ef8f3a0a29a$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $fd179abe7398b4e4$var$__PRIVATE_getLogLevel() {
    return $fd179abe7398b4e4$var$D.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $fd179abe7398b4e4$export$c622e99c0ce7b1c9(e) {
    $fd179abe7398b4e4$var$D.setLogLevel(e);
}
function $fd179abe7398b4e4$var$__PRIVATE_logDebug(e, ...t) {
    if ($fd179abe7398b4e4$var$D.logLevel <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($fd179abe7398b4e4$var$__PRIVATE_argToString);
        $fd179abe7398b4e4$var$D.debug(`Firestore (${$fd179abe7398b4e4$var$b}): ${e}`, ...n);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_logError(e, ...t) {
    if ($fd179abe7398b4e4$var$D.logLevel <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).ERROR) {
        const n = t.map($fd179abe7398b4e4$var$__PRIVATE_argToString);
        $fd179abe7398b4e4$var$D.error(`Firestore (${$fd179abe7398b4e4$var$b}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $fd179abe7398b4e4$export$86cd73f49cc6e0bb(e, ...t) {
    if ($fd179abe7398b4e4$var$D.logLevel <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).WARN) {
        const n = t.map($fd179abe7398b4e4$var$__PRIVATE_argToString);
        $fd179abe7398b4e4$var$D.warn(`Firestore (${$fd179abe7398b4e4$var$b}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $fd179abe7398b4e4$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $fd179abe7398b4e4$var$fail(e = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const t = `FIRESTORE (${$fd179abe7398b4e4$var$b}) INTERNAL ASSERTION FAILED: ` + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $fd179abe7398b4e4$var$__PRIVATE_logError(t), new Error(t);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $fd179abe7398b4e4$var$__PRIVATE_hardAssert(e, t) {
    e || $fd179abe7398b4e4$var$fail();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $fd179abe7398b4e4$export$1d2b90eea9bba017(e, t) {
    e || $fd179abe7398b4e4$var$fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $fd179abe7398b4e4$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$C = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $fd179abe7398b4e4$export$8fada0bf726bf278 extends (0, $59fdd18afb377ad5$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $fd179abe7398b4e4$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($fd179abe7398b4e4$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $fd179abe7398b4e4$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $fd179abe7398b4e4$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken();
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($fd179abe7398b4e4$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($fd179abe7398b4e4$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($fd179abe7398b4e4$var$__PRIVATE_hardAssert("string" == typeof t.accessToken), new $fd179abe7398b4e4$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.auth.removeAuthTokenListener(this.o);
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $fd179abe7398b4e4$var$__PRIVATE_hardAssert(null === e || "string" == typeof e), new $fd179abe7398b4e4$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $fd179abe7398b4e4$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = $fd179abe7398b4e4$var$User.FIRST_PARTY, this.I = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ T() {
        return this.P ? this.P() : null;
    }
    get headers() {
        this.I.set("X-Goog-AuthUser", this.l);
        // Use array notation to prevent minification
        const e = this.T();
        return e && this.I.set("Authorization", e), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $fd179abe7398b4e4$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n;
    }
    getToken() {
        return Promise.resolve(new $fd179abe7398b4e4$var$__PRIVATE_FirstPartyToken(this.l, this.h, this.P));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($fd179abe7398b4e4$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $fd179abe7398b4e4$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(e){
        this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
    }
    start(e, t) {
        const onTokenChanged = (e)=>{
            null != e.error && $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.R;
            return this.R = e.token, $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.appCheck.addTokenListener(this.o);
        };
        this.A.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.A.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($fd179abe7398b4e4$var$__PRIVATE_hardAssert("string" == typeof e.token), this.R = e.token, new $fd179abe7398b4e4$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.appCheck.removeTokenListener(this.o);
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $fd179abe7398b4e4$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $fd179abe7398b4e4$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $fd179abe7398b4e4$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $fd179abe7398b4e4$export$253bcaa5572dcc83 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $fd179abe7398b4e4$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
        }
        return n;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $fd179abe7398b4e4$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $fd179abe7398b4e4$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $fd179abe7398b4e4$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $fd179abe7398b4e4$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $fd179abe7398b4e4$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor(1e6 * (e - 1e3 * t));
        return new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexiographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexiographical ordering.
        const e = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $fd179abe7398b4e4$var$SnapshotVersion {
    constructor(e){
        this.timestamp = e;
    }
    static fromTimestamp(e) {
        return new $fd179abe7398b4e4$var$SnapshotVersion(e);
    }
    static min() {
        return new $fd179abe7398b4e4$var$SnapshotVersion(new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $fd179abe7398b4e4$var$SnapshotVersion(new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $fd179abe7398b4e4$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $fd179abe7398b4e4$var$fail(), void 0 === n ? n = e.length - t : n > e.length - t && $fd179abe7398b4e4$var$fail(), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $fd179abe7398b4e4$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $fd179abe7398b4e4$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = e.get(r), i = t.get(r);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $fd179abe7398b4e4$var$ResourcePath extends $fd179abe7398b4e4$var$BasePath {
    construct(e, t, n) {
        return new $fd179abe7398b4e4$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and traling slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $fd179abe7398b4e4$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $fd179abe7398b4e4$var$ResourcePath([]);
    }
}
const $fd179abe7398b4e4$var$v = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $fd179abe7398b4e4$export$b7871852b967eaf1 extends $fd179abe7398b4e4$var$BasePath {
    construct(e, t, n) {
        return new $fd179abe7398b4e4$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $fd179abe7398b4e4$var$v.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $fd179abe7398b4e4$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $fd179abe7398b4e4$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $fd179abe7398b4e4$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $fd179abe7398b4e4$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $fd179abe7398b4e4$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $fd179abe7398b4e4$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $fd179abe7398b4e4$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $fd179abe7398b4e4$export$afc2e57c475b7810(new $fd179abe7398b4e4$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $fd179abe7398b4e4$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $fd179abe7398b4e4$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $fd179abe7398b4e4$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $fd179abe7398b4e4$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $fd179abe7398b4e4$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $fd179abe7398b4e4$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $fd179abe7398b4e4$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $fd179abe7398b4e4$var$IndexState(0, $fd179abe7398b4e4$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $fd179abe7398b4e4$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $fd179abe7398b4e4$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(n + 1, 0) : new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(n, r));
    return new $fd179abe7398b4e4$var$IndexOffset(i, $fd179abe7398b4e4$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $fd179abe7398b4e4$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $fd179abe7398b4e4$var$IndexOffset(e.readTime, e.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $fd179abe7398b4e4$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $fd179abe7398b4e4$var$IndexOffset($fd179abe7398b4e4$var$SnapshotVersion.min(), $fd179abe7398b4e4$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $fd179abe7398b4e4$var$IndexOffset($fd179abe7398b4e4$var$SnapshotVersion.max(), $fd179abe7398b4e4$export$afc2e57c475b7810.empty(), -1);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $fd179abe7398b4e4$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$F = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $fd179abe7398b4e4$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $fd179abe7398b4e4$var$C.FAILED_PRECONDITION || e.message !== $fd179abe7398b4e4$var$F) throw e;
    $fd179abe7398b4e4$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $fd179abe7398b4e4$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $fd179abe7398b4e4$var$fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $fd179abe7398b4e4$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $fd179abe7398b4e4$var$PersistencePromise ? t : $fd179abe7398b4e4$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $fd179abe7398b4e4$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $fd179abe7398b4e4$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $fd179abe7398b4e4$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $fd179abe7398b4e4$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $fd179abe7398b4e4$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $fd179abe7398b4e4$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $fd179abe7398b4e4$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $fd179abe7398b4e4$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $fd179abe7398b4e4$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $fd179abe7398b4e4$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $fd179abe7398b4e4$var$__PRIVATE_SimpleDbTransaction {
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.V = new $fd179abe7398b4e4$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.V.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.V.reject(new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.V.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $fd179abe7398b4e4$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.V.reject(new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    static open(e, t, n, r) {
        try {
            return new $fd179abe7398b4e4$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    get m() {
        return this.V.promise;
    }
    abort(e) {
        e && this.V.reject(e), this.aborted || ($fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    g() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $fd179abe7398b4e4$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $fd179abe7398b4e4$var$__PRIVATE_SimpleDb {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.p = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $fd179abe7398b4e4$var$__PRIVATE_SimpleDb.S((0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) && $fd179abe7398b4e4$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ static delete(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "Removing database:", e), $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static D() {
        if (!(0, $59fdd18afb377ad5$export$3865db50535c2055)()) return !1;
        if ($fd179abe7398b4e4$var$__PRIVATE_SimpleDb.C()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)(), t = $fd179abe7398b4e4$var$__PRIVATE_SimpleDb.S(e), n = 0 < t && t < 10, r = $fd179abe7398b4e4$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static C() {
        var e;
        return "undefined" != typeof $371a3837fd81d701$exports && "YES" === (null === (e = $371a3837fd81d701$exports.__PRIVATE_env) || void 0 === e ? void 0 : e.v);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static F(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static S(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async M(e) {
        return this.db || ($fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.p.O(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.N && (this.db.onversionchange = (e)=>this.N(e)), this.db;
    }
    L(e) {
        this.N = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.M(e);
                const t = $fd179abe7398b4e4$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.g(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $fd179abe7398b4e4$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.m, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $fd179abe7398b4e4$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IterationController {
    constructor(e){
        this.B = e, this.k = !1, this.q = null;
    }
    get isDone() {
        return this.k;
    }
    get K() {
        return this.q;
    }
    set cursor(e) {
        this.B = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.k = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ $(e) {
        this.q = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(this.B.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransactionError extends $fd179abe7398b4e4$export$8fada0bf726bf278 {
    constructor(e, t){
        super($fd179abe7398b4e4$var$C.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $fd179abe7398b4e4$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
        return $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
        return $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
        return $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(this.store.count());
    }
    U(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $fd179abe7398b4e4$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.W(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ G(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $fd179abe7398b4e4$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    j(e, t) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.H = !1;
        const r = this.cursor(n);
        return this.W(r, (e, t, n)=>n.delete());
    }
    J(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.W(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Y(e) {
        const t = this.cursor({});
        return new $fd179abe7398b4e4$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $fd179abe7398b4e4$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    W(e, t) {
        const n = [];
        return new $fd179abe7398b4e4$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $fd179abe7398b4e4$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $fd179abe7398b4e4$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $fd179abe7398b4e4$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.K ? i.continue() : i.continue(s.K);
            };
        }).next(()=>$fd179abe7398b4e4$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.H ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $fd179abe7398b4e4$var$__PRIVATE_wrapRequest(e) {
    return new $fd179abe7398b4e4$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $fd179abe7398b4e4$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $fd179abe7398b4e4$var$M = !1;
function $fd179abe7398b4e4$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_SimpleDb.S((0, $59fdd18afb377ad5$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $fd179abe7398b4e4$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $fd179abe7398b4e4$var$M || ($fd179abe7398b4e4$var$M = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $fd179abe7398b4e4$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.Z = t, this.task = null;
    }
    start() {
        this.X(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    X(e) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexBackfiller", `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexBackfiller", `Documents written: ${await this.Z.ee()}`);
            } catch (e) {
                $fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e) ? $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexBackfiller", "Ignoring IndexedDB error during index backfill: ", e) : await $fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.X(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $fd179abe7398b4e4$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ee(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.te(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ te(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $fd179abe7398b4e4$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexBackfiller", `Processing collection: ${t}`), this.ne(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ ne(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.re(r, n)).next((n)=>($fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexBackfiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ re(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $fd179abe7398b4e4$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $fd179abe7398b4e4$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $fd179abe7398b4e4$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $fd179abe7398b4e4$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ie(e), this.se = (e)=>t.writeSequenceNumber(e));
    }
    ie(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.se && this.se(e), e;
    }
}
$fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $fd179abe7398b4e4$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $fd179abe7398b4e4$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $fd179abe7398b4e4$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$fd179abe7398b4e4$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $fd179abe7398b4e4$var$__PRIVATE_encodeSeparator(t)), t = $fd179abe7398b4e4$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $fd179abe7398b4e4$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $fd179abe7398b4e4$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case "":
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $fd179abe7398b4e4$var$__PRIVATE_encodeSeparator(e) {
    return e + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(t >= 2), 2 === t) return $fd179abe7398b4e4$var$__PRIVATE_hardAssert("" === e.charAt(0) && "" === e.charAt(1)), $fd179abe7398b4e4$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf("", i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $fd179abe7398b4e4$var$fail();
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $fd179abe7398b4e4$var$fail();
        }
        i = t + 2;
    }
    return new $fd179abe7398b4e4$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$x = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $fd179abe7398b4e4$var$O = {}, $fd179abe7398b4e4$var$N = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $fd179abe7398b4e4$var$L = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $fd179abe7398b4e4$var$B = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $fd179abe7398b4e4$var$k = [
    "canonicalId",
    "targetId"
], $fd179abe7398b4e4$var$q = [
    "targetId",
    "path"
], $fd179abe7398b4e4$var$Q = [
    "path",
    "targetId"
], $fd179abe7398b4e4$var$K = [
    "collectionId",
    "parent"
], $fd179abe7398b4e4$var$$ = [
    "indexId",
    "uid"
], $fd179abe7398b4e4$var$U = [
    "uid",
    "sequenceNumber"
], $fd179abe7398b4e4$var$W = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $fd179abe7398b4e4$var$G = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $fd179abe7398b4e4$var$z = [
    "userId",
    "collectionPath",
    "documentId"
], $fd179abe7398b4e4$var$j = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $fd179abe7398b4e4$var$H = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $fd179abe7398b4e4$var$J = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $fd179abe7398b4e4$var$Y = [
    ...$fd179abe7398b4e4$var$J,
    "documentOverlays"
], $fd179abe7398b4e4$var$Z = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $fd179abe7398b4e4$var$X = $fd179abe7398b4e4$var$Z, $fd179abe7398b4e4$var$ee = [
    ...$fd179abe7398b4e4$var$X,
    "indexConfiguration",
    "indexState",
    "indexEntries"
], $fd179abe7398b4e4$var$te = $fd179abe7398b4e4$var$ee;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransaction extends $fd179abe7398b4e4$var$PersistenceTransaction {
    constructor(e, t){
        super(), this._e = e, this.currentSequenceNumber = t;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_getStore(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return $fd179abe7398b4e4$var$__PRIVATE_SimpleDb.F(n._e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fd179abe7398b4e4$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $fd179abe7398b4e4$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $fd179abe7398b4e4$var$__PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $fd179abe7398b4e4$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $fd179abe7398b4e4$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $fd179abe7398b4e4$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $fd179abe7398b4e4$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $fd179abe7398b4e4$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $fd179abe7398b4e4$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $fd179abe7398b4e4$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $fd179abe7398b4e4$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $fd179abe7398b4e4$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $fd179abe7398b4e4$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $fd179abe7398b4e4$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $fd179abe7398b4e4$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $fd179abe7398b4e4$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $fd179abe7398b4e4$var$LLRBNode.RED, this.left = null != r ? r : $fd179abe7398b4e4$var$LLRBNode.EMPTY, this.right = null != i ? i : $fd179abe7398b4e4$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $fd179abe7398b4e4$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $fd179abe7398b4e4$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $fd179abe7398b4e4$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $fd179abe7398b4e4$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $fd179abe7398b4e4$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $fd179abe7398b4e4$var$fail();
        if (this.right.isRed()) throw $fd179abe7398b4e4$var$fail();
        const e = this.left.check();
        if (e !== this.right.check()) throw $fd179abe7398b4e4$var$fail();
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$fd179abe7398b4e4$var$LLRBNode.EMPTY = null, $fd179abe7398b4e4$var$LLRBNode.RED = !0, $fd179abe7398b4e4$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$fd179abe7398b4e4$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $fd179abe7398b4e4$var$fail();
    }
    get value() {
        throw $fd179abe7398b4e4$var$fail();
    }
    get color() {
        throw $fd179abe7398b4e4$var$fail();
    }
    get left() {
        throw $fd179abe7398b4e4$var$fail();
    }
    get right() {
        throw $fd179abe7398b4e4$var$fail();
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $fd179abe7398b4e4$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $fd179abe7398b4e4$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $fd179abe7398b4e4$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $fd179abe7398b4e4$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $fd179abe7398b4e4$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $fd179abe7398b4e4$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $fd179abe7398b4e4$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $fd179abe7398b4e4$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $fd179abe7398b4e4$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $fd179abe7398b4e4$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($fd179abe7398b4e4$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $fd179abe7398b4e4$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $fd179abe7398b4e4$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $fd179abe7398b4e4$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $fd179abe7398b4e4$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $fd179abe7398b4e4$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $fd179abe7398b4e4$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $fd179abe7398b4e4$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $fd179abe7398b4e4$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $fd179abe7398b4e4$export$67460cdabfa21253("");
const $fd179abe7398b4e4$var$ne = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $fd179abe7398b4e4$var$ne.exec(e);
        if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $fd179abe7398b4e4$export$67460cdabfa21253.fromBase64String(e) : $fd179abe7398b4e4$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $fd179abe7398b4e4$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $fd179abe7398b4e4$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields.__previous_value__;
    return $fd179abe7398b4e4$var$__PRIVATE_isServerTimestamp(t) ? $fd179abe7398b4e4$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $fd179abe7398b4e4$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);
    return new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $fd179abe7398b4e4$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || "(default)";
    }
    static empty() {
        return new $fd179abe7398b4e4$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(e) {
        return e instanceof $fd179abe7398b4e4$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$re = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $fd179abe7398b4e4$var$ie = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $fd179abe7398b4e4$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $fd179abe7398b4e4$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $fd179abe7398b4e4$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : 10 /* TypeOrder.ObjectValue */  : $fd179abe7398b4e4$var$fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $fd179abe7398b4e4$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $fd179abe7398b4e4$var$__PRIVATE_typeOrder(e);
    if (n !== $fd179abe7398b4e4$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $fd179abe7398b4e4$var$__PRIVATE_getLocalWriteTime(e).isEqual($fd179abe7398b4e4$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.integerValue) === $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $fd179abe7398b4e4$var$__PRIVATE_isNegativeZero(n) === $fd179abe7398b4e4$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $fd179abe7398b4e4$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $fd179abe7398b4e4$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($fd179abe7398b4e4$var$__PRIVATE_objectSize(n) !== $fd179abe7398b4e4$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$fd179abe7398b4e4$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $fd179abe7398b4e4$var$fail();
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$fd179abe7398b4e4$var$__PRIVATE_valueEquals(e, t));
}
function $fd179abe7398b4e4$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $fd179abe7398b4e4$var$__PRIVATE_typeOrder(e), r = $fd179abe7398b4e4$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $fd179abe7398b4e4$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $fd179abe7398b4e4$var$__PRIVATE_compareTimestamps($fd179abe7398b4e4$var$__PRIVATE_getLocalWriteTime(e), $fd179abe7398b4e4$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(e), r = $fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator($fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.latitude), $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator($fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.longitude), $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_compareArrays(e, t) {
                const n = e.values || [], r = t.values || [];
                for(let e = 0; e < n.length && e < r.length; ++e){
                    const t = $fd179abe7398b4e4$var$__PRIVATE_valueCompare(n[e], r[e]);
                    if (t) return t;
                }
                return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $fd179abe7398b4e4$var$re.mapValue && t === $fd179abe7398b4e4$var$re.mapValue) return 0;
                if (e === $fd179abe7398b4e4$var$re.mapValue) return 1;
                if (t === $fd179abe7398b4e4$var$re.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $fd179abe7398b4e4$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $fd179abe7398b4e4$var$fail();
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e, t);
    const n = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(e), r = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(t), i = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $fd179abe7398b4e4$var$canonicalId(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_canonifyValue(e);
}
function $fd179abe7398b4e4$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $fd179abe7398b4e4$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $fd179abe7398b4e4$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$fd179abe7398b4e4$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_estimateByteSize(e) {
    switch($fd179abe7398b4e4$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $fd179abe7398b4e4$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $fd179abe7398b4e4$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $fd179abe7398b4e4$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $fd179abe7398b4e4$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $fd179abe7398b4e4$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $fd179abe7398b4e4$var$fail();
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $fd179abe7398b4e4$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $fd179abe7398b4e4$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $fd179abe7398b4e4$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $fd179abe7398b4e4$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $fd179abe7398b4e4$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Creates a deep copy of `source`. */ function $fd179abe7398b4e4$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $fd179abe7398b4e4$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $fd179abe7398b4e4$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $fd179abe7398b4e4$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $fd179abe7398b4e4$var$__PRIVATE_isMaxValue(e) {
    return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function $fd179abe7398b4e4$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $fd179abe7398b4e4$var$ie : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $fd179abe7398b4e4$var$__PRIVATE_refValue($fd179abe7398b4e4$export$4c3ccc07620ae30a.empty(), $fd179abe7398b4e4$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? {
        mapValue: {}
    } : $fd179abe7398b4e4$var$fail();
}
/** Returns the largest value for the given value type (exclusive). */ function $fd179abe7398b4e4$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $fd179abe7398b4e4$var$__PRIVATE_refValue($fd179abe7398b4e4$export$4c3ccc07620ae30a.empty(), $fd179abe7398b4e4$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? {
        mapValue: {}
    } : "mapValue" in e ? $fd179abe7398b4e4$var$re : $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $fd179abe7398b4e4$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $fd179abe7398b4e4$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $fd179abe7398b4e4$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$fd179abe7398b4e4$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $fd179abe7398b4e4$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $fd179abe7398b4e4$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $fd179abe7398b4e4$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $fd179abe7398b4e4$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $fd179abe7398b4e4$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $fd179abe7398b4e4$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $fd179abe7398b4e4$var$ObjectValue($fd179abe7398b4e4$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $fd179abe7398b4e4$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $fd179abe7398b4e4$var$forEach(e.fields, (e, n)=>{
        const r = new $fd179abe7398b4e4$export$b7871852b967eaf1([
            e
        ]);
        if ($fd179abe7398b4e4$var$__PRIVATE_isMapValue(n)) {
            const e = $fd179abe7398b4e4$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $fd179abe7398b4e4$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $fd179abe7398b4e4$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $fd179abe7398b4e4$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $fd179abe7398b4e4$var$SnapshotVersion.min(), /* readTime */ $fd179abe7398b4e4$var$SnapshotVersion.min(), /* createTime */ $fd179abe7398b4e4$var$SnapshotVersion.min(), $fd179abe7398b4e4$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $fd179abe7398b4e4$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $fd179abe7398b4e4$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $fd179abe7398b4e4$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $fd179abe7398b4e4$var$SnapshotVersion.min(), /* createTime */ $fd179abe7398b4e4$var$SnapshotVersion.min(), $fd179abe7398b4e4$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $fd179abe7398b4e4$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $fd179abe7398b4e4$var$SnapshotVersion.min(), /* createTime */ $fd179abe7398b4e4$var$SnapshotVersion.min(), $fd179abe7398b4e4$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $fd179abe7398b4e4$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $fd179abe7398b4e4$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $fd179abe7398b4e4$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $fd179abe7398b4e4$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $fd179abe7398b4e4$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $fd179abe7398b4e4$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $fd179abe7398b4e4$export$afc2e57c475b7810.comparator($fd179abe7398b4e4$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $fd179abe7398b4e4$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $fd179abe7398b4e4$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$fd179abe7398b4e4$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $fd179abe7398b4e4$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$Filter {
}
class $fd179abe7398b4e4$var$FieldFilter extends $fd179abe7398b4e4$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $fd179abe7398b4e4$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $fd179abe7398b4e4$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $fd179abe7398b4e4$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $fd179abe7398b4e4$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $fd179abe7398b4e4$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $fd179abe7398b4e4$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $fd179abe7398b4e4$var$__PRIVATE_KeyFieldInFilter(e, n) : new $fd179abe7398b4e4$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && this.matchesComparison($fd179abe7398b4e4$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $fd179abe7398b4e4$var$__PRIVATE_typeOrder(this.value) === $fd179abe7398b4e4$var$__PRIVATE_typeOrder(t) && this.matchesComparison($fd179abe7398b4e4$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $fd179abe7398b4e4$var$fail();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $fd179abe7398b4e4$var$CompositeFilter extends $fd179abe7398b4e4$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.ae = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $fd179abe7398b4e4$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.ae || (this.ae = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.ae;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsFlat(e) && $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $fd179abe7398b4e4$var$CompositeFilter) return !1;
    return !0;
}
function $fd179abe7398b4e4$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $fd179abe7398b4e4$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $fd179abe7398b4e4$var$canonicalId(e.value);
    if ($fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $fd179abe7398b4e4$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $fd179abe7398b4e4$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $fd179abe7398b4e4$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $fd179abe7398b4e4$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $fd179abe7398b4e4$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $fd179abe7398b4e4$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $fd179abe7398b4e4$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $fd179abe7398b4e4$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $fd179abe7398b4e4$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$fd179abe7398b4e4$var$canonicalId(e.value)}`;
    }(e) : e instanceof $fd179abe7398b4e4$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($fd179abe7398b4e4$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $fd179abe7398b4e4$var$__PRIVATE_KeyFieldFilter extends $fd179abe7398b4e4$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $fd179abe7398b4e4$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $fd179abe7398b4e4$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $fd179abe7398b4e4$var$__PRIVATE_KeyFieldInFilter extends $fd179abe7398b4e4$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $fd179abe7398b4e4$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $fd179abe7398b4e4$var$__PRIVATE_KeyFieldNotInFilter extends $fd179abe7398b4e4$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $fd179abe7398b4e4$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e)=>$fd179abe7398b4e4$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $fd179abe7398b4e4$var$__PRIVATE_ArrayContainsFilter extends $fd179abe7398b4e4$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $fd179abe7398b4e4$var$isArray(t) && $fd179abe7398b4e4$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $fd179abe7398b4e4$var$__PRIVATE_InFilter extends $fd179abe7398b4e4$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $fd179abe7398b4e4$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $fd179abe7398b4e4$var$__PRIVATE_NotInFilter extends $fd179abe7398b4e4$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($fd179abe7398b4e4$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && !$fd179abe7398b4e4$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $fd179abe7398b4e4$var$__PRIVATE_ArrayContainsAnyFilter extends $fd179abe7398b4e4$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$fd179abe7398b4e4$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$fd179abe7398b4e4$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $fd179abe7398b4e4$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.ue = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $fd179abe7398b4e4$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $fd179abe7398b4e4$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $fd179abe7398b4e4$var$__PRIVATE_canonifyTarget(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    if (null === t.ue) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $fd179abe7398b4e4$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$fd179abe7398b4e4$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$fd179abe7398b4e4$var$canonicalId(e)).join(",")), t.ue = e;
    }
    return t.ue;
}
function $fd179abe7398b4e4$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$fd179abe7398b4e4$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$fd179abe7398b4e4$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$fd179abe7398b4e4$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $fd179abe7398b4e4$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $fd179abe7398b4e4$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $fd179abe7398b4e4$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $fd179abe7398b4e4$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $fd179abe7398b4e4$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $fd179abe7398b4e4$var$ie, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $fd179abe7398b4e4$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $fd179abe7398b4e4$var$ie, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $fd179abe7398b4e4$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $fd179abe7398b4e4$var$ie;
        }
        $fd179abe7398b4e4$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $fd179abe7398b4e4$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $fd179abe7398b4e4$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $fd179abe7398b4e4$var$re, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $fd179abe7398b4e4$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $fd179abe7398b4e4$var$re, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $fd179abe7398b4e4$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $fd179abe7398b4e4$var$re;
        }
        $fd179abe7398b4e4$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $fd179abe7398b4e4$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $fd179abe7398b4e4$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.ce = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.le = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.he = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $fd179abe7398b4e4$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $fd179abe7398b4e4$var$__PRIVATE_newQueryForPath(e) {
    return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $fd179abe7398b4e4$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $fd179abe7398b4e4$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $fd179abe7398b4e4$var$__PRIVATE_queryNormalizedOrderBy(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    if (null === t.ce) {
        t.ce = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.ce.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$export$b7871852b967eaf1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new $fd179abe7398b4e4$var$OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($fd179abe7398b4e4$export$b7871852b967eaf1.keyField().canonicalString()) || t.ce.push(new $fd179abe7398b4e4$var$OrderBy($fd179abe7398b4e4$export$b7871852b967eaf1.keyField(), n));
    }
    return t.ce;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return t.le || (t.le = $fd179abe7398b4e4$var$__PRIVATE__queryToTarget(t, $fd179abe7398b4e4$var$__PRIVATE_queryNormalizedOrderBy(e))), t.le;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $fd179abe7398b4e4$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return t.he || // Do not include implicit order-bys for aggregate queries.
    (t.he = $fd179abe7398b4e4$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.he;
}
function $fd179abe7398b4e4$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $fd179abe7398b4e4$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $fd179abe7398b4e4$var$OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $fd179abe7398b4e4$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $fd179abe7398b4e4$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $fd179abe7398b4e4$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $fd179abe7398b4e4$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $fd179abe7398b4e4$var$__PRIVATE_queryEquals(e, t) {
    return $fd179abe7398b4e4$var$__PRIVATE_targetEquals($fd179abe7398b4e4$var$__PRIVATE_queryToTarget(e), $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $fd179abe7398b4e4$var$__PRIVATE_canonifyQuery(e) {
    return `${$fd179abe7398b4e4$var$__PRIVATE_canonifyTarget($fd179abe7398b4e4$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $fd179abe7398b4e4$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $fd179abe7398b4e4$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$fd179abe7398b4e4$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$fd179abe7398b4e4$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($fd179abe7398b4e4$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $fd179abe7398b4e4$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $fd179abe7398b4e4$var$__PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $fd179abe7398b4e4$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $fd179abe7398b4e4$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $fd179abe7398b4e4$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $fd179abe7398b4e4$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $fd179abe7398b4e4$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $fd179abe7398b4e4$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $fd179abe7398b4e4$var$__PRIVATE_queryNormalizedOrderBy(e)){
            const e = $fd179abe7398b4e4$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $fd179abe7398b4e4$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $fd179abe7398b4e4$var$__PRIVATE_valueCompare(r, i) : $fd179abe7398b4e4$var$fail();
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $fd179abe7398b4e4$var$fail();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $fd179abe7398b4e4$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $fd179abe7398b4e4$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $fd179abe7398b4e4$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$se = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
function $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap() {
    return $fd179abe7398b4e4$var$se;
}
const $fd179abe7398b4e4$var$oe = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
function $fd179abe7398b4e4$var$documentMap(...e) {
    let t = $fd179abe7398b4e4$var$oe;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $fd179abe7398b4e4$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $fd179abe7398b4e4$var$oe;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap() {
    return $fd179abe7398b4e4$var$__PRIVATE_newDocumentKeyMap();
}
function $fd179abe7398b4e4$var$__PRIVATE_newMutationMap() {
    return $fd179abe7398b4e4$var$__PRIVATE_newDocumentKeyMap();
}
function $fd179abe7398b4e4$var$__PRIVATE_newDocumentKeyMap() {
    return new $fd179abe7398b4e4$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $fd179abe7398b4e4$var$_e = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
const $fd179abe7398b4e4$var$ae = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
function $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(...e) {
    let t = $fd179abe7398b4e4$var$ae;
    for (const n of e)t = t.add(n);
    return t;
}
const $fd179abe7398b4e4$var$ue = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator);
function $fd179abe7398b4e4$var$__PRIVATE_targetIdSet() {
    return $fd179abe7398b4e4$var$ue;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $fd179abe7398b4e4$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $fd179abe7398b4e4$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $fd179abe7398b4e4$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $fd179abe7398b4e4$var$toNumber(e, t) {
    return $fd179abe7398b4e4$var$isSafeInteger(t) ? $fd179abe7398b4e4$var$__PRIVATE_toInteger(t) : $fd179abe7398b4e4$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $fd179abe7398b4e4$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $fd179abe7398b4e4$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $fd179abe7398b4e4$var$__PRIVATE_isServerTimestamp(t) && (t = $fd179abe7398b4e4$var$__PRIVATE_getPreviousValue(t)), t && (n.fields.__previous_value__ = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation ? $fd179abe7398b4e4$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation ? $fd179abe7398b4e4$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $fd179abe7398b4e4$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $fd179abe7398b4e4$var$asNumber(n) + $fd179abe7398b4e4$var$asNumber(e.Pe);
        return $fd179abe7398b4e4$var$isInteger(n) && $fd179abe7398b4e4$var$isInteger(e.Pe) ? $fd179abe7398b4e4$var$__PRIVATE_toInteger(r) : $fd179abe7398b4e4$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $fd179abe7398b4e4$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation ? $fd179abe7398b4e4$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation ? $fd179abe7398b4e4$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $fd179abe7398b4e4$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $fd179abe7398b4e4$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampTransform extends $fd179abe7398b4e4$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation extends $fd179abe7398b4e4$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$fd179abe7398b4e4$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation extends $fd179abe7398b4e4$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $fd179abe7398b4e4$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$fd179abe7398b4e4$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementTransformOperation extends $fd179abe7398b4e4$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Pe = t;
    }
}
function $fd179abe7398b4e4$var$asNumber(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $fd179abe7398b4e4$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $fd179abe7398b4e4$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $fd179abe7398b4e4$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation ? $fd179abe7398b4e4$var$__PRIVATE_arrayEquals(e.elements, t.elements, $fd179abe7398b4e4$var$__PRIVATE_valueEquals) : e instanceof $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementTransformOperation ? $fd179abe7398b4e4$var$__PRIVATE_valueEquals(e.Pe, t.Pe) : e instanceof $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampTransform && t instanceof $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $fd179abe7398b4e4$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $fd179abe7398b4e4$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $fd179abe7398b4e4$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $fd179abe7398b4e4$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $fd179abe7398b4e4$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $fd179abe7398b4e4$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $fd179abe7398b4e4$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $fd179abe7398b4e4$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $fd179abe7398b4e4$var$__PRIVATE_DeleteMutation(e.key, $fd179abe7398b4e4$var$Precondition.none()) : new $fd179abe7398b4e4$var$__PRIVATE_SetMutation(e.key, e.data, $fd179abe7398b4e4$var$Precondition.none());
    {
        const n = e.data, r = $fd179abe7398b4e4$var$ObjectValue.empty();
        let i = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $fd179abe7398b4e4$var$__PRIVATE_PatchMutation(e.key, r, new $fd179abe7398b4e4$var$FieldMask(i.toArray()), $fd179abe7398b4e4$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $fd179abe7398b4e4$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $fd179abe7398b4e4$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $fd179abe7398b4e4$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$fd179abe7398b4e4$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $fd179abe7398b4e4$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($fd179abe7398b4e4$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $fd179abe7398b4e4$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$fd179abe7398b4e4$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $fd179abe7398b4e4$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $fd179abe7398b4e4$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$fd179abe7398b4e4$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $fd179abe7398b4e4$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($fd179abe7398b4e4$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($fd179abe7398b4e4$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $fd179abe7398b4e4$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $fd179abe7398b4e4$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $fd179abe7398b4e4$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $fd179abe7398b4e4$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $fd179abe7398b4e4$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$fd179abe7398b4e4$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $fd179abe7398b4e4$var$__PRIVATE_SetMutation extends $fd179abe7398b4e4$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_PatchMutation extends $fd179abe7398b4e4$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $fd179abe7398b4e4$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.length === n.length);
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $fd179abe7398b4e4$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $fd179abe7398b4e4$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $fd179abe7398b4e4$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $fd179abe7398b4e4$var$__PRIVATE_DeleteMutation extends $fd179abe7398b4e4$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_VerifyMutation extends $fd179abe7398b4e4$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $fd179abe7398b4e4$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $fd179abe7398b4e4$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $fd179abe7398b4e4$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($fd179abe7398b4e4$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $fd179abe7398b4e4$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $fd179abe7398b4e4$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$fd179abe7398b4e4$var$__PRIVATE_mutationEquals(e, t)) && $fd179abe7398b4e4$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$fd179abe7398b4e4$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $fd179abe7398b4e4$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.mutations.length === n.length);
        let r = function __PRIVATE_documentVersionMap() {
            return $fd179abe7398b4e4$var$_e;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $fd179abe7398b4e4$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $fd179abe7398b4e4$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $fd179abe7398b4e4$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $fd179abe7398b4e4$var$ce, $fd179abe7398b4e4$var$le;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $fd179abe7398b4e4$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        default:
            return $fd179abe7398b4e4$var$fail();
        case $fd179abe7398b4e4$var$C.CANCELLED:
        case $fd179abe7398b4e4$var$C.UNKNOWN:
        case $fd179abe7398b4e4$var$C.DEADLINE_EXCEEDED:
        case $fd179abe7398b4e4$var$C.RESOURCE_EXHAUSTED:
        case $fd179abe7398b4e4$var$C.INTERNAL:
        case $fd179abe7398b4e4$var$C.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $fd179abe7398b4e4$var$C.UNAUTHENTICATED:
            return !1;
        case $fd179abe7398b4e4$var$C.INVALID_ARGUMENT:
        case $fd179abe7398b4e4$var$C.NOT_FOUND:
        case $fd179abe7398b4e4$var$C.ALREADY_EXISTS:
        case $fd179abe7398b4e4$var$C.PERMISSION_DENIED:
        case $fd179abe7398b4e4$var$C.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $fd179abe7398b4e4$var$C.ABORTED:
        case $fd179abe7398b4e4$var$C.OUT_OF_RANGE:
        case $fd179abe7398b4e4$var$C.UNIMPLEMENTED:
        case $fd179abe7398b4e4$var$C.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $fd179abe7398b4e4$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $fd179abe7398b4e4$var$__PRIVATE_logError("GRPC error has no .code"), $fd179abe7398b4e4$var$C.UNKNOWN;
    switch(e){
        case $fd179abe7398b4e4$var$ce.OK:
            return $fd179abe7398b4e4$var$C.OK;
        case $fd179abe7398b4e4$var$ce.CANCELLED:
            return $fd179abe7398b4e4$var$C.CANCELLED;
        case $fd179abe7398b4e4$var$ce.UNKNOWN:
            return $fd179abe7398b4e4$var$C.UNKNOWN;
        case $fd179abe7398b4e4$var$ce.DEADLINE_EXCEEDED:
            return $fd179abe7398b4e4$var$C.DEADLINE_EXCEEDED;
        case $fd179abe7398b4e4$var$ce.RESOURCE_EXHAUSTED:
            return $fd179abe7398b4e4$var$C.RESOURCE_EXHAUSTED;
        case $fd179abe7398b4e4$var$ce.INTERNAL:
            return $fd179abe7398b4e4$var$C.INTERNAL;
        case $fd179abe7398b4e4$var$ce.UNAVAILABLE:
            return $fd179abe7398b4e4$var$C.UNAVAILABLE;
        case $fd179abe7398b4e4$var$ce.UNAUTHENTICATED:
            return $fd179abe7398b4e4$var$C.UNAUTHENTICATED;
        case $fd179abe7398b4e4$var$ce.INVALID_ARGUMENT:
            return $fd179abe7398b4e4$var$C.INVALID_ARGUMENT;
        case $fd179abe7398b4e4$var$ce.NOT_FOUND:
            return $fd179abe7398b4e4$var$C.NOT_FOUND;
        case $fd179abe7398b4e4$var$ce.ALREADY_EXISTS:
            return $fd179abe7398b4e4$var$C.ALREADY_EXISTS;
        case $fd179abe7398b4e4$var$ce.PERMISSION_DENIED:
            return $fd179abe7398b4e4$var$C.PERMISSION_DENIED;
        case $fd179abe7398b4e4$var$ce.FAILED_PRECONDITION:
            return $fd179abe7398b4e4$var$C.FAILED_PRECONDITION;
        case $fd179abe7398b4e4$var$ce.ABORTED:
            return $fd179abe7398b4e4$var$C.ABORTED;
        case $fd179abe7398b4e4$var$ce.OUT_OF_RANGE:
            return $fd179abe7398b4e4$var$C.OUT_OF_RANGE;
        case $fd179abe7398b4e4$var$ce.UNIMPLEMENTED:
            return $fd179abe7398b4e4$var$C.UNIMPLEMENTED;
        case $fd179abe7398b4e4$var$ce.DATA_LOSS:
            return $fd179abe7398b4e4$var$C.DATA_LOSS;
        default:
            return $fd179abe7398b4e4$var$fail();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($fd179abe7398b4e4$var$le = $fd179abe7398b4e4$var$ce || ($fd179abe7398b4e4$var$ce = {}))[$fd179abe7398b4e4$var$le.OK = 0] = "OK", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.CANCELLED = 1] = "CANCELLED", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.UNKNOWN = 2] = "UNKNOWN", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.NOT_FOUND = 5] = "NOT_FOUND", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.ABORTED = 10] = "ABORTED", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.INTERNAL = 13] = "INTERNAL", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.UNAVAILABLE = 14] = "UNAVAILABLE", $fd179abe7398b4e4$var$le[$fd179abe7398b4e4$var$le.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $fd179abe7398b4e4$var$he = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $fd179abe7398b4e4$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$Pe = new (0, $91d6616b496711f3$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $fd179abe7398b4e4$var$__PRIVATE_getMd5HashValue(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $91d6616b496711f3$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $fd179abe7398b4e4$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $91d6616b496711f3$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $91d6616b496711f3$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $fd179abe7398b4e4$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $fd179abe7398b4e4$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $fd179abe7398b4e4$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $fd179abe7398b4e4$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $fd179abe7398b4e4$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.Ie = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Te = (0, $91d6616b496711f3$export$70ffa26850098d01).fromNumber(this.Ie);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Ee(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $91d6616b496711f3$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($fd179abe7398b4e4$var$Pe) && (r = new (0, $91d6616b496711f3$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.Te).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    de(e) {
        return 0 != (this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.Ie) return !1;
        const t = $fd179abe7398b4e4$var$__PRIVATE_getMd5HashValue(e), [n, r] = $fd179abe7398b4e4$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ee(n, r, e);
            if (!this.de(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $fd179abe7398b4e4$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.Ie) return;
        const t = $fd179abe7398b4e4$var$__PRIVATE_getMd5HashValue(e), [n, r] = $fd179abe7398b4e4$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ee(n, r, e);
            this.Ae(t);
        }
    }
    Ae(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $fd179abe7398b4e4$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $fd179abe7398b4e4$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $fd179abe7398b4e4$var$RemoteEvent($fd179abe7398b4e4$var$SnapshotVersion.min(), r, new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator), $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap(), $fd179abe7398b4e4$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $fd179abe7398b4e4$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $fd179abe7398b4e4$var$TargetChange(n, t, $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), $fd179abe7398b4e4$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $fd179abe7398b4e4$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Re = e, this.removedTargetIds = t, this.key = n, this.Ve = r;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.me = t;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $fd179abe7398b4e4$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.fe = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.ge = $fd179abe7398b4e4$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.pe = $fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.ye = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.we = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.ye;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.pe;
    }
    /** Whether this target has pending target adds or target removes. */ get Se() {
        return 0 !== this.fe;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get be() {
        return this.we;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ De(e) {
        e.approximateByteSize() > 0 && (this.we = !0, this.pe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ Ce() {
        let e = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), t = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), n = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        return this.ge.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $fd179abe7398b4e4$var$fail();
            }
        }), new $fd179abe7398b4e4$var$TargetChange(this.pe, this.ye, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ ve() {
        this.we = !1, this.ge = $fd179abe7398b4e4$var$__PRIVATE_snapshotChangesMap();
    }
    Fe(e, t) {
        this.we = !0, this.ge = this.ge.insert(e, t);
    }
    Me(e) {
        this.we = !0, this.ge = this.ge.remove(e);
    }
    xe() {
        this.fe += 1;
    }
    Oe() {
        this.fe -= 1, $fd179abe7398b4e4$var$__PRIVATE_hardAssert(this.fe >= 0);
    }
    Ne() {
        this.we = !0, this.ye = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $fd179abe7398b4e4$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Le = e, /** The internal state of all tracked targets. */ this.Be = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ke = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.qe = $fd179abe7398b4e4$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Qe = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ke(e) {
        for (const t of e.Re)e.Ve && e.Ve.isFoundDocument() ? this.$e(t, e.Ve) : this.Ue(t, e.key, e.Ve);
        for (const t of e.removedTargetIds)this.Ue(t, e.key, e.Ve);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ We(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.Ge(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.ze(t) && n.De(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Oe(), n.Se || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.ve(), n.De(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Oe(), n.Se || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.ze(t) && (n.Ne(), n.De(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.ze(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.je(t), n.De(e.resumeToken));
                    break;
                default:
                    $fd179abe7398b4e4$var$fail();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Be.forEach((e, n)=>{
            this.ze(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ He(e) {
        const t = e.targetId, n = e.me.count, r = this.Je(t);
        if (r) {
            const i = r.target;
            if ($fd179abe7398b4e4$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $fd179abe7398b4e4$export$afc2e57c475b7810(i.path);
                    this.Ue(t, e, $fd179abe7398b4e4$var$MutableDocument.newNoDocument(e, $fd179abe7398b4e4$var$SnapshotVersion.min()));
                } else $fd179abe7398b4e4$var$__PRIVATE_hardAssert(1 === n);
            } else {
                const r = this.Ye(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.Ze(e), i = n ? this.Xe(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.je(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Qe = this.Qe.insert(t, e);
                    }
                    null == $fd179abe7398b4e4$var$he || $fd179abe7398b4e4$var$he.et(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        var s, o, _, a, u, c;
                        const l = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, h = t.unchangedNames;
                        h && (l.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                            mightContain: (e)=>{
                                var t;
                                return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            }
                        });
                        return l;
                    }(r, e.me, this.Le.tt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ Ze(e) {
        const t = e.me.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $fd179abe7398b4e4$var$__PRIVATE_Base64DecodeError) return $fd179abe7398b4e4$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $fd179abe7398b4e4$var$BloomFilter(s, r, i);
        } catch (e) {
            return $fd179abe7398b4e4$export$86cd73f49cc6e0bb(e instanceof $fd179abe7398b4e4$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.Ie ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ Xe(e, t, n) {
        return t.me.count === n - this.nt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ nt(e, t) {
        const n = this.Le.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Le.tt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.Ue(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ rt(e) {
        const t = new Map;
        this.Be.forEach((n, r)=>{
            const i = this.Je(r);
            if (i) {
                if (n.current && $fd179abe7398b4e4$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $fd179abe7398b4e4$export$afc2e57c475b7810(i.target.path);
                    null !== this.ke.get(t) || this.it(r, t) || this.Ue(r, t, $fd179abe7398b4e4$var$MutableDocument.newNoDocument(t, e));
                }
                n.be && (t.set(r, n.Ce()), n.ve());
            }
        });
        let n = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.qe.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.Je(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.ke.forEach((t, n)=>n.setReadTime(e));
        const r = new $fd179abe7398b4e4$var$RemoteEvent(e, t, this.Qe, this.ke, n);
        return this.ke = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap(), this.qe = $fd179abe7398b4e4$var$__PRIVATE_documentTargetMap(), this.Qe = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    $e(e, t) {
        if (!this.ze(e)) return;
        const n = this.it(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.Ge(e).Fe(t.key, n), this.ke = this.ke.insert(t.key, t), this.qe = this.qe.insert(t.key, this.st(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Ue(e, t, n) {
        if (!this.ze(e)) return;
        const r = this.Ge(e);
        this.it(e, t) ? r.Fe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Me(t), this.qe = this.qe.insert(t, this.st(t).delete(e)), n && (this.ke = this.ke.insert(t, n));
    }
    removeTarget(e) {
        this.Be.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ Ye(e) {
        const t = this.Ge(e).Ce();
        return this.Le.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ xe(e) {
        this.Ge(e).xe();
    }
    Ge(e) {
        let t = this.Be.get(e);
        return t || (t = new $fd179abe7398b4e4$var$__PRIVATE_TargetState, this.Be.set(e, t)), t;
    }
    st(e) {
        let t = this.qe.get(e);
        return t || (t = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator), this.qe = this.qe.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ ze(e) {
        const t = null !== this.Je(e);
        return t || $fd179abe7398b4e4$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ Je(e) {
        const t = this.Be.get(e);
        return t && t.Se ? null : this.Le.ot(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ je(e) {
        this.Be.set(e, new $fd179abe7398b4e4$var$__PRIVATE_TargetState);
        this.Le.getRemoteKeysForTarget(e).forEach((t)=>{
            this.Ue(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ it(e, t) {
        return this.Le.getRemoteKeysForTarget(e).has(t);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_documentTargetMap() {
    return new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
}
function $fd179abe7398b4e4$var$__PRIVATE_snapshotChangesMap() {
    return new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
}
const $fd179abe7398b4e4$var$Ie = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $fd179abe7398b4e4$var$Te = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $fd179abe7398b4e4$var$Ee = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $fd179abe7398b4e4$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $fd179abe7398b4e4$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $fd179abe7398b4e4$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $fd179abe7398b4e4$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $fd179abe7398b4e4$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $fd179abe7398b4e4$var$__PRIVATE_toVersion(e, t) {
    return $fd179abe7398b4e4$var$toTimestamp(e, t.toTimestamp());
}
function $fd179abe7398b4e4$var$__PRIVATE_fromVersion(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!e), $fd179abe7398b4e4$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(e);
        return new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $fd179abe7398b4e4$var$__PRIVATE_toResourceName(e, t) {
    return $fd179abe7398b4e4$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $fd179abe7398b4e4$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $fd179abe7398b4e4$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $fd179abe7398b4e4$var$__PRIVATE_fromResourceName(e) {
    const t = $fd179abe7398b4e4$var$ResourcePath.fromString(e);
    return $fd179abe7398b4e4$var$__PRIVATE_hardAssert($fd179abe7398b4e4$var$__PRIVATE_isValidResourceName(t)), t;
}
function $fd179abe7398b4e4$var$__PRIVATE_toName(e, t) {
    return $fd179abe7398b4e4$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $fd179abe7398b4e4$var$fromName(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $fd179abe7398b4e4$var$__PRIVATE_toQueryPath(e, t) {
    return $fd179abe7398b4e4$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $fd179abe7398b4e4$var$__PRIVATE_fromQueryPath(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $fd179abe7398b4e4$var$ResourcePath.emptyPath() : $fd179abe7398b4e4$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $fd179abe7398b4e4$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $fd179abe7398b4e4$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $fd179abe7398b4e4$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $fd179abe7398b4e4$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $fd179abe7398b4e4$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $fd179abe7398b4e4$var$fromName(e, t.name), i = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.createTime) : $fd179abe7398b4e4$var$SnapshotVersion.min(), o = new $fd179abe7398b4e4$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $fd179abe7398b4e4$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $fd179abe7398b4e4$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        const n = $fd179abe7398b4e4$var$fromName(e, t.found.name), r = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.found.createTime) : $fd179abe7398b4e4$var$SnapshotVersion.min(), s = new $fd179abe7398b4e4$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $fd179abe7398b4e4$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!t.missing), $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!t.readTime);
        const n = $fd179abe7398b4e4$var$fromName(e, t.missing), r = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.readTime);
        return $fd179abe7398b4e4$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $fd179abe7398b4e4$var$fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), $fd179abe7398b4e4$export$67460cdabfa21253.fromBase64String(t || "")) : ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $fd179abe7398b4e4$require$Buffer || t instanceof Uint8Array), $fd179abe7398b4e4$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $fd179abe7398b4e4$var$C.UNKNOWN : $fd179abe7398b4e4$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $fd179abe7398b4e4$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $fd179abe7398b4e4$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $fd179abe7398b4e4$var$fromName(e, r.document.name), s = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $fd179abe7398b4e4$var$__PRIVATE_fromVersion(r.document.createTime) : $fd179abe7398b4e4$var$SnapshotVersion.min(), _ = new $fd179abe7398b4e4$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $fd179abe7398b4e4$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $fd179abe7398b4e4$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $fd179abe7398b4e4$var$fromName(e, r.document), s = r.readTime ? $fd179abe7398b4e4$var$__PRIVATE_fromVersion(r.readTime) : $fd179abe7398b4e4$var$SnapshotVersion.min(), o = $fd179abe7398b4e4$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $fd179abe7398b4e4$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $fd179abe7398b4e4$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $fd179abe7398b4e4$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $fd179abe7398b4e4$var$fail();
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $fd179abe7398b4e4$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $fd179abe7398b4e4$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $fd179abe7398b4e4$var$toMutation(e, t) {
    let n;
    if (t instanceof $fd179abe7398b4e4$var$__PRIVATE_SetMutation) n = {
        update: $fd179abe7398b4e4$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $fd179abe7398b4e4$var$__PRIVATE_DeleteMutation) n = {
        delete: $fd179abe7398b4e4$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $fd179abe7398b4e4$var$__PRIVATE_PatchMutation) n = {
        update: $fd179abe7398b4e4$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $fd179abe7398b4e4$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $fd179abe7398b4e4$var$__PRIVATE_VerifyMutation)) return $fd179abe7398b4e4$var$fail();
        n = {
            verify: $fd179abe7398b4e4$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Pe
            };
            throw $fd179abe7398b4e4$var$fail();
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $fd179abe7398b4e4$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $fd179abe7398b4e4$var$fail();
    }(e, t.precondition)), n;
}
function $fd179abe7398b4e4$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $fd179abe7398b4e4$var$Precondition.updateTime($fd179abe7398b4e4$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $fd179abe7398b4e4$var$Precondition.exists(e.exists) : $fd179abe7398b4e4$var$Precondition.none();
    }(t.currentDocument) : $fd179abe7398b4e4$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $fd179abe7398b4e4$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), n = new $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $fd179abe7398b4e4$var$fail();
            const r = $fd179abe7398b4e4$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $fd179abe7398b4e4$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $fd179abe7398b4e4$var$fromName(e, t.update.name), s = new $fd179abe7398b4e4$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $fd179abe7398b4e4$var$FieldMask(t.map((e)=>$fd179abe7398b4e4$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $fd179abe7398b4e4$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $fd179abe7398b4e4$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $fd179abe7398b4e4$var$fromName(e, t.delete);
        return new $fd179abe7398b4e4$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $fd179abe7398b4e4$var$fromName(e, t.verify);
        return new $fd179abe7398b4e4$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(void 0 !== t), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $fd179abe7398b4e4$var$__PRIVATE_fromVersion(e.updateTime) : $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t);
            return n.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t)), new $fd179abe7398b4e4$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $fd179abe7398b4e4$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $fd179abe7398b4e4$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $fd179abe7398b4e4$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $fd179abe7398b4e4$var$__PRIVATE_toFilter($fd179abe7398b4e4$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $fd179abe7398b4e4$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $fd179abe7398b4e4$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        _t: n,
        parent: i
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { _t: i, parent: s } = $fd179abe7398b4e4$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        ut: o,
        parent: s
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $fd179abe7398b4e4$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(1 === r);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_fromFilter(e);
        if (t instanceof $fd179abe7398b4e4$var$CompositeFilter && $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $fd179abe7398b4e4$var$OrderBy($fd179abe7398b4e4$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $fd179abe7398b4e4$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $fd179abe7398b4e4$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $fd179abe7398b4e4$var$Bound(n, t);
    }(n.endAt)), $fd179abe7398b4e4$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $fd179abe7398b4e4$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $fd179abe7398b4e4$var$fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $fd179abe7398b4e4$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $fd179abe7398b4e4$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $fd179abe7398b4e4$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $fd179abe7398b4e4$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $fd179abe7398b4e4$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $fd179abe7398b4e4$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $fd179abe7398b4e4$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $fd179abe7398b4e4$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $fd179abe7398b4e4$var$fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $fd179abe7398b4e4$var$FieldFilter.create($fd179abe7398b4e4$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $fd179abe7398b4e4$var$fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $fd179abe7398b4e4$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $fd179abe7398b4e4$var$fail();
            }
        }(e.compositeFilter.op));
    }(e) : $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_toDirection(e) {
    return $fd179abe7398b4e4$var$Ie[e];
}
function $fd179abe7398b4e4$var$__PRIVATE_toOperatorName(e) {
    return $fd179abe7398b4e4$var$Te[e];
}
function $fd179abe7398b4e4$var$__PRIVATE_toCompositeOperatorName(e) {
    return $fd179abe7398b4e4$var$Ee[e];
}
function $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_fromFieldPathReference(e) {
    return $fd179abe7398b4e4$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $fd179abe7398b4e4$var$__PRIVATE_toFilter(e) {
    return e instanceof $fd179abe7398b4e4$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($fd179abe7398b4e4$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($fd179abe7398b4e4$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($fd179abe7398b4e4$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($fd179abe7398b4e4$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $fd179abe7398b4e4$var$__PRIVATE_toFieldPathReference(e.field),
                op: $fd179abe7398b4e4$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $fd179abe7398b4e4$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$fd179abe7398b4e4$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $fd179abe7398b4e4$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $fd179abe7398b4e4$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $fd179abe7398b4e4$var$SnapshotVersion.min(), s = $fd179abe7398b4e4$var$SnapshotVersion.min(), o = $fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $fd179abe7398b4e4$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $fd179abe7398b4e4$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $fd179abe7398b4e4$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $fd179abe7398b4e4$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $fd179abe7398b4e4$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.ct = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $fd179abe7398b4e4$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $fd179abe7398b4e4$var$__PRIVATE_fromDocument(e.ct, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $fd179abe7398b4e4$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $fd179abe7398b4e4$var$fail();
        {
            const e = $fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $fd179abe7398b4e4$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $fd179abe7398b4e4$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $fd179abe7398b4e4$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $fd179abe7398b4e4$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $fd179abe7398b4e4$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $fd179abe7398b4e4$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $fd179abe7398b4e4$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.ct, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $fd179abe7398b4e4$var$fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $fd179abe7398b4e4$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $fd179abe7398b4e4$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$fd179abe7398b4e4$var$__PRIVATE_fromMutation(e.ct, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$fd179abe7398b4e4$var$__PRIVATE_fromMutation(e.ct, t)), i = $fd179abe7398b4e4$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $fd179abe7398b4e4$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $fd179abe7398b4e4$var$__PRIVATE_fromDbTarget(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $fd179abe7398b4e4$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_hardAssert(1 === e.documents.length), $fd179abe7398b4e4$var$__PRIVATE_queryToTarget($fd179abe7398b4e4$var$__PRIVATE_newQueryForPath($fd179abe7398b4e4$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_queryToTarget($fd179abe7398b4e4$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $fd179abe7398b4e4$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $fd179abe7398b4e4$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $fd179abe7398b4e4$var$__PRIVATE_toDbTarget(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $fd179abe7398b4e4$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $fd179abe7398b4e4$var$__PRIVATE_toDocumentsTarget(e.ct, t.target) : $fd179abe7398b4e4$var$__PRIVATE_toQueryTarget(e.ct, t.target)._t;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $fd179abe7398b4e4$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $fd179abe7398b4e4$var$__PRIVATE_fromBundledQuery(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $fd179abe7398b4e4$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $fd179abe7398b4e4$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $fd179abe7398b4e4$var$Overlay(t.largestBatchId, $fd179abe7398b4e4$var$__PRIVATE_fromMutation(e.ct, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $fd179abe7398b4e4$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $fd179abe7398b4e4$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp($fd179abe7398b4e4$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $fd179abe7398b4e4$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $fd179abe7398b4e4$var$__PRIVATE_toDbTimestamp($fd179abe7398b4e4$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_bundlesStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_namedQueriesStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static lt(e, t) {
        const n = t.uid || "";
        return new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_documentOverlayStore(e).get($fd179abe7398b4e4$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $fd179abe7398b4e4$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap();
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $fd179abe7398b4e4$var$Overlay(t, i);
            r.push(this.ht(e, s));
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($fd179abe7398b4e4$var$__PRIVATE_documentOverlayStore(e).j("collectionPathOverlayIndex", r));
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap(), i = $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $fd179abe7398b4e4$var$__PRIVATE_documentOverlayStore(e).U("collectionPathOverlayIndex", s).next((e)=>{
            for (const t of e){
                const e = $fd179abe7398b4e4$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $fd179abe7398b4e4$var$__PRIVATE_documentOverlayStore(e).J({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $fd179abe7398b4e4$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    ht(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $fd179abe7398b4e4$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $fd179abe7398b4e4$var$toMutation(e.ct, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_documentOverlayStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Pt(e, t) {
        this.It(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.Tt();
    }
    It(e, t) {
        if ("nullValue" in e) this.Et(t, 5);
        else if ("booleanValue" in e) this.Et(t, 10), t.dt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Et(t, 15), t.dt($fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Et(t, 13) : (this.Et(t, 15), $fd179abe7398b4e4$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.dt(0) : t.dt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Et(t, 20), "string" == typeof n && (n = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(n)), t.At(`${n.seconds || ""}`), t.dt(n.nanos || 0);
        } else if ("stringValue" in e) this.Rt(e.stringValue, t), this.Vt(t);
        else if ("bytesValue" in e) this.Et(t, 30), t.ft($fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Vt(t);
        else if ("referenceValue" in e) this.gt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Et(t, 45), t.dt(n.latitude || 0), t.dt(n.longitude || 0);
        } else "mapValue" in e ? $fd179abe7398b4e4$var$__PRIVATE_isMaxValue(e) ? this.Et(t, Number.MAX_SAFE_INTEGER) : (this.yt(e.mapValue, t), this.Vt(t)) : "arrayValue" in e ? (this.wt(e.arrayValue, t), this.Vt(t)) : $fd179abe7398b4e4$var$fail();
    }
    Rt(e, t) {
        this.Et(t, 25), this.St(e, t);
    }
    St(e, t) {
        t.At(e);
    }
    yt(e, t) {
        const n = e.fields || {};
        this.Et(t, 55);
        for (const e of Object.keys(n))this.Rt(e, t), this.It(n[e], t);
    }
    wt(e, t) {
        const n = e.values || [];
        this.Et(t, 50);
        for (const e of n)this.It(e, t);
    }
    gt(e, t) {
        this.Et(t, 37);
        $fd179abe7398b4e4$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.Et(t, 60), this.St(e, t);
        });
    }
    Et(e, t) {
        e.dt(t);
    }
    Vt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.dt(2);
    }
}
$fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter.bt = new $fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $fd179abe7398b4e4$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 == 0 && // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 == 0 && // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $fd179abe7398b4e4$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $fd179abe7398b4e4$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $fd179abe7398b4e4$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Dt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ct(n.value), n = t.next();
        this.vt();
    }
    Ft(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Mt(n.value), n = t.next();
        this.xt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Ot(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ct(e);
            else if (e < 2048) this.Ct(960 | e >>> 6), this.Ct(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ct(480 | e >>> 12), this.Ct(128 | 63 & e >>> 6), this.Ct(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ct(240 | e >>> 18), this.Ct(128 | 63 & e >>> 12), this.Ct(128 | 63 & e >>> 6), this.Ct(128 | 63 & e);
            }
        }
        this.vt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Nt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Mt(e);
            else if (e < 2048) this.Mt(960 | e >>> 6), this.Mt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Mt(480 | e >>> 12), this.Mt(128 | 63 & e >>> 6), this.Mt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Mt(240 | e >>> 18), this.Mt(128 | 63 & e >>> 12), this.Mt(128 | 63 & e >>> 6), this.Mt(128 | 63 & e);
            }
        }
        this.xt();
    }
    Lt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.Bt(e), n = $fd179abe7398b4e4$var$__PRIVATE_unsignedNumLength(t);
        this.kt(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    qt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.Bt(e), n = $fd179abe7398b4e4$var$__PRIVATE_unsignedNumLength(t);
        this.kt(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ Qt() {
        this.Kt(255), this.Kt(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ $t() {
        this.Ut(255), this.Ut(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.kt(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Wt() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Bt(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = 0 != (128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Ct(e) {
        const t = 255 & e;
        0 === t ? (this.Kt(0), this.Kt(255)) : 255 === t ? (this.Kt(255), this.Kt(0)) : this.Kt(t);
    }
    /** Writes a single byte descending to the buffer.  */ Mt(e) {
        const t = 255 & e;
        0 === t ? (this.Ut(0), this.Ut(255)) : 255 === t ? (this.Ut(255), this.Ut(0)) : this.Ut(e);
    }
    vt() {
        this.Kt(0), this.Kt(1);
    }
    xt() {
        this.Ut(0), this.Ut(1);
    }
    Kt(e) {
        this.kt(1), this.buffer[this.position++] = e;
    }
    Ut(e) {
        this.kt(1), this.buffer[this.position++] = ~e;
    }
    kt(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.Gt = e;
    }
    ft(e) {
        this.Gt.Dt(e);
    }
    At(e) {
        this.Gt.Ot(e);
    }
    dt(e) {
        this.Gt.Lt(e);
    }
    Tt() {
        this.Gt.Qt();
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.Gt = e;
    }
    ft(e) {
        this.Gt.Ft(e);
    }
    At(e) {
        this.Gt.Nt(e);
    }
    dt(e) {
        this.Gt.qt(e);
    }
    Tt() {
        this.Gt.$t();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.Gt = new $fd179abe7398b4e4$var$__PRIVATE_OrderedCodeWriter, this.zt = new $fd179abe7398b4e4$var$__PRIVATE_AscendingIndexByteEncoder(this.Gt), this.jt = new $fd179abe7398b4e4$var$__PRIVATE_DescendingIndexByteEncoder(this.Gt);
    }
    seed(e) {
        this.Gt.seed(e);
    }
    Ht(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.zt : this.jt;
    }
    Wt() {
        return this.Gt.Wt();
    }
    reset() {
        this.Gt.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $fd179abe7398b4e4$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Jt() {
        const e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.directionalValue, 0), t !== e ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $fd179abe7398b4e4$var$__PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = $fd179abe7398b4e4$var$__PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 0 !== n ? n : (n = $fd179abe7398b4e4$var$__PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 0 !== n ? n : $fd179abe7398b4e4$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey)));
}
function $fd179abe7398b4e4$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $fd179abe7398b4e4$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Yt = new $fd179abe7398b4e4$var$SortedSet((e, t)=>$fd179abe7398b4e4$export$b7871852b967eaf1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.Zt = e.orderBy, this.Xt = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Yt = this.Yt.add(e) : this.Xt.push(e);
        }
    }
    get en() {
        return this.Yt.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ tn(e) {
        if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId), this.en) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.nn(t)) return !1;
        const n = $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.nn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.Yt.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.Yt.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.rn(e, t) || !this.sn(this.Zt[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.Zt.length || !this.sn(this.Zt[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ on() {
        if (this.en) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$export$b7871852b967eaf1.comparator);
        const t = [];
        for (const n of this.Xt){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $fd179abe7398b4e4$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $fd179abe7398b4e4$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.Zt)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $fd179abe7398b4e4$var$IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $fd179abe7398b4e4$var$FieldIndex($fd179abe7398b4e4$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $fd179abe7398b4e4$var$IndexState.empty());
    }
    nn(e) {
        for (const t of this.Xt)if (this.rn(t, e)) return !0;
        return !1;
    }
    rn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    sn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $fd179abe7398b4e4$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(e instanceof $fd179abe7398b4e4$var$FieldFilter || e instanceof $fd179abe7398b4e4$var$CompositeFilter), e instanceof $fd179abe7398b4e4$var$FieldFilter) {
        if (e instanceof $fd179abe7398b4e4$var$__PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t)=>$fd179abe7398b4e4$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t))) || [];
            return $fd179abe7398b4e4$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const r = e.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_computeInExpansion(e));
    return $fd179abe7398b4e4$var$CompositeFilter.create(r, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $fd179abe7398b4e4$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $fd179abe7398b4e4$var$__PRIVATE_computeDistributedNormalForm($fd179abe7398b4e4$var$__PRIVATE_computeInExpansion(e));
    return $fd179abe7398b4e4$var$__PRIVATE_hardAssert($fd179abe7398b4e4$var$__PRIVATE_isDisjunctiveNormalForm(t)), $fd179abe7398b4e4$var$__PRIVATE_isSingleFieldFilter(t) || $fd179abe7398b4e4$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $fd179abe7398b4e4$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $fd179abe7398b4e4$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $fd179abe7398b4e4$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $fd179abe7398b4e4$var$CompositeFilter && $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $fd179abe7398b4e4$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_isSingleFieldFilter(e) || $fd179abe7398b4e4$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $fd179abe7398b4e4$var$CompositeFilter && $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$fd179abe7398b4e4$var$__PRIVATE_isSingleFieldFilter(t) && !$fd179abe7398b4e4$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $fd179abe7398b4e4$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(e instanceof $fd179abe7398b4e4$var$FieldFilter || e instanceof $fd179abe7398b4e4$var$CompositeFilter), e instanceof $fd179abe7398b4e4$var$FieldFilter) return e;
    if (1 === e.filters.length) return $fd179abe7398b4e4$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $fd179abe7398b4e4$var$CompositeFilter.create(t, e.op);
    return n = $fd179abe7398b4e4$var$__PRIVATE_applyAssociation(n), $fd179abe7398b4e4$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(n instanceof $fd179abe7398b4e4$var$CompositeFilter), $fd179abe7398b4e4$var$__PRIVATE_hardAssert($fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsConjunction(n)), $fd179abe7398b4e4$var$__PRIVATE_hardAssert(n.filters.length > 1), n.filters.reduce((e, t)=>$fd179abe7398b4e4$var$__PRIVATE_applyDistribution(e, t)));
}
function $fd179abe7398b4e4$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $fd179abe7398b4e4$var$__PRIVATE_hardAssert(e instanceof $fd179abe7398b4e4$var$FieldFilter || e instanceof $fd179abe7398b4e4$var$CompositeFilter), $fd179abe7398b4e4$var$__PRIVATE_hardAssert(t instanceof $fd179abe7398b4e4$var$FieldFilter || t instanceof $fd179abe7398b4e4$var$CompositeFilter), // FieldFilter FieldFilter
    n = e instanceof $fd179abe7398b4e4$var$FieldFilter ? t instanceof $fd179abe7398b4e4$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $fd179abe7398b4e4$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $fd179abe7398b4e4$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $fd179abe7398b4e4$var$FieldFilter ? $fd179abe7398b4e4$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsConjunction(e) && $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsConjunction(t)) return $fd179abe7398b4e4$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_applyDistribution(e, r));
        return $fd179abe7398b4e4$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $fd179abe7398b4e4$var$__PRIVATE_applyAssociation(n);
}
function $fd179abe7398b4e4$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $fd179abe7398b4e4$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$fd179abe7398b4e4$var$__PRIVATE_applyDistribution(e, t));
        return $fd179abe7398b4e4$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $fd179abe7398b4e4$var$__PRIVATE_applyAssociation(e) {
    if ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(e instanceof $fd179abe7398b4e4$var$FieldFilter || e instanceof $fd179abe7398b4e4$var$CompositeFilter), e instanceof $fd179abe7398b4e4$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $fd179abe7398b4e4$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($fd179abe7398b4e4$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $fd179abe7398b4e4$var$FieldFilter ? r.push(t) : t instanceof $fd179abe7398b4e4$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $fd179abe7398b4e4$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this._n = new $fd179abe7398b4e4$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this._n.add(t), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this._n.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve($fd179abe7398b4e4$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve($fd179abe7398b4e4$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$de = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.an = new $fd179abe7398b4e4$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.un = new $fd179abe7398b4e4$var$ObjectMap((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyTarget(e), (e, t)=>$fd179abe7398b4e4$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.an.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.an.add(t);
            });
            const i = {
                collectionId: n,
                parent: $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(r)
            };
            return $fd179abe7398b4e4$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $fd179abe7398b4e4$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $fd179abe7398b4e4$var$__PRIVATE_collectionParentsStore(e).U(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $fd179abe7398b4e4$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($fd179abe7398b4e4$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_indexConfigurationStore(e), r = $fd179abe7398b4e4$var$__PRIVATE_indexStateStore(e), i = $fd179abe7398b4e4$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_indexConfigurationStore(e), n = $fd179abe7398b4e4$var$__PRIVATE_indexEntriesStore(e), r = $fd179abe7398b4e4$var$__PRIVATE_indexStateStore(e);
        return t.j().next(()=>n.j()).next(()=>r.j());
    }
    createTargetIndexes(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(this.cn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $fd179abe7398b4e4$var$__PRIVATE_TargetIndexMatcher(t).on();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(this.cn(t), (t)=>this.ln(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
                const r = [];
                return $fd179abe7398b4e4$var$PersistencePromise.forEach(i, (i, s)=>{
                    $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbIndexManager", `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$fd179abe7398b4e4$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $fd179abe7398b4e4$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $fd179abe7398b4e4$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $fd179abe7398b4e4$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $fd179abe7398b4e4$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $fd179abe7398b4e4$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $fd179abe7398b4e4$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $fd179abe7398b4e4$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $fd179abe7398b4e4$var$Bound(n, r);
                    }(s, i), c = this.hn(i, s, a), l = this.hn(i, s, u), h = this.Pn(i, s, _), P = this.In(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $fd179abe7398b4e4$var$PersistencePromise.forEach(P, (i)=>n.G(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $fd179abe7398b4e4$var$PersistencePromise.resolve(null);
        });
    }
    cn(e) {
        let t = this.un.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $fd179abe7398b4e4$var$__PRIVATE_getDnfTerms($fd179abe7398b4e4$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$fd179abe7398b4e4$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.un.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ In(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Tn(t[c / a]) : $fd179abe7398b4e4$var$de, l = this.En(e, _, n[c % a], r), h = this.dn(e, _, i[c % a], s), P = o.map((t)=>this.En(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ En(e, t, n, r) {
        const i = new $fd179abe7398b4e4$var$__PRIVATE_IndexEntry(e, $fd179abe7398b4e4$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.Jt();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ dn(e, t, n, r) {
        const i = new $fd179abe7398b4e4$var$__PRIVATE_IndexEntry(e, $fd179abe7398b4e4$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.Jt() : i;
    }
    ln(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.tn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.cn(t);
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(r, (t)=>this.ln(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ An(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_IndexByteEncoder;
        for (const r of $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Ht(r.kind);
            $fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, i);
        }
        return n.Wt();
    }
    /** Encodes a single value to the ascending index format. */ Tn(e) {
        const t = new $fd179abe7398b4e4$var$__PRIVATE_IndexByteEncoder;
        return $fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, t.Ht(0 /* IndexKind.ASCENDING */ )), t.Wt();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ Rn(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_IndexByteEncoder;
        return $fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt($fd179abe7398b4e4$var$__PRIVATE_refValue(this.databaseId, t), n.Ht(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.Wt();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ Pn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $fd179abe7398b4e4$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.Vn(t, s.fieldPath) && $fd179abe7398b4e4$var$isArray(e)) r = this.mn(r, s, e);
            else {
                const t = n.Ht(s.kind);
                $fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, t);
            }
        }
        return this.fn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ hn(e, t, n) {
        return this.Pn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ fn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].Wt();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ mn(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $fd179abe7398b4e4$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.Wt()), $fd179abe7398b4e4$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, r.Ht(t.kind)), i.push(r);
        }
        return i;
    }
    Vn(e, t) {
        return !!e.filters.find((e)=>e instanceof $fd179abe7398b4e4$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_indexConfigurationStore(e), r = $fd179abe7398b4e4$var$__PRIVATE_indexStateStore(e);
        return (t ? n.U("collectionGroupIndex", IDBKeyRange.bound(t, t)) : n.U()).next((e)=>{
            const t = [];
            return $fd179abe7398b4e4$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $fd179abe7398b4e4$var$IndexState(t.sequenceNumber, new $fd179abe7398b4e4$var$IndexOffset($fd179abe7398b4e4$var$__PRIVATE_fromDbTimestamp(t.readTime), new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $fd179abe7398b4e4$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $fd179abe7398b4e4$var$IndexSegment($fd179abe7398b4e4$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $fd179abe7398b4e4$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_indexConfigurationStore(e), i = $fd179abe7398b4e4$var$__PRIVATE_indexStateStore(e);
        return this.gn(e).next((e)=>r.U("collectionGroupIndex", IDBKeyRange.bound(t, t)).next((t)=>$fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t)=>i.put($fd179abe7398b4e4$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $fd179abe7398b4e4$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $fd179abe7398b4e4$var$PersistencePromise.forEach(i, (n)=>this.pn(e, t, n).next((t)=>{
                        const i = this.yn(r, n);
                        return t.isEqual(i) ? $fd179abe7398b4e4$var$PersistencePromise.resolve() : this.wn(e, r, n, t, i);
                    }))));
        });
    }
    Sn(e, t, n, r) {
        return $fd179abe7398b4e4$var$__PRIVATE_indexEntriesStore(e).put({
            indexId: r.indexId,
            uid: this.uid,
            arrayValue: r.arrayValue,
            directionalValue: r.directionalValue,
            orderedDocumentKey: this.Rn(n, t.key),
            documentKey: t.key.path.toArray()
        });
    }
    bn(e, t, n, r) {
        return $fd179abe7398b4e4$var$__PRIVATE_indexEntriesStore(e).delete([
            r.indexId,
            this.uid,
            r.arrayValue,
            r.directionalValue,
            this.Rn(n, t.key),
            t.key.path.toArray()
        ]);
    }
    pn(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_indexEntriesStore(e);
        let i = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator);
        return r.J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.Rn(n, t)
            ])
        }, (e, r)=>{
            i = i.add(new $fd179abe7398b4e4$var$__PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ yn(e, t) {
        let n = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator);
        const r = this.An(t, e);
        if (null == r) return n;
        const i = $fd179abe7398b4e4$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($fd179abe7398b4e4$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $fd179abe7398b4e4$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Tn(i), r));
        } else n = n.add(new $fd179abe7398b4e4$var$__PRIVATE_IndexEntry(t.indexId, e.key, $fd179abe7398b4e4$var$de, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ wn(e, t, n, r, i) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbIndexManager", "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $fd179abe7398b4e4$var$__PRIVATE_advanceIterator(s), a = $fd179abe7398b4e4$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $fd179abe7398b4e4$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $fd179abe7398b4e4$var$__PRIVATE_advanceIterator(s)) : (_ = $fd179abe7398b4e4$var$__PRIVATE_advanceIterator(s), a = $fd179abe7398b4e4$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.Sn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.bn(e, t, n, r));
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(s);
    }
    gn(e) {
        let t = 1;
        return $fd179abe7398b4e4$var$__PRIVATE_indexStateStore(e).J({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator(i, e), s = $fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.Jt();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.Jt());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Dn(r[e], r[e + 1])) return [];
            const t = [
                r[e].indexId,
                this.uid,
                r[e].arrayValue,
                r[e].directionalValue,
                $fd179abe7398b4e4$var$de,
                []
            ], n = [
                r[e + 1].indexId,
                this.uid,
                r[e + 1].arrayValue,
                r[e + 1].directionalValue,
                $fd179abe7398b4e4$var$de,
                []
            ];
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Dn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $fd179abe7398b4e4$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($fd179abe7398b4e4$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.mapArray(this.cn(t), (t)=>this.ln(e, t).next((e)=>e || $fd179abe7398b4e4$var$fail())).next($fd179abe7398b4e4$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_collectionParentsStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_indexEntriesStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_indexConfigurationStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_indexStateStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "indexState");
}
function $fd179abe7398b4e4$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $fd179abe7398b4e4$var$__PRIVATE_hardAssert(0 !== e.length);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $fd179abe7398b4e4$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $fd179abe7398b4e4$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$Ae = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $fd179abe7398b4e4$var$LruParams {
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
    static withCacheSize(e) {
        return new $fd179abe7398b4e4$var$LruParams(e, $fd179abe7398b4e4$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $fd179abe7398b4e4$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $fd179abe7398b4e4$var$removeMutationBatch(e, t, n) {
    const r = e.store("mutations"), i = e.store("documentMutations"), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.J({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(1 === _);
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $fd179abe7398b4e4$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $fd179abe7398b4e4$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $fd179abe7398b4e4$var$fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $fd179abe7398b4e4$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $fd179abe7398b4e4$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $fd179abe7398b4e4$var$LruParams.DEFAULT = new $fd179abe7398b4e4$var$LruParams(41943040, $fd179abe7398b4e4$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $fd179abe7398b4e4$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $fd179abe7398b4e4$var$LruParams.DISABLED = new $fd179abe7398b4e4$var$LruParams(-1, 0, 0);
class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Cn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static lt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert("" !== e.uid);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $fd179abe7398b4e4$var$__PRIVATE_documentMutationsStore(e), s = $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $fd179abe7398b4e4$var$__PRIVATE_hardAssert("number" == typeof o);
            const _ = new $fd179abe7398b4e4$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$fd179abe7398b4e4$var$toMutation(e.ct, t)), i = n.mutations.map((t)=>$fd179abe7398b4e4$var$toMutation(e.ct, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $fd179abe7398b4e4$var$SortedSet((e, t)=>$fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $fd179abe7398b4e4$var$O));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Cn[o] = _.keys();
            }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.userId === this.userId), $fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    vn(e, t) {
        return this.Cn[t] ? $fd179abe7398b4e4$var$PersistencePromise.resolve(this.Cn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Cn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(t.batchId >= n), i = $fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e).U("userMutationsIndex", t).next((e)=>e.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $fd179abe7398b4e4$var$__PRIVATE_documentMutationsStore(e).J({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $fd179abe7398b4e4$var$fail();
                $fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.userId === this.userId), i.push($fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $fd179abe7398b4e4$var$__PRIVATE_documentMutationsStore(e).J({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(r).next(()=>this.Fn(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator);
        return $fd179abe7398b4e4$var$__PRIVATE_documentMutationsStore(e).J({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.Fn(e, o));
    }
    Fn(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $fd179abe7398b4e4$var$fail();
                $fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.userId === this.userId), n.push($fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $fd179abe7398b4e4$var$removeMutationBatch(e._e, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.Mn(t.batchId);
            }), $fd179abe7398b4e4$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    Mn(e) {
        delete this.Cn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $fd179abe7398b4e4$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $fd179abe7398b4e4$var$__PRIVATE_documentMutationsStore(e).J({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $fd179abe7398b4e4$var$__PRIVATE_hardAssert(0 === r.length);
            });
        });
    }
    containsKey(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ xn(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $fd179abe7398b4e4$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $fd179abe7398b4e4$var$__PRIVATE_documentMutationsStore(e).J({
        range: s,
        H: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_mutationsStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_documentMutationsStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_mutationQueuesStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $fd179abe7398b4e4$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.On = e;
    }
    next() {
        return this.On += 2, this.On;
    }
    static Nn() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $fd179abe7398b4e4$var$__PRIVATE_TargetIdGenerator(0);
    }
    static Ln() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $fd179abe7398b4e4$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.Bn(e).next((t)=>{
            const n = new $fd179abe7398b4e4$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.kn(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.Bn(e).next((e)=>$fd179abe7398b4e4$var$SnapshotVersion.fromTimestamp(new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.Bn(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.Bn(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.kn(e, r)));
    }
    addTargetData(e, t) {
        return this.qn(e, t).next(()=>this.Bn(e).next((n)=>(n.targetCount += 1, this.Qn(t, n), this.kn(e, n))));
    }
    updateTargetData(e, t) {
        return this.qn(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$fd179abe7398b4e4$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.Bn(e)).next((t)=>($fd179abe7398b4e4$var$__PRIVATE_hardAssert(t.targetCount > 0), t.targetCount -= 1, this.kn(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $fd179abe7398b4e4$var$__PRIVATE_targetsStore(e).J((s, o)=>{
            const _ = $fd179abe7398b4e4$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$fd179abe7398b4e4$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_targetsStore(e).J((e, n)=>{
            const r = $fd179abe7398b4e4$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    Bn(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_globalTargetStore(e).get("targetGlobalKey").next((e)=>($fd179abe7398b4e4$var$__PRIVATE_hardAssert(null !== e), e));
    }
    kn(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_globalTargetStore(e).put("targetGlobalKey", t);
    }
    qn(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_targetsStore(e).put($fd179abe7398b4e4$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Qn(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.Bn(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $fd179abe7398b4e4$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $fd179abe7398b4e4$var$__PRIVATE_targetsStore(e).J({
            range: r,
            index: "queryTargetsIndex"
        }, (e, n, r)=>{
            const s = $fd179abe7398b4e4$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $fd179abe7398b4e4$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e);
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t)=>{
            const i = $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(t.path);
            return $fd179abe7398b4e4$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e);
        let i = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        return r.J({
            range: n,
            H: !0
        }, (e, t, n)=>{
            const r = $fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(e[1]), s = new $fd179abe7398b4e4$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $fd179abe7398b4e4$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e).J({
            index: "documentTargetsIndex",
            H: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    ot(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $fd179abe7398b4e4$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_targetsStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_globalTargetStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fd179abe7398b4e4$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $fd179abe7398b4e4$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Kn = e, this.buffer = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_bufferEntryComparator), this.$n = 0;
    }
    Un() {
        return ++this.$n;
    }
    Wn(e) {
        const t = [
            e,
            this.Un()
        ];
        if (this.buffer.size < this.Kn) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $fd179abe7398b4e4$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $fd179abe7398b4e4$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Gn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.zn(6e4);
    }
    stop() {
        this.Gn && (this.Gn.cancel(), this.Gn = null);
    }
    get started() {
        return null !== this.Gn;
    }
    zn(e) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`), this.Gn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Gn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e) ? $fd179abe7398b4e4$var$__PRIVATE_logDebug("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await $fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.zn(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $fd179abe7398b4e4$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.jn = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.jn.Hn(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $fd179abe7398b4e4$var$PersistencePromise.resolve($fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe);
        const n = new $fd179abe7398b4e4$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.jn.forEachTarget(e, (e)=>n.Wn(e.sequenceNumber)).next(()=>this.jn.Jn(e, (e)=>n.Wn(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.jn.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.jn.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($fd179abe7398b4e4$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $fd179abe7398b4e4$var$PersistencePromise.resolve($fd179abe7398b4e4$var$Ae)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($fd179abe7398b4e4$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $fd179abe7398b4e4$var$Ae) : this.Yn(e, t));
    }
    getCacheSize(e) {
        return this.jn.getCacheSize(e);
    }
    Yn(e, t) {
        let n, r, i, s, o, a, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($fd179abe7398b4e4$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, a = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $fd179abe7398b4e4$var$__PRIVATE_getLogLevel() <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).DEBUG) $fd179abe7398b4e4$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (a - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - a) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $fd179abe7398b4e4$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $fd179abe7398b4e4$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $fd179abe7398b4e4$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    Hn(e) {
        const t = this.Zn(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Zn(e) {
        let t = 0;
        return this.Jn(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    Jn(e, t) {
        return this.Xn(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $fd179abe7398b4e4$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $fd179abe7398b4e4$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ er(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $fd179abe7398b4e4$var$__PRIVATE_mutationQueuesStore(e).Y((r)=>$fd179abe7398b4e4$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $fd179abe7398b4e4$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.Xn(e, (s, o)=>{
            if (o <= t) {
                const t = this.er(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $fd179abe7398b4e4$var$SnapshotVersion.min()), $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$fd179abe7398b4e4$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Xn(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e);
        let r, i = $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe;
        return n.J({
            index: "documentTargetsIndex"
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe && t(new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe && t(new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_writeSentinelKey(e, t) {
    return $fd179abe7398b4e4$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $fd179abe7398b4e4$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $fd179abe7398b4e4$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $fd179abe7398b4e4$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $fd179abe7398b4e4$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $fd179abe7398b4e4$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.tr(e, n)));
    }
    getEntry(e, t) {
        let n = $fd179abe7398b4e4$var$MutableDocument.newInvalidDocument(t);
        return $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($fd179abe7398b4e4$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.nr(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ rr(e, t) {
        let n = {
            size: 0,
            document: $fd179abe7398b4e4$var$MutableDocument.newInvalidDocument(t)
        };
        return $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($fd179abe7398b4e4$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.nr(t, r),
                size: $fd179abe7398b4e4$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
        return this.ir(e, t, (e, t)=>{
            const r = this.nr(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ sr(e, t) {
        let n = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap(), r = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
        return this.ir(e, t, (e, t)=>{
            const i = this.nr(e, t);
            n = n.insert(e, i), r = r.insert(e, $fd179abe7398b4e4$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                _r: r
            }));
    }
    ir(e, t, n) {
        if (t.isEmpty()) return $fd179abe7398b4e4$var$PersistencePromise.resolve();
        let r = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($fd179abe7398b4e4$var$__PRIVATE_dbKey(r.first()), $fd179abe7398b4e4$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: i
        }, (e, t, r)=>{
            const i = $fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $fd179abe7398b4e4$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.$($fd179abe7398b4e4$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $fd179abe7398b4e4$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e).U(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            null == i || i.incrementDocumentReadCount(e.length);
            let n = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.nr($fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($fd179abe7398b4e4$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
        const s = $fd179abe7398b4e4$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $fd179abe7398b4e4$var$__PRIVATE_dbCollectionGroupKey(t, $fd179abe7398b4e4$var$IndexOffset.max());
        return $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.nr($fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_documentGlobalStore(e).get("remoteDocumentGlobalKey").next((e)=>($fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!e), e));
    }
    tr(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_documentGlobalStore(e).put("remoteDocumentGlobalKey", t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ nr(e, t) {
        if (t) {
            const e = $fd179abe7398b4e4$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min()))) return e;
        }
        return $fd179abe7398b4e4$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $fd179abe7398b4e4$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $fd179abe7398b4e4$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.ar = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.ur = new $fd179abe7398b4e4$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $fd179abe7398b4e4$var$SortedSet((e, t)=>$fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.ur.get(i);
            if (t.push(this.ar.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $fd179abe7398b4e4$var$__PRIVATE_toDbRemoteDocument(this.ar.serializer, s);
                r = r.add(i.path.popLast());
                const a = $fd179abe7398b4e4$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.ar.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $fd179abe7398b4e4$var$__PRIVATE_toDbRemoteDocument(this.ar.serializer, s.convertToNoDocument($fd179abe7398b4e4$var$SnapshotVersion.min()));
                t.push(this.ar.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.ar.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.ar.updateMetadata(e, n)), $fd179abe7398b4e4$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.ar.rr(e, t).next((e)=>(this.ur.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.ar.sr(e, t).next(({ documents: e, _r: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.ur.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_documentGlobalStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_remoteDocumentsStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $fd179abe7398b4e4$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $fd179abe7398b4e4$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $fd179abe7398b4e4$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $fd179abe7398b4e4$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $fd179abe7398b4e4$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $fd179abe7398b4e4$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $fd179abe7398b4e4$var$FieldMask.empty(), $fd179abe7398b4e4$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $fd179abe7398b4e4$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet()) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $fd179abe7398b4e4$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $fd179abe7398b4e4$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
        const s = $fd179abe7398b4e4$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $fd179abe7398b4e4$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $fd179abe7398b4e4$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $fd179abe7398b4e4$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $fd179abe7398b4e4$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>{
                var n;
                return o.set(e, new $fd179abe7398b4e4$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $fd179abe7398b4e4$var$SortedMap((e, t)=>e - t), i = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $fd179abe7398b4e4$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $fd179abe7398b4e4$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $fd179abe7398b4e4$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $fd179abe7398b4e4$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $fd179abe7398b4e4$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $fd179abe7398b4e4$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $fd179abe7398b4e4$var$PersistencePromise.resolve($fd179abe7398b4e4$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, _ = i;
            return s.next((t)=>$fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $fd179abe7398b4e4$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $fd179abe7398b4e4$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $fd179abe7398b4e4$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $fd179abe7398b4e4$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $fd179abe7398b4e4$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $fd179abe7398b4e4$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$fd179abe7398b4e4$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $fd179abe7398b4e4$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $fd179abe7398b4e4$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $fd179abe7398b4e4$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $fd179abe7398b4e4$var$FieldMask.empty(), $fd179abe7398b4e4$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $fd179abe7398b4e4$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.cr = new Map, this.lr = new Map;
    }
    getBundleMetadata(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.cr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.cr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $fd179abe7398b4e4$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.lr.get(t));
    }
    saveNamedQuery(e, t) {
        return this.lr.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $fd179abe7398b4e4$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $fd179abe7398b4e4$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator), this.hr = new Map;
    }
    getOverlay(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap();
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.ht(e, t, r);
        }), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.hr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.hr.delete(n)), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $fd179abe7398b4e4$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $fd179abe7398b4e4$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $fd179abe7398b4e4$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(o);
    }
    ht(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.hr.get(r.largestBatchId).delete(n.key);
            this.hr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $fd179abe7398b4e4$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.hr.get(t);
        void 0 === i && (i = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), this.hr.set(t, i)), this.hr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $fd179abe7398b4e4$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Pr = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_DocReference.Ir), // A set of outstanding references to a document sorted by target id.
        this.Tr = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_DocReference.Er);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Pr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(e, t);
        this.Pr = this.Pr.add(n), this.Tr = this.Tr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ dr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Ar(new $fd179abe7398b4e4$var$__PRIVATE_DocReference(e, t));
    }
    Rr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Vr(e) {
        const t = new $fd179abe7398b4e4$export$afc2e57c475b7810(new $fd179abe7398b4e4$var$ResourcePath([])), n = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t, e), r = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.Tr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Ar(e), i.push(e.key);
        }), i;
    }
    mr() {
        this.Pr.forEach((e)=>this.Ar(e));
    }
    Ar(e) {
        this.Pr = this.Pr.delete(e), this.Tr = this.Tr.delete(e);
    }
    gr(e) {
        const t = new $fd179abe7398b4e4$export$afc2e57c475b7810(new $fd179abe7398b4e4$var$ResourcePath([])), n = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t, e), r = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t, e + 1);
        let i = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        return this.Tr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(e, 0), n = this.Pr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.pr = t;
    }
    /** Compare by key then by ID */ static Ir(e, t) {
        return $fd179abe7398b4e4$export$afc2e57c475b7810.comparator(e.key, t.key) || $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.pr, t.pr);
    }
    /** Compare by ID then by key */ static Er(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(e.pr, t.pr) || $fd179abe7398b4e4$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.yr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.wr = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_DocReference.Ir);
    }
    checkEmpty(e) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.yr;
        this.yr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $fd179abe7398b4e4$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.wr = this.wr.add(new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.Sr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.br(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? -1 : this.yr - 1);
    }
    getAllMutationBatches(e) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t, 0), r = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.wr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Sr(e.pr);
            i.push(t);
        }), $fd179abe7398b4e4$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(e, 0), r = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.wr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.pr);
            });
        }), $fd179abe7398b4e4$var$PersistencePromise.resolve(this.Dr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(new $fd179abe7398b4e4$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator);
        return this.wr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.pr)), !0);
        }, s), $fd179abe7398b4e4$var$PersistencePromise.resolve(this.Dr(o));
    }
    Dr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Sr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(0 === this.Cr(t.batchId, "removed")), this.mutationQueue.shift();
        let n = this.wr;
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.wr = n;
        });
    }
    Mn(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_DocReference(t, 0), r = this.wr.firstAfterOrEqual(n);
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ Cr(e, t) {
        return this.br(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ br(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ Sr(e) {
        const t = this.br(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.vr = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.vr(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $fd179abe7398b4e4$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $fd179abe7398b4e4$var$MutableDocument.newInvalidDocument(e));
        }), $fd179abe7398b4e4$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $fd179abe7398b4e4$export$afc2e57c475b7810(s.child("")), _ = this.docs.getIteratorFrom(o);
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $fd179abe7398b4e4$var$__PRIVATE_indexOffsetComparator($fd179abe7398b4e4$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $fd179abe7398b4e4$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $fd179abe7398b4e4$var$fail();
    }
    Fr(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $fd179abe7398b4e4$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $fd179abe7398b4e4$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.ar = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.ar.addEntry(e, r)) : this.ar.removeEntry(n);
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.ar.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.ar.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.Mr = new $fd179abe7398b4e4$var$ObjectMap((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyTarget(e), $fd179abe7398b4e4$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $fd179abe7398b4e4$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Or = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.Nr = new $fd179abe7398b4e4$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.Lr = $fd179abe7398b4e4$var$__PRIVATE_TargetIdGenerator.Nn();
    }
    forEachTarget(e, t) {
        return this.Mr.forEach((e, n)=>t(n)), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.Or);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.Lr.next(), $fd179abe7398b4e4$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.Or && (this.Or = t), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    qn(e) {
        this.Mr.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.Lr = new $fd179abe7398b4e4$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.Or && (this.Or = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.qn(t), this.targetCount += 1, $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.qn(t), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.Mr.delete(t.target), this.Nr.Vr(t.targetId), this.targetCount -= 1, $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.Mr.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.Mr.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.Mr.get(t) || null;
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.Nr.dr(t, n), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.Nr.Rr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $fd179abe7398b4e4$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.Nr.Vr(t), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.Nr.gr(t);
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(this.Nr.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.Br = {}, this.overlays = {}, this.kr = new $fd179abe7398b4e4$var$__PRIVATE_ListenSequence(0), this.qr = !1, this.qr = !0, this.referenceDelegate = e(this), this.Qr = new $fd179abe7398b4e4$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $fd179abe7398b4e4$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $fd179abe7398b4e4$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.Kr(e)), this.serializer = new $fd179abe7398b4e4$var$__PRIVATE_LocalSerializer(t), this.$r = new $fd179abe7398b4e4$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.qr = !1, Promise.resolve();
    }
    get started() {
        return this.qr;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $fd179abe7398b4e4$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.Br[e.toKey()];
        return n || (n = new $fd179abe7398b4e4$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.Br[e.toKey()] = n), n;
    }
    getTargetCache() {
        return this.Qr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.$r;
    }
    runTransaction(e, t, n) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $fd179abe7398b4e4$var$__PRIVATE_MemoryTransaction(this.kr.next());
        return this.referenceDelegate.Ur(), n(r).next((e)=>this.referenceDelegate.Wr(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Gr(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.or(Object.values(this.Br).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MemoryTransaction extends $fd179abe7398b4e4$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.zr = new $fd179abe7398b4e4$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.jr = null;
    }
    static Hr(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get Jr() {
        if (this.jr) return this.jr;
        throw $fd179abe7398b4e4$var$fail();
    }
    addReference(e, t, n) {
        return this.zr.addReference(n, t), this.Jr.delete(n.toString()), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.zr.removeReference(n, t), this.Jr.add(n.toString()), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.Jr.add(t.toString()), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.zr.Vr(t.targetId).forEach((e)=>this.Jr.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.Jr.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Ur() {
        this.jr = new Set;
    }
    Wr(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(this.Jr, (n)=>{
            const r = $fd179abe7398b4e4$export$afc2e57c475b7810.fromPath(n);
            return this.Yr(e, r).next((e)=>{
                e || t.removeEntry(r, $fd179abe7398b4e4$var$SnapshotVersion.min());
            });
        }).next(()=>(this.jr = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.Yr(e, t).next((e)=>{
            e ? this.Jr.delete(t.toString()) : this.Jr.add(t.toString());
        });
    }
    Kr(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    Yr(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.or([
            ()=>$fd179abe7398b4e4$var$PersistencePromise.resolve(this.zr.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Gr(e, t)
        ]);
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.Zr = new $fd179abe7398b4e4$var$ObjectMap((e)=>$fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $fd179abe7398b4e4$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static Hr(e, t) {
        return new $fd179abe7398b4e4$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Ur() {}
    Wr(e) {
        return $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    Hn(e) {
        const t = this.Zn(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Zn(e) {
        let t = 0;
        return this.Jn(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    Jn(e, t) {
        return $fd179abe7398b4e4$var$PersistencePromise.forEach(this.Zr, (n, r)=>this.er(e, n, r).next((e)=>e ? $fd179abe7398b4e4$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.Fr(e, (r)=>this.er(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $fd179abe7398b4e4$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.Zr.set(t, e.currentSequenceNumber), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.Zr.set(n, e.currentSequenceNumber), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Zr.set(n, e.currentSequenceNumber), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.Zr.set(t, e.currentSequenceNumber), $fd179abe7398b4e4$var$PersistencePromise.resolve();
    }
    Kr(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $fd179abe7398b4e4$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    er(e, t, n) {
        return $fd179abe7398b4e4$var$PersistencePromise.or([
            ()=>this.persistence.Gr(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.Zr.get(t);
                return $fd179abe7398b4e4$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $fd179abe7398b4e4$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ O(e, t, n, r) {
        const i = new $fd179abe7398b4e4$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore("owner");
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            e.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $fd179abe7398b4e4$var$x, {
                unique: !0
            }), e.createObjectStore("documentMutations");
        }(e), $fd179abe7398b4e4$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore("remoteDocuments");
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $fd179abe7398b4e4$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore("targetDocuments"), e.deleteObjectStore("targets"), e.deleteObjectStore("targetGlobal");
        }(e), $fd179abe7398b4e4$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $fd179abe7398b4e4$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put("targetGlobalKey", n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                return t.store("mutations").U().next((n)=>{
                    e.deleteObjectStore("mutations");
                    e.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $fd179abe7398b4e4$var$x, {
                        unique: !0
                    });
                    const r = t.store("mutations"), i = n.map((e)=>r.put(e));
                    return $fd179abe7398b4e4$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.Xr(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore("remoteDocumentGlobal");
            })(e), this.ei(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.ti(i))), n < 8 && r >= 8 && (s = s.next(()=>this.ni(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.ri(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore("documentOverlays", {
                    keyPath: $fd179abe7398b4e4$var$z
                });
                t.createIndex("collectionPathOverlayIndex", $fd179abe7398b4e4$var$j, {
                    unique: !1
                }), t.createIndex("collectionGroupOverlayIndex", $fd179abe7398b4e4$var$H, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore("remoteDocumentsV14", {
                    keyPath: $fd179abe7398b4e4$var$N
                });
                t.createIndex("documentKeyIndex", $fd179abe7398b4e4$var$L), t.createIndex("collectionGroupIndex", $fd179abe7398b4e4$var$B);
            })(e)).next(()=>this.ii(e, i)).next(()=>e.deleteObjectStore("remoteDocuments"))), n < 14 && r >= 14 && (s = s.next(()=>this.si(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                e.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                e.createObjectStore("indexState", {
                    keyPath: $fd179abe7398b4e4$var$$
                }).createIndex("sequenceNumberIndex", $fd179abe7398b4e4$var$U, {
                    unique: !1
                });
                e.createObjectStore("indexEntries", {
                    keyPath: $fd179abe7398b4e4$var$W
                }).createIndex("documentKeyIndex", $fd179abe7398b4e4$var$G, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore("indexState").clear();
        }).next(()=>{
            t.objectStore("indexEntries").clear();
        })), s;
    }
    ei(e) {
        let t = 0;
        return e.store("remoteDocuments").J((e, n)=>{
            t += $fd179abe7398b4e4$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    Xr(e) {
        const t = e.store("mutationQueues"), n = e.store("mutations");
        return t.U().next((t)=>$fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    -1
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.U("userMutationsIndex", r).next((n)=>$fd179abe7398b4e4$var$PersistencePromise.forEach(n, (n)=>{
                        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(n.userId === t.userId);
                        const r = $fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $fd179abe7398b4e4$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ ti(e) {
        const t = e.store("targetDocuments"), n = e.store("remoteDocuments");
        return e.store("targetGlobal").get("targetGlobalKey").next((e)=>{
            const r = [];
            return n.J((n, i)=>{
                const s = new $fd179abe7398b4e4$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $fd179abe7398b4e4$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$fd179abe7398b4e4$var$PersistencePromise.waitFor(r));
        });
    }
    ni(e, t) {
        // Create the index.
        e.createObjectStore("collectionParents", {
            keyPath: $fd179abe7398b4e4$var$K
        });
        const n = t.store("collectionParents"), r = new $fd179abe7398b4e4$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $fd179abe7398b4e4$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store("remoteDocuments").J({
            H: !0
        }, (e, t)=>{
            const n = new $fd179abe7398b4e4$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store("documentMutations").J({
                H: !0
            }, ([e, t, n], r)=>{
                const i = $fd179abe7398b4e4$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    ri(e) {
        const t = e.store("targets");
        return t.J((e, n)=>{
            const r = $fd179abe7398b4e4$var$__PRIVATE_fromDbTarget(n), i = $fd179abe7398b4e4$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    ii(e, t) {
        const n = t.store("remoteDocuments"), r = [];
        return n.J((e, n)=>{
            const i = t.store("remoteDocumentsV14"), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $fd179abe7398b4e4$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $fd179abe7398b4e4$var$fail();
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$fd179abe7398b4e4$var$PersistencePromise.waitFor(r));
    }
    si(e, t) {
        const n = t.store("mutations"), r = $fd179abe7398b4e4$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $fd179abe7398b4e4$var$__PRIVATE_MemoryPersistence($fd179abe7398b4e4$var$__PRIVATE_MemoryEagerDelegate.Hr, this.serializer.ct);
        return n.U().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
                $fd179abe7398b4e4$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>r = r.add(e)), n.set(e.userId, r);
            }), $fd179abe7398b4e4$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $fd179abe7398b4e4$var$User(n), o = $fd179abe7398b4e4$var$__PRIVATE_IndexedDbDocumentOverlayCache.lt(this.serializer, s), _ = i.getIndexManager(s), a = $fd179abe7398b4e4$var$__PRIVATE_IndexedDbMutationQueue.lt(s, this.serializer, _, i.referenceDelegate);
                return new $fd179abe7398b4e4$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransaction(t, $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe), e).next();
            });
        });
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore("targetDocuments", {
        keyPath: $fd179abe7398b4e4$var$q
    }).createIndex("documentTargetsIndex", $fd179abe7398b4e4$var$Q, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $fd179abe7398b4e4$var$k, {
        unique: !0
    }), e.createObjectStore("targetGlobal");
}
const $fd179abe7398b4e4$var$Re = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 16){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.oi = i, this.window = s, this.document = o, this._i = a, this.ai = u, this.ui = c, this.kr = null, this.qr = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.ci = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.li = null, /** The client metadata refresh task. */ this.hi = null, /** The last time we garbage collected the client metadata object store. */ this.Pi = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Ii = (e)=>Promise.resolve(), !$fd179abe7398b4e4$var$__PRIVATE_IndexedDbPersistence.D()) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Ti = t + "main", this.serializer = new $fd179abe7398b4e4$var$__PRIVATE_LocalSerializer(_), this.Ei = new $fd179abe7398b4e4$var$__PRIVATE_SimpleDb(this.Ti, this.ui, new $fd179abe7398b4e4$var$__PRIVATE_SchemaConverter(this.serializer)), this.Qr = new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $fd179abe7398b4e4$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.$r = new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.di = this.window.localStorage : (this.di = null, !1 === u && $fd179abe7398b4e4$var$__PRIVATE_logError("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.Ai().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, $fd179abe7398b4e4$var$Re);
            return this.Ri(), this.Vi(), this.mi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.Qr.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.kr = new $fd179abe7398b4e4$var$__PRIVATE_ListenSequence(e, this._i);
        }).then(()=>{
            this.qr = !0;
        }).catch((e)=>(this.Ei && this.Ei.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ fi(e) {
        return this.Ii = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.Ei.L(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.oi.enqueueAndForget(async ()=>{
            this.started && await this.Ai();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ Ai() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$fd179abe7398b4e4$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.gi(e).next((e)=>{
                    e || (this.isPrimary = !1, this.oi.enqueueRetryable(()=>this.Ii(!1)));
                });
            }).next(()=>this.pi(e)).next((t)=>this.isPrimary && !t ? this.yi(e).next(()=>!1) : !!t && this.wi(e).next(()=>!0))).catch((e)=>{
            if ($fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbPersistence", "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.oi.enqueueRetryable(()=>this.Ii(e)), this.isPrimary = e;
        });
    }
    gi(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>$fd179abe7398b4e4$var$PersistencePromise.resolve(this.Si(e)));
    }
    bi(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async Di() {
        if (this.isPrimary && !this.Ci(this.Pi, 18e5)) {
            this.Pi = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "clientMetadata");
                return t.U().next((e)=>{
                    const n = this.vi(e, 18e5), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $fd179abe7398b4e4$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.di) for (const t of e)this.di.removeItem(this.Fi(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ mi() {
        this.hi = this.oi.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.Ai().then(()=>this.Di()).then(()=>this.mi()));
    }
    /** Checks whether `client` is the local client. */ Si(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ pi(e) {
        if (this.ai) return $fd179abe7398b4e4$var$PersistencePromise.resolve(!0);
        return $fd179abe7398b4e4$var$__PRIVATE_primaryClientStore(e).get("owner").next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.Ci(t.leaseTimestampMs, 5e3) && !this.Mi(t.ownerId)) {
                if (this.Si(t) && this.networkEnabled) return !0;
                if (!this.Si(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, $fd179abe7398b4e4$var$Re);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $fd179abe7398b4e4$var$__PRIVATE_clientMetadataStore(e).U().next((e)=>void 0 === this.vi(e, 5e3).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.qr = !1, this.xi(), this.hi && (this.hi.cancel(), this.hi = null), this.Oi(), this.Ni(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.Ei.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (e)=>{
            const t = new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransaction(e, $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe);
            return this.yi(t).next(()=>this.bi(t));
        }), this.Ei.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Li();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ vi(e, t) {
        return e.filter((e)=>this.Ci(e.updateTimeMs, t) && !this.Mi(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Bi() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$fd179abe7398b4e4$var$__PRIVATE_clientMetadataStore(e).U().next((e)=>this.vi(e, 18e5).map((e)=>e.clientId)));
    }
    get started() {
        return this.qr;
    }
    getMutationQueue(e, t) {
        return $fd179abe7398b4e4$var$__PRIVATE_IndexedDbMutationQueue.lt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Qr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.ct.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_IndexedDbDocumentOverlayCache.lt(this.serializer, e);
    }
    getBundleCache() {
        return this.$r;
    }
    runTransaction(e, t, n) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbPersistence", "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 16 === e ? $fd179abe7398b4e4$var$te : 15 === e ? $fd179abe7398b4e4$var$ee : 14 === e ? $fd179abe7398b4e4$var$X : 13 === e ? $fd179abe7398b4e4$var$Z : 12 === e ? $fd179abe7398b4e4$var$Y : 11 === e ? $fd179abe7398b4e4$var$J : void $fd179abe7398b4e4$var$fail();
        }(this.ui);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.Ei.runTransaction(e, r, i, (r)=>(s = new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbTransaction(r, this.kr ? this.kr.next() : $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe), "readwrite-primary" === t ? this.gi(s).next((e)=>!!e || this.pi(s)).next((t)=>{
                if (!t) throw $fd179abe7398b4e4$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.oi.enqueueRetryable(()=>this.Ii(!1)), new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, $fd179abe7398b4e4$var$F);
                return n(s);
            }).next((e)=>this.wi(s).next(()=>e)) : this.ki(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    ki(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>{
            if (null !== e && this.Ci(e.leaseTimestampMs, 5e3) && !this.Mi(e.ownerId) && !this.Si(e) && !(this.ai || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, $fd179abe7398b4e4$var$Re);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ wi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $fd179abe7398b4e4$var$__PRIVATE_primaryClientStore(e).put("owner", t);
    }
    static D() {
        return $fd179abe7398b4e4$var$__PRIVATE_SimpleDb.D();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ yi(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_primaryClientStore(e);
        return t.get("owner").next((e)=>this.Si(e) ? ($fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing primary lease."), t.delete("owner")) : $fd179abe7398b4e4$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ Ci(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($fd179abe7398b4e4$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Ri() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.li = ()=>{
            this.oi.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.Ai()));
        }, this.document.addEventListener("visibilitychange", this.li), this.inForeground = "visible" === this.document.visibilityState);
    }
    Oi() {
        this.li && (this.document.removeEventListener("visibilitychange", this.li), this.li = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Vi() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.ci = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.xi();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $59fdd18afb377ad5$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.oi.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.oi.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.ci));
    }
    Ni() {
        this.ci && (this.window.removeEventListener("pagehide", this.ci), this.ci = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Mi(e) {
        var t;
        try {
            const n = null !== (null === (t = this.di) || void 0 === t ? void 0 : t.getItem(this.Fi(e)));
            return $fd179abe7398b4e4$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $fd179abe7398b4e4$var$__PRIVATE_logError("IndexedDbPersistence", "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ xi() {
        if (this.di) try {
            this.di.setItem(this.Fi(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $fd179abe7398b4e4$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ Li() {
        if (this.di) try {
            this.di.removeItem(this.Fi(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    Fi(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_primaryClientStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $fd179abe7398b4e4$var$__PRIVATE_clientMetadataStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_getStore(e, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $fd179abe7398b4e4$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $fd179abe7398b4e4$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.qi = n, this.Qi = r;
    }
    static Ki(e, t) {
        let n = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), r = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $fd179abe7398b4e4$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $fd179abe7398b4e4$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $fd179abe7398b4e4$var$__PRIVATE_QueryEngine {
    constructor(){
        this.$i = !1, this.Ui = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Wi = 100, this.Gi = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $59fdd18afb377ad5$export$95df08bae54cb4df)() ? 8 : $fd179abe7398b4e4$var$__PRIVATE_getAndroidVersion((0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.zi = e, this.indexManager = t, this.$i = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.ji(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.Hi(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $fd179abe7398b4e4$var$QueryContext;
            return this.Ji(e, t, n).next((r)=>{
                if (i.result = r, this.Ui) return this.Yi(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    Yi(e, t, n, r) {
        return n.documentReadCount < this.Wi ? ($fd179abe7398b4e4$var$__PRIVATE_getLogLevel() <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).DEBUG && $fd179abe7398b4e4$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $fd179abe7398b4e4$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Wi, "documents"), $fd179abe7398b4e4$var$PersistencePromise.resolve()) : ($fd179abe7398b4e4$var$__PRIVATE_getLogLevel() <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).DEBUG && $fd179abe7398b4e4$var$__PRIVATE_logDebug("QueryEngine", "Query:", $fd179abe7398b4e4$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Gi * r ? ($fd179abe7398b4e4$var$__PRIVATE_getLogLevel() <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).DEBUG && $fd179abe7398b4e4$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $fd179abe7398b4e4$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(t))) : $fd179abe7398b4e4$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ ji(e, t) {
        if ($fd179abe7398b4e4$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $fd179abe7398b4e4$var$PersistencePromise.resolve(null);
        let n = $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $fd179abe7398b4e4$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(...r);
                return this.zi.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.Zi(t, r);
                        return this.Xi(t, s, i, n.readTime) ? this.ji(e, $fd179abe7398b4e4$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.es(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ Hi(e, t, n, r) {
        return $fd179abe7398b4e4$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min()) ? $fd179abe7398b4e4$var$PersistencePromise.resolve(null) : this.zi.getDocuments(e, n).next((i)=>{
            const s = this.Zi(t, i);
            return this.Xi(t, s, n, r) ? $fd179abe7398b4e4$var$PersistencePromise.resolve(null) : ($fd179abe7398b4e4$var$__PRIVATE_getLogLevel() <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).DEBUG && $fd179abe7398b4e4$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $fd179abe7398b4e4$var$__PRIVATE_stringifyQuery(t)), this.es(e, s, t, $fd179abe7398b4e4$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ Zi(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $fd179abe7398b4e4$var$SortedSet($fd179abe7398b4e4$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $fd179abe7398b4e4$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Xi(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    Ji(e, t, n) {
        return $fd179abe7398b4e4$var$__PRIVATE_getLogLevel() <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).DEBUG && $fd179abe7398b4e4$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $fd179abe7398b4e4$var$__PRIVATE_stringifyQuery(t)), this.zi.getDocumentsMatchingQuery(e, t, $fd179abe7398b4e4$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ es(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.zi.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $fd179abe7398b4e4$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.ts = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.ns = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.rs = new $fd179abe7398b4e4$var$ObjectMap((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyTarget(e), $fd179abe7398b4e4$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.ss = new Map, this.os = e.getRemoteDocumentCache(), this.Qr = e.getTargetCache(), this.$r = e.getBundleCache(), this._s(n);
    }
    _s(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $fd179abe7398b4e4$var$LocalDocumentsView(this.os, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.os.setIndexManager(this.indexManager), this.ts.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.ns));
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $fd179abe7398b4e4$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $fd179abe7398b4e4$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n._s(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    us: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $fd179abe7398b4e4$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.os.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $fd179abe7398b4e4$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $fd179abe7398b4e4$var$__PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $fd179abe7398b4e4$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.Qr.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $fd179abe7398b4e4$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.ns;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.os.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.ns;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Qr.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.Qr.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING, $fd179abe7398b4e4$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($fd179abe7398b4e4$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(a, u, s) && o.push(n.Qr.updateTargetData(e, u));
        });
        let _ = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap(), a = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($fd179abe7398b4e4$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.cs, a = e.ls;
        })), !r.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min())) {
            const t = n.Qr.getLastRemoteSnapshotVersion(e).next((t)=>n.Qr.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $fd179abe7398b4e4$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.ns = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $fd179abe7398b4e4$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), i = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $fd179abe7398b4e4$var$__PRIVATE_logDebug("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            cs: r,
            ls: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $fd179abe7398b4e4$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $fd179abe7398b4e4$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.Qr.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $fd179abe7398b4e4$var$PersistencePromise.resolve(r)) : n.Qr.allocateTargetId(e).next((i)=>(r = new $fd179abe7398b4e4$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.Qr.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.ns.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.ns = n.ns.insert(e.targetId, e), n.rs.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $fd179abe7398b4e4$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), i = r.ns.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.ns = r.ns.remove(t), r.rs.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $fd179abe7398b4e4$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    let i = $fd179abe7398b4e4$var$SnapshotVersion.min(), s = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), i = r.rs.get(n);
            return void 0 !== i ? $fd179abe7398b4e4$var$PersistencePromise.resolve(r.ns.get(i)) : r.Qr.getTargetData(t, n);
        })(r, e, $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.Qr.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.ts.getDocumentsMatchingQuery(e, t, n ? i : $fd179abe7398b4e4$var$SnapshotVersion.min(), n ? s : $fd179abe7398b4e4$var$__PRIVATE_documentKeySet())).next((e)=>($fd179abe7398b4e4$var$__PRIVATE_setMaxReadTime(r, $fd179abe7398b4e4$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                hs: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $fd179abe7398b4e4$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(n.Qr), i = n.ns.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.ot(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $fd179abe7398b4e4$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = n.ss.get(t) || $fd179abe7398b4e4$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.os.getAllFromCollectionGroup(e, t, $fd179abe7398b4e4$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($fd179abe7398b4e4$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $fd179abe7398b4e4$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.ss.get(t) || $fd179abe7398b4e4$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.ss.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    let s = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), o = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Ps(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.Is(e);
        r.setReadTime(t.Ts(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.os.newChangeBuffer({
        trackRemovals: !0
    }), a = await $fd179abe7398b4e4$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $fd179abe7398b4e4$var$__PRIVATE_queryToTarget($fd179abe7398b4e4$var$__PRIVATE_newQueryForPath($fd179abe7398b4e4$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$fd179abe7398b4e4$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.Qr.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.Qr.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.cs, t.ls)).next(()=>t.cs)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $fd179abe7398b4e4$var$__PRIVATE_localStoreAllocateTarget(e, $fd179abe7398b4e4$var$__PRIVATE_queryToTarget($fd179abe7398b4e4$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.$r.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.ns = i.ns.insert(o.targetId, o), i.Qr.updateTargetData(e, o).next(()=>i.Qr.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.Qr.addMatchingKeys(e, n, r.targetId)).next(()=>i.$r.saveNamedQuery(e, t));
    });
}
/** Assembles the key for a client state in WebStorage */ function $fd179abe7398b4e4$var$createWebStorageClientStateKey(e, t) {
    return `firestore_clients_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $fd179abe7398b4e4$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `firestore_mutations_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $fd179abe7398b4e4$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `firestore_targets_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $fd179abe7398b4e4$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Es(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $fd179abe7398b4e4$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $fd179abe7398b4e4$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($fd179abe7398b4e4$var$__PRIVATE_logError("SharedClientState", `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    ds() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $fd179abe7398b4e4$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Es(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $fd179abe7398b4e4$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $fd179abe7398b4e4$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($fd179abe7398b4e4$var$__PRIVATE_logError("SharedClientState", `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    ds() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $fd179abe7398b4e4$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Es(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $fd179abe7398b4e4$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $fd179abe7398b4e4$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $fd179abe7398b4e4$var$__PRIVATE_RemoteClientState(e, i) : ($fd179abe7398b4e4$var$__PRIVATE_logError("SharedClientState", `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $fd179abe7398b4e4$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Es(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $fd179abe7398b4e4$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($fd179abe7398b4e4$var$__PRIVATE_logError("SharedClientState", `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $fd179abe7398b4e4$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $fd179abe7398b4e4$var$__PRIVATE_targetIdSet();
    }
    As(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    Rs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ ds() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $fd179abe7398b4e4$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.oi = t, this.persistenceKey = n, this.Vs = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.fs = this.gs.bind(this), this.ps = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.ys = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.ws = $fd179abe7398b4e4$var$createWebStorageClientStateKey(this.persistenceKey, this.Vs), this.Ss = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.ps = this.ps.insert(this.Vs, new $fd179abe7398b4e4$var$__PRIVATE_LocalClientState), this.bs = new RegExp(`^firestore_clients_${s}_([^_]*)$`), this.Ds = new RegExp(`^firestore_mutations_${s}_(\\d+)(?:_(.*))?$`), this.Cs = new RegExp(`^firestore_targets_${s}_(\\d+)$`), this.vs = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.Fs = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.fs);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static D(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.Bi();
        for (const t of e){
            if (t === this.Vs) continue;
            const e = this.getItem($fd179abe7398b4e4$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $fd179abe7398b4e4$var$__PRIVATE_RemoteClientState.Es(t, e);
                n && (this.ps = this.ps.insert(n.clientId, n));
            }
        }
        this.Ms();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.vs);
        if (t) {
            const e = this.xs(t);
            e && this.Os(e);
        }
        for (const e of this.ys)this.gs(e);
        this.ys = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Ss, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.Ns(this.ps);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.ps.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.Ls(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.Ls(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Bs(e);
    }
    addLocalQueryTarget(e) {
        let t = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const n = this.storage.getItem($fd179abe7398b4e4$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (n) {
                const r = $fd179abe7398b4e4$var$__PRIVATE_QueryTargetMetadata.Es(e, n);
                r && (t = r.state);
            }
        }
        return this.ks.As(e), this.Ms(), t;
    }
    removeLocalQueryTarget(e) {
        this.ks.Rs(e), this.Ms();
    }
    isLocalQueryTarget(e) {
        return this.ks.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($fd179abe7398b4e4$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.qs(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.Bs(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Qs(e);
    }
    notifyBundleLoaded(e) {
        this.Ks(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.fs), this.removeItem(this.ws), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $fd179abe7398b4e4$var$__PRIVATE_logDebug("SharedClientState", "READ", e, t), t;
    }
    setItem(e, t) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
    }
    gs(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($fd179abe7398b4e4$var$__PRIVATE_logDebug("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.ws) return void $fd179abe7398b4e4$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.oi.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.bs.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.$s(t.key);
                                return this.Us(e, null);
                            }
                            {
                                const e = this.Ws(t.key, t.newValue);
                                if (e) return this.Us(e.clientId, e);
                            }
                        } else if (this.Ds.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Gs(t.key, t.newValue);
                                if (e) return this.zs(e);
                            }
                        } else if (this.Cs.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.js(t.key, t.newValue);
                                if (e) return this.Hs(e);
                            }
                        } else if (t.key === this.vs) {
                            if (null !== t.newValue) {
                                const e = this.xs(t.newValue);
                                if (e) return this.Os(e);
                            }
                        } else if (t.key === this.Ss) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $fd179abe7398b4e4$var$__PRIVATE_hardAssert("number" == typeof n), t = n;
                                } catch (e) {
                                    $fd179abe7398b4e4$var$__PRIVATE_logError("SharedClientState", "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe && this.sequenceNumberHandler(e);
                        } else if (t.key === this.Fs) {
                            const e = this.Js(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.Ys(e)));
                        }
                    }
                } else this.ys.push(t);
            });
        }
    }
    get ks() {
        return this.ps.get(this.Vs);
    }
    Ms() {
        this.setItem(this.ws, this.ks.ds());
    }
    Ls(e, t, n) {
        const r = new $fd179abe7398b4e4$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $fd179abe7398b4e4$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.ds());
    }
    Bs(e) {
        const t = $fd179abe7398b4e4$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Qs(e) {
        const t = {
            clientId: this.Vs,
            onlineState: e
        };
        this.storage.setItem(this.vs, JSON.stringify(t));
    }
    qs(e, t, n) {
        const r = $fd179abe7398b4e4$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $fd179abe7398b4e4$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.ds());
    }
    Ks(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.Fs, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ $s(e) {
        const t = this.bs.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Ws(e, t) {
        const n = this.$s(e);
        return $fd179abe7398b4e4$var$__PRIVATE_RemoteClientState.Es(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Gs(e, t) {
        const n = this.Ds.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $fd179abe7398b4e4$var$__PRIVATE_MutationMetadata.Es(new $fd179abe7398b4e4$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ js(e, t) {
        const n = this.Cs.exec(e), r = Number(n[1]);
        return $fd179abe7398b4e4$var$__PRIVATE_QueryTargetMetadata.Es(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ xs(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_SharedOnlineState.Es(e);
    }
    Js(e) {
        return JSON.parse(e);
    }
    async zs(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Zs(e.batchId, e.state, e.error);
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SharedClientState", `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    Hs(e) {
        return this.syncEngine.Xs(e.targetId, e.state, e.error);
    }
    Us(e, t) {
        const n = t ? this.ps.insert(e, t) : this.ps.remove(e), r = this.Ns(this.ps), i = this.Ns(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.eo(s, o).then(()=>{
            this.ps = n;
        });
    }
    Os(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.ps.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    Ns(e) {
        let t = $fd179abe7398b4e4$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.no = new $fd179abe7398b4e4$var$__PRIVATE_LocalClientState, this.ro = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e) {
        return this.no.As(e), this.ro[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.ro[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.no.Rs(e);
    }
    isLocalQueryTarget(e) {
        return this.no.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.ro[e];
    }
    getAllActiveQueryTargets() {
        return this.no.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.no.activeTargetIds.has(e);
    }
    start() {
        return this.no = new $fd179abe7398b4e4$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_NoopConnectivityMonitor {
    io(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $fd179abe7398b4e4$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.so = ()=>this.oo(), this._o = ()=>this.ao(), this.uo = [], this.co();
    }
    io(e) {
        this.uo.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.so), window.removeEventListener("offline", this._o);
    }
    co() {
        window.addEventListener("online", this.so), window.addEventListener("offline", this._o);
    }
    oo() {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const e of this.uo)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    ao() {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const e of this.uo)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static D() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $fd179abe7398b4e4$var$Ve = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $fd179abe7398b4e4$var$__PRIVATE_generateUniqueDebugId() {
    return null === $fd179abe7398b4e4$var$Ve ? $fd179abe7398b4e4$var$Ve = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $fd179abe7398b4e4$var$Ve++, "0x" + $fd179abe7398b4e4$var$Ve.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$me = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $fd179abe7398b4e4$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.lo = e.lo, this.ho = e.ho;
    }
    Po(e) {
        this.Io = e;
    }
    To(e) {
        this.Eo = e;
    }
    Ao(e) {
        this.Ro = e;
    }
    onMessage(e) {
        this.Vo = e;
    }
    close() {
        this.ho();
    }
    send(e) {
        this.lo(e);
    }
    mo() {
        this.Io();
    }
    fo() {
        this.Eo();
    }
    po(e) {
        this.Ro(e);
    }
    yo(e) {
        this.Vo(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$fe = "WebChannelConnection";
class $fd179abe7398b4e4$var$__PRIVATE_WebChannelConnection extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class __PRIVATE_RestConnection {
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.wo = t + "://" + e.host, this.So = `projects/${n}/databases/${r}`, this.bo = "(default)" === this.databaseId.database ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    get Do() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    Co(e, t, n, r, i) {
        const s = $fd179abe7398b4e4$var$__PRIVATE_generateUniqueDebugId(), o = this.vo(e, t.toUriEncodedString());
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("RestConnection", `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.So,
            "x-goog-request-params": this.bo
        };
        return this.Fo(_, r, i), this.Mo(e, o, _, n).then((t)=>($fd179abe7398b4e4$var$__PRIVATE_logDebug("RestConnection", `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $fd179abe7398b4e4$export$86cd73f49cc6e0bb("RestConnection", `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    xo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Co(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Fo(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $fd179abe7398b4e4$var$b;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    vo(e, t) {
        const n = $fd179abe7398b4e4$var$me[e];
        return `${this.wo}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
} {
    constructor(e){
        super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    Mo(e, t, n, r) {
        const i = $fd179abe7398b4e4$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((s, o)=>{
            const _ = new (0, $b187c2c19c5bc792$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $b187c2c19c5bc792$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $b187c2c19c5bc792$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), s(t);
                            break;
                        case (0, $b187c2c19c5bc792$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' ${i} timed out`), o(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $b187c2c19c5bc792$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' ${i} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = null == e ? void 0 : e.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($fd179abe7398b4e4$var$C).indexOf(t) >= 0 ? t : $fd179abe7398b4e4$var$C.UNKNOWN;
                                    }(t.status);
                                    o(new $fd179abe7398b4e4$export$8fada0bf726bf278(e, t.message));
                                } else o(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $fd179abe7398b4e4$var$fail();
                    }
                } finally{
                    $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' ${i} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' ${i} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    Oo(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.wo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $b187c2c19c5bc792$export$66869136fc133c3a)(), o = (0, $b187c2c19c5bc792$export$888d0d9ab79d08fc)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.xmlHttpFactory = new (0, $b187c2c19c5bc792$export$ddb1030448106742)({})), this.Fo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $fd179abe7398b4e4$var$__PRIVATE_StreamBridge({
            lo: (t)=>{
                h ? $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            ho: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $b187c2c19c5bc792$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            h || ($fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} transport opened.`), P.mo());
        }), __PRIVATE_unguardedEventListen(c, (0, $b187c2c19c5bc792$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            h || (h = !0, $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} transport closed`), P.po());
        }), __PRIVATE_unguardedEventListen(c, (0, $b187c2c19c5bc792$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            h || (h = !0, $fd179abe7398b4e4$export$86cd73f49cc6e0bb($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} transport errored:`, t), P.po(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $b187c2c19c5bc792$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            var n;
            if (!h) {
                const i = t.data[0];
                $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = s.error || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $fd179abe7398b4e4$var$ce[e];
                        if (void 0 !== t) return $fd179abe7398b4e4$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = $fd179abe7398b4e4$var$C.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), // Mark closed so no further events are propagated
                    h = !0, P.po(new $fd179abe7398b4e4$export$8fada0bf726bf278(n, i)), c.close();
                } else $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} received:`, i), P.yo(i);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $b187c2c19c5bc792$export$d61e24a684f9e51).STAT_EVENT, (t)=>{
            t.stat === (0, $b187c2c19c5bc792$export$cbbc350c1dfc80cb).PROXY ? $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $b187c2c19c5bc792$export$cbbc350c1dfc80cb).NOPROXY && $fd179abe7398b4e4$var$__PRIVATE_logDebug($fd179abe7398b4e4$var$fe, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.fo();
        }, 0), P;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $fd179abe7398b4e4$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $fd179abe7398b4e4$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fd179abe7398b4e4$var$__PRIVATE_newSerializer(e) {
    return new $fd179abe7398b4e4$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $fd179abe7398b4e4$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.oi = e, this.timerId = t, this.No = n, this.Lo = r, this.Bo = i, this.ko = 0, this.qo = null, /** The last backoff attempt, as epoch milliseconds. */ this.Qo = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.ko = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ Ko() {
        this.ko = this.Bo;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ $o(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.ko + this.Uo()), n = Math.max(0, Date.now() - this.Qo), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $fd179abe7398b4e4$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.ko} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.qo = this.oi.enqueueAfterDelay(this.timerId, r, ()=>(this.Qo = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.ko *= this.Lo, this.ko < this.No && (this.ko = this.No), this.ko > this.Bo && (this.ko = this.Bo);
    }
    Wo() {
        null !== this.qo && (this.qo.skipDelay(), this.qo = null);
    }
    cancel() {
        null !== this.qo && (this.qo.cancel(), this.qo = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ Uo() {
        return (Math.random() - .5) * this.ko;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $fd179abe7398b4e4$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.oi = e, this.Go = n, this.zo = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.jo = 0, this.Ho = null, this.Jo = null, this.stream = null, this.Yo = new $fd179abe7398b4e4$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Zo() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Xo();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Xo() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.e_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Zo() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ t_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.Yo.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ n_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Xo() && null === this.Ho && (this.Ho = this.oi.enqueueAfterDelay(this.Go, 6e4, ()=>this.r_()));
    }
    /** Sends a message to the underlying stream. */ i_(e) {
        this.s_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async r_() {
        if (this.Xo()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ s_() {
        this.Ho && (this.Ho.cancel(), this.Ho = null);
    }
    /** Cancels the health check delayed operation. */ o_() {
        this.Jo && (this.Jo.cancel(), this.Jo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.s_(), this.o_(), this.Yo.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.jo++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.Yo.reset() : t && t.code === $fd179abe7398b4e4$var$C.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($fd179abe7398b4e4$var$__PRIVATE_logError(t.toString()), $fd179abe7398b4e4$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.Yo.Ko()) : t && t.code === $fd179abe7398b4e4$var$C.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.__(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.Ao(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ __() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.a_(this.jo), t = this.jo;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.jo === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.u_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.c_(e);
            });
        });
    }
    u_(e, t) {
        const n = this.a_(this.jo);
        this.stream = this.l_(e, t), this.stream.Po(()=>{
            n(()=>this.listener.Po());
        }), this.stream.To(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Jo = this.oi.enqueueAfterDelay(this.zo, 1e4, ()=>(this.Xo() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.To()));
        }), this.stream.Ao((e)=>{
            n(()=>this.c_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>this.onMessage(e));
        });
    }
    e_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.Yo.$o(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    c_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $fd179abe7398b4e4$var$__PRIVATE_logDebug("PersistentStream", `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ a_(e) {
        return (t)=>{
            this.oi.enqueueAndForget(()=>this.jo === e ? t() : ($fd179abe7398b4e4$var$__PRIVATE_logDebug("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $fd179abe7398b4e4$var$__PRIVATE_PersistentListenStream extends $fd179abe7398b4e4$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    l_(e, t) {
        return this.connection.Oo("Listen", e, t);
    }
    onMessage(e) {
        // A successful response means the stream is healthy
        this.Yo.reset();
        const t = $fd179abe7398b4e4$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $fd179abe7398b4e4$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $fd179abe7398b4e4$var$SnapshotVersion.min() : t.readTime ? $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.readTime) : $fd179abe7398b4e4$var$SnapshotVersion.min();
        }(e);
        return this.listener.h_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ P_(e) {
        const t = {};
        t.database = $fd179abe7398b4e4$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $fd179abe7398b4e4$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $fd179abe7398b4e4$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $fd179abe7398b4e4$var$__PRIVATE_toQueryTarget(e, r)._t
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $fd179abe7398b4e4$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $fd179abe7398b4e4$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($fd179abe7398b4e4$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $fd179abe7398b4e4$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $fd179abe7398b4e4$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $fd179abe7398b4e4$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.i_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ I_(e) {
        const t = {};
        t.database = $fd179abe7398b4e4$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.i_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $fd179abe7398b4e4$var$__PRIVATE_PersistentWriteStream extends $fd179abe7398b4e4$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i, this.T_ = !1;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get E_() {
        return this.T_;
    }
    // Override of PersistentStream.start
    start() {
        this.T_ = !1, this.lastStreamToken = void 0, super.start();
    }
    __() {
        this.T_ && this.d_([]);
    }
    l_(e, t) {
        return this.connection.Oo("Write", e, t);
    }
    onMessage(e) {
        if (// Always capture the last stream token.
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, this.T_) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.Yo.reset();
            const t = $fd179abe7398b4e4$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(e.commitTime);
            return this.listener.A_(n, t);
        }
        // The first response is always the handshake response
        return $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.T_ = !0, this.listener.R_();
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ V_() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $fd179abe7398b4e4$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.i_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ d_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$fd179abe7398b4e4$var$toMutation(this.serializer, e))
        };
        this.i_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $fd179abe7398b4e4$var$__PRIVATE_DatastoreImpl extends class Datastore {
} {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.m_ = !1;
    }
    f_() {
        if (this.m_) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Co(e, t, n, r) {
        return this.f_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Co(e, $fd179abe7398b4e4$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $fd179abe7398b4e4$var$C.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ xo(e, t, n, r, i) {
        return this.f_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.xo(e, $fd179abe7398b4e4$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $fd179abe7398b4e4$var$C.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.m_ = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $fd179abe7398b4e4$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.g_ = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.p_ = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.y_ = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ w_() {
        0 === this.g_ && (this.S_("Unknown" /* OnlineState.Unknown */ ), this.p_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.p_ = null, this.b_("Backend didn't respond within 10 seconds."), this.S_("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ D_(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.S_("Unknown" /* OnlineState.Unknown */ ) : (this.g_++, this.g_ >= 1 && (this.C_(), this.b_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.S_("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.C_(), this.g_ = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.y_ = !1), this.S_(e);
    }
    S_(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    b_(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.y_ ? ($fd179abe7398b4e4$var$__PRIVATE_logError(t), this.y_ = !1) : $fd179abe7398b4e4$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    C_() {
        null !== this.p_ && (this.p_.cancel(), this.p_ = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.v_ = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.F_ = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.M_ = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.x_ = [], this.O_ = i, this.O_.io((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(this) && ($fd179abe7398b4e4$var$__PRIVATE_logDebug("RemoteStore", "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
                    t.M_.add(4 /* OfflineCause.ConnectivityChange */ ), await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkInternal(t), t.N_.set("Unknown" /* OnlineState.Unknown */ ), t.M_.delete(4 /* OfflineCause.ConnectivityChange */ ), await $fd179abe7398b4e4$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.N_ = new $fd179abe7398b4e4$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $fd179abe7398b4e4$var$__PRIVATE_enableNetworkInternal(e) {
    if ($fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(e)) for (const t of e.x_)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $fd179abe7398b4e4$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.x_)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $fd179abe7398b4e4$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    n.F_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.F_.set(t.targetId, t), $fd179abe7398b4e4$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $fd179abe7398b4e4$var$__PRIVATE_startWatchStream(n) : $fd179abe7398b4e4$var$__PRIVATE_ensureWatchStream(n).Xo() && $fd179abe7398b4e4$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $fd179abe7398b4e4$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = $fd179abe7398b4e4$var$__PRIVATE_ensureWatchStream(n);
    n.F_.delete(t), r.Xo() && $fd179abe7398b4e4$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.F_.size && (r.Xo() ? r.n_() : $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.N_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $fd179abe7398b4e4$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.L_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($fd179abe7398b4e4$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $fd179abe7398b4e4$var$__PRIVATE_ensureWatchStream(e).P_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $fd179abe7398b4e4$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.L_.xe(t), $fd179abe7398b4e4$var$__PRIVATE_ensureWatchStream(e).I_(t);
}
function $fd179abe7398b4e4$var$__PRIVATE_startWatchStream(e) {
    e.L_ = new $fd179abe7398b4e4$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        ot: (t)=>e.F_.get(t) || null,
        tt: ()=>e.datastore.serializer.databaseId
    }), $fd179abe7398b4e4$var$__PRIVATE_ensureWatchStream(e).start(), e.N_.w_();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $fd179abe7398b4e4$var$__PRIVATE_shouldStartWatchStream(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(e) && !$fd179abe7398b4e4$var$__PRIVATE_ensureWatchStream(e).Zo() && e.F_.size > 0;
}
function $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $fd179abe7398b4e4$var$__PRIVATE_debugCast(e).M_.size;
}
function $fd179abe7398b4e4$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.L_ = void 0;
}
async function $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.N_.set("Online" /* OnlineState.Online */ );
}
async function $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamOpen(e) {
    e.F_.forEach((t, n)=>{
        $fd179abe7398b4e4$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamClose(e, t) {
    $fd179abe7398b4e4$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $fd179abe7398b4e4$var$__PRIVATE_shouldStartWatchStream(e) ? (e.N_.D_(t), $fd179abe7398b4e4$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.N_.set("Unknown" /* OnlineState.Unknown */ );
}
async function $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.N_.set("Online" /* OnlineState.Online */ ), t instanceof $fd179abe7398b4e4$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.F_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.F_.delete(r), e.L_.removeTarget(r));
        }(e, t);
    } catch (n) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $fd179abe7398b4e4$var$__PRIVATE_DocumentWatchChange ? e.L_.Ke(t) : t instanceof $fd179abe7398b4e4$var$__PRIVATE_ExistenceFilterChange ? e.L_.He(t) : e.L_.We(t), !n.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min())) try {
        const t = await $fd179abe7398b4e4$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.L_.rt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.F_.get(r);
                    // A watched target might have been removed already.
                    i && e.F_.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.F_.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.F_.set(t, r.withResumeToken($fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $fd179abe7398b4e4$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $fd179abe7398b4e4$var$TargetData(r.target, t, n, r.sequenceNumber);
                $fd179abe7398b4e4$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t), await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.M_.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkInternal(e), e.N_.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$fd179abe7398b4e4$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access"), await n(), e.M_.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $fd179abe7398b4e4$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $fd179abe7398b4e4$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$fd179abe7398b4e4$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $fd179abe7398b4e4$var$__PRIVATE_fillWritePipeline(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), n = $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(t);
    let r = t.v_.length > 0 ? t.v_[t.v_.length - 1].batchId : -1;
    for(; $fd179abe7398b4e4$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $fd179abe7398b4e4$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.v_.length && n.n_();
            break;
        }
        r = e.batchId, $fd179abe7398b4e4$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $fd179abe7398b4e4$var$__PRIVATE_shouldStartWriteStream(t) && $fd179abe7398b4e4$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $fd179abe7398b4e4$var$__PRIVATE_canAddToWritePipeline(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(e) && e.v_.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $fd179abe7398b4e4$var$__PRIVATE_addToWritePipeline(e, t) {
    e.v_.push(t);
    const n = $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e);
    n.Xo() && n.E_ && n.d_(t.mutations);
}
function $fd179abe7398b4e4$var$__PRIVATE_shouldStartWriteStream(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(e) && !$fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e).Zo() && e.v_.length > 0;
}
function $fd179abe7398b4e4$var$__PRIVATE_startWriteStream(e) {
    $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $fd179abe7398b4e4$var$__PRIVATE_onWriteStreamOpen(e) {
    $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e).V_();
}
async function $fd179abe7398b4e4$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.v_)t.d_(n.mutations);
}
async function $fd179abe7398b4e4$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.v_.shift(), i = $fd179abe7398b4e4$var$MutationBatchResult.from(r, t, n);
    await $fd179abe7398b4e4$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $fd179abe7398b4e4$var$__PRIVATE_fillWritePipeline(e);
}
async function $fd179abe7398b4e4$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e).E_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $fd179abe7398b4e4$var$__PRIVATE_isPermanentError(e) && e !== $fd179abe7398b4e4$var$C.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.v_.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e).t_(), await $fd179abe7398b4e4$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $fd179abe7398b4e4$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $fd179abe7398b4e4$var$__PRIVATE_shouldStartWriteStream(e) && $fd179abe7398b4e4$var$__PRIVATE_startWriteStream(e);
}
async function $fd179abe7398b4e4$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $fd179abe7398b4e4$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
    const r = $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.M_.add(3 /* OfflineCause.CredentialChange */ ), await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.N_.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.M_.delete(3 /* OfflineCause.CredentialChange */ ), await $fd179abe7398b4e4$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    t ? (n.M_.delete(2 /* OfflineCause.IsSecondary */ ), await $fd179abe7398b4e4$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.M_.add(2 /* OfflineCause.IsSecondary */ ), await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkInternal(n), n.N_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $fd179abe7398b4e4$var$__PRIVATE_ensureWatchStream(e) {
    return e.B_ || // Create stream (but note that it is not started yet).
    (e.B_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
        return r.f_(), new $fd179abe7398b4e4$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Po: $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        To: $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        Ao: $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        h_: $fd179abe7398b4e4$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.x_.push(async (t)=>{
        t ? (e.B_.t_(), $fd179abe7398b4e4$var$__PRIVATE_shouldStartWatchStream(e) ? $fd179abe7398b4e4$var$__PRIVATE_startWatchStream(e) : e.N_.set("Unknown" /* OnlineState.Unknown */ )) : (await e.B_.stop(), $fd179abe7398b4e4$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.B_;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $fd179abe7398b4e4$var$__PRIVATE_ensureWriteStream(e) {
    return e.k_ || // Create stream (but note that it is not started yet).
    (e.k_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
        return r.f_(), new $fd179abe7398b4e4$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Po: ()=>Promise.resolve(),
        To: $fd179abe7398b4e4$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        Ao: $fd179abe7398b4e4$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        R_: $fd179abe7398b4e4$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        A_: $fd179abe7398b4e4$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.x_.push(async (t)=>{
        t ? (e.k_.t_(), // This will start the write stream if necessary.
        await $fd179abe7398b4e4$var$__PRIVATE_fillWritePipeline(e)) : (await e.k_.stop(), e.v_.length > 0 && ($fd179abe7398b4e4$var$__PRIVATE_logDebug("RemoteStore", `Stopping write stream with ${e.v_.length} pending writes`), e.v_ = []));
    })), e.k_;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $fd179abe7398b4e4$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $fd179abe7398b4e4$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $fd179abe7398b4e4$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $fd179abe7398b4e4$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($fd179abe7398b4e4$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $fd179abe7398b4e4$var$DocumentSet {
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $fd179abe7398b4e4$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$fd179abe7398b4e4$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $fd179abe7398b4e4$var$documentMap(), this.sortedSet = new $fd179abe7398b4e4$var$SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $fd179abe7398b4e4$var$DocumentSet(e.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $fd179abe7398b4e4$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $fd179abe7398b4e4$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $fd179abe7398b4e4$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.q_ = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.q_.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.q_ = this.q_.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.q_ = this.q_.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.q_ = this.q_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.q_ = this.q_.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.q_ = this.q_.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.q_ = this.q_.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.q_ = this.q_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $fd179abe7398b4e4$var$fail() : this.q_ = this.q_.insert(t, e);
    }
    Q_() {
        const e = [];
        return this.q_.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $fd179abe7398b4e4$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $fd179abe7398b4e4$var$ViewSnapshot(e, t, $fd179abe7398b4e4$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $fd179abe7398b4e4$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $fd179abe7398b4e4$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.K_ = void 0, this.U_ = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    W_() {
        return this.U_.some((e)=>e.G_());
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = new $fd179abe7398b4e4$var$ObjectMap((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyQuery(e), $fd179abe7398b4e4$var$__PRIVATE_queryEquals), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.z_ = new Set;
    }
}
async function $fd179abe7398b4e4$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.W_() && t.G_() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $fd179abe7398b4e4$var$__PRIVATE_QueryListenersInfo, r = t.G_() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.K_ = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.K_ = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$fd179abe7398b4e4$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.U_.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.j_(n.onlineState), s.K_) t.H_(s.K_) && $fd179abe7398b4e4$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $fd179abe7398b4e4$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.U_.indexOf(t);
        e >= 0 && (s.U_.splice(e, 1), 0 === s.U_.length ? i = t.G_() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.W_() && t.G_() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.U_)t.H_(e) && (r = !0);
            i.K_ = e;
        }
    }
    r && $fd179abe7398b4e4$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $fd179abe7398b4e4$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.U_)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
// Call all global snapshot listeners that have been set.
function $fd179abe7398b4e4$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.z_.forEach((e)=>{
        e.next();
    });
}
var $fd179abe7398b4e4$var$ge, $fd179abe7398b4e4$var$pe;
/** Listen to both cache and server changes */ ($fd179abe7398b4e4$var$pe = $fd179abe7398b4e4$var$ge || ($fd179abe7398b4e4$var$ge = {})).J_ = "default", /** Listen to changes in cache only */ $fd179abe7398b4e4$var$pe.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $fd179abe7398b4e4$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.Y_ = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Z_ = !1, this.X_ = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ H_(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $fd179abe7398b4e4$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.Z_ ? this.ea(e) && (this.Y_.next(e), t = !0) : this.ta(e, this.onlineState) && (this.na(e), t = !0), this.X_ = e, t;
    }
    onError(e) {
        this.Y_.error(e);
    }
    /** Returns whether a snapshot was raised. */ j_(e) {
        this.onlineState = e;
        let t = !1;
        return this.X_ && !this.Z_ && this.ta(this.X_, e) && (this.na(this.X_), t = !0), t;
    }
    ta(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.G_()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.ra || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    ea(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.X_ && this.X_.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    na(e) {
        e = $fd179abe7398b4e4$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Z_ = !0, this.Y_.next(e);
    }
    G_() {
        return this.options.source !== $fd179abe7398b4e4$var$ge.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $fd179abe7398b4e4$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.ia = e, this.byteLength = t;
    }
    sa() {
        return "metadata" in this.ia;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $fd179abe7398b4e4$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Ps(e) {
        return $fd179abe7398b4e4$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ Is(e) {
        return e.metadata.exists ? $fd179abe7398b4e4$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $fd179abe7398b4e4$var$MutableDocument.newNoDocument(this.Ps(e.metadata.name), this.Ts(e.metadata.readTime));
    }
    Ts(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $fd179abe7398b4e4$var$__PRIVATE_BundleLoader {
    constructor(e, t, n){
        this.oa = e, this.localStore = t, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $fd179abe7398b4e4$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ _a(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.ia.namedQuery) this.queries.push(e.ia.namedQuery);
        else if (e.ia.documentMetadata) {
            this.documents.push({
                metadata: e.ia.documentMetadata
            }), e.ia.documentMetadata.exists || ++t;
            const n = $fd179abe7398b4e4$var$ResourcePath.fromString(e.ia.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.ia.document && (this.documents[this.documents.length - 1].document = e.ia.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
    }
    aa(e) {
        const t = new Map, n = new $fd179abe7398b4e4$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Ps(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $fd179abe7398b4e4$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const e = await $fd179abe7398b4e4$var$__PRIVATE_localStoreApplyBundledDocuments(this.localStore, new $fd179abe7398b4e4$var$__PRIVATE_BundleConverterImpl(this.serializer), this.documents, this.oa.id), t = this.aa(this.documents);
        for (const e of this.queries)await $fd179abe7398b4e4$var$__PRIVATE_localStoreSaveNamedQuery(this.localStore, e, t.get(e.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            ua: this.collectionGroups,
            ca: e
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $fd179abe7398b4e4$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $fd179abe7398b4e4$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.la = t, this.ha = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Pa = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), this.Ia = $fd179abe7398b4e4$var$__PRIVATE_newQueryComparator(e), this.Ta = new $fd179abe7398b4e4$var$DocumentSet(this.Ia);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get Ea() {
        return this.la;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ da(e, t) {
        const n = t ? t.Aa : new $fd179abe7398b4e4$var$__PRIVATE_DocumentChangeSet, r = t ? t.Ta : this.Ta;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $fd179abe7398b4e4$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.Ra(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.Ia(c, _) > 0 || a && this.Ia(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            Ta: s,
            Aa: n,
            Xi: o,
            mutatedKeys: i
        };
    }
    Ra(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.Ta;
        this.Ta = e.Ta, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.Aa.Q_();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $fd179abe7398b4e4$var$fail();
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Ia(e.doc, t.doc)), this.Va(n), r = null != r && r;
        const o = t && !r ? this.ma() : [], _ = 0 === this.Pa.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.ha;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.ha = _, 0 !== s.length || a) return {
            snapshot: new $fd179abe7398b4e4$var$ViewSnapshot(this.query, e.Ta, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            fa: o
        };
        // no changes
        return {
            fa: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ j_(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            Ta: this.Ta,
            Aa: new $fd179abe7398b4e4$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Xi: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            fa: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ ga(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.la.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.Ta.has(e) && !this.Ta.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ Va(e) {
        e && (e.addedDocuments.forEach((e)=>this.la = this.la.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.la = this.la.delete(e)), this.current = e.current);
    }
    ma() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Pa;
        this.Pa = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet(), this.Ta.forEach((e)=>{
            this.ga(e.key) && (this.Pa = this.Pa.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Pa.has(e) || t.push(new $fd179abe7398b4e4$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Pa.forEach((n)=>{
            e.has(n) || t.push(new $fd179abe7398b4e4$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    pa(e) {
        this.la = e.hs, this.Pa = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        const t = this.da(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    ya() {
        return $fd179abe7398b4e4$var$ViewSnapshot.fromInitialDocuments(this.query, this.Ta, this.mutatedKeys, 0 /* SyncState.Local */  === this.ha, this.hasCachedResults);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $fd179abe7398b4e4$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $fd179abe7398b4e4$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.wa = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $fd179abe7398b4e4$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Sa = {}, this.ba = new $fd179abe7398b4e4$var$ObjectMap((e)=>$fd179abe7398b4e4$var$__PRIVATE_canonifyQuery(e), $fd179abe7398b4e4$var$__PRIVATE_queryEquals), this.Da = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Ca = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.va = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Fa = new Map, this.Ma = new $fd179abe7398b4e4$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.xa = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Oa = new Map, this.Na = $fd179abe7398b4e4$var$__PRIVATE_TargetIdGenerator.Ln(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.La = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.La;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.ba.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.ya()) : i = await $fd179abe7398b4e4$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $fd179abe7398b4e4$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_ensureWatchCallbacks(e);
    await $fd179abe7398b4e4$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $fd179abe7398b4e4$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $fd179abe7398b4e4$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = n ? e.sharedClientState.addLocalQueryTarget(s) : "not-current";
    let _;
    return r && (_ = await $fd179abe7398b4e4$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $fd179abe7398b4e4$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.Ba = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.da(n);
            i.Xi && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $fd179abe7398b4e4$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.da(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $fd179abe7398b4e4$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.fa), _.snapshot;
        })(e, t, n, r);
    const s = await $fd179abe7398b4e4$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $fd179abe7398b4e4$var$__PRIVATE_View(t, s.hs), _ = o.da(s.documents), a = $fd179abe7398b4e4$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $fd179abe7398b4e4$var$__PRIVATE_updateTrackedLimbos(e, n, u.fa);
    const c = new $fd179abe7398b4e4$var$__PRIVATE_QueryView(t, n, o);
    return e.ba.set(t, c), e.Da.has(n) ? e.Da.get(n).push(t) : e.Da.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), i = r.ba.get(t), s = r.Da.get(i.targetId);
    if (s.length > 1) return r.Da.set(i.targetId, s.filter((e)=>!$fd179abe7398b4e4$var$__PRIVATE_queryEquals(e, t))), void r.ba.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $fd179abe7398b4e4$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $fd179abe7398b4e4$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $fd179abe7398b4e4$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $fd179abe7398b4e4$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $fd179abe7398b4e4$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $fd179abe7398b4e4$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = n.ba.get(t), i = n.Da.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $fd179abe7398b4e4$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = $fd179abe7398b4e4$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $fd179abe7398b4e4$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $fd179abe7398b4e4$var$__PRIVATE_mutableDocumentMap(), a = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
                return n.os.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $fd179abe7398b4e4$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $fd179abe7398b4e4$var$__PRIVATE_PatchMutation(e.key, t, $fd179abe7398b4e4$var$__PRIVATE_extractFieldMask(t.value.mapValue), $fd179abe7398b4e4$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $fd179abe7398b4e4$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.xa[e.currentUser.toKey()];
            r || (r = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.xa[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $fd179abe7398b4e4$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $fd179abe7398b4e4$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    try {
        const e = await $fd179abe7398b4e4$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Fa.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.wa = !0 : e.modifiedDocuments.size > 0 ? $fd179abe7398b4e4$var$__PRIVATE_hardAssert(r.wa) : e.removedDocuments.size > 0 && ($fd179abe7398b4e4$var$__PRIVATE_hardAssert(r.wa), r.wa = !1));
        }), await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.ba.forEach((n, r)=>{
            const i = r.view.j_(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.U_)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.j_(t) && (r = !0);
            }), r && $fd179abe7398b4e4$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Sa.h_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Fa.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $fd179abe7398b4e4$var$MutableDocument.newNoDocument(s, $fd179abe7398b4e4$var$SnapshotVersion.min()));
        const n = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet().add(s), i = new $fd179abe7398b4e4$var$RemoteEvent($fd179abe7398b4e4$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$var$__PRIVATE_primitiveComparator), e, n);
        await $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.va = r.va.remove(s), r.Fa.delete(t), $fd179abe7398b4e4$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $fd179abe7398b4e4$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$fd179abe7398b4e4$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $fd179abe7398b4e4$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $fd179abe7398b4e4$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $fd179abe7398b4e4$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($fd179abe7398b4e4$var$__PRIVATE_hardAssert(null !== t), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $fd179abe7398b4e4$var$__PRIVATE_processUserCallback(r, t, n), $fd179abe7398b4e4$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    $fd179abe7398b4e4$var$__PRIVATE_canUseNetwork(n.remoteStore) || $fd179abe7398b4e4$var$__PRIVATE_logDebug("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (-1 === e) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.Oa.get(e) || [];
        r.push(t), n.Oa.set(e, r);
    } catch (e) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $fd179abe7398b4e4$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Oa.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.Oa.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $fd179abe7398b4e4$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    let i = r.xa[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.xa[r.currentUser.toKey()] = i;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Da.get(t))e.ba.delete(r), n && e.Sa.ka(r, n);
    if (e.Da.delete(t), e.isPrimaryClient) e.Ma.Vr(t).forEach((t)=>{
        e.Ma.containsKey(t) || // We removed the last reference for this key
        $fd179abe7398b4e4$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $fd179abe7398b4e4$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Ca.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.va.get(t);
    null !== n && ($fd179abe7398b4e4$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.va = e.va.remove(t), e.Fa.delete(n), $fd179abe7398b4e4$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $fd179abe7398b4e4$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $fd179abe7398b4e4$var$__PRIVATE_AddedLimboDocument) e.Ma.addReference(r.key, t), $fd179abe7398b4e4$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $fd179abe7398b4e4$var$__PRIVATE_RemovedLimboDocument) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SyncEngine", "Document no longer in limbo: " + r.key), e.Ma.removeReference(r.key, t);
        e.Ma.containsKey(r.key) || // We removed the last reference for this key
        $fd179abe7398b4e4$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.va.get(n) || e.Ca.has(r) || ($fd179abe7398b4e4$var$__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n), e.Ca.add(r), $fd179abe7398b4e4$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $fd179abe7398b4e4$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Ca.size > 0 && e.va.size < e.maxConcurrentLimboResolutions;){
        const t = e.Ca.values().next().value;
        e.Ca.delete(t);
        const n = new $fd179abe7398b4e4$export$afc2e57c475b7810($fd179abe7398b4e4$var$ResourcePath.fromString(t)), r = e.Na.next();
        e.Fa.set(r, new $fd179abe7398b4e4$var$LimboResolution(n)), e.va = e.va.insert(n, r), $fd179abe7398b4e4$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $fd179abe7398b4e4$var$TargetData($fd179abe7398b4e4$var$__PRIVATE_queryToTarget($fd179abe7398b4e4$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $fd179abe7398b4e4$var$__PRIVATE_ListenSequence.oe));
    }
}
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.ba.isEmpty() || (r.ba.forEach((e, _)=>{
        o.push(r.Ba(_, t, n).then((e)=>{
            // Update views if there are actual changes.
            if (// If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            (e || n) && r.isPrimaryClient && r.sharedClientState.updateQueryState(_.targetId, (null == e ? void 0 : e.fromCache) ? "not-current" : "current"), e) {
                i.push(e);
                const t = $fd179abe7398b4e4$var$__PRIVATE_LocalViewChanges.Ki(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Sa.h_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$fd179abe7398b4e4$var$PersistencePromise.forEach(t, (t)=>$fd179abe7398b4e4$var$PersistencePromise.forEach(t.qi, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$fd179abe7398b4e4$var$PersistencePromise.forEach(t.Qi, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $fd179abe7398b4e4$var$__PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.ns.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.ns = n.ns.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $fd179abe7398b4e4$var$__PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
        const e = await $fd179abe7398b4e4$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.Oa.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.CANCELLED, t));
                });
            }), e.Oa.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.us);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = n.Fa.get(t);
    if (r && r.wa) return $fd179abe7398b4e4$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $fd179abe7398b4e4$var$__PRIVATE_documentKeySet();
        const r = n.Da.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.ba.get(t);
            e = e.unionWith(r.view.Ea);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $fd179abe7398b4e4$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = await $fd179abe7398b4e4$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.pa(r);
    return n.isPrimaryClient && $fd179abe7398b4e4$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.fa), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return $fd179abe7398b4e4$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.vn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $fd179abe7398b4e4$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $fd179abe7398b4e4$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($fd179abe7398b4e4$var$__PRIVATE_processUserCallback(i, t, r || null), $fd179abe7398b4e4$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $fd179abe7398b4e4$var$__PRIVATE_debugCast($fd179abe7398b4e4$var$__PRIVATE_debugCast(e).mutationQueue).Mn(t);
    }(i.localStore, t)) : $fd179abe7398b4e4$var$fail(), await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $fd179abe7398b4e4$var$__PRIVATE_logDebug("SyncEngine", "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    if ($fd179abe7398b4e4$var$__PRIVATE_ensureWatchCallbacks(n), $fd179abe7398b4e4$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.La) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $fd179abe7398b4e4$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.La = !0, await $fd179abe7398b4e4$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$fd179abe7398b4e4$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.La) {
        const e = [];
        let t = Promise.resolve();
        n.Da.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($fd179abe7398b4e4$var$__PRIVATE_removeAndCleanupTarget(n, i), $fd179abe7398b4e4$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $fd179abe7398b4e4$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $fd179abe7398b4e4$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            t.Fa.forEach((e, n)=>{
                $fd179abe7398b4e4$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Ma.mr(), t.Fa = new Map, t.va = new $fd179abe7398b4e4$var$SortedMap($fd179abe7398b4e4$export$afc2e57c475b7810.comparator);
        }(n), n.La = !1, await $fd179abe7398b4e4$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $fd179abe7398b4e4$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Da.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $fd179abe7398b4e4$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.ba.get(e), n = await $fd179abe7398b4e4$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $fd179abe7398b4e4$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $fd179abe7398b4e4$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $fd179abe7398b4e4$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $fd179abe7398b4e4$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Sa.h_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $fd179abe7398b4e4$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $fd179abe7398b4e4$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_debugCast($fd179abe7398b4e4$var$__PRIVATE_debugCast(e).persistence).Bi();
    }($fd179abe7398b4e4$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    if (i.La) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $fd179abe7398b4e4$var$__PRIVATE_logDebug("SyncEngine", "Ignoring unexpected query state notification.");
    const s = i.Da.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $fd179abe7398b4e4$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $fd179abe7398b4e4$var$__PRIVATE_queryCollectionGroup(s[0])), r = $fd179abe7398b4e4$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $fd179abe7398b4e4$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $fd179abe7398b4e4$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $fd179abe7398b4e4$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $fd179abe7398b4e4$var$fail();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.La) {
        for (const e of t){
            if (r.Da.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $fd179abe7398b4e4$var$__PRIVATE_logDebug("SyncEngine", "Adding an already active target " + e);
                continue;
            }
            const t = await $fd179abe7398b4e4$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $fd179abe7398b4e4$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $fd179abe7398b4e4$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $fd179abe7398b4e4$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $fd179abe7398b4e4$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Da.has(e) && // Release queries that are still active.
        await $fd179abe7398b4e4$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $fd179abe7398b4e4$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $fd179abe7398b4e4$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($fd179abe7398b4e4$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $fd179abe7398b4e4$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $fd179abe7398b4e4$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Sa.h_ = $fd179abe7398b4e4$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Sa.ka = $fd179abe7398b4e4$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $fd179abe7398b4e4$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $fd179abe7398b4e4$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $fd179abe7398b4e4$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = $fd179abe7398b4e4$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.$r.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($fd179abe7398b4e4$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $fd179abe7398b4e4$var$__PRIVATE_BundleLoader(r, e.localStore, t.serializer);
            let s = await t.qa();
            for(; s;){
                const e = await i._a(s);
                e && n._updateProgress(e), s = await t.qa();
            }
            const o = await i.complete();
            return await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.ca, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.$r.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.ua);
        } catch (e) {
            return $fd179abe7398b4e4$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $fd179abe7398b4e4$var$MemoryOfflineComponentProvider {
    constructor(){
        this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $fd179abe7398b4e4$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.createSharedClientState(e), this.persistence = this.createPersistence(e), await this.persistence.start(), this.localStore = this.createLocalStore(e), this.gcScheduler = this.createGarbageCollectionScheduler(e, this.localStore), this.indexBackfillerScheduler = this.createIndexBackfillerScheduler(e, this.localStore);
    }
    createGarbageCollectionScheduler(e, t) {
        return null;
    }
    createIndexBackfillerScheduler(e, t) {
        return null;
    }
    createLocalStore(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_newLocalStore(this.persistence, new $fd179abe7398b4e4$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    createPersistence(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_MemoryPersistence($fd179abe7398b4e4$var$__PRIVATE_MemoryEagerDelegate.Hr, this.serializer);
    }
    createSharedClientState(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        var e, t;
        null === (e = this.gcScheduler) || void 0 === e || e.stop(), null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $fd179abe7398b4e4$var$MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    createGarbageCollectionScheduler(e, t) {
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $fd179abe7398b4e4$var$__PRIVATE_MemoryLruDelegate);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $fd179abe7398b4e4$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    createPersistence(e) {
        const t = void 0 !== this.cacheSizeBytes ? $fd179abe7398b4e4$var$LruParams.withCacheSize(this.cacheSizeBytes) : $fd179abe7398b4e4$var$LruParams.DEFAULT;
        return new $fd179abe7398b4e4$var$__PRIVATE_MemoryPersistence((e)=>$fd179abe7398b4e4$var$__PRIVATE_MemoryLruDelegate.Hr(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $fd179abe7398b4e4$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $fd179abe7398b4e4$var$MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.Qa = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Qa.initialize(this, e), // Enqueue writes from a previous session
        await $fd179abe7398b4e4$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Qa.syncEngine), await $fd179abe7398b4e4$var$__PRIVATE_fillWritePipeline(this.Qa.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.fi(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    createLocalStore(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_newLocalStore(this.persistence, new $fd179abe7398b4e4$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    createGarbageCollectionScheduler(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $fd179abe7398b4e4$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    createIndexBackfillerScheduler(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $fd179abe7398b4e4$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    createPersistence(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $fd179abe7398b4e4$var$LruParams.withCacheSize(this.cacheSizeBytes) : $fd179abe7398b4e4$var$LruParams.DEFAULT;
        return new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $fd179abe7398b4e4$var$__PRIVATE_getWindow(), $fd179abe7398b4e4$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    createSharedClientState(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $fd179abe7398b4e4$var$__PRIVATE_MultiTabOfflineComponentProvider extends $fd179abe7398b4e4$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.Qa = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Qa.syncEngine;
        this.sharedClientState instanceof $fd179abe7398b4e4$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Zs: $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            Xs: $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            eo: $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            Bi: $fd179abe7398b4e4$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            Ys: $fd179abe7398b4e4$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.fi(async (e)=>{
            await $fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyPrimaryState(this.Qa.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    createSharedClientState(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_getWindow();
        if (!$fd179abe7398b4e4$var$__PRIVATE_WebStorageSharedClientState.D(t)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $fd179abe7398b4e4$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $fd179abe7398b4e4$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $fd179abe7398b4e4$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $fd179abe7398b4e4$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $fd179abe7398b4e4$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $fd179abe7398b4e4$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $fd179abe7398b4e4$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $fd179abe7398b4e4$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $fd179abe7398b4e4$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$fd179abe7398b4e4$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $fd179abe7398b4e4$var$__PRIVATE_BrowserConnectivityMonitor.D() ? new $fd179abe7398b4e4$var$__PRIVATE_BrowserConnectivityMonitor : new $fd179abe7398b4e4$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $fd179abe7398b4e4$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.La = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        var e;
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            $fd179abe7398b4e4$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."), t.M_.add(5 /* OfflineCause.Shutdown */ ), await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkInternal(t), t.O_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.N_.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), null === (e = this.datastore) || void 0 === e || e.terminate();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $fd179abe7398b4e4$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $fd179abe7398b4e4$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.observer.next && this.Ka(this.observer.next, e);
    }
    error(e) {
        this.observer.error ? this.Ka(this.observer.error, e) : $fd179abe7398b4e4$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString());
    }
    $a() {
        this.muted = !0;
    }
    Ka(e, t) {
        this.muted || setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $fd179abe7398b4e4$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Ua = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $fd179abe7398b4e4$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Wa = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.Ga().then((e)=>{
            e && e.sa() ? this.metadata.resolve(e.ia.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.ia)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Ua.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async qa() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.Ga();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async Ga() {
        const e = await this.za();
        if (null === e) return null;
        const t = this.Wa.decode(e), n = Number(t);
        isNaN(n) && this.ja(`length string (${t}) is not valid number`);
        const r = await this.Ha(n);
        return new $fd179abe7398b4e4$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ Ja() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async za() {
        for(; this.Ja() < 0;){
            if (await this.Ya()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.Ja();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.ja("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Ha(e) {
        for(; this.buffer.length < e;)await this.Ya() && this.ja("Reached the end of bundle when more is expected.");
        const t = this.Wa.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    ja(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Ua.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Ya() {
        const e = await this.Ua.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $fd179abe7398b4e4$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.xo("BatchGetDocuments", n.serializer.databaseId, $fd179abe7398b4e4$var$ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $fd179abe7398b4e4$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $fd179abe7398b4e4$var$__PRIVATE_hardAssert(!!t), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $fd179abe7398b4e4$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $fd179abe7398b4e4$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $fd179abe7398b4e4$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$fd179abe7398b4e4$var$toMutation(n.serializer, e))
            };
            await n.Co("Commit", n.serializer.databaseId, $fd179abe7398b4e4$var$ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $fd179abe7398b4e4$var$fail();
            // Represent a deleted doc using SnapshotVersion.min().
            t = $fd179abe7398b4e4$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min()) ? $fd179abe7398b4e4$var$Precondition.exists(!1) : $fd179abe7398b4e4$var$Precondition.updateTime(t) : $fd179abe7398b4e4$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($fd179abe7398b4e4$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $fd179abe7398b4e4$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $fd179abe7398b4e4$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $fd179abe7398b4e4$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Za = n.maxAttempts, this.Yo = new $fd179abe7398b4e4$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ Xa() {
        this.Za -= 1, this.eu();
    }
    eu() {
        this.Yo.$o(async ()=>{
            const e = new $fd179abe7398b4e4$var$Transaction$2(this.datastore), t = this.tu(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.nu(e);
                    }));
            }).catch((e)=>{
                this.nu(e);
            });
        });
    }
    tu(e) {
        try {
            const t = this.updateFunction(e);
            return !$fd179abe7398b4e4$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    nu(e) {
        this.Za > 0 && this.ru(e) ? (this.Za -= 1, this.asyncQueue.enqueueAndForget(()=>(this.eu(), Promise.resolve()))) : this.deferred.reject(e);
    }
    ru(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$fd179abe7398b4e4$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $fd179abe7398b4e4$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $fd179abe7398b4e4$var$User.UNAUTHENTICATED, this.clientId = $fd179abe7398b4e4$export$253bcaa5572dcc83.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this.authCredentials.start(n, async (e)=>{
            $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    /**
     * Checks that the client has not been terminated. Ensures that other methods on //
     * this class cannot be called after the client is terminated. //
     */ verifyNotTerminated() {
        if (this.asyncQueue.isShuttingDown) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $fd179abe7398b4e4$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $fd179abe7398b4e4$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $fd179abe7398b4e4$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $fd179abe7398b4e4$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $fd179abe7398b4e4$var$__PRIVATE_ensureOfflineComponents(e);
    $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$fd179abe7398b4e4$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$fd179abe7398b4e4$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function $fd179abe7398b4e4$var$__PRIVATE_canFallbackFromIndexedDbError(e) {
    return "FirebaseError" === e.name ? e.code === $fd179abe7398b4e4$var$C.FAILED_PRECONDITION || e.code === $fd179abe7398b4e4$var$C.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
    // or an aborted error depending on whether the error happened during
    // schema migration.
    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
    // INVALID_STATE for any usage.
    11 === e.code;
}
async function $fd179abe7398b4e4$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OfflineComponentProvider");
            try {
                await $fd179abe7398b4e4$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!$fd179abe7398b4e4$var$__PRIVATE_canFallbackFromIndexedDbError(n)) throw n;
                $fd179abe7398b4e4$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $fd179abe7398b4e4$var$__PRIVATE_setOfflineComponentProvider(e, new $fd179abe7398b4e4$var$MemoryOfflineComponentProvider);
            }
        } else $fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Using default OfflineComponentProvider"), await $fd179abe7398b4e4$var$__PRIVATE_setOfflineComponentProvider(e, new $fd179abe7398b4e4$var$MemoryOfflineComponentProvider);
    }
    return e._offlineComponents;
}
async function $fd179abe7398b4e4$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OnlineComponentProvider"), await $fd179abe7398b4e4$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($fd179abe7398b4e4$var$__PRIVATE_logDebug("FirestoreClient", "Using default OnlineComponentProvider"), await $fd179abe7398b4e4$var$__PRIVATE_setOnlineComponentProvider(e, new $fd179abe7398b4e4$var$OnlineComponentProvider))), e._onlineComponents;
}
function $fd179abe7398b4e4$var$__PRIVATE_getPersistence(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $fd179abe7398b4e4$var$__PRIVATE_getLocalStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $fd179abe7398b4e4$var$__PRIVATE_getRemoteStore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $fd179abe7398b4e4$var$__PRIVATE_getSyncEngine(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $fd179abe7398b4e4$var$__PRIVATE_getDatastore(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $fd179abe7398b4e4$var$__PRIVATE_getEventManager(e) {
    const t = await $fd179abe7398b4e4$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $fd179abe7398b4e4$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $fd179abe7398b4e4$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $fd179abe7398b4e4$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $fd179abe7398b4e4$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $fd179abe7398b4e4$var$__PRIVATE_getPersistence(e), n = await $fd179abe7398b4e4$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            return t.M_.delete(0 /* OfflineCause.UserDisabled */ ), $fd179abe7398b4e4$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $fd179abe7398b4e4$var$__PRIVATE_getPersistence(e), n = await $fd179abe7398b4e4$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            t.M_.add(0 /* OfflineCause.UserDisabled */ ), await $fd179abe7398b4e4$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.N_.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $fd179abe7398b4e4$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $fd179abe7398b4e4$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $fd179abe7398b4e4$var$__PRIVATE_AsyncObserver({
                next: (s)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    t.enqueueAndForget(()=>$fd179abe7398b4e4$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const _ = s.docs.has(n);
                    !_ && s.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNAVAILABLE, "Failed to get document because the client is offline.")) : _ && s.fromCache && r && "server" === r.source ? i.reject(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(s);
                },
                error: (e)=>i.reject(e)
            }), o = new $fd179abe7398b4e4$var$__PRIVATE_QueryListener($fd179abe7398b4e4$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                ra: !0
            });
            return $fd179abe7398b4e4$var$__PRIVATE_eventManagerListen(e, o);
        })(await $fd179abe7398b4e4$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $fd179abe7398b4e4$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $fd179abe7398b4e4$var$__PRIVATE_View(t, r.hs), s = i.da(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $fd179abe7398b4e4$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $fd179abe7398b4e4$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $fd179abe7398b4e4$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    t.enqueueAndForget(()=>$fd179abe7398b4e4$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $fd179abe7398b4e4$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                ra: !0
            });
            return $fd179abe7398b4e4$var$__PRIVATE_eventManagerListen(e, o);
        })(await $fd179abe7398b4e4$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $fd179abe7398b4e4$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                var r;
                const i = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), { request: s, ut: o, parent: _ } = $fd179abe7398b4e4$var$__PRIVATE_toRunAggregationQueryRequest(i.serializer, $fd179abe7398b4e4$var$__PRIVATE_queryToAggregateTarget(t), n);
                i.connection.Do || delete s.parent;
                const a = (await i.xo("RunAggregationQuery", i.serializer.databaseId, _, s, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $fd179abe7398b4e4$var$__PRIVATE_hardAssert(1 === a.length);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                return Object.keys(u).reduce((e, t)=>(e[o[t]] = u[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $fd179abe7398b4e4$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $fd179abe7398b4e4$var$__PRIVATE_debugCast(e).z_.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $fd179abe7398b4e4$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.$a(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $fd179abe7398b4e4$var$__PRIVATE_debugCast(e).z_.delete(t);
            })(await $fd179abe7398b4e4$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $fd179abe7398b4e4$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $fd179abe7398b4e4$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $fd179abe7398b4e4$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $fd179abe7398b4e4$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $fd179abe7398b4e4$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $fd179abe7398b4e4$var$__PRIVATE_syncEngineLoadBundle(await $fd179abe7398b4e4$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.$r.getNamedQuery(e, t));
        })(await $fd179abe7398b4e4$var$__PRIVATE_getLocalStore(e), t));
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $fd179abe7398b4e4$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$fd179abe7398b4e4$var$PersistencePromise.waitFor(i)));
        })(await $fd179abe7398b4e4$var$__PRIVATE_getLocalStore(e), t));
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $fd179abe7398b4e4$var$__PRIVATE_debugCast(e).ts.Ui = t;
        })(await $fd179abe7398b4e4$var$__PRIVATE_getLocalStore(e), t));
}
function $fd179abe7398b4e4$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $fd179abe7398b4e4$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $fd179abe7398b4e4$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $fd179abe7398b4e4$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$ye = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fd179abe7398b4e4$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $fd179abe7398b4e4$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $fd179abe7398b4e4$var$__PRIVATE_validateDocumentPath(e) {
    if (!$fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(e)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $fd179abe7398b4e4$var$__PRIVATE_validateCollectionPath(e) {
    if ($fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(e)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $fd179abe7398b4e4$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $fd179abe7398b4e4$var$fail();
}
function $fd179abe7398b4e4$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $fd179abe7398b4e4$var$__PRIVATE_valueDescription(e);
            throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $fd179abe7398b4e4$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $fd179abe7398b4e4$var$FirestoreSettingsImpl {
    constructor(e){
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = e.host, this.ssl = null === (t = e.ssl) || void 0 === t || t;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $fd179abe7398b4e4$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $fd179abe7398b4e4$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $fd179abe7398b4e4$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $fd179abe7398b4e4$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1;
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return void 0 !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $fd179abe7398b4e4$var$FirestoreSettingsImpl(e), void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $fd179abe7398b4e4$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $fd179abe7398b4e4$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $fd179abe7398b4e4$var$ye.get(e);
            t && ($fd179abe7398b4e4$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $fd179abe7398b4e4$var$ye.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $fd179abe7398b4e4$export$966a03d25297d115(e, t, n, r = {}) {
    var i;
    const s = (e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$var$Firestore$1))._getSettings(), o = `${t}:${n}`;
    if ("firestore.googleapis.com" !== s.host && s.host !== o && $fd179abe7398b4e4$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), r.mockUserToken) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $fd179abe7398b4e4$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $59fdd18afb377ad5$export$367bf224123348f1)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $fd179abe7398b4e4$var$User(s);
        }
        e._authCredentials = new $fd179abe7398b4e4$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $fd179abe7398b4e4$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $fd179abe7398b4e4$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $fd179abe7398b4e4$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $fd179abe7398b4e4$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $fd179abe7398b4e4$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $fd179abe7398b4e4$export$6be62b059fb12175(this.firestore, e, this._key);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $fd179abe7398b4e4$export$ab5a1a47940a200e extends $fd179abe7398b4e4$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $fd179abe7398b4e4$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $fd179abe7398b4e4$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $fd179abe7398b4e4$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $fd179abe7398b4e4$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $fd179abe7398b4e4$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e), $fd179abe7398b4e4$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $fd179abe7398b4e4$var$Firestore$1) {
        const r = $fd179abe7398b4e4$var$ResourcePath.fromString(t, ...n);
        return $fd179abe7398b4e4$var$__PRIVATE_validateCollectionPath(r), new $fd179abe7398b4e4$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $fd179abe7398b4e4$export$6be62b059fb12175 || e instanceof $fd179abe7398b4e4$export$ab5a1a47940a200e)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($fd179abe7398b4e4$var$ResourcePath.fromString(t, ...n));
        return $fd179abe7398b4e4$var$__PRIVATE_validateCollectionPath(r), new $fd179abe7398b4e4$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $fd179abe7398b4e4$export$473d82a73f88c107(e, t) {
    if (e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$var$Firestore$1), $fd179abe7398b4e4$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $fd179abe7398b4e4$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl($fd179abe7398b4e4$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $fd179abe7398b4e4$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $fd179abe7398b4e4$export$253bcaa5572dcc83.newId()), $fd179abe7398b4e4$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $fd179abe7398b4e4$var$Firestore$1) {
        const r = $fd179abe7398b4e4$var$ResourcePath.fromString(t, ...n);
        return $fd179abe7398b4e4$var$__PRIVATE_validateDocumentPath(r), new $fd179abe7398b4e4$export$6be62b059fb12175(e, /* converter= */ null, new $fd179abe7398b4e4$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $fd179abe7398b4e4$export$6be62b059fb12175 || e instanceof $fd179abe7398b4e4$export$ab5a1a47940a200e)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($fd179abe7398b4e4$var$ResourcePath.fromString(t, ...n));
        return $fd179abe7398b4e4$var$__PRIVATE_validateDocumentPath(r), new $fd179abe7398b4e4$export$6be62b059fb12175(e.firestore, e instanceof $fd179abe7398b4e4$export$ab5a1a47940a200e ? e.converter : null, new $fd179abe7398b4e4$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $fd179abe7398b4e4$export$62a32f2da6187d11(e, t) {
    return e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e), t = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(t), (e instanceof $fd179abe7398b4e4$export$6be62b059fb12175 || e instanceof $fd179abe7398b4e4$export$ab5a1a47940a200e) && (t instanceof $fd179abe7398b4e4$export$6be62b059fb12175 || t instanceof $fd179abe7398b4e4$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $fd179abe7398b4e4$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e), t = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(t), e instanceof $fd179abe7398b4e4$export$62297b13309008b2 && t instanceof $fd179abe7398b4e4$export$62297b13309008b2 && e.firestore === t.firestore && $fd179abe7398b4e4$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fd179abe7398b4e4$var$__PRIVATE_AsyncQueueImpl {
    constructor(){
        // The last promise in the queue.
        this.iu = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.su = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.ou = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this._u = [], // visible for testing
        this.au = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.uu = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.cu = !1, // List of TimerIds to fast-forward delays for.
        this.lu = [], // Backoff timer used to schedule retries for retryable operations
        this.Yo = new $fd179abe7398b4e4$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.hu = ()=>{
            const e = $fd179abe7398b4e4$var$getDocument();
            e && $fd179abe7398b4e4$var$__PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + e.visibilityState), this.Yo.Wo();
        };
        const e = $fd179abe7398b4e4$var$getDocument();
        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.hu);
    }
    get isShuttingDown() {
        return this.ou;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.Pu(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Iu(e);
    }
    enterRestrictedMode(e) {
        if (!this.ou) {
            this.ou = !0, this.cu = e || !1;
            const t = $fd179abe7398b4e4$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.hu);
        }
    }
    enqueue(e) {
        if (this.Pu(), this.ou) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
        return this.Iu(()=>this.ou && this.cu ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.su.push(e), this.Tu()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async Tu() {
        if (0 !== this.su.length) {
            try {
                await this.su[0](), this.su.shift(), this.Yo.reset();
            } catch (e) {
                if (!$fd179abe7398b4e4$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $fd179abe7398b4e4$var$__PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + e);
            }
            this.su.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.Yo.$o(()=>this.Tu());
        }
    }
    Iu(e) {
        const t = this.iu.then(()=>(this.uu = !0, e().catch((e)=>{
                this.au = e, this.uu = !1;
                const t = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
                    let t = e.message || "";
                    e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                    return t;
                }(e);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $fd179abe7398b4e4$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
            }).then((e)=>(this.uu = !1, e))));
        return this.iu = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.Pu(), // Fast-forward delays for timerIds that have been overriden.
        this.lu.indexOf(e) > -1 && (t = 0);
        const r = $fd179abe7398b4e4$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.Eu(e));
        return this._u.push(r), r;
    }
    Pu() {
        this.au && $fd179abe7398b4e4$var$fail();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async du() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.iu, await e;
        while (e !== this.iu);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Au(e) {
        for (const t of this._u)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Ru(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.du().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            this._u.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this._u)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.du();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Vu(e) {
        this.lu.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ Eu(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this._u.indexOf(e);
        this._u.splice(t, 1);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $fd179abe7398b4e4$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $fd179abe7398b4e4$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $fd179abe7398b4e4$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $fd179abe7398b4e4$export$d0e2b3272814ce82 extends $fd179abe7398b4e4$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = function __PRIVATE_newAsyncQueue() {
            return new $fd179abe7398b4e4$var$__PRIVATE_AsyncQueueImpl;
        }(), this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    _terminate() {
        return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        $fd179abe7398b4e4$var$__PRIVATE_configureFirestore(this), this._firestoreClient.terminate();
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $fd179abe7398b4e4$export$9061557f3e3b42f9(e, t, n) {
    n || (n = "(default)");
    const r = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $fd179abe7398b4e4$export$f06a05d14c3a6678(t, n) {
    const r = "object" == typeof t ? t : (0, $6de42d4eacc8610d$export$f9962582c9e66d99)(), i = "string" == typeof t ? t : n || "(default)", s = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $59fdd18afb377ad5$export$a3febcf1f14a3a0c)("firestore");
        e && $fd179abe7398b4e4$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $fd179abe7398b4e4$export$8da5fbea04405656(e) {
    return e._firestoreClient || $fd179abe7398b4e4$var$__PRIVATE_configureFirestore(e), e._firestoreClient.verifyNotTerminated(), e._firestoreClient;
}
function $fd179abe7398b4e4$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $fd179abe7398b4e4$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $fd179abe7398b4e4$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._firestoreClient = new $fd179abe7398b4e4$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s), (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._firestoreClient._uninitializedComponentsProvider = {
        _offlineKind: i.localCache.kind,
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    });
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * On failure, `enableIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * Note: `enableIndexedDbPersistence()` must be called before any other functions
 * (other than {@link initializeFirestore}, {@link (getFirestore:1)} or
 * {@link clearIndexedDbPersistence}.
 *
 * Persistence cannot be used in a Node.js environment.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on IndexedDb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function $fd179abe7398b4e4$export$cebe3b626a79c5f3(e, t) {
    $fd179abe7398b4e4$var$__PRIVATE_verifyNotInitialized(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82));
    const n = $fd179abe7398b4e4$export$8da5fbea04405656(e);
    if (n._uninitializedComponentsProvider) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "SDK cache is already specified.");
    $fd179abe7398b4e4$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const r = e._freezeSettings(), i = new $fd179abe7398b4e4$var$OnlineComponentProvider;
    return $fd179abe7398b4e4$var$__PRIVATE_setPersistenceProviders(n, i, new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbOfflineComponentProvider(i, r.cacheSizeBytes, null == t ? void 0 : t.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function $fd179abe7398b4e4$export$6d4c055e91302ab9(e) {
    $fd179abe7398b4e4$var$__PRIVATE_verifyNotInitialized(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82));
    const t = $fd179abe7398b4e4$export$8da5fbea04405656(e);
    if (t._uninitializedComponentsProvider) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "SDK cache is already specified.");
    $fd179abe7398b4e4$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings(), r = new $fd179abe7398b4e4$var$OnlineComponentProvider;
    return $fd179abe7398b4e4$var$__PRIVATE_setPersistenceProviders(t, r, new $fd179abe7398b4e4$var$__PRIVATE_MultiTabOfflineComponentProvider(r, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $fd179abe7398b4e4$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    const r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueue(async ()=>{
        try {
            await $fd179abe7398b4e4$var$__PRIVATE_setOfflineComponentProvider(e, n), await $fd179abe7398b4e4$var$__PRIVATE_setOnlineComponentProvider(e, t), r.resolve();
        } catch (e) {
            const t = e;
            if (!$fd179abe7398b4e4$var$__PRIVATE_canFallbackFromIndexedDbError(t)) throw t;
            $fd179abe7398b4e4$export$86cd73f49cc6e0bb("Error enabling indexeddb cache. Falling back to memory cache: " + t), r.reject(t);
        }
    }).then(()=>r.promise);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $fd179abe7398b4e4$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$fd179abe7398b4e4$var$__PRIVATE_SimpleDb.D()) return Promise.resolve();
                const t = e + "main";
                await $fd179abe7398b4e4$var$__PRIVATE_SimpleDb.delete(t);
            }($fd179abe7398b4e4$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $fd179abe7398b4e4$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$fd179abe7398b4e4$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $fd179abe7398b4e4$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $fd179abe7398b4e4$export$ee6bdee8287ecc5f(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientEnableNetwork($fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $fd179abe7398b4e4$export$f35b708ad73d52eb(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientDisableNetwork($fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $fd179abe7398b4e4$export$9aff22d1ec357a14(e) {
    return (0, $6de42d4eacc8610d$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $fd179abe7398b4e4$export$4b8b93c690c9810b(e, t) {
    const n = $fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82)), r = new $fd179abe7398b4e4$export$6cac12425252ec14;
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $fd179abe7398b4e4$export$169d2c6fe0f7f4ea(e, t) {
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetNamedQuery($fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82)), t).then((t)=>t ? new $fd179abe7398b4e4$export$62297b13309008b2(e, null, t.query) : null);
}
function $fd179abe7398b4e4$var$__PRIVATE_verifyNotInitialized(e) {
    if (e._initialized || e._terminated) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $fd179abe7398b4e4$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(e = "count", t){
        this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $fd179abe7398b4e4$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $fd179abe7398b4e4$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $fd179abe7398b4e4$export$9f55f2e2bf8c2fc1($fd179abe7398b4e4$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $fd179abe7398b4e4$export$9f55f2e2bf8c2fc1($fd179abe7398b4e4$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $fd179abe7398b4e4$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $fd179abe7398b4e4$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $fd179abe7398b4e4$export$bf6e62266977b8eb() {
    return new $fd179abe7398b4e4$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $fd179abe7398b4e4$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $fd179abe7398b4e4$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $fd179abe7398b4e4$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$Se = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $fd179abe7398b4e4$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $fd179abe7398b4e4$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $fd179abe7398b4e4$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $fd179abe7398b4e4$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $fd179abe7398b4e4$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $fd179abe7398b4e4$var$fail();
    }
}
/** A "context" object passed around while parsing user data. */ class $fd179abe7398b4e4$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.mu(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get fu() {
        return this.settings.fu;
    }
    /** Returns a new context with the specified settings overwritten. */ gu(e) {
        return new $fd179abe7398b4e4$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    pu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.gu({
            path: n,
            yu: !1
        });
        return r.wu(e), r;
    }
    Su(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.gu({
            path: n,
            yu: !1
        });
        return r.mu(), r;
    }
    bu(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.gu({
            path: void 0,
            yu: !0
        });
    }
    Du(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.Cu || !1, this.path, this.settings.vu);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    mu() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.wu(this.path.get(e));
    }
    wu(e) {
        if (0 === e.length) throw this.Du("Document fields must not be empty");
        if ($fd179abe7398b4e4$var$__PRIVATE_isWrite(this.fu) && $fd179abe7398b4e4$var$Se.test(e)) throw this.Du('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $fd179abe7398b4e4$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $fd179abe7398b4e4$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ Fu(e, t, n, r = !1) {
        return new $fd179abe7398b4e4$var$__PRIVATE_ParseContextImpl({
            fu: e,
            methodName: t,
            vu: n,
            path: $fd179abe7398b4e4$export$b7871852b967eaf1.emptyPath(),
            yu: !1,
            Cu: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $fd179abe7398b4e4$var$__PRIVATE_newSerializer(e._databaseId);
    return new $fd179abe7398b4e4$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $fd179abe7398b4e4$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.Fu(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $fd179abe7398b4e4$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $fd179abe7398b4e4$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $fd179abe7398b4e4$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $fd179abe7398b4e4$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $fd179abe7398b4e4$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $fd179abe7398b4e4$var$ParsedSetData(new $fd179abe7398b4e4$var$ObjectValue(_), a, u);
}
class $fd179abe7398b4e4$var$__PRIVATE_DeleteFieldValueImpl extends $fd179abe7398b4e4$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.fu) throw 1 /* UserDataSource.Update */  === e.fu ? e.Du(`${this._methodName}() can only appear at the top level of your update data`) : e.Du(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $fd179abe7398b4e4$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $fd179abe7398b4e4$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $fd179abe7398b4e4$var$__PRIVATE_ParseContextImpl({
        fu: 3 /* UserDataSource.Argument */ ,
        vu: t.settings.vu,
        methodName: e._methodName,
        yu: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampFieldValueImpl extends $fd179abe7398b4e4$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $fd179abe7398b4e4$var$FieldTransform(e.path, new $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionFieldValueImpl extends $fd179abe7398b4e4$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Mu = t;
    }
    _toFieldTransform(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Mu.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_parseData(e, t)), r = new $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $fd179abe7398b4e4$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(this.Mu, e.Mu);
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $fd179abe7398b4e4$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Mu = t;
    }
    _toFieldTransform(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Mu.map((e)=>$fd179abe7398b4e4$var$__PRIVATE_parseData(e, t)), r = new $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $fd179abe7398b4e4$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(this.Mu, e.Mu);
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementFieldValueImpl extends $fd179abe7398b4e4$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.xu = t;
    }
    _toFieldTransform(e) {
        const t = new $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $fd179abe7398b4e4$var$toNumber(e.serializer, this.xu));
        return new $fd179abe7398b4e4$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementFieldValueImpl && this.xu === e.xu;
    }
}
/** Parse update data from an update() call. */ function $fd179abe7398b4e4$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.Fu(1 /* UserDataSource.Update */ , t, n);
    $fd179abe7398b4e4$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $fd179abe7398b4e4$var$ObjectValue.empty();
    $fd179abe7398b4e4$var$forEach(r, (e, r)=>{
        const _ = $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(r);
        const a = i.Su(_);
        if (r instanceof $fd179abe7398b4e4$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $fd179abe7398b4e4$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $fd179abe7398b4e4$var$FieldMask(s);
    return new $fd179abe7398b4e4$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $fd179abe7398b4e4$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.Fu(1 /* UserDataSource.Update */ , t, n), _ = [
        $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $fd179abe7398b4e4$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$fd179abe7398b4e4$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(n);
        const r = o.Su(t);
        if (n instanceof $fd179abe7398b4e4$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $fd179abe7398b4e4$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $fd179abe7398b4e4$var$FieldMask(u);
    return new $fd179abe7398b4e4$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $fd179abe7398b4e4$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $fd179abe7398b4e4$var$__PRIVATE_parseData(n, e.Fu(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $fd179abe7398b4e4$var$__PRIVATE_parseData(e, t) {
    if ($fd179abe7398b4e4$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e))) return $fd179abe7398b4e4$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $fd179abe7398b4e4$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $fd179abe7398b4e4$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$fd179abe7398b4e4$var$__PRIVATE_isWrite(t.fu)) throw t.Du(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.Du(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.yu && 4 /* UserDataSource.ArrayArgument */  !== t.fu) throw t.Du("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $fd179abe7398b4e4$var$__PRIVATE_parseData(i, t.bu(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $fd179abe7398b4e4$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $fd179abe7398b4e4$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $fd179abe7398b4e4$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $fd179abe7398b4e4$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $fd179abe7398b4e4$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $fd179abe7398b4e4$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $fd179abe7398b4e4$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $fd179abe7398b4e4$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $fd179abe7398b4e4$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.Du(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $fd179abe7398b4e4$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        throw t.Du(`Unsupported field value: ${$fd179abe7398b4e4$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $fd179abe7398b4e4$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $fd179abe7398b4e4$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $fd179abe7398b4e4$var$forEach(e, (e, r)=>{
        const i = $fd179abe7398b4e4$var$__PRIVATE_parseData(r, t.pu(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $fd179abe7398b4e4$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $fd179abe7398b4e4$export$d9bcbd5e1ff81430 || e instanceof $fd179abe7398b4e4$export$f9f719d1b6419c4 || e instanceof $fd179abe7398b4e4$export$9f55f2e2bf8c2fc1 || e instanceof $fd179abe7398b4e4$export$6be62b059fb12175 || e instanceof $fd179abe7398b4e4$export$c58bc8ee7ecc248d);
}
function $fd179abe7398b4e4$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$fd179abe7398b4e4$var$__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.Du(e + " a custom object") : t.Du(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (t = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(t)) instanceof $fd179abe7398b4e4$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $fd179abe7398b4e4$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $fd179abe7398b4e4$var$be = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($fd179abe7398b4e4$var$be) >= 0) throw $fd179abe7398b4e4$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $fd179abe7398b4e4$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $fd179abe7398b4e4$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $fd179abe7398b4e4$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $fd179abe7398b4e4$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $fd179abe7398b4e4$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $fd179abe7398b4e4$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $fd179abe7398b4e4$var$QueryDocumentSnapshot$1 extends $fd179abe7398b4e4$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $fd179abe7398b4e4$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fd179abe7398b4e4$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $fd179abe7398b4e4$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $fd179abe7398b4e4$export$b0e86f2c7431df4e extends $fd179abe7398b4e4$var$AppliableConstraint {
}
function $fd179abe7398b4e4$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $fd179abe7398b4e4$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $fd179abe7398b4e4$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $fd179abe7398b4e4$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $fd179abe7398b4e4$export$f765fc5789dfd439 extends $fd179abe7398b4e4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $fd179abe7398b4e4$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $fd179abe7398b4e4$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $fd179abe7398b4e4$export$62297b13309008b2(e.firestore, e.converter, $fd179abe7398b4e4$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $fd179abe7398b4e4$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($fd179abe7398b4e4$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $fd179abe7398b4e4$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $fd179abe7398b4e4$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $fd179abe7398b4e4$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            return $fd179abe7398b4e4$var$FieldFilter.create(i, s, _);
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $fd179abe7398b4e4$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $fd179abe7398b4e4$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $fd179abe7398b4e4$export$6bbc7aef0717f3d2 extends $fd179abe7398b4e4$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $fd179abe7398b4e4$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $fd179abe7398b4e4$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$fd179abe7398b4e4$var$__PRIVATE_validateNewFieldFilter(n, e), n = $fd179abe7398b4e4$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $fd179abe7398b4e4$export$62297b13309008b2(e.firestore, e.converter, $fd179abe7398b4e4$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $fd179abe7398b4e4$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$fd179abe7398b4e4$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $fd179abe7398b4e4$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $fd179abe7398b4e4$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$fd179abe7398b4e4$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $fd179abe7398b4e4$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $fd179abe7398b4e4$export$65a9ba8bbd6ed9e3 extends $fd179abe7398b4e4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $fd179abe7398b4e4$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            return new $fd179abe7398b4e4$var$OrderBy(t, n);
        }(e._query, this._field, this._direction);
        return new $fd179abe7398b4e4$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $fd179abe7398b4e4$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $fd179abe7398b4e4$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $fd179abe7398b4e4$export$49bb5356ca788047 extends $fd179abe7398b4e4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $fd179abe7398b4e4$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $fd179abe7398b4e4$export$62297b13309008b2(e.firestore, e.converter, $fd179abe7398b4e4$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $fd179abe7398b4e4$export$ee37e834aaad6f7e(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_validatePositiveNumber("limit", e), $fd179abe7398b4e4$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $fd179abe7398b4e4$export$f823b3589f69d3b8(e) {
    return $fd179abe7398b4e4$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $fd179abe7398b4e4$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $fd179abe7398b4e4$export$d92e2830aca1d816 extends $fd179abe7398b4e4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $fd179abe7398b4e4$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $fd179abe7398b4e4$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $fd179abe7398b4e4$export$859941c5fc8eba6b(...e) {
    return $fd179abe7398b4e4$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $fd179abe7398b4e4$export$dd8dee5f7b804673(...e) {
    return $fd179abe7398b4e4$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $fd179abe7398b4e4$export$fd1782fd870d1e06 extends $fd179abe7398b4e4$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $fd179abe7398b4e4$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $fd179abe7398b4e4$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $fd179abe7398b4e4$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $fd179abe7398b4e4$export$57203950645b8b11(...e) {
    return $fd179abe7398b4e4$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $fd179abe7398b4e4$export$28ec54a8428bdb3f(...e) {
    return $fd179abe7398b4e4$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $fd179abe7398b4e4$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $fd179abe7398b4e4$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $fd179abe7398b4e4$var$__PRIVATE_queryNormalizedOrderBy(e))if (n.field.isKeyField()) s.push($fd179abe7398b4e4$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($fd179abe7398b4e4$var$__PRIVATE_isServerTimestamp(e)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $fd179abe7398b4e4$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$fd179abe7398b4e4$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($fd179abe7398b4e4$var$ResourcePath.fromString(a));
                    if (!$fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(n)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $fd179abe7398b4e4$export$afc2e57c475b7810(n);
                    _.push($fd179abe7398b4e4$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $fd179abe7398b4e4$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $fd179abe7398b4e4$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$fd179abe7398b4e4$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($fd179abe7398b4e4$var$ResourcePath.fromString(n));
        if (!$fd179abe7398b4e4$export$afc2e57c475b7810.isDocumentKey(r)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $fd179abe7398b4e4$var$__PRIVATE_refValue(e, new $fd179abe7398b4e4$export$afc2e57c475b7810(r));
    }
    if (n instanceof $fd179abe7398b4e4$export$6be62b059fb12175) return $fd179abe7398b4e4$var$__PRIVATE_refValue(e, n._key);
    throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$fd179abe7398b4e4$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $fd179abe7398b4e4$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $fd179abe7398b4e4$var$__PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $fd179abe7398b4e4$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $fd179abe7398b4e4$export$f765fc5789dfd439 || t instanceof $fd179abe7398b4e4$export$6bbc7aef0717f3d2)) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $fd179abe7398b4e4$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($fd179abe7398b4e4$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($fd179abe7398b4e4$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 10 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            default:
                throw $fd179abe7398b4e4$var$fail();
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $fd179abe7398b4e4$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    convertGeoPoint(e) {
        return new $fd179abe7398b4e4$export$f9f719d1b6419c4($fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.latitude), $fd179abe7398b4e4$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $fd179abe7398b4e4$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($fd179abe7398b4e4$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_normalizeTimestamp(e);
        return new $fd179abe7398b4e4$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $fd179abe7398b4e4$var$ResourcePath.fromString(e);
        $fd179abe7398b4e4$var$__PRIVATE_hardAssert($fd179abe7398b4e4$var$__PRIVATE_isValidResourceName(n));
        const r = new $fd179abe7398b4e4$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $fd179abe7398b4e4$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $fd179abe7398b4e4$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $fd179abe7398b4e4$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $fd179abe7398b4e4$var$__PRIVATE_LiteUserDataWriter extends $fd179abe7398b4e4$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $fd179abe7398b4e4$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $fd179abe7398b4e4$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function $fd179abe7398b4e4$export$8a63f25cc62965f1(e) {
    return new $fd179abe7398b4e4$export$fada2345be8928cf("sum", $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $fd179abe7398b4e4$export$cc6710ee5f037d57(e) {
    return new $fd179abe7398b4e4$export$fada2345be8928cf("avg", $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $fd179abe7398b4e4$export$85b9a36db797e02b() {
    return new $fd179abe7398b4e4$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $fd179abe7398b4e4$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $fd179abe7398b4e4$export$fada2345be8928cf && t instanceof $fd179abe7398b4e4$export$fada2345be8928cf && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $fd179abe7398b4e4$export$104f59389a332076(e, t) {
    return $fd179abe7398b4e4$export$49b1d0de6ba30f41(e.query, t.query) && (0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $fd179abe7398b4e4$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $fd179abe7398b4e4$export$acab0e6ef25eb301 extends $fd179abe7398b4e4$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $fd179abe7398b4e4$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($fd179abe7398b4e4$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $fd179abe7398b4e4$export$6d4d04e42af6b03c extends $fd179abe7398b4e4$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $fd179abe7398b4e4$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $fd179abe7398b4e4$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $fd179abe7398b4e4$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $fd179abe7398b4e4$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $fd179abe7398b4e4$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $fd179abe7398b4e4$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $fd179abe7398b4e4$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $fd179abe7398b4e4$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $fd179abe7398b4e4$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $fd179abe7398b4e4$var$fail();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $fd179abe7398b4e4$export$f243a5d948512846(e, t) {
    return e instanceof $fd179abe7398b4e4$export$acab0e6ef25eb301 && t instanceof $fd179abe7398b4e4$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $fd179abe7398b4e4$export$8f21149d8133945c && t instanceof $fd179abe7398b4e4$export$8f21149d8133945c && e._firestore === t._firestore && $fd179abe7398b4e4$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $fd179abe7398b4e4$export$11eb3b5ef9574821(e) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$6be62b059fb12175);
    const t = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82);
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($fd179abe7398b4e4$export$8da5fbea04405656(t), e._key).then((n)=>$fd179abe7398b4e4$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
class $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter extends $fd179abe7398b4e4$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $fd179abe7398b4e4$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $fd179abe7398b4e4$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $fd179abe7398b4e4$export$a58bd92642f7fb58(e) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$6be62b059fb12175);
    const t = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), n = $fd179abe7398b4e4$export$8da5fbea04405656(t), r = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(t);
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $fd179abe7398b4e4$export$acab0e6ef25eb301(t, r, e._key, n, new $fd179abe7398b4e4$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $fd179abe7398b4e4$export$35dd759aed9686b4(e) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$6be62b059fb12175);
    const t = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82);
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($fd179abe7398b4e4$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$fd179abe7398b4e4$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $fd179abe7398b4e4$export$81d3477bd73c86ef(e) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$62297b13309008b2);
    const t = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), n = $fd179abe7398b4e4$export$8da5fbea04405656(t), r = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(t);
    return $fd179abe7398b4e4$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $fd179abe7398b4e4$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $fd179abe7398b4e4$export$3fd010f18eac1dd(e) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$62297b13309008b2);
    const t = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), n = $fd179abe7398b4e4$export$8da5fbea04405656(t), r = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(t);
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $fd179abe7398b4e4$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $fd179abe7398b4e4$export$ec7d9e44f349c77b(e) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$62297b13309008b2);
    const t = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), n = $fd179abe7398b4e4$export$8da5fbea04405656(t), r = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(t);
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $fd179abe7398b4e4$export$8f21149d8133945c(t, r, e, n));
}
function $fd179abe7398b4e4$export$5ff77ddaff3c9e12(e, t, n) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$6be62b059fb12175);
    const r = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), i = $fd179abe7398b4e4$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $fd179abe7398b4e4$export$1945f8fec9dda613(r, [
        $fd179abe7398b4e4$var$__PRIVATE_parseSetData($fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $fd179abe7398b4e4$var$Precondition.none())
    ]);
}
function $fd179abe7398b4e4$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$6be62b059fb12175);
    const i = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), s = $fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(t)) || t instanceof $fd179abe7398b4e4$export$a1a8fea822d17659 ? $fd179abe7398b4e4$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $fd179abe7398b4e4$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $fd179abe7398b4e4$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $fd179abe7398b4e4$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $fd179abe7398b4e4$export$a4f20481fae8f78b(e) {
    return $fd179abe7398b4e4$export$1945f8fec9dda613($fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), [
        new $fd179abe7398b4e4$var$__PRIVATE_DeleteMutation(e._key, $fd179abe7398b4e4$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $fd179abe7398b4e4$export$a13890143fb1c2dd(e, t) {
    const n = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), r = $fd179abe7398b4e4$export$2a111da947c407d2(e), i = $fd179abe7398b4e4$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $fd179abe7398b4e4$export$1945f8fec9dda613(n, [
        $fd179abe7398b4e4$var$__PRIVATE_parseSetData($fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $fd179abe7398b4e4$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $fd179abe7398b4e4$export$d36370812fb26935(e, ...t) {
    var n, r, i;
    e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e);
    let s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || $fd179abe7398b4e4$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if ($fd179abe7398b4e4$var$__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof $fd179abe7398b4e4$export$6be62b059fb12175) u = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), c = $fd179abe7398b4e4$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: (n)=>{
            t[o] && t[o]($fd179abe7398b4e4$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        const n = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$62297b13309008b2);
        u = $fd179abe7398b4e4$export$572106fb5803752c(n.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), c = n._query;
        const r = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: (e)=>{
                t[o] && t[o](new $fd179abe7398b4e4$export$8f21149d8133945c(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $fd179abe7398b4e4$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $fd179abe7398b4e4$var$__PRIVATE_AsyncObserver(r), s = new $fd179abe7398b4e4$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$fd179abe7398b4e4$var$__PRIVATE_eventManagerListen(await $fd179abe7398b4e4$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.$a(), e.asyncQueue.enqueueAndForget(async ()=>$fd179abe7398b4e4$var$__PRIVATE_eventManagerUnlisten(await $fd179abe7398b4e4$var$__PRIVATE_getEventManager(e), s));
        };
    }($fd179abe7398b4e4$export$8da5fbea04405656(u), c, _, a);
}
function $fd179abe7398b4e4$export$9dff4f5aba83e348(e, t) {
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82)), $fd179abe7398b4e4$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $fd179abe7398b4e4$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$fd179abe7398b4e4$var$__PRIVATE_syncEngineWrite(await $fd179abe7398b4e4$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($fd179abe7398b4e4$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $fd179abe7398b4e4$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(e);
    return new $fd179abe7398b4e4$export$acab0e6ef25eb301(e, i, t._key, r, new $fd179abe7398b4e4$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $fd179abe7398b4e4$export$b1de1b12889d0afb(e) {
    return $fd179abe7398b4e4$export$a51511de2fae49b3(e, {
        count: $fd179abe7398b4e4$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $fd179abe7398b4e4$export$a51511de2fae49b3(e, t) {
    const n = $fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82), r = $fd179abe7398b4e4$export$8da5fbea04405656(n), i = $fd179abe7398b4e4$var$__PRIVATE_mapToArray(t, (e, t)=>new $fd179abe7398b4e4$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t)=>/**
 * Converts the core aggregration result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(e);
            return new $fd179abe7398b4e4$export$40257fef64be808b(t, r, n);
        })(n, e, t));
}
class $fd179abe7398b4e4$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = new $fd179abe7398b4e4$var$OnlineComponentProvider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = new $fd179abe7398b4e4$var$MemoryOfflineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $fd179abe7398b4e4$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_MemoryEagerGabageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = new $fd179abe7398b4e4$var$MemoryOfflineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_MemoryLruGabageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = new $fd179abe7398b4e4$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e);
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $fd179abe7398b4e4$export$574728f3be606189() {
    return new $fd179abe7398b4e4$var$__PRIVATE_MemoryEagerGabageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $fd179abe7398b4e4$export$2340f88905cc0c23(e) {
    return new $fd179abe7398b4e4$var$__PRIVATE_MemoryLruGabageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $fd179abe7398b4e4$export$72ef71adb739a32c(e) {
    return new $fd179abe7398b4e4$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $fd179abe7398b4e4$export$51b321e43d5331d5(e) {
    return new $fd179abe7398b4e4$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $fd179abe7398b4e4$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = new $fd179abe7398b4e4$var$OnlineComponentProvider, this._offlineComponentProvider = new $fd179abe7398b4e4$var$__PRIVATE_IndexedDbOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership);
    }
}
class $fd179abe7398b4e4$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = new $fd179abe7398b4e4$var$OnlineComponentProvider, this._offlineComponentProvider = new $fd179abe7398b4e4$var$__PRIVATE_MultiTabOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes);
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $fd179abe7398b4e4$export$d5f96a3c009e86ac(e) {
    return new $fd179abe7398b4e4$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $fd179abe7398b4e4$export$57e9d290b0b4dc04() {
    return new $fd179abe7398b4e4$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd179abe7398b4e4$var$De = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $fd179abe7398b4e4$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore), i = $fd179abe7398b4e4$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $fd179abe7398b4e4$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $fd179abe7398b4e4$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(t)) || t instanceof $fd179abe7398b4e4$export$a1a8fea822d17659 ? $fd179abe7398b4e4$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $fd179abe7398b4e4$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $fd179abe7398b4e4$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $fd179abe7398b4e4$var$__PRIVATE_DeleteMutation(t._key, $fd179abe7398b4e4$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(e)).firestore !== t) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $fd179abe7398b4e4$export$febc5573c75cefb0 extends class Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $fd179abe7398b4e4$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore), n = new $fd179abe7398b4e4$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $fd179abe7398b4e4$var$fail();
            const r = e[0];
            if (r.isFoundDocument()) return new $fd179abe7398b4e4$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $fd179abe7398b4e4$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $fd179abe7398b4e4$var$fail();
        });
    }
    set(e, t, n) {
        const r = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore), i = $fd179abe7398b4e4$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $fd179abe7398b4e4$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(t)) || t instanceof $fd179abe7398b4e4$export$a1a8fea822d17659 ? $fd179abe7398b4e4$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $fd179abe7398b4e4$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
} {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $fd179abe7398b4e4$var$__PRIVATE_validateReference(e, this._firestore), n = new $fd179abe7398b4e4$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $fd179abe7398b4e4$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $fd179abe7398b4e4$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $fd179abe7398b4e4$export$3c54e006bf9c93b7(e, t, n) {
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82);
    const r = Object.assign(Object.assign({}, $fd179abe7398b4e4$var$De), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $fd179abe7398b4e4$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $fd179abe7398b4e4$var$__PRIVATE_getDatastore(e);
            new $fd179abe7398b4e4$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Xa();
        }), r.promise;
    }($fd179abe7398b4e4$export$8da5fbea04405656(e), (n)=>t(new $fd179abe7398b4e4$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $fd179abe7398b4e4$export$2bbad96c62fdba3e() {
    return new $fd179abe7398b4e4$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $fd179abe7398b4e4$export$3ff8e7e00c3264b7() {
    return new $fd179abe7398b4e4$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $fd179abe7398b4e4$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $fd179abe7398b4e4$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $fd179abe7398b4e4$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $fd179abe7398b4e4$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $fd179abe7398b4e4$export$a2647aa13413c947(e) {
    return new $fd179abe7398b4e4$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $fd179abe7398b4e4$export$44cd1c9d57edd9b1(e) {
    return $fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82)), new $fd179abe7398b4e4$export$d94ed661b1cfd435(e, (t)=>$fd179abe7398b4e4$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fd179abe7398b4e4$export$ff1663c0c1304f1a(e, t) {
    var n;
    const r = $fd179abe7398b4e4$export$8da5fbea04405656(e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82));
    if (!r._uninitializedComponentsProvider || "memory" === (null === (n = r._uninitializedComponentsProvider) || void 0 === n ? void 0 : n._offlineKind)) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $fd179abe7398b4e4$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const i = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $fd179abe7398b4e4$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $fd179abe7398b4e4$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $fd179abe7398b4e4$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $fd179abe7398b4e4$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $fd179abe7398b4e4$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $fd179abe7398b4e4$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $fd179abe7398b4e4$var$FieldIndex($fd179abe7398b4e4$var$FieldIndex.UNKNOWN_ID, t, r, $fd179abe7398b4e4$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $fd179abe7398b4e4$var$__PRIVATE_firestoreClientSetIndexConfiguration(r, i);
}
function $fd179abe7398b4e4$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $fd179abe7398b4e4$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(e){
        this._client = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $fd179abe7398b4e4$export$61c6347b57bdfa06(e) {
    var t;
    e = $fd179abe7398b4e4$export$572106fb5803752c(e, $fd179abe7398b4e4$export$d0e2b3272814ce82);
    const n = $fd179abe7398b4e4$var$Ce.get(e);
    if (n) return n;
    const r = $fd179abe7398b4e4$export$8da5fbea04405656(e);
    if ("persistent" !== (null === (t = r._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offlineKind)) return null;
    const i = new $fd179abe7398b4e4$export$cf4db3c220e88bd8(r);
    return $fd179abe7398b4e4$var$Ce.set(e, i), i;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $fd179abe7398b4e4$export$9b2c0a7aacbcd151(e) {
    $fd179abe7398b4e4$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $fd179abe7398b4e4$export$5b460d5f48076743(e) {
    $fd179abe7398b4e4$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $fd179abe7398b4e4$export$72809fc2fc5083d5(e) {
    e._client.verifyNotTerminated();
    $fd179abe7398b4e4$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e._client).then((e)=>$fd179abe7398b4e4$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded")).catch((e)=>$fd179abe7398b4e4$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e));
}
function $fd179abe7398b4e4$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    e._client.verifyNotTerminated();
    $fd179abe7398b4e4$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e._client, t).then((e)=>$fd179abe7398b4e4$var$__PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`)).catch((e)=>$fd179abe7398b4e4$export$86cd73f49cc6e0bb(`setting persistent cache index auto creation isEnabled=${t} failed`, e));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $fd179abe7398b4e4$var$Ce = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fd179abe7398b4e4$export$b22c6725d8899bb4(e) {
    var t;
    const n = null === (t = $fd179abe7398b4e4$export$8da5fbea04405656($fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : $fd179abe7398b4e4$var$__PRIVATE_toQueryTarget(n, $fd179abe7398b4e4$var$__PRIVATE_queryToTarget(e._query))._t;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $fd179abe7398b4e4$export$5bcaa7c32a88925e(e, t) {
    var n;
    const r = $fd179abe7398b4e4$var$__PRIVATE_mapToArray(t, (e, t)=>new $fd179abe7398b4e4$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), i = null === (n = $fd179abe7398b4e4$export$8da5fbea04405656($fd179abe7398b4e4$export$572106fb5803752c(e.firestore, $fd179abe7398b4e4$export$d0e2b3272814ce82))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : $fd179abe7398b4e4$var$__PRIVATE_toRunAggregationQueryRequest(i, $fd179abe7398b4e4$var$__PRIVATE_queryToAggregateTarget(e._query), r, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $fd179abe7398b4e4$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(e) {
        return $fd179abe7398b4e4$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $fd179abe7398b4e4$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.Ou = new Map;
    }
    static get instance() {
        return $fd179abe7398b4e4$var$ve || ($fd179abe7398b4e4$var$ve = new $fd179abe7398b4e4$var$__PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if ($fd179abe7398b4e4$var$he) throw new Error("a TestingHooksSpi instance is already set");
            $fd179abe7398b4e4$var$he = e;
        }($fd179abe7398b4e4$var$ve)), $fd179abe7398b4e4$var$ve;
    }
    et(e) {
        this.Ou.forEach((t)=>t(e));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Ou;
        return n.set(t, e), ()=>n.delete(t);
    }
}
let $fd179abe7398b4e4$var$ve = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $fd179abe7398b4e4$var$b = e;
    }((0, $6de42d4eacc8610d$export$31499a9cd224b78c)), (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $fd179abe7398b4e4$export$d0e2b3272814ce82(new $fd179abe7398b4e4$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $fd179abe7398b4e4$var$__PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $fd179abe7398b4e4$export$8fada0bf726bf278($fd179abe7398b4e4$var$C.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $fd179abe7398b4e4$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($fd179abe7398b4e4$var$S, "4.6.2", e), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($fd179abe7398b4e4$var$S, "4.6.2", "esm2017");
}();





var $lldlC = parcelRequire("lldlC");
// firestore




const $bf4d77e47da3054e$export$731deabbf6f6c2d9 = (0, $fd179abe7398b4e4$export$f06a05d14c3a6678)((0, $f335ccce9ceac24d$export$a4e2c8f07e884e));
// emulator for local
if ((0, $22fc247a044a5f09$export$26cc430c2fed42ce).env == (0, $18313decae4d52e6$export$6c0517834721cef7).local) {
    console.log(`Connecting to local firestore emulator`);
    (0, $fd179abe7398b4e4$export$966a03d25297d115)($bf4d77e47da3054e$export$731deabbf6f6c2d9, "127.0.0.1", 8080);
}




var $lldlC = parcelRequire("lldlC");
var $9b8288c93dde0611$var$has = Object.prototype.hasOwnProperty;
function $9b8288c93dde0611$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($9b8288c93dde0611$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $9b8288c93dde0611$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $9b8288c93dde0611$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$9b8288c93dde0611$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($9b8288c93dde0611$var$has.call(foo, ctor) && ++len && !$9b8288c93dde0611$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$9b8288c93dde0611$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


const $9db34a41ea95235c$export$78fdc9adc3f30400 = (obj1, obj2)=>{
    return (0, $9b8288c93dde0611$export$de8294bb3be0322f)(obj1, obj2);
};


const $9820bd08d81ab8cb$export$853a255c1abddbf0 = (value)=>{
    const ref = (0, $lldlC.useRef)(value);
    if (!(0, $9db34a41ea95235c$export$78fdc9adc3f30400)(ref.current, value)) ref.current = value;
    return ref.current;
};


const $02a6a4d8defc9d58$export$280a58d17031e34d = (firestorePath, args)=>{
    //
    const { key: key, orderByDirection: orderByDirection, orderByField: orderByField, limit: limit = 100, where: where } = args;
    // Initial state is undefined, which should be the loading state
    const [list, setList] = (0, $lldlC.useState)(undefined);
    (0, $lldlC.useEffect)(()=>{
        //
        const path = firestorePath.path(key);
        // create query
        let query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)((0, $fd179abe7398b4e4$export$bf5175b0c24981cd)((0, $bf4d77e47da3054e$export$731deabbf6f6c2d9), path), (0, $fd179abe7398b4e4$export$f18af21d6f4dafd8)(orderByField, orderByDirection), (0, $fd179abe7398b4e4$export$ee37e834aaad6f7e)(limit));
        // where clause and the value is defined
        if (where) {
            if (where.length > 3) console.error(`Cannot have more than 3 items in where clause, please remodel the data to be more optimistic for querying.`);
            for (const w of where)if (w && (0, $46735892604b37f3$export$4e62c701997796c1)(w[2])) query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)(query, (0, $fd179abe7398b4e4$export$9c59b80dda569a6e)(w[0], w[1], w[2]));
        }
        return (0, $fd179abe7398b4e4$export$d36370812fb26935)(query, (snap)=>{
            console.debug(`[bindCollection] On snapshot listener:`, firestorePath, snap);
            if (snap.empty) {
                setList([]);
                return;
            }
            setList(snap.docs.map((e)=>e.data()));
        }, (error)=>{
            console.error(firestorePath, error);
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(error.message);
            setList([]);
        });
    }, [
        (0, $9820bd08d81ab8cb$export$853a255c1abddbf0)(key)
    ]);
    return {
        list: list
    };
};





var $lldlC = parcelRequire("lldlC");



const $bc439225f43f39b2$export$e2dfbe0a07a0db15 = (firestorePath, args)=>{
    //
    const { key: key, orderByDirection: orderByDirection, orderByField: orderByField, limit: limit = 100, where: where } = args;
    // Initial state is undefined, which should be the loading state
    const [value, setValue] = (0, $lldlC.useState)(undefined);
    (0, $lldlC.useEffect)(()=>{
        //
        const path = firestorePath.path(key);
        // create query
        let query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)((0, $fd179abe7398b4e4$export$473d82a73f88c107)((0, $bf4d77e47da3054e$export$731deabbf6f6c2d9), path), (0, $fd179abe7398b4e4$export$f18af21d6f4dafd8)(orderByField, orderByDirection), (0, $fd179abe7398b4e4$export$ee37e834aaad6f7e)(limit));
        // where clause and the value is defined
        if (where) {
            if (where.length > 3) console.error(`Cannot have more than 3 items in where clause, please remodel the data to be more optimistic for querying.`);
            for (const w of where)if (w && (0, $46735892604b37f3$export$4e62c701997796c1)(w[2])) query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)(query, (0, $fd179abe7398b4e4$export$9c59b80dda569a6e)(w[0], w[1], w[2]));
        }
        return (0, $fd179abe7398b4e4$export$d36370812fb26935)(query, (snap)=>{
            console.debug(`[bindCollectionGroup] On snapshot listener:`, firestorePath, snap);
            if (snap.empty) {
                setValue([]);
                return;
            }
            setValue(snap.docs.map((e)=>e.data()));
        }, (error)=>{
            console.error(firestorePath, error);
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(error.message);
            setValue([]);
        });
    }, [
        (0, $9820bd08d81ab8cb$export$853a255c1abddbf0)(key)
    ]);
    return {
        value: value
    };
};




var $lldlC = parcelRequire("lldlC");


const $f0b8f7209ae2acbe$export$e06cf5308dd6fa13 = (documentRepo, key)=>{
    // * For bind use 3 states. undefined - loading, null - value not found, T - value loaded
    const [value, setValue] = (0, $lldlC.useState)(undefined);
    (0, $lldlC.useEffect)(()=>{
        //
        // if (!key) {
        //   setValue(undefined);
        //   return;
        // }
        const disposer = (0, $fd179abe7398b4e4$export$d36370812fb26935)(documentRepo.ref(key), (snap)=>{
            console.debug(`[bind] On snapshot listener:`, documentRepo.path(key), snap);
            if (snap.exists()) {
                setValue(snap.data());
                return;
            }
            setValue(null);
            return;
        }, (error)=>{
            console.error(`${documentRepo.path(key)}`, error);
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(error.message);
            setValue(null);
        });
        return ()=>{
            console.log(`Unsubscribing `, key);
            disposer();
        };
    }, (0, $9820bd08d81ab8cb$export$853a255c1abddbf0)([
        key
    ]));
    return {
        value: value
    };
};



var $lldlC = parcelRequire("lldlC");


const $0a52374de87e2ad4$export$3e95660fed426abb = (documentRepo, key)=>{
    //
    const [value, setValue] = (0, $lldlC.useState)(null);
    const refreshFn = ()=>{
        setValue(undefined);
        documentRepo.get(key).then((doc)=>{
            if (doc) {
                setValue(doc);
                return;
            }
            setValue(null);
        }).catch((e)=>{
            console.error(e);
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(`Error loading document at path ${documentRepo.path(key)}`);
        });
    };
    (0, $lldlC.useEffect)(()=>{
        refreshFn();
    }, (0, $9820bd08d81ab8cb$export$853a255c1abddbf0)([
        key
    ]));
    return {
        value: value,
        refreshFn: refreshFn
    };
};


function $2f2ccd0c808f0025$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $2f2ccd0c808f0025$var$$471139f8c8b1a8bd$exports = {};
$2f2ccd0c808f0025$var$$parcel$export($2f2ccd0c808f0025$var$$471139f8c8b1a8bd$exports, "_validate", ()=>$2f2ccd0c808f0025$export$721aae4e3ead4833);
$2f2ccd0c808f0025$var$$parcel$export($2f2ccd0c808f0025$var$$471139f8c8b1a8bd$exports, "validate", ()=>$2f2ccd0c808f0025$export$a22775fa5e2eebd9);
// utility to check a type
const $2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27 = (o)=>{
    if (o === undefined || o === null) return true;
    return false;
};
const $2f2ccd0c808f0025$var$$f904ecf4db314323$export$844ec244b1367d54 = (o)=>{
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(o)) return false;
    if (typeof o === "string") return true;
    return false;
};
const $2f2ccd0c808f0025$var$$f904ecf4db314323$export$7e4aa119212bc614 = (o)=>{
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(o)) return false;
    if (typeof o === "number") return true;
    return false;
};
const $2f2ccd0c808f0025$var$$f904ecf4db314323$export$871608497c498473 = (o)=>{
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(o)) return false;
    if (o instanceof Date) return true;
    return false;
};
const $2f2ccd0c808f0025$var$$f904ecf4db314323$export$f9ce7b637dfbe238 = (o)=>{
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(o)) return false;
    if (typeof o === "boolean") return true;
    return false;
};
const $2f2ccd0c808f0025$var$$f904ecf4db314323$export$43bee75e5e14138e = (o)=>{
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(o)) return false;
    if (o instanceof Array) return true;
    return false;
};
const $2f2ccd0c808f0025$var$$f904ecf4db314323$export$a6cdc56e425d0d0a = (o)=>{
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(o)) return false;
    if (o instanceof Object) return true;
    return false;
};
const $2f2ccd0c808f0025$var$$2f69080fafedeee7$var$INVALID = {
    isValid: false,
    errorMessage: `Required field.`,
    errorPath: []
};
const $2f2ccd0c808f0025$var$$2f69080fafedeee7$var$VALID = {
    isValid: true,
    errorMessage: ``,
    errorPath: []
};
const $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$1008c55ea88d7e92 = (args)=>{
    const optional = $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$a90a1c93d243c982(args);
    if (optional) return $2f2ccd0c808f0025$var$$2f69080fafedeee7$var$VALID;
    return $2f2ccd0c808f0025$var$$2f69080fafedeee7$var$INVALID;
};
const $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$a90a1c93d243c982 = (args)=>{
    // flag not set, so the field is not optional
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(args.flag)) return false;
    // flag is boolean, return flag
    if (typeof args.flag === "boolean") return args.flag;
    // flag is a function
    const value = args.flag(args);
    return value;
};
const $2f2ccd0c808f0025$var$$c82a7a8e1d2611ac$export$3eaae55c97984591 = (args)=>{
    const { value: arr, schema: schema } = args;
    // isnil
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(arr)) return {
        ...$2f2ccd0c808f0025$var$$2f69080fafedeee7$export$1008c55ea88d7e92({
            ...args,
            flag: schema.optional
        }),
        items: []
    };
    const result = {
        isValid: true,
        errorMessage: "",
        items: [],
        errorPath: []
    };
    // array min-items
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.minItems) && arr.length < schema.minItems) {
        result.isValid = false;
        result.errorMessage = `Should have at least ${schema.minItems} items.`;
    }
    // array max-items
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.maxItems) && arr.length >= schema.maxItems) {
        result.isValid = false;
        result.errorMessage = `Should not have more than ${schema.maxItems - 1} items.`;
    }
    // for each key, validate
    for(let i = 0; i < arr.length; i++)result.items[i] = $2f2ccd0c808f0025$export$721aae4e3ead4833({
        ...args,
        value: arr[i],
        parent: arr,
        schema: schema.items
    });
    // if this node is valid, then check if all of it's children are valid
    // because the node is invalid, if any of it's children are invalid
    if (result.isValid) for(let i = 0; i < arr.length; i++){
        const item = result.items[i];
        if (!item.isValid) {
            result.isValid = false;
            result.errorMessage = item.errorMessage;
            result.errorPath = [
                i,
                ...item.errorPath
            ];
            break;
        }
    }
    return result;
};
const $2f2ccd0c808f0025$var$$cdccad482c0d89f2$export$44043e5a354adaaa = (args)=>{
    try {
        const result = args.validationFn(args);
        if (result) return {
            ...result,
            isValid: false,
            errorPath: []
        };
    } catch (e) {
        // if (Object.keys(e as any).includes("message")) {
        if (e instanceof Error) return {
            errorMessage: e.message,
            isValid: false,
            errorPath: []
        };
        if (Object.keys(e).includes("message")) return {
            errorMessage: e.message,
            isValid: false,
            errorPath: []
        };
        console.error(`Exception executing executor function`, e);
        return {
            errorMessage: `Exception in validationFn`,
            isValid: false,
            errorPath: []
        };
    }
};
const $2f2ccd0c808f0025$var$$b52c95b93976d81b$export$c7ba574ea9352342 = (args)=>{
    const { value: value, schema: schema } = args;
    // isnil
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(value)) return $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$1008c55ea88d7e92({
        ...args,
        flag: schema.optional
    });
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$f9ce7b637dfbe238(value)) return {
        isValid: false,
        errorMessage: `Should be true or false.`,
        errorPath: []
    };
    // validationFn
    if (schema.validationFn) {
        const result = $2f2ccd0c808f0025$var$$cdccad482c0d89f2$export$44043e5a354adaaa({
            ...args,
            value: value,
            validationFn: schema.validationFn
        });
        if (result) return result;
    }
    return {
        isValid: true,
        errorMessage: ``,
        errorPath: []
    };
};
const $2f2ccd0c808f0025$var$$fb3a3f51c1604062$export$ffb3d0046ef3a2 = (args)=>{
    const { value: value, schema: schema } = args;
    // isnil
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(value)) return $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$1008c55ea88d7e92({
        ...args,
        flag: schema.optional
    });
    // is date object
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$871608497c498473(value)) return {
        isValid: false,
        errorMessage: `Should be a valid date.`,
        errorPath: []
    };
    const date = value;
    // custom validationFn
    if (schema.validationFn) {
        const result = $2f2ccd0c808f0025$var$$cdccad482c0d89f2$export$44043e5a354adaaa({
            ...args,
            value: date,
            validationFn: schema.validationFn
        });
        if (result) return result;
    }
    return {
        isValid: true,
        errorMessage: ``,
        errorPath: []
    };
};
const $2f2ccd0c808f0025$var$$149f59cadd33b6b4$export$b3d198e17b370bec = (args)=>{
    //
    const { value: value, schema: schema } = args;
    // isnil
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(value)) return $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$1008c55ea88d7e92({
        ...args,
        flag: schema.optional
    });
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$7e4aa119212bc614(value) || isNaN(value)) return {
        isValid: false,
        errorMessage: `Should be a number.`,
        errorPath: []
    };
    const numbr = value;
    // min length
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.min) && numbr < schema.min) return {
        isValid: false,
        errorMessage: `Should not be less than ${schema.min}.`,
        errorPath: []
    };
    // max length
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.max) && numbr > schema.max) return {
        isValid: false,
        errorMessage: `Should not be larger than ${schema.max}.`,
        errorPath: []
    };
    // pattern
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.pattern)) {
        const match = schema.pattern.test(value);
        if (!match) return {
            isValid: false,
            errorMessage: `Should match the pattern ${schema.pattern} .`,
            errorPath: []
        };
    }
    // validationFn
    if (schema.validationFn) {
        const result = $2f2ccd0c808f0025$var$$cdccad482c0d89f2$export$44043e5a354adaaa({
            ...args,
            value: numbr,
            validationFn: schema.validationFn
        });
        if (result) return result;
    }
    return {
        isValid: true,
        errorMessage: ``,
        errorPath: []
    };
};
const $2f2ccd0c808f0025$var$$3b26661ca7f0f185$export$2569c41dd933e9ea = (str)=>{
    return str.startsWith("/") && str.endsWith("/");
};
const $2f2ccd0c808f0025$var$$3b26661ca7f0f185$export$cb3dda8bd682fefc = (str)=>{
    return new RegExp(`^${str.slice(1, -1)}$`);
};
const $2f2ccd0c808f0025$var$$3b26661ca7f0f185$export$381bae2d0f08004f = (args)=>{
    //
    const { value: value, schema: schema } = args;
    const result = {
        isValid: true,
        errorMessage: "",
        properties: {},
        errorPath: []
    };
    // isnil
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(value)) return {
        ...$2f2ccd0c808f0025$var$$2f69080fafedeee7$export$1008c55ea88d7e92({
            ...args,
            flag: schema.optional
        }),
        properties: {}
    };
    const obj = value;
    const processedFields = [];
    // for each static key, validate
    for(let field in schema.properties){
        if ($2f2ccd0c808f0025$var$$3b26661ca7f0f185$export$2569c41dd933e9ea(field)) continue;
        result.properties[field] = $2f2ccd0c808f0025$export$721aae4e3ead4833({
            ...args,
            value: value ? value[field] : null,
            parent: value,
            schema: schema.properties[field]
        });
        processedFields.push(field);
    }
    // for each regex validate all matching keys
    for(let field in schema.properties){
        if (!$2f2ccd0c808f0025$var$$3b26661ca7f0f185$export$2569c41dd933e9ea(field)) continue; // not-regex
        const regex = $2f2ccd0c808f0025$var$$3b26661ca7f0f185$export$cb3dda8bd682fefc(field);
        // for each key
        for(let key in obj){
            /**
       * Already processed field. This will happen if the regex matches a wide range of fields, like ".*"
       * and the properties also defines specific fields like "red": {}, "blue": {} etc ...
       */ if (processedFields.includes(key)) continue;
            if (!regex.test(key)) continue;
            result.properties[key] = $2f2ccd0c808f0025$export$721aae4e3ead4833({
                ...args,
                value: value ? value[key] : null,
                parent: value,
                schema: schema.properties[field]
            });
            processedFields.push(key);
        }
    }
    // if this node is valid, then check if all of it's children are valid
    // because the node is invalid, if any of it's children are invalid
    if (result.isValid) for (let field of processedFields){
        const property = result.properties[field];
        if (!property.isValid) {
            result.isValid = false;
            result.errorMessage = property.errorMessage;
            result.errorPath = [
                field,
                ...property.errorPath
            ];
            break;
        }
    }
    // validationFn
    // validationFn will be called only if the object is valid at this stage
    if (result.isValid && schema.validationFn) {
        const validationFnResult = $2f2ccd0c808f0025$var$$cdccad482c0d89f2$export$44043e5a354adaaa({
            ...args,
            value: value,
            validationFn: schema.validationFn
        });
        if (validationFnResult) {
            result.isValid = false;
            result.errorMessage = validationFnResult.errorMessage;
            // TODO test this error path
            result.errorPath = [];
        }
    }
    return result;
};
const $2f2ccd0c808f0025$var$$7a303d7bc883789c$export$d7b0a588f685ba7e = (args)=>{
    const { value: value, schema: schema } = args;
    //
    // isnil
    if ($2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(value)) return $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$1008c55ea88d7e92({
        ...args,
        flag: schema.optional
    });
    // check if type is string
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$844ec244b1367d54(value)) return {
        isValid: false,
        errorMessage: `Should be a string.`,
        errorPath: []
    };
    const str = value;
    // check if empty
    if (str === "") {
        const optional = $2f2ccd0c808f0025$var$$2f69080fafedeee7$export$a90a1c93d243c982({
            ...args,
            flag: schema.optional
        });
        if (!optional) return {
            isValid: false,
            errorMessage: `Should not be empty.`,
            errorPath: []
        };
    }
    // min length
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.minLength) && str.length < schema.minLength) return {
        isValid: false,
        errorMessage: `Should be at least ${schema.minLength} characters.`,
        errorPath: []
    };
    // max length
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.maxLength) && str.length > schema.maxLength) return {
        isValid: false,
        errorMessage: `Should not be longer than ${schema.maxLength} characters.`,
        errorPath: []
    };
    // pattern
    if (!$2f2ccd0c808f0025$var$$f904ecf4db314323$export$984f70f9382f5d27(schema.pattern)) {
        const match = schema.pattern.test(value);
        if (!match) return {
            isValid: false,
            errorMessage: `Should match the pattern ${schema.pattern} .`,
            errorPath: []
        };
    }
    // validationFn
    if (schema.validationFn) {
        const result = $2f2ccd0c808f0025$var$$cdccad482c0d89f2$export$44043e5a354adaaa({
            ...args,
            value: str,
            validationFn: schema.validationFn
        });
        if (result) return result;
    }
    return {
        isValid: true,
        errorMessage: ``,
        errorPath: []
    };
};
const $2f2ccd0c808f0025$export$721aae4e3ead4833 = (args)=>{
    //
    if (!args.schema) throw new Error("Schema should not be null");
    /**
   * validate object against the schema
   */ switch(args.schema.type){
        case "number":
            return $2f2ccd0c808f0025$var$$149f59cadd33b6b4$export$b3d198e17b370bec({
                ...args,
                schema: args.schema
            });
        case "string":
            return $2f2ccd0c808f0025$var$$7a303d7bc883789c$export$d7b0a588f685ba7e({
                ...args,
                schema: args.schema
            });
        case "boolean":
            return $2f2ccd0c808f0025$var$$b52c95b93976d81b$export$c7ba574ea9352342({
                ...args,
                schema: args.schema
            });
        case "array":
            // TODO array schema type remove any
            return $2f2ccd0c808f0025$var$$c82a7a8e1d2611ac$export$3eaae55c97984591({
                ...args,
                value: args.value,
                schema: args.schema
            });
        case "object":
            return $2f2ccd0c808f0025$var$$3b26661ca7f0f185$export$381bae2d0f08004f({
                ...args,
                schema: args.schema
            });
        case "date":
            return $2f2ccd0c808f0025$var$$fb3a3f51c1604062$export$ffb3d0046ef3a2({
                ...args,
                schema: args.schema
            });
    }
    throw new Error(`Unhandled data type`);
};
const $2f2ccd0c808f0025$export$a22775fa5e2eebd9 = (value, schema)=>{
    return $2f2ccd0c808f0025$export$721aae4e3ead4833({
        value: value,
        root: value,
        parent: null,
        schema: schema
    });
}; // const api = <T, R = T>(args: { value: T; schema: Schema<T, R> }) => {
//   return val({
//     ...args,
//     root: args.value as unknown as R,
//     parent: null,
//   });
// };
// const val = <T, P, R>(args: { value: T; parent: P; root: R; schema: Schema<T, R> }) => {
//   if (!args.schema) {
//     throw new Error("Schema should not be null");
//   }
//   switch (args.schema.type) {
//     case "number":
//       return validateNumber({ ...args, schema: args.schema as NumberSchema<R> }) as Result<T>;
//     default:
//       throw new Error(`Unhandled data type`);
//     //   case "string":
//     //     return validateString({ ...args, schema: args.schema as StringSchema<R> }) as Result<T>;
//     //   case "boolean":
//     //     return validateBoolean({ ...args, schema: args.schema as BooleanSchema<R> }) as Result<T>;
//     //   case "array":
//     //     return validateArray({ value: args.value as any, parent: args.parent, schema: args.schema as any }) as Result<T>;
//     //   case "object":
//     //     return validateObject({ ...args, schema: args.schema }) as Result<T>;
//     //   case "date":
//     //     return validateDate({ ...args, schema: args.schema as DateSchema<R> }) as Result<T>;
//     // }
//     // throw new Error(`Unhandled data type`);
//   }
// };
var $2f2ccd0c808f0025$var$$678320e3ff843929$exports = {};
var $2f2ccd0c808f0025$var$$4e67428d2d3d3880$exports = {};
var $2f2ccd0c808f0025$var$$b5582ce25602f3a1$exports = {};



var $lldlC = parcelRequire("lldlC");
const $357e45f6f4caf5e7$export$87fe492f99f25a20 = (value, schema)=>{
    console.log((0, $2f2ccd0c808f0025$export$a22775fa5e2eebd9)(value, schema));
    const [validation, setValidation] = (0, $lldlC.useState)((0, $2f2ccd0c808f0025$export$a22775fa5e2eebd9)(value, schema));
    (0, $lldlC.useEffect)(()=>{
        setValidation((0, $2f2ccd0c808f0025$export$a22775fa5e2eebd9)(value, schema));
    }, [
        value
    ]);
    return validation;
};





/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $416ae6f5d6e0c08b$var$LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
const $416ae6f5d6e0c08b$var$UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
function $416ae6f5d6e0c08b$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    const result = {};
    for(const key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */ function $416ae6f5d6e0c08b$var$encode(data) {
    if (data == null) return null;
    if (data instanceof Number) data = data.valueOf();
    if (typeof data === 'number' && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
    if (data === true || data === false) return data;
    if (Object.prototype.toString.call(data) === '[object String]') return data;
    if (data instanceof Date) return data.toISOString();
    if (Array.isArray(data)) return data.map((x)=>$416ae6f5d6e0c08b$var$encode(x));
    if (typeof data === 'function' || typeof data === 'object') return $416ae6f5d6e0c08b$var$mapValues(data, (x)=>$416ae6f5d6e0c08b$var$encode(x));
    // If we got this far, the data is not encodable.
    throw new Error('Data cannot be encoded in JSON: ' + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */ function $416ae6f5d6e0c08b$var$decode(json) {
    if (json == null) return json;
    if (json['@type']) switch(json['@type']){
        case $416ae6f5d6e0c08b$var$LONG_TYPE:
        // Fall through and handle this the same as unsigned.
        case $416ae6f5d6e0c08b$var$UNSIGNED_LONG_TYPE:
            {
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                const value = Number(json['value']);
                if (isNaN(value)) throw new Error('Data cannot be decoded from JSON: ' + json);
                return value;
            }
        default:
            throw new Error('Data cannot be decoded from JSON: ' + json);
    }
    if (Array.isArray(json)) return json.map((x)=>$416ae6f5d6e0c08b$var$decode(x));
    if (typeof json === 'function' || typeof json === 'object') return $416ae6f5d6e0c08b$var$mapValues(json, (x)=>$416ae6f5d6e0c08b$var$decode(x));
    // Anything else is safe to return.
    return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ const $416ae6f5d6e0c08b$var$FUNCTIONS_TYPE = 'functions';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ const $416ae6f5d6e0c08b$var$errorCodeMap = {
    OK: 'ok',
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    UNAUTHENTICATED: 'unauthenticated',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss'
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */ class $416ae6f5d6e0c08b$var$FunctionsError extends (0, $59fdd18afb377ad5$export$dd24e9cd51226c56) {
    constructor(/**
     * A standard error code that will be returned to the client. This also
     * determines the HTTP status code of the response, as defined in code.proto.
     */ code, message, /**
     * Extra data to be converted to JSON and included in the error response.
     */ details){
        super(`${$416ae6f5d6e0c08b$var$FUNCTIONS_TYPE}/${code}`, message || '');
        this.details = details;
    }
}
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $416ae6f5d6e0c08b$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return 'ok';
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return 'internal';
        case 400:
            return 'invalid-argument';
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission-denied';
        case 404:
            return 'not-found';
        case 409:
            return 'aborted';
        case 429:
            return 'resource-exhausted';
        case 499:
            return 'cancelled';
        case 500:
            return 'internal';
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline-exceeded';
    }
    return 'unknown';
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $416ae6f5d6e0c08b$var$_errorForResponse(status, bodyJSON) {
    let code = $416ae6f5d6e0c08b$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    let description = code;
    let details = undefined;
    // Then look through the body for explicit details.
    try {
        const errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            const status = errorJSON.status;
            if (typeof status === 'string') {
                if (!$416ae6f5d6e0c08b$var$errorCodeMap[status]) // They must've included an unknown error code in the body.
                return new $416ae6f5d6e0c08b$var$FunctionsError('internal', 'internal');
                code = $416ae6f5d6e0c08b$var$errorCodeMap[status];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status;
            }
            const message = errorJSON.message;
            if (typeof message === 'string') description = message;
            details = errorJSON.details;
            if (details !== undefined) details = $416ae6f5d6e0c08b$var$decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === 'ok') // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $416ae6f5d6e0c08b$var$FunctionsError(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */ class $416ae6f5d6e0c08b$var$ContextProvider {
    constructor(authProvider, messagingProvider, appCheckProvider){
        this.auth = null;
        this.messaging = null;
        this.appCheck = null;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then((auth)=>this.auth = auth, ()=>{
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then((messaging)=>this.messaging = messaging, ()=>{
        /* get() never rejects */ });
        if (!this.appCheck) appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck, ()=>{
        /* get() never rejects */ });
    }
    async getAuthToken() {
        if (!this.auth) return undefined;
        try {
            const token = await this.auth.getToken();
            return token === null || token === void 0 ? void 0 : token.accessToken;
        } catch (e) {
            // If there's any error when trying to get the auth token, leave it off.
            return undefined;
        }
    }
    async getMessagingToken() {
        if (!this.messaging || !('Notification' in self) || Notification.permission !== 'granted') return undefined;
        try {
            return await this.messaging.getToken();
        } catch (e) {
            // We don't warn on this, because it usually means messaging isn't set up.
            // console.warn('Failed to retrieve instance id token.', e);
            // If there's any error when trying to get the token, leave it off.
            return undefined;
        }
    }
    async getAppCheckToken(limitedUseAppCheckTokens) {
        if (this.appCheck) {
            const result = limitedUseAppCheckTokens ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
            if (result.error) // Do not send the App Check header to the functions endpoint if
            // there was an error from the App Check exchange endpoint. The App
            // Check SDK will already have logged the error to console.
            return null;
            return result.token;
        }
        return null;
    }
    async getContext(limitedUseAppCheckTokens) {
        const authToken = await this.getAuthToken();
        const messagingToken = await this.getMessagingToken();
        const appCheckToken = await this.getAppCheckToken(limitedUseAppCheckTokens);
        return {
            authToken: authToken,
            messagingToken: messagingToken,
            appCheckToken: appCheckToken
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $416ae6f5d6e0c08b$var$DEFAULT_REGION = 'us-central1';
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $416ae6f5d6e0c08b$var$failAfter(millis) {
    // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer = null;
    return {
        promise: new Promise((_, reject)=>{
            timer = setTimeout(()=>{
                reject(new $416ae6f5d6e0c08b$var$FunctionsError('deadline-exceeded', 'deadline-exceeded'));
            }, millis);
        }),
        cancel: ()=>{
            if (timer) clearTimeout(timer);
        }
    };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */ class $416ae6f5d6e0c08b$var$FunctionsService {
    /**
     * Creates a new Functions service for the given app.
     * @param app - The FirebaseApp to use.
     */ constructor(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain = $416ae6f5d6e0c08b$var$DEFAULT_REGION, fetchImpl){
        this.app = app;
        this.fetchImpl = fetchImpl;
        this.emulatorOrigin = null;
        this.contextProvider = new $416ae6f5d6e0c08b$var$ContextProvider(authProvider, messagingProvider, appCheckProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise((resolve)=>{
            this.deleteService = ()=>{
                return Promise.resolve(resolve());
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            const url = new URL(regionOrCustomDomain);
            this.customDomain = url.origin;
            this.region = $416ae6f5d6e0c08b$var$DEFAULT_REGION;
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain;
        }
    }
    _delete() {
        return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */ _url(name) {
        const projectId = this.app.options.projectId;
        if (this.emulatorOrigin !== null) {
            const origin = this.emulatorOrigin;
            return `${origin}/${projectId}/${this.region}/${name}`;
        }
        if (this.customDomain !== null) return `${this.customDomain}/${name}`;
        return `https://${this.region}-${projectId}.cloudfunctions.net/${name}`;
    }
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */ function $416ae6f5d6e0c08b$var$connectFunctionsEmulator$1(functionsInstance, host, port) {
    functionsInstance.emulatorOrigin = `http://${host}:${port}`;
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $416ae6f5d6e0c08b$var$httpsCallable$1(functionsInstance, name, options) {
    return (data)=>{
        return $416ae6f5d6e0c08b$var$call(functionsInstance, name, data, options || {});
    };
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */ function $416ae6f5d6e0c08b$var$httpsCallableFromURL$1(functionsInstance, url, options) {
    return (data)=>{
        return $416ae6f5d6e0c08b$var$callAtURL(functionsInstance, url, data, options || {});
    };
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @return A Promise that will succeed when the request finishes.
 */ async function $416ae6f5d6e0c08b$var$postJSON(url, body, headers, fetchImpl) {
    headers['Content-Type'] = 'application/json';
    let response;
    try {
        response = await fetchImpl(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: headers
        });
    } catch (e) {
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        return {
            status: 0,
            json: null
        };
    }
    let json = null;
    try {
        json = await response.json();
    } catch (e) {
    // If we fail to parse JSON, it will fail the same as an empty body.
    }
    return {
        status: response.status,
        json: json
    };
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ function $416ae6f5d6e0c08b$var$call(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $416ae6f5d6e0c08b$var$callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ async function $416ae6f5d6e0c08b$var$callAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $416ae6f5d6e0c08b$var$encode(data);
    const body = {
        data: data
    };
    // Add a header for the authToken.
    const headers = {};
    const context = await functionsInstance.contextProvider.getContext(options.limitedUseAppCheckTokens);
    if (context.authToken) headers['Authorization'] = 'Bearer ' + context.authToken;
    if (context.messagingToken) headers['Firebase-Instance-ID-Token'] = context.messagingToken;
    if (context.appCheckToken !== null) headers['X-Firebase-AppCheck'] = context.appCheckToken;
    // Default timeout to 70s, but let the options override it.
    const timeout = options.timeout || 70000;
    const failAfterHandle = $416ae6f5d6e0c08b$var$failAfter(timeout);
    const response = await Promise.race([
        $416ae6f5d6e0c08b$var$postJSON(url, body, headers, functionsInstance.fetchImpl),
        failAfterHandle.promise,
        functionsInstance.cancelAllRequests
    ]);
    // Always clear the failAfter timeout
    failAfterHandle.cancel();
    // If service was deleted, interrupted response throws an error.
    if (!response) throw new $416ae6f5d6e0c08b$var$FunctionsError('cancelled', 'Firebase Functions instance was deleted.');
    // Check for an error status, regardless of http status.
    const error = $416ae6f5d6e0c08b$var$_errorForResponse(response.status, response.json);
    if (error) throw error;
    if (!response.json) throw new $416ae6f5d6e0c08b$var$FunctionsError('internal', 'Response is not valid JSON object.');
    let responseData = response.json.data;
    // TODO(klimt): For right now, allow "result" instead of "data", for
    // backwards compatibility.
    if (typeof responseData === 'undefined') responseData = response.json.result;
    if (typeof responseData === 'undefined') // Consider the response malformed.
    throw new $416ae6f5d6e0c08b$var$FunctionsError('internal', 'Response is missing data field.');
    // Decode any special types, such as dates, in the returned data.
    const decodedData = $416ae6f5d6e0c08b$var$decode(responseData);
    return {
        data: decodedData
    };
}
const $416ae6f5d6e0c08b$var$name = "@firebase/functions";
const $416ae6f5d6e0c08b$var$version = "0.11.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $416ae6f5d6e0c08b$var$AUTH_INTERNAL_NAME = 'auth-internal';
const $416ae6f5d6e0c08b$var$APP_CHECK_INTERNAL_NAME = 'app-check-internal';
const $416ae6f5d6e0c08b$var$MESSAGING_INTERNAL_NAME = 'messaging-internal';
function $416ae6f5d6e0c08b$var$registerFunctions(fetchImpl, variant) {
    const factory = (container, { instanceIdentifier: regionOrCustomDomain })=>{
        // Dependencies
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider($416ae6f5d6e0c08b$var$AUTH_INTERNAL_NAME);
        const messagingProvider = container.getProvider($416ae6f5d6e0c08b$var$MESSAGING_INTERNAL_NAME);
        const appCheckProvider = container.getProvider($416ae6f5d6e0c08b$var$APP_CHECK_INTERNAL_NAME);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $416ae6f5d6e0c08b$var$FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain, fetchImpl);
    };
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)($416ae6f5d6e0c08b$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($416ae6f5d6e0c08b$var$name, $416ae6f5d6e0c08b$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($416ae6f5d6e0c08b$var$name, $416ae6f5d6e0c08b$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */ function $416ae6f5d6e0c08b$export$7d4c14593b8a2193(app = (0, $6de42d4eacc8610d$export$f9962582c9e66d99)(), regionOrCustomDomain = $416ae6f5d6e0c08b$var$DEFAULT_REGION) {
    // Dependencies
    const functionsProvider = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(app), $416ae6f5d6e0c08b$var$FUNCTIONS_TYPE);
    const functionsInstance = functionsProvider.getImmediate({
        identifier: regionOrCustomDomain
    });
    const emulator = (0, $59fdd18afb377ad5$export$a3febcf1f14a3a0c)('functions');
    if (emulator) $416ae6f5d6e0c08b$export$472343ee9d485d97(functionsInstance, ...emulator);
    return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */ function $416ae6f5d6e0c08b$export$472343ee9d485d97(functionsInstance, host, port) {
    $416ae6f5d6e0c08b$var$connectFunctionsEmulator$1((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $416ae6f5d6e0c08b$export$438b58c7f2c6bf5e(functionsInstance, name, options) {
    return $416ae6f5d6e0c08b$var$httpsCallable$1((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */ function $416ae6f5d6e0c08b$export$486b60b301a0b194(functionsInstance, url, options) {
    return $416ae6f5d6e0c08b$var$httpsCallableFromURL$1((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */ $416ae6f5d6e0c08b$var$registerFunctions(fetch.bind(self));




// firestore




const $9bfe549b082495a6$export$25b8ec5fafc4c761 = (0, $416ae6f5d6e0c08b$export$7d4c14593b8a2193)((0, $f335ccce9ceac24d$export$a4e2c8f07e884e));
// emulator for local
if ((0, $22fc247a044a5f09$export$26cc430c2fed42ce).env == (0, $18313decae4d52e6$export$6c0517834721cef7).local) {
    console.log(`Connecting to local firestore emulator`);
    (0, $416ae6f5d6e0c08b$export$472343ee9d485d97)($9bfe549b082495a6$export$25b8ec5fafc4c761, "127.0.0.1", 5001);
}


const $ead54b3c845eba59$var$wrapper = (fnName)=>{
    const fn = (0, $416ae6f5d6e0c08b$export$438b58c7f2c6bf5e)((0, $9bfe549b082495a6$export$25b8ec5fafc4c761), fnName);
    console.log(`Creating callable function: ${fnName}`);
    return async (request)=>{
        console.log(`callable request: ${JSON.stringify(request, null, 2)}`);
        // // Option 2: Log the object directly without string conversion
        // console.log("callable request:", request);
        // // Option 3: Use console.dir for more detailed object inspection
        // console.dir(request, { depth: null });
        const response = await fn(request);
        console.log(`callable response: ${JSON.stringify(response, null, 2)}`);
        return response.data;
    };
};
const $ead54b3c845eba59$var$createOrg = $ead54b3c845eba59$var$wrapper("createOrgCf");
const $ead54b3c845eba59$var$addMember = $ead54b3c845eba59$var$wrapper("addMemberCf");
const $ead54b3c845eba59$var$addGroup = $ead54b3c845eba59$var$wrapper("addGroupCf");
const $ead54b3c845eba59$var$checkDomainVerificationStatus = $ead54b3c845eba59$var$wrapper("checkDomainVerificationStatusCf");
const $ead54b3c845eba59$var$getMyOrg = $ead54b3c845eba59$var$wrapper("getMyOrgCf");
const $ead54b3c845eba59$var$resetPassword = $ead54b3c845eba59$var$wrapper("resetPasswordCf");
const $ead54b3c845eba59$var$emailPassword = $ead54b3c845eba59$var$wrapper("emailPasswordCf");
const $ead54b3c845eba59$var$suspendMember = $ead54b3c845eba59$var$wrapper("suspendMemberCf");
const $ead54b3c845eba59$var$getDkimAttributes = $ead54b3c845eba59$var$wrapper("getDkimAttributesCf");
const $ead54b3c845eba59$export$64fa523eeab26787 = {
    addMember: $ead54b3c845eba59$var$addMember,
    addGroup: $ead54b3c845eba59$var$addGroup,
    createOrg: $ead54b3c845eba59$var$createOrg,
    checkDomainVerificationStatus: $ead54b3c845eba59$var$checkDomainVerificationStatus,
    getMyOrg: $ead54b3c845eba59$var$getMyOrg,
    suspendMember: $ead54b3c845eba59$var$suspendMember,
    resetPassword: $ead54b3c845eba59$var$resetPassword,
    emailPassword: $ead54b3c845eba59$var$emailPassword,
    getDkimAttributes: $ead54b3c845eba59$var$getDkimAttributes
};


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries








const $f05caab30360a480$var$name = "@firebase/installations";
const $f05caab30360a480$var$version = "0.6.7";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f05caab30360a480$var$PENDING_TIMEOUT_MS = 10000;
const $f05caab30360a480$var$PACKAGE_VERSION = `w:${$f05caab30360a480$var$version}`;
const $f05caab30360a480$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $f05caab30360a480$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $f05caab30360a480$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $f05caab30360a480$var$SERVICE = 'installations';
const $f05caab30360a480$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f05caab30360a480$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $f05caab30360a480$var$ERROR_FACTORY = new (0, $59fdd18afb377ad5$export$3fa6e1b18a3b2d40)($f05caab30360a480$var$SERVICE, $f05caab30360a480$var$SERVICE_NAME, $f05caab30360a480$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $f05caab30360a480$var$isServerError(error) {
    return error instanceof (0, $59fdd18afb377ad5$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f05caab30360a480$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$f05caab30360a480$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $f05caab30360a480$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $f05caab30360a480$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $f05caab30360a480$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $f05caab30360a480$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $f05caab30360a480$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $f05caab30360a480$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $f05caab30360a480$var$getHeaders(appConfig);
    headers.append('Authorization', $f05caab30360a480$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $f05caab30360a480$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $f05caab30360a480$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $f05caab30360a480$var$getAuthorizationHeader(refreshToken) {
    return `${$f05caab30360a480$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f05caab30360a480$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $f05caab30360a480$var$getInstallationsEndpoint(appConfig);
    const headers = $f05caab30360a480$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $f05caab30360a480$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $f05caab30360a480$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $f05caab30360a480$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $f05caab30360a480$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $f05caab30360a480$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $f05caab30360a480$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f05caab30360a480$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f05caab30360a480$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $f05caab30360a480$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $f05caab30360a480$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $f05caab30360a480$var$encode(fidByteArray);
        return $f05caab30360a480$var$VALID_FID_PATTERN.test(fid) ? fid : $f05caab30360a480$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $f05caab30360a480$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $f05caab30360a480$var$encode(fidByteArray) {
    const b64String = $f05caab30360a480$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $f05caab30360a480$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f05caab30360a480$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $f05caab30360a480$var$fidChanged(appConfig, fid) {
    const key = $f05caab30360a480$var$getKey(appConfig);
    $f05caab30360a480$var$callFidChangeCallbacks(key, fid);
    $f05caab30360a480$var$broadcastFidChange(key, fid);
}
function $f05caab30360a480$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $f05caab30360a480$var$getBroadcastChannel();
    const key = $f05caab30360a480$var$getKey(appConfig);
    let callbackSet = $f05caab30360a480$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $f05caab30360a480$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $f05caab30360a480$var$removeCallback(appConfig, callback) {
    const key = $f05caab30360a480$var$getKey(appConfig);
    const callbackSet = $f05caab30360a480$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $f05caab30360a480$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $f05caab30360a480$var$closeBroadcastChannel();
}
function $f05caab30360a480$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $f05caab30360a480$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $f05caab30360a480$var$broadcastFidChange(key, fid) {
    const channel = $f05caab30360a480$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $f05caab30360a480$var$closeBroadcastChannel();
}
let $f05caab30360a480$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $f05caab30360a480$var$getBroadcastChannel() {
    if (!$f05caab30360a480$var$broadcastChannel && 'BroadcastChannel' in self) {
        $f05caab30360a480$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $f05caab30360a480$var$broadcastChannel.onmessage = (e)=>{
            $f05caab30360a480$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $f05caab30360a480$var$broadcastChannel;
}
function $f05caab30360a480$var$closeBroadcastChannel() {
    if ($f05caab30360a480$var$fidChangeCallbacks.size === 0 && $f05caab30360a480$var$broadcastChannel) {
        $f05caab30360a480$var$broadcastChannel.close();
        $f05caab30360a480$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f05caab30360a480$var$DATABASE_NAME = 'firebase-installations-database';
const $f05caab30360a480$var$DATABASE_VERSION = 1;
const $f05caab30360a480$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $f05caab30360a480$var$dbPromise = null;
function $f05caab30360a480$var$getDbPromise() {
    if (!$f05caab30360a480$var$dbPromise) $f05caab30360a480$var$dbPromise = (0, $dcd2f819ff509019$export$ca0ed41b1a2af7e)($f05caab30360a480$var$DATABASE_NAME, $f05caab30360a480$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($f05caab30360a480$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $f05caab30360a480$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $f05caab30360a480$var$set(appConfig, value) {
    const key = $f05caab30360a480$var$getKey(appConfig);
    const db = await $f05caab30360a480$var$getDbPromise();
    const tx = db.transaction($f05caab30360a480$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($f05caab30360a480$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $f05caab30360a480$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $f05caab30360a480$var$remove(appConfig) {
    const key = $f05caab30360a480$var$getKey(appConfig);
    const db = await $f05caab30360a480$var$getDbPromise();
    const tx = db.transaction($f05caab30360a480$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($f05caab30360a480$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $f05caab30360a480$var$update(appConfig, updateFn) {
    const key = $f05caab30360a480$var$getKey(appConfig);
    const db = await $f05caab30360a480$var$getDbPromise();
    const tx = db.transaction($f05caab30360a480$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($f05caab30360a480$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $f05caab30360a480$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $f05caab30360a480$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $f05caab30360a480$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $f05caab30360a480$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $f05caab30360a480$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $f05caab30360a480$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $f05caab30360a480$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $f05caab30360a480$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $f05caab30360a480$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $f05caab30360a480$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($f05caab30360a480$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $f05caab30360a480$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $f05caab30360a480$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $f05caab30360a480$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $f05caab30360a480$var$createInstallationRequest(installations, installationEntry);
        return $f05caab30360a480$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($f05caab30360a480$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $f05caab30360a480$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $f05caab30360a480$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $f05caab30360a480$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $f05caab30360a480$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $f05caab30360a480$var$sleep(100);
        entry = await $f05caab30360a480$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $f05caab30360a480$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $f05caab30360a480$var$updateInstallationRequest(appConfig) {
    return $f05caab30360a480$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $f05caab30360a480$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $f05caab30360a480$var$clearTimedOutRequest(oldEntry);
    });
}
function $f05caab30360a480$var$clearTimedOutRequest(entry) {
    if ($f05caab30360a480$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $f05caab30360a480$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $f05caab30360a480$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f05caab30360a480$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $f05caab30360a480$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $f05caab30360a480$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $f05caab30360a480$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $f05caab30360a480$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $f05caab30360a480$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $f05caab30360a480$var$getErrorFromResponse('Generate Auth Token', response);
}
function $f05caab30360a480$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$f05caab30360a480$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $f05caab30360a480$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $f05caab30360a480$var$update(installations.appConfig, (oldEntry)=>{
        if (!$f05caab30360a480$var$isEntryRegistered(oldEntry)) throw $f05caab30360a480$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $f05caab30360a480$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $f05caab30360a480$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $f05caab30360a480$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $f05caab30360a480$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $f05caab30360a480$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $f05caab30360a480$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $f05caab30360a480$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $f05caab30360a480$var$sleep(100);
        entry = await $f05caab30360a480$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $f05caab30360a480$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $f05caab30360a480$var$updateAuthTokenRequest(appConfig) {
    return $f05caab30360a480$var$update(appConfig, (oldEntry)=>{
        if (!$f05caab30360a480$var$isEntryRegistered(oldEntry)) throw $f05caab30360a480$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($f05caab30360a480$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $f05caab30360a480$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $f05caab30360a480$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $f05caab30360a480$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($f05caab30360a480$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $f05caab30360a480$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $f05caab30360a480$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $f05caab30360a480$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $f05caab30360a480$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$f05caab30360a480$var$isAuthTokenExpired(authToken);
}
function $f05caab30360a480$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $f05caab30360a480$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $f05caab30360a480$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $f05caab30360a480$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $f05caab30360a480$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $f05caab30360a480$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $f05caab30360a480$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $f05caab30360a480$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $f05caab30360a480$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $f05caab30360a480$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $f05caab30360a480$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $f05caab30360a480$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $f05caab30360a480$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f05caab30360a480$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $f05caab30360a480$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $f05caab30360a480$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $f05caab30360a480$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $f05caab30360a480$var$getErrorFromResponse('Delete Installation', response);
}
function $f05caab30360a480$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$f05caab30360a480$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $f05caab30360a480$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $f05caab30360a480$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $f05caab30360a480$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $f05caab30360a480$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $f05caab30360a480$var$deleteInstallationRequest(appConfig, entry);
                await $f05caab30360a480$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $f05caab30360a480$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $f05caab30360a480$var$addCallback(appConfig, callback);
    return ()=>{
        $f05caab30360a480$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $f05caab30360a480$export$9bfc115e43431ff5(app = (0, $6de42d4eacc8610d$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f05caab30360a480$var$extractAppConfig(app) {
    if (!app || !app.options) throw $f05caab30360a480$var$getMissingValueError('App Configuration');
    if (!app.name) throw $f05caab30360a480$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $f05caab30360a480$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $f05caab30360a480$var$getMissingValueError(valueName) {
    return $f05caab30360a480$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f05caab30360a480$var$INSTALLATIONS_NAME = 'installations';
const $f05caab30360a480$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $f05caab30360a480$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $f05caab30360a480$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $f05caab30360a480$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, $f05caab30360a480$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$f05caab30360a480$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$f05caab30360a480$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $f05caab30360a480$var$registerInstallations() {
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)($f05caab30360a480$var$INSTALLATIONS_NAME, $f05caab30360a480$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)($f05caab30360a480$var$INSTALLATIONS_NAME_INTERNAL, $f05caab30360a480$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $f05caab30360a480$var$registerInstallations();
(0, $6de42d4eacc8610d$export$d29d5299a7137abc)($f05caab30360a480$var$name, $f05caab30360a480$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $6de42d4eacc8610d$export$d29d5299a7137abc)($f05caab30360a480$var$name, $f05caab30360a480$var$version, 'esm2017');


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $00d5d4678e71d8cb$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $00d5d4678e71d8cb$var$GA_FID_KEY = 'firebase_id';
const $00d5d4678e71d8cb$var$ORIGIN_KEY = 'origin';
const $00d5d4678e71d8cb$var$FETCH_TIMEOUT_MILLIS = 60000;
const $00d5d4678e71d8cb$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $00d5d4678e71d8cb$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $00d5d4678e71d8cb$var$logger = new (0, $b3ab7ef8f3a0a29a$export$efa9a398d6368992)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $00d5d4678e71d8cb$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $00d5d4678e71d8cb$var$ERROR_FACTORY = new (0, $59fdd18afb377ad5$export$3fa6e1b18a3b2d40)('analytics', 'Analytics', $00d5d4678e71d8cb$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $00d5d4678e71d8cb$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($00d5d4678e71d8cb$var$GTAG_URL)) {
        const err = $00d5d4678e71d8cb$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $00d5d4678e71d8cb$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $00d5d4678e71d8cb$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $00d5d4678e71d8cb$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $00d5d4678e71d8cb$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $00d5d4678e71d8cb$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $00d5d4678e71d8cb$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$00d5d4678e71d8cb$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $00d5d4678e71d8cb$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $00d5d4678e71d8cb$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $00d5d4678e71d8cb$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $00d5d4678e71d8cb$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $00d5d4678e71d8cb$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $00d5d4678e71d8cb$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $00d5d4678e71d8cb$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $00d5d4678e71d8cb$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $00d5d4678e71d8cb$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $00d5d4678e71d8cb$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [gtagParams] = args;
                gtagCore("consent" /* GtagCommand.CONSENT */ , 'update', gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $00d5d4678e71d8cb$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $00d5d4678e71d8cb$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $00d5d4678e71d8cb$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $00d5d4678e71d8cb$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($00d5d4678e71d8cb$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $00d5d4678e71d8cb$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $00d5d4678e71d8cb$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $00d5d4678e71d8cb$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $00d5d4678e71d8cb$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $00d5d4678e71d8cb$var$defaultRetryData = new $00d5d4678e71d8cb$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $00d5d4678e71d8cb$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $00d5d4678e71d8cb$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $00d5d4678e71d8cb$var$getHeaders(apiKey)
    };
    const appUrl = $00d5d4678e71d8cb$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $00d5d4678e71d8cb$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $00d5d4678e71d8cb$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $00d5d4678e71d8cb$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $00d5d4678e71d8cb$var$FETCH_TIMEOUT_MILLIS);
    return $00d5d4678e71d8cb$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $00d5d4678e71d8cb$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $00d5d4678e71d8cb$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $00d5d4678e71d8cb$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $00d5d4678e71d8cb$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $00d5d4678e71d8cb$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$00d5d4678e71d8cb$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $00d5d4678e71d8cb$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $59fdd18afb377ad5$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $00d5d4678e71d8cb$var$LONG_RETRY_FACTOR) : (0, $59fdd18afb377ad5$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $00d5d4678e71d8cb$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $00d5d4678e71d8cb$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $00d5d4678e71d8cb$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($00d5d4678e71d8cb$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $00d5d4678e71d8cb$var$isRetriableError(e) {
    if (!(e instanceof (0, $59fdd18afb377ad5$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $00d5d4678e71d8cb$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $00d5d4678e71d8cb$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $00d5d4678e71d8cb$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            'send_to': measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $00d5d4678e71d8cb$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $00d5d4678e71d8cb$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $00d5d4678e71d8cb$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $00d5d4678e71d8cb$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($00d5d4678e71d8cb$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $00d5d4678e71d8cb$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $00d5d4678e71d8cb$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $00d5d4678e71d8cb$var$_setConsentDefaultForInit(consentSettings) {
    $00d5d4678e71d8cb$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $00d5d4678e71d8cb$var$_setDefaultEventParametersForInit(customParams) {
    $00d5d4678e71d8cb$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $00d5d4678e71d8cb$var$validateIndexedDB() {
    if (!(0, $59fdd18afb377ad5$export$3865db50535c2055)()) {
        $00d5d4678e71d8cb$var$logger.warn($00d5d4678e71d8cb$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $59fdd18afb377ad5$export$a8a3018f3d187a4d)();
    } catch (e) {
        $00d5d4678e71d8cb$var$logger.warn($00d5d4678e71d8cb$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $00d5d4678e71d8cb$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $00d5d4678e71d8cb$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $00d5d4678e71d8cb$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$00d5d4678e71d8cb$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $00d5d4678e71d8cb$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$00d5d4678e71d8cb$var$findGtagScriptOnPage(dataLayerName)) $00d5d4678e71d8cb$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($00d5d4678e71d8cb$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $00d5d4678e71d8cb$var$defaultConsentSettingsForInit);
        $00d5d4678e71d8cb$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$00d5d4678e71d8cb$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$00d5d4678e71d8cb$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($00d5d4678e71d8cb$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $00d5d4678e71d8cb$var$defaultEventParametersForInit);
        $00d5d4678e71d8cb$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $00d5d4678e71d8cb$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $00d5d4678e71d8cb$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $00d5d4678e71d8cb$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $00d5d4678e71d8cb$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $00d5d4678e71d8cb$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $00d5d4678e71d8cb$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $00d5d4678e71d8cb$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $00d5d4678e71d8cb$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $00d5d4678e71d8cb$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $00d5d4678e71d8cb$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $00d5d4678e71d8cb$export$a5a6e0b888b2c992(options) {
    if ($00d5d4678e71d8cb$var$globalInitDone) throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $00d5d4678e71d8cb$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $00d5d4678e71d8cb$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $00d5d4678e71d8cb$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $59fdd18afb377ad5$export$caa8774a9107a58e)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $59fdd18afb377ad5$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $00d5d4678e71d8cb$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $00d5d4678e71d8cb$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $00d5d4678e71d8cb$var$factory(app, installations, options) {
    $00d5d4678e71d8cb$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $00d5d4678e71d8cb$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($00d5d4678e71d8cb$var$initializationPromisesMap[appId] != null) throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$00d5d4678e71d8cb$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $00d5d4678e71d8cb$var$getOrCreateDataLayer($00d5d4678e71d8cb$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $00d5d4678e71d8cb$var$wrapOrCreateGtag($00d5d4678e71d8cb$var$initializationPromisesMap, $00d5d4678e71d8cb$var$dynamicConfigPromisesList, $00d5d4678e71d8cb$var$measurementIdToAppId, $00d5d4678e71d8cb$var$dataLayerName, $00d5d4678e71d8cb$var$gtagName);
        $00d5d4678e71d8cb$var$wrappedGtagFunction = wrappedGtag;
        $00d5d4678e71d8cb$var$gtagCoreFunction = gtagCore;
        $00d5d4678e71d8cb$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $00d5d4678e71d8cb$var$initializationPromisesMap[appId] = $00d5d4678e71d8cb$var$_initializeAnalytics(app, $00d5d4678e71d8cb$var$dynamicConfigPromisesList, $00d5d4678e71d8cb$var$measurementIdToAppId, installations, $00d5d4678e71d8cb$var$gtagCoreFunction, $00d5d4678e71d8cb$var$dataLayerName, options);
    const analyticsInstance = new $00d5d4678e71d8cb$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $00d5d4678e71d8cb$export$b0297573c90085aa(app = (0, $6de42d4eacc8610d$export$f9962582c9e66d99)()) {
    app = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, $00d5d4678e71d8cb$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $00d5d4678e71d8cb$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $00d5d4678e71d8cb$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, $00d5d4678e71d8cb$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $00d5d4678e71d8cb$export$48c17662a6902497() {
    if ((0, $59fdd18afb377ad5$export$caa8774a9107a58e)()) return false;
    if (!(0, $59fdd18afb377ad5$export$f172b7eb6cf60599)()) return false;
    if (!(0, $59fdd18afb377ad5$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $59fdd18afb377ad5$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $00d5d4678e71d8cb$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(analyticsInstance);
    $00d5d4678e71d8cb$var$setCurrentScreen$1($00d5d4678e71d8cb$var$wrappedGtagFunction, $00d5d4678e71d8cb$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$00d5d4678e71d8cb$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $00d5d4678e71d8cb$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(analyticsInstance);
    return $00d5d4678e71d8cb$var$internalGetGoogleAnalyticsClientId($00d5d4678e71d8cb$var$wrappedGtagFunction, $00d5d4678e71d8cb$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $00d5d4678e71d8cb$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(analyticsInstance);
    $00d5d4678e71d8cb$var$setUserId$1($00d5d4678e71d8cb$var$wrappedGtagFunction, $00d5d4678e71d8cb$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$00d5d4678e71d8cb$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $00d5d4678e71d8cb$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(analyticsInstance);
    $00d5d4678e71d8cb$var$setUserProperties$1($00d5d4678e71d8cb$var$wrappedGtagFunction, $00d5d4678e71d8cb$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$00d5d4678e71d8cb$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $00d5d4678e71d8cb$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(analyticsInstance);
    $00d5d4678e71d8cb$var$setAnalyticsCollectionEnabled$1($00d5d4678e71d8cb$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$00d5d4678e71d8cb$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $00d5d4678e71d8cb$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($00d5d4678e71d8cb$var$wrappedGtagFunction) $00d5d4678e71d8cb$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $00d5d4678e71d8cb$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $00d5d4678e71d8cb$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(analyticsInstance);
    $00d5d4678e71d8cb$var$logEvent$1($00d5d4678e71d8cb$var$wrappedGtagFunction, $00d5d4678e71d8cb$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$00d5d4678e71d8cb$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $00d5d4678e71d8cb$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($00d5d4678e71d8cb$var$wrappedGtagFunction) $00d5d4678e71d8cb$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $00d5d4678e71d8cb$var$_setConsentDefaultForInit(consentSettings);
}
const $00d5d4678e71d8cb$var$name = "@firebase/analytics";
const $00d5d4678e71d8cb$var$version = "0.10.3";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $00d5d4678e71d8cb$var$registerAnalytics() {
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)($00d5d4678e71d8cb$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $00d5d4678e71d8cb$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($00d5d4678e71d8cb$var$name, $00d5d4678e71d8cb$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($00d5d4678e71d8cb$var$name, $00d5d4678e71d8cb$var$version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($00d5d4678e71d8cb$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$00d5d4678e71d8cb$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $00d5d4678e71d8cb$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$00d5d4678e71d8cb$var$registerAnalytics();





const $7a0f621719098735$export$71a493436f9bccb6 = (0, $00d5d4678e71d8cb$export$b0297573c90085aa)((0, $f335ccce9ceac24d$export$a4e2c8f07e884e));







/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $bbec114f87dbfe2a$var$extendStatics = function(d, b) {
    $bbec114f87dbfe2a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bbec114f87dbfe2a$var$extendStatics(d, b);
};
function $bbec114f87dbfe2a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bbec114f87dbfe2a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bbec114f87dbfe2a$export$18ce0697a983be9b = function() {
    $bbec114f87dbfe2a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbec114f87dbfe2a$export$18ce0697a983be9b.apply(this, arguments);
};
function $bbec114f87dbfe2a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bbec114f87dbfe2a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bbec114f87dbfe2a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bbec114f87dbfe2a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bbec114f87dbfe2a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bbec114f87dbfe2a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bbec114f87dbfe2a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bbec114f87dbfe2a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bbec114f87dbfe2a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bbec114f87dbfe2a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bbec114f87dbfe2a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bbec114f87dbfe2a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bbec114f87dbfe2a$export$45d3717a4c69092e(o, m, p);
}
function $bbec114f87dbfe2a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bbec114f87dbfe2a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bbec114f87dbfe2a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bbec114f87dbfe2a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bbec114f87dbfe2a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bbec114f87dbfe2a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bbec114f87dbfe2a$export$10c90e4f7922046c(v) {
    return this instanceof $bbec114f87dbfe2a$export$10c90e4f7922046c ? (this.v = v, this) : new $bbec114f87dbfe2a$export$10c90e4f7922046c(v);
}
function $bbec114f87dbfe2a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bbec114f87dbfe2a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bbec114f87dbfe2a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bbec114f87dbfe2a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bbec114f87dbfe2a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bbec114f87dbfe2a$export$19a8beecd37a4c45 === "function" ? $bbec114f87dbfe2a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bbec114f87dbfe2a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bbec114f87dbfe2a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bbec114f87dbfe2a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bbec114f87dbfe2a$export$45d3717a4c69092e(result, mod, k);
    }
    $bbec114f87dbfe2a$var$__setModuleDefault(result, mod);
    return result;
}
function $bbec114f87dbfe2a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bbec114f87dbfe2a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bbec114f87dbfe2a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bbec114f87dbfe2a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bbec114f87dbfe2a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bbec114f87dbfe2a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bbec114f87dbfe2a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bbec114f87dbfe2a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $bbec114f87dbfe2a$export$2e2bcd8739ae039 = {
    __extends: $bbec114f87dbfe2a$export$a8ba968b8961cb8a,
    __assign: $bbec114f87dbfe2a$export$18ce0697a983be9b,
    __rest: $bbec114f87dbfe2a$export$3c9a16f847548506,
    __decorate: $bbec114f87dbfe2a$export$29e00dfd3077644b,
    __param: $bbec114f87dbfe2a$export$d5ad3fd78186038f,
    __metadata: $bbec114f87dbfe2a$export$f1db080c865becb9,
    __awaiter: $bbec114f87dbfe2a$export$1050f835b63b671e,
    __generator: $bbec114f87dbfe2a$export$67ebef60e6f28a6,
    __createBinding: $bbec114f87dbfe2a$export$45d3717a4c69092e,
    __exportStar: $bbec114f87dbfe2a$export$f33643c0debef087,
    __values: $bbec114f87dbfe2a$export$19a8beecd37a4c45,
    __read: $bbec114f87dbfe2a$export$8d051b38c9118094,
    __spread: $bbec114f87dbfe2a$export$afc72e2116322959,
    __spreadArrays: $bbec114f87dbfe2a$export$6388937ca91ccae8,
    __spreadArray: $bbec114f87dbfe2a$export$1216008129fb82ed,
    __await: $bbec114f87dbfe2a$export$10c90e4f7922046c,
    __asyncGenerator: $bbec114f87dbfe2a$export$e427f37a30a4de9b,
    __asyncDelegator: $bbec114f87dbfe2a$export$bbd80228419bb833,
    __asyncValues: $bbec114f87dbfe2a$export$e3b29a3d6162315f,
    __makeTemplateObject: $bbec114f87dbfe2a$export$4fb47efe1390b86f,
    __importStar: $bbec114f87dbfe2a$export$c21735bcef00d192,
    __importDefault: $bbec114f87dbfe2a$export$da59b14a69baef04,
    __classPrivateFieldGet: $bbec114f87dbfe2a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bbec114f87dbfe2a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bbec114f87dbfe2a$export$81fdc39f203e4e04,
    __addDisposableResource: $bbec114f87dbfe2a$export$88ac25d8e944e405,
    __disposeResources: $bbec114f87dbfe2a$export$8f076105dc360e92
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $827e1caa20d65a4f$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $827e1caa20d65a4f$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $827e1caa20d65a4f$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $827e1caa20d65a4f$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $827e1caa20d65a4f$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registed for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.'
    };
}
function $827e1caa20d65a4f$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $827e1caa20d65a4f$export$2329c99376c9d0a4 = $827e1caa20d65a4f$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $827e1caa20d65a4f$export$7f8ddf7c7c20b3cd = $827e1caa20d65a4f$var$_prodErrorMap;
const $827e1caa20d65a4f$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $59fdd18afb377ad5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $827e1caa20d65a4f$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $827e1caa20d65a4f$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$logClient = new (0, $b3ab7ef8f3a0a29a$export$efa9a398d6368992)('@firebase/auth');
function $827e1caa20d65a4f$var$_logWarn(msg, ...args) {
    if ($827e1caa20d65a4f$var$logClient.logLevel <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).WARN) $827e1caa20d65a4f$var$logClient.warn(`Auth (${(0, $6de42d4eacc8610d$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $827e1caa20d65a4f$var$_logError(msg, ...args) {
    if ($827e1caa20d65a4f$var$logClient.logLevel <= (0, $b3ab7ef8f3a0a29a$export$243e62d78d3b544d).ERROR) $827e1caa20d65a4f$var$logClient.error(`Auth (${(0, $6de42d4eacc8610d$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $827e1caa20d65a4f$var$createErrorInternal(authOrCode, ...rest);
}
function $827e1caa20d65a4f$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $827e1caa20d65a4f$var$createErrorInternal(authOrCode, ...rest);
}
function $827e1caa20d65a4f$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $827e1caa20d65a4f$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $59fdd18afb377ad5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $827e1caa20d65a4f$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $827e1caa20d65a4f$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $827e1caa20d65a4f$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $827e1caa20d65a4f$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $827e1caa20d65a4f$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $827e1caa20d65a4f$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $827e1caa20d65a4f$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $827e1caa20d65a4f$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $827e1caa20d65a4f$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $827e1caa20d65a4f$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $827e1caa20d65a4f$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$_getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function $827e1caa20d65a4f$var$_isHttpOrHttps() {
    return $827e1caa20d65a4f$var$_getCurrentScheme() === 'http:' || $827e1caa20d65a4f$var$_getCurrentScheme() === 'https:';
}
function $827e1caa20d65a4f$var$_getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $827e1caa20d65a4f$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($827e1caa20d65a4f$var$_isHttpOrHttps() || (0, $59fdd18afb377ad5$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $827e1caa20d65a4f$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $827e1caa20d65a4f$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $827e1caa20d65a4f$export$1fbe638ecf81657e(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $59fdd18afb377ad5$export$872f8323f01d7ae0)() || (0, $59fdd18afb377ad5$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$827e1caa20d65a4f$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$_emulatorUrl(config, path) {
    $827e1caa20d65a4f$export$1fbe638ecf81657e(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $827e1caa20d65a4f$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $827e1caa20d65a4f$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $827e1caa20d65a4f$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $827e1caa20d65a4f$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$DEFAULT_API_TIMEOUT_MS = new $827e1caa20d65a4f$var$Delay(30000, 60000);
function $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $827e1caa20d65a4f$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $827e1caa20d65a4f$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $59fdd18afb377ad5$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $827e1caa20d65a4f$export$2ed0fc6709e59212.fetch()($827e1caa20d65a4f$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: 'no-referrer'
        }, body));
    });
}
async function $827e1caa20d65a4f$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $827e1caa20d65a4f$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $827e1caa20d65a4f$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $827e1caa20d65a4f$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $827e1caa20d65a4f$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $827e1caa20d65a4f$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $827e1caa20d65a4f$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $827e1caa20d65a4f$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $59fdd18afb377ad5$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $827e1caa20d65a4f$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $827e1caa20d65a4f$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $827e1caa20d65a4f$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $827e1caa20d65a4f$var$_emulatorUrl(auth.config, base);
}
function $827e1caa20d65a4f$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $827e1caa20d65a4f$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($827e1caa20d65a4f$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $827e1caa20d65a4f$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $827e1caa20d65a4f$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $827e1caa20d65a4f$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $827e1caa20d65a4f$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $827e1caa20d65a4f$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $827e1caa20d65a4f$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$getRecaptchaParams(auth) {
    return (await $827e1caa20d65a4f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $827e1caa20d65a4f$var$getRecaptchaConfig(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$deleteAccount(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $827e1caa20d65a4f$var$deleteLinkedAccounts(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $827e1caa20d65a4f$var$getAccountInfo(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $827e1caa20d65a4f$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $827e1caa20d65a4f$var$_parseToken(token);
    $827e1caa20d65a4f$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $827e1caa20d65a4f$var$utcTimestampToDateString($827e1caa20d65a4f$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $827e1caa20d65a4f$var$utcTimestampToDateString($827e1caa20d65a4f$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $827e1caa20d65a4f$var$utcTimestampToDateString($827e1caa20d65a4f$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function $827e1caa20d65a4f$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $827e1caa20d65a4f$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $827e1caa20d65a4f$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $59fdd18afb377ad5$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $827e1caa20d65a4f$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $827e1caa20d65a4f$var$_logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $827e1caa20d65a4f$var$_tokenExpiresIn(token) {
    const parsedToken = $827e1caa20d65a4f$var$_parseToken(token);
    $827e1caa20d65a4f$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $827e1caa20d65a4f$export$890c4ad488842ce7(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $827e1caa20d65a4f$export$890c4ad488842ce7(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $59fdd18afb377ad5$export$dd24e9cd51226c56) && $827e1caa20d65a4f$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $827e1caa20d65a4f$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $827e1caa20d65a4f$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $827e1caa20d65a4f$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $827e1caa20d65a4f$var$_logoutIfInvalidated(user, $827e1caa20d65a4f$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $827e1caa20d65a4f$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $827e1caa20d65a4f$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $827e1caa20d65a4f$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $827e1caa20d65a4f$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$d24c54395ce0c509(user) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    await $827e1caa20d65a4f$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $827e1caa20d65a4f$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $827e1caa20d65a4f$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $bbec114f87dbfe2a$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$requestStsToken(auth, refreshToken) {
    const response = await $827e1caa20d65a4f$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $59fdd18afb377ad5$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $827e1caa20d65a4f$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        return $827e1caa20d65a4f$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $827e1caa20d65a4f$var$revokeToken(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $827e1caa20d65a4f$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $827e1caa20d65a4f$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $827e1caa20d65a4f$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $827e1caa20d65a4f$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $827e1caa20d65a4f$var$StsTokenManager();
        if (refreshToken) {
            $827e1caa20d65a4f$export$890c4ad488842ce7(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $827e1caa20d65a4f$export$890c4ad488842ce7(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $827e1caa20d65a4f$export$890c4ad488842ce7(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $827e1caa20d65a4f$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $827e1caa20d65a4f$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$assertStringOrUndefined(assertion, appName) {
    $827e1caa20d65a4f$export$890c4ad488842ce7(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $827e1caa20d65a4f$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $bbec114f87dbfe2a$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $827e1caa20d65a4f$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $827e1caa20d65a4f$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $827e1caa20d65a4f$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $827e1caa20d65a4f$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $827e1caa20d65a4f$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $827e1caa20d65a4f$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $827e1caa20d65a4f$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $827e1caa20d65a4f$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $827e1caa20d65a4f$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $827e1caa20d65a4f$var$_logoutIfInvalidated(this, $827e1caa20d65a4f$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $827e1caa20d65a4f$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $827e1caa20d65a4f$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $827e1caa20d65a4f$var$assertStringOrUndefined(displayName, auth.name);
        $827e1caa20d65a4f$var$assertStringOrUndefined(email, auth.name);
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $827e1caa20d65a4f$var$assertStringOrUndefined(phoneNumber, auth.name);
        $827e1caa20d65a4f$var$assertStringOrUndefined(photoURL, auth.name);
        $827e1caa20d65a4f$var$assertStringOrUndefined(tenantId, auth.name);
        $827e1caa20d65a4f$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $827e1caa20d65a4f$var$assertStringOrUndefined(createdAt, auth.name);
        $827e1caa20d65a4f$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $827e1caa20d65a4f$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $827e1caa20d65a4f$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $827e1caa20d65a4f$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $827e1caa20d65a4f$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $827e1caa20d65a4f$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $827e1caa20d65a4f$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $827e1caa20d65a4f$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $827e1caa20d65a4f$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $827e1caa20d65a4f$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$instanceCache = new Map();
function $827e1caa20d65a4f$export$158acd800e1ef08b(cls) {
    $827e1caa20d65a4f$export$1fbe638ecf81657e(cls instanceof Function, 'Expected a class definition');
    let instance = $827e1caa20d65a4f$var$instanceCache.get(cls);
    if (instance) {
        $827e1caa20d65a4f$export$1fbe638ecf81657e(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $827e1caa20d65a4f$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$827e1caa20d65a4f$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $827e1caa20d65a4f$export$3a6d5c9ae78a2c08 = $827e1caa20d65a4f$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $827e1caa20d65a4f$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $827e1caa20d65a4f$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $827e1caa20d65a4f$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $827e1caa20d65a4f$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $827e1caa20d65a4f$var$PersistenceUserManager($827e1caa20d65a4f$export$158acd800e1ef08b($827e1caa20d65a4f$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $827e1caa20d65a4f$export$158acd800e1ef08b($827e1caa20d65a4f$export$3a6d5c9ae78a2c08);
        const key = $827e1caa20d65a4f$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $827e1caa20d65a4f$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $827e1caa20d65a4f$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $827e1caa20d65a4f$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $827e1caa20d65a4f$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($827e1caa20d65a4f$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($827e1caa20d65a4f$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($827e1caa20d65a4f$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($827e1caa20d65a4f$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($827e1caa20d65a4f$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $827e1caa20d65a4f$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($827e1caa20d65a4f$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $827e1caa20d65a4f$var$_isFirefox(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $827e1caa20d65a4f$var$_isSafari(userAgent = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $827e1caa20d65a4f$var$_isChromeIOS(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $827e1caa20d65a4f$var$_isIEMobile(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $827e1caa20d65a4f$export$92108d983e8ee699(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $827e1caa20d65a4f$var$_isBlackBerry(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $827e1caa20d65a4f$var$_isWebOS(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $827e1caa20d65a4f$export$d66dc83d8cfc8dd(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $827e1caa20d65a4f$export$91c6e00c14e7e6fd(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $827e1caa20d65a4f$var$_isIOSStandalone(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    var _a;
    return $827e1caa20d65a4f$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $827e1caa20d65a4f$var$_isIE10() {
    return (0, $59fdd18afb377ad5$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $827e1caa20d65a4f$var$_isMobileBrowser(ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $827e1caa20d65a4f$export$d66dc83d8cfc8dd(ua) || $827e1caa20d65a4f$export$92108d983e8ee699(ua) || $827e1caa20d65a4f$var$_isWebOS(ua) || $827e1caa20d65a4f$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $827e1caa20d65a4f$var$_isIEMobile(ua);
}
function $827e1caa20d65a4f$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $827e1caa20d65a4f$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $827e1caa20d65a4f$var$_getBrowserName((0, $59fdd18afb377ad5$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$827e1caa20d65a4f$var$_getBrowserName((0, $59fdd18afb377ad5$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $6de42d4eacc8610d$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $827e1caa20d65a4f$var$_getPasswordPolicy(auth, request = {}) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $827e1caa20d65a4f$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $827e1caa20d65a4f$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $827e1caa20d65a4f$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $827e1caa20d65a4f$var$Subscription(this);
        this.idTokenSubscription = new $827e1caa20d65a4f$var$Subscription(this);
        this.beforeStateQueue = new $827e1caa20d65a4f$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $827e1caa20d65a4f$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $827e1caa20d65a4f$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $827e1caa20d65a4f$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $827e1caa20d65a4f$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $827e1caa20d65a4f$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $827e1caa20d65a4f$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $827e1caa20d65a4f$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $827e1caa20d65a4f$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(this.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $827e1caa20d65a4f$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $827e1caa20d65a4f$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(this.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(this.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($827e1caa20d65a4f$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $827e1caa20d65a4f$var$_getPasswordPolicy(this);
        const passwordPolicy = new $827e1caa20d65a4f$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $59fdd18afb377ad5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $827e1caa20d65a4f$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $827e1caa20d65a4f$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $827e1caa20d65a4f$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $827e1caa20d65a4f$var$PersistenceUserManager.create(this, [
                $827e1caa20d65a4f$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $827e1caa20d65a4f$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $827e1caa20d65a4f$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $827e1caa20d65a4f$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $827e1caa20d65a4f$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $59fdd18afb377ad5$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $827e1caa20d65a4f$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $827e1caa20d65a4f$var$_setExternalJSProvider(p) {
    $827e1caa20d65a4f$var$externalJSProvider = p;
}
function $827e1caa20d65a4f$var$_loadJS(url) {
    return $827e1caa20d65a4f$var$externalJSProvider.loadJS(url);
}
function $827e1caa20d65a4f$var$_recaptchaV2ScriptUrl() {
    return $827e1caa20d65a4f$var$externalJSProvider.recaptchaV2Script;
}
function $827e1caa20d65a4f$var$_recaptchaEnterpriseScriptUrl() {
    return $827e1caa20d65a4f$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $827e1caa20d65a4f$var$_gapiScriptUrl() {
    return $827e1caa20d65a4f$var$externalJSProvider.gapiScript;
}
function $827e1caa20d65a4f$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $827e1caa20d65a4f$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $827e1caa20d65a4f$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $827e1caa20d65a4f$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $827e1caa20d65a4f$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $827e1caa20d65a4f$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $827e1caa20d65a4f$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $827e1caa20d65a4f$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($827e1caa20d65a4f$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($827e1caa20d65a4f$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $827e1caa20d65a4f$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $827e1caa20d65a4f$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $827e1caa20d65a4f$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $827e1caa20d65a4f$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $827e1caa20d65a4f$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $827e1caa20d65a4f$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $827e1caa20d65a4f$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $827e1caa20d65a4f$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $827e1caa20d65a4f$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    const response = await $827e1caa20d65a4f$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $827e1caa20d65a4f$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $827e1caa20d65a4f$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $827e1caa20d65a4f$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $59fdd18afb377ad5$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $827e1caa20d65a4f$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($827e1caa20d65a4f$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $827e1caa20d65a4f$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    $827e1caa20d65a4f$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $827e1caa20d65a4f$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $827e1caa20d65a4f$var$extractProtocol(url);
    const { host: host, port: port } = $827e1caa20d65a4f$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $827e1caa20d65a4f$var$emitEmulatorWarning();
}
function $827e1caa20d65a4f$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $827e1caa20d65a4f$var$extractHostAndPort(url) {
    const protocol = $827e1caa20d65a4f$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $827e1caa20d65a4f$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $827e1caa20d65a4f$var$parsePort(port)
        };
    }
}
function $827e1caa20d65a4f$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $827e1caa20d65a4f$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $827e1caa20d65a4f$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $827e1caa20d65a4f$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $827e1caa20d65a4f$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $827e1caa20d65a4f$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $827e1caa20d65a4f$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$resetPassword(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
async function $827e1caa20d65a4f$var$updateEmailPassword(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $827e1caa20d65a4f$var$linkEmailPassword(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $827e1caa20d65a4f$var$applyActionCode$1(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$signInWithPassword(auth, request) {
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
async function $827e1caa20d65a4f$var$sendOobCode(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
async function $827e1caa20d65a4f$var$sendEmailVerification$1(auth, request) {
    return $827e1caa20d65a4f$var$sendOobCode(auth, request);
}
async function $827e1caa20d65a4f$var$sendPasswordResetEmail$1(auth, request) {
    return $827e1caa20d65a4f$var$sendOobCode(auth, request);
}
async function $827e1caa20d65a4f$var$sendSignInLinkToEmail$1(auth, request) {
    return $827e1caa20d65a4f$var$sendOobCode(auth, request);
}
async function $827e1caa20d65a4f$var$verifyAndChangeEmail(auth, request) {
    return $827e1caa20d65a4f$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$signInWithEmailLink$1(auth, request) {
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
async function $827e1caa20d65a4f$var$signInWithEmailLinkForLinking(auth, request) {
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $827e1caa20d65a4f$export$3a1a48c8f6ef640e extends $827e1caa20d65a4f$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $827e1caa20d65a4f$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $827e1caa20d65a4f$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $827e1caa20d65a4f$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $827e1caa20d65a4f$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $827e1caa20d65a4f$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $827e1caa20d65a4f$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $827e1caa20d65a4f$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $827e1caa20d65a4f$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$signInWithIdp(auth, request) {
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $827e1caa20d65a4f$export$a07804094c3ecf2d extends $827e1caa20d65a4f$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $827e1caa20d65a4f$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $827e1caa20d65a4f$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $bbec114f87dbfe2a$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $827e1caa20d65a4f$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $827e1caa20d65a4f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $827e1caa20d65a4f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $827e1caa20d65a4f$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $827e1caa20d65a4f$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $59fdd18afb377ad5$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$sendPhoneVerificationCode(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
async function $827e1caa20d65a4f$var$signInWithPhoneNumber$1(auth, request) {
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
async function $827e1caa20d65a4f$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $827e1caa20d65a4f$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $827e1caa20d65a4f$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $827e1caa20d65a4f$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, apiRequest), $827e1caa20d65a4f$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $827e1caa20d65a4f$export$3722cfe417b6ed86 extends $827e1caa20d65a4f$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $827e1caa20d65a4f$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $827e1caa20d65a4f$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $827e1caa20d65a4f$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $827e1caa20d65a4f$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $827e1caa20d65a4f$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $827e1caa20d65a4f$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $827e1caa20d65a4f$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $827e1caa20d65a4f$var$parseDeepLink(url) {
    const link = (0, $59fdd18afb377ad5$export$c1271ca4c8a70741)((0, $59fdd18afb377ad5$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $59fdd18afb377ad5$export$c1271ca4c8a70741)((0, $59fdd18afb377ad5$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $59fdd18afb377ad5$export$c1271ca4c8a70741)((0, $59fdd18afb377ad5$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $59fdd18afb377ad5$export$c1271ca4c8a70741)((0, $59fdd18afb377ad5$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $827e1caa20d65a4f$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $59fdd18afb377ad5$export$c1271ca4c8a70741)((0, $59fdd18afb377ad5$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $827e1caa20d65a4f$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $827e1caa20d65a4f$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $827e1caa20d65a4f$var$parseDeepLink(link);
        try {
            return new $827e1caa20d65a4f$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $827e1caa20d65a4f$export$3b513254972cfc9c(link) {
    return $827e1caa20d65a4f$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $827e1caa20d65a4f$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $827e1caa20d65a4f$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $827e1caa20d65a4f$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $827e1caa20d65a4f$export$f38c853ae54ed474.parseLink(emailLink);
        $827e1caa20d65a4f$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $827e1caa20d65a4f$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $827e1caa20d65a4f$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $827e1caa20d65a4f$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $827e1caa20d65a4f$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $827e1caa20d65a4f$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $827e1caa20d65a4f$var$BaseOAuthProvider extends $827e1caa20d65a4f$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $827e1caa20d65a4f$export$dc98b0b04f4c7758 extends $827e1caa20d65a4f$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $827e1caa20d65a4f$export$890c4ad488842ce7('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $827e1caa20d65a4f$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $827e1caa20d65a4f$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $827e1caa20d65a4f$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $827e1caa20d65a4f$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $827e1caa20d65a4f$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $827e1caa20d65a4f$export$71cec2538cb2c617 extends $827e1caa20d65a4f$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $827e1caa20d65a4f$export$a07804094c3ecf2d._fromParams({
            providerId: $827e1caa20d65a4f$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $827e1caa20d65a4f$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $827e1caa20d65a4f$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $827e1caa20d65a4f$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $827e1caa20d65a4f$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $827e1caa20d65a4f$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $827e1caa20d65a4f$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $827e1caa20d65a4f$export$78acf4525d8a74c4 extends $827e1caa20d65a4f$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $827e1caa20d65a4f$export$a07804094c3ecf2d._fromParams({
            providerId: $827e1caa20d65a4f$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $827e1caa20d65a4f$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $827e1caa20d65a4f$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $827e1caa20d65a4f$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $827e1caa20d65a4f$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $827e1caa20d65a4f$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $827e1caa20d65a4f$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $827e1caa20d65a4f$export$8743009a87fcb00f extends $827e1caa20d65a4f$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $827e1caa20d65a4f$export$a07804094c3ecf2d._fromParams({
            providerId: $827e1caa20d65a4f$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $827e1caa20d65a4f$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $827e1caa20d65a4f$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $827e1caa20d65a4f$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $827e1caa20d65a4f$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $827e1caa20d65a4f$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $827e1caa20d65a4f$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $827e1caa20d65a4f$export$f96d196f7728bb5 extends $827e1caa20d65a4f$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $827e1caa20d65a4f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $827e1caa20d65a4f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $827e1caa20d65a4f$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $827e1caa20d65a4f$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $827e1caa20d65a4f$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $827e1caa20d65a4f$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $827e1caa20d65a4f$export$71511d61b312f219 extends $827e1caa20d65a4f$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $827e1caa20d65a4f$export$890c4ad488842ce7(providerId.startsWith($827e1caa20d65a4f$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $827e1caa20d65a4f$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $827e1caa20d65a4f$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $827e1caa20d65a4f$export$f96d196f7728bb5.fromJSON(json);
        $827e1caa20d65a4f$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $827e1caa20d65a4f$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $827e1caa20d65a4f$export$3d8c2f653ac9d0b9 extends $827e1caa20d65a4f$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $827e1caa20d65a4f$export$a07804094c3ecf2d._fromParams({
            providerId: $827e1caa20d65a4f$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $827e1caa20d65a4f$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $827e1caa20d65a4f$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $827e1caa20d65a4f$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $827e1caa20d65a4f$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $827e1caa20d65a4f$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $827e1caa20d65a4f$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$signUp(auth, request) {
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $827e1caa20d65a4f$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $827e1caa20d65a4f$var$providerIdForResponse(idTokenResponse);
        const userCred = new $827e1caa20d65a4f$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $827e1caa20d65a4f$var$providerIdForResponse(response);
        return new $827e1caa20d65a4f$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $827e1caa20d65a4f$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $827e1caa20d65a4f$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $827e1caa20d65a4f$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $827e1caa20d65a4f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$MultiFactorError extends (0, $59fdd18afb377ad5$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $827e1caa20d65a4f$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $827e1caa20d65a4f$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $827e1caa20d65a4f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $827e1caa20d65a4f$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $827e1caa20d65a4f$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    await $827e1caa20d65a4f$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $827e1caa20d65a4f$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $827e1caa20d65a4f$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $827e1caa20d65a4f$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $827e1caa20d65a4f$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $827e1caa20d65a4f$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $827e1caa20d65a4f$var$_assertLinkedStatus(expected, user, provider) {
    await $827e1caa20d65a4f$var$_reloadWithoutSaving(user);
    const providerIds = $827e1caa20d65a4f$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $827e1caa20d65a4f$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $827e1caa20d65a4f$var$_logoutIfInvalidated(user, $827e1caa20d65a4f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $827e1caa20d65a4f$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $827e1caa20d65a4f$var$_parseToken(response.idToken);
        $827e1caa20d65a4f$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $827e1caa20d65a4f$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $827e1caa20d65a4f$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $827e1caa20d65a4f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $827e1caa20d65a4f$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$3c2fa207a37baaea(auth, credential) {
    return $827e1caa20d65a4f$var$_signInWithCredential($827e1caa20d65a4f$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    await $827e1caa20d65a4f$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $827e1caa20d65a4f$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$6559d589eb85fbb6(user, credential) {
    return $827e1caa20d65a4f$var$_reauthenticate((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$signInWithCustomToken$1(auth, request) {
    return $827e1caa20d65a4f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    const response = await $827e1caa20d65a4f$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $827e1caa20d65a4f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $827e1caa20d65a4f$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $827e1caa20d65a4f$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $827e1caa20d65a4f$var$PhoneMultiFactorInfoImpl extends $827e1caa20d65a4f$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $827e1caa20d65a4f$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $827e1caa20d65a4f$var$TotpMultiFactorInfoImpl extends $827e1caa20d65a4f$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $827e1caa20d65a4f$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $827e1caa20d65a4f$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $827e1caa20d65a4f$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $827e1caa20d65a4f$var$recachePasswordPolicy(auth) {
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $827e1caa20d65a4f$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $827e1caa20d65a4f$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $827e1caa20d65a4f$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $827e1caa20d65a4f$var$resetPassword((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $827e1caa20d65a4f$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$a93c5207d687da10(auth, oobCode) {
    await $827e1caa20d65a4f$var$applyActionCode$1((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth);
    const response = await $827e1caa20d65a4f$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $827e1caa20d65a4f$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $827e1caa20d65a4f$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $827e1caa20d65a4f$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $827e1caa20d65a4f$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $827e1caa20d65a4f$var$MultiFactorInfoImpl._fromServerResponse($827e1caa20d65a4f$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $827e1caa20d65a4f$export$c3950d9923825c02((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $827e1caa20d65a4f$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $827e1caa20d65a4f$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $827e1caa20d65a4f$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $827e1caa20d65a4f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $827e1caa20d65a4f$export$555508cbc6add439(auth, email, password) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $827e1caa20d65a4f$export$3c2fa207a37baaea((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth), $827e1caa20d65a4f$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $827e1caa20d65a4f$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $827e1caa20d65a4f$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $827e1caa20d65a4f$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $827e1caa20d65a4f$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $827e1caa20d65a4f$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $827e1caa20d65a4f$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth);
    const credential = $827e1caa20d65a4f$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $827e1caa20d65a4f$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $827e1caa20d65a4f$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $827e1caa20d65a4f$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$createAuthUri(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $827e1caa20d65a4f$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $827e1caa20d65a4f$var$_isHttpOrHttps() ? $827e1caa20d65a4f$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $827e1caa20d65a4f$var$createAuthUri((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $827e1caa20d65a4f$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $827e1caa20d65a4f$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $827e1caa20d65a4f$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $827e1caa20d65a4f$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$var$updateProfile$1(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $827e1caa20d65a4f$var$_logoutIfInvalidated(userInternal, $827e1caa20d65a4f$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $827e1caa20d65a4f$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $827e1caa20d65a4f$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $827e1caa20d65a4f$export$1a82df3d29112e01(user, newPassword) {
    return $827e1caa20d65a4f$var$updateEmailOrPassword((0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $827e1caa20d65a4f$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $827e1caa20d65a4f$var$_logoutIfInvalidated(user, $827e1caa20d65a4f$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $827e1caa20d65a4f$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $827e1caa20d65a4f$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $827e1caa20d65a4f$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $827e1caa20d65a4f$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $827e1caa20d65a4f$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $827e1caa20d65a4f$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $827e1caa20d65a4f$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $827e1caa20d65a4f$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $827e1caa20d65a4f$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $827e1caa20d65a4f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $827e1caa20d65a4f$var$FederatedAdditionalUserInfoWithUsername extends $827e1caa20d65a4f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $827e1caa20d65a4f$var$FacebookAdditionalUserInfo extends $827e1caa20d65a4f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $827e1caa20d65a4f$var$GithubAdditionalUserInfo extends $827e1caa20d65a4f$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $827e1caa20d65a4f$var$GoogleAdditionalUserInfo extends $827e1caa20d65a4f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $827e1caa20d65a4f$var$TwitterAdditionalUserInfo extends $827e1caa20d65a4f$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $827e1caa20d65a4f$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $827e1caa20d65a4f$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $827e1caa20d65a4f$export$9e5f44173e64f162(auth, persistence) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $827e1caa20d65a4f$export$625550452a3fa3ec(auth) {
    return $827e1caa20d65a4f$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$90a7f3efeed30595(auth, password) {
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $827e1caa20d65a4f$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $827e1caa20d65a4f$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $827e1caa20d65a4f$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $827e1caa20d65a4f$export$df995fae86a55f06(auth) {
    (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $827e1caa20d65a4f$export$ef35774e6d314e91(auth, user) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $827e1caa20d65a4f$export$e7094788287c5e9b(auth) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $827e1caa20d65a4f$export$96f57966bedc81b4(auth, token) {
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$a9c23c6ac3fc3eca(user) {
    return (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $827e1caa20d65a4f$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $827e1caa20d65a4f$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $827e1caa20d65a4f$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $827e1caa20d65a4f$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $827e1caa20d65a4f$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$827e1caa20d65a4f$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $827e1caa20d65a4f$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $827e1caa20d65a4f$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $827e1caa20d65a4f$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $827e1caa20d65a4f$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $827e1caa20d65a4f$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $827e1caa20d65a4f$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $827e1caa20d65a4f$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $827e1caa20d65a4f$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $827e1caa20d65a4f$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $827e1caa20d65a4f$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$startEnrollPhoneMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
function $827e1caa20d65a4f$var$finalizeEnrollPhoneMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
function $827e1caa20d65a4f$var$startEnrollTotpMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
function $827e1caa20d65a4f$var$finalizeEnrollTotpMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
function $827e1caa20d65a4f$var$withdrawMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
class $827e1caa20d65a4f$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$827e1caa20d65a4f$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $827e1caa20d65a4f$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $827e1caa20d65a4f$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $827e1caa20d65a4f$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $827e1caa20d65a4f$var$_logoutIfInvalidated(this.user, $827e1caa20d65a4f$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $827e1caa20d65a4f$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $827e1caa20d65a4f$export$493d36ec626b6698(user) {
    const userModular = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    if (!$827e1caa20d65a4f$var$multiFactorUserCache.has(userModular)) $827e1caa20d65a4f$var$multiFactorUserCache.set(userModular, $827e1caa20d65a4f$var$MultiFactorUserImpl._fromUser(userModular));
    return $827e1caa20d65a4f$var$multiFactorUserCache.get(userModular);
}
const $827e1caa20d65a4f$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $827e1caa20d65a4f$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($827e1caa20d65a4f$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($827e1caa20d65a4f$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)();
    return $827e1caa20d65a4f$var$_isSafari(ua) || $827e1caa20d65a4f$export$d66dc83d8cfc8dd(ua);
}
// The polling period in case events are not supported
const $827e1caa20d65a4f$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $827e1caa20d65a4f$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $827e1caa20d65a4f$var$BrowserLocalPersistence extends $827e1caa20d65a4f$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $827e1caa20d65a4f$var$_iframeCannotSyncWebStorage() && $827e1caa20d65a4f$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $827e1caa20d65a4f$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($827e1caa20d65a4f$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $827e1caa20d65a4f$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $827e1caa20d65a4f$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$827e1caa20d65a4f$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $827e1caa20d65a4f$export$8b22cf2602fb60ce = $827e1caa20d65a4f$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$BrowserSessionPersistence extends $827e1caa20d65a4f$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$827e1caa20d65a4f$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $827e1caa20d65a4f$export$407448d2b89b1813 = $827e1caa20d65a4f$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $827e1caa20d65a4f$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $827e1caa20d65a4f$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $827e1caa20d65a4f$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $827e1caa20d65a4f$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$827e1caa20d65a4f$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$export$faec65b429be379(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $827e1caa20d65a4f$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $827e1caa20d65a4f$export$faec65b429be379('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $827e1caa20d65a4f$var$_window() {
    return window;
}
function $827e1caa20d65a4f$var$_setWindowLocation(url) {
    $827e1caa20d65a4f$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$_isWorker() {
    return typeof $827e1caa20d65a4f$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $827e1caa20d65a4f$var$_window()['importScripts'] === 'function';
}
async function $827e1caa20d65a4f$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $827e1caa20d65a4f$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $827e1caa20d65a4f$var$_getWorkerGlobalScope() {
    return $827e1caa20d65a4f$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$DB_NAME = 'firebaseLocalStorageDb';
const $827e1caa20d65a4f$var$DB_VERSION = 1;
const $827e1caa20d65a4f$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $827e1caa20d65a4f$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $827e1caa20d65a4f$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $827e1caa20d65a4f$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $827e1caa20d65a4f$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($827e1caa20d65a4f$var$DB_OBJECTSTORE_NAME);
}
function $827e1caa20d65a4f$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($827e1caa20d65a4f$var$DB_NAME);
    return new $827e1caa20d65a4f$var$DBPromise(request).toPromise();
}
function $827e1caa20d65a4f$var$_openDatabase() {
    const request = indexedDB.open($827e1caa20d65a4f$var$DB_NAME, $827e1caa20d65a4f$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($827e1caa20d65a4f$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $827e1caa20d65a4f$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($827e1caa20d65a4f$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $827e1caa20d65a4f$var$_deleteDatabase();
                resolve(await $827e1caa20d65a4f$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $827e1caa20d65a4f$var$_putObject(db, key, value) {
    const request = $827e1caa20d65a4f$var$getObjectStore(db, true).put({
        [$827e1caa20d65a4f$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $827e1caa20d65a4f$var$DBPromise(request).toPromise();
}
async function $827e1caa20d65a4f$var$getObject(db, key) {
    const request = $827e1caa20d65a4f$var$getObjectStore(db, false).get(key);
    const data = await new $827e1caa20d65a4f$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $827e1caa20d65a4f$var$_deleteObject(db, key) {
    const request = $827e1caa20d65a4f$var$getObjectStore(db, true).delete(key);
    return new $827e1caa20d65a4f$var$DBPromise(request).toPromise();
}
const $827e1caa20d65a4f$var$_POLLING_INTERVAL_MS = 800;
const $827e1caa20d65a4f$var$_TRANSACTION_RETRY_COUNT = 3;
class $827e1caa20d65a4f$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $827e1caa20d65a4f$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $827e1caa20d65a4f$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $827e1caa20d65a4f$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $827e1caa20d65a4f$var$Receiver._getInstance($827e1caa20d65a4f$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $827e1caa20d65a4f$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $827e1caa20d65a4f$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $827e1caa20d65a4f$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $827e1caa20d65a4f$var$_openDatabase();
            await $827e1caa20d65a4f$var$_putObject(db, $827e1caa20d65a4f$var$STORAGE_AVAILABLE_KEY, '1');
            await $827e1caa20d65a4f$var$_deleteObject(db, $827e1caa20d65a4f$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$827e1caa20d65a4f$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$827e1caa20d65a4f$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$827e1caa20d65a4f$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $827e1caa20d65a4f$var$getObjectStore(db, false).getAll();
            return new $827e1caa20d65a4f$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $827e1caa20d65a4f$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$827e1caa20d65a4f$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $827e1caa20d65a4f$export$23f2a1d2818174ef = $827e1caa20d65a4f$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$startSignInPhoneMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
function $827e1caa20d65a4f$var$finalizeSignInPhoneMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
function $827e1caa20d65a4f$var$finalizeSignInTotpMfa(auth, request) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $827e1caa20d65a4f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$_SOLVE_TIME_MS = 500;
const $827e1caa20d65a4f$var$_EXPIRATION_TIME_MS = 60000;
const $827e1caa20d65a4f$var$_WIDGET_ID_START = 1000000000000;
class $827e1caa20d65a4f$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $827e1caa20d65a4f$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $827e1caa20d65a4f$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $827e1caa20d65a4f$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $827e1caa20d65a4f$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $827e1caa20d65a4f$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class $827e1caa20d65a4f$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $827e1caa20d65a4f$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $827e1caa20d65a4f$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $827e1caa20d65a4f$var$_EXPIRATION_TIME_MS);
        }, $827e1caa20d65a4f$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $827e1caa20d65a4f$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $827e1caa20d65a4f$var$_JSLOAD_CALLBACK = $827e1caa20d65a4f$var$_generateCallbackName('rcb');
const $827e1caa20d65a4f$var$NETWORK_TIMEOUT_DELAY = new $827e1caa20d65a4f$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $827e1caa20d65a4f$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $827e1caa20d65a4f$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        $827e1caa20d65a4f$export$890c4ad488842ce7($827e1caa20d65a4f$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $827e1caa20d65a4f$var$isV2($827e1caa20d65a4f$var$_window().grecaptcha)) return Promise.resolve($827e1caa20d65a4f$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $827e1caa20d65a4f$var$_window().setTimeout(()=>{
                reject($827e1caa20d65a4f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $827e1caa20d65a4f$var$NETWORK_TIMEOUT_DELAY.get());
            $827e1caa20d65a4f$var$_window()[$827e1caa20d65a4f$var$_JSLOAD_CALLBACK] = ()=>{
                $827e1caa20d65a4f$var$_window().clearTimeout(networkTimeout);
                delete $827e1caa20d65a4f$var$_window()[$827e1caa20d65a4f$var$_JSLOAD_CALLBACK];
                const recaptcha = $827e1caa20d65a4f$var$_window().grecaptcha;
                if (!recaptcha || !$827e1caa20d65a4f$var$isV2(recaptcha)) {
                    reject($827e1caa20d65a4f$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$827e1caa20d65a4f$var$_recaptchaV2ScriptUrl()}?${(0, $59fdd18afb377ad5$export$ac4103b836844853)({
                onload: $827e1caa20d65a4f$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $827e1caa20d65a4f$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($827e1caa20d65a4f$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $827e1caa20d65a4f$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $827e1caa20d65a4f$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $827e1caa20d65a4f$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $827e1caa20d65a4f$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $827e1caa20d65a4f$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $827e1caa20d65a4f$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $827e1caa20d65a4f$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $827e1caa20d65a4f$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $827e1caa20d65a4f$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $827e1caa20d65a4f$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $827e1caa20d65a4f$var$MockReCaptchaLoaderImpl() : new $827e1caa20d65a4f$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $827e1caa20d65a4f$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $827e1caa20d65a4f$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $827e1caa20d65a4f$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $827e1caa20d65a4f$export$890c4ad488842ce7($827e1caa20d65a4f$var$_isHttpOrHttps() && !$827e1caa20d65a4f$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $827e1caa20d65a4f$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $827e1caa20d65a4f$var$getRecaptchaParams(this.auth);
        $827e1caa20d65a4f$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $827e1caa20d65a4f$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $827e1caa20d65a4f$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    const verificationId = await $827e1caa20d65a4f$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(appVerifier));
    return new $827e1caa20d65a4f$var$ConfirmationResultImpl(verificationId, (cred)=>$827e1caa20d65a4f$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    await $827e1caa20d65a4f$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $827e1caa20d65a4f$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(appVerifier));
    return new $827e1caa20d65a4f$var$ConfirmationResultImpl(verificationId, (cred)=>$827e1caa20d65a4f$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $827e1caa20d65a4f$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(appVerifier));
    return new $827e1caa20d65a4f$var$ConfirmationResultImpl(verificationId, (cred)=>$827e1caa20d65a4f$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $827e1caa20d65a4f$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof recaptchaToken === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $827e1caa20d65a4f$export$890c4ad488842ce7(verifier.type === $827e1caa20d65a4f$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $827e1caa20d65a4f$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $827e1caa20d65a4f$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $827e1caa20d65a4f$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $827e1caa20d65a4f$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $827e1caa20d65a4f$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $827e1caa20d65a4f$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $827e1caa20d65a4f$var$_link$1(userInternal, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $827e1caa20d65a4f$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $827e1caa20d65a4f$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $827e1caa20d65a4f$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $827e1caa20d65a4f$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $827e1caa20d65a4f$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $827e1caa20d65a4f$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $827e1caa20d65a4f$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $827e1caa20d65a4f$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $827e1caa20d65a4f$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $827e1caa20d65a4f$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $827e1caa20d65a4f$export$158acd800e1ef08b(resolverOverride);
    $827e1caa20d65a4f$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$IdpCredential extends $827e1caa20d65a4f$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $827e1caa20d65a4f$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $827e1caa20d65a4f$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $827e1caa20d65a4f$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $827e1caa20d65a4f$var$_signIn(params) {
    return $827e1caa20d65a4f$var$_signInWithCredential(params.auth, new $827e1caa20d65a4f$var$IdpCredential(params), params.bypassAuthState);
}
function $827e1caa20d65a4f$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $827e1caa20d65a4f$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $827e1caa20d65a4f$var$_reauthenticate(user, new $827e1caa20d65a4f$var$IdpCredential(params), params.bypassAuthState);
}
async function $827e1caa20d65a4f$var$_link(params) {
    const { auth: auth, user: user } = params;
    $827e1caa20d65a4f$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $827e1caa20d65a4f$var$_link$1(user, new $827e1caa20d65a4f$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $827e1caa20d65a4f$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $827e1caa20d65a4f$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $827e1caa20d65a4f$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $827e1caa20d65a4f$var$_reauth;
            default:
                $827e1caa20d65a4f$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $827e1caa20d65a4f$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $827e1caa20d65a4f$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $827e1caa20d65a4f$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    $827e1caa20d65a4f$var$_assertInstanceOf(auth, provider, $827e1caa20d65a4f$var$FederatedAuthProvider);
    const resolverInternal = $827e1caa20d65a4f$var$_withDefaultResolver(authInternal, resolver);
    const action = new $827e1caa20d65a4f$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($827e1caa20d65a4f$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $827e1caa20d65a4f$var$_assertInstanceOf(userInternal.auth, provider, $827e1caa20d65a4f$var$FederatedAuthProvider);
    const resolverInternal = $827e1caa20d65a4f$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $827e1caa20d65a4f$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    $827e1caa20d65a4f$var$_assertInstanceOf(userInternal.auth, provider, $827e1caa20d65a4f$var$FederatedAuthProvider);
    const resolverInternal = $827e1caa20d65a4f$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $827e1caa20d65a4f$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $827e1caa20d65a4f$var$PopupOperation extends $827e1caa20d65a4f$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($827e1caa20d65a4f$var$PopupOperation.currentPopupAction) $827e1caa20d65a4f$var$PopupOperation.currentPopupAction.cancel();
        $827e1caa20d65a4f$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $827e1caa20d65a4f$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $827e1caa20d65a4f$export$1fbe638ecf81657e(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $827e1caa20d65a4f$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($827e1caa20d65a4f$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($827e1caa20d65a4f$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $827e1caa20d65a4f$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($827e1caa20d65a4f$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $827e1caa20d65a4f$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$827e1caa20d65a4f$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $827e1caa20d65a4f$var$redirectOutcomeMap = new Map();
class $827e1caa20d65a4f$var$RedirectAction extends $827e1caa20d65a4f$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $827e1caa20d65a4f$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $827e1caa20d65a4f$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $827e1caa20d65a4f$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $827e1caa20d65a4f$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $827e1caa20d65a4f$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $827e1caa20d65a4f$var$pendingRedirectKey(auth);
    const persistence = $827e1caa20d65a4f$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $827e1caa20d65a4f$var$_setPendingRedirectStatus(resolver, auth) {
    return $827e1caa20d65a4f$var$resolverPersistence(resolver)._set($827e1caa20d65a4f$var$pendingRedirectKey(auth), 'true');
}
function $827e1caa20d65a4f$export$b9a6b53f9be3734() {
    $827e1caa20d65a4f$var$redirectOutcomeMap.clear();
}
function $827e1caa20d65a4f$export$a33b77bbdbb8366c(auth, result) {
    $827e1caa20d65a4f$var$redirectOutcomeMap.set(auth._key(), result);
}
function $827e1caa20d65a4f$var$resolverPersistence(resolver) {
    return $827e1caa20d65a4f$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $827e1caa20d65a4f$var$pendingRedirectKey(auth) {
    return $827e1caa20d65a4f$export$cf2f7c5792f80b46($827e1caa20d65a4f$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $827e1caa20d65a4f$export$2d1720544b23b823(auth, provider, resolver) {
    return $827e1caa20d65a4f$var$_signInWithRedirect(auth, provider, resolver);
}
async function $827e1caa20d65a4f$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    $827e1caa20d65a4f$var$_assertInstanceOf(auth, provider, $827e1caa20d65a4f$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $827e1caa20d65a4f$var$_withDefaultResolver(authInternal, resolver);
    await $827e1caa20d65a4f$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $827e1caa20d65a4f$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $827e1caa20d65a4f$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $827e1caa20d65a4f$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    $827e1caa20d65a4f$var$_assertInstanceOf(userInternal.auth, provider, $827e1caa20d65a4f$var$FederatedAuthProvider);
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $827e1caa20d65a4f$var$_withDefaultResolver(userInternal.auth, resolver);
    await $827e1caa20d65a4f$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $827e1caa20d65a4f$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $827e1caa20d65a4f$export$39b482c5e57630a8(user, provider, resolver) {
    return $827e1caa20d65a4f$var$_linkWithRedirect(user, provider, resolver);
}
async function $827e1caa20d65a4f$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $59fdd18afb377ad5$export$4befe9b5fa509a1b)(user);
    $827e1caa20d65a4f$var$_assertInstanceOf(userInternal.auth, provider, $827e1caa20d65a4f$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $827e1caa20d65a4f$var$_withDefaultResolver(userInternal.auth, resolver);
    await $827e1caa20d65a4f$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $827e1caa20d65a4f$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $827e1caa20d65a4f$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $827e1caa20d65a4f$export$35e795649ee09318(auth, resolver) {
    await $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $827e1caa20d65a4f$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $827e1caa20d65a4f$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $6de42d4eacc8610d$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($827e1caa20d65a4f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $827e1caa20d65a4f$export$a05254e7c3aeba6e(auth);
    const resolver = $827e1caa20d65a4f$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $827e1caa20d65a4f$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $827e1caa20d65a4f$var$prepareUserForRedirect(user) {
    const eventId = $827e1caa20d65a4f$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $827e1caa20d65a4f$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $827e1caa20d65a4f$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$827e1caa20d65a4f$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$827e1caa20d65a4f$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($827e1caa20d65a4f$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $827e1caa20d65a4f$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($827e1caa20d65a4f$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($827e1caa20d65a4f$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $827e1caa20d65a4f$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $827e1caa20d65a4f$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $827e1caa20d65a4f$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $827e1caa20d65a4f$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $827e1caa20d65a4f$export$3d12bd131bb975d1(auth, request = {}) {
    return $827e1caa20d65a4f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $827e1caa20d65a4f$var$HTTP_REGEX = /^https?/;
async function $827e1caa20d65a4f$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $827e1caa20d65a4f$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($827e1caa20d65a4f$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $827e1caa20d65a4f$var$matchDomain(expected) {
    const currentUrl = $827e1caa20d65a4f$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$827e1caa20d65a4f$var$HTTP_REGEX.test(protocol)) return false;
    if ($827e1caa20d65a4f$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$NETWORK_TIMEOUT = new $827e1caa20d65a4f$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $827e1caa20d65a4f$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $827e1caa20d65a4f$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $827e1caa20d65a4f$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $827e1caa20d65a4f$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $827e1caa20d65a4f$var$resetUnloadedGapiModules();
                    reject($827e1caa20d65a4f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $827e1caa20d65a4f$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $827e1caa20d65a4f$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $827e1caa20d65a4f$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $827e1caa20d65a4f$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $827e1caa20d65a4f$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($827e1caa20d65a4f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $827e1caa20d65a4f$var$_loadJS(`${$827e1caa20d65a4f$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $827e1caa20d65a4f$var$cachedGApiLoader = null;
        throw error;
    });
}
let $827e1caa20d65a4f$var$cachedGApiLoader = null;
function $827e1caa20d65a4f$var$_loadGapi(auth) {
    $827e1caa20d65a4f$var$cachedGApiLoader = $827e1caa20d65a4f$var$cachedGApiLoader || $827e1caa20d65a4f$var$loadGapi(auth);
    return $827e1caa20d65a4f$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$PING_TIMEOUT = new $827e1caa20d65a4f$var$Delay(5000, 15000);
const $827e1caa20d65a4f$var$IFRAME_PATH = '__/auth/iframe';
const $827e1caa20d65a4f$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $827e1caa20d65a4f$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $827e1caa20d65a4f$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $827e1caa20d65a4f$var$getIframeUrl(auth) {
    const config = auth.config;
    $827e1caa20d65a4f$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $827e1caa20d65a4f$var$_emulatorUrl(config, $827e1caa20d65a4f$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$827e1caa20d65a4f$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $6de42d4eacc8610d$export$31499a9cd224b78c)
    };
    const eid = $827e1caa20d65a4f$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $59fdd18afb377ad5$export$ac4103b836844853)(params).slice(1)}`;
}
async function $827e1caa20d65a4f$var$_openIframe(auth) {
    const context = await $827e1caa20d65a4f$var$_loadGapi(auth);
    const gapi1 = $827e1caa20d65a4f$var$_window().gapi;
    $827e1caa20d65a4f$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $827e1caa20d65a4f$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $827e1caa20d65a4f$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $827e1caa20d65a4f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $827e1caa20d65a4f$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $827e1caa20d65a4f$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $827e1caa20d65a4f$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $827e1caa20d65a4f$var$DEFAULT_WIDTH = 500;
const $827e1caa20d65a4f$var$DEFAULT_HEIGHT = 600;
const $827e1caa20d65a4f$var$TARGET_BLANK = '_blank';
const $827e1caa20d65a4f$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $827e1caa20d65a4f$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $827e1caa20d65a4f$var$_open(auth, url, name, width = $827e1caa20d65a4f$var$DEFAULT_WIDTH, height = $827e1caa20d65a4f$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, $827e1caa20d65a4f$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $59fdd18afb377ad5$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $827e1caa20d65a4f$var$_isChromeIOS(ua) ? $827e1caa20d65a4f$var$TARGET_BLANK : name;
    if ($827e1caa20d65a4f$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $827e1caa20d65a4f$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($827e1caa20d65a4f$var$_isIOSStandalone(ua) && target !== '_self') {
        $827e1caa20d65a4f$var$openAsNewWindowIOS(url || '', target);
        return new $827e1caa20d65a4f$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $827e1caa20d65a4f$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $827e1caa20d65a4f$export$c03999cb2f36933f(newWin);
}
function $827e1caa20d65a4f$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $827e1caa20d65a4f$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $827e1caa20d65a4f$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $827e1caa20d65a4f$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $827e1caa20d65a4f$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $827e1caa20d65a4f$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $827e1caa20d65a4f$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $6de42d4eacc8610d$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $827e1caa20d65a4f$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $59fdd18afb377ad5$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $827e1caa20d65a4f$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$827e1caa20d65a4f$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$827e1caa20d65a4f$var$getHandlerBase(auth)}?${(0, $59fdd18afb377ad5$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $827e1caa20d65a4f$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$827e1caa20d65a4f$var$WIDGET_PATH}`;
    return $827e1caa20d65a4f$var$_emulatorUrl(config, $827e1caa20d65a4f$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $827e1caa20d65a4f$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $827e1caa20d65a4f$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $827e1caa20d65a4f$export$407448d2b89b1813;
        this._completeRedirectFn = $827e1caa20d65a4f$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $827e1caa20d65a4f$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $827e1caa20d65a4f$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await $827e1caa20d65a4f$export$28f7fcd39efa255(auth, provider, authType, $827e1caa20d65a4f$var$_getCurrentUrl(), eventId);
        return $827e1caa20d65a4f$var$_open(auth, url, $827e1caa20d65a4f$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $827e1caa20d65a4f$export$28f7fcd39efa255(auth, provider, authType, $827e1caa20d65a4f$var$_getCurrentUrl(), eventId);
        $827e1caa20d65a4f$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $827e1caa20d65a4f$export$1fbe638ecf81657e(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $827e1caa20d65a4f$var$_openIframe(auth);
        const manager = new $827e1caa20d65a4f$export$24baa2b76016ce0e(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $827e1caa20d65a4f$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($827e1caa20d65a4f$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $827e1caa20d65a4f$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$827e1caa20d65a4f$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $827e1caa20d65a4f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $827e1caa20d65a4f$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $827e1caa20d65a4f$var$_isMobileBrowser() || $827e1caa20d65a4f$var$_isSafari() || $827e1caa20d65a4f$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $827e1caa20d65a4f$export$342063e11d6c3cad = $827e1caa20d65a4f$var$BrowserPopupRedirectResolver;
class $827e1caa20d65a4f$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $827e1caa20d65a4f$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $827e1caa20d65a4f$var$PhoneMultiFactorAssertionImpl extends $827e1caa20d65a4f$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $827e1caa20d65a4f$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $827e1caa20d65a4f$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $827e1caa20d65a4f$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $827e1caa20d65a4f$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $827e1caa20d65a4f$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $827e1caa20d65a4f$export$953cecd6e717a553.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $827e1caa20d65a4f$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $827e1caa20d65a4f$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $827e1caa20d65a4f$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $827e1caa20d65a4f$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $827e1caa20d65a4f$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $827e1caa20d65a4f$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $827e1caa20d65a4f$var$TotpMultiFactorAssertionImpl extends $827e1caa20d65a4f$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $827e1caa20d65a4f$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $827e1caa20d65a4f$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $827e1caa20d65a4f$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $827e1caa20d65a4f$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $827e1caa20d65a4f$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $827e1caa20d65a4f$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($827e1caa20d65a4f$var$_isEmptyString(accountName) || $827e1caa20d65a4f$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($827e1caa20d65a4f$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if ($827e1caa20d65a4f$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $827e1caa20d65a4f$var$_isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $827e1caa20d65a4f$var$name = "@firebase/auth";
var $827e1caa20d65a4f$var$version = "1.7.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $827e1caa20d65a4f$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $827e1caa20d65a4f$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $827e1caa20d65a4f$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $827e1caa20d65a4f$var$registerAuth(clientPlatform) {
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $827e1caa20d65a4f$export$890c4ad488842ce7(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $827e1caa20d65a4f$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $827e1caa20d65a4f$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $827e1caa20d65a4f$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $6de42d4eacc8610d$export$c930050e7bb63965)(new (0, $35aa09327d546cd1$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $827e1caa20d65a4f$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $827e1caa20d65a4f$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($827e1caa20d65a4f$var$name, $827e1caa20d65a4f$var$version, $827e1caa20d65a4f$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $6de42d4eacc8610d$export$d29d5299a7137abc)($827e1caa20d65a4f$var$name, $827e1caa20d65a4f$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $827e1caa20d65a4f$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $827e1caa20d65a4f$var$authIdTokenMaxAge = (0, $59fdd18afb377ad5$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $827e1caa20d65a4f$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $827e1caa20d65a4f$var$lastPostedIdToken = null;
const $827e1caa20d65a4f$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $827e1caa20d65a4f$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($827e1caa20d65a4f$var$lastPostedIdToken === idToken) return;
        $827e1caa20d65a4f$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $827e1caa20d65a4f$export$ae1af26003f05816(app = (0, $6de42d4eacc8610d$export$f9962582c9e66d99)()) {
    const provider = (0, $6de42d4eacc8610d$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $827e1caa20d65a4f$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $827e1caa20d65a4f$export$342063e11d6c3cad,
        persistence: [
            $827e1caa20d65a4f$export$23f2a1d2818174ef,
            $827e1caa20d65a4f$export$8b22cf2602fb60ce,
            $827e1caa20d65a4f$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $59fdd18afb377ad5$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $827e1caa20d65a4f$var$mintCookieFactory(authTokenSyncUrl.toString());
            $827e1caa20d65a4f$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $827e1caa20d65a4f$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $59fdd18afb377ad5$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $827e1caa20d65a4f$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $827e1caa20d65a4f$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$827e1caa20d65a4f$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $827e1caa20d65a4f$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $827e1caa20d65a4f$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$827e1caa20d65a4f$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );













const $add0fd9ad07e71af$export$b4ae2c1c09f3f2c6 = (0, $827e1caa20d65a4f$export$ae1af26003f05816)((0, $f335ccce9ceac24d$export$a4e2c8f07e884e));
if ((0, $22fc247a044a5f09$export$26cc430c2fed42ce).env == (0, $18313decae4d52e6$export$6c0517834721cef7).local) {
    console.log(` hello Connecting to local auth emulator`);
    (0, $827e1caa20d65a4f$export$3466f893ebf79586)($add0fd9ad07e71af$export$b4ae2c1c09f3f2c6, "http://127.0.0.1:9099");
}





/**
 * Firestore is also considered as integration as it helps a lot in testing
 */ 


/**
 *
 * @param path This API does not work with keys, instead the path to the document or the collection in firestore should be provided
 * @returns
 */ const $6715d74da7b8c638$var$documentRef = (path)=>{
    return (0, $fd179abe7398b4e4$export$2a111da947c407d2)((0, $bf4d77e47da3054e$export$731deabbf6f6c2d9), path);
};
const $6715d74da7b8c638$var$collectionRef = (path)=>{
    return (0, $fd179abe7398b4e4$export$bf5175b0c24981cd)((0, $bf4d77e47da3054e$export$731deabbf6f6c2d9), path);
};
const $6715d74da7b8c638$var$getDoc = async (path)=>{
    const document = await (0, $fd179abe7398b4e4$export$11eb3b5ef9574821)($6715d74da7b8c638$var$documentRef(path));
    if (document.exists()) return document.data();
    return null;
};
const $6715d74da7b8c638$var$setDoc = async (path, obj, opts)=>{
    const safeObj = (0, $dbd8b3c7b3311df5$export$e103312118435c5d)(obj);
    return (0, $fd179abe7398b4e4$export$5ff77ddaff3c9e12)($6715d74da7b8c638$var$documentRef(path), safeObj, opts ?? {});
};
const $6715d74da7b8c638$var$mergeDoc = async (path, obj)=>{
    const safeObj = (0, $dbd8b3c7b3311df5$export$e103312118435c5d)(obj);
    return (0, $fd179abe7398b4e4$export$5ff77ddaff3c9e12)($6715d74da7b8c638$var$documentRef(path), safeObj, {
        merge: true
    });
};
const $6715d74da7b8c638$var$deleteDoc = async (path)=>{
    return (0, $fd179abe7398b4e4$export$a4f20481fae8f78b)($6715d74da7b8c638$var$documentRef(path));
};
// https://firebase.google.com/docs/firestore/query-data/queries
const $6715d74da7b8c638$var$page = async (args)=>{
    //
    const { path: path, orderByField: orderByField, orderByDirection: orderByDirection, limit: limit = 100, cursor: cursor, where: where } = args;
    // create query
    let query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)($6715d74da7b8c638$var$collectionRef(path), (0, $fd179abe7398b4e4$export$f18af21d6f4dafd8)(orderByField, orderByDirection), (0, $fd179abe7398b4e4$export$ee37e834aaad6f7e)(limit));
    // cursor
    if (cursor) query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)(query, (0, $fd179abe7398b4e4$export$dd8dee5f7b804673)(cursor));
    // where clause and the value is defined
    if (where) {
        if (where.length > 3) {
            console.error(`Cannot have more than 3 items in where clause, please remodel the data to be more optimistic for querying.`);
            return {
                list: [],
                cursor: null
            };
        }
        for (const w of where)if (w && (0, $46735892604b37f3$export$4e62c701997796c1)(w[2])) query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)(query, (0, $fd179abe7398b4e4$export$9c59b80dda569a6e)(w[0], w[1], w[2]));
    }
    // get snapshot
    const snapshot = await (0, $fd179abe7398b4e4$export$81d3477bd73c86ef)(query);
    // empty list
    if (snapshot.empty) return {
        list: [],
        cursor: null
    };
    // return without cursor
    const list = snapshot.docs.map((doc)=>doc.data());
    if (snapshot.size < limit) return {
        list: list,
        cursor: null
    };
    // return with cursor
    return {
        list: list,
        cursor: snapshot.docs[snapshot.docs.length - 1]
    };
};
const $6715d74da7b8c638$var$query = async (args)=>{
    //
    const { path: path, orderByField: orderByField, orderByDirection: orderByDirection, where: where } = args;
    // set max limit
    const limit = args.limit && args.limit < 20 ? args.limit : 20;
    // create query
    let query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)($6715d74da7b8c638$var$collectionRef(path), (0, $fd179abe7398b4e4$export$f18af21d6f4dafd8)(orderByField, orderByDirection), (0, $fd179abe7398b4e4$export$ee37e834aaad6f7e)(limit));
    // where clause and the value is defined
    if (where) {
        if (where.length > 3) {
            console.error(`Cannot have more than 3 items in where clause, please remodel the data to be more optimistic for querying.`);
            return;
        }
        for (const w of where)if (w && (0, $46735892604b37f3$export$4e62c701997796c1)(w[2])) query = (0, $fd179abe7398b4e4$export$2fa187e846a241c4)(query, (0, $fd179abe7398b4e4$export$9c59b80dda569a6e)(w[0], w[1], w[2]));
    }
    // get snapshot
    const snapshot = await (0, $fd179abe7398b4e4$export$81d3477bd73c86ef)(query);
    if (snapshot.empty) return;
    return snapshot.docs.map((doc)=>doc.data());
};
const $6715d74da7b8c638$var$countAll = async (args)=>{
    //
    const { path: path } = args;
    let snapshot = await (0, $fd179abe7398b4e4$export$b1de1b12889d0afb)($6715d74da7b8c638$var$collectionRef(path));
    return snapshot.data().count;
};
const $6715d74da7b8c638$export$abf9d8f0eb83ad0 = {
    documentRef: $6715d74da7b8c638$var$documentRef,
    collectionRef: $6715d74da7b8c638$var$collectionRef,
    getDoc: $6715d74da7b8c638$var$getDoc,
    setDoc: $6715d74da7b8c638$var$setDoc,
    mergeDoc: $6715d74da7b8c638$var$mergeDoc,
    deleteDoc: $6715d74da7b8c638$var$deleteDoc,
    page: $6715d74da7b8c638$var$page,
    query: $6715d74da7b8c638$var$query,
    countAll: $6715d74da7b8c638$var$countAll
};




const $20aadb388675cc69$var$provider = new (0, $827e1caa20d65a4f$export$78acf4525d8a74c4)();
$20aadb388675cc69$var$provider.setCustomParameters({
    prompt: "select_account "
});
const $20aadb388675cc69$export$4118493e57cd9489 = ()=>(0, $827e1caa20d65a4f$export$db3b6bfb95261072)((0, $add0fd9ad07e71af$export$b4ae2c1c09f3f2c6), $20aadb388675cc69$var$provider);




const $7a4e386e8653215f$var$microsoftProvider = new (0, $827e1caa20d65a4f$export$dc98b0b04f4c7758)("microsoft.com");
$7a4e386e8653215f$var$microsoftProvider.setCustomParameters({
    prompt: "select_account"
});
const $7a4e386e8653215f$export$9af0e352c79e17a4 = ()=>(0, $827e1caa20d65a4f$export$db3b6bfb95261072)((0, $add0fd9ad07e71af$export$b4ae2c1c09f3f2c6), $7a4e386e8653215f$var$microsoftProvider);







const $64075845ae8c3191$export$8e8b1a498b02721a = (setState)=>{
    return (partial)=>{
        setState((prev)=>({
                ...prev,
                ...partial
            }));
    };
};



var $lldlC = parcelRequire("lldlC");
const $30152c02d8e9517a$export$f0dc76b03756ac7e = ()=>{
    const [browser, setBrowser] = (0, $lldlC.useState)(false);
    (0, $lldlC.useEffect)(()=>setBrowser(true), []);
    return browser;
};





var $lldlC = parcelRequire("lldlC");

const $ce8af0d64a5e8b97$export$cae1c58733dbe1ed = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "notification",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "title",
                children: props.title
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "message",
                children: props.message
            })
        ]
    });
};





var $lldlC = parcelRequire("lldlC");


const $45ef3258e41ae9d6$var$AuthContext = /*#__PURE__*/ (0, $lldlC.createContext)(undefined);
const $45ef3258e41ae9d6$export$87091915187a1a85 = ({ children: children })=>{
    //
    const [user, setUser] = (0, $lldlC.useState)(null);
    (0, $lldlC.useEffect)(()=>{
        const unsubscribe = (0, $add0fd9ad07e71af$export$b4ae2c1c09f3f2c6).onAuthStateChanged((value)=>{
            console.log(value);
            setUser(value);
        });
        return unsubscribe;
    }, []);
    const logout = ()=>{
        return (0, $827e1caa20d65a4f$export$e7094788287c5e9b)((0, $add0fd9ad07e71af$export$b4ae2c1c09f3f2c6)).then(()=>{
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).info(`Successfully signed out`);
        }).catch((error)=>{
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(`Error in signing out the user. ${error.message}`);
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($45ef3258e41ae9d6$var$AuthContext.Provider, {
        value: {
            user: user,
            logout: logout
        },
        children: children
    });
};
function $45ef3258e41ae9d6$export$1d39dc5b47e56ff0() {
    const context = (0, $lldlC.useContext)($45ef3258e41ae9d6$var$AuthContext);
    if (context === undefined) throw new Error("useFirebaseAuth must be used within a FirebaseAuthProvider");
    return context;
}





var $lldlC = parcelRequire("lldlC");
/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lldlC = parcelRequire("lldlC");
var $a47646e093dbda8d$exports = {};
'use strict';
function $a47646e093dbda8d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a47646e093dbda8d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a47646e093dbda8d$var$checkDCE();

$a47646e093dbda8d$exports = (parcelRequire("d95iC"));


/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $33fb5de7ebafcf6c$var$_extends() {
    $33fb5de7ebafcf6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $33fb5de7ebafcf6c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $33fb5de7ebafcf6c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($33fb5de7ebafcf6c$export$e19cd5f9376f8cee || ($33fb5de7ebafcf6c$export$e19cd5f9376f8cee = {}));
const $33fb5de7ebafcf6c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $33fb5de7ebafcf6c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $33fb5de7ebafcf6c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $33fb5de7ebafcf6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $33fb5de7ebafcf6c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $33fb5de7ebafcf6c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $33fb5de7ebafcf6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $33fb5de7ebafcf6c$export$fe53371bee54353d(to);
    }
    return $33fb5de7ebafcf6c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $33fb5de7ebafcf6c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $33fb5de7ebafcf6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $33fb5de7ebafcf6c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $33fb5de7ebafcf6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $33fb5de7ebafcf6c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $33fb5de7ebafcf6c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $33fb5de7ebafcf6c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $33fb5de7ebafcf6c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $33fb5de7ebafcf6c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $33fb5de7ebafcf6c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $33fb5de7ebafcf6c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $33fb5de7ebafcf6c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $33fb5de7ebafcf6c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $33fb5de7ebafcf6c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($33fb5de7ebafcf6c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Push;
        let location = $33fb5de7ebafcf6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $33fb5de7ebafcf6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Replace;
        let location = $33fb5de7ebafcf6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $33fb5de7ebafcf6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $33fb5de7ebafcf6c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($33fb5de7ebafcf6c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($33fb5de7ebafcf6c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $33fb5de7ebafcf6c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($33fb5de7ebafcf6c$var$ResultType || ($33fb5de7ebafcf6c$var$ResultType = {}));
const $33fb5de7ebafcf6c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $33fb5de7ebafcf6c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $33fb5de7ebafcf6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($33fb5de7ebafcf6c$var$isIndexRoute(route)) {
            let indexRoute = $33fb5de7ebafcf6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $33fb5de7ebafcf6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $33fb5de7ebafcf6c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $33fb5de7ebafcf6c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $33fb5de7ebafcf6c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $33fb5de7ebafcf6c$var$flattenRoutes(routes);
    $33fb5de7ebafcf6c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $33fb5de7ebafcf6c$var$decodePath(pathname);
        matches = $33fb5de7ebafcf6c$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $33fb5de7ebafcf6c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $33fb5de7ebafcf6c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $33fb5de7ebafcf6c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $33fb5de7ebafcf6c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $33fb5de7ebafcf6c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $33fb5de7ebafcf6c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $33fb5de7ebafcf6c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $33fb5de7ebafcf6c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $33fb5de7ebafcf6c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $33fb5de7ebafcf6c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $33fb5de7ebafcf6c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $33fb5de7ebafcf6c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $33fb5de7ebafcf6c$var$paramRe = /^:[\w-]+$/;
const $33fb5de7ebafcf6c$var$dynamicSegmentValue = 3;
const $33fb5de7ebafcf6c$var$indexRouteValue = 2;
const $33fb5de7ebafcf6c$var$emptySegmentValue = 1;
const $33fb5de7ebafcf6c$var$staticSegmentValue = 10;
const $33fb5de7ebafcf6c$var$splatPenalty = -2;
const $33fb5de7ebafcf6c$var$isSplat = (s)=>s === "*";
function $33fb5de7ebafcf6c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($33fb5de7ebafcf6c$var$isSplat)) initialScore += $33fb5de7ebafcf6c$var$splatPenalty;
    if (index) initialScore += $33fb5de7ebafcf6c$var$indexRouteValue;
    return segments.filter((s)=>!$33fb5de7ebafcf6c$var$isSplat(s)).reduce((score, segment)=>score + ($33fb5de7ebafcf6c$var$paramRe.test(segment) ? $33fb5de7ebafcf6c$var$dynamicSegmentValue : segment === "" ? $33fb5de7ebafcf6c$var$emptySegmentValue : $33fb5de7ebafcf6c$var$staticSegmentValue), initialScore);
}
function $33fb5de7ebafcf6c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $33fb5de7ebafcf6c$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $33fb5de7ebafcf6c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $33fb5de7ebafcf6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $33fb5de7ebafcf6c$export$a5c6d149b50c1d86($33fb5de7ebafcf6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $33fb5de7ebafcf6c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $33fb5de7ebafcf6c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $33fb5de7ebafcf6c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $33fb5de7ebafcf6c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $33fb5de7ebafcf6c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $33fb5de7ebafcf6c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $33fb5de7ebafcf6c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $33fb5de7ebafcf6c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $33fb5de7ebafcf6c$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $33fb5de7ebafcf6c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $33fb5de7ebafcf6c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $33fb5de7ebafcf6c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $33fb5de7ebafcf6c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $33fb5de7ebafcf6c$var$normalizeSearch(search),
        hash: $33fb5de7ebafcf6c$var$normalizeHash(hash)
    };
}
function $33fb5de7ebafcf6c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $33fb5de7ebafcf6c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $33fb5de7ebafcf6c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $33fb5de7ebafcf6c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $33fb5de7ebafcf6c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $33fb5de7ebafcf6c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $33fb5de7ebafcf6c$var$_extends({}, toArg);
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $33fb5de7ebafcf6c$var$getInvalidPathError("?", "pathname", "search", to));
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $33fb5de7ebafcf6c$var$getInvalidPathError("#", "pathname", "hash", to));
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $33fb5de7ebafcf6c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $33fb5de7ebafcf6c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $33fb5de7ebafcf6c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $33fb5de7ebafcf6c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $33fb5de7ebafcf6c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $33fb5de7ebafcf6c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $33fb5de7ebafcf6c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $33fb5de7ebafcf6c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $33fb5de7ebafcf6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $33fb5de7ebafcf6c$export$42a99a7a4bc0e76a extends Error {
}
class $33fb5de7ebafcf6c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $33fb5de7ebafcf6c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $33fb5de7ebafcf6c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $33fb5de7ebafcf6c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $33fb5de7ebafcf6c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $33fb5de7ebafcf6c$var$unwrapTrackedPromise(value) {
    if (!$33fb5de7ebafcf6c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $33fb5de7ebafcf6c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $33fb5de7ebafcf6c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $33fb5de7ebafcf6c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $33fb5de7ebafcf6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $33fb5de7ebafcf6c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $33fb5de7ebafcf6c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $33fb5de7ebafcf6c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $33fb5de7ebafcf6c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $33fb5de7ebafcf6c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $33fb5de7ebafcf6c$var$validMutationMethods = new Set($33fb5de7ebafcf6c$var$validMutationMethodsArr);
const $33fb5de7ebafcf6c$var$validRequestMethodsArr = [
    "get",
    ...$33fb5de7ebafcf6c$var$validMutationMethodsArr
];
const $33fb5de7ebafcf6c$var$validRequestMethods = new Set($33fb5de7ebafcf6c$var$validRequestMethodsArr);
const $33fb5de7ebafcf6c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $33fb5de7ebafcf6c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $33fb5de7ebafcf6c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $33fb5de7ebafcf6c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $33fb5de7ebafcf6c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $33fb5de7ebafcf6c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $33fb5de7ebafcf6c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $33fb5de7ebafcf6c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $33fb5de7ebafcf6c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $33fb5de7ebafcf6c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $33fb5de7ebafcf6c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $33fb5de7ebafcf6c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $33fb5de7ebafcf6c$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $33fb5de7ebafcf6c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $33fb5de7ebafcf6c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $33fb5de7ebafcf6c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $33fb5de7ebafcf6c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $33fb5de7ebafcf6c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $33fb5de7ebafcf6c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $33fb5de7ebafcf6c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$33fb5de7ebafcf6c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $33fb5de7ebafcf6c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $33fb5de7ebafcf6c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $33fb5de7ebafcf6c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $33fb5de7ebafcf6c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $33fb5de7ebafcf6c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($33fb5de7ebafcf6c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $33fb5de7ebafcf6c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $33fb5de7ebafcf6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $33fb5de7ebafcf6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $33fb5de7ebafcf6c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $33fb5de7ebafcf6c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $33fb5de7ebafcf6c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $33fb5de7ebafcf6c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $33fb5de7ebafcf6c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $33fb5de7ebafcf6c$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $33fb5de7ebafcf6c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $33fb5de7ebafcf6c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $33fb5de7ebafcf6c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $33fb5de7ebafcf6c$var$findNearestBoundary(matches).route.id,
            {
                type: $33fb5de7ebafcf6c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $33fb5de7ebafcf6c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $33fb5de7ebafcf6c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $33fb5de7ebafcf6c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $33fb5de7ebafcf6c$var$_extends({
            matches: matches
        }, $33fb5de7ebafcf6c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $33fb5de7ebafcf6c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $33fb5de7ebafcf6c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $33fb5de7ebafcf6c$var$ResultType.error,
            error: $33fb5de7ebafcf6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($33fb5de7ebafcf6c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $33fb5de7ebafcf6c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($33fb5de7ebafcf6c$var$isDeferredResult(result)) throw $33fb5de7ebafcf6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($33fb5de7ebafcf6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $33fb5de7ebafcf6c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $33fb5de7ebafcf6c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $33fb5de7ebafcf6c$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $33fb5de7ebafcf6c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $33fb5de7ebafcf6c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $33fb5de7ebafcf6c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $33fb5de7ebafcf6c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($33fb5de7ebafcf6c$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $33fb5de7ebafcf6c$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $33fb5de7ebafcf6c$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $33fb5de7ebafcf6c$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $33fb5de7ebafcf6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $33fb5de7ebafcf6c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $33fb5de7ebafcf6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $33fb5de7ebafcf6c$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $33fb5de7ebafcf6c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $33fb5de7ebafcf6c$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $33fb5de7ebafcf6c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $33fb5de7ebafcf6c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($33fb5de7ebafcf6c$var$isRedirectResult(actionResult) || $33fb5de7ebafcf6c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $33fb5de7ebafcf6c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($33fb5de7ebafcf6c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $33fb5de7ebafcf6c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $33fb5de7ebafcf6c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($33fb5de7ebafcf6c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($33fb5de7ebafcf6c$var$isDeferredResult(actionResult)) throw $33fb5de7ebafcf6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $33fb5de7ebafcf6c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $33fb5de7ebafcf6c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $33fb5de7ebafcf6c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $33fb5de7ebafcf6c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $33fb5de7ebafcf6c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $33fb5de7ebafcf6c$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $33fb5de7ebafcf6c$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $33fb5de7ebafcf6c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $33fb5de7ebafcf6c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $33fb5de7ebafcf6c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $33fb5de7ebafcf6c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $33fb5de7ebafcf6c$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($33fb5de7ebafcf6c$var$isDeferredResult(result)) result = await $33fb5de7ebafcf6c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $33fb5de7ebafcf6c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($33fb5de7ebafcf6c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $33fb5de7ebafcf6c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($33fb5de7ebafcf6c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(!$33fb5de7ebafcf6c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $33fb5de7ebafcf6c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $33fb5de7ebafcf6c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $33fb5de7ebafcf6c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($33fb5de7ebafcf6c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $33fb5de7ebafcf6c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Replace : $33fb5de7ebafcf6c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $33fb5de7ebafcf6c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($33fb5de7ebafcf6c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $33fb5de7ebafcf6c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $33fb5de7ebafcf6c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $33fb5de7ebafcf6c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $33fb5de7ebafcf6c$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($33fb5de7ebafcf6c$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $33fb5de7ebafcf6c$var$ResultType.redirect,
                        response: $33fb5de7ebafcf6c$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $33fb5de7ebafcf6c$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $33fb5de7ebafcf6c$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $33fb5de7ebafcf6c$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $33fb5de7ebafcf6c$var$ResultType.error,
                    error: $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $33fb5de7ebafcf6c$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $33fb5de7ebafcf6c$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $33fb5de7ebafcf6c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $33fb5de7ebafcf6c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $33fb5de7ebafcf6c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $33fb5de7ebafcf6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $33fb5de7ebafcf6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $33fb5de7ebafcf6c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $33fb5de7ebafcf6c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $33fb5de7ebafcf6c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $33fb5de7ebafcf6c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$33fb5de7ebafcf6c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $33fb5de7ebafcf6c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $33fb5de7ebafcf6c$export$4d0306f8f6a4585b = Symbol("deferred");
function $33fb5de7ebafcf6c$export$3336b097a6fbc59a(routes, opts) {
    $33fb5de7ebafcf6c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $33fb5de7ebafcf6c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $33fb5de7ebafcf6c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $33fb5de7ebafcf6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $33fb5de7ebafcf6c$var$createLocation("", $33fb5de7ebafcf6c$export$fe53371bee54353d(url), null, "default");
        let matches = $33fb5de7ebafcf6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$33fb5de7ebafcf6c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $33fb5de7ebafcf6c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $33fb5de7ebafcf6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $33fb5de7ebafcf6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($33fb5de7ebafcf6c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $33fb5de7ebafcf6c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $33fb5de7ebafcf6c$var$createLocation("", $33fb5de7ebafcf6c$export$fe53371bee54353d(url), null, "default");
        let matches = $33fb5de7ebafcf6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$33fb5de7ebafcf6c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $33fb5de7ebafcf6c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $33fb5de7ebafcf6c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $33fb5de7ebafcf6c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, null, false, match);
        if ($33fb5de7ebafcf6c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$33fb5de7ebafcf6c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($33fb5de7ebafcf6c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $33fb5de7ebafcf6c$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $33fb5de7ebafcf6c$var$isResponse(result) ? result : $33fb5de7ebafcf6c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($33fb5de7ebafcf6c$var$isHandlerResult(e) && $33fb5de7ebafcf6c$var$isResponse(e.result)) {
                if (e.type === $33fb5de7ebafcf6c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($33fb5de7ebafcf6c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $33fb5de7ebafcf6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $33fb5de7ebafcf6c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $33fb5de7ebafcf6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($33fb5de7ebafcf6c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($33fb5de7ebafcf6c$var$isDeferredResult(result)) {
            let error = $33fb5de7ebafcf6c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $33fb5de7ebafcf6c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($33fb5de7ebafcf6c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($33fb5de7ebafcf6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $33fb5de7ebafcf6c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $33fb5de7ebafcf6c$var$_extends({}, context, {
                statusCode: $33fb5de7ebafcf6c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $33fb5de7ebafcf6c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $33fb5de7ebafcf6c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $33fb5de7ebafcf6c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1]) ? $33fb5de7ebafcf6c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $33fb5de7ebafcf6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $33fb5de7ebafcf6c$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $33fb5de7ebafcf6c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $33fb5de7ebafcf6c$var$callDataStrategyImpl(unstable_dataStrategy || $33fb5de7ebafcf6c$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($33fb5de7ebafcf6c$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $33fb5de7ebafcf6c$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($33fb5de7ebafcf6c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $33fb5de7ebafcf6c$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $33fb5de7ebafcf6c$export$fec11da027c70692(routes, context, error) {
    let newContext = $33fb5de7ebafcf6c$var$_extends({}, context, {
        statusCode: $33fb5de7ebafcf6c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $33fb5de7ebafcf6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $33fb5de7ebafcf6c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $33fb5de7ebafcf6c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $33fb5de7ebafcf6c$export$cae722b0cc860f13(to ? to : ".", $33fb5de7ebafcf6c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $33fb5de7ebafcf6c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$33fb5de7ebafcf6c$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $33fb5de7ebafcf6c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $33fb5de7ebafcf6c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $33fb5de7ebafcf6c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$33fb5de7ebafcf6c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$33fb5de7ebafcf6c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $33fb5de7ebafcf6c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $33fb5de7ebafcf6c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $33fb5de7ebafcf6c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$33fb5de7ebafcf6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$33fb5de7ebafcf6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $33fb5de7ebafcf6c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $33fb5de7ebafcf6c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $33fb5de7ebafcf6c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $33fb5de7ebafcf6c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $33fb5de7ebafcf6c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($33fb5de7ebafcf6c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $33fb5de7ebafcf6c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $33fb5de7ebafcf6c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $33fb5de7ebafcf6c$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $33fb5de7ebafcf6c$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $33fb5de7ebafcf6c$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($33fb5de7ebafcf6c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $33fb5de7ebafcf6c$var$shouldRevalidateLoader(match, $33fb5de7ebafcf6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $33fb5de7ebafcf6c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $33fb5de7ebafcf6c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $33fb5de7ebafcf6c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $33fb5de7ebafcf6c$var$shouldRevalidateLoader(fetcherMatch, $33fb5de7ebafcf6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $33fb5de7ebafcf6c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $33fb5de7ebafcf6c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $33fb5de7ebafcf6c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $33fb5de7ebafcf6c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $33fb5de7ebafcf6c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $33fb5de7ebafcf6c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$33fb5de7ebafcf6c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $33fb5de7ebafcf6c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $33fb5de7ebafcf6c$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $33fb5de7ebafcf6c$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $33fb5de7ebafcf6c$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $33fb5de7ebafcf6c$var$ResultType.data,
                    result: undefined
                });
            };
            return $33fb5de7ebafcf6c$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$33fb5de7ebafcf6c$export$3e9cee6b33872309(loadedMatches.has(m.route.id), "`match.resolve()` was not called for route id \"" + m.route.id + "\". " + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $33fb5de7ebafcf6c$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $33fb5de7ebafcf6c$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $33fb5de7ebafcf6c$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $33fb5de7ebafcf6c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $33fb5de7ebafcf6c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $33fb5de7ebafcf6c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $33fb5de7ebafcf6c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $33fb5de7ebafcf6c$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($33fb5de7ebafcf6c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $33fb5de7ebafcf6c$var$ResultType.error,
                error: e
            };
        }
        if (type === $33fb5de7ebafcf6c$var$ResultType.error) return {
            type: $33fb5de7ebafcf6c$var$ResultType.error,
            error: new $33fb5de7ebafcf6c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $33fb5de7ebafcf6c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $33fb5de7ebafcf6c$var$ResultType.error) return {
        type: $33fb5de7ebafcf6c$var$ResultType.error,
        error: result,
        statusCode: $33fb5de7ebafcf6c$export$972111febbeef05b(result) ? result.status : status
    };
    if ($33fb5de7ebafcf6c$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $33fb5de7ebafcf6c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $33fb5de7ebafcf6c$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $33fb5de7ebafcf6c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $33fb5de7ebafcf6c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$33fb5de7ebafcf6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $33fb5de7ebafcf6c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $33fb5de7ebafcf6c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($33fb5de7ebafcf6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $33fb5de7ebafcf6c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $33fb5de7ebafcf6c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($33fb5de7ebafcf6c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $33fb5de7ebafcf6c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $33fb5de7ebafcf6c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $33fb5de7ebafcf6c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $33fb5de7ebafcf6c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $33fb5de7ebafcf6c$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(!$33fb5de7ebafcf6c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($33fb5de7ebafcf6c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $33fb5de7ebafcf6c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $33fb5de7ebafcf6c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($33fb5de7ebafcf6c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $33fb5de7ebafcf6c$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $33fb5de7ebafcf6c$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($33fb5de7ebafcf6c$var$isErrorResult(result)) {
            let boundaryMatch = $33fb5de7ebafcf6c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $33fb5de7ebafcf6c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($33fb5de7ebafcf6c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($33fb5de7ebafcf6c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $33fb5de7ebafcf6c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $33fb5de7ebafcf6c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $33fb5de7ebafcf6c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $33fb5de7ebafcf6c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $33fb5de7ebafcf6c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $33fb5de7ebafcf6c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $33fb5de7ebafcf6c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $33fb5de7ebafcf6c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $33fb5de7ebafcf6c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $33fb5de7ebafcf6c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $33fb5de7ebafcf6c$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($33fb5de7ebafcf6c$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $33fb5de7ebafcf6c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(path) : path;
    return $33fb5de7ebafcf6c$export$fe53371bee54353d($33fb5de7ebafcf6c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $33fb5de7ebafcf6c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $33fb5de7ebafcf6c$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $33fb5de7ebafcf6c$var$ResultType.data || result.type === $33fb5de7ebafcf6c$var$ResultType.error);
}
function $33fb5de7ebafcf6c$var$isRedirectHandlerResult(result) {
    return $33fb5de7ebafcf6c$var$isResponse(result.result) && $33fb5de7ebafcf6c$var$redirectStatusCodes.has(result.result.status);
}
function $33fb5de7ebafcf6c$var$isDeferredResult(result) {
    return result.type === $33fb5de7ebafcf6c$var$ResultType.deferred;
}
function $33fb5de7ebafcf6c$var$isErrorResult(result) {
    return result.type === $33fb5de7ebafcf6c$var$ResultType.error;
}
function $33fb5de7ebafcf6c$var$isRedirectResult(result) {
    return (result && result.type) === $33fb5de7ebafcf6c$var$ResultType.redirect;
}
function $33fb5de7ebafcf6c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $33fb5de7ebafcf6c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $33fb5de7ebafcf6c$var$isRedirectResponse(result) {
    if (!$33fb5de7ebafcf6c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $33fb5de7ebafcf6c$var$isValidMethod(method) {
    return $33fb5de7ebafcf6c$var$validRequestMethods.has(method.toLowerCase());
}
function $33fb5de7ebafcf6c$var$isMutationMethod(method) {
    return $33fb5de7ebafcf6c$var$validMutationMethods.has(method.toLowerCase());
}
async function $33fb5de7ebafcf6c$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$33fb5de7ebafcf6c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($33fb5de7ebafcf6c$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $33fb5de7ebafcf6c$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $33fb5de7ebafcf6c$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $33fb5de7ebafcf6c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $33fb5de7ebafcf6c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $33fb5de7ebafcf6c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $33fb5de7ebafcf6c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $33fb5de7ebafcf6c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $33fb5de7ebafcf6c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $33fb5de7ebafcf6c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $33fb5de7ebafcf6c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $33fb5de7ebafcf6c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $33fb5de7ebafcf6c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $33fb5de7ebafcf6c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $33fb5de7ebafcf6c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $33fb5de7ebafcf6c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $33fb5de7ebafcf6c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $33fb5de7ebafcf6c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $33fb5de7ebafcf6c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($33fb5de7ebafcf6c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $33fb5de7ebafcf6c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($33fb5de7ebafcf6c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $33fb5de7ebafcf6c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lldlC = parcelRequire("lldlC");

function $20bbbf7d5bcb0a93$var$_extends() {
    $20bbbf7d5bcb0a93$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $20bbbf7d5bcb0a93$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $20bbbf7d5bcb0a93$export$3add0d5dce533e2e = /*#__PURE__*/ $lldlC.createContext(null);
const $20bbbf7d5bcb0a93$export$145dfa71566a64dc = /*#__PURE__*/ $lldlC.createContext(null);
const $20bbbf7d5bcb0a93$var$AwaitContext = /*#__PURE__*/ $lldlC.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $20bbbf7d5bcb0a93$export$26749e8557646306 = /*#__PURE__*/ $lldlC.createContext(null);
const $20bbbf7d5bcb0a93$export$c7914228fb69b0f5 = /*#__PURE__*/ $lldlC.createContext(null);
const $20bbbf7d5bcb0a93$export$9072aa6dd1f93057 = /*#__PURE__*/ $lldlC.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $20bbbf7d5bcb0a93$var$RouteErrorContext = /*#__PURE__*/ $lldlC.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $20bbbf7d5bcb0a93$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $lldlC.useContext($20bbbf7d5bcb0a93$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $20bbbf7d5bcb0a93$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $33fb5de7ebafcf6c$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() {
    return $lldlC.useContext($20bbbf7d5bcb0a93$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $20bbbf7d5bcb0a93$export$45d76561a5302f2b() {
    !$20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    return $lldlC.useContext($20bbbf7d5bcb0a93$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $20bbbf7d5bcb0a93$export$1b3f31771c5d07c() {
    return $lldlC.useContext($20bbbf7d5bcb0a93$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $20bbbf7d5bcb0a93$export$6c330e8992e8a295(pattern) {
    !$20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $20bbbf7d5bcb0a93$export$45d76561a5302f2b();
    return $lldlC.useMemo(()=>(0, $33fb5de7ebafcf6c$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $20bbbf7d5bcb0a93$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $20bbbf7d5bcb0a93$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $lldlC.useContext($20bbbf7d5bcb0a93$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $lldlC.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $20bbbf7d5bcb0a93$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $20bbbf7d5bcb0a93$var$useNavigateStable() : $20bbbf7d5bcb0a93$var$useNavigateUnstable();
}
function $20bbbf7d5bcb0a93$var$useNavigateUnstable() {
    !$20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    let dataRouterContext = $lldlC.useContext($20bbbf7d5bcb0a93$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $lldlC.useContext($20bbbf7d5bcb0a93$export$26749e8557646306);
    let { matches: matches } = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $20bbbf7d5bcb0a93$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $33fb5de7ebafcf6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $lldlC.useRef(false);
    $20bbbf7d5bcb0a93$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lldlC.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $33fb5de7ebafcf6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $33fb5de7ebafcf6c$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $20bbbf7d5bcb0a93$var$OutletContext = /*#__PURE__*/ $lldlC.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $20bbbf7d5bcb0a93$export$4138103a3ae699cc() {
    return $lldlC.useContext($20bbbf7d5bcb0a93$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $20bbbf7d5bcb0a93$export$a3be3530d8e40d0b(context) {
    let outlet = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $20bbbf7d5bcb0a93$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $20bbbf7d5bcb0a93$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $lldlC.useContext($20bbbf7d5bcb0a93$export$26749e8557646306);
    let { matches: matches } = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $20bbbf7d5bcb0a93$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $33fb5de7ebafcf6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $lldlC.useMemo(()=>(0, $33fb5de7ebafcf6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $20bbbf7d5bcb0a93$export$5d3fca4a98652595(routes, locationArg) {
    return $20bbbf7d5bcb0a93$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $20bbbf7d5bcb0a93$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $lldlC.useContext($20bbbf7d5bcb0a93$export$26749e8557646306);
    let { matches: parentMatches } = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $20bbbf7d5bcb0a93$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $33fb5de7ebafcf6c$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $33fb5de7ebafcf6c$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $20bbbf7d5bcb0a93$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $33fb5de7ebafcf6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $33fb5de7ebafcf6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $20bbbf7d5bcb0a93$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $33fb5de7ebafcf6c$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $20bbbf7d5bcb0a93$var$DefaultErrorComponent() {
    let error = $20bbbf7d5bcb0a93$export$ed527bf60f6e05f2();
    let message = (0, $33fb5de7ebafcf6c$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $lldlC.createElement($lldlC.Fragment, null, /*#__PURE__*/ $lldlC.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $lldlC.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $lldlC.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $20bbbf7d5bcb0a93$var$defaultErrorElement = /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$DefaultErrorComponent, null);
class $20bbbf7d5bcb0a93$var$RenderErrorBoundary extends $lldlC.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $20bbbf7d5bcb0a93$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $lldlC.useContext($20bbbf7d5bcb0a93$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $20bbbf7d5bcb0a93$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $20bbbf7d5bcb0a93$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $20bbbf7d5bcb0a93$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $lldlC.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $20bbbf7d5bcb0a93$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($20bbbf7d5bcb0a93$var$DataRouterHook || {});
var $20bbbf7d5bcb0a93$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($20bbbf7d5bcb0a93$var$DataRouterStateHook || {});
function $20bbbf7d5bcb0a93$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $20bbbf7d5bcb0a93$var$useDataRouterContext(hookName) {
    let ctx = $lldlC.useContext($20bbbf7d5bcb0a93$export$3add0d5dce533e2e);
    !ctx && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $20bbbf7d5bcb0a93$var$useDataRouterState(hookName) {
    let state = $lldlC.useContext($20bbbf7d5bcb0a93$export$145dfa71566a64dc);
    !state && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    return state;
}
function $20bbbf7d5bcb0a93$var$useRouteContext(hookName) {
    let route = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057);
    !route && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $20bbbf7d5bcb0a93$var$useCurrentRouteId(hookName) {
    let route = $20bbbf7d5bcb0a93$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $20bbbf7d5bcb0a93$export$5fc8298006ad9e58() {
    return $20bbbf7d5bcb0a93$var$useCurrentRouteId($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $20bbbf7d5bcb0a93$export$d0fd4b7106de2769() {
    let state = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $20bbbf7d5bcb0a93$export$600dc272ed516c15() {
    let dataRouterContext = $20bbbf7d5bcb0a93$var$useDataRouterContext($20bbbf7d5bcb0a93$var$DataRouterHook.UseRevalidator);
    let state = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseRevalidator);
    return $lldlC.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $20bbbf7d5bcb0a93$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseMatches);
    return $lldlC.useMemo(()=>matches.map((m)=>(0, $33fb5de7ebafcf6c$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $20bbbf7d5bcb0a93$export$1448a5050d252c4d() {
    let state = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseLoaderData);
    let routeId = $20bbbf7d5bcb0a93$var$useCurrentRouteId($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $20bbbf7d5bcb0a93$export$fd5d37484eab868d(routeId) {
    let state = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $20bbbf7d5bcb0a93$export$fdc00f3f26066d5e() {
    let state = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseActionData);
    let routeId = $20bbbf7d5bcb0a93$var$useCurrentRouteId($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $20bbbf7d5bcb0a93$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $lldlC.useContext($20bbbf7d5bcb0a93$var$RouteErrorContext);
    let state = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseRouteError);
    let routeId = $20bbbf7d5bcb0a93$var$useCurrentRouteId($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $20bbbf7d5bcb0a93$export$78a72ddb39bdd145() {
    let value = $lldlC.useContext($20bbbf7d5bcb0a93$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $20bbbf7d5bcb0a93$export$17f53340677d5831() {
    let value = $lldlC.useContext($20bbbf7d5bcb0a93$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $20bbbf7d5bcb0a93$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $20bbbf7d5bcb0a93$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $20bbbf7d5bcb0a93$var$useDataRouterContext($20bbbf7d5bcb0a93$var$DataRouterHook.UseBlocker);
    let state = $20bbbf7d5bcb0a93$var$useDataRouterState($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $lldlC.useState("");
    let blockerFunction = $lldlC.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $20bbbf7d5bcb0a93$var$_extends({}, currentLocation, {
                pathname: (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $20bbbf7d5bcb0a93$var$_extends({}, nextLocation, {
                pathname: (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $lldlC.useEffect(()=>{
        let key = String(++$20bbbf7d5bcb0a93$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $lldlC.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $33fb5de7ebafcf6c$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $20bbbf7d5bcb0a93$var$useNavigateStable() {
    let { router: router } = $20bbbf7d5bcb0a93$var$useDataRouterContext($20bbbf7d5bcb0a93$var$DataRouterHook.UseNavigateStable);
    let id = $20bbbf7d5bcb0a93$var$useCurrentRouteId($20bbbf7d5bcb0a93$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $lldlC.useRef(false);
    $20bbbf7d5bcb0a93$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lldlC.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $20bbbf7d5bcb0a93$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $20bbbf7d5bcb0a93$var$alreadyWarned = {};
function $20bbbf7d5bcb0a93$var$warningOnce(key, cond, message) {
    if (!cond && !$20bbbf7d5bcb0a93$var$alreadyWarned[key]) $20bbbf7d5bcb0a93$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $20bbbf7d5bcb0a93$var$START_TRANSITION = "startTransition";
const $20bbbf7d5bcb0a93$var$startTransitionImpl = $lldlC[$20bbbf7d5bcb0a93$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $20bbbf7d5bcb0a93$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lldlC.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lldlC.useCallback((newState)=>{
        if (v7_startTransition && $20bbbf7d5bcb0a93$var$startTransitionImpl) $20bbbf7d5bcb0a93$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lldlC.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $lldlC.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lldlC.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lldlC.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lldlC.createElement($lldlC.Fragment, null, /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $20bbbf7d5bcb0a93$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $20bbbf7d5bcb0a93$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $20bbbf7d5bcb0a93$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $lldlC.useRef();
    if (historyRef.current == null) historyRef.current = (0, $33fb5de7ebafcf6c$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lldlC.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lldlC.useCallback((newState)=>{
        v7_startTransition && $20bbbf7d5bcb0a93$var$startTransitionImpl ? $20bbbf7d5bcb0a93$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lldlC.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $20bbbf7d5bcb0a93$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $lldlC.useContext($20bbbf7d5bcb0a93$export$26749e8557646306);
    let { matches: matches } = $lldlC.useContext($20bbbf7d5bcb0a93$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $20bbbf7d5bcb0a93$export$45d76561a5302f2b();
    let navigate = $20bbbf7d5bcb0a93$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $33fb5de7ebafcf6c$export$cae722b0cc860f13)(to, (0, $33fb5de7ebafcf6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $lldlC.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $20bbbf7d5bcb0a93$export$910ae8079b2c2852(props) {
    return $20bbbf7d5bcb0a93$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6(_props) {
    (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $20bbbf7d5bcb0a93$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $33fb5de7ebafcf6c$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$20bbbf7d5bcb0a93$export$9c954a9d03d32f4a() && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $lldlC.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $20bbbf7d5bcb0a93$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $33fb5de7ebafcf6c$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $lldlC.useMemo(()=>{
        let trailingPathname = (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $20bbbf7d5bcb0a93$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $20bbbf7d5bcb0a93$export$5d3fca4a98652595($20bbbf7d5bcb0a93$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $20bbbf7d5bcb0a93$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$ResolveAwait, null, children));
}
var $20bbbf7d5bcb0a93$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($20bbbf7d5bcb0a93$var$AwaitRenderStatus || {});
const $20bbbf7d5bcb0a93$var$neverSettledPromise = new Promise(()=>{});
class $20bbbf7d5bcb0a93$var$AwaitErrorBoundary extends $lldlC.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $20bbbf7d5bcb0a93$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $20bbbf7d5bcb0a93$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $20bbbf7d5bcb0a93$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $20bbbf7d5bcb0a93$var$AwaitRenderStatus.error : promise._data !== undefined ? $20bbbf7d5bcb0a93$var$AwaitRenderStatus.success : $20bbbf7d5bcb0a93$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $20bbbf7d5bcb0a93$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $20bbbf7d5bcb0a93$var$AwaitRenderStatus.error && promise._error instanceof (0, $33fb5de7ebafcf6c$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $20bbbf7d5bcb0a93$var$neverSettledPromise;
        if (status === $20bbbf7d5bcb0a93$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $20bbbf7d5bcb0a93$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $20bbbf7d5bcb0a93$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $lldlC.createElement($20bbbf7d5bcb0a93$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $20bbbf7d5bcb0a93$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $20bbbf7d5bcb0a93$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $lldlC.createElement($lldlC.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $20bbbf7d5bcb0a93$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $lldlC.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $lldlC.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $lldlC.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $20bbbf7d5bcb0a93$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6) && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $20bbbf7d5bcb0a93$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $20bbbf7d5bcb0a93$export$daf73786167a7f72(matches) {
    return $20bbbf7d5bcb0a93$var$_renderMatches(matches);
}
function $20bbbf7d5bcb0a93$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $lldlC.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $lldlC.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $lldlC.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $20bbbf7d5bcb0a93$export$f30f7e456d254e83(routes, opts) {
    return (0, $33fb5de7ebafcf6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $20bbbf7d5bcb0a93$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $33fb5de7ebafcf6c$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $20bbbf7d5bcb0a93$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $5eed20d16fad0e34$var$_extends() {
    $5eed20d16fad0e34$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5eed20d16fad0e34$var$_extends.apply(this, arguments);
}
function $5eed20d16fad0e34$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $5eed20d16fad0e34$var$defaultMethod = "get";
const $5eed20d16fad0e34$var$defaultEncType = "application/x-www-form-urlencoded";
function $5eed20d16fad0e34$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $5eed20d16fad0e34$var$isButtonElement(object) {
    return $5eed20d16fad0e34$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $5eed20d16fad0e34$var$isFormElement(object) {
    return $5eed20d16fad0e34$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $5eed20d16fad0e34$var$isInputElement(object) {
    return $5eed20d16fad0e34$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $5eed20d16fad0e34$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $5eed20d16fad0e34$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$5eed20d16fad0e34$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $5eed20d16fad0e34$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $5eed20d16fad0e34$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $5eed20d16fad0e34$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $5eed20d16fad0e34$var$_formDataSupportsSubmitter = null;
function $5eed20d16fad0e34$var$isFormDataSubmitterSupported() {
    if ($5eed20d16fad0e34$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $5eed20d16fad0e34$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $5eed20d16fad0e34$var$_formDataSupportsSubmitter = true;
    }
    return $5eed20d16fad0e34$var$_formDataSupportsSubmitter;
}
const $5eed20d16fad0e34$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $5eed20d16fad0e34$var$getFormEncType(encType) {
    if (encType != null && !$5eed20d16fad0e34$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $5eed20d16fad0e34$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($5eed20d16fad0e34$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $5eed20d16fad0e34$var$defaultMethod;
        encType = $5eed20d16fad0e34$var$getFormEncType(target.getAttribute("enctype")) || $5eed20d16fad0e34$var$defaultEncType;
        formData = new FormData(target);
    } else if ($5eed20d16fad0e34$var$isButtonElement(target) || $5eed20d16fad0e34$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $5eed20d16fad0e34$var$defaultMethod;
        encType = $5eed20d16fad0e34$var$getFormEncType(target.getAttribute("formenctype")) || $5eed20d16fad0e34$var$getFormEncType(form.getAttribute("enctype")) || $5eed20d16fad0e34$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$5eed20d16fad0e34$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($5eed20d16fad0e34$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $5eed20d16fad0e34$var$defaultMethod;
        action = null;
        encType = $5eed20d16fad0e34$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $5eed20d16fad0e34$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $5eed20d16fad0e34$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $5eed20d16fad0e34$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $5eed20d16fad0e34$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $5eed20d16fad0e34$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $5eed20d16fad0e34$export$1f3f55432a00e06d(routes, opts) {
    return (0, $33fb5de7ebafcf6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5eed20d16fad0e34$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $33fb5de7ebafcf6c$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $5eed20d16fad0e34$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $20bbbf7d5bcb0a93$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $5eed20d16fad0e34$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $33fb5de7ebafcf6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5eed20d16fad0e34$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $33fb5de7ebafcf6c$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $5eed20d16fad0e34$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $20bbbf7d5bcb0a93$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $5eed20d16fad0e34$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $5eed20d16fad0e34$var$_extends({}, state, {
        errors: $5eed20d16fad0e34$var$deserializeErrors(state.errors)
    });
    return state;
}
function $5eed20d16fad0e34$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $33fb5de7ebafcf6c$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $5eed20d16fad0e34$export$7ad602f0e94e62d1 = /*#__PURE__*/ $lldlC.createContext({
    isTransitioning: false
});
const $5eed20d16fad0e34$export$148fd98d095596d4 = /*#__PURE__*/ $lldlC.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5eed20d16fad0e34$var$START_TRANSITION = "startTransition";
const $5eed20d16fad0e34$var$startTransitionImpl = $lldlC[$5eed20d16fad0e34$var$START_TRANSITION];
const $5eed20d16fad0e34$var$FLUSH_SYNC = "flushSync";
const $5eed20d16fad0e34$var$flushSyncImpl = $a47646e093dbda8d$exports[$5eed20d16fad0e34$var$FLUSH_SYNC];
const $5eed20d16fad0e34$var$USE_ID = "useId";
const $5eed20d16fad0e34$var$useIdImpl = $lldlC[$5eed20d16fad0e34$var$USE_ID];
function $5eed20d16fad0e34$var$startTransitionSafe(cb) {
    if ($5eed20d16fad0e34$var$startTransitionImpl) $5eed20d16fad0e34$var$startTransitionImpl(cb);
    else cb();
}
function $5eed20d16fad0e34$var$flushSyncSafe(cb) {
    if ($5eed20d16fad0e34$var$flushSyncImpl) $5eed20d16fad0e34$var$flushSyncImpl(cb);
    else cb();
}
class $5eed20d16fad0e34$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5eed20d16fad0e34$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lldlC.useState(router.state);
    let [pendingState, setPendingState] = $lldlC.useState();
    let [vtContext, setVtContext] = $lldlC.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $lldlC.useState();
    let [transition, setTransition] = $lldlC.useState();
    let [interruption, setInterruption] = $lldlC.useState();
    let fetcherData = $lldlC.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $lldlC.useCallback((cb)=>{
        if (v7_startTransition) $5eed20d16fad0e34$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $lldlC.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $5eed20d16fad0e34$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $5eed20d16fad0e34$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $5eed20d16fad0e34$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $5eed20d16fad0e34$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $5eed20d16fad0e34$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lldlC.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $lldlC.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $5eed20d16fad0e34$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $lldlC.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $lldlC.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $lldlC.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $lldlC.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lldlC.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lldlC.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lldlC.createElement($lldlC.Fragment, null, /*#__PURE__*/ $lldlC.createElement((0, $20bbbf7d5bcb0a93$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lldlC.createElement((0, $20bbbf7d5bcb0a93$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $lldlC.createElement($5eed20d16fad0e34$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $lldlC.createElement($5eed20d16fad0e34$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $lldlC.createElement((0, $20bbbf7d5bcb0a93$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lldlC.createElement($5eed20d16fad0e34$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $5eed20d16fad0e34$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $20bbbf7d5bcb0a93$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $5eed20d16fad0e34$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $lldlC.useRef();
    if (historyRef.current == null) historyRef.current = (0, $33fb5de7ebafcf6c$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lldlC.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lldlC.useCallback((newState)=>{
        v7_startTransition && $5eed20d16fad0e34$var$startTransitionImpl ? $5eed20d16fad0e34$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lldlC.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lldlC.createElement((0, $20bbbf7d5bcb0a93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $5eed20d16fad0e34$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $lldlC.useRef();
    if (historyRef.current == null) historyRef.current = (0, $33fb5de7ebafcf6c$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lldlC.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lldlC.useCallback((newState)=>{
        v7_startTransition && $5eed20d16fad0e34$var$startTransitionImpl ? $5eed20d16fad0e34$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lldlC.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lldlC.createElement((0, $20bbbf7d5bcb0a93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $5eed20d16fad0e34$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $lldlC.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lldlC.useCallback((newState)=>{
        v7_startTransition && $5eed20d16fad0e34$var$startTransitionImpl ? $5eed20d16fad0e34$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lldlC.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lldlC.createElement((0, $20bbbf7d5bcb0a93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $5eed20d16fad0e34$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $5eed20d16fad0e34$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $5eed20d16fad0e34$export$a6c7ac8248d6e38a = /*#__PURE__*/ $lldlC.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $5eed20d16fad0e34$var$_objectWithoutPropertiesLoose(_ref7, $5eed20d16fad0e34$var$_excluded);
    let { basename: basename } = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $5eed20d16fad0e34$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($5eed20d16fad0e34$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $20bbbf7d5bcb0a93$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $5eed20d16fad0e34$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $lldlC.createElement("a", $5eed20d16fad0e34$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $5eed20d16fad0e34$export$b0d92dbee9b5b60d = /*#__PURE__*/ $lldlC.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $5eed20d16fad0e34$var$_objectWithoutPropertiesLoose(_ref8, $5eed20d16fad0e34$var$_excluded2);
    let path = (0, $20bbbf7d5bcb0a93$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $20bbbf7d5bcb0a93$export$45d76561a5302f2b)();
    let routerState = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5eed20d16fad0e34$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $lldlC.createElement($5eed20d16fad0e34$export$a6c7ac8248d6e38a, $5eed20d16fad0e34$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $5eed20d16fad0e34$export$a7fed597f4b8afd8 = /*#__PURE__*/ $lldlC.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $5eed20d16fad0e34$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $5eed20d16fad0e34$var$_objectWithoutPropertiesLoose(_ref9, $5eed20d16fad0e34$var$_excluded3);
    let submit = $5eed20d16fad0e34$export$47c85c6e3a081d3();
    let formAction = $5eed20d16fad0e34$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $lldlC.createElement("form", $5eed20d16fad0e34$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $5eed20d16fad0e34$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $5eed20d16fad0e34$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $5eed20d16fad0e34$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($5eed20d16fad0e34$var$DataRouterHook || ($5eed20d16fad0e34$var$DataRouterHook = {}));
var $5eed20d16fad0e34$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($5eed20d16fad0e34$var$DataRouterStateHook || ($5eed20d16fad0e34$var$DataRouterStateHook = {}));
// Internal hooks
function $5eed20d16fad0e34$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5eed20d16fad0e34$var$useDataRouterContext(hookName) {
    let ctx = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$3add0d5dce533e2e));
    !ctx && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $5eed20d16fad0e34$var$useDataRouterState(hookName) {
    let state = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$145dfa71566a64dc));
    !state && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $5eed20d16fad0e34$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $20bbbf7d5bcb0a93$export$9770f232ac06a008)();
    let location = (0, $20bbbf7d5bcb0a93$export$45d76561a5302f2b)();
    let path = (0, $20bbbf7d5bcb0a93$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $lldlC.useCallback((event)=>{
        if ($5eed20d16fad0e34$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $33fb5de7ebafcf6c$export$fe53371bee54353d)(location) === (0, $33fb5de7ebafcf6c$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $5eed20d16fad0e34$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $lldlC.useRef($5eed20d16fad0e34$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $lldlC.useRef(false);
    let location = (0, $20bbbf7d5bcb0a93$export$45d76561a5302f2b)();
    let searchParams = $lldlC.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $5eed20d16fad0e34$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $20bbbf7d5bcb0a93$export$9770f232ac06a008)();
    let setSearchParams = $lldlC.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $5eed20d16fad0e34$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $5eed20d16fad0e34$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $5eed20d16fad0e34$var$fetcherId = 0;
let $5eed20d16fad0e34$var$getUniqueFetcherId = ()=>"__" + String(++$5eed20d16fad0e34$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $5eed20d16fad0e34$export$47c85c6e3a081d3() {
    let { router: router } = $5eed20d16fad0e34$var$useDataRouterContext($5eed20d16fad0e34$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$26749e8557646306));
    let currentRouteId = (0, $20bbbf7d5bcb0a93$export$5fc8298006ad9e58)();
    return $lldlC.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $5eed20d16fad0e34$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5eed20d16fad0e34$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $5eed20d16fad0e34$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $5eed20d16fad0e34$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$26749e8557646306));
    let routeContext = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$9072aa6dd1f93057));
    !routeContext && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $5eed20d16fad0e34$var$_extends({}, (0, $20bbbf7d5bcb0a93$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $20bbbf7d5bcb0a93$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $33fb5de7ebafcf6c$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $33fb5de7ebafcf6c$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $5eed20d16fad0e34$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $5eed20d16fad0e34$var$useDataRouterContext($5eed20d16fad0e34$var$DataRouterHook.UseFetcher);
    let state = $5eed20d16fad0e34$var$useDataRouterState($5eed20d16fad0e34$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $lldlC.useContext($5eed20d16fad0e34$export$148fd98d095596d4);
    let route = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    !route && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $5eed20d16fad0e34$var$useIdImpl ? $5eed20d16fad0e34$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $lldlC.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($5eed20d16fad0e34$var$getUniqueFetcherId());
    // Registration/cleanup
    $lldlC.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $lldlC.useCallback((href, opts)=>{
        !routeId && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $5eed20d16fad0e34$export$47c85c6e3a081d3();
    let submit = $lldlC.useCallback((target, opts)=>{
        submitImpl(target, $5eed20d16fad0e34$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $lldlC.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $lldlC.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $lldlC.createElement($5eed20d16fad0e34$export$a7fed597f4b8afd8, $5eed20d16fad0e34$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $33fb5de7ebafcf6c$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $lldlC.useMemo(()=>$5eed20d16fad0e34$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $5eed20d16fad0e34$export$fa996778a3a31087() {
    let state = $5eed20d16fad0e34$var$useDataRouterState($5eed20d16fad0e34$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $5eed20d16fad0e34$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $5eed20d16fad0e34$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $5eed20d16fad0e34$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $5eed20d16fad0e34$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $5eed20d16fad0e34$var$useDataRouterContext($5eed20d16fad0e34$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5eed20d16fad0e34$var$useDataRouterState($5eed20d16fad0e34$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $lldlC.useContext((0, $20bbbf7d5bcb0a93$export$26749e8557646306));
    let location = (0, $20bbbf7d5bcb0a93$export$45d76561a5302f2b)();
    let matches = (0, $20bbbf7d5bcb0a93$export$2378eb7f5ff86053)();
    let navigation = (0, $20bbbf7d5bcb0a93$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $lldlC.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $5eed20d16fad0e34$var$usePageHide($lldlC.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $5eed20d16fad0e34$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5eed20d16fad0e34$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5eed20d16fad0e34$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lldlC.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5eed20d16fad0e34$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5eed20d16fad0e34$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lldlC.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($5eed20d16fad0e34$var$_extends({}, location, {
                    pathname: (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($5eed20d16fad0e34$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lldlC.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $5eed20d16fad0e34$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $lldlC.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $5eed20d16fad0e34$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $lldlC.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $5eed20d16fad0e34$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $20bbbf7d5bcb0a93$export$b273b3273281a049)(when);
    $lldlC.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lldlC.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $5eed20d16fad0e34$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $lldlC.useContext($5eed20d16fad0e34$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $33fb5de7ebafcf6c$export$3e9cee6b33872309)(false);
    let { basename: basename } = $5eed20d16fad0e34$var$useDataRouterContext($5eed20d16fad0e34$var$DataRouterHook.useViewTransitionState);
    let path = (0, $20bbbf7d5bcb0a93$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $33fb5de7ebafcf6c$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $33fb5de7ebafcf6c$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $33fb5de7ebafcf6c$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}












var $lldlC = parcelRequire("lldlC");
const $592a0f3ddb09dd65$var$PortalContext = /*#__PURE__*/ (0, $lldlC.createContext)(undefined);
const $592a0f3ddb09dd65$export$6df4068a17305b10 = ({ isAdminPortal: isAdminPortal, children: children })=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($592a0f3ddb09dd65$var$PortalContext.Provider, {
        value: {
            isAdminPortal: isAdminPortal
        },
        children: children
    });
};
function $592a0f3ddb09dd65$export$b1072f43c67b540c() {
    const context = (0, $lldlC.useContext)($592a0f3ddb09dd65$var$PortalContext);
    if (context === undefined) throw new Error("usePortal must be used within a PortalProvider");
    return context;
}


const $262cbea1b43a894e$var$schema = {
    type: "object",
    properties: {
        email: {
            type: "string"
        },
        password: {
            type: "string"
        }
    }
};
const $262cbea1b43a894e$export$3d423776c18897a = (props)=>{
    const [info, setInfo] = (0, $lldlC.useState)({
        email: "",
        password: ""
    });
    const [busy, setBusy] = (0, $lldlC.useState)(false);
    const validation = (0, $357e45f6f4caf5e7$export$87fe492f99f25a20)(info, $262cbea1b43a894e$var$schema);
    const { user: user } = (0, $45ef3258e41ae9d6$export$1d39dc5b47e56ff0)();
    const { isAdminPortal: isAdminPortal } = (0, $592a0f3ddb09dd65$export$b1072f43c67b540c)();
    const onLogin = async ()=>{
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $827e1caa20d65a4f$export$555508cbc6add439)((0, $add0fd9ad07e71af$export$b4ae2c1c09f3f2c6), info.email, info.password),
            loadingMessage: `Logging in..`,
            setBusyFlag: (busy)=>setBusy(busy),
            successMessage: "Successfully logged in"
        });
    };
    const handleGoogleSignIn = async ()=>{
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $20aadb388675cc69$export$4118493e57cd9489)(),
            loadingMessage: `Logging in..`,
            setBusyFlag: (busy)=>setBusy(busy),
            successMessage: "Successfully logged in"
        });
    };
    const handleMicrosoftSignIn = async ()=>{
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $7a4e386e8653215f$export$9af0e352c79e17a4)(),
            loadingMessage: `Logging in..`,
            setBusyFlag: (busy)=>setBusy(busy),
            successMessage: "Successfully logged in"
        });
    };
    if (user) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        children: [
            "Already logged-in as ",
            user.email,
            "."
        ]
    });
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "login-widget",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "form-header",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "heading",
                        children: "Login"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "sub-heading",
                        children: "Login with your personal email to manage your organisation\u2019s work email addresses."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $2ca4aa9d03086c70$export$a7fed597f4b8afd8), {
                type: "default",
                submit: {
                    label: "Login",
                    handler: onLogin
                },
                validationResult: validation,
                loading: busy,
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $2fee28811b42ff9c$export$519cf571a2a32ad4), {
                        validation: validation.properties.email,
                        label: "Username",
                        value: info.email,
                        additionalClassNames: "input-label",
                        onChange: (value)=>setInfo((prev)=>({
                                    ...prev,
                                    email: value
                                })),
                        type: "email",
                        dataCy: "auth-email"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $2fee28811b42ff9c$export$519cf571a2a32ad4), {
                        validation: validation.properties.password,
                        label: "Password",
                        value: info.password,
                        additionalClassNames: "input-label",
                        onChange: (value)=>setInfo((prev)=>({
                                    ...prev,
                                    password: value
                                })),
                        type: "password",
                        dataCy: "auth-password"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $5eed20d16fad0e34$export$a6c7ac8248d6e38a), {
                        to: "/forget-password",
                        className: "forget-password",
                        children: "Forgot password?"
                    })
                ]
            }),
            isAdminPortal && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "form-actions",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "divider",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "rectangle"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "or",
                                children: "or"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "rectangle"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: "card-button",
                        onClick: handleGoogleSignIn,
                        children: "Login with Google"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: "card-button",
                        onClick: handleMicrosoftSignIn,
                        children: "Login with Outlook"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "signup-message",
                        children: [
                            "Do not have an account?\xa0",
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                onClick: props.onChange,
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                                    href: "#",
                                    children: "Sign up"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $lldlC = parcelRequire("lldlC");









const $f7391967127461aa$var$signupInfoSchema = {
    type: "object",
    properties: {
        email: {
            type: "string"
        },
        password: {
            type: "string"
        },
        confirmPassword: {
            type: "string",
            validationFn: (args)=>{
                const form = args.parent;
                if (form.password != form.confirmPassword) return {
                    errorMessage: "Passwords do not match"
                };
            }
        }
    }
};
const $f7391967127461aa$export$93cf0349a782b585 = (props)=>{
    //
    const [info, setInfo] = (0, $lldlC.useState)({
        email: "",
        password: "",
        confirmPassword: ""
    });
    const [busy, setBusy] = (0, $lldlC.useState)(false);
    const validation = (0, $357e45f6f4caf5e7$export$87fe492f99f25a20)(info, $f7391967127461aa$var$signupInfoSchema);
    const onSubmit = async ()=>{
        // create
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $827e1caa20d65a4f$export$7910e0436ed8d1de)((0, $add0fd9ad07e71af$export$b4ae2c1c09f3f2c6), info.email, info.password),
            loadingMessage: `Signing up..`,
            setBusyFlag: (busy)=>setBusy(busy),
            onSuccess: (result)=>{
                (0, $827e1caa20d65a4f$export$ee7c8ad385a60b7b)(result.user);
                (0, $4d0abda1dc9c23ff$exports.toast).success("A verification email has been sent to your email. Please check your inbox to continue.");
            },
            onError: (e)=>{
                if (e instanceof (0, $59fdd18afb377ad5$export$dd24e9cd51226c56)) switch(e.code){
                    case "auth/email-already-in-use":
                        (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).info("Email already exists. Login instead.");
                        return;
                }
            }
        });
    };
    const handleGoogleSignIn = async ()=>{
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $20aadb388675cc69$export$4118493e57cd9489)(),
            loadingMessage: `Logging in..`,
            setBusyFlag: (busy)=>setBusy(busy),
            successMessage: "Successfully logged in"
        });
    };
    const handleMicrosoftSignIn = async ()=>{
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $7a4e386e8653215f$export$9af0e352c79e17a4)(),
            loadingMessage: `Logging in..`,
            setBusyFlag: (busy)=>setBusy(busy),
            successMessage: "Successfully logged in"
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "signup-widget",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "form-header",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "heading",
                        children: "Signup"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "sub-heading",
                        children: "Signup with your personal email to setup your organisation\u2019s work email."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $2ca4aa9d03086c70$export$a7fed597f4b8afd8), {
                type: "default",
                submit: {
                    label: "Signup",
                    handler: onSubmit
                },
                validationResult: validation,
                loading: busy,
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $2fee28811b42ff9c$export$519cf571a2a32ad4), {
                        validation: validation.properties.email,
                        label: "Email",
                        value: info.email,
                        additionalClassNames: "input-label",
                        onChange: (value)=>setInfo((prev)=>({
                                    ...prev,
                                    email: value
                                })),
                        type: "email",
                        dataCy: "auth-email"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $2fee28811b42ff9c$export$519cf571a2a32ad4), {
                        validation: validation.properties.password,
                        label: "Password",
                        value: info.password,
                        additionalClassNames: "input-label",
                        onChange: (value)=>setInfo((prev)=>({
                                    ...prev,
                                    password: value
                                })),
                        type: "password",
                        dataCy: "auth-password"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $2fee28811b42ff9c$export$519cf571a2a32ad4), {
                        label: "Confirm Password",
                        value: info.confirmPassword,
                        additionalClassNames: "input-label",
                        validation: validation.properties.confirmPassword,
                        onChange: (value)=>setInfo((prev)=>({
                                    ...prev,
                                    confirmPassword: value
                                })),
                        type: "password",
                        dataCy: "auth-confirm-password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "form-actions",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "divider",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "rectangle"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "or",
                                children: "or"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "rectangle"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: "card-button",
                        onClick: handleGoogleSignIn,
                        children: "Signup with Google"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: "card-button",
                        onClick: handleMicrosoftSignIn,
                        children: "Signup with Outlook"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "login-message",
                        children: [
                            "Already have an account?\xa0",
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                onClick: props.onChange,
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                                    href: "#",
                                    children: "Login"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




const $d1368fba386d3d93$export$1884a2df5920bfd5 = (props)=>{
    const auth = (0, $45ef3258e41ae9d6$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "email-verify-widget",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "form-header",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "heading",
                        children: "Email Verification"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "sub-heading",
                        children: [
                            "Please click on the verification link sent to ",
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                className: "mail",
                                children: props.email
                            }),
                            " to complete the signup process."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "form-actions",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: "primary",
                        onClick: ()=>{
                            window.location.reload();
                        },
                        children: "It's done!"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: "card-button",
                        onClick: ()=>{
                            auth.logout();
                        },
                        children: "Logout"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "resend-email-message",
                        children: [
                            "No email in your inbox or spam folder?\xa0",
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                onClick: ()=>{},
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                                    href: "#",
                                    children: "Resend Email"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






const $48125029fc620f16$export$ef8da11641c635de = (props)=>{
    const navigateTo = (0, $20bbbf7d5bcb0a93$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "nav-bar",
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "container-items",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "logo",
                            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                                src: props.logo.src,
                                alt: props.logo.alt,
                                onClick: ()=>navigateTo("/")
                            })
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "nav-items",
                            children: props.links.map((link)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("a", {
                                    className: "nav-item",
                                    onClick: link.onClick,
                                    children: link.label
                                }, link.label))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "actions",
                    children: props.actions?.map((action, index)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "action",
                            onClick: action.action,
                            children: action.icon
                        }, index))
                })
            ]
        })
    });
};




var $lldlC = parcelRequire("lldlC");

var $lldlC = parcelRequire("lldlC");


function $1c4fb89e1ab02400$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c4fb89e1ab02400$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c4fb89e1ab02400$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c4fb89e1ab02400$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1c4fb89e1ab02400$var$_extends() {
    $1c4fb89e1ab02400$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c4fb89e1ab02400$var$_extends.apply(this, arguments);
}
function $1c4fb89e1ab02400$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $1c4fb89e1ab02400$var$_setPrototypeOf(subClass, superClass);
}
function $1c4fb89e1ab02400$var$_setPrototypeOf(o, p) {
    $1c4fb89e1ab02400$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1c4fb89e1ab02400$var$_setPrototypeOf(o, p);
}
function $1c4fb89e1ab02400$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1c4fb89e1ab02400$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1c4fb89e1ab02400$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1c4fb89e1ab02400$var$_arrayLikeToArray(o, minLen);
}
function $1c4fb89e1ab02400$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1c4fb89e1ab02400$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1c4fb89e1ab02400$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Utility hook to track the reference of a html-element.
 * It notifies the listener when a change occured, so it can act
 * on the change
 */ function $1c4fb89e1ab02400$var$useTrackRef(onRefChange) {
    var storedReference = (0, $lldlC.useRef)(null); // this is de function that actually gets passed to the `ref` prop
    // on the html element. I.e.:
    // <div ref={setter} />
    function setter(element) {
        if (!element || element === storedReference.current) return;
        storedReference.current = element;
        onRefChange(element);
    }
    return setter;
}
/**
 * Utility hook that stores mutable state.
 * Since a getter function is used, it will always return the most
 * up-to-date state. This is useful when you want to get certain state within
 * an effect, without triggering the same effect when the same state changes.
 * Note: may be seen as an anti-pattern.
 */ function $1c4fb89e1ab02400$var$useMutableStore(initialState) {
    var state = (0, $lldlC.useRef)(initialState);
    return (0, $lldlC.useMemo)(function() {
        function set(setter) {
            if (typeof setter === "function") state.current = setter(state.current);
            else state.current = setter;
        }
        function get() {
            return state.current;
        }
        return [
            get,
            set
        ];
    }, []);
}
/**
 * Utility hook that keeps track of active event listeners and how
 * to remove these listeners
 */ function $1c4fb89e1ab02400$var$useEventSubscriptions() {
    var subscriptions = (0, $lldlC.useRef)([]);
    return (0, $lldlC.useMemo)(function() {
        function hasEventSubscriptions() {
            return subscriptions.current.length > 0;
        }
        function removeAllEventSubscriptions() {
            for(var _iterator = $1c4fb89e1ab02400$var$_createForOfIteratorHelperLoose(subscriptions.current), _step; !(_step = _iterator()).done;){
                var unsubscribe = _step.value;
                unsubscribe();
            }
            subscriptions.current = [];
        }
        function addEventSubscription(unsubscriber) {
            subscriptions.current.push(unsubscriber);
        }
        return {
            hasEventSubscriptions: hasEventSubscriptions,
            removeAllEventSubscriptions: removeAllEventSubscriptions,
            addEventSubscription: addEventSubscription
        };
    }, []);
}
/**
 * SSR-safe effect hook
 */ var $1c4fb89e1ab02400$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $lldlC.useLayoutEffect) : (0, $lldlC.useEffect);
/**
 * Utility hook that tracks an state object.
 * If `enabled=false` it will discard changes and reset the lastState to `null`
 */ function $1c4fb89e1ab02400$var$useLastState(currentState, enabled) {
    var lastState = (0, $lldlC.useRef)(currentState);
    if (!enabled) {
        lastState.current = null;
        return lastState;
    }
    lastState.current = currentState;
    return lastState;
}
var $1c4fb89e1ab02400$var$EMPTY_BOUNDS = {
    top: 0,
    left: 0,
    right: 1,
    bottom: 1,
    width: 1,
    height: 1
};
/**
 * @description Utility hook that lets you use the mouse-position as source of the trigger.
 * This is useful in scenario's like context-menu's.
 *
 * @example
 * ```tsx
 * const {
 *  hasMousePosition,
 *  resetMousePosition,
 *  handleMouseEvent,
 *  trigger
 *  } = useMousePositionAsTrigger();
 *
 * const { renderLayer, layerProps } = useLayer({
 *  isOpen: hasMousePosition,
 *  trigger,
 *  onOutsideClick: resetMousePosition
 * });
 *
 * return (
 *  <>
 *   {isOpen && renderLayer(<div {...layerProps} />)}
 *   <div onContextMenu={handleMouseEvent} />
 *  </>
 * );
 * ```
 */ function $1c4fb89e1ab02400$export$6401212d24ae6231(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$enabled = _ref.enabled, enabled = _ref$enabled === void 0 ? true : _ref$enabled, _ref$preventDefault = _ref.preventDefault, preventDefault = _ref$preventDefault === void 0 ? true : _ref$preventDefault;
    var parentRef = (0, $lldlC.useRef)(null);
    var _useState = (0, $lldlC.useState)($1c4fb89e1ab02400$var$EMPTY_BOUNDS), mouseBounds = _useState[0], setMouseBounds = _useState[1];
    function resetMousePosition() {
        setMouseBounds($1c4fb89e1ab02400$var$EMPTY_BOUNDS);
    }
    var hasMousePosition = mouseBounds !== $1c4fb89e1ab02400$var$EMPTY_BOUNDS;
    function handleMouseEvent(evt) {
        if (!enabled) return;
        if (preventDefault) evt.preventDefault();
        var left = evt.clientX, top = evt.clientY;
        setMouseBounds({
            top: top,
            left: left,
            width: 1,
            height: 1,
            right: left + 1,
            bottom: top + 1
        });
    }
    return {
        hasMousePosition: hasMousePosition,
        resetMousePosition: resetMousePosition,
        handleMouseEvent: handleMouseEvent,
        trigger: {
            getBounds: function getBounds() {
                return mouseBounds;
            },
            getParent: parentRef.current ? function() {
                return parentRef.current;
            } : undefined
        },
        parentRef: parentRef
    };
}
/**
 * Convert a pixel value into a numeric value
 * @param value string value (ie. '12px')
 */ function $1c4fb89e1ab02400$var$getPixelValue(value) {
    return parseFloat(value.replace("px", ""));
}
/**
 * Returns a numeric value that doesn't exceed min or max
 */ function $1c4fb89e1ab02400$var$limit(value, min, max) {
    return value < min ? min : value > max ? max : value;
}
/**
 * Utility function which ensures whether a value is truthy
 */ function $1c4fb89e1ab02400$var$isSet(value) {
    return value === null || value === undefined ? false : true;
}
/**
 * Utility function that let's you assign multiple references to a 'ref' prop
 * @param refs list of MutableRefObject's and / or callbacks
 */ function $1c4fb89e1ab02400$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return function(element) {
        for(var _iterator = $1c4fb89e1ab02400$var$_createForOfIteratorHelperLoose(refs), _step; !(_step = _iterator()).done;){
            var ref = _step.value;
            if (!ref) continue;
            if (typeof ref === "function") ref(element);
            else ref.current = element;
        }
    };
}
/**
 * Utility to get the correct ResizeObserver class
 */ function $1c4fb89e1ab02400$var$getResizeObserver(environment, polyfill) {
    if (typeof environment === "undefined") return undefined;
    return polyfill || environment.ResizeObserver;
}
/**
 * Utility function that given a element traverses up in the html-hierarchy
 * to find and return all ancestors that have scroll behavior
 */ function $1c4fb89e1ab02400$var$findScrollContainers(element, environment) {
    var result = [];
    if (!element || !environment || element === document.body) return result;
    var _environment$getCompu = environment.getComputedStyle(element), overflow = _environment$getCompu.overflow, overflowX = _environment$getCompu.overflowX, overflowY = _environment$getCompu.overflowY;
    if ([
        overflow,
        overflowX,
        overflowY
    ].some(function(prop) {
        return [
            "auto",
            "scroll"
        ].includes(prop);
    })) result.push(element);
    return [].concat(result, $1c4fb89e1ab02400$var$findScrollContainers(element.parentElement, environment));
}
function $1c4fb89e1ab02400$var$createReferenceError(subject) {
    return "react-laag: Could not find a valid reference for the " + subject + " element. There might be 2 causes:\n   - Make sure that the 'ref' is set correctly on the " + subject + " element when isOpen: true. Also make sure your component forwards the ref with \"forwardRef()\".\n   - Make sure that you are actually rendering the " + subject + " when the isOpen prop is set to true";
}
/**
 * This hook has the responsibility to track the bounds of:
 * - the trigger element
 * - the layer element
 * - the arrow element
 * - the scroll-containers of which the trigger element is a descendant of
 *
 * It will call the `onChange` callback with a collection of these elements when any
 * of the tracked elements bounds have changed
 *
 * It will detect these changes by listening:
 * - when the reference of the trigger element changes
 * - when the reference of the layer element changes
 * - when the trigger, layer or document body changes in size
 * - when the user scrolls the page, or any of the scroll containers
 */ function $1c4fb89e1ab02400$var$useTrackElements(_ref) {
    var enabled = _ref.enabled, onChange = _ref.onChange, environment = _ref.environment, ResizeObserverPolyfill = _ref.ResizeObserverPolyfill, overflowContainer = _ref.overflowContainer, triggerOption = _ref.triggerOption;
    // get the correct reference to the ResizeObserver class
    var ResizeObserver = $1c4fb89e1ab02400$var$getResizeObserver(environment, ResizeObserverPolyfill); // warn the user when no valid ResizeObserver class could be found
    (0, $lldlC.useEffect)(function() {}, [
        ResizeObserver
    ]); // keep reference of the optional arrow-component
    var arrowRef = (0, $lldlC.useRef)(null); // if user has provided the trigger-option we should ingore certain things elsewhere
    var hasTriggerOption = Boolean(triggerOption); // Keep track of mutable element related state
    // It is generally better to use React.useState, but unfortunately that causes to many re-renders
    var _useMutableStore = $1c4fb89e1ab02400$var$useMutableStore({
        scrollContainers: [],
        trigger: null,
        layer: null
    }), get = _useMutableStore[0], set = _useMutableStore[1]; // utility to keep track of the scroll and resize listeners and how to unsubscribe them
    var _useEventSubscription = $1c4fb89e1ab02400$var$useEventSubscriptions(), hasEventSubscriptions = _useEventSubscription.hasEventSubscriptions, addEventSubscription = _useEventSubscription.addEventSubscription, removeAllEventSubscriptions = _useEventSubscription.removeAllEventSubscriptions; // All scroll and resize changes eventually end up here, where the collection of bounds (subjectsBounds) is
    // constructed in order to notifiy the `onBoundsChange` callback
    var handleChange = (0, $lldlC.useCallback)(function handleChange() {
        var _get = get(), layer = _get.layer, trigger = _get.trigger, scrollContainers = _get.scrollContainers;
        var closestScrollContainer = scrollContainers[0];
        if (!layer) throw new Error($1c4fb89e1ab02400$var$createReferenceError("layer"));
         // ignore when user has provided the trigger-option
        if (!trigger && !hasTriggerOption) throw new Error($1c4fb89e1ab02400$var$createReferenceError("trigger"));
        var scrollOffsets = {
            top: 0,
            left: 0
        };
        if (closestScrollContainer) {
            var scrollLeft = closestScrollContainer.scrollLeft, scrollTop = closestScrollContainer.scrollTop;
            scrollOffsets = {
                top: scrollTop,
                left: scrollLeft
            };
        } else {
            var scrollX = environment.scrollX, scrollY = environment.scrollY;
            scrollOffsets = {
                top: scrollY,
                left: scrollX
            };
        }
        var borderOffsets = {
            left: 0,
            top: 0
        };
        if (closestScrollContainer) {
            var _environment$getCompu2 = environment.getComputedStyle(closestScrollContainer), borderLeftWidth = _environment$getCompu2.borderLeftWidth, borderTopWidth = _environment$getCompu2.borderTopWidth;
            borderOffsets = {
                left: $1c4fb89e1ab02400$var$getPixelValue(borderLeftWidth) || 0,
                top: $1c4fb89e1ab02400$var$getPixelValue(borderTopWidth) || 0
            };
        }
        onChange({
            layer: layer,
            trigger: trigger,
            scrollContainers: scrollContainers,
            arrow: arrowRef.current
        }, scrollOffsets, borderOffsets);
    }, [
        get,
        onChange,
        environment,
        arrowRef,
        hasTriggerOption
    ]); // responsible for adding the scroll and resize listeners to the correct
    // html elements
    var addEventListeners = (0, $lldlC.useCallback)(function addEventListeners() {
        var _get2 = get(), trigger = _get2.trigger, layer = _get2.layer, scrollContainers = _get2.scrollContainers;
        if (!layer) throw new Error($1c4fb89e1ab02400$var$createReferenceError("layer"));
        if (!trigger && !hasTriggerOption) // ignore when user has provided the trigger-option
        throw new Error($1c4fb89e1ab02400$var$createReferenceError("trigger"));
        if (ResizeObserver) {
            var ignoredInitialCall = false;
            var observerCallback = function observerCallback() {
                if (!ignoredInitialCall) {
                    ignoredInitialCall = true;
                    return;
                }
                handleChange();
            };
            var observer = new ResizeObserver(observerCallback);
            for(var _i = 0, _arr = [
                trigger,
                layer,
                document.body
            ]; _i < _arr.length; _i++){
                var element = _arr[_i];
                if (element) observer.observe(element);
            }
            addEventSubscription(function() {
                for(var _i2 = 0, _arr2 = [
                    trigger,
                    layer,
                    document.body
                ]; _i2 < _arr2.length; _i2++){
                    var _element = _arr2[_i2];
                    if (_element) observer.unobserve(_element);
                }
                observer.disconnect();
            });
        }
        var listenForScrollElements = [
            environment
        ].concat(scrollContainers);
        var _loop = function _loop() {
            var element = _step.value;
            element.addEventListener("scroll", handleChange);
            addEventSubscription(function() {
                return element.removeEventListener("scroll", handleChange);
            });
        };
        for(var _iterator = $1c4fb89e1ab02400$var$_createForOfIteratorHelperLoose(listenForScrollElements), _step; !(_step = _iterator()).done;)_loop();
    }, [
        get,
        addEventSubscription,
        handleChange,
        environment,
        ResizeObserver,
        hasTriggerOption
    ]); // when either the reference to the trigger or layer element changes
    // we should reset the event listeners and trigger a `onChange`
    var resetWhenReferenceChangedWhileTracking = (0, $lldlC.useCallback)(function(previous, next) {
        if (enabled && previous && previous !== next) {
            removeAllEventSubscriptions();
            addEventListeners();
            handleChange();
        }
    }, [
        removeAllEventSubscriptions,
        addEventListeners,
        handleChange,
        enabled
    ]); // Logic when reference to layer changes
    var layerRef = $1c4fb89e1ab02400$var$useTrackRef((0, $lldlC.useCallback)(function(layer) {
        var _get3 = get(), previousLayer = _get3.layer; // store new reference
        set(function(state) {
            return $1c4fb89e1ab02400$var$_extends({}, state, {
                layer: layer
            });
        }); // check if we should reset the event listeners
        resetWhenReferenceChangedWhileTracking(previousLayer, layer);
    }, [
        get,
        set,
        resetWhenReferenceChangedWhileTracking
    ]));
    var getScrollContainers = (0, $lldlC.useCallback)(function handleScrollContainers(element) {
        var scrollContainers = $1c4fb89e1ab02400$var$findScrollContainers(element, environment);
        var closestScrollContainer = scrollContainers[0];
        if (closestScrollContainer) {
            // Check if we should warn the user about 'position: relative; stuff...'
            var position = environment.getComputedStyle(closestScrollContainer).position;
            var closestScrollContainerHasCorrectStyling = [
                "relative",
                "absolute",
                "fixed"
            ].includes(position) || overflowContainer;
            if (!closestScrollContainerHasCorrectStyling) closestScrollContainer.style.position = "relative";
        }
        return scrollContainers;
    }, [
        environment,
        overflowContainer
    ]); // Logic when reference to trigger changes
    // Note: this will have no effect when user provided the trigger-option
    var triggerRef = $1c4fb89e1ab02400$var$useTrackRef((0, $lldlC.useCallback)(function(trigger) {
        // collect list of scroll containers
        var scrollContainers = getScrollContainers(trigger);
        var _get4 = get(), previousTrigger = _get4.trigger; // store new references
        set(function(state) {
            return $1c4fb89e1ab02400$var$_extends({}, state, {
                trigger: trigger,
                scrollContainers: scrollContainers
            });
        }); // check if we should reset the event listeners
        resetWhenReferenceChangedWhileTracking(previousTrigger, trigger);
    }, [
        get,
        set,
        resetWhenReferenceChangedWhileTracking,
        getScrollContainers
    ])); // when user has provided the trigger-option, it monitors the optional parent-element
    // in order to determine the scroll-containers
    var triggerOptionParent = triggerOption == null ? void 0 : triggerOption.getParent == null ? void 0 : triggerOption.getParent();
    $1c4fb89e1ab02400$var$useIsomorphicLayoutEffect(function() {
        if (!triggerOptionParent) return;
        set(function(state) {
            return $1c4fb89e1ab02400$var$_extends({}, state, {
                scrollContainers: getScrollContainers(triggerOptionParent)
            });
        });
    }, [
        triggerOptionParent,
        set,
        getScrollContainers
    ]);
    $1c4fb89e1ab02400$var$useIsomorphicLayoutEffect(function() {
        if (enabled) // add event listeners if necessary
        {
            if (!hasEventSubscriptions()) addEventListeners();
        }
        return function() {
            if (hasEventSubscriptions()) removeAllEventSubscriptions();
        };
    }, [
        enabled,
        hasEventSubscriptions,
        addEventListeners,
        removeAllEventSubscriptions
    ]); // run this effect after every render
    $1c4fb89e1ab02400$var$useIsomorphicLayoutEffect(function() {
        if (enabled) // eventually call `handleChange` with latest elements-refs
        handleChange();
    });
    return {
        triggerRef: triggerRef,
        layerRef: layerRef,
        arrowRef: arrowRef,
        closestScrollContainer: get().scrollContainers[0] || null
    };
}
var $1c4fb89e1ab02400$var$GroupContext = /*#__PURE__*/ (0, $lldlC.createContext)({}); // Provider that wraps arround the layer in order to provide other useLayers
// down in the hiearchy (child layers) with means to communicate with the parent.
// This provider receives a `registrations` Set which can be used to add and
// delete registrations.
function $1c4fb89e1ab02400$var$GroupProvider(_ref) {
    var children = _ref.children, registrations = _ref.registrations;
    // registration function that is used as 'context payload' for child layers
    // to call. It returns a function to unregister.
    var handleRegister = (0, $lldlC.useCallback)(function register(registration) {
        registrations.current.add(registration);
        return function() {
            return registrations.current.delete(registration);
        };
    }, [
        registrations
    ]);
    return (0, $lldlC.createElement)($1c4fb89e1ab02400$var$GroupContext.Provider, {
        value: handleRegister
    }, children);
} // asks child layers if they would close given the documents click event
// if there's one that signals not to close, return early (false)
function $1c4fb89e1ab02400$var$getShouldCloseAccordingToChildren(registrations, event) {
    for(var _iterator = $1c4fb89e1ab02400$var$_createForOfIteratorHelperLoose(registrations), _step; !(_step = _iterator()).done;){
        var shouldCloseWhenClickedOutside = _step.value.shouldCloseWhenClickedOutside;
        if (!shouldCloseWhenClickedOutside(event)) return false;
    }
    return true;
}
/**
 * Responsible for close behavior
 * When the `onOutsideClick` callback is provided by the user, it will listen for clicks
 * in the document, and tell whether the user clicked outside -> not on layer / trigger.
 * It keeps track of nested useLayers a.k.a child layers (`registrations` Set), through which
 * we can ask whether they `shouldCloseWhenClickedOutside`, or tell them to close.
 *
 * Behavior:
 * - `onOutsideClick` only works on the most outer parent, and not on children. The parent will ask
 *   the child layers whether they would close, and will handle accordingly. The parent may
 *   command the children to close indirectly with the help of `onParentClose`
 * - When the parent just was closed, it will make sure that any children will also close
 *   with the help of `onParentClose`
 */ function $1c4fb89e1ab02400$var$useGroup(_ref2) {
    var isOpen = _ref2.isOpen, onOutsideClick = _ref2.onOutsideClick, onParentClose = _ref2.onParentClose;
    // store references to the dom-elements
    // we need these to later determine wether the clicked outside or not
    var trigger = (0, $lldlC.useRef)(null);
    var layer = (0, $lldlC.useRef)(null); // a Set which keeps track of callbacks given by the child layers through context
    var registrations = (0, $lldlC.useRef)(new Set()); // if this instance is a child itself, we should use this function to register
    // some callbacks to the parent
    var possibleRegisterFn = (0, $lldlC.useContext)($1c4fb89e1ab02400$var$GroupContext); // recursively checks whether to close or not. This mechanism has some similarities
    // with event bubbling.
    var shouldCloseWhenClickedOutside = (0, $lldlC.useCallback)(function shouldCloseWhenClickedOutside(event) {
        var target = event.target;
        var clickedOnTrigger = trigger.current && trigger.current.contains(target);
        var clickedOnLayer = layer.current && layer.current.contains(target);
        var shouldCloseAccordingToChildren = $1c4fb89e1ab02400$var$getShouldCloseAccordingToChildren(registrations.current, event); // when clicked on own layer, but the child would have closed ->
        // let child close
        if (clickedOnLayer && shouldCloseAccordingToChildren) registrations.current.forEach(function(_ref3) {
            var closeChild = _ref3.closeChild;
            return closeChild();
        });
        return !clickedOnTrigger && !clickedOnLayer && shouldCloseAccordingToChildren;
    }, [
        trigger,
        layer,
        registrations
    ]); // registration stuff
    (0, $lldlC.useEffect)(function() {
        if (typeof possibleRegisterFn !== "function") return;
         // 'possibleRegisterFn' will return a function that will unregister
        // on cleanup
        return possibleRegisterFn({
            shouldCloseWhenClickedOutside: shouldCloseWhenClickedOutside,
            closeChild: function closeChild() {
                if (onParentClose) onParentClose();
            }
        });
    }, [
        possibleRegisterFn,
        shouldCloseWhenClickedOutside,
        onParentClose,
        registrations
    ]); // document click handling
    (0, $lldlC.useEffect)(function() {
        var isChild = typeof possibleRegisterFn === "function";
        var shouldNotListen = !isOpen || !onOutsideClick || isChild;
        if (shouldNotListen) return;
        function handleClick(event) {
            if (shouldCloseWhenClickedOutside(event)) onOutsideClick();
        }
        document.addEventListener("click", handleClick, true);
        return function() {
            return document.removeEventListener("click", handleClick, true);
        };
    }, [
        isOpen,
        onOutsideClick,
        shouldCloseWhenClickedOutside,
        possibleRegisterFn
    ]); // When this 'useLayer' gets closed -> tell child layers to close as well
    (0, $lldlC.useEffect)(function() {
        if (!isOpen) registrations.current.forEach(function(_ref4) {
            var closeChild = _ref4.closeChild;
            return closeChild();
        });
    }, [
        isOpen
    ]);
    return {
        closeOnOutsideClickRefs: {
            trigger: trigger,
            layer: layer
        },
        registrations: registrations
    };
}
var $1c4fb89e1ab02400$export$e7d486c3403374a0 = [
    "bottom-start",
    "bottom-end",
    "bottom-center",
    "top-start",
    "top-center",
    "top-end",
    "left-end",
    "left-center",
    "left-start",
    "right-end",
    "right-center",
    "right-start",
    "center"
];
var $1c4fb89e1ab02400$var$OPPOSITES = {
    top: "bottom",
    left: "right",
    bottom: "top",
    right: "left",
    center: "center"
};
var $1c4fb89e1ab02400$var$SideBase = /*#__PURE__*/ function() {
    function SideBase(prop, opposite, isHorizontal, sizeProp, oppositeSizeProp, cssProp, oppositeCssProp, isCenter, isPush // left | top
    ) {
        this.prop = void 0;
        this.opposite = void 0;
        this.isHorizontal = void 0;
        this.sizeProp = void 0;
        this.oppositeSizeProp = void 0;
        this.cssProp = void 0;
        this.oppositeCssProp = void 0;
        this.isCenter = void 0;
        this.isPush = void 0;
        this.prop = prop;
        this.opposite = opposite;
        this.isHorizontal = isHorizontal;
        this.sizeProp = sizeProp;
        this.oppositeSizeProp = oppositeSizeProp;
        this.cssProp = cssProp;
        this.oppositeCssProp = oppositeCssProp;
        this.isCenter = isCenter;
        this.isPush = isPush;
    }
    var _proto = SideBase.prototype;
    _proto.factor = function factor(value) {
        return value * (this.isPush ? 1 : -1);
    };
    _proto.isOppositeDirection = function isOppositeDirection(side) {
        return this.isHorizontal !== side.isHorizontal;
    };
    return SideBase;
}();
function $1c4fb89e1ab02400$var$createSide(prop, recursive) {
    if (recursive === void 0) recursive = true;
    var isHorizontal = [
        "left",
        "right"
    ].includes(prop);
    return new $1c4fb89e1ab02400$var$SideBase(prop, recursive ? $1c4fb89e1ab02400$var$createSide($1c4fb89e1ab02400$var$OPPOSITES[prop], false) : null, isHorizontal, isHorizontal ? "width" : "height", isHorizontal ? "height" : "width", isHorizontal ? "left" : "top", isHorizontal ? "top" : "left", prop === "center", ![
        "right",
        "bottom"
    ].includes(prop));
}
var $1c4fb89e1ab02400$var$BoundSide = {
    top: /*#__PURE__*/ $1c4fb89e1ab02400$var$createSide("top"),
    bottom: /*#__PURE__*/ $1c4fb89e1ab02400$var$createSide("bottom"),
    left: /*#__PURE__*/ $1c4fb89e1ab02400$var$createSide("left"),
    right: /*#__PURE__*/ $1c4fb89e1ab02400$var$createSide("right")
};
var $1c4fb89e1ab02400$var$Side = /*#__PURE__*/ $1c4fb89e1ab02400$var$_extends({}, $1c4fb89e1ab02400$var$BoundSide, {
    center: /*#__PURE__*/ $1c4fb89e1ab02400$var$createSide("center")
});
var $1c4fb89e1ab02400$var$SIDES = [
    "top",
    "left",
    "bottom",
    "right"
];
/**
 * A class containing the positional properties which represent the distance
 * between two Bounds instances for each side
 */ var $1c4fb89e1ab02400$var$BoundsOffsets = /*#__PURE__*/ function() {
    function BoundsOffsets(offsets) {
        this.top = void 0;
        this.left = void 0;
        this.right = void 0;
        this.bottom = void 0;
        return Object.assign(this, offsets);
    }
    /**
   * Takes multiple BoundsOffets instances and creates a new BoundsOffsets instance
   * by taking the smallest value for each side
   * @param boundsOffsets list of BoundsOffsets instances
   */ BoundsOffsets.mergeSmallestSides = function mergeSmallestSides(boundsOffsets) {
        var first = boundsOffsets[0], rest = boundsOffsets.slice(1);
        if (!first) throw new Error("Please provide at least 1 bounds objects in order to merge");
        var result = Object.fromEntries($1c4fb89e1ab02400$var$SIDES.map(function(side) {
            return [
                side,
                first[side]
            ];
        }));
        for(var _iterator = $1c4fb89e1ab02400$var$_createForOfIteratorHelperLoose(rest), _step; !(_step = _iterator()).done;){
            var boundsOffset = _step.value;
            for(var _iterator2 = $1c4fb89e1ab02400$var$_createForOfIteratorHelperLoose($1c4fb89e1ab02400$var$SIDES), _step2; !(_step2 = _iterator2()).done;){
                var side = _step2.value;
                result[side] = Math.min(result[side], boundsOffset[side]);
            }
        }
        return new BoundsOffsets(result);
    } /**
   * Checks whether all sides sides are positive, meaning the corresponding Bounds instance
   * fits perfectly within a parent Bounds instance
   */ ;
    $1c4fb89e1ab02400$var$_createClass(BoundsOffsets, [
        {
            key: "allSidesArePositive",
            get: function get() {
                var _this = this;
                return $1c4fb89e1ab02400$var$SIDES.every(function(side) {
                    return _this[side] >= 0;
                });
            }
        },
        {
            key: "negativeSides",
            get: function get() {
                var _this2 = this;
                return Object.fromEntries($1c4fb89e1ab02400$var$SIDES.filter(function(side) {
                    return _this2[side] < 0;
                }).map(function(side) {
                    return [
                        side,
                        _this2[side]
                    ];
                }));
            }
        }
    ]);
    return BoundsOffsets;
}();
/**
 * Utility function that returns sum of various computed styles
 * @param propertyValues list of computed styles (ie. '12px')
 */ function $1c4fb89e1ab02400$var$sumOfPropertyValues() {
    for(var _len = arguments.length, propertyValues = new Array(_len), _key = 0; _key < _len; _key++)propertyValues[_key] = arguments[_key];
    return propertyValues.reduce(function(sum, propertyValue) {
        return sum + (propertyValue ? $1c4fb89e1ab02400$var$getPixelValue(propertyValue) : 0);
    }, 0);
}
function $1c4fb89e1ab02400$var$boundsToObject(_ref) {
    var top = _ref.top, left = _ref.left, right = _ref.right, bottom = _ref.bottom, width = _ref.width, height = _ref.height;
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: width,
        height: height
    };
}
var $1c4fb89e1ab02400$var$EMPTY = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
};
/**
 * A class containing the positional properties of the native DOM's ClientRect
 * (`element.getBoundingClientRect()`), together with some utility methods
 */ var $1c4fb89e1ab02400$var$Bounds = /*#__PURE__*/ function() {
    /**
   * Creates a new Bounds class
   * @param bounds An object that adheres to the `IBounds` interface
   */ Bounds.create = function create(bounds) {
        return new Bounds(bounds);
    } /**
   * Creates a new Bounds class from a DOM-element
   * @param element reference to the DOM-element
   * @param options optional options object
   */ ;
    Bounds.fromElement = function fromElement(element, options) {
        if (options === void 0) options = {};
        var _options = options, _options$withTransfor = _options.withTransform, withTransform = _options$withTransfor === void 0 ? true : _options$withTransfor, _options$environment = _options.environment, environment = _options$environment === void 0 ? window : _options$environment, _options$withScrollba = _options.withScrollbars, withScrollbars = _options$withScrollba === void 0 ? true : _options$withScrollba;
        var plain = $1c4fb89e1ab02400$var$boundsToObject(element.getBoundingClientRect());
        var bounds = new Bounds(plain);
        if (!withTransform) {
            var _environment$getCompu = environment.getComputedStyle(element), width = _environment$getCompu.width, height = _environment$getCompu.height, boxSizing = _environment$getCompu.boxSizing, borderLeft = _environment$getCompu.borderLeft, borderRight = _environment$getCompu.borderRight, borderTop = _environment$getCompu.borderTop, borderBottom = _environment$getCompu.borderBottom, paddingLeft = _environment$getCompu.paddingLeft, paddingRight = _environment$getCompu.paddingRight, paddingTop = _environment$getCompu.paddingTop, paddingBottom = _environment$getCompu.paddingBottom;
            var boxWidth = boxSizing === "border-box" ? $1c4fb89e1ab02400$var$getPixelValue(width) : $1c4fb89e1ab02400$var$sumOfPropertyValues(width, borderLeft, borderRight, paddingLeft, paddingRight);
            var boxHeight = boxSizing === "border-box" ? $1c4fb89e1ab02400$var$getPixelValue(height) : $1c4fb89e1ab02400$var$sumOfPropertyValues(height, borderTop, borderBottom, paddingTop, paddingBottom);
            bounds = new Bounds($1c4fb89e1ab02400$var$_extends({}, bounds, {
                width: boxWidth,
                height: boxHeight
            }));
        }
        if (!withScrollbars) {
            var scrollbarWidth = bounds.width - element.clientWidth;
            var scrollbarHeight = bounds.height - element.clientHeight;
            return bounds.substract({
                right: scrollbarWidth,
                bottom: scrollbarHeight
            });
        }
        return bounds;
    } /**
   * Creates an empty Bounds class
   */ ;
    Bounds.empty = function empty() {
        return new Bounds();
    } /**
   * Creates a Bounds class from the window's dimensions
   * @param environment reference to the window-object (needed when working with iframes for instance). Defaults to `window`
   */ ;
    Bounds.fromWindow = function fromWindow(environment) {
        var _environment$document;
        var scrollingElement = (_environment$document = environment == null ? void 0 : environment.document.scrollingElement) != null ? _environment$document : environment == null ? void 0 : environment.document.documentElement;
        var _ref2 = scrollingElement != null ? scrollingElement : {}, _ref2$clientWidth = _ref2.clientWidth, width = _ref2$clientWidth === void 0 ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, height = _ref2$clientHeight === void 0 ? 0 : _ref2$clientHeight;
        return new Bounds({
            width: width,
            height: height,
            right: width,
            bottom: height
        });
    };
    function Bounds(bounds) {
        if (bounds === void 0) bounds = {};
        this.top = void 0;
        this.left = void 0;
        this.right = void 0;
        this.bottom = void 0;
        this.width = void 0;
        this.height = void 0;
        return Object.assign(this, $1c4fb89e1ab02400$var$EMPTY, bounds);
    }
    /**
   * Returns the square surface of the bounds in pixels
   */ var _proto = Bounds.prototype;
    /**
   * Returns a plain object containing only positional properties
   */ _proto.toObject = function toObject() {
        return $1c4fb89e1ab02400$var$boundsToObject(this);
    };
    _proto.merge = function merge(partialBoundsOrMergeFn) {
        var current = this.toObject();
        return new Bounds($1c4fb89e1ab02400$var$_extends({}, current, typeof partialBoundsOrMergeFn === "function" ? partialBoundsOrMergeFn(current) : partialBoundsOrMergeFn));
    } /**
   * Return a new Bounds instance by subtracting each property of the provided IBounds object
   * @param bounds partial IBounds object to substract with
   */ ;
    _proto.substract = function substract(bounds) {
        var result = this.toObject();
        var entries = Object.entries(bounds);
        for(var _i = 0, _entries = entries; _i < _entries.length; _i++){
            var _entries$_i = _entries[_i], prop = _entries$_i[0], value = _entries$_i[1];
            if (prop in $1c4fb89e1ab02400$var$BoundSide) {
                // if `prop` is one of 'top', 'left', 'bottom' or 'right'...
                var boundSide = $1c4fb89e1ab02400$var$BoundSide[prop]; // decide if we should add or substract
                result[prop] += boundSide.factor(value); // make sure that the size-properties are also updated
                result[boundSide.isHorizontal ? "width" : "height"] -= value;
            } else // prop is 'width' or 'height'
            result[prop] -= value || 0;
        }
        return new Bounds(result);
    } /**
   * Returns a new BoundsOffsets instance by determining the distance for each bound-side:
   * (child -> parent)
   * @param child child bounds instance
   */ ;
    _proto.offsetsTo = function offsetsTo(child) {
        return new $1c4fb89e1ab02400$var$BoundsOffsets({
            top: child.top - this.top,
            bottom: this.bottom - child.bottom,
            left: child.left - this.left,
            right: this.right - child.right
        });
    } /**
   * Return a new Bounds instance by mapping over each bound-side
   * @param mapper callback that takes a boundSide + value in pixels, returning a new value for that side
   */ ;
    _proto.mapSides = function mapSides(mapper) {
        var result = this.toObject();
        var boundSides = Object.values($1c4fb89e1ab02400$var$BoundSide);
        for(var _i2 = 0, _boundSides = boundSides; _i2 < _boundSides.length; _i2++){
            var boundSide = _boundSides[_i2];
            result[boundSide.prop] = mapper(boundSide, result[boundSide.prop]);
        }
        return new Bounds(result);
    };
    $1c4fb89e1ab02400$var$_createClass(Bounds, [
        {
            key: "surface",
            get: function get() {
                return this.width * this.height;
            }
        }
    ]);
    return Bounds;
}();
/**
 * Class for various calculations based on a placement-type. I.e 'top-left';
 */ var $1c4fb89e1ab02400$var$Placement = /*#__PURE__*/ function() {
    function Placement(primary, secondary, subjectBounds, layerDimensions, offsets) {
        this.primary = void 0;
        this.secondary = void 0;
        this.offsets = void 0;
        this.subjectsBounds = void 0;
        this._cachedLayerBounds = null;
        this._cachedContainerOffsets = null;
        this.primary = primary;
        this.secondary = secondary;
        this.offsets = offsets;
        this.setSubjectsBounds(subjectBounds, layerDimensions);
    }
    /**
   * Set subjectsBounds that are specific for this placement
   * @param subjectBounds original SubjectBounds instance
   * @param layerDimensions possible config prodvided by the user
   */ var _proto = Placement.prototype;
    _proto.setSubjectsBounds = function setSubjectsBounds(subjectBounds, layerDimensions) {
        // if user did not provide any layerDimensions config...
        if (!layerDimensions) {
            this.subjectsBounds = subjectBounds;
            return;
        } // get anticipated layer-dimensions provided by the user
        var dimensions = // the placement
        typeof layerDimensions === "function" ? layerDimensions(this.primary.prop) : layerDimensions; // create new SubjectsBounds instance by merging our newly create layer-bounds
        this.subjectsBounds = subjectBounds.merge({
            layer: $1c4fb89e1ab02400$var$_extends({}, subjectBounds.layer, dimensions)
        });
    } /**
   * Returns the string respresentation of this placement (ie. 'top-start')
   */ ;
    /**
   * Calculates the actual boundaries based on the placement
   * @param secondaryOffset optional offset on the secondary-side
   */ _proto.getLayerBounds = function getLayerBounds(secondaryOffset) {
        if (secondaryOffset === void 0) secondaryOffset = 0;
        // return cached version if possible
        if (this._cachedLayerBounds && secondaryOffset === 0) return this._cachedLayerBounds;
        var primary = this.primary, secondary = this.secondary, subjectsBounds = this.subjectsBounds;
        var trigger = subjectsBounds.trigger, layer = subjectsBounds.layer, arrow = subjectsBounds.arrow;
        var isHorizontal = primary.isHorizontal, oppositeCssProp = primary.oppositeCssProp, oppositeSizeProp = primary.oppositeSizeProp, prop = primary.prop, opposite = primary.opposite;
        var result = $1c4fb89e1ab02400$var$Bounds.empty(); // let's take the placement 'top-start' as an example...
        // the offsets are the following:
        // trigger -> 8px
        // container -> 10px;
        // arrow -> 2px;
        // PRIMARY STUFF
        // bottom = trigger.top + 8;
        result[opposite.prop] = trigger[prop] - primary.factor(this.offsets.trigger); // top = bottom - layer.height
        result[prop] = result[opposite.prop] - primary.factor(layer[primary.sizeProp]); // SECONDARY STUFF
        // arrowOffsetBase = 4
        var arrowOffsetBase = this.offsets.arrow * 2; // limitMin = trigger.left - (layer.width - arrow.width) + 4
        var limitMin = trigger[oppositeCssProp] - (layer[oppositeSizeProp] - arrow[oppositeSizeProp]) + arrowOffsetBase; // limitMax = trigger.left + (trigger.width - arrow.width) - 4
        var limitMax = trigger[oppositeCssProp] + (trigger[oppositeSizeProp] - arrow[oppositeSizeProp]) - arrowOffsetBase;
        if (!secondary.isPush) {
            // if secondary is bottom or right -> add the width or height of the layer
            limitMin += layer[oppositeSizeProp];
            limitMax += layer[oppositeSizeProp];
        }
        if (secondary.isCenter) {
            var propertyA = (isHorizontal ? $1c4fb89e1ab02400$var$BoundSide.top : $1c4fb89e1ab02400$var$BoundSide.left).prop;
            var propertyB = (isHorizontal ? $1c4fb89e1ab02400$var$BoundSide.bottom : $1c4fb89e1ab02400$var$BoundSide.right).prop; // left = limit(
            //   trigger.left + trigger.width / 2 - layer.width / 2 + secondaryOffset,
            //   limitMin,
            //   limitMax
            // )
            result[propertyA] = $1c4fb89e1ab02400$var$limit(trigger[propertyA] + trigger[oppositeSizeProp] / 2 - layer[oppositeSizeProp] / 2 + secondaryOffset, limitMin, limitMax); // right = left + layer.width
            result[propertyB] = result[propertyA] + layer[oppositeSizeProp];
        } else {
            var sec = secondary;
            var triggerValue = trigger[sec.prop]; // Under some conditions, when the layer is not able to align with the trigger
            // due to arrow-size and arrow-offsets, we need to compensate.
            // Otherwise, the secondary-offset will have no impact
            var arrowCompensation = triggerValue < limitMin ? limitMin - triggerValue : triggerValue > limitMax ? limitMax - triggerValue : 0; // left = limit(
            //   trigger.left + secondaryOffset + arrowCompensation,
            //   limitMin,
            //   limitMax
            // )
            result[sec.prop] = $1c4fb89e1ab02400$var$limit(triggerValue + secondaryOffset + arrowCompensation, limitMin, limitMax); // right = left + layer.width
            result[sec.opposite.prop] = result[sec.prop] + secondary.factor(layer[oppositeSizeProp]);
        } // set the correct dimensions
        result.width = result.right - result.left;
        result.height = result.bottom - result.top; // create new bounds object
        var layerBounds = $1c4fb89e1ab02400$var$Bounds.create(result);
        if (secondaryOffset === 0) this._cachedLayerBounds = layerBounds;
        return layerBounds;
    } /**
   * Checks whether the trigger is bigger on the opposite side
   * ie. placement "top-start" -> has trigger a bigger width?
   */ ;
    /**
   * returns getLayerBounds(), including container-offsets
   */ _proto.getLayerCollisionBounds = function getLayerCollisionBounds() {
        var container = this.offsets.container;
        return this.getLayerBounds().mapSides(function(side, value) {
            return value -= side.factor(container);
        }).merge(function(_ref) {
            var width = _ref.width, height = _ref.height;
            return {
                width: width + container * 2,
                height: height + container * 2
            };
        });
    } /**
   * Returns a BoundsOffsets instance containing merged offsets to containers with the most
   * negative scenario
   */ ;
    _proto.getContainerOffsets = function getContainerOffsets(layerBounds) {
        if (this._cachedContainerOffsets && !layerBounds) return this._cachedContainerOffsets;
        var subjectBounds = this.subjectsBounds.merge({
            layer: layerBounds || this.getLayerCollisionBounds()
        });
        var offsets = $1c4fb89e1ab02400$var$BoundsOffsets.mergeSmallestSides(subjectBounds.layerOffsetsToScrollContainers);
        if (!layerBounds) this._cachedContainerOffsets = offsets;
        return offsets;
    };
    $1c4fb89e1ab02400$var$_createClass(Placement, [
        {
            key: "type",
            get: function get() {
                return this.primary.prop + "-" + (this.secondary.prop === "center" ? "center" : [
                    "bottom",
                    "right"
                ].includes(this.secondary.prop) ? "end" : "start");
            }
        },
        {
            key: "triggerIsBigger",
            get: function get() {
                var isHorizontal = this.secondary.isHorizontal;
                var _this$subjectsBounds = this.subjectsBounds, triggerHasBiggerWidth = _this$subjectsBounds.triggerHasBiggerWidth, triggerHasBiggerHeight = _this$subjectsBounds.triggerHasBiggerHeight;
                return isHorizontal && triggerHasBiggerWidth || !isHorizontal && triggerHasBiggerHeight;
            }
        },
        {
            key: "fitsContainer",
            get: function get() {
                return this.getContainerOffsets().allSidesArePositive;
            }
        },
        {
            key: "visibleSurface",
            get: function get() {
                var layerBounds = this.getLayerBounds();
                var containerOffsets = this.getContainerOffsets(layerBounds);
                var substract = containerOffsets.negativeSides;
                for(var side in substract)// @ts-ignore
                substract[side] = -substract[side]; // make positive for substraction;
                return layerBounds.substract(substract).surface;
            }
        },
        {
            key: "secondaryOffsetSide",
            get: function get() {
                var _Object$entries$map$f, _Object$entries$map$f2, _this = this;
                // Given placement 'top-start' and containerOffsets { left: -20, top: -10, right: -10, bottom: 200 }...
                // the only negative offsets on the opposite side are { left: -20, right: -10 }
                // since we have to return only 1 side, we pick the most negative, which is 'left'
                var containerOffsets = this.getContainerOffsets();
                var _ref2 = (_Object$entries$map$f = (_Object$entries$map$f2 = Object.entries(containerOffsets.negativeSides).map(function(_ref3) {
                    var side = _ref3[0], value = _ref3[1];
                    return [
                        $1c4fb89e1ab02400$var$BoundSide[side],
                        value
                    ];
                }).filter(function(_ref4) {
                    var side = _ref4[0];
                    return _this.primary.isOppositeDirection(side);
                }).sort(function(_ref5, _ref6) {
                    var a = _ref5[1];
                    var b = _ref6[1];
                    return b - a;
                })) == null ? void 0 : _Object$entries$map$f2[0]) != null ? _Object$entries$map$f : [], mostNegativeSide = _ref2[0];
                return mostNegativeSide || null;
            }
        }
    ]);
    return Placement;
}();
var $1c4fb89e1ab02400$var$PlacementCenter = /*#__PURE__*/ function(_Placement) {
    $1c4fb89e1ab02400$var$_inheritsLoose(PlacementCenter, _Placement);
    function PlacementCenter() {
        return _Placement.apply(this, arguments) || this;
    }
    var _proto2 = PlacementCenter.prototype;
    _proto2.getLayerBounds = function getLayerBounds() {
        var _this$subjectsBounds2 = this.subjectsBounds, trigger = _this$subjectsBounds2.trigger, layer = _this$subjectsBounds2.layer;
        var result = $1c4fb89e1ab02400$var$Bounds.empty();
        result.top = trigger.top + trigger.height / 2 - layer.height / 2;
        result.bottom = result.top + layer.height;
        result.left = trigger.left + trigger.width / 2 - layer.width / 2;
        result.right = result.left + layer.width;
        result.width = result.right - result.left;
        result.height = result.bottom - result.top;
        return result;
    };
    return PlacementCenter;
}($1c4fb89e1ab02400$var$Placement);
function $1c4fb89e1ab02400$var$getNegativeOffsetBetweenLayerCenterAndTrigger(subjectsBounds, placement, arrowOffset) {
    var layer = subjectsBounds.layer, trigger = subjectsBounds.trigger, arrow = subjectsBounds.arrow;
    var sizeProperty = placement.primary.oppositeSizeProp;
    var _ref = !placement.primary.isHorizontal ? [
        "left",
        "right"
    ] : [
        "top",
        "bottom"
    ], sideA = _ref[0], sideB = _ref[1];
    var offsetA = layer[sideA] + layer[sizeProperty] / 2 - trigger[sideA] - arrow[sizeProperty] / 2 - arrowOffset;
    var offsetB = layer[sideB] - layer[sizeProperty] / 2 - trigger[sideB] + arrow[sizeProperty] / 2 + arrowOffset;
    return (offsetA < 0 ? -offsetA : 0) + (offsetB > 0 ? -offsetB : 0);
}
var $1c4fb89e1ab02400$var$STYLE_BASE = {
    position: "absolute",
    willChange: "top, left",
    left: null,
    right: null,
    top: null,
    bottom: null
};
function $1c4fb89e1ab02400$var$getArrowStyle(subjectsBounds, placement, arrowOffset) {
    var _extends2;
    if (placement.primary.isCenter) return $1c4fb89e1ab02400$var$STYLE_BASE;
    var layer = subjectsBounds.layer, trigger = subjectsBounds.trigger, arrow = subjectsBounds.arrow;
    var sizeProperty = placement.primary.oppositeSizeProp;
    var triggerIsBigger = trigger[sizeProperty] > layer[sizeProperty];
    var min = arrowOffset + arrow[sizeProperty] / 2;
    var max = layer[sizeProperty] - arrow[sizeProperty] / 2 - arrowOffset;
    var negativeOffset = $1c4fb89e1ab02400$var$getNegativeOffsetBetweenLayerCenterAndTrigger(subjectsBounds, placement, arrowOffset);
    var primarySide = placement.primary.prop;
    var secondarySide = placement.primary.oppositeCssProp;
    var secondaryValue = triggerIsBigger ? layer[sizeProperty] / 2 + negativeOffset : trigger[secondarySide] + trigger[sizeProperty] / 2 - layer[secondarySide];
    return $1c4fb89e1ab02400$var$_extends({}, $1c4fb89e1ab02400$var$STYLE_BASE, (_extends2 = {}, _extends2[primarySide] = "100%", _extends2[secondarySide] = $1c4fb89e1ab02400$var$limit(secondaryValue, min, max), _extends2));
}
/**
 * Class mostly concerned about calculating and finding the right placement
 */ var $1c4fb89e1ab02400$var$Placements = /*#__PURE__*/ function() {
    function Placements(placements, config, subjectsBounds) {
        this.placements = void 0;
        this.config = void 0;
        this.subjectsBounds = void 0;
        this.placements = placements;
        this.config = config;
        this.subjectsBounds = subjectsBounds;
    }
    /**
   * Converts a placement-type into a primary-side and a secondary-side
   */ Placements.getSidesFromPlacementType = function getSidesFromPlacementType(type) {
        var _type$split = type.split("-"), a = _type$split[0], b = _type$split[1];
        var primary = $1c4fb89e1ab02400$var$BoundSide[a];
        var secondary;
        if (b === "center") secondary = $1c4fb89e1ab02400$var$Side.center;
        else if (primary.isHorizontal) secondary = b === "start" ? $1c4fb89e1ab02400$var$Side.top : $1c4fb89e1ab02400$var$Side.bottom;
        else secondary = b === "start" ? $1c4fb89e1ab02400$var$Side.left : $1c4fb89e1ab02400$var$Side.right;
        return [
            primary,
            secondary
        ];
    } /**
   * Main static method to create a Placements instance
   * @param subjectsBounds instance of the SubjectsBounds class
   * @param config config provided by the user
   */ ;
    Placements.create = function create(subjectsBounds, config) {
        // create offsets-object from user config
        var offsets = {
            arrow: config.arrowOffset,
            container: config.containerOffset,
            trigger: config.triggerOffset
        }; // function which creates a prioritized list of possible placments
        // by looking at user-config
        function getListOfPlacements(preferedPlacement) {
            if (preferedPlacement === void 0) preferedPlacement = config.placement;
            var _Placements$getSidesF = Placements.getSidesFromPlacementType(preferedPlacement), primary = _Placements$getSidesF[0], secondary = _Placements$getSidesF[1];
            var preferredSide = $1c4fb89e1ab02400$var$BoundSide[primary.isHorizontal ? config.preferY : config.preferX]; // some priorities may alter when the trigger is bigger
            var triggerIsBigger = !primary.isHorizontal && subjectsBounds.triggerHasBiggerWidth || primary.isHorizontal && subjectsBounds.triggerHasBiggerHeight; // utility function which constructs a placement by primary and secondary sides
            function placementFrom(primary, secondary) {
                return new $1c4fb89e1ab02400$var$Placement(primary, secondary, subjectsBounds, config.layerDimensions, offsets);
            } // creating the list
            var list = [];
            list[0] = placementFrom(primary, secondary);
            list[1] = placementFrom(primary, secondary.isCenter ? preferredSide : $1c4fb89e1ab02400$var$Side.center);
            list[2] = placementFrom(primary, $1c4fb89e1ab02400$var$Side[(secondary.opposite.isCenter ? preferredSide.opposite : secondary.opposite).prop]);
            list[3] = placementFrom(preferredSide, triggerIsBigger ? primary : $1c4fb89e1ab02400$var$Side[primary.opposite.prop]);
            list[4] = placementFrom(preferredSide, $1c4fb89e1ab02400$var$Side.center);
            list[5] = placementFrom(preferredSide, triggerIsBigger ? $1c4fb89e1ab02400$var$Side[primary.opposite.prop] : primary);
            list[6] = placementFrom($1c4fb89e1ab02400$var$BoundSide[preferredSide.opposite.prop], triggerIsBigger ? primary : $1c4fb89e1ab02400$var$Side[primary.opposite.prop]);
            list[7] = placementFrom($1c4fb89e1ab02400$var$BoundSide[preferredSide.opposite.prop], $1c4fb89e1ab02400$var$Side.center);
            list[8] = placementFrom($1c4fb89e1ab02400$var$BoundSide[preferredSide.opposite.prop], triggerIsBigger ? $1c4fb89e1ab02400$var$Side[primary.opposite.prop] : primary);
            list[9] = placementFrom($1c4fb89e1ab02400$var$BoundSide[primary.opposite.prop], secondary);
            list[10] = placementFrom($1c4fb89e1ab02400$var$BoundSide[primary.opposite.prop], secondary.isCenter ? preferredSide : $1c4fb89e1ab02400$var$Side.center);
            list[11] = placementFrom($1c4fb89e1ab02400$var$BoundSide[primary.opposite.prop], $1c4fb89e1ab02400$var$Side[(secondary.opposite.isCenter ? preferredSide.opposite : secondary.opposite).prop]); // only include placements that are part of 'possible-placements'
            list = list.filter(function(placement) {
                return placement.type === config.placement || config.possiblePlacements.includes(placement.type);
            });
            return list;
        } // treat placement 'center' a little bit different
        if (config.placement === "center") return new Placements([
            new $1c4fb89e1ab02400$var$PlacementCenter($1c4fb89e1ab02400$var$Side.center, $1c4fb89e1ab02400$var$Side.center, subjectsBounds, config.layerDimensions, offsets)
        ].concat(getListOfPlacements(config.preferY + "-" + config.preferX)), config, subjectsBounds);
        return new Placements(getListOfPlacements(), config, subjectsBounds);
    };
    var _proto = Placements.prototype;
    _proto.filterPlacementsBySide = function filterPlacementsBySide(side) {
        return this.placements.filter(function(placement) {
            return placement.primary === side;
        });
    };
    _proto.findFirstPlacementThatFits = function findFirstPlacementThatFits() {
        return this.placements.find(function(placement) {
            return placement.fitsContainer;
        });
    };
    _proto.placementWithBiggestVisibleSurface = function placementWithBiggestVisibleSurface() {
        var _this$placements$map$ = this.placements.map(function(placement) {
            return {
                placement: placement,
                surface: placement.visibleSurface
            };
        }) // sort -> biggest surface first
        .sort(function(a, b) {
            return b.surface - a.surface;
        }), placementWithBiggestSurface = _this$placements$map$[0].placement;
        return placementWithBiggestSurface;
    };
    _proto.findSuitablePlacement = function findSuitablePlacement() {
        if (!this.config.auto) return this.placements[0];
        return this.findFirstPlacementThatFits() || this.placementWithBiggestVisibleSurface();
    } /**
   * secondary offset: the number of pixels between the edge of the
   * scroll-container and the current placement, on the side of the layer
   * that didn't fit.
   * Eventually this secondary offset gets added / subtracted from the
   * placement that does fit in order to move the layer closer to the
   * position of the placement that just would not fit.
   * This creates the effect that the layer is moving gradually from one
   * placement to the next as the users scrolls the page or scroll-container
   */ ;
    _proto.getSecondaryOffset = function getSecondaryOffset(placement) {
        var _this$config = this.config, auto = _this$config.auto, snap = _this$config.snap; // return early when we're not interested...
        if (!auto || snap || placement instanceof $1c4fb89e1ab02400$var$PlacementCenter) return 0;
         // if current placement fits and is prefered placement...
        // return early
        var placementsOnSameSide = this.filterPlacementsBySide(placement.primary);
        var currentPlacementHasHighestPriority = placementsOnSameSide.indexOf(placement) === 0;
        if (currentPlacementHasHighestPriority && placement.fitsContainer) return 0;
        var firstPlacementThatDoesNotFit = placementsOnSameSide.find(function(placement) {
            return !placement.fitsContainer;
        });
        if (!firstPlacementThatDoesNotFit) return 0;
        var secondaryOffsetSide = firstPlacementThatDoesNotFit.secondaryOffsetSide;
        if (!secondaryOffsetSide) return 0;
        var containerOffsets = placement.getContainerOffsets(); // determine whether we should add or substract the secondary-offset
        var secondary = placement.secondary;
        var factor;
        if (placement.triggerIsBigger || firstPlacementThatDoesNotFit === placement) factor = secondaryOffsetSide.isPush ? -1 : 1;
        else factor = secondary === $1c4fb89e1ab02400$var$Side.left || [
            $1c4fb89e1ab02400$var$Side.top,
            $1c4fb89e1ab02400$var$Side.center
        ].includes(secondary) && secondaryOffsetSide.isPush ? -1 : 1;
         // get number of pixels between placement that did not fit and current
        // placement
        var secondaryOffset = containerOffsets[secondaryOffsetSide.prop];
        return secondaryOffset * factor;
    };
    _proto.getStyles = function getStyles(layerBounds, placement, scrollOffsets, borderOffsets) {
        var layerStyleBase = {
            willChange: "top, left, width, height"
        };
        var arrow = $1c4fb89e1ab02400$var$getArrowStyle(this.subjectsBounds.merge({
            layer: layerBounds
        }), placement, this.config.arrowOffset);
        var layer = this.config.overflowContainer ? $1c4fb89e1ab02400$var$_extends({}, layerStyleBase, {
            position: "fixed",
            top: layerBounds.top,
            left: layerBounds.left
        }) : $1c4fb89e1ab02400$var$_extends({}, layerStyleBase, {
            position: "absolute",
            top: layerBounds.top - this.subjectsBounds.parent.top + scrollOffsets.top - borderOffsets.top,
            left: layerBounds.left - this.subjectsBounds.parent.left + scrollOffsets.left - borderOffsets.left
        });
        return {
            arrow: arrow,
            layer: layer
        };
    };
    _proto.getHasDisappeared = function getHasDisappeared(layerBounds) {
        var subject = this.config.overflowContainer ? this.subjectsBounds.trigger : layerBounds;
        var containerOffsets = $1c4fb89e1ab02400$var$BoundsOffsets.mergeSmallestSides(this.subjectsBounds.offsetsToScrollContainers(subject, true));
        var entries = Object.entries(containerOffsets.negativeSides);
        var hasFullyDisappeared = entries.some(function(_ref) {
            var prop = _ref[0], value = _ref[1];
            var side = $1c4fb89e1ab02400$var$BoundSide[prop];
            return value <= -subject[side.sizeProp];
        });
        if (hasFullyDisappeared) return "full";
        if (!containerOffsets.allSidesArePositive) return "partial";
        return null;
    };
    _proto.result = function result(scrollOffsets, borderOffsets) {
        var suitablePlacement = this.findSuitablePlacement();
        var secondaryOffset = this.getSecondaryOffset(suitablePlacement);
        var layerBounds = suitablePlacement.getLayerBounds(secondaryOffset);
        var styles = this.getStyles(layerBounds, suitablePlacement, scrollOffsets, borderOffsets);
        var layerSide = suitablePlacement.primary.prop;
        return {
            styles: styles,
            layerSide: layerSide,
            placement: suitablePlacement,
            layerBounds: layerBounds,
            hasDisappeared: this.getHasDisappeared(layerBounds)
        };
    };
    return Placements;
}();
var $1c4fb89e1ab02400$var$SubjectsBounds = /*#__PURE__*/ function() {
    function SubjectsBounds(subjectsBounds, overflowContainer) {
        this.overflowContainer = void 0;
        this.trigger = void 0;
        this.layer = void 0;
        this.arrow = void 0;
        this.parent = void 0;
        this.window = void 0;
        this.scrollContainers = void 0;
        this.overflowContainer = overflowContainer;
        Object.assign(this, subjectsBounds);
    }
    SubjectsBounds.create = function create(environment, layer, trigger, parent, arrow, scrollContainers, overflowContainer, getTriggerBounds) {
        var window1 = $1c4fb89e1ab02400$var$Bounds.fromWindow(environment);
        return new SubjectsBounds({
            layer: $1c4fb89e1ab02400$var$Bounds.fromElement(layer, {
                environment: environment,
                withTransform: false
            }),
            trigger: getTriggerBounds ? $1c4fb89e1ab02400$var$Bounds.create($1c4fb89e1ab02400$var$boundsToObject(getTriggerBounds())) : $1c4fb89e1ab02400$var$Bounds.fromElement(trigger),
            arrow: arrow ? $1c4fb89e1ab02400$var$Bounds.fromElement(arrow) : $1c4fb89e1ab02400$var$Bounds.empty(),
            parent: parent ? $1c4fb89e1ab02400$var$Bounds.fromElement(parent) : window1,
            window: window1,
            scrollContainers: [
                window1
            ].concat(scrollContainers.map(function(container) {
                return $1c4fb89e1ab02400$var$Bounds.fromElement(container, {
                    withScrollbars: false
                });
            }))
        }, overflowContainer);
    };
    var _proto = SubjectsBounds.prototype;
    _proto.merge = function merge(subjectsBounds) {
        return new SubjectsBounds($1c4fb89e1ab02400$var$_extends({}, this, subjectsBounds), this.overflowContainer);
    };
    _proto.offsetsToScrollContainers = function offsetsToScrollContainers(subject, allContainers) {
        if (allContainers === void 0) allContainers = false;
        var scrollContainers = this.overflowContainer && !allContainers ? [
            this.window
        ] : this.scrollContainers;
        return scrollContainers.map(function(scrollContainer) {
            return scrollContainer.offsetsTo(subject);
        });
    };
    $1c4fb89e1ab02400$var$_createClass(SubjectsBounds, [
        {
            key: "layerOffsetsToScrollContainers",
            get: function get() {
                return this.offsetsToScrollContainers(this.layer);
            }
        },
        {
            key: "triggerHasBiggerWidth",
            get: function get() {
                return this.trigger.width > this.layer.width;
            }
        },
        {
            key: "triggerHasBiggerHeight",
            get: function get() {
                return this.trigger.height > this.layer.height;
            }
        }
    ]);
    return SubjectsBounds;
}();
var $1c4fb89e1ab02400$var$GLOBAL_CONTAINER = null;
function $1c4fb89e1ab02400$export$a3d6b390315f4851(container) {
    if (typeof document === "undefined") return;
    if (typeof container === "function") $1c4fb89e1ab02400$var$GLOBAL_CONTAINER = container();
    else if (typeof container === "string") $1c4fb89e1ab02400$var$GLOBAL_CONTAINER = document.getElementById(container);
    else $1c4fb89e1ab02400$var$GLOBAL_CONTAINER = container;
}
var $1c4fb89e1ab02400$export$93ca5d3f8675ae4c = {
    auto: false,
    arrowOffset: 0,
    containerOffset: 10,
    triggerOffset: 0,
    overflowContainer: true,
    placement: "top-center",
    possiblePlacements: $1c4fb89e1ab02400$export$e7d486c3403374a0,
    preferX: "right",
    preferY: "bottom",
    snap: false,
    container: undefined,
    trigger: undefined
};
function $1c4fb89e1ab02400$export$807913709de17c01(_ref) {
    var _triggerBoundsRef$cur;
    var _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen, _ref$overflowContaine = _ref.overflowContainer, overflowContainer = _ref$overflowContaine === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.overflowContainer : _ref$overflowContaine, _ref$environment = _ref.environment, environment = _ref$environment === void 0 ? typeof window !== "undefined" ? window : undefined : _ref$environment, ResizeObserverPolyfill = _ref.ResizeObserver, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.placement : _ref$placement, _ref$possiblePlacemen = _ref.possiblePlacements, possiblePlacements = _ref$possiblePlacemen === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.possiblePlacements : _ref$possiblePlacemen, _ref$preferX = _ref.preferX, preferX = _ref$preferX === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.preferX : _ref$preferX, _ref$preferY = _ref.preferY, preferY = _ref$preferY === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.preferY : _ref$preferY, _ref$auto = _ref.auto, auto = _ref$auto === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.auto : _ref$auto, _ref$snap = _ref.snap, snap = _ref$snap === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.snap : _ref$snap, _ref$triggerOffset = _ref.triggerOffset, triggerOffset = _ref$triggerOffset === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.triggerOffset : _ref$triggerOffset, _ref$containerOffset = _ref.containerOffset, containerOffset = _ref$containerOffset === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.containerOffset : _ref$containerOffset, _ref$arrowOffset = _ref.arrowOffset, arrowOffset = _ref$arrowOffset === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.arrowOffset : _ref$arrowOffset, _ref$container = _ref.container, container = _ref$container === void 0 ? $1c4fb89e1ab02400$export$93ca5d3f8675ae4c.container : _ref$container, _ref$layerDimensions = _ref.layerDimensions, layerDimensions = _ref$layerDimensions === void 0 ? null : _ref$layerDimensions, onDisappear = _ref.onDisappear, onOutsideClick = _ref.onOutsideClick, onParentClose = _ref.onParentClose, triggerOption = _ref.trigger;
    // initialize styles
    var _useState = (0, $lldlC.useState)(function() {
        return {
            layerSide: placement === "center" ? "center" : $1c4fb89e1ab02400$var$Placements.getSidesFromPlacementType(placement)[0].prop,
            styles: {
                layer: {
                    position: overflowContainer ? "fixed" : "absolute",
                    top: 0,
                    left: 0
                },
                arrow: {
                    position: "absolute",
                    top: 0,
                    left: 0
                }
            }
        };
    }), state = _useState[0], setState = _useState[1];
    var triggerBoundsRef = (0, $lldlC.useRef)(null); // tracks state in order for us to use read inside functions that require dependencies,
    // like `useCallback`, without triggering an update
    var lastState = $1c4fb89e1ab02400$var$useLastState(state, isOpen); // track invalidations for scheduled position updates
    var repositioningToken = (0, $lldlC.useRef)({
        cancelled: false
    });
    (0, $lldlC.useEffect)(function() {
        return function() {
            // when this hook unmounts, make sure to cancel any scheduled position updates
            repositioningToken.current.cancelled = true;
        };
    }, []); // Most important function regarding positioning
    // It receives boundaries collected by `useTrackElements`, does some calculations,
    // sets new styles, and handles when a layer has disappeared.
    var handlePositioning = (0, $lldlC.useCallback)(function handlePositioning(_ref2, scrollOffsets, borderOffsets) {
        var arrow = _ref2.arrow, layer = _ref2.layer, scrollContainers = _ref2.scrollContainers, trigger = _ref2.trigger;
        var parent = scrollContainers[0];
        var subjectsBounds = $1c4fb89e1ab02400$var$SubjectsBounds.create(environment, layer, trigger, parent, arrow, scrollContainers, overflowContainer, triggerOption == null ? void 0 : triggerOption.getBounds);
        var config = {
            placement: placement,
            possiblePlacements: possiblePlacements,
            auto: auto,
            layerDimensions: layerDimensions,
            arrowOffset: arrowOffset,
            containerOffset: containerOffset,
            triggerOffset: triggerOffset,
            preferX: preferX,
            preferY: preferY,
            snap: snap,
            overflowContainer: overflowContainer
        };
        var _Placements$create$re = $1c4fb89e1ab02400$var$Placements.create(subjectsBounds, config).result(scrollOffsets, borderOffsets), hasDisappeared = _Placements$create$re.hasDisappeared, layerSide = _Placements$create$re.layerSide, styles = _Placements$create$re.styles;
        var newState = {
            layerSide: layerSide,
            styles: styles
        };
        if (!lastState.current || $1c4fb89e1ab02400$var$didStateChange(lastState.current, newState)) {
            lastState.current = newState; // optimistically update lastState to prevent infinite loop
            /**
       * Throttle state updates slightly by delaying them using an immediately
       * resolved promise, only applying them if there is no later update.
       * This helps for multiple updates that happens synchronously one after another.
       */ repositioningToken.current.cancelled = true;
            var token = {
                cancelled: false
            };
            repositioningToken.current = token;
            Promise.resolve().then(function() {
                if (!token.cancelled) setState(newState);
            });
        }
        if ($1c4fb89e1ab02400$var$isSet(hasDisappeared) && $1c4fb89e1ab02400$var$isSet(onDisappear)) onDisappear(hasDisappeared);
    }, [
        arrowOffset,
        auto,
        containerOffset,
        environment,
        layerDimensions,
        onDisappear,
        overflowContainer,
        placement,
        possiblePlacements,
        preferX,
        preferY,
        snap,
        triggerOffset,
        lastState,
        triggerOption
    ]);
    var _useTrackElements = $1c4fb89e1ab02400$var$useTrackElements({
        ResizeObserverPolyfill: ResizeObserverPolyfill,
        environment: environment,
        enabled: isOpen,
        overflowContainer: overflowContainer,
        onChange: handlePositioning,
        triggerOption: triggerOption
    }), triggerRef = _useTrackElements.triggerRef, layerRef = _useTrackElements.layerRef, arrowRef = _useTrackElements.arrowRef, closestScrollContainer = _useTrackElements.closestScrollContainer;
    var _useGroup = $1c4fb89e1ab02400$var$useGroup({
        isOpen: isOpen,
        onOutsideClick: onOutsideClick,
        onParentClose: onParentClose
    }), closeOnOutsideClickRefs = _useGroup.closeOnOutsideClickRefs, registrations = _useGroup.registrations;
    var props = {
        triggerProps: Boolean(triggerOption) ? {} // when using the `trigger` option, make `triggerProps` useless
         : {
            ref: $1c4fb89e1ab02400$export$c9058316764c140e(triggerRef, closeOnOutsideClickRefs.trigger, triggerBoundsRef)
        },
        layerProps: {
            ref: $1c4fb89e1ab02400$export$c9058316764c140e(layerRef, closeOnOutsideClickRefs.layer),
            style: state.styles.layer
        },
        arrowProps: {
            ref: arrowRef,
            style: state.styles.arrow,
            layerSide: state.layerSide
        },
        layerSide: state.layerSide,
        triggerBounds: isOpen ? triggerOption ? triggerOption.getBounds() : (_triggerBoundsRef$cur = triggerBoundsRef.current) == null ? void 0 : _triggerBoundsRef$cur.getBoundingClientRect() : null,
        renderLayer: function renderLayer(children) {
            return typeof document !== "undefined" ? (0, $a47646e093dbda8d$exports.createPortal)((0, $lldlC.createElement)($1c4fb89e1ab02400$var$GroupProvider, {
                registrations: registrations,
                children: children
            }), overflowContainer || !closestScrollContainer ? $1c4fb89e1ab02400$var$getContainerElement(container) : closestScrollContainer) : null;
        }
    };
    return props;
}
function $1c4fb89e1ab02400$var$didStateChange(previous, next) {
    if (previous.layerSide !== next.layerSide) return true;
    var styleProps = [
        "position",
        "top",
        "left",
        "right",
        "bottom"
    ];
    for(var _i = 0, _styleProps = styleProps; _i < _styleProps.length; _i++){
        var prop = _styleProps[_i];
        if (previous.styles.layer[prop] !== next.styles.layer[prop] || previous.styles.arrow[prop] !== next.styles.arrow[prop]) return true;
    }
    return false;
}
var $1c4fb89e1ab02400$var$DEFAULT_CONTAINER_ID = "layers";
function $1c4fb89e1ab02400$var$getContainerElement(container) {
    var element;
    if (typeof container === "function") {
        element = container();
        if (!element || !(element instanceof HTMLElement)) throw new Error("react-laag: You've passed a function to the 'container' prop, but it returned no valid HTMLElement");
    } else if (container instanceof HTMLElement) element = container;
    else if (typeof container === "string") {
        element = document.getElementById(container);
        if (!element) throw new Error("react-laag: You've passed element with id '" + container + "' to the 'container' prop, but it returned no valid HTMLElement");
    } else if ($1c4fb89e1ab02400$var$GLOBAL_CONTAINER instanceof HTMLElement) return $1c4fb89e1ab02400$var$GLOBAL_CONTAINER;
    else {
        element = document.getElementById($1c4fb89e1ab02400$var$DEFAULT_CONTAINER_ID);
        if (!element) {
            element = document.createElement("div");
            element.id = $1c4fb89e1ab02400$var$DEFAULT_CONTAINER_ID;
            element.style.cssText = "\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        right: 0px;\n      ";
            document.body.appendChild(element);
        }
    }
    return element;
}
var $1c4fb89e1ab02400$var$_excluded = [
    "size",
    "angle",
    "borderWidth",
    "borderColor",
    "roundness",
    "backgroundColor",
    "layerSide",
    "style"
];
var $1c4fb89e1ab02400$var$LEFT = "left";
var $1c4fb89e1ab02400$var$TOP = "top";
var $1c4fb89e1ab02400$var$BOTTOM = "bottom";
var $1c4fb89e1ab02400$var$RIGHT = "right";
function $1c4fb89e1ab02400$var$getWidthBasedOnAngle(angle, size) {
    return Math.tan(angle * (Math.PI / 180)) * size;
}
function $1c4fb89e1ab02400$var$getViewBox(sizeA, sizeB, side, borderWidth) {
    var _map;
    var map = (_map = {}, _map[$1c4fb89e1ab02400$var$BOTTOM] = "0 " + -borderWidth + " " + sizeB + " " + sizeA, _map[$1c4fb89e1ab02400$var$TOP] = "0 0 " + sizeB + " " + (sizeA + borderWidth), _map[$1c4fb89e1ab02400$var$RIGHT] = -borderWidth + " 0 " + sizeA + " " + sizeB, _map[$1c4fb89e1ab02400$var$LEFT] = "0 0 " + (sizeA + borderWidth) + " " + sizeB, _map);
    return map[side.prop];
}
function $1c4fb89e1ab02400$var$getTrianglePath(sizeA, sizeB, side, roundness, angle) {
    var _BOTTOM$TOP$RIGHT$LEF, _BOTTOM$TOP$RIGHT$LEF2, _BOTTOM$TOP$RIGHT$LEF3;
    var relativeRoundness = roundness / 10 * sizeA * 2;
    var A = (_BOTTOM$TOP$RIGHT$LEF = {}, _BOTTOM$TOP$RIGHT$LEF[$1c4fb89e1ab02400$var$BOTTOM] = [
        0,
        sizeA
    ], _BOTTOM$TOP$RIGHT$LEF[$1c4fb89e1ab02400$var$TOP] = [
        0,
        0
    ], _BOTTOM$TOP$RIGHT$LEF[$1c4fb89e1ab02400$var$RIGHT] = [
        sizeA,
        sizeB
    ], _BOTTOM$TOP$RIGHT$LEF[$1c4fb89e1ab02400$var$LEFT] = [
        0,
        sizeB
    ], _BOTTOM$TOP$RIGHT$LEF)[side.prop].join(" ");
    var B = side.isHorizontal ? "V 0" : "H " + sizeB;
    var cPoint = sizeB / 2;
    var c1A = sizeB / 2 + $1c4fb89e1ab02400$var$getWidthBasedOnAngle(angle, sizeA / 8);
    var c1B = sizeA / 8;
    var C = (_BOTTOM$TOP$RIGHT$LEF2 = {}, _BOTTOM$TOP$RIGHT$LEF2[$1c4fb89e1ab02400$var$BOTTOM] = [
        "C",
        c1A,
        c1B,
        cPoint + relativeRoundness,
        0,
        cPoint,
        0
    ], _BOTTOM$TOP$RIGHT$LEF2[$1c4fb89e1ab02400$var$TOP] = [
        "C",
        c1A,
        sizeA - c1B,
        cPoint + relativeRoundness,
        sizeA,
        cPoint,
        sizeA
    ], _BOTTOM$TOP$RIGHT$LEF2[$1c4fb89e1ab02400$var$RIGHT] = [
        "C",
        c1B,
        sizeB - c1A,
        0,
        cPoint - relativeRoundness,
        0,
        cPoint
    ], _BOTTOM$TOP$RIGHT$LEF2[$1c4fb89e1ab02400$var$LEFT] = [
        "C",
        sizeA - c1B,
        sizeB - c1A,
        sizeA,
        cPoint - relativeRoundness,
        sizeA,
        cPoint
    ], _BOTTOM$TOP$RIGHT$LEF2)[side.prop].join(" ");
    var d1A = sizeB / 2 - $1c4fb89e1ab02400$var$getWidthBasedOnAngle(angle, sizeA / 8);
    var d1B = sizeA / 8;
    var D = (_BOTTOM$TOP$RIGHT$LEF3 = {}, _BOTTOM$TOP$RIGHT$LEF3[$1c4fb89e1ab02400$var$BOTTOM] = [
        "C",
        cPoint - relativeRoundness,
        0,
        d1A,
        d1B,
        A
    ], _BOTTOM$TOP$RIGHT$LEF3[$1c4fb89e1ab02400$var$TOP] = [
        "C",
        cPoint - relativeRoundness,
        sizeA,
        d1A,
        sizeA - d1B,
        A
    ], _BOTTOM$TOP$RIGHT$LEF3[$1c4fb89e1ab02400$var$RIGHT] = [
        "C",
        0,
        cPoint + relativeRoundness,
        d1B,
        sizeB - d1A,
        A
    ], _BOTTOM$TOP$RIGHT$LEF3[$1c4fb89e1ab02400$var$LEFT] = [
        "C",
        sizeA,
        cPoint + relativeRoundness,
        sizeA - d1B,
        sizeB - d1A,
        A
    ], _BOTTOM$TOP$RIGHT$LEF3)[side.prop].join(" ");
    return [
        "M",
        A,
        B,
        C,
        D
    ].join(" ");
}
function $1c4fb89e1ab02400$var$getBorderMaskPath(sizeA, sizeB, borderWidth, side, angle) {
    var borderOffset = $1c4fb89e1ab02400$var$getWidthBasedOnAngle(angle, borderWidth);
    var _ref = !side.isPush ? [
        sizeA,
        sizeA - borderWidth
    ] : [
        0,
        borderWidth
    ], A = _ref[0], B = _ref[1];
    if (side.isHorizontal) return [
        "M",
        A,
        borderWidth,
        "V",
        sizeB - borderWidth,
        "L",
        B,
        sizeB - borderWidth - borderOffset,
        "V",
        borderOffset + borderWidth,
        "Z"
    ].join(" ");
    return [
        "M",
        borderWidth,
        A,
        "H",
        sizeB - borderWidth,
        "L",
        sizeB - borderWidth - borderOffset,
        B,
        "H",
        borderOffset + borderWidth,
        "Z"
    ].join(" ");
}
var $1c4fb89e1ab02400$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $lldlC.forwardRef)(function Arrow(_ref2, ref) {
    var _ref2$size = _ref2.size, size = _ref2$size === void 0 ? 8 : _ref2$size, _ref2$angle = _ref2.angle, angle = _ref2$angle === void 0 ? 45 : _ref2$angle, _ref2$borderWidth = _ref2.borderWidth, borderWidth = _ref2$borderWidth === void 0 ? 0 : _ref2$borderWidth, _ref2$borderColor = _ref2.borderColor, borderColor = _ref2$borderColor === void 0 ? "black" : _ref2$borderColor, _ref2$roundness = _ref2.roundness, roundness = _ref2$roundness === void 0 ? 0 : _ref2$roundness, _ref2$backgroundColor = _ref2.backgroundColor, backgroundColor = _ref2$backgroundColor === void 0 ? "white" : _ref2$backgroundColor, _ref2$layerSide = _ref2.layerSide, layerSide = _ref2$layerSide === void 0 ? "top" : _ref2$layerSide, _ref2$style = _ref2.style, style = _ref2$style === void 0 ? {} : _ref2$style, rest = $1c4fb89e1ab02400$var$_objectWithoutPropertiesLoose(_ref2, $1c4fb89e1ab02400$var$_excluded);
    if (layerSide === "center") return null;
    var side = $1c4fb89e1ab02400$var$BoundSide[layerSide];
    var sizeA = size;
    var sizeB = $1c4fb89e1ab02400$var$getWidthBasedOnAngle(angle, size) * 2;
    var maxSize = Math.max(sizeA, sizeB);
    return (0, $lldlC.createElement)("svg", $1c4fb89e1ab02400$var$_extends({
        ref: ref
    }, rest, {
        style: $1c4fb89e1ab02400$var$_extends({}, style, {
            transform: "translate" + (side.isHorizontal ? "Y" : "X") + "(-50%)"
        }),
        width: maxSize,
        height: maxSize,
        preserveAspectRatio: side.isPush ? "xMinYMin" : "xMaxYMax",
        viewBox: $1c4fb89e1ab02400$var$getViewBox(sizeA, sizeB, side, borderWidth)
    }), (0, $lldlC.createElement)("path", {
        fill: backgroundColor,
        strokeWidth: borderWidth,
        stroke: borderColor,
        d: $1c4fb89e1ab02400$var$getTrianglePath(sizeA, sizeB, side, roundness, angle)
    }), (0, $lldlC.createElement)("path", {
        fill: backgroundColor,
        d: $1c4fb89e1ab02400$var$getBorderMaskPath(sizeA, sizeB, borderWidth, side, angle)
    }));
});
var $1c4fb89e1ab02400$var$Status;
(function(Status) {
    Status[Status["ENTERING"] = 0] = "ENTERING";
    Status[Status["LEAVING"] = 1] = "LEAVING";
    Status[Status["IDLE"] = 2] = "IDLE";
})($1c4fb89e1ab02400$var$Status || ($1c4fb89e1ab02400$var$Status = {}));
function $1c4fb89e1ab02400$export$ae780daf29e6d456(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$delayEnter = _ref.delayEnter, delayEnter = _ref$delayEnter === void 0 ? 0 : _ref$delayEnter, _ref$delayLeave = _ref.delayLeave, delayLeave = _ref$delayLeave === void 0 ? 0 : _ref$delayLeave, _ref$hideOnScroll = _ref.hideOnScroll, hideOnScroll = _ref$hideOnScroll === void 0 ? true : _ref$hideOnScroll;
    var _useState = (0, $lldlC.useState)(false), show = _useState[0], setShow = _useState[1];
    var timeout = (0, $lldlC.useRef)(null);
    var status = (0, $lldlC.useRef)($1c4fb89e1ab02400$var$Status.IDLE);
    var hasTouchMoved = (0, $lldlC.useRef)(false);
    var removeTimeout = (0, $lldlC.useCallback)(function removeTimeout() {
        clearTimeout(timeout.current);
        timeout.current = null;
        status.current = $1c4fb89e1ab02400$var$Status.IDLE;
    }, []);
    function onMouseEnter() {
        // if was leaving, stop leaving
        if (status.current === $1c4fb89e1ab02400$var$Status.LEAVING && timeout.current) removeTimeout();
        if (show) return;
        status.current = $1c4fb89e1ab02400$var$Status.ENTERING;
        timeout.current = window.setTimeout(function() {
            setShow(true);
            timeout.current = null;
            status.current = $1c4fb89e1ab02400$var$Status.IDLE;
        }, delayEnter);
    }
    function onMouseLeave(_, immediate) {
        // if was waiting for entering,
        // clear timeout
        if (status.current === $1c4fb89e1ab02400$var$Status.ENTERING && timeout.current) removeTimeout();
        if (!show) return;
        if (immediate) {
            setShow(false);
            timeout.current = null;
            status.current = $1c4fb89e1ab02400$var$Status.IDLE;
            return;
        }
        status.current = $1c4fb89e1ab02400$var$Status.LEAVING;
        timeout.current = window.setTimeout(function() {
            setShow(false);
            timeout.current = null;
            status.current = $1c4fb89e1ab02400$var$Status.IDLE;
        }, delayLeave);
    } // make sure to clear timeout on unmount
    (0, $lldlC.useEffect)(function() {
        function onScroll() {
            if (show && hideOnScroll) {
                removeTimeout();
                setShow(false);
            }
        }
        window.addEventListener("scroll", onScroll, true);
        return function() {
            window.removeEventListener("scroll", onScroll, true);
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, [
        show,
        hideOnScroll,
        removeTimeout
    ]);
    var hoverProps = {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onTouchStart: function onTouchStart() {
            hasTouchMoved.current = false;
        },
        onTouchMove: function onTouchMove() {
            hasTouchMoved.current = true;
        },
        onTouchEnd: function onTouchEnd() {
            if (!hasTouchMoved.current && !show) setShow(true);
            hasTouchMoved.current = false;
        }
    };
    return [
        show,
        hoverProps,
        function() {
            return onMouseLeave(null, true);
        }
    ];
}
/**
 * @deprecated
 * Note: this component is marked as deprecated and will be removed and a possible
 * future release
 */ function $1c4fb89e1ab02400$export$be58926105124dd4(_ref) {
    var isOpenExternal = _ref.isOpen, children = _ref.children;
    var _useState = (0, $lldlC.useState)({
        isOpenInternal: isOpenExternal,
        isLeaving: false
    }), state = _useState[0], setState = _useState[1];
    var didMount = (0, $lldlC.useRef)(false);
    (0, $lldlC.useEffect)(function() {
        if (isOpenExternal) setState({
            isOpenInternal: true,
            isLeaving: false
        });
        else if (didMount.current) setState({
            isOpenInternal: false,
            isLeaving: true
        });
    }, [
        isOpenExternal,
        setState
    ]);
    (0, $lldlC.useEffect)(function() {}, [
        children
    ]);
    (0, $lldlC.useEffect)(function() {
        didMount.current = true;
    }, []);
    if (!isOpenExternal && !state.isOpenInternal && !state.isLeaving) return null;
    return children(state.isOpenInternal, function() {
        if (!state.isOpenInternal) setState(function(s) {
            return $1c4fb89e1ab02400$var$_extends({}, s, {
                isLeaving: false
            });
        });
    }, state.isLeaving);
}



const $e404b4293f3fed4b$export$857b1a87d5c023b8 = (template)=>{
    const link = (pathParams, queryParams)=>`${(0, $5f93497ef0243768$export$97964dd01d43da22)(template, pathParams)}${(0, $48db62750359aef4$export$6b17a39e52c8ee53)(queryParams)}`;
    return {
        template: template,
        link: link
    };
};


(function(portalRoutes) {
    portalRoutes.home = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)("/");
    (function(orgs) {
        orgs.home = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`/orgs`);
        orgs.create = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${portalRoutes.orgs.home.template}/create`);
        orgs.select = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${portalRoutes.orgs.home.template}/select`);
        (function(org) {
            org.home = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${portalRoutes.orgs.home.template}/:orgId`);
            org.view = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${orgs.org.home.template}/view`);
            org.edit = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${orgs.org.home.template}/edit`);
            org.dashboard = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${orgs.org.home.template}/dashboard`);
            (function(members) {
                members.home = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${orgs.org.home.template}/members`);
                members.list = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.members.home.template}/list`);
                members.create = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.members.home.template}/create`);
                members.edit = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.members.home.template}/edit/:uid`);
                members.view = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.members.home.template}/:uid`);
            })(org.members || (org.members = {}));
            (function(groups) {
                groups.home = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${orgs.org.home.template}/groups`);
                groups.list = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.groups.home.template}/list`);
                groups.create = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.groups.home.template}/create`);
                groups.edit = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.groups.home.template}/edit/:groupId`);
                groups.view = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)(`${org.groups.home.template}/:groupId`);
            })(org.groups || (org.groups = {}));
        })(orgs.org || (orgs.org = {}));
    })(portalRoutes.orgs || (portalRoutes.orgs = {}));
})($20ec8ba4fa00092b$export$9bf56a579356bd66 || ($20ec8ba4fa00092b$export$9bf56a579356bd66 = {}));
var $20ec8ba4fa00092b$export$9bf56a579356bd66;


/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $lldlC = parcelRequire("lldlC");
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $f4d882f23cc4edc1$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $f4d882f23cc4edc1$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");


/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $lldlC = parcelRequire("lldlC");
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $89f0bd10c0c278ef$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $0317aaa86115c198$export$2e2bcd8739ae039 = (0, $lldlC.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $lldlC.createElement)("svg", {
        ref: ref,
        ...(0, $89f0bd10c0c278ef$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $f4d882f23cc4edc1$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $lldlC.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $5ffb589cfd67dd25$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $lldlC.forwardRef)(({ className: className, ...props }, ref)=>(0, $lldlC.createElement)((0, $0317aaa86115c198$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $f4d882f23cc4edc1$export$3d46f4579dba46e5)(`lucide-${(0, $f4d882f23cc4edc1$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $f4188c1fef1eb64c$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Mail", [
    [
        "rect",
        {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            key: "18n3k1"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
            key: "1ocrg3"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e19949dc6cc036dc$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("User", [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
]);


const $792320feaee41c79$var$logo = "/images/logo-small-zickko.svg";
const $792320feaee41c79$export$5b97127cfaf7c3f5 = (props)=>{
    const navigateTo = (0, $20bbbf7d5bcb0a93$export$9770f232ac06a008)();
    const auth = (0, $45ef3258e41ae9d6$export$1d39dc5b47e56ff0)();
    const { orgId: orgId } = (0, $20bbbf7d5bcb0a93$export$99eaa27ddbbb95ef)();
    const [isOpen, setIsOpen] = (0, $lldlC.useState)(false);
    const navLinks = orgId ? [
        {
            label: "Dashboard",
            onClick: ()=>navigateTo((0, $20ec8ba4fa00092b$export$9bf56a579356bd66).orgs.org.dashboard.link({
                    orgId: orgId
                }, {}))
        },
        {
            label: "Users",
            onClick: ()=>navigateTo((0, $20ec8ba4fa00092b$export$9bf56a579356bd66).orgs.org.members.list.link({
                    orgId: orgId
                }, {}))
        },
        {
            label: "Groups",
            onClick: ()=>navigateTo((0, $20ec8ba4fa00092b$export$9bf56a579356bd66).orgs.org.groups.list.link({
                    orgId: orgId
                }, {}))
        },
        {
            label: "Billing",
            onClick: ()=>{}
        },
        {
            label: "Settings",
            onClick: ()=>navigateTo((0, $20ec8ba4fa00092b$export$9bf56a579356bd66).orgs.org.edit.link({
                    orgId: orgId
                }, {}))
        }
    ] : [];
    const { renderLayer: renderLayer, triggerProps: triggerProps, layerProps: layerProps, arrowProps: arrowProps } = (0, $1c4fb89e1ab02400$export$807913709de17c01)({
        isOpen: isOpen,
        onOutsideClick: ()=>setIsOpen(false),
        onDisappear: ()=>setIsOpen(false),
        placement: "bottom-end",
        triggerOffset: 22
    });
    const toggleDropdown = ()=>{
        setIsOpen(!isOpen);
    };
    const logout = ()=>{
        auth.logout();
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $48125029fc620f16$export$ef8da11641c635de), {
        logo: {
            src: $792320feaee41c79$var$logo,
            alt: "Zickko Logo"
        },
        links: props.showNavLinks ? navLinks : [],
        actions: [
            {
                icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("button", {
                    className: "zickko-button",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $f4188c1fef1eb64c$export$2e2bcd8739ae039), {
                            className: "icon",
                            strokeWidth: 1.75
                        }),
                        "Access zickko"
                    ]
                }),
                action: ()=>{}
            },
            ...props.showUserIcon ? [
                {
                    icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "user-icon-container",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                                className: "icon-button",
                                ...triggerProps,
                                onClick: toggleDropdown,
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $e19949dc6cc036dc$export$2e2bcd8739ae039), {
                                    className: "icon",
                                    strokeWidth: 3
                                })
                            }),
                            isOpen && renderLayer(/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "dropdown-menu",
                                ...layerProps,
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $1c4fb89e1ab02400$export$21b07c8f274aebd5), {
                                        ...arrowProps,
                                        layerSide: "bottom",
                                        onPointerEnterCapture: ()=>{},
                                        onPointerLeaveCapture: ()=>{}
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("button", {
                                        className: "dropdown-buttons switch-button",
                                        onClick: ()=>navigateTo((0, $20ec8ba4fa00092b$export$9bf56a579356bd66).orgs.select.link({}, {})),
                                        children: [
                                            "Example Studios ",
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                                children: "Switch Organization"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("button", {
                                        className: "dropdown-buttons logged-in-button",
                                        children: [
                                            "Logged in as ",
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                                children: auth.user?.email
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                                        className: "dropdown-buttons",
                                        onClick: ()=>orgId ? navigateTo((0, $20ec8ba4fa00092b$export$9bf56a579356bd66).orgs.org.edit.link({
                                                orgId: orgId
                                            }, {})) : navigateTo((0, $20ec8ba4fa00092b$export$9bf56a579356bd66).orgs.create.link({}, {})),
                                        children: "Settings"
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                                        className: "dropdown-buttons",
                                        onClick: logout,
                                        children: "Logout"
                                    })
                                ]
                            }))
                        ]
                    }),
                    action: ()=>{}
                }
            ] : []
        ]
    });
};


const $d11af2c5a04dbf80$export$c6fe8c00cce8e413 = ()=>{
    //
    const { user: user } = (0, $45ef3258e41ae9d6$export$1d39dc5b47e56ff0)();
    const [showSignup, setShowSignup] = (0, $lldlC.useState)(false);
    const renderSignup = ()=>{
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $792320feaee41c79$export$5b97127cfaf7c3f5), {
                    showUserIcon: false
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "auth-widget",
                    children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $f7391967127461aa$export$93cf0349a782b585), {
                        onChange: ()=>setShowSignup(false)
                    })
                })
            ]
        });
    };
    const renderLogin = ()=>{
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $792320feaee41c79$export$5b97127cfaf7c3f5), {
                    showUserIcon: false
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "auth-widget",
                    children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $262cbea1b43a894e$export$3d423776c18897a), {
                        onChange: ()=>setShowSignup(true)
                    })
                })
            ]
        });
    };
    // user not logged in
    if (!user) {
        if (showSignup) return renderSignup();
        return renderLogin();
    }
    // user present
    if (user.email && !user.emailVerified) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $792320feaee41c79$export$5b97127cfaf7c3f5), {
                showUserIcon: true
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "auth-widget",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d1368fba386d3d93$export$1884a2df5920bfd5), {
                    email: user.email
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $ce8af0d64a5e8b97$export$cae1c58733dbe1ed), {
        message: `User already logged-in. Not ${user.email}, logout, to login as a different user.`
    });
};






const $2e364c54b0738fa9$export$fa28293725b41956 = (props)=>{
    const selectionToggle = (e)=>{
        var element = document.getElementsByClassName("selected");
        element[0]?.classList.remove("selected");
        e.target.classList.toggle("selected");
        if (e.target.id === "basic") props.setSelectedTab("basic");
        if (e.target.id === "dns-settings") props.setSelectedTab("dns-settings");
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "settings-nav",
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "nav-container",
            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "nav-container-items",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("ul", {
                    className: "nav-list",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("li", {
                            className: "nav-item selected",
                            id: "basic",
                            onClick: selectionToggle,
                            children: "Basic"
                        }, "basic"),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("li", {
                            className: "nav-item",
                            id: "dns-settings",
                            onClick: selectionToggle,
                            children: "DNS Settings"
                        }, "DNS Settings"),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("li", {
                            className: "nav-item",
                            id: "email-settings",
                            onClick: selectionToggle,
                            children: "Email Settings"
                        }, "Email Settings"),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("li", {
                            className: "nav-item",
                            id: "advanced",
                            onClick: selectionToggle,
                            children: "Advanced"
                        }, "Advanced")
                    ]
                })
            })
        })
    });
};



const $23510c92e640383c$export$c84671f46d6a1ca = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: `layout ${props.name}`,
        children: props.children
    });
};



const $6702048b6ff484e6$export$6955bcca4cd3539f = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: `page ${props.name}`,
        children: props.children
    });
};



const $6974fff77c24f88c$export$16800ac069904dff = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: `content ${props.additionalClassNames}`,
        children: props.children
    });
};



const $60be71f4561afbb9$export$53f1cd6809577fc5 = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "page-header",
        children: props.children
    });
};






var $lldlC = parcelRequire("lldlC");


const $7916f3d550438e18$export$38ee920e59704589 = /*#__PURE__*/ (0, $lldlC.createContext)({});
const $7916f3d550438e18$export$88f24fd8fcfab6ca = (props)=>{
    //
    const { user: user } = (0, $45ef3258e41ae9d6$export$1d39dc5b47e56ff0)();
    // login
    if (!user || !user.emailVerified) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d11af2c5a04dbf80$export$c6fe8c00cce8e413), {});
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($7916f3d550438e18$export$38ee920e59704589.Provider, {
        value: {
            user: user
        },
        children: props.children
    });
};
function $7916f3d550438e18$export$23bbbc4533528f03() {
    return (0, $lldlC.useContext)($7916f3d550438e18$export$38ee920e59704589);
}





class $8791d71a848a02f9$export$e64fa467c0e9c9e8 {
    constructor(firestorePath){
        this.ref = (key)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).collectionRef(this.firestorePath.path(key));
        };
        this.page = async (args)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).page({
                path: this.firestorePath.path(args.key),
                ...args
            });
        };
        this.query = async (args)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).query({
                path: this.firestorePath.path(args.key),
                ...args
            });
        };
        this.getCount = async (args)=>{
            const path = this.firestorePath.path(args.key);
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).countAll({
                path: path
            });
        };
        this.firestorePath = firestorePath;
    }
}



class $096ad58fadf3d169$export$551035b9d67de4c6 {
    constructor(firestorePath){
        this.template = ()=>{
            return this.firestorePath.template;
        };
        this.ref = (key)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).documentRef(this.path(key));
        };
        this.path = (key)=>{
            return this.firestorePath.path(key);
        };
        this.get = async (key)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).getDoc(this.path(key));
        };
        this.set = (key, obj)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).setDoc(this.path(key), obj);
        };
        this.merge = (key, obj)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).mergeDoc(this.path(key), obj);
        };
        this.remove = (key)=>{
            return (0, $6715d74da7b8c638$export$abf9d8f0eb83ad0).deleteDoc(this.path(key));
        };
        this.firestorePath = firestorePath;
    }
}


// prettier-ignore



const $abf2d4628a1238d4$export$2b8e1946228932b7 = {
    userProfile: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).userProfile),
    orgs: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).orgs),
    org: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).org),
    members: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).members),
    member: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).member),
    groups: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).groups),
    group: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).group),
    owners: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).owners),
    owner: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).owner),
    domainVerifications: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).domainVerifications),
    domainVerification: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).domainVerification),
    inbox: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).inbox),
    inboundEmail: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).inboundEmail),
    outbox: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).outbox),
    outboundEmail: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).outboundEmail),
    archive: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).archive),
    archiveEmail: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).archiveEmail),
    drafts: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).drafts),
    draftEmail: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).draftEmail),
    trash: new (0, $8791d71a848a02f9$export$e64fa467c0e9c9e8)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).trash),
    trashEmail: new (0, $096ad58fadf3d169$export$551035b9d67de4c6)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).trashEmail)
};





const $3092da2d1c8cfe85$export$84c25b2945fb8676 = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("pre", {
        children: JSON.stringify(props.value, null, 2)
    });
};




var $lldlC = parcelRequire("lldlC");



const $6a345e780dadf654$export$c4a9d90eb427f09c = /*#__PURE__*/ (0, $lldlC.createContext)({});
const $6a345e780dadf654$export$35eae644bb87870c = (props)=>{
    //
    const { orgId: orgId } = (0, $20bbbf7d5bcb0a93$export$99eaa27ddbbb95ef)();
    const [org, setOrg] = (0, $lldlC.useState)();
    // login
    if (!orgId) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Please check the URL. `orgId` expected in path."
    });
    (0, $lldlC.useEffect)(()=>{
        // get org
        (0, $abf2d4628a1238d4$export$2b8e1946228932b7).org.get({
            orgId: orgId
        }).then((doc)=>{
            if (doc) {
                setOrg(doc);
                return;
            }
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error(`Cannot find requested org.`);
            setOrg(null);
        });
    }, [
        orgId
    ]);
    if (org === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading org ..."
    });
    if (org === null) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Org not found."
    });
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($6a345e780dadf654$export$c4a9d90eb427f09c.Provider, {
        value: {
            org: org
        },
        children: props.children
    });
};
function $6a345e780dadf654$export$7f785727a26e156() {
    return (0, $lldlC.useContext)($6a345e780dadf654$export$c4a9d90eb427f09c);
}



const $29a77eb925234970$export$7097499bf5735f0a = (path)=>{
    const storage = (0, $3fab5dd6ec5d4e72$export$fbd9b57a66480737)();
    const pathReference = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)(storage, path);
    return (0, $3fab5dd6ec5d4e72$export$c8bf645a0c2a7d9f)(pathReference);
};




var $dba17d0653e4af30$export$882461b6382ed46c;
var $dba17d0653e4af30$export$757ceba2d55c277e;
'use strict';

var $dba17d0653e4af30$var$i;
$dba17d0653e4af30$export$882461b6382ed46c = $a47646e093dbda8d$exports.createRoot;
$dba17d0653e4af30$export$757ceba2d55c277e = $a47646e093dbda8d$exports.hydrateRoot;









var $lldlC = parcelRequire("lldlC");
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $b1251cab8096f97a$exports = {};

$parcel$export($b1251cab8096f97a$exports, "LexicalComposer", () => $b1251cab8096f97a$export$97615ad7610e68cc);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $b138a8ccd1cf7ffe$exports = {};

$parcel$export($b138a8ccd1cf7ffe$exports, "LexicalComposerContext", () => $b138a8ccd1cf7ffe$export$89ed468fc445de9);
$parcel$export($b138a8ccd1cf7ffe$exports, "createLexicalComposerContext", () => $b138a8ccd1cf7ffe$export$415f945d0a04b29b);
$parcel$export($b138a8ccd1cf7ffe$exports, "useLexicalComposerContext", () => $b138a8ccd1cf7ffe$export$6aeca6bab7b7edbc);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $lldlC = parcelRequire("lldlC");
function $b138a8ccd1cf7ffe$var$r(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $b138a8ccd1cf7ffe$var$t = $b138a8ccd1cf7ffe$var$r(function(e) {
    const n = new URLSearchParams;
    n.append("code", e);
    for(let e = 1; e < arguments.length; e++)n.append("v", arguments[e]);
    throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${n} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const $b138a8ccd1cf7ffe$export$89ed468fc445de9 = (0, $lldlC.createContext)(null);
function $b138a8ccd1cf7ffe$export$415f945d0a04b29b(e, n) {
    let r = null;
    return null != e && (r = e[1]), {
        getTheme: function() {
            return null != n ? n : null != r ? r.getTheme() : null;
        }
    };
}
function $b138a8ccd1cf7ffe$export$6aeca6bab7b7edbc() {
    const e = (0, $lldlC.useContext)($b138a8ccd1cf7ffe$export$89ed468fc445de9);
    return null == e && $b138a8ccd1cf7ffe$var$t(8), e;
}


const $594140ffbcb49f97$var$mod = $b138a8ccd1cf7ffe$exports;
const $594140ffbcb49f97$export$89ed468fc445de9 = $594140ffbcb49f97$var$mod.LexicalComposerContext;
const $594140ffbcb49f97$export$415f945d0a04b29b = $594140ffbcb49f97$var$mod.createLexicalComposerContext;
const $594140ffbcb49f97$export$6aeca6bab7b7edbc = $594140ffbcb49f97$var$mod.useLexicalComposerContext;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $6f291e234003fc86$exports = {};

$parcel$export($6f291e234003fc86$exports, "createCommand", () => $6f291e234003fc86$export$8d4021544bdece00);
$parcel$export($6f291e234003fc86$exports, "SELECTION_CHANGE_COMMAND", () => $6f291e234003fc86$export$e396fef71d2b56e5);
$parcel$export($6f291e234003fc86$exports, "SELECTION_INSERT_CLIPBOARD_NODES_COMMAND", () => $6f291e234003fc86$export$e47bb493817ec5f6);
$parcel$export($6f291e234003fc86$exports, "CLICK_COMMAND", () => $6f291e234003fc86$export$c1a2de6c823e5f82);
$parcel$export($6f291e234003fc86$exports, "DELETE_CHARACTER_COMMAND", () => $6f291e234003fc86$export$35595bf6d7e36fd5);
$parcel$export($6f291e234003fc86$exports, "INSERT_LINE_BREAK_COMMAND", () => $6f291e234003fc86$export$64e35ce26e025724);
$parcel$export($6f291e234003fc86$exports, "INSERT_PARAGRAPH_COMMAND", () => $6f291e234003fc86$export$24f4fea65b096b4);
$parcel$export($6f291e234003fc86$exports, "CONTROLLED_TEXT_INSERTION_COMMAND", () => $6f291e234003fc86$export$6f67c758bb657857);
$parcel$export($6f291e234003fc86$exports, "PASTE_COMMAND", () => $6f291e234003fc86$export$7fb70c61b3bcc883);
$parcel$export($6f291e234003fc86$exports, "REMOVE_TEXT_COMMAND", () => $6f291e234003fc86$export$9cc285f2a3ff220c);
$parcel$export($6f291e234003fc86$exports, "DELETE_WORD_COMMAND", () => $6f291e234003fc86$export$8e315b175631384c);
$parcel$export($6f291e234003fc86$exports, "DELETE_LINE_COMMAND", () => $6f291e234003fc86$export$d77fad8fb8747fd);
$parcel$export($6f291e234003fc86$exports, "FORMAT_TEXT_COMMAND", () => $6f291e234003fc86$export$85443a1a9543f043);
$parcel$export($6f291e234003fc86$exports, "UNDO_COMMAND", () => $6f291e234003fc86$export$34722a4946cb641e);
$parcel$export($6f291e234003fc86$exports, "REDO_COMMAND", () => $6f291e234003fc86$export$8c4a0748d31d9941);
$parcel$export($6f291e234003fc86$exports, "KEY_DOWN_COMMAND", () => $6f291e234003fc86$export$61973214e0e18936);
$parcel$export($6f291e234003fc86$exports, "KEY_ARROW_RIGHT_COMMAND", () => $6f291e234003fc86$export$217ec2281ac1c53b);
$parcel$export($6f291e234003fc86$exports, "MOVE_TO_END", () => $6f291e234003fc86$export$fb3b2d438650aff6);
$parcel$export($6f291e234003fc86$exports, "KEY_ARROW_LEFT_COMMAND", () => $6f291e234003fc86$export$7525f8f8ab44508);
$parcel$export($6f291e234003fc86$exports, "MOVE_TO_START", () => $6f291e234003fc86$export$dc117ee4d661295a);
$parcel$export($6f291e234003fc86$exports, "KEY_ARROW_UP_COMMAND", () => $6f291e234003fc86$export$7833c2a33ae81d3d);
$parcel$export($6f291e234003fc86$exports, "KEY_ARROW_DOWN_COMMAND", () => $6f291e234003fc86$export$baa60daa2ca402b3);
$parcel$export($6f291e234003fc86$exports, "KEY_ENTER_COMMAND", () => $6f291e234003fc86$export$2cdb7cdd6fccb293);
$parcel$export($6f291e234003fc86$exports, "KEY_SPACE_COMMAND", () => $6f291e234003fc86$export$d0bc2bb647ce4c17);
$parcel$export($6f291e234003fc86$exports, "KEY_BACKSPACE_COMMAND", () => $6f291e234003fc86$export$24bbba9bfa830f78);
$parcel$export($6f291e234003fc86$exports, "KEY_ESCAPE_COMMAND", () => $6f291e234003fc86$export$53589e422a755d59);
$parcel$export($6f291e234003fc86$exports, "KEY_DELETE_COMMAND", () => $6f291e234003fc86$export$13a0e72b5c0146bb);
$parcel$export($6f291e234003fc86$exports, "KEY_TAB_COMMAND", () => $6f291e234003fc86$export$b321bdc226ccdcde);
$parcel$export($6f291e234003fc86$exports, "INSERT_TAB_COMMAND", () => $6f291e234003fc86$export$926ce4da2c89d118);
$parcel$export($6f291e234003fc86$exports, "INDENT_CONTENT_COMMAND", () => $6f291e234003fc86$export$2f74f6a2d927e6bd);
$parcel$export($6f291e234003fc86$exports, "OUTDENT_CONTENT_COMMAND", () => $6f291e234003fc86$export$ecf9caa19e96e40d);
$parcel$export($6f291e234003fc86$exports, "DROP_COMMAND", () => $6f291e234003fc86$export$eac1e4b16b80d3ea);
$parcel$export($6f291e234003fc86$exports, "FORMAT_ELEMENT_COMMAND", () => $6f291e234003fc86$export$d394dc6514823b18);
$parcel$export($6f291e234003fc86$exports, "DRAGSTART_COMMAND", () => $6f291e234003fc86$export$2e0fd45fde1da719);
$parcel$export($6f291e234003fc86$exports, "DRAGOVER_COMMAND", () => $6f291e234003fc86$export$b62c1cce98fa7223);
$parcel$export($6f291e234003fc86$exports, "DRAGEND_COMMAND", () => $6f291e234003fc86$export$ffbd838cf75d7d8e);
$parcel$export($6f291e234003fc86$exports, "COPY_COMMAND", () => $6f291e234003fc86$export$3435fcfb1f59ef96);
$parcel$export($6f291e234003fc86$exports, "CUT_COMMAND", () => $6f291e234003fc86$export$4dc8a35a083beec4);
$parcel$export($6f291e234003fc86$exports, "SELECT_ALL_COMMAND", () => $6f291e234003fc86$export$185c218616045e75);
$parcel$export($6f291e234003fc86$exports, "CLEAR_EDITOR_COMMAND", () => $6f291e234003fc86$export$4926ce1a5702fdc7);
$parcel$export($6f291e234003fc86$exports, "CLEAR_HISTORY_COMMAND", () => $6f291e234003fc86$export$d3f69a65bbe7edc);
$parcel$export($6f291e234003fc86$exports, "CAN_REDO_COMMAND", () => $6f291e234003fc86$export$e36aacf84f559bb3);
$parcel$export($6f291e234003fc86$exports, "CAN_UNDO_COMMAND", () => $6f291e234003fc86$export$9fd9dd31dd6ebdf5);
$parcel$export($6f291e234003fc86$exports, "FOCUS_COMMAND", () => $6f291e234003fc86$export$cafe35f35e77bf56);
$parcel$export($6f291e234003fc86$exports, "BLUR_COMMAND", () => $6f291e234003fc86$export$4b6d457d076906ac);
$parcel$export($6f291e234003fc86$exports, "KEY_MODIFIER_COMMAND", () => $6f291e234003fc86$export$452548a3c1874d61);
$parcel$export($6f291e234003fc86$exports, "IS_BOLD", () => $6f291e234003fc86$export$d401051135d8c941);
$parcel$export($6f291e234003fc86$exports, "IS_ITALIC", () => $6f291e234003fc86$export$6f537bdfcfab164);
$parcel$export($6f291e234003fc86$exports, "IS_STRIKETHROUGH", () => $6f291e234003fc86$export$27809404dee18444);
$parcel$export($6f291e234003fc86$exports, "IS_UNDERLINE", () => $6f291e234003fc86$export$4fefe1576f07e925);
$parcel$export($6f291e234003fc86$exports, "IS_CODE", () => $6f291e234003fc86$export$bf809f2b03ed57cc);
$parcel$export($6f291e234003fc86$exports, "IS_SUBSCRIPT", () => $6f291e234003fc86$export$22c32c29c50da53a);
$parcel$export($6f291e234003fc86$exports, "IS_SUPERSCRIPT", () => $6f291e234003fc86$export$703b9afdf8723203);
$parcel$export($6f291e234003fc86$exports, "IS_HIGHLIGHT", () => $6f291e234003fc86$export$f1e9b55cdd671814);
$parcel$export($6f291e234003fc86$exports, "IS_ALL_FORMATTING", () => $6f291e234003fc86$export$a0ecbce4c0037b95);
$parcel$export($6f291e234003fc86$exports, "TEXT_TYPE_TO_FORMAT", () => $6f291e234003fc86$export$c9e7d6eb65b13430);
$parcel$export($6f291e234003fc86$exports, "$isRangeSelection", () => $6f291e234003fc86$export$181b63acea8a0224);
$parcel$export($6f291e234003fc86$exports, "$getSelection", () => $6f291e234003fc86$export$63a3201b3a5c7d90);
$parcel$export($6f291e234003fc86$exports, "$getNearestNodeFromDOMNode", () => $6f291e234003fc86$export$fef265f0d2fcffdd);
$parcel$export($6f291e234003fc86$exports, "$isDecoratorNode", () => $6f291e234003fc86$export$60aa03725ce41b1c);
$parcel$export($6f291e234003fc86$exports, "$isTextNode", () => $6f291e234003fc86$export$471953706258be2b);
$parcel$export($6f291e234003fc86$exports, "$isElementNode", () => $6f291e234003fc86$export$923a058ef54437a4);
$parcel$export($6f291e234003fc86$exports, "$setSelection", () => $6f291e234003fc86$export$2aad78c37810bca9);
$parcel$export($6f291e234003fc86$exports, "$normalizeSelection__EXPERIMENTAL", () => $6f291e234003fc86$export$db10bc6ba67ffcb5);
$parcel$export($6f291e234003fc86$exports, "resetRandomKey", () => $6f291e234003fc86$export$404db5fc87e4045);
$parcel$export($6f291e234003fc86$exports, "isSelectionCapturedInDecoratorInput", () => $6f291e234003fc86$export$340cc5df988bf401);
$parcel$export($6f291e234003fc86$exports, "isSelectionWithinEditor", () => $6f291e234003fc86$export$f1b377b21cd6350b);
$parcel$export($6f291e234003fc86$exports, "getNearestEditorFromDOMNode", () => $6f291e234003fc86$export$30c13854ab4c9903);
$parcel$export($6f291e234003fc86$exports, "$isLeafNode", () => $6f291e234003fc86$export$8d016e0592201ace);
$parcel$export($6f291e234003fc86$exports, "$isLineBreakNode", () => $6f291e234003fc86$export$b16330e40aa25c4e);
$parcel$export($6f291e234003fc86$exports, "$setCompositionKey", () => $6f291e234003fc86$export$ea25f5ef71f2d042);
$parcel$export($6f291e234003fc86$exports, "$getNodeByKey", () => $6f291e234003fc86$export$e725f93d4d48c6d8);
$parcel$export($6f291e234003fc86$exports, "isCurrentlyReadOnlyMode", () => $6f291e234003fc86$export$761df28585b755e8);
$parcel$export($6f291e234003fc86$exports, "$getRoot", () => $6f291e234003fc86$export$8d83ea843c4eea9a);
$parcel$export($6f291e234003fc86$exports, "$getPreviousSelection", () => $6f291e234003fc86$export$846e9407a8b5d98c);
$parcel$export($6f291e234003fc86$exports, "$createTextNode", () => $6f291e234003fc86$export$2785f39dcdec0078);
$parcel$export($6f291e234003fc86$exports, "$selectAll", () => $6f291e234003fc86$export$824f075b28fd7b6c);
$parcel$export($6f291e234003fc86$exports, "$nodesOfType", () => $6f291e234003fc86$export$ac6fed8d7d40e66c);
$parcel$export($6f291e234003fc86$exports, "$getAdjacentNode", () => $6f291e234003fc86$export$c4b907be1879d8c1);
$parcel$export($6f291e234003fc86$exports, "$isRootNode", () => $6f291e234003fc86$export$5b29ca560c2fedab);
$parcel$export($6f291e234003fc86$exports, "$hasUpdateTag", () => $6f291e234003fc86$export$fbcbbb073e480e61);
$parcel$export($6f291e234003fc86$exports, "$addUpdateTag", () => $6f291e234003fc86$export$24cab2f466b76c04);
$parcel$export($6f291e234003fc86$exports, "$hasAncestor", () => $6f291e234003fc86$export$e3d4b782f65c81f1);
$parcel$export($6f291e234003fc86$exports, "$isInlineElementOrDecoratorNode", () => $6f291e234003fc86$export$a78813a4e8e8b9dd);
$parcel$export($6f291e234003fc86$exports, "$getNearestRootOrShadowRoot", () => $6f291e234003fc86$export$6f13c476561e4734);
$parcel$export($6f291e234003fc86$exports, "$isRootOrShadowRoot", () => $6f291e234003fc86$export$6f851a24c61146af);
$parcel$export($6f291e234003fc86$exports, "$copyNode", () => $6f291e234003fc86$export$def73b17b22438e7);
$parcel$export($6f291e234003fc86$exports, "$applyNodeReplacement", () => $6f291e234003fc86$export$2f5beb31df92ea57);
$parcel$export($6f291e234003fc86$exports, "$getNodeByKeyOrThrow", () => $6f291e234003fc86$export$b86173decb513938);
$parcel$export($6f291e234003fc86$exports, "$splitNode", () => $6f291e234003fc86$export$cc2d53c74c1fb2b2);
$parcel$export($6f291e234003fc86$exports, "isHTMLAnchorElement", () => $6f291e234003fc86$export$f5326d78d8d21e1f);
$parcel$export($6f291e234003fc86$exports, "isHTMLElement", () => $6f291e234003fc86$export$1b3bfaa9684536aa);
$parcel$export($6f291e234003fc86$exports, "isInlineDomNode", () => $6f291e234003fc86$export$456fd4e5e0a7123d);
$parcel$export($6f291e234003fc86$exports, "isBlockDomNode", () => $6f291e234003fc86$export$5ef1a5ca687c7168);
$parcel$export($6f291e234003fc86$exports, "$getEditor", () => $6f291e234003fc86$export$8a7392c46faf1a3f);
$parcel$export($6f291e234003fc86$exports, "$isParagraphNode", () => $6f291e234003fc86$export$1fdda795300c79c6);
$parcel$export($6f291e234003fc86$exports, "$isNodeSelection", () => $6f291e234003fc86$export$7257e4181651a7c3);
$parcel$export($6f291e234003fc86$exports, "ParagraphNode", () => $6f291e234003fc86$export$e94424771493b912);
$parcel$export($6f291e234003fc86$exports, "$createParagraphNode", () => $6f291e234003fc86$export$7f0c05ffb7ced90d);
$parcel$export($6f291e234003fc86$exports, "LineBreakNode", () => $6f291e234003fc86$export$965f56e8043e93ae);
$parcel$export($6f291e234003fc86$exports, "$createLineBreakNode", () => $6f291e234003fc86$export$4ccaf7d0d16ab4c);
$parcel$export($6f291e234003fc86$exports, "TextNode", () => $6f291e234003fc86$export$f0a25ea3087686aa);
$parcel$export($6f291e234003fc86$exports, "$createTabNode", () => $6f291e234003fc86$export$5bde9d58a1da0796);
$parcel$export($6f291e234003fc86$exports, "TabNode", () => $6f291e234003fc86$export$8dbf7edd89edc19c);
$parcel$export($6f291e234003fc86$exports, "$isTabNode", () => $6f291e234003fc86$export$ac9141efa5fb7932);
$parcel$export($6f291e234003fc86$exports, "$createPoint", () => $6f291e234003fc86$export$9b3f8d373c057995);
$parcel$export($6f291e234003fc86$exports, "$getCharacterOffsets", () => $6f291e234003fc86$export$5a33b5b9a9d5db8f);
$parcel$export($6f291e234003fc86$exports, "$createNodeSelection", () => $6f291e234003fc86$export$f8cd0c3f35d1a61c);
$parcel$export($6f291e234003fc86$exports, "$isBlockElementNode", () => $6f291e234003fc86$export$de078facd4ee1560);
$parcel$export($6f291e234003fc86$exports, "$createRangeSelection", () => $6f291e234003fc86$export$1ccc217b9831b072);
$parcel$export($6f291e234003fc86$exports, "$createRangeSelectionFromDom", () => $6f291e234003fc86$export$68ac2b736ac647aa);
$parcel$export($6f291e234003fc86$exports, "$insertNodes", () => $6f291e234003fc86$export$d773017360b45449);
$parcel$export($6f291e234003fc86$exports, "$getTextContent", () => $6f291e234003fc86$export$2d96f9a07231d1b9);
$parcel$export($6f291e234003fc86$exports, "$parseSerializedNode", () => $6f291e234003fc86$export$e1d3a194df5be556);
$parcel$export($6f291e234003fc86$exports, "ElementNode", () => $6f291e234003fc86$export$dc064fe9e59310fd);
$parcel$export($6f291e234003fc86$exports, "DecoratorNode", () => $6f291e234003fc86$export$8244b9efe04488e);
$parcel$export($6f291e234003fc86$exports, "RootNode", () => $6f291e234003fc86$export$1c180cb67301903c);
$parcel$export($6f291e234003fc86$exports, "ArtificialNode__DO_NOT_USE", () => $6f291e234003fc86$export$82a585c2442a6dd6);
$parcel$export($6f291e234003fc86$exports, "COMMAND_PRIORITY_EDITOR", () => $6f291e234003fc86$export$11c61e12af5e1f41);
$parcel$export($6f291e234003fc86$exports, "COMMAND_PRIORITY_LOW", () => $6f291e234003fc86$export$1d1358fe8b5bfab4);
$parcel$export($6f291e234003fc86$exports, "COMMAND_PRIORITY_NORMAL", () => $6f291e234003fc86$export$7bb13e375de35064);
$parcel$export($6f291e234003fc86$exports, "COMMAND_PRIORITY_HIGH", () => $6f291e234003fc86$export$e8fb7042985cd2e9);
$parcel$export($6f291e234003fc86$exports, "COMMAND_PRIORITY_CRITICAL", () => $6f291e234003fc86$export$6afdf194f304e546);
$parcel$export($6f291e234003fc86$exports, "createEditor", () => $6f291e234003fc86$export$eb02d1ee0d3cac30);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ function $6f291e234003fc86$export$8d4021544bdece00(t) {
    return {};
}
const $6f291e234003fc86$export$e396fef71d2b56e5 = {}, $6f291e234003fc86$export$e47bb493817ec5f6 = {}, $6f291e234003fc86$export$c1a2de6c823e5f82 = {}, $6f291e234003fc86$export$35595bf6d7e36fd5 = {}, $6f291e234003fc86$export$64e35ce26e025724 = {}, $6f291e234003fc86$export$24f4fea65b096b4 = {}, $6f291e234003fc86$export$6f67c758bb657857 = {}, $6f291e234003fc86$export$7fb70c61b3bcc883 = {}, $6f291e234003fc86$export$9cc285f2a3ff220c = {}, $6f291e234003fc86$export$8e315b175631384c = {}, $6f291e234003fc86$export$d77fad8fb8747fd = {}, $6f291e234003fc86$export$85443a1a9543f043 = {}, $6f291e234003fc86$export$34722a4946cb641e = {}, $6f291e234003fc86$export$8c4a0748d31d9941 = {}, $6f291e234003fc86$export$61973214e0e18936 = {}, $6f291e234003fc86$export$217ec2281ac1c53b = {}, $6f291e234003fc86$export$fb3b2d438650aff6 = {}, $6f291e234003fc86$export$7525f8f8ab44508 = {}, $6f291e234003fc86$export$dc117ee4d661295a = {}, $6f291e234003fc86$export$7833c2a33ae81d3d = {}, $6f291e234003fc86$export$baa60daa2ca402b3 = {}, $6f291e234003fc86$export$2cdb7cdd6fccb293 = {}, $6f291e234003fc86$export$d0bc2bb647ce4c17 = {}, $6f291e234003fc86$export$24bbba9bfa830f78 = {}, $6f291e234003fc86$export$53589e422a755d59 = {}, $6f291e234003fc86$export$13a0e72b5c0146bb = {}, $6f291e234003fc86$export$b321bdc226ccdcde = {}, $6f291e234003fc86$export$926ce4da2c89d118 = {}, $6f291e234003fc86$export$2f74f6a2d927e6bd = {}, $6f291e234003fc86$export$ecf9caa19e96e40d = {}, $6f291e234003fc86$export$eac1e4b16b80d3ea = {}, $6f291e234003fc86$export$d394dc6514823b18 = {}, $6f291e234003fc86$export$2e0fd45fde1da719 = {}, $6f291e234003fc86$export$b62c1cce98fa7223 = {}, $6f291e234003fc86$export$ffbd838cf75d7d8e = {}, $6f291e234003fc86$export$3435fcfb1f59ef96 = {}, $6f291e234003fc86$export$4dc8a35a083beec4 = {}, $6f291e234003fc86$export$185c218616045e75 = {}, $6f291e234003fc86$export$4926ce1a5702fdc7 = {}, $6f291e234003fc86$export$d3f69a65bbe7edc = {}, $6f291e234003fc86$export$e36aacf84f559bb3 = {}, $6f291e234003fc86$export$9fd9dd31dd6ebdf5 = {}, $6f291e234003fc86$export$cafe35f35e77bf56 = {}, $6f291e234003fc86$export$4b6d457d076906ac = {}, $6f291e234003fc86$export$452548a3c1874d61 = {}, $6f291e234003fc86$var$H = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement, $6f291e234003fc86$var$j = $6f291e234003fc86$var$H && "documentMode" in document ? document.documentMode : null, $6f291e234003fc86$var$q = $6f291e234003fc86$var$H && /Mac|iPod|iPhone|iPad/.test(navigator.platform), $6f291e234003fc86$var$Q = $6f291e234003fc86$var$H && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), $6f291e234003fc86$var$X = !(!$6f291e234003fc86$var$H || !("InputEvent" in window) || $6f291e234003fc86$var$j) && "getTargetRanges" in new window.InputEvent("input"), $6f291e234003fc86$var$Y = $6f291e234003fc86$var$H && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), $6f291e234003fc86$var$Z = $6f291e234003fc86$var$H && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, $6f291e234003fc86$var$G = $6f291e234003fc86$var$H && /Android/.test(navigator.userAgent), $6f291e234003fc86$var$tt = $6f291e234003fc86$var$H && /^(?=.*Chrome).*/i.test(navigator.userAgent), $6f291e234003fc86$var$et = $6f291e234003fc86$var$H && $6f291e234003fc86$var$G && $6f291e234003fc86$var$tt, $6f291e234003fc86$var$nt = $6f291e234003fc86$var$H && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !$6f291e234003fc86$var$tt, $6f291e234003fc86$var$rt = 1, $6f291e234003fc86$var$st = 3, $6f291e234003fc86$var$it = 0, $6f291e234003fc86$var$ot = 1, $6f291e234003fc86$var$lt = 2, $6f291e234003fc86$var$ct = 0, $6f291e234003fc86$var$at = 1, $6f291e234003fc86$var$ut = 2, $6f291e234003fc86$export$d401051135d8c941 = 1, $6f291e234003fc86$export$6f537bdfcfab164 = 2, $6f291e234003fc86$export$27809404dee18444 = 4, $6f291e234003fc86$export$4fefe1576f07e925 = 8, $6f291e234003fc86$export$bf809f2b03ed57cc = 16, $6f291e234003fc86$export$22c32c29c50da53a = 32, $6f291e234003fc86$export$703b9afdf8723203 = 64, $6f291e234003fc86$export$f1e9b55cdd671814 = 128, $6f291e234003fc86$export$a0ecbce4c0037b95 = 112 | (3 | $6f291e234003fc86$export$27809404dee18444 | $6f291e234003fc86$export$4fefe1576f07e925) | $6f291e234003fc86$export$f1e9b55cdd671814, $6f291e234003fc86$var$vt = 1, $6f291e234003fc86$var$Tt = 2, $6f291e234003fc86$var$Ct = 3, $6f291e234003fc86$var$St = 4, $6f291e234003fc86$var$kt = 5, $6f291e234003fc86$var$bt = 6, $6f291e234003fc86$var$wt = $6f291e234003fc86$var$Y || $6f291e234003fc86$var$Z || $6f291e234003fc86$var$nt ? "\xa0" : "\u200B", $6f291e234003fc86$var$Nt = "\n\n", $6f291e234003fc86$var$Et = $6f291e234003fc86$var$Q ? "\xa0" : $6f291e234003fc86$var$wt, $6f291e234003fc86$var$Pt = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC", $6f291e234003fc86$var$Dt = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF", $6f291e234003fc86$var$Ft = new RegExp("^[^" + $6f291e234003fc86$var$Dt + "]*[" + $6f291e234003fc86$var$Pt + "]"), $6f291e234003fc86$var$Ot = new RegExp("^[^" + $6f291e234003fc86$var$Pt + "]*[" + $6f291e234003fc86$var$Dt + "]"), $6f291e234003fc86$export$c9e7d6eb65b13430 = {
    bold: 1,
    code: 16,
    highlight: $6f291e234003fc86$export$f1e9b55cdd671814,
    italic: 2,
    strikethrough: $6f291e234003fc86$export$27809404dee18444,
    subscript: 32,
    superscript: 64,
    underline: $6f291e234003fc86$export$4fefe1576f07e925
}, $6f291e234003fc86$var$Lt = {
    directionless: 1,
    unmergeable: 2
}, $6f291e234003fc86$var$At = {
    center: $6f291e234003fc86$var$Tt,
    end: $6f291e234003fc86$var$bt,
    justify: $6f291e234003fc86$var$St,
    left: $6f291e234003fc86$var$vt,
    right: $6f291e234003fc86$var$Ct,
    start: $6f291e234003fc86$var$kt
}, $6f291e234003fc86$var$Mt = {
    [$6f291e234003fc86$var$Tt]: "center",
    [$6f291e234003fc86$var$bt]: "end",
    [$6f291e234003fc86$var$St]: "justify",
    [$6f291e234003fc86$var$vt]: "left",
    [$6f291e234003fc86$var$Ct]: "right",
    [$6f291e234003fc86$var$kt]: "start"
}, $6f291e234003fc86$var$zt = {
    normal: 0,
    segmented: 2,
    token: 1
}, $6f291e234003fc86$var$Wt = {
    [$6f291e234003fc86$var$ct]: "normal",
    [$6f291e234003fc86$var$ut]: "segmented",
    [$6f291e234003fc86$var$at]: "token"
};
function $6f291e234003fc86$var$Bt(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $6f291e234003fc86$var$Rt = $6f291e234003fc86$var$Bt(function(t) {
    const e = new URLSearchParams;
    e.append("code", t);
    for(let t = 1; t < arguments.length; t++)e.append("v", arguments[t]);
    throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function $6f291e234003fc86$var$Kt(...t) {
    const e = [];
    for (const n of t)if (n && "string" == typeof n) for (const [t] of n.matchAll(/\S+/g))e.push(t);
    return e;
}
const $6f291e234003fc86$var$Jt = 100;
let $6f291e234003fc86$var$Ut = !1, $6f291e234003fc86$var$Vt = 0;
function $6f291e234003fc86$var$$t(t) {
    $6f291e234003fc86$var$Vt = t.timeStamp;
}
function $6f291e234003fc86$var$Ht(t, e, n) {
    return e.__lexicalLineBreak === t || void 0 !== t[`__lexicalKey_${n._key}`];
}
function $6f291e234003fc86$var$jt(t, e, n) {
    const r = $6f291e234003fc86$var$_n(n._window);
    let s = null, i = null;
    null !== r && r.anchorNode === t && (s = r.anchorOffset, i = r.focusOffset);
    const o = t.nodeValue;
    null !== o && $6f291e234003fc86$var$Le(e, o, s, i, !1);
}
function $6f291e234003fc86$var$qt(t, e, n) {
    if ($6f291e234003fc86$export$181b63acea8a0224(t)) {
        const e = t.anchor.getNode();
        if (e.is(n) && t.format !== e.getFormat()) return !1;
    }
    return e.nodeType === $6f291e234003fc86$var$st && n.isAttached();
}
function $6f291e234003fc86$var$Qt(t, e, n) {
    $6f291e234003fc86$var$Ut = !0;
    const r = performance.now() - $6f291e234003fc86$var$Vt > $6f291e234003fc86$var$Jt;
    try {
        $6f291e234003fc86$var$ii(t, ()=>{
            const s = $6f291e234003fc86$export$63a3201b3a5c7d90() || function(t) {
                return t.getEditorState().read(()=>{
                    const t = $6f291e234003fc86$export$63a3201b3a5c7d90();
                    return null !== t ? t.clone() : null;
                });
            }(t), i = new Map, o = t.getRootElement(), l = t._editorState, c = t._blockCursorElement;
            let a = !1, u = "";
            for(let n = 0; n < e.length; n++){
                const f = e[n], d = f.type, h = f.target;
                let g = $6f291e234003fc86$export$fef265f0d2fcffdd(h, l);
                if (!(null === g && h !== o || $6f291e234003fc86$export$60aa03725ce41b1c(g))) {
                    if ("characterData" === d) r && $6f291e234003fc86$export$471953706258be2b(g) && $6f291e234003fc86$var$qt(s, h, g) && $6f291e234003fc86$var$jt(h, g, t);
                    else if ("childList" === d) {
                        a = !0;
                        const e = f.addedNodes;
                        for(let n = 0; n < e.length; n++){
                            const r = e[n], s = $6f291e234003fc86$var$ve(r), i = r.parentNode;
                            if (null != i && r !== c && null === s && ("BR" !== r.nodeName || !$6f291e234003fc86$var$Ht(r, i, t))) {
                                if ($6f291e234003fc86$var$Q) {
                                    const t = r.innerText || r.nodeValue;
                                    t && (u += t);
                                }
                                i.removeChild(r);
                            }
                        }
                        const n = f.removedNodes, r = n.length;
                        if (r > 0) {
                            let e = 0;
                            for(let s = 0; s < r; s++){
                                const r = n[s];
                                ("BR" === r.nodeName && $6f291e234003fc86$var$Ht(r, h, t) || c === r) && (h.appendChild(r), e++);
                            }
                            r !== e && (h === o && (g = $6f291e234003fc86$var$be(l)), i.set(h, g));
                        }
                    }
                }
            }
            if (i.size > 0) for (const [e, n] of i)if ($6f291e234003fc86$export$923a058ef54437a4(n)) {
                const r = n.getChildrenKeys();
                let s = e.firstChild;
                for(let n = 0; n < r.length; n++){
                    const i = r[n], o = t.getElementByKey(i);
                    null !== o && (null == s ? (e.appendChild(o), s = o) : s !== o && e.replaceChild(o, s), s = s.nextSibling);
                }
            } else $6f291e234003fc86$export$471953706258be2b(n) && n.markDirty();
            const f = n.takeRecords();
            if (f.length > 0) {
                for(let e = 0; e < f.length; e++){
                    const n = f[e], r = n.addedNodes, s = n.target;
                    for(let e = 0; e < r.length; e++){
                        const n = r[e], i = n.parentNode;
                        null == i || "BR" !== n.nodeName || $6f291e234003fc86$var$Ht(n, s, t) || i.removeChild(n);
                    }
                }
                n.takeRecords();
            }
            null !== s && (a && (s.dirty = !0, $6f291e234003fc86$export$2aad78c37810bca9(s)), $6f291e234003fc86$var$Q && $6f291e234003fc86$var$Qe(t) && s.insertRawText(u));
        });
    } finally{
        $6f291e234003fc86$var$Ut = !1;
    }
}
function $6f291e234003fc86$var$Xt(t) {
    const e = t._observer;
    if (null !== e) $6f291e234003fc86$var$Qt(t, e.takeRecords(), e);
}
function $6f291e234003fc86$var$Yt(t) {
    !function(t) {
        0 === $6f291e234003fc86$var$Vt && $6f291e234003fc86$var$rn(t).addEventListener("textInput", $6f291e234003fc86$var$$t, !0);
    }(t), t._observer = new MutationObserver((e, n)=>{
        $6f291e234003fc86$var$Qt(t, e, n);
    });
}
function $6f291e234003fc86$var$Zt(t, e) {
    const n = t.__mode, r = t.__format, s = t.__style, i = e.__mode, o = e.__format, l = e.__style;
    return !(null !== n && n !== i || null !== r && r !== o || null !== s && s !== l);
}
function $6f291e234003fc86$var$Gt(t, e) {
    const n = t.mergeWithSibling(e), r = $6f291e234003fc86$var$js()._normalizedNodes;
    return r.add(t.__key), r.add(e.__key), n;
}
function $6f291e234003fc86$var$te(t) {
    let e, n, r = t;
    if ("" !== r.__text || !r.isSimpleText() || r.isUnmergeable()) {
        for(; null !== (e = r.getPreviousSibling()) && $6f291e234003fc86$export$471953706258be2b(e) && e.isSimpleText() && !e.isUnmergeable();){
            if ("" !== e.__text) {
                if ($6f291e234003fc86$var$Zt(e, r)) {
                    r = $6f291e234003fc86$var$Gt(e, r);
                    break;
                }
                break;
            }
            e.remove();
        }
        for(; null !== (n = r.getNextSibling()) && $6f291e234003fc86$export$471953706258be2b(n) && n.isSimpleText() && !n.isUnmergeable();){
            if ("" !== n.__text) {
                if ($6f291e234003fc86$var$Zt(r, n)) {
                    r = $6f291e234003fc86$var$Gt(r, n);
                    break;
                }
                break;
            }
            n.remove();
        }
    } else r.remove();
}
function $6f291e234003fc86$export$db10bc6ba67ffcb5(t) {
    return $6f291e234003fc86$var$ne(t.anchor), $6f291e234003fc86$var$ne(t.focus), t;
}
function $6f291e234003fc86$var$ne(t) {
    for(; "element" === t.type;){
        const e = t.getNode(), n = t.offset;
        let r, s;
        if (n === e.getChildrenSize() ? (r = e.getChildAtIndex(n - 1), s = !0) : (r = e.getChildAtIndex(n), s = !1), $6f291e234003fc86$export$471953706258be2b(r)) {
            t.set(r.__key, s ? r.getTextContentSize() : 0, "text");
            break;
        }
        if (!$6f291e234003fc86$export$923a058ef54437a4(r)) break;
        t.set(r.__key, s ? r.getChildrenSize() : 0, "element");
    }
}
let $6f291e234003fc86$var$re = 1;
function $6f291e234003fc86$export$404db5fc87e4045() {
    $6f291e234003fc86$var$re = 1;
}
const $6f291e234003fc86$var$ie = "function" == typeof queueMicrotask ? queueMicrotask : (t)=>{
    Promise.resolve().then(t);
};
function $6f291e234003fc86$export$340cc5df988bf401(t) {
    const e = document.activeElement;
    if (null === e) return !1;
    const n = e.nodeName;
    return $6f291e234003fc86$export$60aa03725ce41b1c($6f291e234003fc86$export$fef265f0d2fcffdd(t)) && ("INPUT" === n || "TEXTAREA" === n || "true" === e.contentEditable && null == e.__lexicalEditor);
}
function $6f291e234003fc86$export$f1b377b21cd6350b(t, e, n) {
    const r = t.getRootElement();
    try {
        return null !== r && r.contains(e) && r.contains(n) && null !== e && !$6f291e234003fc86$export$340cc5df988bf401(e) && $6f291e234003fc86$export$30c13854ab4c9903(e) === t;
    } catch (t) {
        return !1;
    }
}
function $6f291e234003fc86$export$30c13854ab4c9903(t) {
    let e = t;
    for(; null != e;){
        const t = e.__lexicalEditor;
        if (null != t) return t;
        e = $6f291e234003fc86$var$Ge(e);
    }
    return null;
}
function $6f291e234003fc86$var$ae(t) {
    return t.isToken() || t.isSegmented();
}
function $6f291e234003fc86$var$ue(t) {
    return t.nodeType === $6f291e234003fc86$var$st;
}
function $6f291e234003fc86$var$fe(t) {
    let e = t;
    for(; null != e;){
        if ($6f291e234003fc86$var$ue(e)) return e;
        e = e.firstChild;
    }
    return null;
}
function $6f291e234003fc86$var$de(t, e, n) {
    const r = $6f291e234003fc86$export$c9e7d6eb65b13430[e];
    if (null !== n && (t & r) == (n & r)) return t;
    let s = t ^ r;
    return "subscript" === e ? s &= ~$6f291e234003fc86$export$c9e7d6eb65b13430.superscript : "superscript" === e && (s &= ~$6f291e234003fc86$export$c9e7d6eb65b13430.subscript), s;
}
function $6f291e234003fc86$export$8d016e0592201ace(t) {
    return $6f291e234003fc86$export$471953706258be2b(t) || $6f291e234003fc86$export$b16330e40aa25c4e(t) || $6f291e234003fc86$export$60aa03725ce41b1c(t);
}
function $6f291e234003fc86$var$ge(t, e) {
    if (null != e) return void (t.__key = e);
    $6f291e234003fc86$var$Vs(), $6f291e234003fc86$var$$s();
    const n = $6f291e234003fc86$var$js(), r = $6f291e234003fc86$var$Hs(), s = "" + $6f291e234003fc86$var$re++;
    r._nodeMap.set(s, t), $6f291e234003fc86$export$923a058ef54437a4(t) ? n._dirtyElements.set(s, !0) : n._dirtyLeaves.add(s), n._cloneNotNeeded.add(s), n._dirtyType = $6f291e234003fc86$var$ot, t.__key = s;
}
function $6f291e234003fc86$var$_e(t) {
    const e = t.getParent();
    if (null !== e) {
        const n = t.getWritable(), r = e.getWritable(), s = t.getPreviousSibling(), i = t.getNextSibling();
        if (null === s) {
            if (null !== i) {
                const t = i.getWritable();
                r.__first = i.__key, t.__prev = null;
            } else r.__first = null;
        } else {
            const t = s.getWritable();
            if (null !== i) {
                const e = i.getWritable();
                e.__prev = t.__key, t.__next = e.__key;
            } else t.__next = null;
            n.__prev = null;
        }
        if (null === i) {
            if (null !== s) {
                const t = s.getWritable();
                r.__last = s.__key, t.__next = null;
            } else r.__last = null;
        } else {
            const t = i.getWritable();
            if (null !== s) {
                const e = s.getWritable();
                e.__next = t.__key, t.__prev = e.__key;
            } else t.__prev = null;
            n.__next = null;
        }
        r.__size--, n.__parent = null;
    }
}
function $6f291e234003fc86$var$pe(t) {
    $6f291e234003fc86$var$$s();
    const e = t.getLatest(), n = e.__parent, r = $6f291e234003fc86$var$Hs(), s = $6f291e234003fc86$var$js(), i = r._nodeMap, o = s._dirtyElements;
    null !== n && function(t, e, n) {
        let r = t;
        for(; null !== r;){
            if (n.has(r)) return;
            const t = e.get(r);
            if (void 0 === t) break;
            n.set(r, !1), r = t.__parent;
        }
    }(n, i, o);
    const l = e.__key;
    s._dirtyType = $6f291e234003fc86$var$ot, $6f291e234003fc86$export$923a058ef54437a4(t) ? o.set(l, !0) : s._dirtyLeaves.add(l);
}
function $6f291e234003fc86$export$ea25f5ef71f2d042(t) {
    $6f291e234003fc86$var$Vs();
    const e = $6f291e234003fc86$var$js(), n = e._compositionKey;
    if (t !== n) {
        if (e._compositionKey = t, null !== n) {
            const t = $6f291e234003fc86$export$e725f93d4d48c6d8(n);
            null !== t && t.getWritable();
        }
        if (null !== t) {
            const e = $6f291e234003fc86$export$e725f93d4d48c6d8(t);
            null !== e && e.getWritable();
        }
    }
}
function $6f291e234003fc86$var$me() {
    if ($6f291e234003fc86$export$761df28585b755e8()) return null;
    return $6f291e234003fc86$var$js()._compositionKey;
}
function $6f291e234003fc86$export$e725f93d4d48c6d8(t, e) {
    const n = (e || $6f291e234003fc86$var$Hs())._nodeMap.get(t);
    return void 0 === n ? null : n;
}
function $6f291e234003fc86$var$ve(t, e) {
    const n = t[`__lexicalKey_${$6f291e234003fc86$var$js()._key}`];
    return void 0 !== n ? $6f291e234003fc86$export$e725f93d4d48c6d8(n, e) : null;
}
function $6f291e234003fc86$export$fef265f0d2fcffdd(t, e) {
    let n = t;
    for(; null != n;){
        const t = $6f291e234003fc86$var$ve(n, e);
        if (null !== t) return t;
        n = $6f291e234003fc86$var$Ge(n);
    }
    return null;
}
function $6f291e234003fc86$var$Ce(t) {
    const e = t._decorators, n = Object.assign({}, e);
    return t._pendingDecorators = n, n;
}
function $6f291e234003fc86$var$Se(t) {
    return t.read(()=>$6f291e234003fc86$export$8d83ea843c4eea9a().getTextContent());
}
function $6f291e234003fc86$export$8d83ea843c4eea9a() {
    return $6f291e234003fc86$var$be($6f291e234003fc86$var$Hs());
}
function $6f291e234003fc86$var$be(t) {
    return t._nodeMap.get("root");
}
function $6f291e234003fc86$export$2aad78c37810bca9(t) {
    $6f291e234003fc86$var$Vs();
    const e = $6f291e234003fc86$var$Hs();
    null !== t && (t.dirty = !0, t.setCachedNodes(null)), e._selection = t;
}
function $6f291e234003fc86$var$Ne(t) {
    const e = $6f291e234003fc86$var$js(), n = function(t, e) {
        let n = t;
        for(; null != n;){
            const t = n[`__lexicalKey_${e._key}`];
            if (void 0 !== t) return t;
            n = $6f291e234003fc86$var$Ge(n);
        }
        return null;
    }(t, e);
    if (null === n) return t === e.getRootElement() ? $6f291e234003fc86$export$e725f93d4d48c6d8("root") : null;
    return $6f291e234003fc86$export$e725f93d4d48c6d8(n);
}
function $6f291e234003fc86$var$Ee(t, e) {
    return e ? t.getTextContentSize() : 0;
}
function $6f291e234003fc86$var$Pe(t) {
    return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(t);
}
function $6f291e234003fc86$var$De(t) {
    const e = [];
    let n = t;
    for(; null !== n;)e.push(n), n = n._parentEditor;
    return e;
}
function $6f291e234003fc86$var$Fe() {
    return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function $6f291e234003fc86$var$Oe(t) {
    return t.nodeType === $6f291e234003fc86$var$st ? t.nodeValue : null;
}
function $6f291e234003fc86$var$Ie(t, e, n) {
    const r = $6f291e234003fc86$var$_n(e._window);
    if (null === r) return;
    const s = r.anchorNode;
    let { anchorOffset: i, focusOffset: o } = r;
    if (null !== s) {
        let e = $6f291e234003fc86$var$Oe(s);
        const r = $6f291e234003fc86$export$fef265f0d2fcffdd(s);
        if (null !== e && $6f291e234003fc86$export$471953706258be2b(r)) {
            if (e === $6f291e234003fc86$var$wt && n) {
                const t = n.length;
                e = n, i = t, o = t;
            }
            null !== e && $6f291e234003fc86$var$Le(r, e, i, o, t);
        }
    }
}
function $6f291e234003fc86$var$Le(t, e, n, r, s) {
    let i = t;
    if (i.isAttached() && (s || !i.isDirty())) {
        const o = i.isComposing();
        let l = e;
        (o || s) && e[e.length - 1] === $6f291e234003fc86$var$wt && (l = e.slice(0, -1));
        const c = i.getTextContent();
        if (s || l !== c) {
            if ("" === l) {
                if ($6f291e234003fc86$export$ea25f5ef71f2d042(null), $6f291e234003fc86$var$Y || $6f291e234003fc86$var$Z || $6f291e234003fc86$var$nt) i.remove();
                else {
                    const t = $6f291e234003fc86$var$js();
                    setTimeout(()=>{
                        t.update(()=>{
                            i.isAttached() && i.remove();
                        });
                    }, 20);
                }
                return;
            }
            const e = i.getParent(), s = $6f291e234003fc86$export$846e9407a8b5d98c(), c = i.getTextContentSize(), a = $6f291e234003fc86$var$me(), u = i.getKey();
            if (i.isToken() || null !== a && u === a && !o || $6f291e234003fc86$export$181b63acea8a0224(s) && (null !== e && !e.canInsertTextBefore() && 0 === s.anchor.offset || s.anchor.key === t.__key && 0 === s.anchor.offset && !i.canInsertTextBefore() && !o || s.focus.key === t.__key && s.focus.offset === c && !i.canInsertTextAfter() && !o)) return void i.markDirty();
            const f = $6f291e234003fc86$export$63a3201b3a5c7d90();
            if (!$6f291e234003fc86$export$181b63acea8a0224(f) || null === n || null === r) return void i.setTextContent(l);
            if (f.setTextNodeRange(i, n, i, r), i.isSegmented()) {
                const t = $6f291e234003fc86$export$2785f39dcdec0078(i.getTextContent());
                i.replace(t), i = t;
            }
            i.setTextContent(l);
        }
    }
}
function $6f291e234003fc86$var$Ae(t, e) {
    if (e.isSegmented()) return !0;
    if (!t.isCollapsed()) return !1;
    const n = t.anchor.offset, r = e.getParentOrThrow(), s = e.isToken();
    return 0 === n ? !e.canInsertTextBefore() || !r.canInsertTextBefore() && !e.isComposing() || s || function(t) {
        const e = t.getPreviousSibling();
        return ($6f291e234003fc86$export$471953706258be2b(e) || $6f291e234003fc86$export$923a058ef54437a4(e) && e.isInline()) && !e.canInsertTextAfter();
    }(e) : n === e.getTextContentSize() && (!e.canInsertTextAfter() || !r.canInsertTextAfter() && !e.isComposing() || s);
}
function $6f291e234003fc86$var$Me(t) {
    return "ArrowLeft" === t;
}
function $6f291e234003fc86$var$ze(t) {
    return "ArrowRight" === t;
}
function $6f291e234003fc86$var$We(t, e) {
    return $6f291e234003fc86$var$q ? t : e;
}
function $6f291e234003fc86$var$Be(t) {
    return "Enter" === t;
}
function $6f291e234003fc86$var$Re(t) {
    return "Backspace" === t;
}
function $6f291e234003fc86$var$Ke(t) {
    return "Delete" === t;
}
function $6f291e234003fc86$var$Je(t, e, n) {
    return "a" === t.toLowerCase() && $6f291e234003fc86$var$We(e, n);
}
function $6f291e234003fc86$export$824f075b28fd7b6c() {
    const t = $6f291e234003fc86$export$8d83ea843c4eea9a();
    $6f291e234003fc86$export$2aad78c37810bca9($6f291e234003fc86$export$db10bc6ba67ffcb5(t.select(0, t.getChildrenSize())));
}
function $6f291e234003fc86$var$Ve(t, e) {
    void 0 === t.__lexicalClassNameCache && (t.__lexicalClassNameCache = {});
    const n = t.__lexicalClassNameCache, r = n[e];
    if (void 0 !== r) return r;
    const s = t[e];
    if ("string" == typeof s) {
        const t = $6f291e234003fc86$var$Kt(s);
        return n[e] = t, t;
    }
    return s;
}
function $6f291e234003fc86$var$$e(t, e, n, r, s) {
    if (0 === n.size) return;
    const i = r.__type, o = r.__key, l = e.get(i);
    void 0 === l && $6f291e234003fc86$var$Rt(33, i);
    const c = l.klass;
    let a = t.get(c);
    void 0 === a && (a = new Map, t.set(c, a));
    const u = a.get(o), f = "destroyed" === u && "created" === s;
    (void 0 === u || f) && a.set(o, f ? "updated" : s);
}
function $6f291e234003fc86$export$ac6fed8d7d40e66c(t) {
    const e = $6f291e234003fc86$var$Hs(), n = e._readOnly, r = t.getType(), s = e._nodeMap, i = [];
    for (const [, e] of s)e instanceof t && e.__type === r && (n || e.isAttached()) && i.push(e);
    return i;
}
function $6f291e234003fc86$var$je(t, e, n) {
    const r = t.getParent();
    let s = n, i = t;
    return null !== r && (e && 0 === n ? (s = i.getIndexWithinParent(), i = r) : e || n !== i.getChildrenSize() || (s = i.getIndexWithinParent() + 1, i = r)), i.getChildAtIndex(e ? s - 1 : s);
}
function $6f291e234003fc86$export$c4b907be1879d8c1(t, e) {
    const n = t.offset;
    if ("element" === t.type) return $6f291e234003fc86$var$je(t.getNode(), e, n);
    {
        const r = t.getNode();
        if (e && 0 === n || !e && n === r.getTextContentSize()) {
            const t = e ? r.getPreviousSibling() : r.getNextSibling();
            return null === t ? $6f291e234003fc86$var$je(r.getParentOrThrow(), e, r.getIndexWithinParent() + (e ? 0 : 1)) : t;
        }
    }
    return null;
}
function $6f291e234003fc86$var$Qe(t) {
    const e = $6f291e234003fc86$var$rn(t).event, n = e && e.inputType;
    return "insertFromPaste" === n || "insertFromPasteAsQuotation" === n;
}
function $6f291e234003fc86$var$Xe(t, e, n) {
    return $6f291e234003fc86$var$ni(t, e, n);
}
function $6f291e234003fc86$var$Ye(t) {
    return !$6f291e234003fc86$export$5b29ca560c2fedab(t) && !t.isLastChild() && !t.isInline();
}
function $6f291e234003fc86$var$Ze(t, e) {
    const n = t._keyToDOMMap.get(e);
    return void 0 === n && $6f291e234003fc86$var$Rt(75, e), n;
}
function $6f291e234003fc86$var$Ge(t) {
    const e = t.assignedSlot || t.parentElement;
    return null !== e && 11 === e.nodeType ? e.host : e;
}
function $6f291e234003fc86$export$fbcbbb073e480e61(t) {
    return $6f291e234003fc86$var$js()._updateTags.has(t);
}
function $6f291e234003fc86$export$24cab2f466b76c04(t) {
    $6f291e234003fc86$var$Vs();
    $6f291e234003fc86$var$js()._updateTags.add(t);
}
function $6f291e234003fc86$export$e3d4b782f65c81f1(t, e) {
    let n = t.getParent();
    for(; null !== n;){
        if (n.is(e)) return !0;
        n = n.getParent();
    }
    return !1;
}
function $6f291e234003fc86$var$rn(t) {
    const e = t._window;
    return null === e && $6f291e234003fc86$var$Rt(78), e;
}
function $6f291e234003fc86$export$a78813a4e8e8b9dd(t) {
    return $6f291e234003fc86$export$923a058ef54437a4(t) && t.isInline() || $6f291e234003fc86$export$60aa03725ce41b1c(t) && t.isInline();
}
function $6f291e234003fc86$export$6f13c476561e4734(t) {
    let e = t.getParentOrThrow();
    for(; null !== e;){
        if ($6f291e234003fc86$export$6f851a24c61146af(e)) return e;
        e = e.getParentOrThrow();
    }
    return e;
}
function $6f291e234003fc86$export$6f851a24c61146af(t) {
    return $6f291e234003fc86$export$5b29ca560c2fedab(t) || $6f291e234003fc86$export$923a058ef54437a4(t) && t.isShadowRoot();
}
function $6f291e234003fc86$export$def73b17b22438e7(t) {
    const e = t.constructor.clone(t);
    return $6f291e234003fc86$var$ge(e, null), e;
}
function $6f291e234003fc86$export$2f5beb31df92ea57(t) {
    const e = $6f291e234003fc86$var$js(), n = t.constructor.getType(), r = e._nodes.get(n);
    void 0 === r && $6f291e234003fc86$var$Rt(97);
    const s = r.replace;
    if (null !== s) {
        const e = s(t);
        return e instanceof t.constructor || $6f291e234003fc86$var$Rt(98), e;
    }
    return t;
}
function $6f291e234003fc86$var$un(t, e) {
    !$6f291e234003fc86$export$5b29ca560c2fedab(t.getParent()) || $6f291e234003fc86$export$923a058ef54437a4(e) || $6f291e234003fc86$export$60aa03725ce41b1c(e) || $6f291e234003fc86$var$Rt(99);
}
function $6f291e234003fc86$export$b86173decb513938(t) {
    const e = $6f291e234003fc86$export$e725f93d4d48c6d8(t);
    return null === e && $6f291e234003fc86$var$Rt(63, t), e;
}
function $6f291e234003fc86$var$dn(t) {
    return ($6f291e234003fc86$export$60aa03725ce41b1c(t) || $6f291e234003fc86$export$923a058ef54437a4(t) && !t.canBeEmpty()) && !t.isInline();
}
function $6f291e234003fc86$var$hn(t, e, n) {
    n.style.removeProperty("caret-color"), e._blockCursorElement = null;
    const r = t.parentElement;
    null !== r && r.removeChild(t);
}
function $6f291e234003fc86$var$gn(t, e, n) {
    let r = t._blockCursorElement;
    if ($6f291e234003fc86$export$181b63acea8a0224(n) && n.isCollapsed() && "element" === n.anchor.type && e.contains(document.activeElement)) {
        const s = n.anchor, i = s.getNode(), o = s.offset;
        let l = !1, c = null;
        if (o === i.getChildrenSize()) $6f291e234003fc86$var$dn(i.getChildAtIndex(o - 1)) && (l = !0);
        else {
            const e = i.getChildAtIndex(o);
            if ($6f291e234003fc86$var$dn(e)) {
                const n = e.getPreviousSibling();
                (null === n || $6f291e234003fc86$var$dn(n)) && (l = !0, c = t.getElementByKey(e.__key));
            }
        }
        if (l) {
            const n = t.getElementByKey(i.__key);
            return null === r && (t._blockCursorElement = r = function(t) {
                const e = t.theme, n = document.createElement("div");
                n.contentEditable = "false", n.setAttribute("data-lexical-cursor", "true");
                let r = e.blockCursor;
                if (void 0 !== r) {
                    if ("string" == typeof r) {
                        const t = $6f291e234003fc86$var$Kt(r);
                        r = e.blockCursor = t;
                    }
                    void 0 !== r && n.classList.add(...r);
                }
                return n;
            }(t._config)), e.style.caretColor = "transparent", void (null === c ? n.appendChild(r) : n.insertBefore(r, c));
        }
    }
    null !== r && $6f291e234003fc86$var$hn(r, t, e);
}
function $6f291e234003fc86$var$_n(t) {
    return $6f291e234003fc86$var$H ? (t || window).getSelection() : null;
}
function $6f291e234003fc86$export$cc2d53c74c1fb2b2(t, e) {
    let n = t.getChildAtIndex(e);
    null == n && (n = t), $6f291e234003fc86$export$6f851a24c61146af(t) && $6f291e234003fc86$var$Rt(102);
    const r = (t)=>{
        const e = t.getParentOrThrow(), s = $6f291e234003fc86$export$6f851a24c61146af(e), i = t !== n || s ? $6f291e234003fc86$export$def73b17b22438e7(t) : t;
        if (s) return $6f291e234003fc86$export$923a058ef54437a4(t) && $6f291e234003fc86$export$923a058ef54437a4(i) || $6f291e234003fc86$var$Rt(133), t.insertAfter(i), [
            t,
            i,
            i
        ];
        {
            const [n, s, o] = r(e), l = t.getNextSiblings();
            return o.append(i, ...l), [
                n,
                s,
                i
            ];
        }
    }, [s, i] = r(n);
    return [
        s,
        i
    ];
}
function $6f291e234003fc86$export$f5326d78d8d21e1f(t) {
    return $6f291e234003fc86$export$1b3bfaa9684536aa(t) && "A" === t.tagName;
}
function $6f291e234003fc86$export$1b3bfaa9684536aa(t) {
    return 1 === t.nodeType;
}
function $6f291e234003fc86$export$456fd4e5e0a7123d(t) {
    const e = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var|#text)$/, "i");
    return null !== t.nodeName.match(e);
}
function $6f291e234003fc86$export$5ef1a5ca687c7168(t) {
    const e = new RegExp(/^(address|article|aside|blockquote|canvas|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hr|li|main|nav|noscript|ol|p|pre|section|table|td|tfoot|ul|video)$/, "i");
    return null !== t.nodeName.match(e);
}
function $6f291e234003fc86$var$Tn(t) {
    if ($6f291e234003fc86$export$5b29ca560c2fedab(t) || $6f291e234003fc86$export$60aa03725ce41b1c(t) && !t.isInline()) return !0;
    if (!$6f291e234003fc86$export$923a058ef54437a4(t) || $6f291e234003fc86$export$6f851a24c61146af(t)) return !1;
    const e = t.getFirstChild(), n = null === e || $6f291e234003fc86$export$b16330e40aa25c4e(e) || $6f291e234003fc86$export$471953706258be2b(e) || e.isInline();
    return !t.isInline() && !1 !== t.canBeEmpty() && n;
}
function $6f291e234003fc86$var$Cn(t, e) {
    let n = t;
    for(; null !== n && null !== n.getParent() && !e(n);)n = n.getParentOrThrow();
    return e(n) ? n : null;
}
function $6f291e234003fc86$export$8a7392c46faf1a3f() {
    return $6f291e234003fc86$var$js();
}
function $6f291e234003fc86$var$kn(t, e, n, r, s, i) {
    let o = t.getFirstChild();
    for(; null !== o;){
        const t = o.__key;
        o.__parent === e && ($6f291e234003fc86$export$923a058ef54437a4(o) && $6f291e234003fc86$var$kn(o, t, n, r, s, i), n.has(t) || i.delete(t), s.push(t)), o = o.getNextSibling();
    }
}
let $6f291e234003fc86$var$bn, $6f291e234003fc86$var$wn, $6f291e234003fc86$var$Nn, $6f291e234003fc86$var$En, $6f291e234003fc86$var$Pn, $6f291e234003fc86$var$Dn, $6f291e234003fc86$var$Fn, $6f291e234003fc86$var$On, $6f291e234003fc86$var$In, $6f291e234003fc86$var$Ln, $6f291e234003fc86$var$An = "", $6f291e234003fc86$var$Mn = "", $6f291e234003fc86$var$zn = null, $6f291e234003fc86$var$Wn = "", $6f291e234003fc86$var$Bn = !1, $6f291e234003fc86$var$Rn = !1, $6f291e234003fc86$var$Kn = null;
function $6f291e234003fc86$var$Jn(t, e) {
    const n = $6f291e234003fc86$var$Fn.get(t);
    if (null !== e) {
        const n = $6f291e234003fc86$var$ir(t);
        n.parentNode === e && e.removeChild(n);
    }
    if ($6f291e234003fc86$var$On.has(t) || $6f291e234003fc86$var$wn._keyToDOMMap.delete(t), $6f291e234003fc86$export$923a058ef54437a4(n)) {
        const t = $6f291e234003fc86$var$tr(n, $6f291e234003fc86$var$Fn);
        $6f291e234003fc86$var$Un(t, 0, t.length - 1, null);
    }
    void 0 !== n && $6f291e234003fc86$var$$e($6f291e234003fc86$var$Ln, $6f291e234003fc86$var$Nn, $6f291e234003fc86$var$En, n, "destroyed");
}
function $6f291e234003fc86$var$Un(t, e, n, r) {
    let s = e;
    for(; s <= n; ++s){
        const e = t[s];
        void 0 !== e && $6f291e234003fc86$var$Jn(e, r);
    }
}
function $6f291e234003fc86$var$Vn(t, e) {
    t.setProperty("text-align", e);
}
const $6f291e234003fc86$var$$n = "40px";
function $6f291e234003fc86$var$Hn(t, e) {
    const n = $6f291e234003fc86$var$bn.theme.indent;
    if ("string" == typeof n) {
        const r = t.classList.contains(n);
        e > 0 && !r ? t.classList.add(n) : e < 1 && r && t.classList.remove(n);
    }
    const r = getComputedStyle(t).getPropertyValue("--lexical-indent-base-value") || $6f291e234003fc86$var$$n;
    t.style.setProperty("padding-inline-start", 0 === e ? "" : `calc(${e} * ${r})`);
}
function $6f291e234003fc86$var$jn(t, e) {
    const n = t.style;
    0 === e ? $6f291e234003fc86$var$Vn(n, "") : e === $6f291e234003fc86$var$vt ? $6f291e234003fc86$var$Vn(n, "left") : e === $6f291e234003fc86$var$Tt ? $6f291e234003fc86$var$Vn(n, "center") : e === $6f291e234003fc86$var$Ct ? $6f291e234003fc86$var$Vn(n, "right") : e === $6f291e234003fc86$var$St ? $6f291e234003fc86$var$Vn(n, "justify") : e === $6f291e234003fc86$var$kt ? $6f291e234003fc86$var$Vn(n, "start") : e === $6f291e234003fc86$var$bt && $6f291e234003fc86$var$Vn(n, "end");
}
function $6f291e234003fc86$var$qn(t, e, n) {
    const r = $6f291e234003fc86$var$On.get(t);
    void 0 === r && $6f291e234003fc86$var$Rt(60);
    const s = r.createDOM($6f291e234003fc86$var$bn, $6f291e234003fc86$var$wn);
    if (function(t, e, n) {
        const r = n._keyToDOMMap;
        e["__lexicalKey_" + n._key] = t, r.set(t, e);
    }(t, s, $6f291e234003fc86$var$wn), $6f291e234003fc86$export$471953706258be2b(r) ? s.setAttribute("data-lexical-text", "true") : $6f291e234003fc86$export$60aa03725ce41b1c(r) && s.setAttribute("data-lexical-decorator", "true"), $6f291e234003fc86$export$923a058ef54437a4(r)) {
        const t = r.__indent, e = r.__size;
        if (0 !== t && $6f291e234003fc86$var$Hn(s, t), 0 !== e) {
            const t = e - 1;
            !function(t, e, n, r) {
                const s = $6f291e234003fc86$var$Mn;
                $6f291e234003fc86$var$Mn = "", $6f291e234003fc86$var$Qn(t, n, 0, e, r, null), $6f291e234003fc86$var$Zn(n, r), $6f291e234003fc86$var$Mn = s;
            }($6f291e234003fc86$var$tr(r, $6f291e234003fc86$var$On), t, r, s);
        }
        const n = r.__format;
        0 !== n && $6f291e234003fc86$var$jn(s, n), r.isInline() || $6f291e234003fc86$var$Yn(null, r, s), $6f291e234003fc86$var$Ye(r) && ($6f291e234003fc86$var$An += $6f291e234003fc86$var$Nt, $6f291e234003fc86$var$Wn += $6f291e234003fc86$var$Nt);
    } else {
        const e = r.getTextContent();
        if ($6f291e234003fc86$export$60aa03725ce41b1c(r)) {
            const e = r.decorate($6f291e234003fc86$var$wn, $6f291e234003fc86$var$bn);
            null !== e && $6f291e234003fc86$var$nr(t, e), s.contentEditable = "false";
        } else $6f291e234003fc86$export$471953706258be2b(r) && (r.isDirectionless() || ($6f291e234003fc86$var$Mn += e));
        $6f291e234003fc86$var$An += e, $6f291e234003fc86$var$Wn += e;
    }
    if (null !== e) {
        if (null != n) e.insertBefore(s, n);
        else {
            const t = e.__lexicalLineBreak;
            null != t ? e.insertBefore(s, t) : e.appendChild(s);
        }
    }
    return $6f291e234003fc86$var$$e($6f291e234003fc86$var$Ln, $6f291e234003fc86$var$Nn, $6f291e234003fc86$var$En, r, "created"), s;
}
function $6f291e234003fc86$var$Qn(t, e, n, r, s, i) {
    const o = $6f291e234003fc86$var$An;
    $6f291e234003fc86$var$An = "";
    let l = n;
    for(; l <= r; ++l){
        $6f291e234003fc86$var$qn(t[l], s, i);
        const e = $6f291e234003fc86$var$On.get(t[l]);
        null !== e && null === $6f291e234003fc86$var$zn && $6f291e234003fc86$export$471953706258be2b(e) && ($6f291e234003fc86$var$zn = e.getFormat());
    }
    $6f291e234003fc86$var$Ye(e) && ($6f291e234003fc86$var$An += $6f291e234003fc86$var$Nt), s.__lexicalTextContent = $6f291e234003fc86$var$An, $6f291e234003fc86$var$An = o + $6f291e234003fc86$var$An;
}
function $6f291e234003fc86$var$Xn(t, e) {
    const n = e.get(t);
    return $6f291e234003fc86$export$b16330e40aa25c4e(n) || $6f291e234003fc86$export$60aa03725ce41b1c(n) && n.isInline();
}
function $6f291e234003fc86$var$Yn(t, e, n) {
    const r = null !== t && (0 === t.__size || $6f291e234003fc86$var$Xn(t.__last, $6f291e234003fc86$var$Fn)), s = 0 === e.__size || $6f291e234003fc86$var$Xn(e.__last, $6f291e234003fc86$var$On);
    if (r) {
        if (!s) {
            const t = n.__lexicalLineBreak;
            null != t && n.removeChild(t), n.__lexicalLineBreak = null;
        }
    } else if (s) {
        const t = document.createElement("br");
        n.__lexicalLineBreak = t, n.appendChild(t);
    }
}
function $6f291e234003fc86$var$Zn(t, e) {
    const n = e.__lexicalDirTextContent, r = e.__lexicalDir;
    if (n !== $6f291e234003fc86$var$Mn || r !== $6f291e234003fc86$var$Kn) {
        const n = "" === $6f291e234003fc86$var$Mn, i = n ? $6f291e234003fc86$var$Kn : (s = $6f291e234003fc86$var$Mn, $6f291e234003fc86$var$Ft.test(s) ? "rtl" : $6f291e234003fc86$var$Ot.test(s) ? "ltr" : null);
        if (i !== r) {
            const s = e.classList, o = $6f291e234003fc86$var$bn.theme;
            let l = null !== r ? o[r] : void 0, c = null !== i ? o[i] : void 0;
            if (void 0 !== l) {
                if ("string" == typeof l) {
                    const t = $6f291e234003fc86$var$Kt(l);
                    l = o[r] = t;
                }
                s.remove(...l);
            }
            if (null === i || n && "ltr" === i) e.removeAttribute("dir");
            else {
                if (void 0 !== c) {
                    if ("string" == typeof c) {
                        const t = $6f291e234003fc86$var$Kt(c);
                        c = o[i] = t;
                    }
                    void 0 !== c && s.add(...c);
                }
                e.dir = i;
            }
            if (!$6f291e234003fc86$var$Rn) t.getWritable().__dir = i;
        }
        $6f291e234003fc86$var$Kn = i, e.__lexicalDirTextContent = $6f291e234003fc86$var$Mn, e.__lexicalDir = i;
    }
    var s;
}
function $6f291e234003fc86$var$Gn(t, e, n) {
    const r = $6f291e234003fc86$var$Mn;
    var s;
    $6f291e234003fc86$var$Mn = "", $6f291e234003fc86$var$zn = null, function(t, e, n) {
        const r = $6f291e234003fc86$var$An, s = t.__size, i = e.__size;
        if ($6f291e234003fc86$var$An = "", 1 === s && 1 === i) {
            const r = t.__first, s = e.__first;
            if (r === s) $6f291e234003fc86$var$er(r, n);
            else {
                const t = $6f291e234003fc86$var$ir(r), e = $6f291e234003fc86$var$qn(s, null, null);
                n.replaceChild(e, t), $6f291e234003fc86$var$Jn(r, null);
            }
            const i = $6f291e234003fc86$var$On.get(s);
            null === $6f291e234003fc86$var$zn && $6f291e234003fc86$export$471953706258be2b(i) && ($6f291e234003fc86$var$zn = i.getFormat());
        } else {
            const r = $6f291e234003fc86$var$tr(t, $6f291e234003fc86$var$Fn), o = $6f291e234003fc86$var$tr(e, $6f291e234003fc86$var$On);
            if (0 === s) 0 !== i && $6f291e234003fc86$var$Qn(o, e, 0, i - 1, n, null);
            else if (0 === i) {
                if (0 !== s) {
                    const t = null == n.__lexicalLineBreak;
                    $6f291e234003fc86$var$Un(r, 0, s - 1, t ? null : n), t && (n.textContent = "");
                }
            } else !function(t, e, n, r, s, i) {
                const o = r - 1, l = s - 1;
                let c, a, u = (h = i, h.firstChild), f = 0, d = 0;
                var h;
                for(; f <= o && d <= l;){
                    const t = e[f], r = n[d];
                    if (t === r) u = $6f291e234003fc86$var$rr($6f291e234003fc86$var$er(r, i)), f++, d++;
                    else {
                        void 0 === c && (c = new Set(e)), void 0 === a && (a = new Set(n));
                        const s = a.has(t), o = c.has(r);
                        if (s) {
                            if (o) {
                                const t = $6f291e234003fc86$var$Ze($6f291e234003fc86$var$wn, r);
                                t === u ? u = $6f291e234003fc86$var$rr($6f291e234003fc86$var$er(r, i)) : (null != u ? i.insertBefore(t, u) : i.appendChild(t), $6f291e234003fc86$var$er(r, i)), f++, d++;
                            } else $6f291e234003fc86$var$qn(r, i, u), d++;
                        } else u = $6f291e234003fc86$var$rr($6f291e234003fc86$var$ir(t)), $6f291e234003fc86$var$Jn(t, i), f++;
                    }
                    const s = $6f291e234003fc86$var$On.get(r);
                    null !== s && null === $6f291e234003fc86$var$zn && $6f291e234003fc86$export$471953706258be2b(s) && ($6f291e234003fc86$var$zn = s.getFormat());
                }
                const g = f > o, _ = d > l;
                if (g && !_) {
                    const e = n[l + 1];
                    $6f291e234003fc86$var$Qn(n, t, d, l, i, void 0 === e ? null : $6f291e234003fc86$var$wn.getElementByKey(e));
                } else _ && !g && $6f291e234003fc86$var$Un(e, f, o, i);
            }(e, r, o, s, i, n);
        }
        $6f291e234003fc86$var$Ye(e) && ($6f291e234003fc86$var$An += $6f291e234003fc86$var$Nt);
        n.__lexicalTextContent = $6f291e234003fc86$var$An, $6f291e234003fc86$var$An = r + $6f291e234003fc86$var$An;
    }(t, e, n), $6f291e234003fc86$var$Zn(e, n), $6f291e234003fc86$export$1fdda795300c79c6(s = e) && null != $6f291e234003fc86$var$zn && $6f291e234003fc86$var$zn !== s.__textFormat && !$6f291e234003fc86$var$Rn && s.setTextFormat($6f291e234003fc86$var$zn), $6f291e234003fc86$var$Mn = r, $6f291e234003fc86$var$zn = null;
}
function $6f291e234003fc86$var$tr(t, e) {
    const n = [];
    let r = t.__first;
    for(; null !== r;){
        const t = e.get(r);
        void 0 === t && $6f291e234003fc86$var$Rt(101), n.push(r), r = t.__next;
    }
    return n;
}
function $6f291e234003fc86$var$er(t, e) {
    const n = $6f291e234003fc86$var$Fn.get(t);
    let r = $6f291e234003fc86$var$On.get(t);
    void 0 !== n && void 0 !== r || $6f291e234003fc86$var$Rt(61);
    const s = $6f291e234003fc86$var$Bn || $6f291e234003fc86$var$Dn.has(t) || $6f291e234003fc86$var$Pn.has(t), i = $6f291e234003fc86$var$Ze($6f291e234003fc86$var$wn, t);
    if (n === r && !s) {
        if ($6f291e234003fc86$export$923a058ef54437a4(n)) {
            const t = i.__lexicalTextContent;
            void 0 !== t && ($6f291e234003fc86$var$An += t, $6f291e234003fc86$var$Wn += t);
            const e = i.__lexicalDirTextContent;
            void 0 !== e && ($6f291e234003fc86$var$Mn += e);
        } else {
            const t = n.getTextContent();
            $6f291e234003fc86$export$471953706258be2b(n) && !n.isDirectionless() && ($6f291e234003fc86$var$Mn += t), $6f291e234003fc86$var$Wn += t, $6f291e234003fc86$var$An += t;
        }
        return i;
    }
    if (n !== r && s && $6f291e234003fc86$var$$e($6f291e234003fc86$var$Ln, $6f291e234003fc86$var$Nn, $6f291e234003fc86$var$En, r, "updated"), r.updateDOM(n, i, $6f291e234003fc86$var$bn)) {
        const n = $6f291e234003fc86$var$qn(t, null, null);
        return null === e && $6f291e234003fc86$var$Rt(62), e.replaceChild(n, i), $6f291e234003fc86$var$Jn(t, null), n;
    }
    if ($6f291e234003fc86$export$923a058ef54437a4(n) && $6f291e234003fc86$export$923a058ef54437a4(r)) {
        const t = r.__indent;
        t !== n.__indent && $6f291e234003fc86$var$Hn(i, t);
        const e = r.__format;
        e !== n.__format && $6f291e234003fc86$var$jn(i, e), s && ($6f291e234003fc86$var$Gn(n, r, i), $6f291e234003fc86$export$5b29ca560c2fedab(r) || r.isInline() || $6f291e234003fc86$var$Yn(n, r, i)), $6f291e234003fc86$var$Ye(r) && ($6f291e234003fc86$var$An += $6f291e234003fc86$var$Nt, $6f291e234003fc86$var$Wn += $6f291e234003fc86$var$Nt);
    } else {
        const e = r.getTextContent();
        if ($6f291e234003fc86$export$60aa03725ce41b1c(r)) {
            const e = r.decorate($6f291e234003fc86$var$wn, $6f291e234003fc86$var$bn);
            null !== e && $6f291e234003fc86$var$nr(t, e);
        } else $6f291e234003fc86$export$471953706258be2b(r) && !r.isDirectionless() && ($6f291e234003fc86$var$Mn += e);
        $6f291e234003fc86$var$An += e, $6f291e234003fc86$var$Wn += e;
    }
    if (!$6f291e234003fc86$var$Rn && $6f291e234003fc86$export$5b29ca560c2fedab(r) && r.__cachedText !== $6f291e234003fc86$var$Wn) {
        const t = r.getWritable();
        t.__cachedText = $6f291e234003fc86$var$Wn, r = t;
    }
    return i;
}
function $6f291e234003fc86$var$nr(t, e) {
    let n = $6f291e234003fc86$var$wn._pendingDecorators;
    const r = $6f291e234003fc86$var$wn._decorators;
    if (null === n) {
        if (r[t] === e) return;
        n = $6f291e234003fc86$var$Ce($6f291e234003fc86$var$wn);
    }
    n[t] = e;
}
function $6f291e234003fc86$var$rr(t) {
    let e = t.nextSibling;
    return null !== e && e === $6f291e234003fc86$var$wn._blockCursorElement && (e = e.nextSibling), e;
}
function $6f291e234003fc86$var$sr(t, e, n, r, s, i) {
    $6f291e234003fc86$var$An = "", $6f291e234003fc86$var$Wn = "", $6f291e234003fc86$var$Mn = "", $6f291e234003fc86$var$Bn = r === $6f291e234003fc86$var$lt, $6f291e234003fc86$var$Kn = null, $6f291e234003fc86$var$wn = n, $6f291e234003fc86$var$bn = n._config, $6f291e234003fc86$var$Nn = n._nodes, $6f291e234003fc86$var$En = $6f291e234003fc86$var$wn._listeners.mutation, $6f291e234003fc86$var$Pn = s, $6f291e234003fc86$var$Dn = i, $6f291e234003fc86$var$Fn = t._nodeMap, $6f291e234003fc86$var$On = e._nodeMap, $6f291e234003fc86$var$Rn = e._readOnly, $6f291e234003fc86$var$In = new Map(n._keyToDOMMap);
    const o = new Map;
    return $6f291e234003fc86$var$Ln = o, $6f291e234003fc86$var$er("root", null), $6f291e234003fc86$var$wn = void 0, $6f291e234003fc86$var$Nn = void 0, $6f291e234003fc86$var$Pn = void 0, $6f291e234003fc86$var$Dn = void 0, $6f291e234003fc86$var$Fn = void 0, $6f291e234003fc86$var$On = void 0, $6f291e234003fc86$var$bn = void 0, $6f291e234003fc86$var$In = void 0, $6f291e234003fc86$var$Ln = void 0, o;
}
function $6f291e234003fc86$var$ir(t) {
    const e = $6f291e234003fc86$var$In.get(t);
    return void 0 === e && $6f291e234003fc86$var$Rt(75, t), e;
}
const $6f291e234003fc86$var$or = Object.freeze({}), $6f291e234003fc86$var$lr = 30, $6f291e234003fc86$var$cr = [
    [
        "keydown",
        function(t, e) {
            if ($6f291e234003fc86$var$ar = t.timeStamp, $6f291e234003fc86$var$ur = t.key, e.isComposing()) return;
            const { key: n, shiftKey: r, ctrlKey: o, metaKey: l, altKey: c } = t;
            if ($6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$61973214e0e18936, t)) return;
            if (null == n) return;
            if (function(t, e, n, r) {
                return $6f291e234003fc86$var$ze(t) && !e && !r && !n;
            }(n, o, c, l)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$217ec2281ac1c53b, t);
            else if (function(t, e, n, r, s) {
                return $6f291e234003fc86$var$ze(t) && !r && !n && (e || s);
            }(n, o, r, c, l)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$fb3b2d438650aff6, t);
            else if (function(t, e, n, r) {
                return $6f291e234003fc86$var$Me(t) && !e && !r && !n;
            }(n, o, c, l)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$7525f8f8ab44508, t);
            else if (function(t, e, n, r, s) {
                return $6f291e234003fc86$var$Me(t) && !r && !n && (e || s);
            }(n, o, r, c, l)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$dc117ee4d661295a, t);
            else if (function(t, e, n) {
                return function(t) {
                    return "ArrowUp" === t;
                }(t) && !e && !n;
            }(n, o, l)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$7833c2a33ae81d3d, t);
            else if (function(t, e, n) {
                return function(t) {
                    return "ArrowDown" === t;
                }(t) && !e && !n;
            }(n, o, l)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$baa60daa2ca402b3, t);
            else if (function(t, e) {
                return $6f291e234003fc86$var$Be(t) && e;
            }(n, r)) $6f291e234003fc86$var$pr = !0, $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$2cdb7cdd6fccb293, t);
            else if (function(t) {
                return " " === t;
            }(n)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$d0bc2bb647ce4c17, t);
            else if (function(t, e) {
                return $6f291e234003fc86$var$q && e && "o" === t.toLowerCase();
            }(n, o)) t.preventDefault(), $6f291e234003fc86$var$pr = !0, $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$64e35ce26e025724, !0);
            else if (function(t, e) {
                return $6f291e234003fc86$var$Be(t) && !e;
            }(n, r)) $6f291e234003fc86$var$pr = !1, $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$2cdb7cdd6fccb293, t);
            else if (function(t, e, n, r) {
                return $6f291e234003fc86$var$q ? !e && !n && ($6f291e234003fc86$var$Re(t) || "h" === t.toLowerCase() && r) : !(r || e || n) && $6f291e234003fc86$var$Re(t);
            }(n, c, l, o)) $6f291e234003fc86$var$Re(n) ? $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$24bbba9bfa830f78, t) : (t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$35595bf6d7e36fd5, !0));
            else if (function(t) {
                return "Escape" === t;
            }(n)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$53589e422a755d59, t);
            else if (function(t, e, n, r, s) {
                return $6f291e234003fc86$var$q ? !(n || r || s) && ($6f291e234003fc86$var$Ke(t) || "d" === t.toLowerCase() && e) : !(e || r || s) && $6f291e234003fc86$var$Ke(t);
            }(n, o, r, c, l)) $6f291e234003fc86$var$Ke(n) ? $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$13a0e72b5c0146bb, t) : (t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$35595bf6d7e36fd5, !1));
            else if (function(t, e, n) {
                return $6f291e234003fc86$var$Re(t) && ($6f291e234003fc86$var$q ? e : n);
            }(n, c, o)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$8e315b175631384c, !0);
            else if (function(t, e, n) {
                return $6f291e234003fc86$var$Ke(t) && ($6f291e234003fc86$var$q ? e : n);
            }(n, c, o)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$8e315b175631384c, !1);
            else if (function(t, e) {
                return $6f291e234003fc86$var$q && e && $6f291e234003fc86$var$Re(t);
            }(n, l)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$d77fad8fb8747fd, !0);
            else if (function(t, e) {
                return $6f291e234003fc86$var$q && e && $6f291e234003fc86$var$Ke(t);
            }(n, l)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$d77fad8fb8747fd, !1);
            else if (function(t, e, n, r) {
                return "b" === t.toLowerCase() && !e && $6f291e234003fc86$var$We(n, r);
            }(n, c, l, o)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$85443a1a9543f043, "bold");
            else if (function(t, e, n, r) {
                return "u" === t.toLowerCase() && !e && $6f291e234003fc86$var$We(n, r);
            }(n, c, l, o)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$85443a1a9543f043, "underline");
            else if (function(t, e, n, r) {
                return "i" === t.toLowerCase() && !e && $6f291e234003fc86$var$We(n, r);
            }(n, c, l, o)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$85443a1a9543f043, "italic");
            else if (function(t, e, n, r) {
                return "Tab" === t && !e && !n && !r;
            }(n, c, o, l)) $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$b321bdc226ccdcde, t);
            else if (function(t, e, n, r) {
                return "z" === t.toLowerCase() && !e && $6f291e234003fc86$var$We(n, r);
            }(n, r, l, o)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$34722a4946cb641e, void 0);
            else if (function(t, e, n, r) {
                return $6f291e234003fc86$var$q ? "z" === t.toLowerCase() && n && e : "y" === t.toLowerCase() && r || "z" === t.toLowerCase() && r && e;
            }(n, r, l, o)) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$8c4a0748d31d9941, void 0);
            else $6f291e234003fc86$export$7257e4181651a7c3(e._editorState._selection) ? !function(t, e, n, r) {
                return !e && "c" === t.toLowerCase() && ($6f291e234003fc86$var$q ? n : r);
            }(n, r, l, o) ? !function(t, e, n, r) {
                return !e && "x" === t.toLowerCase() && ($6f291e234003fc86$var$q ? n : r);
            }(n, r, l, o) ? $6f291e234003fc86$var$Je(n, l, o) && (t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$185c218616045e75, t)) : (t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$4dc8a35a083beec4, t)) : (t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$3435fcfb1f59ef96, t)) : !$6f291e234003fc86$var$Q && $6f291e234003fc86$var$Je(n, l, o) && (t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$185c218616045e75, t));
            (function(t, e, n, r) {
                return t || e || n || r;
            })(o, r, c, l) && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$452548a3c1874d61, t);
        }
    ],
    [
        "pointerdown",
        function(t, e) {
            const n = t.target, r = t.pointerType;
            n instanceof Node && "touch" !== r && $6f291e234003fc86$var$ii(e, ()=>{
                $6f291e234003fc86$export$60aa03725ce41b1c($6f291e234003fc86$export$fef265f0d2fcffdd(n)) || ($6f291e234003fc86$var$_r = !0);
            });
        }
    ],
    [
        "compositionstart",
        function(t, e) {
            $6f291e234003fc86$var$ii(e, ()=>{
                const n = $6f291e234003fc86$export$63a3201b3a5c7d90();
                if ($6f291e234003fc86$export$181b63acea8a0224(n) && !e.isComposing()) {
                    const r = n.anchor, s = n.anchor.getNode();
                    $6f291e234003fc86$export$ea25f5ef71f2d042(r.key), (t.timeStamp < $6f291e234003fc86$var$ar + $6f291e234003fc86$var$lr || "element" === r.type || !n.isCollapsed() || s.getFormat() !== n.format || $6f291e234003fc86$export$471953706258be2b(s) && s.getStyle() !== n.style) && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$6f67c758bb657857, $6f291e234003fc86$var$Et);
                }
            });
        }
    ],
    [
        "compositionend",
        function(t, e) {
            $6f291e234003fc86$var$Q ? $6f291e234003fc86$var$yr = !0 : $6f291e234003fc86$var$ii(e, ()=>{
                $6f291e234003fc86$var$Sr(e, t.data);
            });
        }
    ],
    [
        "input",
        function(t, e) {
            t.stopPropagation(), $6f291e234003fc86$var$ii(e, ()=>{
                const n = $6f291e234003fc86$export$63a3201b3a5c7d90(), r = t.data, s = $6f291e234003fc86$var$Cr(t);
                if (null != r && $6f291e234003fc86$export$181b63acea8a0224(n) && $6f291e234003fc86$var$xr(n, s, r, t.timeStamp, !1)) {
                    $6f291e234003fc86$var$yr && ($6f291e234003fc86$var$Sr(e, r), $6f291e234003fc86$var$yr = !1);
                    const s = n.anchor.getNode(), i = $6f291e234003fc86$var$_n(e._window);
                    if (null === i) return;
                    const o = n.isBackward(), c = o ? n.anchor.offset : n.focus.offset, a = o ? n.focus.offset : n.anchor.offset;
                    $6f291e234003fc86$var$X && !n.isCollapsed() && $6f291e234003fc86$export$471953706258be2b(s) && null !== i.anchorNode && s.getTextContent().slice(0, c) + r + s.getTextContent().slice(c + a) === $6f291e234003fc86$var$Oe(i.anchorNode) || $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$6f67c758bb657857, r);
                    const u = r.length;
                    $6f291e234003fc86$var$Q && u > 1 && "insertCompositionText" === t.inputType && !e.isComposing() && (n.anchor.offset -= u), $6f291e234003fc86$var$Y || $6f291e234003fc86$var$Z || $6f291e234003fc86$var$nt || !e.isComposing() || ($6f291e234003fc86$var$ar = 0, $6f291e234003fc86$export$ea25f5ef71f2d042(null));
                } else $6f291e234003fc86$var$Ie(!1, e, null !== r ? r : void 0), $6f291e234003fc86$var$yr && ($6f291e234003fc86$var$Sr(e, r || void 0), $6f291e234003fc86$var$yr = !1);
                $6f291e234003fc86$var$Vs(), $6f291e234003fc86$var$Xt($6f291e234003fc86$var$js());
            }), $6f291e234003fc86$var$dr = null;
        }
    ],
    [
        "click",
        function(t, e) {
            $6f291e234003fc86$var$ii(e, ()=>{
                const n = $6f291e234003fc86$export$63a3201b3a5c7d90(), s = $6f291e234003fc86$var$_n(e._window), i = $6f291e234003fc86$export$846e9407a8b5d98c();
                if (s) {
                    if ($6f291e234003fc86$export$181b63acea8a0224(n)) {
                        const e = n.anchor, r = e.getNode();
                        if ("element" === e.type && 0 === e.offset && n.isCollapsed() && !$6f291e234003fc86$export$5b29ca560c2fedab(r) && 1 === $6f291e234003fc86$export$8d83ea843c4eea9a().getChildrenSize() && r.getTopLevelElementOrThrow().isEmpty() && null !== i && n.is(i)) s.removeAllRanges(), n.dirty = !0;
                        else if (3 === t.detail && !n.isCollapsed()) r !== n.focus.getNode() && ($6f291e234003fc86$export$923a058ef54437a4(r) ? r.select(0) : r.getParentOrThrow().select(0));
                    } else if ("touch" === t.pointerType) {
                        const n = s.anchorNode;
                        if (null !== n) {
                            const r = n.nodeType;
                            if (r === $6f291e234003fc86$var$rt || r === $6f291e234003fc86$var$st) $6f291e234003fc86$export$2aad78c37810bca9($6f291e234003fc86$var$bs(i, s, e, t));
                        }
                    }
                }
                $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$c1a2de6c823e5f82, t);
            });
        }
    ],
    [
        "cut",
        $6f291e234003fc86$var$or
    ],
    [
        "copy",
        $6f291e234003fc86$var$or
    ],
    [
        "dragstart",
        $6f291e234003fc86$var$or
    ],
    [
        "dragover",
        $6f291e234003fc86$var$or
    ],
    [
        "dragend",
        $6f291e234003fc86$var$or
    ],
    [
        "paste",
        $6f291e234003fc86$var$or
    ],
    [
        "focus",
        $6f291e234003fc86$var$or
    ],
    [
        "blur",
        $6f291e234003fc86$var$or
    ],
    [
        "drop",
        $6f291e234003fc86$var$or
    ]
];
$6f291e234003fc86$var$X && $6f291e234003fc86$var$cr.push([
    "beforeinput",
    (t, e)=>(function(t, e) {
            const n = t.inputType, r = $6f291e234003fc86$var$Cr(t);
            if ("deleteCompositionText" === n || $6f291e234003fc86$var$Q && $6f291e234003fc86$var$Qe(e)) return;
            if ("insertCompositionText" === n) return;
            $6f291e234003fc86$var$ii(e, ()=>{
                const _ = $6f291e234003fc86$export$63a3201b3a5c7d90();
                if ("deleteContentBackward" === n) {
                    if (null === _) {
                        const t = $6f291e234003fc86$export$846e9407a8b5d98c();
                        if (!$6f291e234003fc86$export$181b63acea8a0224(t)) return;
                        $6f291e234003fc86$export$2aad78c37810bca9(t.clone());
                    }
                    if ($6f291e234003fc86$export$181b63acea8a0224(_)) {
                        const n = _.anchor.key === _.focus.key;
                        if (p = t.timeStamp, "MediaLast" === $6f291e234003fc86$var$ur && p < $6f291e234003fc86$var$ar + $6f291e234003fc86$var$lr && e.isComposing() && n) {
                            if ($6f291e234003fc86$export$ea25f5ef71f2d042(null), $6f291e234003fc86$var$ar = 0, setTimeout(()=>{
                                $6f291e234003fc86$var$ii(e, ()=>{
                                    $6f291e234003fc86$export$ea25f5ef71f2d042(null);
                                });
                            }, $6f291e234003fc86$var$lr), $6f291e234003fc86$export$181b63acea8a0224(_)) {
                                const t = _.anchor.getNode();
                                t.markDirty(), _.format = t.getFormat(), $6f291e234003fc86$export$471953706258be2b(t) || $6f291e234003fc86$var$Rt(142), _.style = t.getStyle();
                            }
                        } else {
                            $6f291e234003fc86$export$ea25f5ef71f2d042(null), t.preventDefault();
                            const r = _.anchor.getNode().getTextContent(), i = 0 === _.anchor.offset && _.focus.offset === r.length;
                            $6f291e234003fc86$var$et && n && !i || $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$35595bf6d7e36fd5, !0);
                        }
                        return;
                    }
                }
                var p;
                if (!$6f291e234003fc86$export$181b63acea8a0224(_)) return;
                const y = t.data;
                null !== $6f291e234003fc86$var$dr && $6f291e234003fc86$var$Ie(!1, e, $6f291e234003fc86$var$dr), _.dirty && null === $6f291e234003fc86$var$dr || !_.isCollapsed() || $6f291e234003fc86$export$5b29ca560c2fedab(_.anchor.getNode()) || null === r || _.applyDOMRange(r), $6f291e234003fc86$var$dr = null;
                const m = _.anchor, x = _.focus, v = m.getNode(), T = x.getNode();
                if ("insertText" !== n && "insertTranspose" !== n) switch(t.preventDefault(), n){
                    case "insertFromYank":
                    case "insertFromDrop":
                    case "insertReplacementText":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$6f67c758bb657857, t);
                        break;
                    case "insertFromComposition":
                        $6f291e234003fc86$export$ea25f5ef71f2d042(null), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$6f67c758bb657857, t);
                        break;
                    case "insertLineBreak":
                        $6f291e234003fc86$export$ea25f5ef71f2d042(null), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$64e35ce26e025724, !1);
                        break;
                    case "insertParagraph":
                        $6f291e234003fc86$export$ea25f5ef71f2d042(null), $6f291e234003fc86$var$pr && !$6f291e234003fc86$var$Z ? ($6f291e234003fc86$var$pr = !1, $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$64e35ce26e025724, !1)) : $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$24f4fea65b096b4, void 0);
                        break;
                    case "insertFromPaste":
                    case "insertFromPasteAsQuotation":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$7fb70c61b3bcc883, t);
                        break;
                    case "deleteByComposition":
                        (function(t, e) {
                            return t !== e || $6f291e234003fc86$export$923a058ef54437a4(t) || $6f291e234003fc86$export$923a058ef54437a4(e) || !t.isToken() || !e.isToken();
                        })(v, T) && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$9cc285f2a3ff220c, t);
                        break;
                    case "deleteByDrag":
                    case "deleteByCut":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$9cc285f2a3ff220c, t);
                        break;
                    case "deleteContent":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$35595bf6d7e36fd5, !1);
                        break;
                    case "deleteWordBackward":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$8e315b175631384c, !0);
                        break;
                    case "deleteWordForward":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$8e315b175631384c, !1);
                        break;
                    case "deleteHardLineBackward":
                    case "deleteSoftLineBackward":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$d77fad8fb8747fd, !0);
                        break;
                    case "deleteContentForward":
                    case "deleteHardLineForward":
                    case "deleteSoftLineForward":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$d77fad8fb8747fd, !1);
                        break;
                    case "formatStrikeThrough":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$85443a1a9543f043, "strikethrough");
                        break;
                    case "formatBold":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$85443a1a9543f043, "bold");
                        break;
                    case "formatItalic":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$85443a1a9543f043, "italic");
                        break;
                    case "formatUnderline":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$85443a1a9543f043, "underline");
                        break;
                    case "historyUndo":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$34722a4946cb641e, void 0);
                        break;
                    case "historyRedo":
                        $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$8c4a0748d31d9941, void 0);
                }
                else {
                    if ("\n" === y) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$64e35ce26e025724, !1);
                    else if (y === $6f291e234003fc86$var$Nt) t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$24f4fea65b096b4, void 0);
                    else if (null == y && t.dataTransfer) {
                        const e = t.dataTransfer.getData("text/plain");
                        t.preventDefault(), _.insertRawText(e);
                    } else null != y && $6f291e234003fc86$var$xr(_, r, y, t.timeStamp, !0) ? (t.preventDefault(), $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$6f67c758bb657857, y)) : $6f291e234003fc86$var$dr = y;
                    $6f291e234003fc86$var$fr = t.timeStamp;
                }
            });
        })(t, e)
]);
let $6f291e234003fc86$var$ar = 0, $6f291e234003fc86$var$ur = null, $6f291e234003fc86$var$fr = 0, $6f291e234003fc86$var$dr = null;
const $6f291e234003fc86$var$hr = new WeakMap;
let $6f291e234003fc86$var$gr = !1, $6f291e234003fc86$var$_r = !1, $6f291e234003fc86$var$pr = !1, $6f291e234003fc86$var$yr = !1, $6f291e234003fc86$var$mr = [
    0,
    "",
    0,
    "root",
    0
];
function $6f291e234003fc86$var$xr(t, e, n, r, s) {
    const i = t.anchor, o = t.focus, l = i.getNode(), c = $6f291e234003fc86$var$js(), a = $6f291e234003fc86$var$_n(c._window), u = null !== a ? a.anchorNode : null, f = i.key, d = c.getElementByKey(f), h = n.length;
    return f !== o.key || !$6f291e234003fc86$export$471953706258be2b(l) || (!s && (!$6f291e234003fc86$var$X || $6f291e234003fc86$var$fr < r + 50) || l.isDirty() && h < 2 || $6f291e234003fc86$var$Pe(n)) && i.offset !== o.offset && !l.isComposing() || $6f291e234003fc86$var$ae(l) || l.isDirty() && h > 1 || (s || !$6f291e234003fc86$var$X) && null !== d && !l.isComposing() && u !== $6f291e234003fc86$var$fe(d) || null !== a && null !== e && (!e.collapsed || e.startContainer !== a.anchorNode || e.startOffset !== a.anchorOffset) || l.getFormat() !== t.format || l.getStyle() !== t.style || $6f291e234003fc86$var$Ae(t, l);
}
function $6f291e234003fc86$var$vr(t, e) {
    return null !== t && null !== t.nodeValue && t.nodeType === $6f291e234003fc86$var$st && 0 !== e && e !== t.nodeValue.length;
}
function $6f291e234003fc86$var$Tr(t, n, r) {
    const { anchorNode: s, anchorOffset: i, focusNode: o, focusOffset: l } = t;
    $6f291e234003fc86$var$gr && ($6f291e234003fc86$var$gr = !1, $6f291e234003fc86$var$vr(s, i) && $6f291e234003fc86$var$vr(o, l)) || $6f291e234003fc86$var$ii(n, ()=>{
        if (!r) return void $6f291e234003fc86$export$2aad78c37810bca9(null);
        if (!$6f291e234003fc86$export$f1b377b21cd6350b(n, s, o)) return;
        const c = $6f291e234003fc86$export$63a3201b3a5c7d90();
        if ($6f291e234003fc86$export$181b63acea8a0224(c)) {
            const e = c.anchor, r = e.getNode();
            if (c.isCollapsed()) {
                "Range" === t.type && t.anchorNode === t.focusNode && (c.dirty = !0);
                const s = $6f291e234003fc86$var$rn(n).event, i = s ? s.timeStamp : performance.now(), [o, l, a, u, f] = $6f291e234003fc86$var$mr, d = $6f291e234003fc86$export$8d83ea843c4eea9a(), h = !1 === n.isComposing() && "" === d.getTextContent();
                if (i < f + 200 && e.offset === a && e.key === u) c.format = o, c.style = l;
                else if ("text" === e.type) $6f291e234003fc86$export$471953706258be2b(r) || $6f291e234003fc86$var$Rt(141), c.format = r.getFormat(), c.style = r.getStyle();
                else if ("element" === e.type && !h) {
                    const t = e.getNode();
                    t instanceof $6f291e234003fc86$export$e94424771493b912 && 0 === t.getChildrenSize() ? c.format = t.getTextFormat() : c.format = 0, c.style = "";
                }
            } else {
                const t = e.key, n = c.focus.key, r = c.getNodes(), s = r.length, o = c.isBackward(), a = o ? l : i, u = o ? i : l, f = o ? n : t, d = o ? t : n;
                let h = $6f291e234003fc86$export$a0ecbce4c0037b95, g = !1;
                for(let t = 0; t < s; t++){
                    const e = r[t], n = e.getTextContentSize();
                    if ($6f291e234003fc86$export$471953706258be2b(e) && 0 !== n && !(0 === t && e.__key === f && a === n || t === s - 1 && e.__key === d && 0 === u) && (g = !0, h &= e.getFormat(), 0 === h)) break;
                }
                c.format = g ? h : 0;
            }
        }
        $6f291e234003fc86$var$Xe(n, $6f291e234003fc86$export$e396fef71d2b56e5, void 0);
    });
}
function $6f291e234003fc86$var$Cr(t) {
    if (!t.getTargetRanges) return null;
    const e = t.getTargetRanges();
    return 0 === e.length ? null : e[0];
}
function $6f291e234003fc86$var$Sr(t, e) {
    const n = t._compositionKey;
    if ($6f291e234003fc86$export$ea25f5ef71f2d042(null), null !== n && null != e) {
        if ("" === e) {
            const e = $6f291e234003fc86$export$e725f93d4d48c6d8(n), r = $6f291e234003fc86$var$fe(t.getElementByKey(n));
            return void (null !== r && null !== r.nodeValue && $6f291e234003fc86$export$471953706258be2b(e) && $6f291e234003fc86$var$Le(e, r.nodeValue, null, null, !0));
        }
        if ("\n" === e[e.length - 1]) {
            const e = $6f291e234003fc86$export$63a3201b3a5c7d90();
            if ($6f291e234003fc86$export$181b63acea8a0224(e)) {
                const n = e.focus;
                return e.anchor.set(n.key, n.offset, n.type), void $6f291e234003fc86$var$Xe(t, $6f291e234003fc86$export$2cdb7cdd6fccb293, null);
            }
        }
    }
    $6f291e234003fc86$var$Ie(!0, t, e);
}
function $6f291e234003fc86$var$kr(t) {
    let e = t.__lexicalEventHandles;
    return void 0 === e && (e = [], t.__lexicalEventHandles = e), e;
}
const $6f291e234003fc86$var$br = new Map;
function $6f291e234003fc86$var$wr(t) {
    const e = t.target, n = $6f291e234003fc86$var$_n(null == e ? null : 9 === e.nodeType ? e.defaultView : e.ownerDocument.defaultView);
    if (null === n) return;
    const r = $6f291e234003fc86$export$30c13854ab4c9903(n.anchorNode);
    if (null === r) return;
    $6f291e234003fc86$var$_r && ($6f291e234003fc86$var$_r = !1, $6f291e234003fc86$var$ii(r, ()=>{
        const e = $6f291e234003fc86$export$846e9407a8b5d98c(), s = n.anchorNode;
        if (null === s) return;
        const i = s.nodeType;
        if (i !== $6f291e234003fc86$var$rt && i !== $6f291e234003fc86$var$st) return;
        $6f291e234003fc86$export$2aad78c37810bca9($6f291e234003fc86$var$bs(e, n, r, t));
    }));
    const s = $6f291e234003fc86$var$De(r), i = s[s.length - 1], o = i._key, l = $6f291e234003fc86$var$br.get(o), c = l || i;
    c !== r && $6f291e234003fc86$var$Tr(n, c, !1), $6f291e234003fc86$var$Tr(n, r, !0), r !== i ? $6f291e234003fc86$var$br.set(o, r) : l && $6f291e234003fc86$var$br.delete(o);
}
function $6f291e234003fc86$var$Nr(t) {
    t._lexicalHandled = !0;
}
function $6f291e234003fc86$var$Er(t) {
    return !0 === t._lexicalHandled;
}
function $6f291e234003fc86$var$Pr(t) {
    const e = t.ownerDocument, n = $6f291e234003fc86$var$hr.get(e);
    void 0 === n && $6f291e234003fc86$var$Rt(162);
    const r = n - 1;
    r >= 0 || $6f291e234003fc86$var$Rt(164), $6f291e234003fc86$var$hr.set(e, r), 0 === r && e.removeEventListener("selectionchange", $6f291e234003fc86$var$wr);
    const s = t.__lexicalEditor;
    null != s && (!function(t) {
        if (null !== t._parentEditor) {
            const e = $6f291e234003fc86$var$De(t), n = e[e.length - 1]._key;
            $6f291e234003fc86$var$br.get(n) === t && $6f291e234003fc86$var$br.delete(n);
        } else $6f291e234003fc86$var$br.delete(t._key);
    }(s), t.__lexicalEditor = null);
    const i = $6f291e234003fc86$var$kr(t);
    for(let t = 0; t < i.length; t++)i[t]();
    t.__lexicalEventHandles = [];
}
function $6f291e234003fc86$var$Dr(t, e, n) {
    $6f291e234003fc86$var$Vs();
    const r = t.__key, s = t.getParent();
    if (null === s) return;
    const i = function(t) {
        const e = $6f291e234003fc86$export$63a3201b3a5c7d90();
        if (!$6f291e234003fc86$export$181b63acea8a0224(e) || !$6f291e234003fc86$export$923a058ef54437a4(t)) return e;
        const { anchor: n, focus: r } = e, s = n.getNode(), i = r.getNode();
        return $6f291e234003fc86$export$e3d4b782f65c81f1(s, t) && n.set(t.__key, 0, "element"), $6f291e234003fc86$export$e3d4b782f65c81f1(i, t) && r.set(t.__key, 0, "element"), e;
    }(t);
    let o = !1;
    if ($6f291e234003fc86$export$181b63acea8a0224(i) && e) {
        const e = i.anchor, n = i.focus;
        e.key === r && ($6f291e234003fc86$var$Ds(e, t, s, t.getPreviousSibling(), t.getNextSibling()), o = !0), n.key === r && ($6f291e234003fc86$var$Ds(n, t, s, t.getPreviousSibling(), t.getNextSibling()), o = !0);
    } else $6f291e234003fc86$export$7257e4181651a7c3(i) && e && t.isSelected() && t.selectPrevious();
    if ($6f291e234003fc86$export$181b63acea8a0224(i) && e && !o) {
        const e = t.getIndexWithinParent();
        $6f291e234003fc86$var$_e(t), $6f291e234003fc86$var$Es(i, s, e, -1);
    } else $6f291e234003fc86$var$_e(t);
    n || $6f291e234003fc86$export$6f851a24c61146af(s) || s.canBeEmpty() || !s.isEmpty() || $6f291e234003fc86$var$Dr(s, e), e && $6f291e234003fc86$export$5b29ca560c2fedab(s) && s.isEmpty() && s.selectEnd();
}
class $6f291e234003fc86$var$Fr {
    static getType() {
        $6f291e234003fc86$var$Rt(64, this.name);
    }
    static clone(t) {
        $6f291e234003fc86$var$Rt(65, this.name);
    }
    constructor(t){
        this.__type = this.constructor.getType(), this.__parent = null, this.__prev = null, this.__next = null, $6f291e234003fc86$var$ge(this, t);
    }
    getType() {
        return this.__type;
    }
    isInline() {
        $6f291e234003fc86$var$Rt(137, this.constructor.name);
    }
    isAttached() {
        let t = this.__key;
        for(; null !== t;){
            if ("root" === t) return !0;
            const e = $6f291e234003fc86$export$e725f93d4d48c6d8(t);
            if (null === e) break;
            t = e.__parent;
        }
        return !1;
    }
    isSelected(t) {
        const e = t || $6f291e234003fc86$export$63a3201b3a5c7d90();
        if (null == e) return !1;
        const n = e.getNodes().some((t)=>t.__key === this.__key);
        return ($6f291e234003fc86$export$471953706258be2b(this) || !$6f291e234003fc86$export$181b63acea8a0224(e) || "element" !== e.anchor.type || "element" !== e.focus.type || e.anchor.key !== e.focus.key || e.anchor.offset !== e.focus.offset) && n;
    }
    getKey() {
        return this.__key;
    }
    getIndexWithinParent() {
        const t = this.getParent();
        if (null === t) return -1;
        let e = t.getFirstChild(), n = 0;
        for(; null !== e;){
            if (this.is(e)) return n;
            n++, e = e.getNextSibling();
        }
        return -1;
    }
    getParent() {
        const t = this.getLatest().__parent;
        return null === t ? null : $6f291e234003fc86$export$e725f93d4d48c6d8(t);
    }
    getParentOrThrow() {
        const t = this.getParent();
        return null === t && $6f291e234003fc86$var$Rt(66, this.__key), t;
    }
    getTopLevelElement() {
        let t = this;
        for(; null !== t;){
            const e = t.getParent();
            if ($6f291e234003fc86$export$6f851a24c61146af(e)) return $6f291e234003fc86$export$923a058ef54437a4(t) || $6f291e234003fc86$var$Rt(138), t;
            t = e;
        }
        return null;
    }
    getTopLevelElementOrThrow() {
        const t = this.getTopLevelElement();
        return null === t && $6f291e234003fc86$var$Rt(67, this.__key), t;
    }
    getParents() {
        const t = [];
        let e = this.getParent();
        for(; null !== e;)t.push(e), e = e.getParent();
        return t;
    }
    getParentKeys() {
        const t = [];
        let e = this.getParent();
        for(; null !== e;)t.push(e.__key), e = e.getParent();
        return t;
    }
    getPreviousSibling() {
        const t = this.getLatest().__prev;
        return null === t ? null : $6f291e234003fc86$export$e725f93d4d48c6d8(t);
    }
    getPreviousSiblings() {
        const t = [], e = this.getParent();
        if (null === e) return t;
        let n = e.getFirstChild();
        for(; null !== n && !n.is(this);)t.push(n), n = n.getNextSibling();
        return t;
    }
    getNextSibling() {
        const t = this.getLatest().__next;
        return null === t ? null : $6f291e234003fc86$export$e725f93d4d48c6d8(t);
    }
    getNextSiblings() {
        const t = [];
        let e = this.getNextSibling();
        for(; null !== e;)t.push(e), e = e.getNextSibling();
        return t;
    }
    getCommonAncestor(t) {
        const e = this.getParents(), n = t.getParents();
        $6f291e234003fc86$export$923a058ef54437a4(this) && e.unshift(this), $6f291e234003fc86$export$923a058ef54437a4(t) && n.unshift(t);
        const r = e.length, s = n.length;
        if (0 === r || 0 === s || e[r - 1] !== n[s - 1]) return null;
        const i = new Set(n);
        for(let t = 0; t < r; t++){
            const n = e[t];
            if (i.has(n)) return n;
        }
        return null;
    }
    is(t) {
        return null != t && this.__key === t.__key;
    }
    isBefore(t) {
        if (this === t) return !1;
        if (t.isParentOf(this)) return !0;
        if (this.isParentOf(t)) return !1;
        const e = this.getCommonAncestor(t);
        let n = 0, r = 0, s = this;
        for(;;){
            const t = s.getParentOrThrow();
            if (t === e) {
                n = s.getIndexWithinParent();
                break;
            }
            s = t;
        }
        for(s = t;;){
            const t = s.getParentOrThrow();
            if (t === e) {
                r = s.getIndexWithinParent();
                break;
            }
            s = t;
        }
        return n < r;
    }
    isParentOf(t) {
        const e = this.__key;
        if (e === t.__key) return !1;
        let n = t;
        for(; null !== n;){
            if (n.__key === e) return !0;
            n = n.getParent();
        }
        return !1;
    }
    getNodesBetween(t) {
        const e = this.isBefore(t), n = [], r = new Set;
        let s = this;
        for(; null !== s;){
            const i = s.__key;
            if (r.has(i) || (r.add(i), n.push(s)), s === t) break;
            const o = $6f291e234003fc86$export$923a058ef54437a4(s) ? e ? s.getFirstChild() : s.getLastChild() : null;
            if (null !== o) {
                s = o;
                continue;
            }
            const l = e ? s.getNextSibling() : s.getPreviousSibling();
            if (null !== l) {
                s = l;
                continue;
            }
            const c = s.getParentOrThrow();
            if (r.has(c.__key) || n.push(c), c === t) break;
            let a = null, u = c;
            do {
                if (null === u && $6f291e234003fc86$var$Rt(68), a = e ? u.getNextSibling() : u.getPreviousSibling(), u = u.getParent(), null === u) break;
                null !== a || r.has(u.__key) || n.push(u);
            }while (null === a);
            s = a;
        }
        return e || n.reverse(), n;
    }
    isDirty() {
        const t = $6f291e234003fc86$var$js()._dirtyLeaves;
        return null !== t && t.has(this.__key);
    }
    getLatest() {
        const t = $6f291e234003fc86$export$e725f93d4d48c6d8(this.__key);
        return null === t && $6f291e234003fc86$var$Rt(113), t;
    }
    getWritable() {
        $6f291e234003fc86$var$Vs();
        const t = $6f291e234003fc86$var$Hs(), e = $6f291e234003fc86$var$js(), n = t._nodeMap, r = this.__key, s = this.getLatest(), i = s.__parent, o = e._cloneNotNeeded, l = $6f291e234003fc86$export$63a3201b3a5c7d90();
        if (null !== l && l.setCachedNodes(null), o.has(r)) return $6f291e234003fc86$var$pe(s), s;
        const c = s.constructor.clone(s);
        return c.__parent = i, c.__next = s.__next, c.__prev = s.__prev, $6f291e234003fc86$export$923a058ef54437a4(s) && $6f291e234003fc86$export$923a058ef54437a4(c) ? ($6f291e234003fc86$export$1fdda795300c79c6(s) && $6f291e234003fc86$export$1fdda795300c79c6(c) && (c.__textFormat = s.__textFormat), c.__first = s.__first, c.__last = s.__last, c.__size = s.__size, c.__indent = s.__indent, c.__format = s.__format, c.__dir = s.__dir) : $6f291e234003fc86$export$471953706258be2b(s) && $6f291e234003fc86$export$471953706258be2b(c) && (c.__format = s.__format, c.__style = s.__style, c.__mode = s.__mode, c.__detail = s.__detail), o.add(r), c.__key = r, $6f291e234003fc86$var$pe(c), n.set(r, c), c;
    }
    getTextContent() {
        return "";
    }
    getTextContentSize() {
        return this.getTextContent().length;
    }
    createDOM(t, e) {
        $6f291e234003fc86$var$Rt(70);
    }
    updateDOM(t, e, n) {
        $6f291e234003fc86$var$Rt(71);
    }
    exportDOM(t) {
        return {
            element: this.createDOM(t._config, t)
        };
    }
    exportJSON() {
        $6f291e234003fc86$var$Rt(72);
    }
    static importJSON(t) {
        $6f291e234003fc86$var$Rt(18, this.name);
    }
    static transform() {
        return null;
    }
    remove(t) {
        $6f291e234003fc86$var$Dr(this, !0, t);
    }
    replace(t, e) {
        $6f291e234003fc86$var$Vs();
        let n = $6f291e234003fc86$export$63a3201b3a5c7d90();
        null !== n && (n = n.clone()), $6f291e234003fc86$var$un(this, t);
        const r = this.getLatest(), s = this.__key, i = t.__key, o = t.getWritable(), l = this.getParentOrThrow().getWritable(), c = l.__size;
        $6f291e234003fc86$var$_e(o);
        const a = r.getPreviousSibling(), u = r.getNextSibling(), f = r.__prev, d = r.__next, h = r.__parent;
        if ($6f291e234003fc86$var$Dr(r, !1, !0), null === a) l.__first = i;
        else a.getWritable().__next = i;
        if (o.__prev = f, null === u) l.__last = i;
        else u.getWritable().__prev = i;
        if (o.__next = d, o.__parent = h, l.__size = c, e && ($6f291e234003fc86$export$923a058ef54437a4(this) && $6f291e234003fc86$export$923a058ef54437a4(o) || $6f291e234003fc86$var$Rt(139), this.getChildren().forEach((t)=>{
            o.append(t);
        })), $6f291e234003fc86$export$181b63acea8a0224(n)) {
            $6f291e234003fc86$export$2aad78c37810bca9(n);
            const t = n.anchor, e = n.focus;
            t.key === s && $6f291e234003fc86$var$ls(t, o), e.key === s && $6f291e234003fc86$var$ls(e, o);
        }
        return $6f291e234003fc86$var$me() === s && $6f291e234003fc86$export$ea25f5ef71f2d042(i), o;
    }
    insertAfter(t, e = !0) {
        $6f291e234003fc86$var$Vs(), $6f291e234003fc86$var$un(this, t);
        const n = this.getWritable(), r = t.getWritable(), s = r.getParent(), i = $6f291e234003fc86$export$63a3201b3a5c7d90();
        let o = !1, l = !1;
        if (null !== s) {
            const e = t.getIndexWithinParent();
            if ($6f291e234003fc86$var$_e(r), $6f291e234003fc86$export$181b63acea8a0224(i)) {
                const t = s.__key, n = i.anchor, r = i.focus;
                o = "element" === n.type && n.key === t && n.offset === e + 1, l = "element" === r.type && r.key === t && r.offset === e + 1;
            }
        }
        const c = this.getNextSibling(), a = this.getParentOrThrow().getWritable(), u = r.__key, f = n.__next;
        if (null === c) a.__last = u;
        else c.getWritable().__prev = u;
        if (a.__size++, n.__next = u, r.__next = f, r.__prev = n.__key, r.__parent = n.__parent, e && $6f291e234003fc86$export$181b63acea8a0224(i)) {
            const t = this.getIndexWithinParent();
            $6f291e234003fc86$var$Es(i, a, t + 1);
            const e = a.__key;
            o && i.anchor.set(e, t + 2, "element"), l && i.focus.set(e, t + 2, "element");
        }
        return t;
    }
    insertBefore(t, e = !0) {
        $6f291e234003fc86$var$Vs(), $6f291e234003fc86$var$un(this, t);
        const n = this.getWritable(), r = t.getWritable(), s = r.__key;
        $6f291e234003fc86$var$_e(r);
        const i = this.getPreviousSibling(), o = this.getParentOrThrow().getWritable(), l = n.__prev, c = this.getIndexWithinParent();
        if (null === i) o.__first = s;
        else i.getWritable().__next = s;
        o.__size++, n.__prev = s, r.__prev = l, r.__next = n.__key, r.__parent = n.__parent;
        const a = $6f291e234003fc86$export$63a3201b3a5c7d90();
        if (e && $6f291e234003fc86$export$181b63acea8a0224(a)) $6f291e234003fc86$var$Es(a, this.getParentOrThrow(), c);
        return t;
    }
    isParentRequired() {
        return !1;
    }
    createParentElementNode() {
        return $6f291e234003fc86$export$7f0c05ffb7ced90d();
    }
    selectStart() {
        return this.selectPrevious();
    }
    selectEnd() {
        return this.selectNext(0, 0);
    }
    selectPrevious(t, e) {
        $6f291e234003fc86$var$Vs();
        const n = this.getPreviousSibling(), r = this.getParentOrThrow();
        if (null === n) return r.select(0, 0);
        if ($6f291e234003fc86$export$923a058ef54437a4(n)) return n.select();
        if (!$6f291e234003fc86$export$471953706258be2b(n)) {
            const t = n.getIndexWithinParent() + 1;
            return r.select(t, t);
        }
        return n.select(t, e);
    }
    selectNext(t, e) {
        $6f291e234003fc86$var$Vs();
        const n = this.getNextSibling(), r = this.getParentOrThrow();
        if (null === n) return r.select();
        if ($6f291e234003fc86$export$923a058ef54437a4(n)) return n.select(0, 0);
        if (!$6f291e234003fc86$export$471953706258be2b(n)) {
            const t = n.getIndexWithinParent();
            return r.select(t, t);
        }
        return n.select(t, e);
    }
    markDirty() {
        this.getWritable();
    }
}
class $6f291e234003fc86$export$965f56e8043e93ae extends $6f291e234003fc86$var$Fr {
    static getType() {
        return "linebreak";
    }
    static clone(t) {
        return new $6f291e234003fc86$export$965f56e8043e93ae(t.__key);
    }
    constructor(t){
        super(t);
    }
    getTextContent() {
        return "\n";
    }
    createDOM() {
        return document.createElement("br");
    }
    updateDOM() {
        return !1;
    }
    static importDOM() {
        return {
            br: (t)=>(function(t) {
                    const e = t.parentElement;
                    if (null !== e) {
                        const n = e.firstChild;
                        if (n === t || n.nextSibling === t && $6f291e234003fc86$var$Mr(n)) {
                            const n = e.lastChild;
                            if (n === t || n.previousSibling === t && $6f291e234003fc86$var$Mr(n)) return !0;
                        }
                    }
                    return !1;
                })(t) ? null : {
                    conversion: $6f291e234003fc86$var$Ir,
                    priority: 0
                }
        };
    }
    static importJSON(t) {
        return $6f291e234003fc86$export$4ccaf7d0d16ab4c();
    }
    exportJSON() {
        return {
            type: "linebreak",
            version: 1
        };
    }
}
function $6f291e234003fc86$var$Ir(t) {
    return {
        node: $6f291e234003fc86$export$4ccaf7d0d16ab4c()
    };
}
function $6f291e234003fc86$export$4ccaf7d0d16ab4c() {
    return $6f291e234003fc86$export$2f5beb31df92ea57(new $6f291e234003fc86$export$965f56e8043e93ae);
}
function $6f291e234003fc86$export$b16330e40aa25c4e(t) {
    return t instanceof $6f291e234003fc86$export$965f56e8043e93ae;
}
function $6f291e234003fc86$var$Mr(t) {
    return t.nodeType === $6f291e234003fc86$var$st && /^( |\t|\r?\n)+$/.test(t.textContent || "");
}
function $6f291e234003fc86$var$zr(t, e) {
    return 16 & e ? "code" : e & $6f291e234003fc86$export$f1e9b55cdd671814 ? "mark" : 32 & e ? "sub" : 64 & e ? "sup" : null;
}
function $6f291e234003fc86$var$Wr(t, e) {
    return 1 & e ? "strong" : 2 & e ? "em" : "span";
}
function $6f291e234003fc86$var$Br(t, e, n, r, s) {
    const i = r.classList;
    let o = $6f291e234003fc86$var$Ve(s, "base");
    void 0 !== o && i.add(...o), o = $6f291e234003fc86$var$Ve(s, "underlineStrikethrough");
    let l = !1;
    const c = e & $6f291e234003fc86$export$4fefe1576f07e925 && e & $6f291e234003fc86$export$27809404dee18444;
    void 0 !== o && (n & $6f291e234003fc86$export$4fefe1576f07e925 && n & $6f291e234003fc86$export$27809404dee18444 ? (l = !0, c || i.add(...o)) : c && i.remove(...o));
    for(const t in $6f291e234003fc86$export$c9e7d6eb65b13430){
        const r = $6f291e234003fc86$export$c9e7d6eb65b13430[t];
        if (o = $6f291e234003fc86$var$Ve(s, t), void 0 !== o) {
            if (n & r) {
                if (l && ("underline" === t || "strikethrough" === t)) {
                    e & r && i.remove(...o);
                    continue;
                }
                e & r && (!c || "underline" !== t) && "strikethrough" !== t || i.add(...o);
            } else e & r && i.remove(...o);
        }
    }
}
function $6f291e234003fc86$var$Rr(t, e, n) {
    const r = e.firstChild, s = n.isComposing(), i = t + (s ? $6f291e234003fc86$var$wt : "");
    if (null == r) e.textContent = i;
    else {
        const t = r.nodeValue;
        if (t !== i) {
            if (s || $6f291e234003fc86$var$Q) {
                const [e, n, s] = function(t, e) {
                    const n = t.length, r = e.length;
                    let s = 0, i = 0;
                    for(; s < n && s < r && t[s] === e[s];)s++;
                    for(; i + s < n && i + s < r && t[n - i - 1] === e[r - i - 1];)i++;
                    return [
                        s,
                        n - s - i,
                        e.slice(s, r - i)
                    ];
                }(t, i);
                0 !== n && r.deleteData(e, n), r.insertData(e, s);
            } else r.nodeValue = i;
        }
    }
}
function $6f291e234003fc86$var$Kr(t, e, n, r, s, i) {
    $6f291e234003fc86$var$Rr(s, t, e);
    const o = i.theme.text;
    void 0 !== o && $6f291e234003fc86$var$Br(0, 0, r, t, o);
}
function $6f291e234003fc86$var$Jr(t, e) {
    const n = document.createElement(e);
    return n.appendChild(t), n;
}
class $6f291e234003fc86$export$f0a25ea3087686aa extends $6f291e234003fc86$var$Fr {
    static getType() {
        return "text";
    }
    static clone(t) {
        return new $6f291e234003fc86$export$f0a25ea3087686aa(t.__text, t.__key);
    }
    constructor(t, e){
        super(e), this.__text = t, this.__format = 0, this.__style = "", this.__mode = 0, this.__detail = 0;
    }
    getFormat() {
        return this.getLatest().__format;
    }
    getDetail() {
        return this.getLatest().__detail;
    }
    getMode() {
        const t = this.getLatest();
        return $6f291e234003fc86$var$Wt[t.__mode];
    }
    getStyle() {
        return this.getLatest().__style;
    }
    isToken() {
        return 1 === this.getLatest().__mode;
    }
    isComposing() {
        return this.__key === $6f291e234003fc86$var$me();
    }
    isSegmented() {
        return 2 === this.getLatest().__mode;
    }
    isDirectionless() {
        return !!(1 & this.getLatest().__detail);
    }
    isUnmergeable() {
        return !!(2 & this.getLatest().__detail);
    }
    hasFormat(t) {
        const e = $6f291e234003fc86$export$c9e7d6eb65b13430[t];
        return !!(this.getFormat() & e);
    }
    isSimpleText() {
        return "text" === this.__type && 0 === this.__mode;
    }
    getTextContent() {
        return this.getLatest().__text;
    }
    getFormatFlags(t, e) {
        return $6f291e234003fc86$var$de(this.getLatest().__format, t, e);
    }
    canHaveFormat() {
        return !0;
    }
    createDOM(t, e) {
        const n = this.__format, r = $6f291e234003fc86$var$zr(0, n), s = $6f291e234003fc86$var$Wr(0, n), i = null === r ? s : r, o = document.createElement(i);
        let l = o;
        this.hasFormat("code") && o.setAttribute("spellcheck", "false"), null !== r && (l = document.createElement(s), o.appendChild(l));
        $6f291e234003fc86$var$Kr(l, this, 0, n, this.__text, t);
        const c = this.__style;
        return "" !== c && (o.style.cssText = c), o;
    }
    updateDOM(t, e, n) {
        const r = this.__text, s = t.__format, i = this.__format, o = $6f291e234003fc86$var$zr(0, s), l = $6f291e234003fc86$var$zr(0, i), c = $6f291e234003fc86$var$Wr(0, s), a = $6f291e234003fc86$var$Wr(0, i);
        if ((null === o ? c : o) !== (null === l ? a : l)) return !0;
        if (o === l && c !== a) {
            const t = e.firstChild;
            null == t && $6f291e234003fc86$var$Rt(48);
            const s = document.createElement(a);
            return $6f291e234003fc86$var$Kr(s, this, 0, i, r, n), e.replaceChild(s, t), !1;
        }
        let u = e;
        null !== l && null !== o && (u = e.firstChild, null == u && $6f291e234003fc86$var$Rt(49)), $6f291e234003fc86$var$Rr(r, u, this);
        const f = n.theme.text;
        void 0 !== f && s !== i && $6f291e234003fc86$var$Br(0, s, i, u, f);
        const d = t.__style, h = this.__style;
        return d !== h && (e.style.cssText = h), !1;
    }
    static importDOM() {
        return {
            "#text": ()=>({
                    conversion: $6f291e234003fc86$var$qr,
                    priority: 0
                }),
            b: ()=>({
                    conversion: $6f291e234003fc86$var$$r,
                    priority: 0
                }),
            code: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                }),
            em: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                }),
            i: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                }),
            s: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                }),
            span: ()=>({
                    conversion: $6f291e234003fc86$var$Vr,
                    priority: 0
                }),
            strong: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                }),
            sub: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                }),
            sup: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                }),
            u: ()=>({
                    conversion: $6f291e234003fc86$var$Yr,
                    priority: 0
                })
        };
    }
    static importJSON(t) {
        const e = $6f291e234003fc86$export$2785f39dcdec0078(t.text);
        return e.setFormat(t.format), e.setDetail(t.detail), e.setMode(t.mode), e.setStyle(t.style), e;
    }
    exportDOM(t) {
        let { element: e } = super.exportDOM(t);
        return null !== e && $6f291e234003fc86$export$1b3bfaa9684536aa(e) || $6f291e234003fc86$var$Rt(132), e.style.whiteSpace = "pre-wrap", this.hasFormat("bold") && (e = $6f291e234003fc86$var$Jr(e, "b")), this.hasFormat("italic") && (e = $6f291e234003fc86$var$Jr(e, "i")), this.hasFormat("strikethrough") && (e = $6f291e234003fc86$var$Jr(e, "s")), this.hasFormat("underline") && (e = $6f291e234003fc86$var$Jr(e, "u")), {
            element: e
        };
    }
    exportJSON() {
        return {
            detail: this.getDetail(),
            format: this.getFormat(),
            mode: this.getMode(),
            style: this.getStyle(),
            text: this.getTextContent(),
            type: "text",
            version: 1
        };
    }
    selectionTransform(t, e) {}
    setFormat(t) {
        const e = this.getWritable();
        return e.__format = "string" == typeof t ? $6f291e234003fc86$export$c9e7d6eb65b13430[t] : t, e;
    }
    setDetail(t) {
        const e = this.getWritable();
        return e.__detail = "string" == typeof t ? $6f291e234003fc86$var$Lt[t] : t, e;
    }
    setStyle(t) {
        const e = this.getWritable();
        return e.__style = t, e;
    }
    toggleFormat(t) {
        const e = $6f291e234003fc86$var$de(this.getFormat(), t, null);
        return this.setFormat(e);
    }
    toggleDirectionless() {
        const t = this.getWritable();
        return t.__detail ^= 1, t;
    }
    toggleUnmergeable() {
        const t = this.getWritable();
        return t.__detail ^= 2, t;
    }
    setMode(t) {
        const e = $6f291e234003fc86$var$zt[t];
        if (this.__mode === e) return this;
        const n = this.getWritable();
        return n.__mode = e, n;
    }
    setTextContent(t) {
        if (this.__text === t) return this;
        const e = this.getWritable();
        return e.__text = t, e;
    }
    select(t, e) {
        $6f291e234003fc86$var$Vs();
        let n = t, r = e;
        const s = $6f291e234003fc86$export$63a3201b3a5c7d90(), i = this.getTextContent(), o = this.__key;
        if ("string" == typeof i) {
            const t = i.length;
            void 0 === n && (n = t), void 0 === r && (r = t);
        } else n = 0, r = 0;
        if (!$6f291e234003fc86$export$181b63acea8a0224(s)) return $6f291e234003fc86$var$Ts(o, n, o, r, "text", "text");
        {
            const t = $6f291e234003fc86$var$me();
            t !== s.anchor.key && t !== s.focus.key || $6f291e234003fc86$export$ea25f5ef71f2d042(o), s.setTextNodeRange(this, n, this, r);
        }
        return s;
    }
    selectStart() {
        return this.select(0, 0);
    }
    selectEnd() {
        const t = this.getTextContentSize();
        return this.select(t, t);
    }
    spliceText(t, e, n, r) {
        const s = this.getWritable(), i = s.__text, o = n.length;
        let l = t;
        l < 0 && (l = o + l, l < 0 && (l = 0));
        const c = $6f291e234003fc86$export$63a3201b3a5c7d90();
        if (r && $6f291e234003fc86$export$181b63acea8a0224(c)) {
            const e = t + o;
            c.setTextNodeRange(s, e, s, e);
        }
        const a = i.slice(0, l) + n + i.slice(l + e);
        return s.__text = a, s;
    }
    canInsertTextBefore() {
        return !0;
    }
    canInsertTextAfter() {
        return !0;
    }
    splitText(...t) {
        $6f291e234003fc86$var$Vs();
        const e = this.getLatest(), n = e.getTextContent(), r = e.__key, s = $6f291e234003fc86$var$me(), i = new Set(t), o = [], l = n.length;
        let c = "";
        for(let t = 0; t < l; t++)"" !== c && i.has(t) && (o.push(c), c = ""), c += n[t];
        "" !== c && o.push(c);
        const a = o.length;
        if (0 === a) return [];
        if (o[0] === n) return [
            e
        ];
        const u = o[0], f = e.getParentOrThrow();
        let d;
        const h = e.getFormat(), g = e.getStyle(), _ = e.__detail;
        let p = !1;
        e.isSegmented() ? (d = $6f291e234003fc86$export$2785f39dcdec0078(u), d.__format = h, d.__style = g, d.__detail = _, p = !0) : (d = e.getWritable(), d.__text = u);
        const y = $6f291e234003fc86$export$63a3201b3a5c7d90(), m = [
            d
        ];
        let x = u.length;
        for(let t = 1; t < a; t++){
            const e = o[t], n = e.length, i = $6f291e234003fc86$export$2785f39dcdec0078(e).getWritable();
            i.__format = h, i.__style = g, i.__detail = _;
            const l = i.__key, c = x + n;
            if ($6f291e234003fc86$export$181b63acea8a0224(y)) {
                const t = y.anchor, e = y.focus;
                t.key === r && "text" === t.type && t.offset > x && t.offset <= c && (t.key = l, t.offset -= x, y.dirty = !0), e.key === r && "text" === e.type && e.offset > x && e.offset <= c && (e.key = l, e.offset -= x, y.dirty = !0);
            }
            s === r && $6f291e234003fc86$export$ea25f5ef71f2d042(l), x = c, m.push(i);
        }
        !function(t) {
            const e = t.getPreviousSibling(), n = t.getNextSibling();
            null !== e && $6f291e234003fc86$var$pe(e), null !== n && $6f291e234003fc86$var$pe(n);
        }(this);
        const v = f.getWritable(), T = this.getIndexWithinParent();
        return p ? (v.splice(T, 0, m), this.remove()) : v.splice(T, 1, m), $6f291e234003fc86$export$181b63acea8a0224(y) && $6f291e234003fc86$var$Es(y, f, T, a - 1), m;
    }
    mergeWithSibling(t) {
        const e = t === this.getPreviousSibling();
        e || t === this.getNextSibling() || $6f291e234003fc86$var$Rt(50);
        const n = this.__key, r = t.__key, s = this.__text, i = s.length;
        $6f291e234003fc86$var$me() === r && $6f291e234003fc86$export$ea25f5ef71f2d042(n);
        const o = $6f291e234003fc86$export$63a3201b3a5c7d90();
        if ($6f291e234003fc86$export$181b63acea8a0224(o)) {
            const s = o.anchor, l = o.focus;
            null !== s && s.key === r && ($6f291e234003fc86$var$Fs(s, e, n, t, i), o.dirty = !0), null !== l && l.key === r && ($6f291e234003fc86$var$Fs(l, e, n, t, i), o.dirty = !0);
        }
        const l = t.__text, c = e ? l + s : s + l;
        this.setTextContent(c);
        const a = this.getWritable();
        return t.remove(), a;
    }
    isTextEntity() {
        return !1;
    }
}
function $6f291e234003fc86$var$Vr(t) {
    return {
        forChild: $6f291e234003fc86$var$ts(t.style),
        node: null
    };
}
function $6f291e234003fc86$var$$r(t) {
    const e = t, n = "normal" === e.style.fontWeight;
    return {
        forChild: $6f291e234003fc86$var$ts(e.style, n ? void 0 : "bold"),
        node: null
    };
}
const $6f291e234003fc86$var$Hr = new WeakMap;
function $6f291e234003fc86$var$jr(t) {
    return "PRE" === t.nodeName || t.nodeType === $6f291e234003fc86$var$rt && void 0 !== t.style && void 0 !== t.style.whiteSpace && t.style.whiteSpace.startsWith("pre");
}
function $6f291e234003fc86$var$qr(t) {
    const e = t;
    null === t.parentElement && $6f291e234003fc86$var$Rt(129);
    let n = e.textContent || "";
    if (null !== function(t) {
        let e, n = t.parentNode;
        const r = [
            t
        ];
        for(; null !== n && void 0 === (e = $6f291e234003fc86$var$Hr.get(n)) && !$6f291e234003fc86$var$jr(n);)r.push(n), n = n.parentNode;
        const s = void 0 === e ? n : e;
        for(let t = 0; t < r.length; t++)$6f291e234003fc86$var$Hr.set(r[t], s);
        return s;
    }(e)) {
        const t = n.split(/(\r?\n|\t)/), e = [], r = t.length;
        for(let n = 0; n < r; n++){
            const r = t[n];
            "\n" === r || "\r\n" === r ? e.push($6f291e234003fc86$export$4ccaf7d0d16ab4c()) : "\t" === r ? e.push($6f291e234003fc86$export$5bde9d58a1da0796()) : "" !== r && e.push($6f291e234003fc86$export$2785f39dcdec0078(r));
        }
        return {
            node: e
        };
    }
    if (n = n.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), "" === n) return {
        node: null
    };
    if (" " === n[0]) {
        let t = e, r = !0;
        for(; null !== t && null !== (t = $6f291e234003fc86$var$Qr(t, !1));){
            const e = t.textContent || "";
            if (e.length > 0) {
                /[ \t\n]$/.test(e) && (n = n.slice(1)), r = !1;
                break;
            }
        }
        r && (n = n.slice(1));
    }
    if (" " === n[n.length - 1]) {
        let t = e, r = !0;
        for(; null !== t && null !== (t = $6f291e234003fc86$var$Qr(t, !0));)if ((t.textContent || "").replace(/^( |\t|\r?\n)+/, "").length > 0) {
            r = !1;
            break;
        }
        r && (n = n.slice(0, n.length - 1));
    }
    return "" === n ? {
        node: null
    } : {
        node: $6f291e234003fc86$export$2785f39dcdec0078(n)
    };
}
function $6f291e234003fc86$var$Qr(t, e) {
    let n = t;
    for(;;){
        let t;
        for(; null === (t = e ? n.nextSibling : n.previousSibling);){
            const t = n.parentElement;
            if (null === t) return null;
            n = t;
        }
        if (n = t, n.nodeType === $6f291e234003fc86$var$rt) {
            const t = n.style.display;
            if ("" === t && !$6f291e234003fc86$export$456fd4e5e0a7123d(n) || "" !== t && !t.startsWith("inline")) return null;
        }
        let r = n;
        for(; null !== (r = e ? n.firstChild : n.lastChild);)n = r;
        if (n.nodeType === $6f291e234003fc86$var$st) return n;
        if ("BR" === n.nodeName) return null;
    }
}
const $6f291e234003fc86$var$Xr = {
    code: "code",
    em: "italic",
    i: "italic",
    s: "strikethrough",
    strong: "bold",
    sub: "subscript",
    sup: "superscript",
    u: "underline"
};
function $6f291e234003fc86$var$Yr(t) {
    const e = $6f291e234003fc86$var$Xr[t.nodeName.toLowerCase()];
    return void 0 === e ? {
        node: null
    } : {
        forChild: $6f291e234003fc86$var$ts(t.style, e),
        node: null
    };
}
function $6f291e234003fc86$export$2785f39dcdec0078(t = "") {
    return $6f291e234003fc86$export$2f5beb31df92ea57(new $6f291e234003fc86$export$f0a25ea3087686aa(t));
}
function $6f291e234003fc86$export$471953706258be2b(t) {
    return t instanceof $6f291e234003fc86$export$f0a25ea3087686aa;
}
function $6f291e234003fc86$var$ts(t, e) {
    const n = t.fontWeight, r = t.textDecoration.split(" "), s = "700" === n || "bold" === n, i = r.includes("line-through"), o = "italic" === t.fontStyle, l = r.includes("underline"), c = t.verticalAlign;
    return (t)=>$6f291e234003fc86$export$471953706258be2b(t) ? (s && !t.hasFormat("bold") && t.toggleFormat("bold"), i && !t.hasFormat("strikethrough") && t.toggleFormat("strikethrough"), o && !t.hasFormat("italic") && t.toggleFormat("italic"), l && !t.hasFormat("underline") && t.toggleFormat("underline"), "sub" !== c || t.hasFormat("subscript") || t.toggleFormat("subscript"), "super" !== c || t.hasFormat("superscript") || t.toggleFormat("superscript"), e && !t.hasFormat(e) && t.toggleFormat(e), t) : t;
}
class $6f291e234003fc86$export$8dbf7edd89edc19c extends $6f291e234003fc86$export$f0a25ea3087686aa {
    static getType() {
        return "tab";
    }
    static clone(t) {
        const e = new $6f291e234003fc86$export$8dbf7edd89edc19c(t.__key);
        return e.__text = t.__text, e.__format = t.__format, e.__style = t.__style, e;
    }
    constructor(t){
        super("\t", t), this.__detail = 2;
    }
    static importDOM() {
        return null;
    }
    static importJSON(t) {
        const e = $6f291e234003fc86$export$5bde9d58a1da0796();
        return e.setFormat(t.format), e.setStyle(t.style), e;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "tab",
            version: 1
        };
    }
    setTextContent(t) {
        $6f291e234003fc86$var$Rt(126);
    }
    setDetail(t) {
        $6f291e234003fc86$var$Rt(127);
    }
    setMode(t) {
        $6f291e234003fc86$var$Rt(128);
    }
    canInsertTextBefore() {
        return !1;
    }
    canInsertTextAfter() {
        return !1;
    }
}
function $6f291e234003fc86$export$5bde9d58a1da0796() {
    return $6f291e234003fc86$export$2f5beb31df92ea57(new $6f291e234003fc86$export$8dbf7edd89edc19c);
}
function $6f291e234003fc86$export$ac9141efa5fb7932(t) {
    return t instanceof $6f291e234003fc86$export$8dbf7edd89edc19c;
}
class $6f291e234003fc86$var$ss {
    constructor(t, e, n){
        this._selection = null, this.key = t, this.offset = e, this.type = n;
    }
    is(t) {
        return this.key === t.key && this.offset === t.offset && this.type === t.type;
    }
    isBefore(t) {
        let e = this.getNode(), n = t.getNode();
        const r = this.offset, s = t.offset;
        if ($6f291e234003fc86$export$923a058ef54437a4(e)) {
            const t = e.getDescendantByIndex(r);
            e = null != t ? t : e;
        }
        if ($6f291e234003fc86$export$923a058ef54437a4(n)) {
            const t = n.getDescendantByIndex(s);
            n = null != t ? t : n;
        }
        return e === n ? r < s : e.isBefore(n);
    }
    getNode() {
        const t = $6f291e234003fc86$export$e725f93d4d48c6d8(this.key);
        return null === t && $6f291e234003fc86$var$Rt(20), t;
    }
    set(t, e, n) {
        const r = this._selection, s = this.key;
        this.key = t, this.offset = e, this.type = n, $6f291e234003fc86$export$761df28585b755e8() || ($6f291e234003fc86$var$me() === s && $6f291e234003fc86$export$ea25f5ef71f2d042(t), null !== r && (r.setCachedNodes(null), r.dirty = !0));
    }
}
function $6f291e234003fc86$export$9b3f8d373c057995(t, e, n) {
    return new $6f291e234003fc86$var$ss(t, e, n);
}
function $6f291e234003fc86$var$os(t, e) {
    let n = e.__key, r = t.offset, s = "element";
    if ($6f291e234003fc86$export$471953706258be2b(e)) {
        s = "text";
        const t = e.getTextContentSize();
        r > t && (r = t);
    } else if (!$6f291e234003fc86$export$923a058ef54437a4(e)) {
        const t = e.getNextSibling();
        if ($6f291e234003fc86$export$471953706258be2b(t)) n = t.__key, r = 0, s = "text";
        else {
            const t = e.getParent();
            t && (n = t.__key, r = e.getIndexWithinParent() + 1);
        }
    }
    t.set(n, r, s);
}
function $6f291e234003fc86$var$ls(t, e) {
    if ($6f291e234003fc86$export$923a058ef54437a4(e)) {
        const n = e.getLastDescendant();
        $6f291e234003fc86$export$923a058ef54437a4(n) || $6f291e234003fc86$export$471953706258be2b(n) ? $6f291e234003fc86$var$os(t, n) : $6f291e234003fc86$var$os(t, e);
    } else $6f291e234003fc86$var$os(t, e);
}
function $6f291e234003fc86$var$cs(t, e, n, r) {
    t.key = e, t.offset = n, t.type = r;
}
class $6f291e234003fc86$var$as {
    constructor(t){
        this._cachedNodes = null, this._nodes = t, this.dirty = !1;
    }
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(t) {
        this._cachedNodes = t;
    }
    is(t) {
        if (!$6f291e234003fc86$export$7257e4181651a7c3(t)) return !1;
        const e = this._nodes, n = t._nodes;
        return e.size === n.size && Array.from(e).every((t)=>n.has(t));
    }
    isCollapsed() {
        return !1;
    }
    isBackward() {
        return !1;
    }
    getStartEndPoints() {
        return null;
    }
    add(t) {
        this.dirty = !0, this._nodes.add(t), this._cachedNodes = null;
    }
    delete(t) {
        this.dirty = !0, this._nodes.delete(t), this._cachedNodes = null;
    }
    clear() {
        this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
    }
    has(t) {
        return this._nodes.has(t);
    }
    clone() {
        return new $6f291e234003fc86$var$as(new Set(this._nodes));
    }
    extract() {
        return this.getNodes();
    }
    insertRawText(t) {}
    insertText() {}
    insertNodes(t) {
        const e = this.getNodes(), n = e.length, r = e[n - 1];
        let s;
        if ($6f291e234003fc86$export$471953706258be2b(r)) s = r.select();
        else {
            const t = r.getIndexWithinParent() + 1;
            s = r.getParentOrThrow().select(t, t);
        }
        s.insertNodes(t);
        for(let t = 0; t < n; t++)e[t].remove();
    }
    getNodes() {
        const t = this._cachedNodes;
        if (null !== t) return t;
        const e = this._nodes, n = [];
        for (const t of e){
            const e = $6f291e234003fc86$export$e725f93d4d48c6d8(t);
            null !== e && n.push(e);
        }
        return $6f291e234003fc86$export$761df28585b755e8() || (this._cachedNodes = n), n;
    }
    getTextContent() {
        const t = this.getNodes();
        let e = "";
        for(let n = 0; n < t.length; n++)e += t[n].getTextContent();
        return e;
    }
}
function $6f291e234003fc86$export$181b63acea8a0224(t) {
    return t instanceof $6f291e234003fc86$var$fs;
}
class $6f291e234003fc86$var$fs {
    constructor(t, e, n, r){
        this.anchor = t, this.focus = e, t._selection = this, e._selection = this, this._cachedNodes = null, this.format = n, this.style = r, this.dirty = !1;
    }
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(t) {
        this._cachedNodes = t;
    }
    is(t) {
        return !!$6f291e234003fc86$export$181b63acea8a0224(t) && this.anchor.is(t.anchor) && this.focus.is(t.focus) && this.format === t.format && this.style === t.style;
    }
    isCollapsed() {
        return this.anchor.is(this.focus);
    }
    getNodes() {
        const t = this._cachedNodes;
        if (null !== t) return t;
        const e = this.anchor, n = this.focus, r = e.isBefore(n), s = r ? e : n, i = r ? n : e;
        let o = s.getNode(), l = i.getNode();
        const c = s.offset, a = i.offset;
        if ($6f291e234003fc86$export$923a058ef54437a4(o)) {
            const t = o.getDescendantByIndex(c);
            o = null != t ? t : o;
        }
        if ($6f291e234003fc86$export$923a058ef54437a4(l)) {
            let t = l.getDescendantByIndex(a);
            null !== t && t !== o && l.getChildAtIndex(a) === t && (t = t.getPreviousSibling()), l = null != t ? t : l;
        }
        let u;
        return u = o.is(l) ? $6f291e234003fc86$export$923a058ef54437a4(o) && o.getChildrenSize() > 0 ? [] : [
            o
        ] : o.getNodesBetween(l), $6f291e234003fc86$export$761df28585b755e8() || (this._cachedNodes = u), u;
    }
    setTextNodeRange(t, e, n, r) {
        $6f291e234003fc86$var$cs(this.anchor, t.__key, e, "text"), $6f291e234003fc86$var$cs(this.focus, n.__key, r, "text"), this._cachedNodes = null, this.dirty = !0;
    }
    getTextContent() {
        const t = this.getNodes();
        if (0 === t.length) return "";
        const e = t[0], n = t[t.length - 1], r = this.anchor, s = this.focus, i = r.isBefore(s), [o, l] = $6f291e234003fc86$export$5a33b5b9a9d5db8f(this);
        let c = "", a = !0;
        for(let u = 0; u < t.length; u++){
            const f = t[u];
            if ($6f291e234003fc86$export$923a058ef54437a4(f) && !f.isInline()) a || (c += "\n"), a = !f.isEmpty();
            else if (a = !1, $6f291e234003fc86$export$471953706258be2b(f)) {
                let t = f.getTextContent();
                f === e ? f === n ? "element" === r.type && "element" === s.type && s.offset !== r.offset || (t = o < l ? t.slice(o, l) : t.slice(l, o)) : t = i ? t.slice(o) : t.slice(l) : f === n && (t = i ? t.slice(0, l) : t.slice(0, o)), c += t;
            } else !$6f291e234003fc86$export$60aa03725ce41b1c(f) && !$6f291e234003fc86$export$b16330e40aa25c4e(f) || f === n && this.isCollapsed() || (c += f.getTextContent());
        }
        return c;
    }
    applyDOMRange(t) {
        const e = $6f291e234003fc86$var$js(), n = e.getEditorState()._selection, r = $6f291e234003fc86$var$xs(t.startContainer, t.startOffset, t.endContainer, t.endOffset, e, n);
        if (null === r) return;
        const [s, i] = r;
        $6f291e234003fc86$var$cs(this.anchor, s.key, s.offset, s.type), $6f291e234003fc86$var$cs(this.focus, i.key, i.offset, i.type), this._cachedNodes = null;
    }
    clone() {
        const t = this.anchor, e = this.focus;
        return new $6f291e234003fc86$var$fs($6f291e234003fc86$export$9b3f8d373c057995(t.key, t.offset, t.type), $6f291e234003fc86$export$9b3f8d373c057995(e.key, e.offset, e.type), this.format, this.style);
    }
    toggleFormat(t) {
        this.format = $6f291e234003fc86$var$de(this.format, t, null), this.dirty = !0;
    }
    setStyle(t) {
        this.style = t, this.dirty = !0;
    }
    hasFormat(t) {
        const e = $6f291e234003fc86$export$c9e7d6eb65b13430[t];
        return !!(this.format & e);
    }
    insertRawText(t) {
        const e = t.split(/(\r?\n|\t)/), n = [], r = e.length;
        for(let t = 0; t < r; t++){
            const r = e[t];
            "\n" === r || "\r\n" === r ? n.push($6f291e234003fc86$export$4ccaf7d0d16ab4c()) : "\t" === r ? n.push($6f291e234003fc86$export$5bde9d58a1da0796()) : n.push($6f291e234003fc86$export$2785f39dcdec0078(r));
        }
        this.insertNodes(n);
    }
    insertText(t) {
        const e = this.anchor, n = this.focus, r = this.format, s = this.style;
        let i = e, o = n;
        !this.isCollapsed() && n.isBefore(e) && (i = n, o = e), "element" === i.type && function(t, e, n, r) {
            const s = t.getNode(), i = s.getChildAtIndex(t.offset), o = $6f291e234003fc86$export$2785f39dcdec0078(), l = $6f291e234003fc86$export$5b29ca560c2fedab(s) ? $6f291e234003fc86$export$7f0c05ffb7ced90d().append(o) : o;
            o.setFormat(n), o.setStyle(r), null === i ? s.append(l) : i.insertBefore(l), t.is(e) && e.set(o.__key, 0, "text"), t.set(o.__key, 0, "text");
        }(i, o, r, s);
        const l = i.offset;
        let c = o.offset;
        const a = this.getNodes(), u = a.length;
        let f = a[0];
        $6f291e234003fc86$export$471953706258be2b(f) || $6f291e234003fc86$var$Rt(26);
        const d = f.getTextContent().length, h = f.getParentOrThrow();
        let g = a[u - 1];
        if (1 === u && "element" === o.type && (c = d, o.set(i.key, c, "text")), this.isCollapsed() && l === d && (f.isSegmented() || f.isToken() || !f.canInsertTextAfter() || !h.canInsertTextAfter() && null === f.getNextSibling())) {
            let e = f.getNextSibling();
            if ($6f291e234003fc86$export$471953706258be2b(e) && e.canInsertTextBefore() && !$6f291e234003fc86$var$ae(e) || (e = $6f291e234003fc86$export$2785f39dcdec0078(), e.setFormat(r), e.setStyle(s), h.canInsertTextAfter() ? f.insertAfter(e) : h.insertAfter(e)), e.select(0, 0), f = e, "" !== t) return void this.insertText(t);
        } else if (this.isCollapsed() && 0 === l && (f.isSegmented() || f.isToken() || !f.canInsertTextBefore() || !h.canInsertTextBefore() && null === f.getPreviousSibling())) {
            let e = f.getPreviousSibling();
            if ($6f291e234003fc86$export$471953706258be2b(e) && !$6f291e234003fc86$var$ae(e) || (e = $6f291e234003fc86$export$2785f39dcdec0078(), e.setFormat(r), h.canInsertTextBefore() ? f.insertBefore(e) : h.insertBefore(e)), e.select(), f = e, "" !== t) return void this.insertText(t);
        } else if (f.isSegmented() && l !== d) {
            const t = $6f291e234003fc86$export$2785f39dcdec0078(f.getTextContent());
            t.setFormat(r), f.replace(t), f = t;
        } else if (!this.isCollapsed() && "" !== t) {
            const e = g.getParent();
            if (!h.canInsertTextBefore() || !h.canInsertTextAfter() || $6f291e234003fc86$export$923a058ef54437a4(e) && (!e.canInsertTextBefore() || !e.canInsertTextAfter())) return this.insertText(""), $6f291e234003fc86$var$ms(this.anchor, this.focus, null), void this.insertText(t);
        }
        if (1 === u) {
            if (f.isToken()) {
                const e = $6f291e234003fc86$export$2785f39dcdec0078(t);
                return e.select(), void f.replace(e);
            }
            const e = f.getFormat(), n = f.getStyle();
            if (l !== c || e === r && n === s) {
                if ($6f291e234003fc86$export$ac9141efa5fb7932(f)) {
                    const e = $6f291e234003fc86$export$2785f39dcdec0078(t);
                    return e.setFormat(r), e.setStyle(s), e.select(), void f.replace(e);
                }
            } else {
                if ("" !== f.getTextContent()) {
                    const e = $6f291e234003fc86$export$2785f39dcdec0078(t);
                    if (e.setFormat(r), e.setStyle(s), e.select(), 0 === l) f.insertBefore(e, !1);
                    else {
                        const [t] = f.splitText(l);
                        t.insertAfter(e, !1);
                    }
                    return void (e.isComposing() && "text" === this.anchor.type && (this.anchor.offset -= t.length));
                }
                f.setFormat(r), f.setStyle(s);
            }
            const i = c - l;
            f = f.spliceText(l, i, t, !0), "" === f.getTextContent() ? f.remove() : "text" === this.anchor.type && (f.isComposing() ? this.anchor.offset -= t.length : (this.format = e, this.style = n));
        } else {
            const e = new Set([
                ...f.getParentKeys(),
                ...g.getParentKeys()
            ]), n = $6f291e234003fc86$export$923a058ef54437a4(f) ? f : f.getParentOrThrow();
            let r = $6f291e234003fc86$export$923a058ef54437a4(g) ? g : g.getParentOrThrow(), s = g;
            if (!n.is(r) && r.isInline()) do s = r, r = r.getParentOrThrow();
            while (r.isInline());
            if ("text" === o.type && (0 !== c || "" === g.getTextContent()) || "element" === o.type && g.getIndexWithinParent() < c) {
                if ($6f291e234003fc86$export$471953706258be2b(g) && !g.isToken() && c !== g.getTextContentSize()) {
                    if (g.isSegmented()) {
                        const t = $6f291e234003fc86$export$2785f39dcdec0078(g.getTextContent());
                        g.replace(t), g = t;
                    }
                    $6f291e234003fc86$export$5b29ca560c2fedab(o.getNode()) || "text" !== o.type || (g = g.spliceText(0, c, "")), e.add(g.__key);
                } else {
                    const t = g.getParentOrThrow();
                    t.canBeEmpty() || 1 !== t.getChildrenSize() ? g.remove() : t.remove();
                }
            } else e.add(g.__key);
            const i = r.getChildren(), h = new Set(a), _ = n.is(r), p = n.isInline() && null === f.getNextSibling() ? n : f;
            for(let t = i.length - 1; t >= 0; t--){
                const e = i[t];
                if (e.is(f) || $6f291e234003fc86$export$923a058ef54437a4(e) && e.isParentOf(f)) break;
                e.isAttached() && (!h.has(e) || e.is(s) ? _ || p.insertAfter(e, !1) : e.remove());
            }
            if (!_) {
                let t = r, n = null;
                for(; null !== t;){
                    const r = t.getChildren(), s = r.length;
                    (0 === s || r[s - 1].is(n)) && (e.delete(t.__key), n = t), t = t.getParent();
                }
            }
            if (f.isToken()) {
                if (l === d) f.select();
                else {
                    const e = $6f291e234003fc86$export$2785f39dcdec0078(t);
                    e.select(), f.replace(e);
                }
            } else f = f.spliceText(l, d - l, t, !0), "" === f.getTextContent() ? f.remove() : f.isComposing() && "text" === this.anchor.type && (this.anchor.offset -= t.length);
            for(let t = 1; t < u; t++){
                const n = a[t], r = n.__key;
                e.has(r) || n.remove();
            }
        }
    }
    removeText() {
        this.insertText("");
    }
    formatText(t) {
        if (this.isCollapsed()) return this.toggleFormat(t), void $6f291e234003fc86$export$ea25f5ef71f2d042(null);
        const e = this.getNodes(), n = [];
        for (const t of e)$6f291e234003fc86$export$471953706258be2b(t) && n.push(t);
        const r = n.length;
        if (0 === r) return this.toggleFormat(t), void $6f291e234003fc86$export$ea25f5ef71f2d042(null);
        const s = this.anchor, i = this.focus, o = this.isBackward(), l = o ? i : s, c = o ? s : i;
        let a = 0, u = n[0], f = "element" === l.type ? 0 : l.offset;
        if ("text" === l.type && f === u.getTextContentSize() && (a = 1, u = n[1], f = 0), null == u) return;
        const d = u.getFormatFlags(t, null), h = r - 1;
        let g = n[h];
        const _ = "text" === c.type ? c.offset : g.getTextContentSize();
        if (u.is(g)) {
            if (f === _) return;
            if ($6f291e234003fc86$var$ae(u) || 0 === f && _ === u.getTextContentSize()) u.setFormat(d);
            else {
                const t = u.splitText(f, _), e = 0 === f ? t[0] : t[1];
                e.setFormat(d), "text" === l.type && l.set(e.__key, 0, "text"), "text" === c.type && c.set(e.__key, _ - f, "text");
            }
            return void (this.format = d);
        }
        0 === f || $6f291e234003fc86$var$ae(u) || ([, u] = u.splitText(f), f = 0), u.setFormat(d);
        const p = g.getFormatFlags(t, d);
        _ > 0 && (_ === g.getTextContentSize() || $6f291e234003fc86$var$ae(g) || ([g] = g.splitText(_)), g.setFormat(p));
        for(let e = a + 1; e < h; e++){
            const r = n[e], s = r.getFormatFlags(t, p);
            r.setFormat(s);
        }
        "text" === l.type && l.set(u.__key, f, "text"), "text" === c.type && c.set(g.__key, _, "text"), this.format = d | p;
    }
    insertNodes(t) {
        if (0 === t.length) return;
        if ("root" === this.anchor.key) {
            this.insertParagraph();
            const e = $6f291e234003fc86$export$63a3201b3a5c7d90();
            return $6f291e234003fc86$export$181b63acea8a0224(e) || $6f291e234003fc86$var$Rt(134), e.insertNodes(t);
        }
        const e = $6f291e234003fc86$var$Cn((this.isBackward() ? this.focus : this.anchor).getNode(), $6f291e234003fc86$var$Tn), n = t[t.length - 1];
        if ("__language" in e && $6f291e234003fc86$export$923a058ef54437a4(e)) {
            if ("__language" in t[0]) this.insertText(t[0].getTextContent());
            else {
                const r = $6f291e234003fc86$var$As(this);
                e.splice(r, 0, t), n.selectEnd();
            }
            return;
        }
        if (!t.some((t)=>($6f291e234003fc86$export$923a058ef54437a4(t) || $6f291e234003fc86$export$60aa03725ce41b1c(t)) && !t.isInline())) {
            $6f291e234003fc86$export$923a058ef54437a4(e) || $6f291e234003fc86$var$Rt(135);
            const r = $6f291e234003fc86$var$As(this);
            return e.splice(r, 0, t), void n.selectEnd();
        }
        const r = function(t) {
            const e = $6f291e234003fc86$export$7f0c05ffb7ced90d();
            let n = null;
            for(let r = 0; r < t.length; r++){
                const s = t[r], i = $6f291e234003fc86$export$b16330e40aa25c4e(s);
                if (i || $6f291e234003fc86$export$60aa03725ce41b1c(s) && s.isInline() || $6f291e234003fc86$export$923a058ef54437a4(s) && s.isInline() || $6f291e234003fc86$export$471953706258be2b(s) || s.isParentRequired()) {
                    if (null === n && (n = s.createParentElementNode(), e.append(n), i)) continue;
                    null !== n && n.append(s);
                } else e.append(s), n = null;
            }
            return e;
        }(t), s = r.getLastDescendant(), i = r.getChildren(), o = (t)=>"__value" in t && "__checked" in t, l = !$6f291e234003fc86$export$923a058ef54437a4(e) || !e.isEmpty() ? this.insertParagraph() : null, c = i[i.length - 1];
        let a = i[0];
        var u;
        $6f291e234003fc86$export$923a058ef54437a4(u = a) && $6f291e234003fc86$var$Tn(u) && !u.isEmpty() && $6f291e234003fc86$export$923a058ef54437a4(e) && (!e.isEmpty() || o(e)) && ($6f291e234003fc86$export$923a058ef54437a4(e) || $6f291e234003fc86$var$Rt(135), e.append(...a.getChildren()), a = i[1]), a && function(t, e, n) {
            const r = e.getParentOrThrow().getLastChild();
            let s = e;
            const i = [
                e
            ];
            for(; s !== r;)s.getNextSibling() || $6f291e234003fc86$var$Rt(140), s = s.getNextSibling(), i.push(s);
            let o = t;
            for (const t of i)o = o.insertAfter(t);
        }(e, a);
        const f = $6f291e234003fc86$var$Cn(s, $6f291e234003fc86$var$Tn);
        l && $6f291e234003fc86$export$923a058ef54437a4(f) && (o(l) || $6f291e234003fc86$var$Tn(c)) && (f.append(...l.getChildren()), l.remove()), $6f291e234003fc86$export$923a058ef54437a4(e) && e.isEmpty() && e.remove(), s.selectEnd();
        const d = $6f291e234003fc86$export$923a058ef54437a4(e) ? e.getLastChild() : null;
        $6f291e234003fc86$export$b16330e40aa25c4e(d) && f !== e && d.remove();
    }
    insertParagraph() {
        if ("root" === this.anchor.key) {
            const t = $6f291e234003fc86$export$7f0c05ffb7ced90d();
            return $6f291e234003fc86$export$8d83ea843c4eea9a().splice(this.anchor.offset, 0, [
                t
            ]), t.select(), t;
        }
        const t = $6f291e234003fc86$var$As(this), e = $6f291e234003fc86$var$Cn(this.anchor.getNode(), $6f291e234003fc86$var$Tn);
        $6f291e234003fc86$export$923a058ef54437a4(e) || $6f291e234003fc86$var$Rt(136);
        const n = e.getChildAtIndex(t), r = n ? [
            n,
            ...n.getNextSiblings()
        ] : [], s = e.insertNewAfter(this, !1);
        return s ? (s.append(...r), s.selectStart(), s) : null;
    }
    insertLineBreak(t) {
        const e = $6f291e234003fc86$export$4ccaf7d0d16ab4c();
        if (this.insertNodes([
            e
        ]), t) {
            const t = e.getParentOrThrow(), n = e.getIndexWithinParent();
            t.select(n, n);
        }
    }
    extract() {
        const t = this.getNodes(), e = t.length, n = e - 1, r = this.anchor, s = this.focus;
        let i = t[0], o = t[n];
        const [l, c] = $6f291e234003fc86$export$5a33b5b9a9d5db8f(this);
        if (0 === e) return [];
        if (1 === e) {
            if ($6f291e234003fc86$export$471953706258be2b(i) && !this.isCollapsed()) {
                const t = l > c ? c : l, e = l > c ? l : c, n = i.splitText(t, e), r = 0 === t ? n[0] : n[1];
                return null != r ? [
                    r
                ] : [];
            }
            return [
                i
            ];
        }
        const a = r.isBefore(s);
        if ($6f291e234003fc86$export$471953706258be2b(i)) {
            const e = a ? l : c;
            e === i.getTextContentSize() ? t.shift() : 0 !== e && ([, i] = i.splitText(e), t[0] = i);
        }
        if ($6f291e234003fc86$export$471953706258be2b(o)) {
            const e = o.getTextContent().length, r = a ? c : l;
            0 === r ? t.pop() : r !== e && ([o] = o.splitText(r), t[n] = o);
        }
        return t;
    }
    modify(t, e, n) {
        const r = this.focus, s = this.anchor, i = "move" === t, o = $6f291e234003fc86$export$c4b907be1879d8c1(r, e);
        if ($6f291e234003fc86$export$60aa03725ce41b1c(o) && !o.isIsolated()) {
            if (i && o.isKeyboardSelectable()) {
                const t = $6f291e234003fc86$export$f8cd0c3f35d1a61c();
                return t.add(o.__key), void $6f291e234003fc86$export$2aad78c37810bca9(t);
            }
            const t = e ? o.getPreviousSibling() : o.getNextSibling();
            if ($6f291e234003fc86$export$471953706258be2b(t)) {
                const n = t.__key, o = e ? t.getTextContent().length : 0;
                return r.set(n, o, "text"), void (i && s.set(n, o, "text"));
            }
            {
                const n = o.getParentOrThrow();
                let l, c;
                return $6f291e234003fc86$export$923a058ef54437a4(t) ? (c = t.__key, l = e ? t.getChildrenSize() : 0) : (l = o.getIndexWithinParent(), c = n.__key, e || l++), r.set(c, l, "element"), void (i && s.set(c, l, "element"));
            }
        }
        const l = $6f291e234003fc86$var$js(), c = $6f291e234003fc86$var$_n(l._window);
        if (!c) return;
        const a = l._blockCursorElement, u = l._rootElement;
        if (null === u || null === a || !$6f291e234003fc86$export$923a058ef54437a4(o) || o.isInline() || o.canBeEmpty() || $6f291e234003fc86$var$hn(a, l, u), function(t, e, n, r) {
            t.modify(e, n, r);
        }(c, t, e ? "backward" : "forward", n), c.rangeCount > 0) {
            const t = c.getRangeAt(0), n = this.anchor.getNode(), r = $6f291e234003fc86$export$5b29ca560c2fedab(n) ? n : $6f291e234003fc86$export$6f13c476561e4734(n);
            if (this.applyDOMRange(t), this.dirty = !0, !i) {
                const n = this.getNodes(), s = [];
                let i = !1;
                for(let t = 0; t < n.length; t++){
                    const e = n[t];
                    $6f291e234003fc86$export$e3d4b782f65c81f1(e, r) ? s.push(e) : i = !0;
                }
                if (i && s.length > 0) {
                    if (e) {
                        const t = s[0];
                        $6f291e234003fc86$export$923a058ef54437a4(t) ? t.selectStart() : t.getParentOrThrow().selectStart();
                    } else {
                        const t = s[s.length - 1];
                        $6f291e234003fc86$export$923a058ef54437a4(t) ? t.selectEnd() : t.getParentOrThrow().selectEnd();
                    }
                }
                c.anchorNode === t.startContainer && c.anchorOffset === t.startOffset || function(t) {
                    const e = t.focus, n = t.anchor, r = n.key, s = n.offset, i = n.type;
                    $6f291e234003fc86$var$cs(n, e.key, e.offset, e.type), $6f291e234003fc86$var$cs(e, r, s, i), t._cachedNodes = null;
                }(this);
            }
        }
    }
    forwardDeletion(t, e, n) {
        if (!n && ("element" === t.type && $6f291e234003fc86$export$923a058ef54437a4(e) && t.offset === e.getChildrenSize() || "text" === t.type && t.offset === e.getTextContentSize())) {
            const t = e.getParent(), n = e.getNextSibling() || (null === t ? null : t.getNextSibling());
            if ($6f291e234003fc86$export$923a058ef54437a4(n) && n.isShadowRoot()) return !0;
        }
        return !1;
    }
    deleteCharacter(t) {
        const n = this.isCollapsed();
        if (this.isCollapsed()) {
            const n = this.anchor;
            let r = n.getNode();
            if (this.forwardDeletion(n, r, t)) return;
            const s = this.focus, i = $6f291e234003fc86$export$c4b907be1879d8c1(s, t);
            if ($6f291e234003fc86$export$60aa03725ce41b1c(i) && !i.isIsolated()) {
                if (i.isKeyboardSelectable() && $6f291e234003fc86$export$923a058ef54437a4(r) && 0 === r.getChildrenSize()) {
                    r.remove();
                    const t = $6f291e234003fc86$export$f8cd0c3f35d1a61c();
                    t.add(i.__key), $6f291e234003fc86$export$2aad78c37810bca9(t);
                } else {
                    i.remove();
                    $6f291e234003fc86$var$js().dispatchCommand($6f291e234003fc86$export$e396fef71d2b56e5, void 0);
                }
                return;
            }
            if (!t && $6f291e234003fc86$export$923a058ef54437a4(i) && $6f291e234003fc86$export$923a058ef54437a4(r) && r.isEmpty()) return r.remove(), void i.selectStart();
            if (this.modify("extend", t, "character"), this.isCollapsed()) {
                if (t && 0 === n.offset) {
                    if (("element" === n.type ? n.getNode() : n.getNode().getParentOrThrow()).collapseAtStart(this)) return;
                }
            } else {
                const e = "text" === s.type ? s.getNode() : null;
                if (r = "text" === n.type ? n.getNode() : null, null !== e && e.isSegmented()) {
                    const n = s.offset, i = e.getTextContentSize();
                    if (e.is(r) || t && n !== i || !t && 0 !== n) return void $6f291e234003fc86$var$_s(e, t, n);
                } else if (null !== r && r.isSegmented()) {
                    const s = n.offset, i = r.getTextContentSize();
                    if (r.is(e) || t && 0 !== s || !t && s !== i) return void $6f291e234003fc86$var$_s(r, t, s);
                }
                !function(t, e) {
                    const n = t.anchor, r = t.focus, s = n.getNode(), i = r.getNode();
                    if (s === i && "text" === n.type && "text" === r.type) {
                        const t = n.offset, i = r.offset, o = t < i, l = o ? t : i, c = o ? i : t, a = c - 1;
                        if (l !== a) $6f291e234003fc86$var$Pe(s.getTextContent().slice(l, c)) || (e ? r.offset = a : n.offset = a);
                    }
                }(this, t);
            }
        }
        if (this.removeText(), t && !n && this.isCollapsed() && "element" === this.anchor.type && 0 === this.anchor.offset) {
            const t = this.anchor.getNode();
            t.isEmpty() && $6f291e234003fc86$export$5b29ca560c2fedab(t.getParent()) && 0 === t.getIndexWithinParent() && t.collapseAtStart(this);
        }
    }
    deleteLine(t) {
        if (this.isCollapsed()) {
            const e = "element" === this.anchor.type;
            e && this.insertText(" "), this.modify("extend", t, "lineboundary");
            if (0 === (t ? this.focus : this.anchor).offset && this.modify("extend", t, "character"), e) {
                const e = t ? this.anchor : this.focus;
                e.set(e.key, e.offset + 1, e.type);
            }
        }
        this.removeText();
    }
    deleteWord(t) {
        if (this.isCollapsed()) {
            const e = this.anchor, n = e.getNode();
            if (this.forwardDeletion(e, n, t)) return;
            this.modify("extend", t, "word");
        }
        this.removeText();
    }
    isBackward() {
        return this.focus.isBefore(this.anchor);
    }
    getStartEndPoints() {
        return [
            this.anchor,
            this.focus
        ];
    }
}
function $6f291e234003fc86$export$7257e4181651a7c3(t) {
    return t instanceof $6f291e234003fc86$var$as;
}
function $6f291e234003fc86$var$hs(t) {
    const e = t.offset;
    if ("text" === t.type) return e;
    const n = t.getNode();
    return e === n.getChildrenSize() ? n.getTextContent().length : 0;
}
function $6f291e234003fc86$export$5a33b5b9a9d5db8f(t) {
    const e = t.getStartEndPoints();
    if (null === e) return [
        0,
        0
    ];
    const [n, r] = e;
    return "element" === n.type && "element" === r.type && n.key === r.key && n.offset === r.offset ? [
        0,
        0
    ] : [
        $6f291e234003fc86$var$hs(n),
        $6f291e234003fc86$var$hs(r)
    ];
}
function $6f291e234003fc86$var$_s(t, e, n) {
    const r = t, s = r.getTextContent().split(/(?=\s)/g), i = s.length;
    let o = 0, l = 0;
    for(let t = 0; t < i; t++){
        const r = t === i - 1;
        if (l = o, o += s[t].length, e && o === n || o > n || r) {
            s.splice(t, 1), r && (l = void 0);
            break;
        }
    }
    const c = s.join("").trim();
    "" === c ? r.remove() : (r.setTextContent(c), r.select(l, l));
}
function $6f291e234003fc86$var$ps(t, e, n, r) {
    let s, i = e;
    if (t.nodeType === $6f291e234003fc86$var$rt) {
        let o = !1;
        const l = t.childNodes, c = l.length, a = r._blockCursorElement;
        i === c && (o = !0, i = c - 1);
        let u = l[i], f = !1;
        if (u === a) u = l[i + 1], f = !0;
        else if (null !== a) {
            const n = a.parentNode;
            if (t === n) e > Array.prototype.indexOf.call(n.children, a) && i--;
        }
        if (s = $6f291e234003fc86$var$Ne(u), $6f291e234003fc86$export$471953706258be2b(s)) i = $6f291e234003fc86$var$Ee(s, o);
        else {
            let r = $6f291e234003fc86$var$Ne(t);
            if (null === r) return null;
            if ($6f291e234003fc86$export$923a058ef54437a4(r)) {
                i = Math.min(r.getChildrenSize(), i);
                let t = r.getChildAtIndex(i);
                if ($6f291e234003fc86$export$923a058ef54437a4(t) && function(t, e, n) {
                    const r = t.getParent();
                    return null === n || null === r || !r.canBeEmpty() || r !== n.getNode();
                }(t, 0, n)) {
                    const e = o ? t.getLastDescendant() : t.getFirstDescendant();
                    null === e ? r = t : (t = e, r = $6f291e234003fc86$export$923a058ef54437a4(t) ? t : t.getParentOrThrow()), i = 0;
                }
                $6f291e234003fc86$export$471953706258be2b(t) ? (s = t, r = null, i = $6f291e234003fc86$var$Ee(t, o)) : t !== r && o && !f && i++;
            } else {
                const n = r.getIndexWithinParent();
                i = 0 === e && $6f291e234003fc86$export$60aa03725ce41b1c(r) && $6f291e234003fc86$var$Ne(t) === r ? n : n + 1, r = r.getParentOrThrow();
            }
            if ($6f291e234003fc86$export$923a058ef54437a4(r)) return $6f291e234003fc86$export$9b3f8d373c057995(r.__key, i, "element");
        }
    } else s = $6f291e234003fc86$var$Ne(t);
    return $6f291e234003fc86$export$471953706258be2b(s) ? $6f291e234003fc86$export$9b3f8d373c057995(s.__key, i, "text") : null;
}
function $6f291e234003fc86$var$ys(t, e, n) {
    const r = t.offset, s = t.getNode();
    if (0 === r) {
        const r = s.getPreviousSibling(), i = s.getParent();
        if (e) {
            if ((n || !e) && null === r && $6f291e234003fc86$export$923a058ef54437a4(i) && i.isInline()) {
                const e = i.getPreviousSibling();
                $6f291e234003fc86$export$471953706258be2b(e) && (t.key = e.__key, t.offset = e.getTextContent().length);
            }
        } else $6f291e234003fc86$export$923a058ef54437a4(r) && !n && r.isInline() ? (t.key = r.__key, t.offset = r.getChildrenSize(), t.type = "element") : $6f291e234003fc86$export$471953706258be2b(r) && (t.key = r.__key, t.offset = r.getTextContent().length);
    } else if (r === s.getTextContent().length) {
        const r = s.getNextSibling(), i = s.getParent();
        if (e && $6f291e234003fc86$export$923a058ef54437a4(r) && r.isInline()) t.key = r.__key, t.offset = 0, t.type = "element";
        else if ((n || e) && null === r && $6f291e234003fc86$export$923a058ef54437a4(i) && i.isInline() && !i.canInsertTextAfter()) {
            const e = i.getNextSibling();
            $6f291e234003fc86$export$471953706258be2b(e) && (t.key = e.__key, t.offset = 0);
        }
    }
}
function $6f291e234003fc86$var$ms(t, e, n) {
    if ("text" === t.type && "text" === e.type) {
        const r = t.isBefore(e), s = t.is(e);
        $6f291e234003fc86$var$ys(t, r, s), $6f291e234003fc86$var$ys(e, !r, s), s && (e.key = t.key, e.offset = t.offset, e.type = t.type);
        const i = $6f291e234003fc86$var$js();
        if (i.isComposing() && i._compositionKey !== t.key && $6f291e234003fc86$export$181b63acea8a0224(n)) {
            const r = n.anchor, s = n.focus;
            $6f291e234003fc86$var$cs(t, r.key, r.offset, r.type), $6f291e234003fc86$var$cs(e, s.key, s.offset, s.type);
        }
    }
}
function $6f291e234003fc86$var$xs(t, e, n, r, s, i) {
    if (null === t || null === n || !$6f291e234003fc86$export$f1b377b21cd6350b(s, t, n)) return null;
    const o = $6f291e234003fc86$var$ps(t, e, $6f291e234003fc86$export$181b63acea8a0224(i) ? i.anchor : null, s);
    if (null === o) return null;
    const l = $6f291e234003fc86$var$ps(n, r, $6f291e234003fc86$export$181b63acea8a0224(i) ? i.focus : null, s);
    if (null === l) return null;
    if ("element" === o.type && "element" === l.type) {
        const e = $6f291e234003fc86$var$Ne(t), r = $6f291e234003fc86$var$Ne(n);
        if ($6f291e234003fc86$export$60aa03725ce41b1c(e) && $6f291e234003fc86$export$60aa03725ce41b1c(r)) return null;
    }
    return $6f291e234003fc86$var$ms(o, l, i), [
        o,
        l
    ];
}
function $6f291e234003fc86$export$de078facd4ee1560(t) {
    return $6f291e234003fc86$export$923a058ef54437a4(t) && !t.isInline();
}
function $6f291e234003fc86$var$Ts(t, e, n, r, s, i) {
    const o = $6f291e234003fc86$var$Hs(), l = new $6f291e234003fc86$var$fs($6f291e234003fc86$export$9b3f8d373c057995(t, e, s), $6f291e234003fc86$export$9b3f8d373c057995(n, r, i), 0, "");
    return l.dirty = !0, o._selection = l, l;
}
function $6f291e234003fc86$export$1ccc217b9831b072() {
    const t = $6f291e234003fc86$export$9b3f8d373c057995("root", 0, "element"), e = $6f291e234003fc86$export$9b3f8d373c057995("root", 0, "element");
    return new $6f291e234003fc86$var$fs(t, e, 0, "");
}
function $6f291e234003fc86$export$f8cd0c3f35d1a61c() {
    return new $6f291e234003fc86$var$as(new Set);
}
function $6f291e234003fc86$export$68ac2b736ac647aa(t, e) {
    return $6f291e234003fc86$var$bs(null, t, e, null);
}
function $6f291e234003fc86$var$bs(t, e, n, r) {
    const s = n._window;
    if (null === s) return null;
    const i = r || s.event, o = i ? i.type : void 0, l = "selectionchange" === o, c = !$6f291e234003fc86$var$Ut && (l || "beforeinput" === o || "compositionstart" === o || "compositionend" === o || "click" === o && i && 3 === i.detail || "drop" === o || void 0 === o);
    let a, u, f, d;
    if ($6f291e234003fc86$export$181b63acea8a0224(t) && !c) return t.clone();
    if (null === e) return null;
    if (a = e.anchorNode, u = e.focusNode, f = e.anchorOffset, d = e.focusOffset, l && $6f291e234003fc86$export$181b63acea8a0224(t) && !$6f291e234003fc86$export$f1b377b21cd6350b(n, a, u)) return t.clone();
    const h = $6f291e234003fc86$var$xs(a, f, u, d, n, t);
    if (null === h) return null;
    const [g, _] = h;
    return new $6f291e234003fc86$var$fs(g, _, $6f291e234003fc86$export$181b63acea8a0224(t) ? t.format : 0, $6f291e234003fc86$export$181b63acea8a0224(t) ? t.style : "");
}
function $6f291e234003fc86$export$63a3201b3a5c7d90() {
    return $6f291e234003fc86$var$Hs()._selection;
}
function $6f291e234003fc86$export$846e9407a8b5d98c() {
    return $6f291e234003fc86$var$js()._editorState._selection;
}
function $6f291e234003fc86$var$Es(t, e, n, r = 1) {
    const s = t.anchor, i = t.focus, o = s.getNode(), l = i.getNode();
    if (!e.is(o) && !e.is(l)) return;
    const c = e.__key;
    if (t.isCollapsed()) {
        const e = s.offset;
        if (n <= e && r > 0 || n < e && r < 0) {
            const n = Math.max(0, e + r);
            s.set(c, n, "element"), i.set(c, n, "element"), $6f291e234003fc86$var$Ps(t);
        }
    } else {
        const o = t.isBackward(), l = o ? i : s, a = l.getNode(), u = o ? s : i, f = u.getNode();
        if (e.is(a)) {
            const t = l.offset;
            (n <= t && r > 0 || n < t && r < 0) && l.set(c, Math.max(0, t + r), "element");
        }
        if (e.is(f)) {
            const t = u.offset;
            (n <= t && r > 0 || n < t && r < 0) && u.set(c, Math.max(0, t + r), "element");
        }
    }
    $6f291e234003fc86$var$Ps(t);
}
function $6f291e234003fc86$var$Ps(t) {
    const e = t.anchor, n = e.offset, r = t.focus, s = r.offset, i = e.getNode(), o = r.getNode();
    if (t.isCollapsed()) {
        if (!$6f291e234003fc86$export$923a058ef54437a4(i)) return;
        const t = i.getChildrenSize(), s = n >= t, o = s ? i.getChildAtIndex(t - 1) : i.getChildAtIndex(n);
        if ($6f291e234003fc86$export$471953706258be2b(o)) {
            let t = 0;
            s && (t = o.getTextContentSize()), e.set(o.__key, t, "text"), r.set(o.__key, t, "text");
        }
    } else {
        if ($6f291e234003fc86$export$923a058ef54437a4(i)) {
            const t = i.getChildrenSize(), r = n >= t, s = r ? i.getChildAtIndex(t - 1) : i.getChildAtIndex(n);
            if ($6f291e234003fc86$export$471953706258be2b(s)) {
                let t = 0;
                r && (t = s.getTextContentSize()), e.set(s.__key, t, "text");
            }
        }
        if ($6f291e234003fc86$export$923a058ef54437a4(o)) {
            const t = o.getChildrenSize(), e = s >= t, n = e ? o.getChildAtIndex(t - 1) : o.getChildAtIndex(s);
            if ($6f291e234003fc86$export$471953706258be2b(n)) {
                let t = 0;
                e && (t = n.getTextContentSize()), r.set(n.__key, t, "text");
            }
        }
    }
}
function $6f291e234003fc86$var$Ds(t, e, n, r, s) {
    let i = null, o = 0, l = null;
    null !== r ? (i = r.__key, $6f291e234003fc86$export$471953706258be2b(r) ? (o = r.getTextContentSize(), l = "text") : $6f291e234003fc86$export$923a058ef54437a4(r) && (o = r.getChildrenSize(), l = "element")) : null !== s && (i = s.__key, $6f291e234003fc86$export$471953706258be2b(s) ? l = "text" : $6f291e234003fc86$export$923a058ef54437a4(s) && (l = "element")), null !== i && null !== l ? t.set(i, o, l) : (o = e.getIndexWithinParent(), -1 === o && (o = n.getChildrenSize()), t.set(n.__key, o, "element"));
}
function $6f291e234003fc86$var$Fs(t, e, n, r, s) {
    "text" === t.type ? (t.key = n, e || (t.offset += s)) : t.offset > r.getIndexWithinParent() && (t.offset -= 1);
}
function $6f291e234003fc86$var$Os(t, e, n, r, s, i, o) {
    const l = r.anchorNode, c = r.focusNode, a = r.anchorOffset, u = r.focusOffset, f = document.activeElement;
    if (s.has("collaboration") && f !== i || null !== f && $6f291e234003fc86$export$340cc5df988bf401(f)) return;
    if (!$6f291e234003fc86$export$181b63acea8a0224(e)) return void (null !== t && $6f291e234003fc86$export$f1b377b21cd6350b(n, l, c) && r.removeAllRanges());
    const d = e.anchor, h = e.focus, g = d.key, _ = h.key, p = $6f291e234003fc86$var$Ze(n, g), y = $6f291e234003fc86$var$Ze(n, _), m = d.offset, x = h.offset, v = e.format, T = e.style, C = e.isCollapsed();
    let S = p, k = y, b = !1;
    if ("text" === d.type) {
        S = $6f291e234003fc86$var$fe(p);
        const t = d.getNode();
        b = t.getFormat() !== v || t.getStyle() !== T;
    } else $6f291e234003fc86$export$181b63acea8a0224(t) && "text" === t.anchor.type && (b = !0);
    var w, N, E, P, D;
    if (("text" === h.type && (k = $6f291e234003fc86$var$fe(y)), null !== S && null !== k) && (C && (null === t || b || $6f291e234003fc86$export$181b63acea8a0224(t) && (t.format !== v || t.style !== T)) && (w = v, N = T, E = m, P = g, D = performance.now(), $6f291e234003fc86$var$mr = [
        w,
        N,
        E,
        P,
        D
    ]), a !== m || u !== x || l !== S || c !== k || "Range" === r.type && C || (null !== f && i.contains(f) || i.focus({
        preventScroll: !0
    }), "element" === d.type))) {
        try {
            r.setBaseAndExtent(S, m, k, x);
        } catch (t) {}
        if (!s.has("skip-scroll-into-view") && e.isCollapsed() && null !== i && i === document.activeElement) {
            const t = e instanceof $6f291e234003fc86$var$fs && "element" === e.anchor.type ? S.childNodes[m] || null : r.rangeCount > 0 ? r.getRangeAt(0) : null;
            if (null !== t) {
                let e;
                if (t instanceof Text) {
                    const n = document.createRange();
                    n.selectNode(t), e = n.getBoundingClientRect();
                } else e = t.getBoundingClientRect();
                !function(t, e, n) {
                    const r = n.ownerDocument, s = r.defaultView;
                    if (null === s) return;
                    let { top: i, bottom: o } = e, l = 0, c = 0, a = n;
                    for(; null !== a;){
                        const e = a === r.body;
                        if (e) l = 0, c = $6f291e234003fc86$var$rn(t).innerHeight;
                        else {
                            const t = a.getBoundingClientRect();
                            l = t.top, c = t.bottom;
                        }
                        let n = 0;
                        if (i < l ? n = -(l - i) : o > c && (n = o - c), 0 !== n) {
                            if (e) s.scrollBy(0, n);
                            else {
                                const t = a.scrollTop;
                                a.scrollTop += n;
                                const e = a.scrollTop - t;
                                i -= e, o -= e;
                            }
                        }
                        if (e) break;
                        a = $6f291e234003fc86$var$Ge(a);
                    }
                }(n, e, i);
            }
        }
        $6f291e234003fc86$var$gr = !0;
    }
}
function $6f291e234003fc86$export$d773017360b45449(t) {
    let e = $6f291e234003fc86$export$63a3201b3a5c7d90() || $6f291e234003fc86$export$846e9407a8b5d98c();
    null === e && (e = $6f291e234003fc86$export$8d83ea843c4eea9a().selectEnd()), e.insertNodes(t);
}
function $6f291e234003fc86$export$2d96f9a07231d1b9() {
    const t = $6f291e234003fc86$export$63a3201b3a5c7d90();
    return null === t ? "" : t.getTextContent();
}
function $6f291e234003fc86$var$As(t) {
    let e = t;
    t.isCollapsed() || e.removeText();
    const n = $6f291e234003fc86$export$63a3201b3a5c7d90();
    $6f291e234003fc86$export$181b63acea8a0224(n) && (e = n), $6f291e234003fc86$export$181b63acea8a0224(e) || $6f291e234003fc86$var$Rt(161);
    const r = e.anchor;
    let s = r.getNode(), i = r.offset;
    for(; !$6f291e234003fc86$var$Tn(s);)[s, i] = $6f291e234003fc86$var$Ms(s, i);
    return i;
}
function $6f291e234003fc86$var$Ms(t, e) {
    const n = t.getParent();
    if (!n) {
        const t = $6f291e234003fc86$export$7f0c05ffb7ced90d();
        return $6f291e234003fc86$export$8d83ea843c4eea9a().append(t), t.select(), [
            $6f291e234003fc86$export$8d83ea843c4eea9a(),
            0
        ];
    }
    if ($6f291e234003fc86$export$471953706258be2b(t)) {
        const r = t.splitText(e);
        if (0 === r.length) return [
            n,
            t.getIndexWithinParent()
        ];
        const s = 0 === e ? 0 : 1;
        return [
            n,
            r[0].getIndexWithinParent() + s
        ];
    }
    if (!$6f291e234003fc86$export$923a058ef54437a4(t) || 0 === e) return [
        n,
        t.getIndexWithinParent()
    ];
    const r = t.getChildAtIndex(e);
    if (r) {
        const n = new $6f291e234003fc86$var$fs($6f291e234003fc86$export$9b3f8d373c057995(t.__key, e, "element"), $6f291e234003fc86$export$9b3f8d373c057995(t.__key, e, "element"), 0, ""), s = t.insertNewAfter(n);
        s && s.append(r, ...r.getNextSiblings());
    }
    return [
        n,
        t.getIndexWithinParent() + 1
    ];
}
let $6f291e234003fc86$var$zs = null, $6f291e234003fc86$var$Ws = null, $6f291e234003fc86$var$Bs = !1, $6f291e234003fc86$var$Rs = !1, $6f291e234003fc86$var$Ks = 0;
const $6f291e234003fc86$var$Js = {
    characterData: !0,
    childList: !0,
    subtree: !0
};
function $6f291e234003fc86$export$761df28585b755e8() {
    return $6f291e234003fc86$var$Bs || null !== $6f291e234003fc86$var$zs && $6f291e234003fc86$var$zs._readOnly;
}
function $6f291e234003fc86$var$Vs() {
    $6f291e234003fc86$var$Bs && $6f291e234003fc86$var$Rt(13);
}
function $6f291e234003fc86$var$$s() {
    $6f291e234003fc86$var$Ks > 99 && $6f291e234003fc86$var$Rt(14);
}
function $6f291e234003fc86$var$Hs() {
    return null === $6f291e234003fc86$var$zs && $6f291e234003fc86$var$Rt(15), $6f291e234003fc86$var$zs;
}
function $6f291e234003fc86$var$js() {
    return null === $6f291e234003fc86$var$Ws && $6f291e234003fc86$var$Rt(16), $6f291e234003fc86$var$Ws;
}
function $6f291e234003fc86$var$qs() {
    return $6f291e234003fc86$var$Ws;
}
function $6f291e234003fc86$var$Qs(t, e, n) {
    const r = e.__type, s = function(t, e) {
        const n = t._nodes.get(e);
        return void 0 === n && $6f291e234003fc86$var$Rt(30, e), n;
    }(t, r);
    let i = n.get(r);
    void 0 === i && (i = Array.from(s.transforms), n.set(r, i));
    const o = i.length;
    for(let t = 0; t < o && (i[t](e), e.isAttached()); t++);
}
function $6f291e234003fc86$var$Xs(t, e) {
    return void 0 !== t && t.__key !== e && t.isAttached();
}
function $6f291e234003fc86$export$e1d3a194df5be556(t) {
    return $6f291e234003fc86$var$Zs(t, $6f291e234003fc86$var$js()._nodes);
}
function $6f291e234003fc86$var$Zs(t, e) {
    const n = t.type, r = e.get(n);
    void 0 === r && $6f291e234003fc86$var$Rt(17, n);
    const s = r.klass;
    t.type !== s.getType() && $6f291e234003fc86$var$Rt(18, s.name);
    const i = s.importJSON(t), o = t.children;
    if ($6f291e234003fc86$export$923a058ef54437a4(i) && Array.isArray(o)) for(let t = 0; t < o.length; t++){
        const n = $6f291e234003fc86$var$Zs(o[t], e);
        i.append(n);
    }
    return i;
}
function $6f291e234003fc86$var$Gs(t, e) {
    const n = $6f291e234003fc86$var$zs, r = $6f291e234003fc86$var$Bs, s = $6f291e234003fc86$var$Ws;
    $6f291e234003fc86$var$zs = t, $6f291e234003fc86$var$Bs = !0, $6f291e234003fc86$var$Ws = null;
    try {
        return e();
    } finally{
        $6f291e234003fc86$var$zs = n, $6f291e234003fc86$var$Bs = r, $6f291e234003fc86$var$Ws = s;
    }
}
function $6f291e234003fc86$var$ti(t, n) {
    const r = t._pendingEditorState, s = t._rootElement, i = t._headless || null === s;
    if (null === r) return;
    const o = t._editorState, l = o._selection, c = r._selection, a = t._dirtyType !== $6f291e234003fc86$var$it, u = $6f291e234003fc86$var$zs, f = $6f291e234003fc86$var$Bs, d = $6f291e234003fc86$var$Ws, h = t._updating, g = t._observer;
    let _ = null;
    if (t._pendingEditorState = null, t._editorState = r, !i && a && null !== g) {
        $6f291e234003fc86$var$Ws = t, $6f291e234003fc86$var$zs = r, $6f291e234003fc86$var$Bs = !1, t._updating = !0;
        try {
            const e = t._dirtyType, n = t._dirtyElements, s = t._dirtyLeaves;
            g.disconnect(), _ = $6f291e234003fc86$var$sr(o, r, t, e, n, s);
        } catch (e) {
            if (e instanceof Error && t._onError(e), $6f291e234003fc86$var$Rs) throw e;
            return $6f291e234003fc86$var$wi(t, null, s, r), $6f291e234003fc86$var$Yt(t), t._dirtyType = $6f291e234003fc86$var$lt, $6f291e234003fc86$var$Rs = !0, $6f291e234003fc86$var$ti(t, o), void ($6f291e234003fc86$var$Rs = !1);
        } finally{
            g.observe(s, $6f291e234003fc86$var$Js), t._updating = h, $6f291e234003fc86$var$zs = u, $6f291e234003fc86$var$Bs = f, $6f291e234003fc86$var$Ws = d;
        }
    }
    r._readOnly || (r._readOnly = !0);
    const p = t._dirtyLeaves, y = t._dirtyElements, m = t._normalizedNodes, x = t._updateTags, v = t._deferred;
    a && (t._dirtyType = $6f291e234003fc86$var$it, t._cloneNotNeeded.clear(), t._dirtyLeaves = new Set, t._dirtyElements = new Map, t._normalizedNodes = new Set, t._updateTags = new Set), function(t, e) {
        const n = t._decorators;
        let r = t._pendingDecorators || n;
        const s = e._nodeMap;
        let i;
        for(i in r)s.has(i) || (r === n && (r = $6f291e234003fc86$var$Ce(t)), delete r[i]);
    }(t, r);
    const T = i ? null : $6f291e234003fc86$var$_n(t._window);
    if (t._editable && null !== T && (a || null === c || c.dirty)) {
        $6f291e234003fc86$var$Ws = t, $6f291e234003fc86$var$zs = r;
        try {
            if (null !== g && g.disconnect(), a || null === c || c.dirty) {
                const e = t._blockCursorElement;
                null !== e && $6f291e234003fc86$var$hn(e, t, s), $6f291e234003fc86$var$Os(l, c, t, T, x, s);
            }
            $6f291e234003fc86$var$gn(t, s, c), null !== g && g.observe(s, $6f291e234003fc86$var$Js);
        } finally{
            $6f291e234003fc86$var$Ws = d, $6f291e234003fc86$var$zs = u;
        }
    }
    null !== _ && function(t, e, n, r, s) {
        const i = Array.from(t._listeners.mutation), o = i.length;
        for(let t = 0; t < o; t++){
            const [o, l] = i[t], c = e.get(l);
            void 0 !== c && o(c, {
                dirtyLeaves: r,
                prevEditorState: s,
                updateTags: n
            });
        }
    }(t, _, x, p, o), $6f291e234003fc86$export$181b63acea8a0224(c) || null === c || null !== l && l.is(c) || t.dispatchCommand($6f291e234003fc86$export$e396fef71d2b56e5, void 0);
    const C = t._pendingDecorators;
    null !== C && (t._decorators = C, t._pendingDecorators = null, $6f291e234003fc86$var$ei("decorator", t, !0, C)), function(t, e, n) {
        const r = $6f291e234003fc86$var$Se(e), s = $6f291e234003fc86$var$Se(n);
        r !== s && $6f291e234003fc86$var$ei("textcontent", t, !0, s);
    }(t, n || o, r), $6f291e234003fc86$var$ei("update", t, !0, {
        dirtyElements: y,
        dirtyLeaves: p,
        editorState: r,
        normalizedNodes: m,
        prevEditorState: n || o,
        tags: x
    }), function(t, e) {
        if (t._deferred = [], 0 !== e.length) {
            const n = t._updating;
            t._updating = !0;
            try {
                for(let t = 0; t < e.length; t++)e[t]();
            } finally{
                t._updating = n;
            }
        }
    }(t, v), function(t) {
        const e = t._updates;
        if (0 !== e.length) {
            const n = e.shift();
            if (n) {
                const [e, r] = n;
                $6f291e234003fc86$var$si(t, e, r);
            }
        }
    }(t);
}
function $6f291e234003fc86$var$ei(t, e, n, ...r) {
    const s = e._updating;
    e._updating = n;
    try {
        const n = Array.from(e._listeners[t]);
        for(let t = 0; t < n.length; t++)n[t].apply(null, r);
    } finally{
        e._updating = s;
    }
}
function $6f291e234003fc86$var$ni(t, e, n) {
    if (!1 === t._updating || $6f291e234003fc86$var$Ws !== t) {
        let r = !1;
        return t.update(()=>{
            r = $6f291e234003fc86$var$ni(t, e, n);
        }), r;
    }
    const r = $6f291e234003fc86$var$De(t);
    for(let s = 4; s >= 0; s--)for(let i = 0; i < r.length; i++){
        const o = r[i]._commands.get(e);
        if (void 0 !== o) {
            const e = o[s];
            if (void 0 !== e) {
                const r = Array.from(e), s = r.length;
                for(let e = 0; e < s; e++)if (!0 === r[e](n, t)) return !0;
            }
        }
    }
    return !1;
}
function $6f291e234003fc86$var$ri(t, e) {
    const n = t._updates;
    let r = e || !1;
    for(; 0 !== n.length;){
        const e = n.shift();
        if (e) {
            const [n, s] = e;
            let i, o;
            void 0 !== s && (i = s.onUpdate, o = s.tag, s.skipTransforms && (r = !0), i && t._deferred.push(i), o && t._updateTags.add(o)), n();
        }
    }
    return r;
}
function $6f291e234003fc86$var$si(t, e, n) {
    const r = t._updateTags;
    let s, i, o = !1, l = !1;
    void 0 !== n && (s = n.onUpdate, i = n.tag, null != i && r.add(i), o = n.skipTransforms || !1, l = n.discrete || !1), s && t._deferred.push(s);
    const c = t._editorState;
    let a = t._pendingEditorState, u = !1;
    (null === a || a._readOnly) && (a = t._pendingEditorState = new $6f291e234003fc86$var$_i(new Map((a || c)._nodeMap)), u = !0), a._flushSync = l;
    const f = $6f291e234003fc86$var$zs, d = $6f291e234003fc86$var$Bs, h = $6f291e234003fc86$var$Ws, g = t._updating;
    $6f291e234003fc86$var$zs = a, $6f291e234003fc86$var$Bs = !1, t._updating = !0, $6f291e234003fc86$var$Ws = t;
    try {
        u && (t._headless ? null !== c._selection && (a._selection = c._selection.clone()) : a._selection = function(t) {
            const e = t.getEditorState()._selection, n = $6f291e234003fc86$var$_n(t._window);
            return $6f291e234003fc86$export$181b63acea8a0224(e) || null == e ? $6f291e234003fc86$var$bs(e, n, t, null) : e.clone();
        }(t));
        const n = t._compositionKey;
        e(), o = $6f291e234003fc86$var$ri(t, o), function(t, e) {
            const n = e.getEditorState()._selection, r = t._selection;
            if ($6f291e234003fc86$export$181b63acea8a0224(r)) {
                const t = r.anchor, e = r.focus;
                let s;
                if ("text" === t.type && (s = t.getNode(), s.selectionTransform(n, r)), "text" === e.type) {
                    const t = e.getNode();
                    s !== t && t.selectionTransform(n, r);
                }
            }
        }(a, t), t._dirtyType !== $6f291e234003fc86$var$it && (o ? function(t, e) {
            const n = e._dirtyLeaves, r = t._nodeMap;
            for (const t of n){
                const e = r.get(t);
                $6f291e234003fc86$export$471953706258be2b(e) && e.isAttached() && e.isSimpleText() && !e.isUnmergeable() && $6f291e234003fc86$var$te(e);
            }
        }(a, t) : function(t, e) {
            const n = e._dirtyLeaves, r = e._dirtyElements, s = t._nodeMap, i = $6f291e234003fc86$var$me(), o = new Map;
            let l = n, c = l.size, a = r, u = a.size;
            for(; c > 0 || u > 0;){
                if (c > 0) {
                    e._dirtyLeaves = new Set;
                    for (const t of l){
                        const r = s.get(t);
                        $6f291e234003fc86$export$471953706258be2b(r) && r.isAttached() && r.isSimpleText() && !r.isUnmergeable() && $6f291e234003fc86$var$te(r), void 0 !== r && $6f291e234003fc86$var$Xs(r, i) && $6f291e234003fc86$var$Qs(e, r, o), n.add(t);
                    }
                    if (l = e._dirtyLeaves, c = l.size, c > 0) {
                        $6f291e234003fc86$var$Ks++;
                        continue;
                    }
                }
                e._dirtyLeaves = new Set, e._dirtyElements = new Map;
                for (const t of a){
                    const n = t[0], l = t[1];
                    if ("root" !== n && !l) continue;
                    const c = s.get(n);
                    void 0 !== c && $6f291e234003fc86$var$Xs(c, i) && $6f291e234003fc86$var$Qs(e, c, o), r.set(n, l);
                }
                l = e._dirtyLeaves, c = l.size, a = e._dirtyElements, u = a.size, $6f291e234003fc86$var$Ks++;
            }
            e._dirtyLeaves = n, e._dirtyElements = r;
        }(a, t), $6f291e234003fc86$var$ri(t), function(t, e, n, r) {
            const s = t._nodeMap, i = e._nodeMap, o = [];
            for (const [t] of r){
                const e = i.get(t);
                void 0 !== e && (e.isAttached() || ($6f291e234003fc86$export$923a058ef54437a4(e) && $6f291e234003fc86$var$kn(e, t, s, i, o, r), s.has(t) || r.delete(t), o.push(t)));
            }
            for (const t of o)i.delete(t);
            for (const t of n){
                const e = i.get(t);
                void 0 === e || e.isAttached() || (s.has(t) || n.delete(t), i.delete(t));
            }
        }(c, a, t._dirtyLeaves, t._dirtyElements));
        n !== t._compositionKey && (a._flushSync = !0);
        const r = a._selection;
        if ($6f291e234003fc86$export$181b63acea8a0224(r)) {
            const t = a._nodeMap, e = r.anchor.key, n = r.focus.key;
            void 0 !== t.get(e) && void 0 !== t.get(n) || $6f291e234003fc86$var$Rt(19);
        } else $6f291e234003fc86$export$7257e4181651a7c3(r) && 0 === r._nodes.size && (a._selection = null);
    } catch (e) {
        return e instanceof Error && t._onError(e), t._pendingEditorState = c, t._dirtyType = $6f291e234003fc86$var$lt, t._cloneNotNeeded.clear(), t._dirtyLeaves = new Set, t._dirtyElements.clear(), void $6f291e234003fc86$var$ti(t);
    } finally{
        $6f291e234003fc86$var$zs = f, $6f291e234003fc86$var$Bs = d, $6f291e234003fc86$var$Ws = h, t._updating = g, $6f291e234003fc86$var$Ks = 0;
    }
    const _ = t._dirtyType !== $6f291e234003fc86$var$it || function(t, e) {
        const n = e.getEditorState()._selection, r = t._selection;
        if (null !== r) {
            if (r.dirty || !r.is(n)) return !0;
        } else if (null !== n) return !0;
        return !1;
    }(a, t);
    _ ? a._flushSync ? (a._flushSync = !1, $6f291e234003fc86$var$ti(t)) : u && $6f291e234003fc86$var$ie(()=>{
        $6f291e234003fc86$var$ti(t);
    }) : (a._flushSync = !1, u && (r.clear(), t._deferred = [], t._pendingEditorState = null));
}
function $6f291e234003fc86$var$ii(t, e, n) {
    t._updating ? t._updates.push([
        e,
        n
    ]) : $6f291e234003fc86$var$si(t, e, n);
}
class $6f291e234003fc86$export$dc064fe9e59310fd extends $6f291e234003fc86$var$Fr {
    constructor(t){
        super(t), this.__first = null, this.__last = null, this.__size = 0, this.__format = 0, this.__indent = 0, this.__dir = null;
    }
    getFormat() {
        return this.getLatest().__format;
    }
    getFormatType() {
        const t = this.getFormat();
        return $6f291e234003fc86$var$Mt[t] || "";
    }
    getIndent() {
        return this.getLatest().__indent;
    }
    getChildren() {
        const t = [];
        let e = this.getFirstChild();
        for(; null !== e;)t.push(e), e = e.getNextSibling();
        return t;
    }
    getChildrenKeys() {
        const t = [];
        let e = this.getFirstChild();
        for(; null !== e;)t.push(e.__key), e = e.getNextSibling();
        return t;
    }
    getChildrenSize() {
        return this.getLatest().__size;
    }
    isEmpty() {
        return 0 === this.getChildrenSize();
    }
    isDirty() {
        const t = $6f291e234003fc86$var$js()._dirtyElements;
        return null !== t && t.has(this.__key);
    }
    isLastChild() {
        const t = this.getLatest(), e = this.getParentOrThrow().getLastChild();
        return null !== e && e.is(t);
    }
    getAllTextNodes() {
        const t = [];
        let e = this.getFirstChild();
        for(; null !== e;){
            if ($6f291e234003fc86$export$471953706258be2b(e) && t.push(e), $6f291e234003fc86$export$923a058ef54437a4(e)) {
                const n = e.getAllTextNodes();
                t.push(...n);
            }
            e = e.getNextSibling();
        }
        return t;
    }
    getFirstDescendant() {
        let t = this.getFirstChild();
        for(; $6f291e234003fc86$export$923a058ef54437a4(t);){
            const e = t.getFirstChild();
            if (null === e) break;
            t = e;
        }
        return t;
    }
    getLastDescendant() {
        let t = this.getLastChild();
        for(; $6f291e234003fc86$export$923a058ef54437a4(t);){
            const e = t.getLastChild();
            if (null === e) break;
            t = e;
        }
        return t;
    }
    getDescendantByIndex(t) {
        const e = this.getChildren(), n = e.length;
        if (t >= n) {
            const t = e[n - 1];
            return $6f291e234003fc86$export$923a058ef54437a4(t) && t.getLastDescendant() || t || null;
        }
        const r = e[t];
        return $6f291e234003fc86$export$923a058ef54437a4(r) && r.getFirstDescendant() || r || null;
    }
    getFirstChild() {
        const t = this.getLatest().__first;
        return null === t ? null : $6f291e234003fc86$export$e725f93d4d48c6d8(t);
    }
    getFirstChildOrThrow() {
        const t = this.getFirstChild();
        return null === t && $6f291e234003fc86$var$Rt(45, this.__key), t;
    }
    getLastChild() {
        const t = this.getLatest().__last;
        return null === t ? null : $6f291e234003fc86$export$e725f93d4d48c6d8(t);
    }
    getLastChildOrThrow() {
        const t = this.getLastChild();
        return null === t && $6f291e234003fc86$var$Rt(96, this.__key), t;
    }
    getChildAtIndex(t) {
        const e = this.getChildrenSize();
        let n, r;
        if (t < e / 2) {
            for(n = this.getFirstChild(), r = 0; null !== n && r <= t;){
                if (r === t) return n;
                n = n.getNextSibling(), r++;
            }
            return null;
        }
        for(n = this.getLastChild(), r = e - 1; null !== n && r >= t;){
            if (r === t) return n;
            n = n.getPreviousSibling(), r--;
        }
        return null;
    }
    getTextContent() {
        let t = "";
        const e = this.getChildren(), n = e.length;
        for(let r = 0; r < n; r++){
            const s = e[r];
            t += s.getTextContent(), $6f291e234003fc86$export$923a058ef54437a4(s) && r !== n - 1 && !s.isInline() && (t += $6f291e234003fc86$var$Nt);
        }
        return t;
    }
    getTextContentSize() {
        let t = 0;
        const e = this.getChildren(), n = e.length;
        for(let r = 0; r < n; r++){
            const s = e[r];
            t += s.getTextContentSize(), $6f291e234003fc86$export$923a058ef54437a4(s) && r !== n - 1 && !s.isInline() && (t += $6f291e234003fc86$var$Nt.length);
        }
        return t;
    }
    getDirection() {
        return this.getLatest().__dir;
    }
    hasFormat(t) {
        if ("" !== t) {
            const e = $6f291e234003fc86$var$At[t];
            return !!(this.getFormat() & e);
        }
        return !1;
    }
    select(t, e) {
        $6f291e234003fc86$var$Vs();
        const n = $6f291e234003fc86$export$63a3201b3a5c7d90();
        let r = t, s = e;
        const i = this.getChildrenSize();
        if (!this.canBeEmpty()) {
            if (0 === t && 0 === e) {
                const t = this.getFirstChild();
                if ($6f291e234003fc86$export$471953706258be2b(t) || $6f291e234003fc86$export$923a058ef54437a4(t)) return t.select(0, 0);
            } else if (!(void 0 !== t && t !== i || void 0 !== e && e !== i)) {
                const t = this.getLastChild();
                if ($6f291e234003fc86$export$471953706258be2b(t) || $6f291e234003fc86$export$923a058ef54437a4(t)) return t.select();
            }
        }
        void 0 === r && (r = i), void 0 === s && (s = i);
        const o = this.__key;
        return $6f291e234003fc86$export$181b63acea8a0224(n) ? (n.anchor.set(o, r, "element"), n.focus.set(o, s, "element"), n.dirty = !0, n) : $6f291e234003fc86$var$Ts(o, r, o, s, "element", "element");
    }
    selectStart() {
        const t = this.getFirstDescendant();
        return t ? t.selectStart() : this.select();
    }
    selectEnd() {
        const t = this.getLastDescendant();
        return t ? t.selectEnd() : this.select();
    }
    clear() {
        const t = this.getWritable();
        return this.getChildren().forEach((t)=>t.remove()), t;
    }
    append(...t) {
        return this.splice(this.getChildrenSize(), 0, t);
    }
    setDirection(t) {
        const e = this.getWritable();
        return e.__dir = t, e;
    }
    setFormat(t) {
        return this.getWritable().__format = "" !== t ? $6f291e234003fc86$var$At[t] : 0, this;
    }
    setIndent(t) {
        return this.getWritable().__indent = t, this;
    }
    splice(t, e, n) {
        const r = n.length, s = this.getChildrenSize(), i = this.getWritable(), o = i.__key, l = [], c = [], a = this.getChildAtIndex(t + e);
        let u = null, f = s - e + r;
        if (0 !== t) {
            if (t === s) u = this.getLastChild();
            else {
                const e = this.getChildAtIndex(t);
                null !== e && (u = e.getPreviousSibling());
            }
        }
        if (e > 0) {
            let t = null === u ? this.getFirstChild() : u.getNextSibling();
            for(let n = 0; n < e; n++){
                null === t && $6f291e234003fc86$var$Rt(100);
                const e = t.getNextSibling(), n = t.__key;
                $6f291e234003fc86$var$_e(t.getWritable()), c.push(n), t = e;
            }
        }
        let d = u;
        for(let t = 0; t < r; t++){
            const e = n[t];
            null !== d && e.is(d) && (u = d = d.getPreviousSibling());
            const r = e.getWritable();
            r.__parent === o && f--, $6f291e234003fc86$var$_e(r);
            const s = e.__key;
            if (null === d) i.__first = s, r.__prev = null;
            else {
                const t = d.getWritable();
                t.__next = s, r.__prev = t.__key;
            }
            e.__key === o && $6f291e234003fc86$var$Rt(76), r.__parent = o, l.push(s), d = e;
        }
        if (t + e === s) {
            if (null !== d) d.getWritable().__next = null, i.__last = d.__key;
        } else if (null !== a) {
            const t = a.getWritable();
            if (null !== d) {
                const e = d.getWritable();
                t.__prev = d.__key, e.__next = a.__key;
            } else t.__prev = null;
        }
        if (i.__size = f, c.length) {
            const t = $6f291e234003fc86$export$63a3201b3a5c7d90();
            if ($6f291e234003fc86$export$181b63acea8a0224(t)) {
                const e = new Set(c), n = new Set(l), { anchor: r, focus: s } = t;
                $6f291e234003fc86$var$ci(r, e, n) && $6f291e234003fc86$var$Ds(r, r.getNode(), this, u, a), $6f291e234003fc86$var$ci(s, e, n) && $6f291e234003fc86$var$Ds(s, s.getNode(), this, u, a), 0 !== f || this.canBeEmpty() || $6f291e234003fc86$export$6f851a24c61146af(this) || this.remove();
            }
        }
        return i;
    }
    exportJSON() {
        return {
            children: [],
            direction: this.getDirection(),
            format: this.getFormatType(),
            indent: this.getIndent(),
            type: "element",
            version: 1
        };
    }
    insertNewAfter(t, e) {
        return null;
    }
    canIndent() {
        return !0;
    }
    collapseAtStart(t) {
        return !1;
    }
    excludeFromCopy(t) {
        return !1;
    }
    canReplaceWith(t) {
        return !0;
    }
    canInsertAfter(t) {
        return !0;
    }
    canBeEmpty() {
        return !0;
    }
    canInsertTextBefore() {
        return !0;
    }
    canInsertTextAfter() {
        return !0;
    }
    isInline() {
        return !1;
    }
    isShadowRoot() {
        return !1;
    }
    canMergeWith(t) {
        return !1;
    }
    extractWithChild(t, e, n) {
        return !1;
    }
}
function $6f291e234003fc86$export$923a058ef54437a4(t) {
    return t instanceof $6f291e234003fc86$export$dc064fe9e59310fd;
}
function $6f291e234003fc86$var$ci(t, e, n) {
    let r = t.getNode();
    for(; r;){
        const t = r.__key;
        if (e.has(t) && !n.has(t)) return !0;
        r = r.getParent();
    }
    return !1;
}
class $6f291e234003fc86$export$8244b9efe04488e extends $6f291e234003fc86$var$Fr {
    constructor(t){
        super(t);
    }
    decorate(t, e) {
        $6f291e234003fc86$var$Rt(47);
    }
    isIsolated() {
        return !1;
    }
    isInline() {
        return !0;
    }
    isKeyboardSelectable() {
        return !0;
    }
}
function $6f291e234003fc86$export$60aa03725ce41b1c(t) {
    return t instanceof $6f291e234003fc86$export$8244b9efe04488e;
}
class $6f291e234003fc86$export$1c180cb67301903c extends $6f291e234003fc86$export$dc064fe9e59310fd {
    static getType() {
        return "root";
    }
    static clone() {
        return new $6f291e234003fc86$export$1c180cb67301903c;
    }
    constructor(){
        super("root"), this.__cachedText = null;
    }
    getTopLevelElementOrThrow() {
        $6f291e234003fc86$var$Rt(51);
    }
    getTextContent() {
        const t = this.__cachedText;
        return !$6f291e234003fc86$export$761df28585b755e8() && $6f291e234003fc86$var$js()._dirtyType !== $6f291e234003fc86$var$it || null === t ? super.getTextContent() : t;
    }
    remove() {
        $6f291e234003fc86$var$Rt(52);
    }
    replace(t) {
        $6f291e234003fc86$var$Rt(53);
    }
    insertBefore(t) {
        $6f291e234003fc86$var$Rt(54);
    }
    insertAfter(t) {
        $6f291e234003fc86$var$Rt(55);
    }
    updateDOM(t, e) {
        return !1;
    }
    append(...t) {
        for(let e = 0; e < t.length; e++){
            const n = t[e];
            $6f291e234003fc86$export$923a058ef54437a4(n) || $6f291e234003fc86$export$60aa03725ce41b1c(n) || $6f291e234003fc86$var$Rt(56);
        }
        return super.append(...t);
    }
    static importJSON(t) {
        const e = $6f291e234003fc86$export$8d83ea843c4eea9a();
        return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e;
    }
    exportJSON() {
        return {
            children: [],
            direction: this.getDirection(),
            format: this.getFormatType(),
            indent: this.getIndent(),
            type: "root",
            version: 1
        };
    }
    collapseAtStart() {
        return !0;
    }
}
function $6f291e234003fc86$export$5b29ca560c2fedab(t) {
    return t instanceof $6f291e234003fc86$export$1c180cb67301903c;
}
function $6f291e234003fc86$var$hi() {
    return new $6f291e234003fc86$var$_i(new Map([
        [
            "root",
            new $6f291e234003fc86$export$1c180cb67301903c
        ]
    ]));
}
function $6f291e234003fc86$var$gi(t) {
    const e = t.exportJSON(), n = t.constructor;
    if (e.type !== n.getType() && $6f291e234003fc86$var$Rt(130, n.name), $6f291e234003fc86$export$923a058ef54437a4(t)) {
        const r = e.children;
        Array.isArray(r) || $6f291e234003fc86$var$Rt(59, n.name);
        const s = t.getChildren();
        for(let t = 0; t < s.length; t++){
            const e = $6f291e234003fc86$var$gi(s[t]);
            r.push(e);
        }
    }
    return e;
}
class $6f291e234003fc86$var$_i {
    constructor(t, e){
        this._nodeMap = t, this._selection = e || null, this._flushSync = !1, this._readOnly = !1;
    }
    isEmpty() {
        return 1 === this._nodeMap.size && null === this._selection;
    }
    read(t) {
        return $6f291e234003fc86$var$Gs(this, t);
    }
    clone(t) {
        const e = new $6f291e234003fc86$var$_i(this._nodeMap, void 0 === t ? this._selection : t);
        return e._readOnly = !0, e;
    }
    toJSON() {
        return $6f291e234003fc86$var$Gs(this, ()=>({
                root: $6f291e234003fc86$var$gi($6f291e234003fc86$export$8d83ea843c4eea9a())
            }));
    }
}
class $6f291e234003fc86$export$82a585c2442a6dd6 extends $6f291e234003fc86$export$dc064fe9e59310fd {
    static getType() {
        return "artificial";
    }
    createDOM(t) {
        return document.createElement("div");
    }
}
class $6f291e234003fc86$export$e94424771493b912 extends $6f291e234003fc86$export$dc064fe9e59310fd {
    constructor(t){
        super(t), this.__textFormat = 0;
    }
    static getType() {
        return "paragraph";
    }
    getTextFormat() {
        return this.getLatest().__textFormat;
    }
    setTextFormat(t) {
        const e = this.getWritable();
        return e.__textFormat = t, e;
    }
    hasTextFormat(t) {
        const e = $6f291e234003fc86$export$c9e7d6eb65b13430[t];
        return !!(this.getTextFormat() & e);
    }
    static clone(t) {
        return new $6f291e234003fc86$export$e94424771493b912(t.__key);
    }
    createDOM(t) {
        const e = document.createElement("p"), n = $6f291e234003fc86$var$Ve(t.theme, "paragraph");
        if (void 0 !== n) e.classList.add(...n);
        return e;
    }
    updateDOM(t, e, n) {
        return !1;
    }
    static importDOM() {
        return {
            p: (t)=>({
                    conversion: $6f291e234003fc86$var$mi,
                    priority: 0
                })
        };
    }
    exportDOM(t) {
        const { element: e } = super.exportDOM(t);
        if (e && $6f291e234003fc86$export$1b3bfaa9684536aa(e)) {
            this.isEmpty() && e.append(document.createElement("br"));
            const t = this.getFormatType();
            e.style.textAlign = t;
            const n = this.getDirection();
            n && (e.dir = n);
            const r = this.getIndent();
            r > 0 && (e.style.textIndent = 20 * r + "px");
        }
        return {
            element: e
        };
    }
    static importJSON(t) {
        const e = $6f291e234003fc86$export$7f0c05ffb7ced90d();
        return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e.setTextFormat(t.textFormat), e;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            textFormat: this.getTextFormat(),
            type: "paragraph",
            version: 1
        };
    }
    insertNewAfter(t, e) {
        const n = $6f291e234003fc86$export$7f0c05ffb7ced90d();
        n.setTextFormat(t.format);
        const r = this.getDirection();
        return n.setDirection(r), n.setFormat(this.getFormatType()), this.insertAfter(n, e), n;
    }
    collapseAtStart() {
        const t = this.getChildren();
        if (0 === t.length || $6f291e234003fc86$export$471953706258be2b(t[0]) && "" === t[0].getTextContent().trim()) {
            if (null !== this.getNextSibling()) return this.selectNext(), this.remove(), !0;
            if (null !== this.getPreviousSibling()) return this.selectPrevious(), this.remove(), !0;
        }
        return !1;
    }
}
function $6f291e234003fc86$var$mi(t) {
    const e = $6f291e234003fc86$export$7f0c05ffb7ced90d();
    if (t.style) {
        e.setFormat(t.style.textAlign);
        const n = parseInt(t.style.textIndent, 10) / 20;
        n > 0 && e.setIndent(n);
    }
    return {
        node: e
    };
}
function $6f291e234003fc86$export$7f0c05ffb7ced90d() {
    return $6f291e234003fc86$export$2f5beb31df92ea57(new $6f291e234003fc86$export$e94424771493b912);
}
function $6f291e234003fc86$export$1fdda795300c79c6(t) {
    return t instanceof $6f291e234003fc86$export$e94424771493b912;
}
const $6f291e234003fc86$export$11c61e12af5e1f41 = 0, $6f291e234003fc86$export$1d1358fe8b5bfab4 = 1, $6f291e234003fc86$export$7bb13e375de35064 = 2, $6f291e234003fc86$export$e8fb7042985cd2e9 = 3, $6f291e234003fc86$export$6afdf194f304e546 = 4;
function $6f291e234003fc86$var$wi(t, e, n, r) {
    const s = t._keyToDOMMap;
    s.clear(), t._editorState = $6f291e234003fc86$var$hi(), t._pendingEditorState = r, t._compositionKey = null, t._dirtyType = $6f291e234003fc86$var$it, t._cloneNotNeeded.clear(), t._dirtyLeaves = new Set, t._dirtyElements.clear(), t._normalizedNodes = new Set, t._updateTags = new Set, t._updates = [], t._blockCursorElement = null;
    const i = t._observer;
    null !== i && (i.disconnect(), t._observer = null), null !== e && (e.textContent = ""), null !== n && (n.textContent = "", s.set("root", n));
}
function $6f291e234003fc86$export$eb02d1ee0d3cac30(t) {
    const e = t || {}, n = $6f291e234003fc86$var$qs(), r = e.theme || {}, s = void 0 === t ? n : e.parentEditor || null, i = e.disableEvents || !1, o = $6f291e234003fc86$var$hi(), l = e.namespace || (null !== s ? s._config.namespace : $6f291e234003fc86$var$Fe()), c = e.editorState, a = [
        $6f291e234003fc86$export$1c180cb67301903c,
        $6f291e234003fc86$export$f0a25ea3087686aa,
        $6f291e234003fc86$export$965f56e8043e93ae,
        $6f291e234003fc86$export$8dbf7edd89edc19c,
        $6f291e234003fc86$export$e94424771493b912,
        $6f291e234003fc86$export$82a585c2442a6dd6,
        ...e.nodes || []
    ], { onError: u, html: f } = e, d = void 0 === e.editable || e.editable;
    let h;
    if (void 0 === t && null !== n) h = n._nodes;
    else {
        h = new Map;
        for(let t = 0; t < a.length; t++){
            let e = a[t], n = null, r = null;
            if ("function" != typeof e) {
                const t = e;
                e = t.replace, n = t.with, r = t.withKlass || null;
            }
            const s = e.getType(), i = e.transform(), o = new Set;
            null !== i && o.add(i), h.set(s, {
                exportDOM: f && f.export ? f.export.get(e) : void 0,
                klass: e,
                replace: n,
                replaceWithKlass: r,
                transforms: o
            });
        }
    }
    const g = new $6f291e234003fc86$var$Ei(o, s, h, {
        disableEvents: i,
        namespace: l,
        theme: r
    }, u || console.error, function(t, e) {
        const n = new Map, r = new Set, s = (t)=>{
            Object.keys(t).forEach((e)=>{
                let r = n.get(e);
                void 0 === r && (r = [], n.set(e, r)), r.push(t[e]);
            });
        };
        return t.forEach((t)=>{
            const e = t.klass.importDOM;
            if (null == e || r.has(e)) return;
            r.add(e);
            const n = e.call(t.klass);
            null !== n && s(n);
        }), e && s(e), n;
    }(h, f ? f.import : void 0), d);
    return void 0 !== c && (g._pendingEditorState = c, g._dirtyType = $6f291e234003fc86$var$lt), g;
}
class $6f291e234003fc86$var$Ei {
    constructor(t, e, n, r, s, i, o){
        this._parentEditor = e, this._rootElement = null, this._editorState = t, this._pendingEditorState = null, this._compositionKey = null, this._deferred = [], this._keyToDOMMap = new Map, this._updates = [], this._updating = !1, this._listeners = {
            decorator: new Set,
            editable: new Set,
            mutation: new Map,
            root: new Set,
            textcontent: new Set,
            update: new Set
        }, this._commands = new Map, this._config = r, this._nodes = n, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = $6f291e234003fc86$var$it, this._cloneNotNeeded = new Set, this._dirtyLeaves = new Set, this._dirtyElements = new Map, this._normalizedNodes = new Set, this._updateTags = new Set, this._observer = null, this._key = $6f291e234003fc86$var$Fe(), this._onError = s, this._htmlConversions = i, this._editable = o, this._headless = null !== e && e._headless, this._window = null, this._blockCursorElement = null;
    }
    isComposing() {
        return null != this._compositionKey;
    }
    registerUpdateListener(t) {
        const e = this._listeners.update;
        return e.add(t), ()=>{
            e.delete(t);
        };
    }
    registerEditableListener(t) {
        const e = this._listeners.editable;
        return e.add(t), ()=>{
            e.delete(t);
        };
    }
    registerDecoratorListener(t) {
        const e = this._listeners.decorator;
        return e.add(t), ()=>{
            e.delete(t);
        };
    }
    registerTextContentListener(t) {
        const e = this._listeners.textcontent;
        return e.add(t), ()=>{
            e.delete(t);
        };
    }
    registerRootListener(t) {
        const e = this._listeners.root;
        return t(this._rootElement, null), e.add(t), ()=>{
            t(null, this._rootElement), e.delete(t);
        };
    }
    registerCommand(t, e, n) {
        void 0 === n && $6f291e234003fc86$var$Rt(35);
        const r = this._commands;
        r.has(t) || r.set(t, [
            new Set,
            new Set,
            new Set,
            new Set,
            new Set
        ]);
        const s = r.get(t);
        void 0 === s && $6f291e234003fc86$var$Rt(36, String(t));
        const i = s[n];
        return i.add(e), ()=>{
            i.delete(e), s.every((t)=>0 === t.size) && r.delete(t);
        };
    }
    registerMutationListener(t, e) {
        let n = this._nodes.get(t.getType());
        void 0 === n && $6f291e234003fc86$var$Rt(37, t.name);
        let r = t, s = null;
        for(; s = n.replaceWithKlass;)r = s, n = this._nodes.get(s.getType()), void 0 === n && $6f291e234003fc86$var$Rt(37, s.name);
        const i = this._listeners.mutation;
        return i.set(e, r), ()=>{
            i.delete(e);
        };
    }
    registerNodeTransformToKlass(t, e) {
        const n = t.getType(), r = this._nodes.get(n);
        void 0 === r && $6f291e234003fc86$var$Rt(37, t.name);
        return r.transforms.add(e), r;
    }
    registerNodeTransform(t, e) {
        const n = this.registerNodeTransformToKlass(t, e), r = [
            n
        ], s = n.replaceWithKlass;
        if (null != s) {
            const t = this.registerNodeTransformToKlass(s, e);
            r.push(t);
        }
        var i, o;
        return i = this, o = t.getType(), $6f291e234003fc86$var$ii(i, ()=>{
            const t = $6f291e234003fc86$var$Hs();
            if (t.isEmpty()) return;
            if ("root" === o) return void $6f291e234003fc86$export$8d83ea843c4eea9a().markDirty();
            const e = t._nodeMap;
            for (const [, t] of e)t.markDirty();
        }, null === i._pendingEditorState ? {
            tag: "history-merge"
        } : void 0), ()=>{
            r.forEach((t)=>t.transforms.delete(e));
        };
    }
    hasNode(t) {
        return this._nodes.has(t.getType());
    }
    hasNodes(t) {
        return t.every(this.hasNode.bind(this));
    }
    dispatchCommand(t, e) {
        return $6f291e234003fc86$var$Xe(this, t, e);
    }
    getDecorators() {
        return this._decorators;
    }
    getRootElement() {
        return this._rootElement;
    }
    getKey() {
        return this._key;
    }
    setRootElement(t) {
        const e = this._rootElement;
        if (t !== e) {
            const n = $6f291e234003fc86$var$Ve(this._config.theme, "root"), r = this._pendingEditorState || this._editorState;
            if (this._rootElement = t, $6f291e234003fc86$var$wi(this, e, t, r), null !== e && (this._config.disableEvents || $6f291e234003fc86$var$Pr(e), null != n && e.classList.remove(...n)), null !== t) {
                const e = function(t) {
                    const e = t.ownerDocument;
                    return e && e.defaultView || null;
                }(t), r = t.style;
                r.userSelect = "text", r.whiteSpace = "pre-wrap", r.wordBreak = "break-word", t.setAttribute("data-lexical-editor", "true"), this._window = e, this._dirtyType = $6f291e234003fc86$var$lt, $6f291e234003fc86$var$Yt(this), this._updateTags.add("history-merge"), $6f291e234003fc86$var$ti(this), this._config.disableEvents || function(t, e) {
                    const n = t.ownerDocument, r = $6f291e234003fc86$var$hr.get(n);
                    (void 0 === r || r < 1) && n.addEventListener("selectionchange", $6f291e234003fc86$var$wr), $6f291e234003fc86$var$hr.set(n, (r || 0) + 1), t.__lexicalEditor = e;
                    const s = $6f291e234003fc86$var$kr(t);
                    for(let n = 0; n < $6f291e234003fc86$var$cr.length; n++){
                        const [r, i] = $6f291e234003fc86$var$cr[n], o = "function" == typeof i ? (t)=>{
                            $6f291e234003fc86$var$Er(t) || ($6f291e234003fc86$var$Nr(t), (e.isEditable() || "click" === r) && i(t, e));
                        } : (t)=>{
                            if ($6f291e234003fc86$var$Er(t)) return;
                            $6f291e234003fc86$var$Nr(t);
                            const n = e.isEditable();
                            switch(r){
                                case "cut":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$4dc8a35a083beec4, t);
                                case "copy":
                                    return $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$3435fcfb1f59ef96, t);
                                case "paste":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$7fb70c61b3bcc883, t);
                                case "dragstart":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$2e0fd45fde1da719, t);
                                case "dragover":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$b62c1cce98fa7223, t);
                                case "dragend":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$ffbd838cf75d7d8e, t);
                                case "focus":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$cafe35f35e77bf56, t);
                                case "blur":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$4b6d457d076906ac, t);
                                case "drop":
                                    return n && $6f291e234003fc86$var$Xe(e, $6f291e234003fc86$export$eac1e4b16b80d3ea, t);
                            }
                        };
                        t.addEventListener(r, o), s.push(()=>{
                            t.removeEventListener(r, o);
                        });
                    }
                }(t, this), null != n && t.classList.add(...n);
            } else this._editorState = r, this._pendingEditorState = null, this._window = null;
            $6f291e234003fc86$var$ei("root", this, !1, t, e);
        }
    }
    getElementByKey(t) {
        return this._keyToDOMMap.get(t) || null;
    }
    getEditorState() {
        return this._editorState;
    }
    setEditorState(t, e) {
        t.isEmpty() && $6f291e234003fc86$var$Rt(38), $6f291e234003fc86$var$Xt(this);
        const n = this._pendingEditorState, r = this._updateTags, s = void 0 !== e ? e.tag : null;
        null === n || n.isEmpty() || (null != s && r.add(s), $6f291e234003fc86$var$ti(this)), this._pendingEditorState = t, this._dirtyType = $6f291e234003fc86$var$lt, this._dirtyElements.set("root", !1), this._compositionKey = null, null != s && r.add(s), $6f291e234003fc86$var$ti(this);
    }
    parseEditorState(t, e) {
        return function(t, e, n) {
            const r = $6f291e234003fc86$var$hi(), s = $6f291e234003fc86$var$zs, i = $6f291e234003fc86$var$Bs, o = $6f291e234003fc86$var$Ws, l = e._dirtyElements, c = e._dirtyLeaves, a = e._cloneNotNeeded, u = e._dirtyType;
            e._dirtyElements = new Map, e._dirtyLeaves = new Set, e._cloneNotNeeded = new Set, e._dirtyType = 0, $6f291e234003fc86$var$zs = r, $6f291e234003fc86$var$Bs = !1, $6f291e234003fc86$var$Ws = e;
            try {
                const s = e._nodes;
                $6f291e234003fc86$var$Zs(t.root, s), n && n(), r._readOnly = !0;
            } catch (t) {
                t instanceof Error && e._onError(t);
            } finally{
                e._dirtyElements = l, e._dirtyLeaves = c, e._cloneNotNeeded = a, e._dirtyType = u, $6f291e234003fc86$var$zs = s, $6f291e234003fc86$var$Bs = i, $6f291e234003fc86$var$Ws = o;
            }
            return r;
        }("string" == typeof t ? JSON.parse(t) : t, this, e);
    }
    update(t, e) {
        $6f291e234003fc86$var$ii(this, t, e);
    }
    focus(t, e = {}) {
        const n = this._rootElement;
        null !== n && (n.setAttribute("autocapitalize", "off"), $6f291e234003fc86$var$ii(this, ()=>{
            const t = $6f291e234003fc86$export$63a3201b3a5c7d90(), n = $6f291e234003fc86$export$8d83ea843c4eea9a();
            null !== t ? t.dirty = !0 : 0 !== n.getChildrenSize() && ("rootStart" === e.defaultSelection ? n.selectStart() : n.selectEnd());
        }, {
            onUpdate: ()=>{
                n.removeAttribute("autocapitalize"), t && t();
            },
            tag: "focus"
        }), null === this._pendingEditorState && n.removeAttribute("autocapitalize"));
    }
    blur() {
        const t = this._rootElement;
        null !== t && t.blur();
        const e = $6f291e234003fc86$var$_n(this._window);
        null !== e && e.removeAllRanges();
    }
    isEditable() {
        return this._editable;
    }
    setEditable(t) {
        this._editable !== t && (this._editable = t, $6f291e234003fc86$var$ei("editable", this, !0, t));
    }
    toJSON() {
        return {
            editorState: this._editorState.toJSON()
        };
    }
}


const $f3de35ce60b0ef48$var$mod = $6f291e234003fc86$exports;
const $f3de35ce60b0ef48$export$24cab2f466b76c04 = $f3de35ce60b0ef48$var$mod.$addUpdateTag;
const $f3de35ce60b0ef48$export$2f5beb31df92ea57 = $f3de35ce60b0ef48$var$mod.$applyNodeReplacement;
const $f3de35ce60b0ef48$export$def73b17b22438e7 = $f3de35ce60b0ef48$var$mod.$copyNode;
const $f3de35ce60b0ef48$export$4ccaf7d0d16ab4c = $f3de35ce60b0ef48$var$mod.$createLineBreakNode;
const $f3de35ce60b0ef48$export$f8cd0c3f35d1a61c = $f3de35ce60b0ef48$var$mod.$createNodeSelection;
const $f3de35ce60b0ef48$export$7f0c05ffb7ced90d = $f3de35ce60b0ef48$var$mod.$createParagraphNode;
const $f3de35ce60b0ef48$export$9b3f8d373c057995 = $f3de35ce60b0ef48$var$mod.$createPoint;
const $f3de35ce60b0ef48$export$1ccc217b9831b072 = $f3de35ce60b0ef48$var$mod.$createRangeSelection;
const $f3de35ce60b0ef48$export$68ac2b736ac647aa = $f3de35ce60b0ef48$var$mod.$createRangeSelectionFromDom;
const $f3de35ce60b0ef48$export$5bde9d58a1da0796 = $f3de35ce60b0ef48$var$mod.$createTabNode;
const $f3de35ce60b0ef48$export$2785f39dcdec0078 = $f3de35ce60b0ef48$var$mod.$createTextNode;
const $f3de35ce60b0ef48$export$c4b907be1879d8c1 = $f3de35ce60b0ef48$var$mod.$getAdjacentNode;
const $f3de35ce60b0ef48$export$5a33b5b9a9d5db8f = $f3de35ce60b0ef48$var$mod.$getCharacterOffsets;
const $f3de35ce60b0ef48$export$8a7392c46faf1a3f = $f3de35ce60b0ef48$var$mod.$getEditor;
const $f3de35ce60b0ef48$export$fef265f0d2fcffdd = $f3de35ce60b0ef48$var$mod.$getNearestNodeFromDOMNode;
const $f3de35ce60b0ef48$export$6f13c476561e4734 = $f3de35ce60b0ef48$var$mod.$getNearestRootOrShadowRoot;
const $f3de35ce60b0ef48$export$e725f93d4d48c6d8 = $f3de35ce60b0ef48$var$mod.$getNodeByKey;
const $f3de35ce60b0ef48$export$b86173decb513938 = $f3de35ce60b0ef48$var$mod.$getNodeByKeyOrThrow;
const $f3de35ce60b0ef48$export$846e9407a8b5d98c = $f3de35ce60b0ef48$var$mod.$getPreviousSelection;
const $f3de35ce60b0ef48$export$8d83ea843c4eea9a = $f3de35ce60b0ef48$var$mod.$getRoot;
const $f3de35ce60b0ef48$export$63a3201b3a5c7d90 = $f3de35ce60b0ef48$var$mod.$getSelection;
const $f3de35ce60b0ef48$export$2d96f9a07231d1b9 = $f3de35ce60b0ef48$var$mod.$getTextContent;
const $f3de35ce60b0ef48$export$e3d4b782f65c81f1 = $f3de35ce60b0ef48$var$mod.$hasAncestor;
const $f3de35ce60b0ef48$export$fbcbbb073e480e61 = $f3de35ce60b0ef48$var$mod.$hasUpdateTag;
const $f3de35ce60b0ef48$export$d773017360b45449 = $f3de35ce60b0ef48$var$mod.$insertNodes;
const $f3de35ce60b0ef48$export$de078facd4ee1560 = $f3de35ce60b0ef48$var$mod.$isBlockElementNode;
const $f3de35ce60b0ef48$export$60aa03725ce41b1c = $f3de35ce60b0ef48$var$mod.$isDecoratorNode;
const $f3de35ce60b0ef48$export$923a058ef54437a4 = $f3de35ce60b0ef48$var$mod.$isElementNode;
const $f3de35ce60b0ef48$export$a78813a4e8e8b9dd = $f3de35ce60b0ef48$var$mod.$isInlineElementOrDecoratorNode;
const $f3de35ce60b0ef48$export$8d016e0592201ace = $f3de35ce60b0ef48$var$mod.$isLeafNode;
const $f3de35ce60b0ef48$export$b16330e40aa25c4e = $f3de35ce60b0ef48$var$mod.$isLineBreakNode;
const $f3de35ce60b0ef48$export$7257e4181651a7c3 = $f3de35ce60b0ef48$var$mod.$isNodeSelection;
const $f3de35ce60b0ef48$export$1fdda795300c79c6 = $f3de35ce60b0ef48$var$mod.$isParagraphNode;
const $f3de35ce60b0ef48$export$181b63acea8a0224 = $f3de35ce60b0ef48$var$mod.$isRangeSelection;
const $f3de35ce60b0ef48$export$5b29ca560c2fedab = $f3de35ce60b0ef48$var$mod.$isRootNode;
const $f3de35ce60b0ef48$export$6f851a24c61146af = $f3de35ce60b0ef48$var$mod.$isRootOrShadowRoot;
const $f3de35ce60b0ef48$export$ac9141efa5fb7932 = $f3de35ce60b0ef48$var$mod.$isTabNode;
const $f3de35ce60b0ef48$export$471953706258be2b = $f3de35ce60b0ef48$var$mod.$isTextNode;
const $f3de35ce60b0ef48$export$ac6fed8d7d40e66c = $f3de35ce60b0ef48$var$mod.$nodesOfType;
const $f3de35ce60b0ef48$export$db10bc6ba67ffcb5 = $f3de35ce60b0ef48$var$mod.$normalizeSelection__EXPERIMENTAL;
const $f3de35ce60b0ef48$export$e1d3a194df5be556 = $f3de35ce60b0ef48$var$mod.$parseSerializedNode;
const $f3de35ce60b0ef48$export$824f075b28fd7b6c = $f3de35ce60b0ef48$var$mod.$selectAll;
const $f3de35ce60b0ef48$export$ea25f5ef71f2d042 = $f3de35ce60b0ef48$var$mod.$setCompositionKey;
const $f3de35ce60b0ef48$export$2aad78c37810bca9 = $f3de35ce60b0ef48$var$mod.$setSelection;
const $f3de35ce60b0ef48$export$cc2d53c74c1fb2b2 = $f3de35ce60b0ef48$var$mod.$splitNode;
const $f3de35ce60b0ef48$export$82a585c2442a6dd6 = $f3de35ce60b0ef48$var$mod.ArtificialNode__DO_NOT_USE;
const $f3de35ce60b0ef48$export$4b6d457d076906ac = $f3de35ce60b0ef48$var$mod.BLUR_COMMAND;
const $f3de35ce60b0ef48$export$e36aacf84f559bb3 = $f3de35ce60b0ef48$var$mod.CAN_REDO_COMMAND;
const $f3de35ce60b0ef48$export$9fd9dd31dd6ebdf5 = $f3de35ce60b0ef48$var$mod.CAN_UNDO_COMMAND;
const $f3de35ce60b0ef48$export$4926ce1a5702fdc7 = $f3de35ce60b0ef48$var$mod.CLEAR_EDITOR_COMMAND;
const $f3de35ce60b0ef48$export$d3f69a65bbe7edc = $f3de35ce60b0ef48$var$mod.CLEAR_HISTORY_COMMAND;
const $f3de35ce60b0ef48$export$c1a2de6c823e5f82 = $f3de35ce60b0ef48$var$mod.CLICK_COMMAND;
const $f3de35ce60b0ef48$export$6afdf194f304e546 = $f3de35ce60b0ef48$var$mod.COMMAND_PRIORITY_CRITICAL;
const $f3de35ce60b0ef48$export$11c61e12af5e1f41 = $f3de35ce60b0ef48$var$mod.COMMAND_PRIORITY_EDITOR;
const $f3de35ce60b0ef48$export$e8fb7042985cd2e9 = $f3de35ce60b0ef48$var$mod.COMMAND_PRIORITY_HIGH;
const $f3de35ce60b0ef48$export$1d1358fe8b5bfab4 = $f3de35ce60b0ef48$var$mod.COMMAND_PRIORITY_LOW;
const $f3de35ce60b0ef48$export$7bb13e375de35064 = $f3de35ce60b0ef48$var$mod.COMMAND_PRIORITY_NORMAL;
const $f3de35ce60b0ef48$export$6f67c758bb657857 = $f3de35ce60b0ef48$var$mod.CONTROLLED_TEXT_INSERTION_COMMAND;
const $f3de35ce60b0ef48$export$3435fcfb1f59ef96 = $f3de35ce60b0ef48$var$mod.COPY_COMMAND;
const $f3de35ce60b0ef48$export$4dc8a35a083beec4 = $f3de35ce60b0ef48$var$mod.CUT_COMMAND;
const $f3de35ce60b0ef48$export$35595bf6d7e36fd5 = $f3de35ce60b0ef48$var$mod.DELETE_CHARACTER_COMMAND;
const $f3de35ce60b0ef48$export$d77fad8fb8747fd = $f3de35ce60b0ef48$var$mod.DELETE_LINE_COMMAND;
const $f3de35ce60b0ef48$export$8e315b175631384c = $f3de35ce60b0ef48$var$mod.DELETE_WORD_COMMAND;
const $f3de35ce60b0ef48$export$ffbd838cf75d7d8e = $f3de35ce60b0ef48$var$mod.DRAGEND_COMMAND;
const $f3de35ce60b0ef48$export$b62c1cce98fa7223 = $f3de35ce60b0ef48$var$mod.DRAGOVER_COMMAND;
const $f3de35ce60b0ef48$export$2e0fd45fde1da719 = $f3de35ce60b0ef48$var$mod.DRAGSTART_COMMAND;
const $f3de35ce60b0ef48$export$eac1e4b16b80d3ea = $f3de35ce60b0ef48$var$mod.DROP_COMMAND;
const $f3de35ce60b0ef48$export$8244b9efe04488e = $f3de35ce60b0ef48$var$mod.DecoratorNode;
const $f3de35ce60b0ef48$export$dc064fe9e59310fd = $f3de35ce60b0ef48$var$mod.ElementNode;
const $f3de35ce60b0ef48$export$cafe35f35e77bf56 = $f3de35ce60b0ef48$var$mod.FOCUS_COMMAND;
const $f3de35ce60b0ef48$export$d394dc6514823b18 = $f3de35ce60b0ef48$var$mod.FORMAT_ELEMENT_COMMAND;
const $f3de35ce60b0ef48$export$85443a1a9543f043 = $f3de35ce60b0ef48$var$mod.FORMAT_TEXT_COMMAND;
const $f3de35ce60b0ef48$export$2f74f6a2d927e6bd = $f3de35ce60b0ef48$var$mod.INDENT_CONTENT_COMMAND;
const $f3de35ce60b0ef48$export$64e35ce26e025724 = $f3de35ce60b0ef48$var$mod.INSERT_LINE_BREAK_COMMAND;
const $f3de35ce60b0ef48$export$24f4fea65b096b4 = $f3de35ce60b0ef48$var$mod.INSERT_PARAGRAPH_COMMAND;
const $f3de35ce60b0ef48$export$926ce4da2c89d118 = $f3de35ce60b0ef48$var$mod.INSERT_TAB_COMMAND;
const $f3de35ce60b0ef48$export$a0ecbce4c0037b95 = $f3de35ce60b0ef48$var$mod.IS_ALL_FORMATTING;
const $f3de35ce60b0ef48$export$d401051135d8c941 = $f3de35ce60b0ef48$var$mod.IS_BOLD;
const $f3de35ce60b0ef48$export$bf809f2b03ed57cc = $f3de35ce60b0ef48$var$mod.IS_CODE;
const $f3de35ce60b0ef48$export$f1e9b55cdd671814 = $f3de35ce60b0ef48$var$mod.IS_HIGHLIGHT;
const $f3de35ce60b0ef48$export$6f537bdfcfab164 = $f3de35ce60b0ef48$var$mod.IS_ITALIC;
const $f3de35ce60b0ef48$export$27809404dee18444 = $f3de35ce60b0ef48$var$mod.IS_STRIKETHROUGH;
const $f3de35ce60b0ef48$export$22c32c29c50da53a = $f3de35ce60b0ef48$var$mod.IS_SUBSCRIPT;
const $f3de35ce60b0ef48$export$703b9afdf8723203 = $f3de35ce60b0ef48$var$mod.IS_SUPERSCRIPT;
const $f3de35ce60b0ef48$export$4fefe1576f07e925 = $f3de35ce60b0ef48$var$mod.IS_UNDERLINE;
const $f3de35ce60b0ef48$export$baa60daa2ca402b3 = $f3de35ce60b0ef48$var$mod.KEY_ARROW_DOWN_COMMAND;
const $f3de35ce60b0ef48$export$7525f8f8ab44508 = $f3de35ce60b0ef48$var$mod.KEY_ARROW_LEFT_COMMAND;
const $f3de35ce60b0ef48$export$217ec2281ac1c53b = $f3de35ce60b0ef48$var$mod.KEY_ARROW_RIGHT_COMMAND;
const $f3de35ce60b0ef48$export$7833c2a33ae81d3d = $f3de35ce60b0ef48$var$mod.KEY_ARROW_UP_COMMAND;
const $f3de35ce60b0ef48$export$24bbba9bfa830f78 = $f3de35ce60b0ef48$var$mod.KEY_BACKSPACE_COMMAND;
const $f3de35ce60b0ef48$export$13a0e72b5c0146bb = $f3de35ce60b0ef48$var$mod.KEY_DELETE_COMMAND;
const $f3de35ce60b0ef48$export$61973214e0e18936 = $f3de35ce60b0ef48$var$mod.KEY_DOWN_COMMAND;
const $f3de35ce60b0ef48$export$2cdb7cdd6fccb293 = $f3de35ce60b0ef48$var$mod.KEY_ENTER_COMMAND;
const $f3de35ce60b0ef48$export$53589e422a755d59 = $f3de35ce60b0ef48$var$mod.KEY_ESCAPE_COMMAND;
const $f3de35ce60b0ef48$export$452548a3c1874d61 = $f3de35ce60b0ef48$var$mod.KEY_MODIFIER_COMMAND;
const $f3de35ce60b0ef48$export$d0bc2bb647ce4c17 = $f3de35ce60b0ef48$var$mod.KEY_SPACE_COMMAND;
const $f3de35ce60b0ef48$export$b321bdc226ccdcde = $f3de35ce60b0ef48$var$mod.KEY_TAB_COMMAND;
const $f3de35ce60b0ef48$export$965f56e8043e93ae = $f3de35ce60b0ef48$var$mod.LineBreakNode;
const $f3de35ce60b0ef48$export$fb3b2d438650aff6 = $f3de35ce60b0ef48$var$mod.MOVE_TO_END;
const $f3de35ce60b0ef48$export$dc117ee4d661295a = $f3de35ce60b0ef48$var$mod.MOVE_TO_START;
const $f3de35ce60b0ef48$export$ecf9caa19e96e40d = $f3de35ce60b0ef48$var$mod.OUTDENT_CONTENT_COMMAND;
const $f3de35ce60b0ef48$export$7fb70c61b3bcc883 = $f3de35ce60b0ef48$var$mod.PASTE_COMMAND;
const $f3de35ce60b0ef48$export$e94424771493b912 = $f3de35ce60b0ef48$var$mod.ParagraphNode;
const $f3de35ce60b0ef48$export$8c4a0748d31d9941 = $f3de35ce60b0ef48$var$mod.REDO_COMMAND;
const $f3de35ce60b0ef48$export$9cc285f2a3ff220c = $f3de35ce60b0ef48$var$mod.REMOVE_TEXT_COMMAND;
const $f3de35ce60b0ef48$export$1c180cb67301903c = $f3de35ce60b0ef48$var$mod.RootNode;
const $f3de35ce60b0ef48$export$e396fef71d2b56e5 = $f3de35ce60b0ef48$var$mod.SELECTION_CHANGE_COMMAND;
const $f3de35ce60b0ef48$export$e47bb493817ec5f6 = $f3de35ce60b0ef48$var$mod.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND;
const $f3de35ce60b0ef48$export$185c218616045e75 = $f3de35ce60b0ef48$var$mod.SELECT_ALL_COMMAND;
const $f3de35ce60b0ef48$export$c9e7d6eb65b13430 = $f3de35ce60b0ef48$var$mod.TEXT_TYPE_TO_FORMAT;
const $f3de35ce60b0ef48$export$8dbf7edd89edc19c = $f3de35ce60b0ef48$var$mod.TabNode;
const $f3de35ce60b0ef48$export$f0a25ea3087686aa = $f3de35ce60b0ef48$var$mod.TextNode;
const $f3de35ce60b0ef48$export$34722a4946cb641e = $f3de35ce60b0ef48$var$mod.UNDO_COMMAND;
const $f3de35ce60b0ef48$export$8d4021544bdece00 = $f3de35ce60b0ef48$var$mod.createCommand;
const $f3de35ce60b0ef48$export$eb02d1ee0d3cac30 = $f3de35ce60b0ef48$var$mod.createEditor;
const $f3de35ce60b0ef48$export$30c13854ab4c9903 = $f3de35ce60b0ef48$var$mod.getNearestEditorFromDOMNode;
const $f3de35ce60b0ef48$export$5ef1a5ca687c7168 = $f3de35ce60b0ef48$var$mod.isBlockDomNode;
const $f3de35ce60b0ef48$export$761df28585b755e8 = $f3de35ce60b0ef48$var$mod.isCurrentlyReadOnlyMode;
const $f3de35ce60b0ef48$export$f5326d78d8d21e1f = $f3de35ce60b0ef48$var$mod.isHTMLAnchorElement;
const $f3de35ce60b0ef48$export$1b3bfaa9684536aa = $f3de35ce60b0ef48$var$mod.isHTMLElement;
const $f3de35ce60b0ef48$export$456fd4e5e0a7123d = $f3de35ce60b0ef48$var$mod.isInlineDomNode;
const $f3de35ce60b0ef48$export$340cc5df988bf401 = $f3de35ce60b0ef48$var$mod.isSelectionCapturedInDecoratorInput;
const $f3de35ce60b0ef48$export$f1b377b21cd6350b = $f3de35ce60b0ef48$var$mod.isSelectionWithinEditor;
const $f3de35ce60b0ef48$export$404db5fc87e4045 = $f3de35ce60b0ef48$var$mod.resetRandomKey;



var $lldlC = parcelRequire("lldlC");

const $b1251cab8096f97a$var$s = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement, $b1251cab8096f97a$var$m = $b1251cab8096f97a$var$s ? (0, $lldlC.useLayoutEffect) : (0, $lldlC.useEffect), $b1251cab8096f97a$var$u = {
    tag: "history-merge"
};
function $b1251cab8096f97a$export$97615ad7610e68cc({ initialConfig: l, children: c }) {
    const p = (0, $lldlC.useMemo)(()=>{
        const { theme: t, namespace: c, editor__DEPRECATED: a, nodes: d, onError: m, editorState: p, html: f } = l, E = (0, $594140ffbcb49f97$export$415f945d0a04b29b)(null, t);
        let h = a || null;
        if (null === h) {
            const e = (0, $f3de35ce60b0ef48$export$eb02d1ee0d3cac30)({
                editable: l.editable,
                html: f,
                namespace: c,
                nodes: d,
                onError: (t)=>m(t, e),
                theme: t
            });
            !function(e, t) {
                if (null === t) return;
                if (void 0 === t) e.update(()=>{
                    const t = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)();
                    if (t.isEmpty()) {
                        const o = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)();
                        t.append(o);
                        const n = $b1251cab8096f97a$var$s ? document.activeElement : null;
                        (null !== (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)() || null !== n && n === e.getRootElement()) && o.select();
                    }
                }, $b1251cab8096f97a$var$u);
                else if (null !== t) switch(typeof t){
                    case "string":
                        {
                            const o = e.parseEditorState(t);
                            e.setEditorState(o, $b1251cab8096f97a$var$u);
                            break;
                        }
                    case "object":
                        e.setEditorState(t, $b1251cab8096f97a$var$u);
                        break;
                    case "function":
                        e.update(()=>{
                            (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().isEmpty() && t(e);
                        }, $b1251cab8096f97a$var$u);
                }
            }(e, p), h = e;
        }
        return [
            h,
            E
        ];
    }, []);
    return $b1251cab8096f97a$var$m(()=>{
        const e = l.editable, [t] = p;
        t.setEditable(void 0 === e || e);
    }, []), (0, $c53f8b07b96ee0c5$exports.jsx)((0, $594140ffbcb49f97$export$89ed468fc445de9).Provider, {
        value: p,
        children: c
    });
}


const $6c8cca9abc369701$var$mod = $b1251cab8096f97a$exports;
const $6c8cca9abc369701$export$97615ad7610e68cc = $6c8cca9abc369701$var$mod.LexicalComposer;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $69008ce182c0a63b$exports = {};

$parcel$defineInteropFlag($69008ce182c0a63b$exports);

$parcel$export($69008ce182c0a63b$exports, "LexicalErrorBoundary", () => $69008ce182c0a63b$export$a8147b707c252e29);
$parcel$export($69008ce182c0a63b$exports, "default", () => $69008ce182c0a63b$export$a8147b707c252e29);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $lldlC = parcelRequire("lldlC");

function $69008ce182c0a63b$var$t(r, e) {
    return $69008ce182c0a63b$var$t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, e) {
        return r.__proto__ = e, r;
    }, $69008ce182c0a63b$var$t(r, e);
}
var $69008ce182c0a63b$var$o = {
    error: null
}, $69008ce182c0a63b$var$n = function(e) {
    var n, a;
    function s() {
        for(var r, t = arguments.length, n = new Array(t), a = 0; a < t; a++)n[a] = arguments[a];
        return (r = e.call.apply(e, [
            this
        ].concat(n)) || this).state = $69008ce182c0a63b$var$o, r.resetErrorBoundary = function() {
            for(var e, t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
            null == r.props.onReset || (e = r.props).onReset.apply(e, o), r.reset();
        }, r;
    }
    a = e, (n = s).prototype = Object.create(a.prototype), n.prototype.constructor = n, $69008ce182c0a63b$var$t(n, a), s.getDerivedStateFromError = function(r) {
        return {
            error: r
        };
    };
    var l = s.prototype;
    return l.reset = function() {
        this.setState($69008ce182c0a63b$var$o);
    }, l.componentDidCatch = function(r, e) {
        var t, o;
        null == (t = (o = this.props).onError) || t.call(o, r, e);
    }, l.componentDidUpdate = function(r, e) {
        var t, o, n, a, s = this.state.error, l = this.props.resetKeys;
        null !== s && null !== e.error && (void 0 === (n = r.resetKeys) && (n = []), void 0 === (a = l) && (a = []), n.length !== a.length || n.some(function(r, e) {
            return !Object.is(r, a[e]);
        })) && (null == (t = (o = this.props).onResetKeysChange) || t.call(o, r.resetKeys, l), this.reset());
    }, l.render = function() {
        var e = this.state.error, t = this.props, o = t.fallbackRender, n = t.FallbackComponent, a = t.fallback;
        if (null !== e) {
            var s = {
                error: e,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if ($lldlC.isValidElement(a)) return a;
            if ("function" == typeof o) return o(s);
            if (n) return $lldlC.createElement(n, s);
            throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
        }
        return this.props.children;
    }, s;
}($lldlC.Component);
function $69008ce182c0a63b$export$a8147b707c252e29({ children: r, onError: t }) {
    return (0, $c53f8b07b96ee0c5$exports.jsx)($69008ce182c0a63b$var$n, {
        fallback: (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            style: {
                border: "1px solid #f00",
                color: "#f00",
                padding: "8px"
            },
            children: "An error was thrown."
        }),
        onError: t,
        children: r
    });
}


const $721ffc860e2471af$var$mod = $69008ce182c0a63b$exports;
const $721ffc860e2471af$export$a8147b707c252e29 = $721ffc860e2471af$var$mod.LexicalErrorBoundary;
var $721ffc860e2471af$export$2e2bcd8739ae039 = $721ffc860e2471af$var$mod.default;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $437602ae74a2acce$exports = {};

$parcel$export($437602ae74a2acce$exports, "RichTextPlugin", () => $437602ae74a2acce$export$26ad95729aab2c7a);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $e4d54b94d66364c8$exports = {};

$parcel$defineInteropFlag($e4d54b94d66364c8$exports);

$parcel$export($e4d54b94d66364c8$exports, "default", () => $e4d54b94d66364c8$export$2e2bcd8739ae039);
$parcel$export($e4d54b94d66364c8$exports, "useLexicalEditable", () => $e4d54b94d66364c8$export$2e2bcd8739ae039);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

var $lldlC = parcelRequire("lldlC");
const $e4d54b94d66364c8$var$u = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? (0, $lldlC.useLayoutEffect) : (0, $lldlC.useEffect);
function $e4d54b94d66364c8$var$c(e) {
    return {
        initialValueFn: ()=>e.isEditable(),
        subscribe: (t)=>e.registerEditableListener(t)
    };
}
function $e4d54b94d66364c8$export$2e2bcd8739ae039() {
    return function(t) {
        const [n] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)(), c = (0, $lldlC.useMemo)(()=>t(n), [
            n,
            t
        ]), a = (0, $lldlC.useRef)(c.initialValueFn()), [l, d] = (0, $lldlC.useState)(a.current);
        return $e4d54b94d66364c8$var$u(()=>{
            const { initialValueFn: e, subscribe: t } = c, n = e();
            return a.current !== n && (a.current = n, d(n)), t((e)=>{
                a.current = e, d(e);
            });
        }, [
            c,
            t
        ]), l;
    }($e4d54b94d66364c8$var$c);
}


const $95e8cca9146e50d7$var$mod = $e4d54b94d66364c8$exports;
var $95e8cca9146e50d7$export$2e2bcd8739ae039 = $95e8cca9146e50d7$var$mod.default;
const $95e8cca9146e50d7$export$216c7470de8af95b = $95e8cca9146e50d7$var$mod.useLexicalEditable;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $13bc5f8a645cb062$exports = {};

$parcel$export($13bc5f8a645cb062$exports, "$rootTextContent", () => $13bc5f8a645cb062$export$30f3f631b921b275);
$parcel$export($13bc5f8a645cb062$exports, "$isRootTextContentEmpty", () => $13bc5f8a645cb062$export$39012e9ed4d8a4a2);
$parcel$export($13bc5f8a645cb062$exports, "$isRootTextContentEmptyCurry", () => $13bc5f8a645cb062$export$4dd45bbaca0ebba9);
$parcel$export($13bc5f8a645cb062$exports, "$canShowPlaceholder", () => $13bc5f8a645cb062$export$8ccd1eb35058e001);
$parcel$export($13bc5f8a645cb062$exports, "$canShowPlaceholderCurry", () => $13bc5f8a645cb062$export$91992121baced35b);
$parcel$export($13bc5f8a645cb062$exports, "$findTextIntersectionFromCharacters", () => $13bc5f8a645cb062$export$36df953e3249f0c7);
$parcel$export($13bc5f8a645cb062$exports, "registerLexicalTextEntity", () => $13bc5f8a645cb062$export$1a95a1271f0bbc64);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
function $13bc5f8a645cb062$export$30f3f631b921b275() {
    return (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getTextContent();
}
function $13bc5f8a645cb062$export$39012e9ed4d8a4a2(t, e = !0) {
    if (t) return !1;
    let n = $13bc5f8a645cb062$export$30f3f631b921b275();
    return e && (n = n.trim()), "" === n;
}
function $13bc5f8a645cb062$export$4dd45bbaca0ebba9(t, e) {
    return ()=>$13bc5f8a645cb062$export$39012e9ed4d8a4a2(t, e);
}
function $13bc5f8a645cb062$export$8ccd1eb35058e001(o) {
    if (!$13bc5f8a645cb062$export$39012e9ed4d8a4a2(o, !1)) return !1;
    const l = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getChildren(), s = l.length;
    if (s > 1) return !1;
    for(let t = 0; t < s; t++){
        const o = l[t];
        if ((0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(o)) return !1;
        if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o)) {
            if (!(0, $f3de35ce60b0ef48$export$1fdda795300c79c6)(o)) return !1;
            if (0 !== o.__indent) return !1;
            const e = o.getChildren(), n = e.length;
            for(let r = 0; r < n; r++){
                const n = e[t];
                if (!(0, $f3de35ce60b0ef48$export$471953706258be2b)(n)) return !1;
            }
        }
    }
    return !0;
}
function $13bc5f8a645cb062$export$91992121baced35b(t) {
    return ()=>$13bc5f8a645cb062$export$8ccd1eb35058e001(t);
}
function $13bc5f8a645cb062$export$36df953e3249f0c7(t, e) {
    let r = t.getFirstChild(), o = 0;
    t: for(; null !== r;){
        if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(r)) {
            const t = r.getFirstChild();
            if (null !== t) {
                r = t;
                continue;
            }
        } else if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(r)) {
            const t = r.getTextContentSize();
            if (o + t > e) return {
                node: r,
                offset: e - o
            };
            o += t;
        }
        const t = r.getNextSibling();
        if (null !== t) {
            r = t;
            continue;
        }
        let l = r.getParent();
        for(; null !== l;){
            const t = l.getNextSibling();
            if (null !== t) {
                r = t;
                continue t;
            }
            l = l.getParent();
        }
        break;
    }
    return null;
}
function $13bc5f8a645cb062$var$d(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $13bc5f8a645cb062$var$x = $13bc5f8a645cb062$var$d(function(t) {
    const e = new URLSearchParams;
    e.append("code", t);
    for(let t = 1; t < arguments.length; t++)e.append("v", arguments[t]);
    throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function $13bc5f8a645cb062$export$1a95a1271f0bbc64(t, e, n, r) {
    const s = (t)=>t instanceof n, u = (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$2785f39dcdec0078)(t.getTextContent());
        e.setFormat(t.getFormat()), t.replace(e);
    };
    return [
        t.registerNodeTransform((0, $f3de35ce60b0ef48$export$f0a25ea3087686aa), (t)=>{
            if (!t.isSimpleText()) return;
            let n, o = t.getPreviousSibling(), l = t.getTextContent(), f = t;
            if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(o)) {
                const n = o.getTextContent(), r = e(n + l);
                if (s(o)) {
                    if (null === r || 0 !== ((t)=>t.getLatest().__mode)(o)) return void u(o);
                    {
                        const e = r.end - n.length;
                        if (e > 0) {
                            const r = n + l.slice(0, e);
                            if (o.select(), o.setTextContent(r), e === l.length) t.remove();
                            else {
                                const n = l.slice(e);
                                t.setTextContent(n);
                            }
                            return;
                        }
                    }
                } else if (null === r || r.start < n.length) return;
            }
            let c = 0;
            for(;;){
                n = e(l);
                let t, g = null === n ? "" : l.slice(n.end);
                if (l = g, "" === g) {
                    const t = f.getNextSibling();
                    if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(t)) {
                        g = f.getTextContent() + t.getTextContent();
                        const n = e(g);
                        if (null === n) return void (s(t) ? u(t) : t.markDirty());
                        if (0 !== n.start) return;
                    }
                }
                if (null === n) return;
                if (0 === n.start && (0, $f3de35ce60b0ef48$export$471953706258be2b)(o) && o.isTextEntity()) {
                    c += n.end;
                    continue;
                }
                0 === n.start ? [t, f] = f.splitText(n.end) : [, t, f] = f.splitText(n.start + c, n.end + c), void 0 === t && $13bc5f8a645cb062$var$x(165, "nodeToReplace");
                const a = r(t);
                if (a.setFormat(t.getFormat()), t.replace(a), null == f) return;
                c = 0, o = a;
            }
        }),
        t.registerNodeTransform(n, (t)=>{
            const n = t.getTextContent(), r = e(n);
            if (null === r || 0 !== r.start) return void u(t);
            if (n.length > r.end) return void t.splitText(r.end);
            const o = t.getPreviousSibling();
            (0, $f3de35ce60b0ef48$export$471953706258be2b)(o) && o.isTextEntity() && (u(o), u(t));
            const l = t.getNextSibling();
            (0, $f3de35ce60b0ef48$export$471953706258be2b)(l) && l.isTextEntity() && (u(l), s(t) && u(t));
        })
    ];
}


const $c0aa6092a78d41a4$var$mod = $13bc5f8a645cb062$exports;
const $c0aa6092a78d41a4$export$8ccd1eb35058e001 = $c0aa6092a78d41a4$var$mod.$canShowPlaceholder;
const $c0aa6092a78d41a4$export$91992121baced35b = $c0aa6092a78d41a4$var$mod.$canShowPlaceholderCurry;
const $c0aa6092a78d41a4$export$36df953e3249f0c7 = $c0aa6092a78d41a4$var$mod.$findTextIntersectionFromCharacters;
const $c0aa6092a78d41a4$export$39012e9ed4d8a4a2 = $c0aa6092a78d41a4$var$mod.$isRootTextContentEmpty;
const $c0aa6092a78d41a4$export$4dd45bbaca0ebba9 = $c0aa6092a78d41a4$var$mod.$isRootTextContentEmptyCurry;
const $c0aa6092a78d41a4$export$30f3f631b921b275 = $c0aa6092a78d41a4$var$mod.$rootTextContent;
const $c0aa6092a78d41a4$export$1a95a1271f0bbc64 = $c0aa6092a78d41a4$var$mod.registerLexicalTextEntity;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $5f90891a4bf12a6d$exports = {};

$parcel$export($5f90891a4bf12a6d$exports, "mergeRegister", () => $5f90891a4bf12a6d$export$d64d64f541cc1835);
$parcel$export($5f90891a4bf12a6d$exports, "positionNodeOnRange", () => $5f90891a4bf12a6d$export$27d1076112acf609);
$parcel$export($5f90891a4bf12a6d$exports, "markSelection", () => $5f90891a4bf12a6d$export$3ba48467d3728463);
$parcel$export($5f90891a4bf12a6d$exports, "CAN_USE_BEFORE_INPUT", () => $5f90891a4bf12a6d$export$7596791c42a3094d);
$parcel$export($5f90891a4bf12a6d$exports, "CAN_USE_DOM", () => $5f90891a4bf12a6d$export$37d2f1e98a187e61);
$parcel$export($5f90891a4bf12a6d$exports, "IS_ANDROID", () => $5f90891a4bf12a6d$export$2760ddee6a71ee7d);
$parcel$export($5f90891a4bf12a6d$exports, "IS_ANDROID_CHROME", () => $5f90891a4bf12a6d$export$129f916e5a4d8e94);
$parcel$export($5f90891a4bf12a6d$exports, "IS_APPLE", () => $5f90891a4bf12a6d$export$d093bd80dddd0842);
$parcel$export($5f90891a4bf12a6d$exports, "IS_APPLE_WEBKIT", () => $5f90891a4bf12a6d$export$e9250b0198928087);
$parcel$export($5f90891a4bf12a6d$exports, "IS_CHROME", () => $5f90891a4bf12a6d$export$265e05392e08df49);
$parcel$export($5f90891a4bf12a6d$exports, "IS_FIREFOX", () => $5f90891a4bf12a6d$export$fa35291248be714f);
$parcel$export($5f90891a4bf12a6d$exports, "IS_IOS", () => $5f90891a4bf12a6d$export$9135b5fce2a2854d);
$parcel$export($5f90891a4bf12a6d$exports, "IS_SAFARI", () => $5f90891a4bf12a6d$export$af54264dae9065e6);
$parcel$export($5f90891a4bf12a6d$exports, "addClassNamesToElement", () => $5f90891a4bf12a6d$export$71781797876b07d6);
$parcel$export($5f90891a4bf12a6d$exports, "removeClassNamesFromElement", () => $5f90891a4bf12a6d$export$b59af601940ff389);
$parcel$export($5f90891a4bf12a6d$exports, "isMimeType", () => $5f90891a4bf12a6d$export$fdc4ce7158f86e77);
$parcel$export($5f90891a4bf12a6d$exports, "mediaFileReader", () => $5f90891a4bf12a6d$export$d7187ecdab7ff06e);
$parcel$export($5f90891a4bf12a6d$exports, "$dfs", () => $5f90891a4bf12a6d$export$a96b5f91cc4d807b);
$parcel$export($5f90891a4bf12a6d$exports, "$getNextRightPreorderNode", () => $5f90891a4bf12a6d$export$4e6d9091ca9005b4);
$parcel$export($5f90891a4bf12a6d$exports, "$getNearestNodeOfType", () => $5f90891a4bf12a6d$export$9f980e09b7e30818);
$parcel$export($5f90891a4bf12a6d$exports, "$getNearestBlockElementAncestorOrThrow", () => $5f90891a4bf12a6d$export$87243b8185b18f91);
$parcel$export($5f90891a4bf12a6d$exports, "$findMatchingParent", () => $5f90891a4bf12a6d$export$57101724ca611500);
$parcel$export($5f90891a4bf12a6d$exports, "registerNestedElementResolver", () => $5f90891a4bf12a6d$export$91c210fb70675873);
$parcel$export($5f90891a4bf12a6d$exports, "$restoreEditorState", () => $5f90891a4bf12a6d$export$695042680df6d70a);
$parcel$export($5f90891a4bf12a6d$exports, "$insertNodeToNearestRoot", () => $5f90891a4bf12a6d$export$4ec669795a8ed6b);
$parcel$export($5f90891a4bf12a6d$exports, "$wrapNodeInElement", () => $5f90891a4bf12a6d$export$4de868a07eee3cf0);
$parcel$export($5f90891a4bf12a6d$exports, "objectKlassEquals", () => $5f90891a4bf12a6d$export$266ae88fb619dc2e);
$parcel$export($5f90891a4bf12a6d$exports, "$filter", () => $5f90891a4bf12a6d$export$f8463c20f5fd3ddc);
$parcel$export($5f90891a4bf12a6d$exports, "$insertFirst", () => $5f90891a4bf12a6d$export$8cc97bf6a3616a50);
$parcel$export($5f90891a4bf12a6d$exports, "calculateZoomLevel", () => $5f90891a4bf12a6d$export$8c73aeb81b5c13e3);
$parcel$export($5f90891a4bf12a6d$exports, "$isEditorIsNestedEditor", () => $5f90891a4bf12a6d$export$bbe8eaa4f00d1da0);
$parcel$export($5f90891a4bf12a6d$exports, "$splitNode", () => $f3de35ce60b0ef48$export$cc2d53c74c1fb2b2);
$parcel$export($5f90891a4bf12a6d$exports, "isBlockDomNode", () => $f3de35ce60b0ef48$export$5ef1a5ca687c7168);
$parcel$export($5f90891a4bf12a6d$exports, "isHTMLAnchorElement", () => $f3de35ce60b0ef48$export$f5326d78d8d21e1f);
$parcel$export($5f90891a4bf12a6d$exports, "isHTMLElement", () => $f3de35ce60b0ef48$export$1b3bfaa9684536aa);
$parcel$export($5f90891a4bf12a6d$exports, "isInlineDomNode", () => $f3de35ce60b0ef48$export$456fd4e5e0a7123d);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $5c8bb1dc4167c577$exports = {};

$parcel$export($5c8bb1dc4167c577$exports, "createDOMRange", () => $5c8bb1dc4167c577$export$b5835907b026f0bc);
$parcel$export($5c8bb1dc4167c577$exports, "createRectsFromDOMRange", () => $5c8bb1dc4167c577$export$3021984b31d6d2e2);
$parcel$export($5c8bb1dc4167c577$exports, "getStyleObjectFromCSS", () => $5c8bb1dc4167c577$export$2ce8a4767ed9993e);
$parcel$export($5c8bb1dc4167c577$exports, "$cloneWithProperties", () => $5c8bb1dc4167c577$export$10b12fb9e226edf0);
$parcel$export($5c8bb1dc4167c577$exports, "$sliceSelectedTextNodeContent", () => $5c8bb1dc4167c577$export$56763a00ff6960e6);
$parcel$export($5c8bb1dc4167c577$exports, "$isAtNodeEnd", () => $5c8bb1dc4167c577$export$899bddb8773a1c9e);
$parcel$export($5c8bb1dc4167c577$exports, "$trimTextContentFromAnchor", () => $5c8bb1dc4167c577$export$440ba083e0a4348);
$parcel$export($5c8bb1dc4167c577$exports, "$addNodeStyle", () => $5c8bb1dc4167c577$export$2c70ac68e537db45);
$parcel$export($5c8bb1dc4167c577$exports, "$patchStyleText", () => $5c8bb1dc4167c577$export$77e498d7a92e253c);
$parcel$export($5c8bb1dc4167c577$exports, "$setBlocksType", () => $5c8bb1dc4167c577$export$b298cd49550a7619);
$parcel$export($5c8bb1dc4167c577$exports, "$wrapNodes", () => $5c8bb1dc4167c577$export$bb69554bb07b9f3d);
$parcel$export($5c8bb1dc4167c577$exports, "$shouldOverrideDefaultCharacterSelection", () => $5c8bb1dc4167c577$export$d0018f657aae1e58);
$parcel$export($5c8bb1dc4167c577$exports, "$moveCaretSelection", () => $5c8bb1dc4167c577$export$fe8c741023d35787);
$parcel$export($5c8bb1dc4167c577$exports, "$isParentElementRTL", () => $5c8bb1dc4167c577$export$4e1eaaa3c34f8a7);
$parcel$export($5c8bb1dc4167c577$exports, "$moveCharacter", () => $5c8bb1dc4167c577$export$2ced31adbb83549a);
$parcel$export($5c8bb1dc4167c577$exports, "$selectAll", () => $5c8bb1dc4167c577$export$824f075b28fd7b6c);
$parcel$export($5c8bb1dc4167c577$exports, "$getSelectionStyleValueForProperty", () => $5c8bb1dc4167c577$export$195af47f5349a5ae);
$parcel$export($5c8bb1dc4167c577$exports, "trimTextContentFromAnchor", () => $5c8bb1dc4167c577$export$fc113f24dcf7dc);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
function $5c8bb1dc4167c577$var$m(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $5c8bb1dc4167c577$var$y = $5c8bb1dc4167c577$var$m(function(e) {
    const t = new URLSearchParams;
    t.append("code", e);
    for(let e = 1; e < arguments.length; e++)t.append("v", arguments[e]);
    throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const $5c8bb1dc4167c577$var$x = new Map;
function $5c8bb1dc4167c577$var$T(e) {
    let t = e;
    for(; null != t;){
        if (t.nodeType === Node.TEXT_NODE) return t;
        t = t.firstChild;
    }
    return null;
}
function $5c8bb1dc4167c577$var$S(e) {
    const t = e.parentNode;
    if (null == t) throw new Error("Should never happen");
    return [
        t,
        Array.from(t.childNodes).indexOf(e)
    ];
}
function $5c8bb1dc4167c577$export$b5835907b026f0bc(t, n, o, l, r) {
    const s = n.getKey(), i = l.getKey(), c = document.createRange();
    let f = t.getElementByKey(s), u = t.getElementByKey(i), a = o, g = r;
    if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(n) && (f = $5c8bb1dc4167c577$var$T(f)), (0, $f3de35ce60b0ef48$export$471953706258be2b)(l) && (u = $5c8bb1dc4167c577$var$T(u)), void 0 === n || void 0 === l || null === f || null === u) return null;
    "BR" === f.nodeName && ([f, a] = $5c8bb1dc4167c577$var$S(f)), "BR" === u.nodeName && ([u, g] = $5c8bb1dc4167c577$var$S(u));
    const d = f.firstChild;
    f === u && null != d && "BR" === d.nodeName && 0 === a && 0 === g && (g = 1);
    try {
        c.setStart(f, a), c.setEnd(u, g);
    } catch (e) {
        return null;
    }
    return !c.collapsed || a === g && s === i || (c.setStart(u, g), c.setEnd(f, a)), c;
}
function $5c8bb1dc4167c577$export$3021984b31d6d2e2(e, t) {
    const n = e.getRootElement();
    if (null === n) return [];
    const o = n.getBoundingClientRect(), l = getComputedStyle(n), r = parseFloat(l.paddingLeft) + parseFloat(l.paddingRight), s = Array.from(t.getClientRects());
    let i, c = s.length;
    s.sort((e, t)=>{
        const n = e.top - t.top;
        return Math.abs(n) <= 3 ? e.left - t.left : n;
    });
    for(let e = 0; e < c; e++){
        const t = s[e], n = i && i.top <= t.top && i.top + i.height > t.top && i.left + i.width > t.left, l = t.width + r === o.width;
        n || l ? (s.splice(e--, 1), c--) : i = t;
    }
    return s;
}
function $5c8bb1dc4167c577$var$w(e) {
    const t = {}, n = e.split(";");
    for (const e of n)if ("" !== e) {
        const [n, o] = e.split(/:([^]+)/);
        n && o && (t[n.trim()] = o.trim());
    }
    return t;
}
function $5c8bb1dc4167c577$export$2ce8a4767ed9993e(e) {
    let t = $5c8bb1dc4167c577$var$x.get(e);
    return void 0 === t && (t = $5c8bb1dc4167c577$var$w(e), $5c8bb1dc4167c577$var$x.set(e, t)), t;
}
function $5c8bb1dc4167c577$export$10b12fb9e226edf0(o) {
    const l = o.constructor.clone(o);
    var r, s;
    return l.__parent = o.__parent, l.__next = o.__next, l.__prev = o.__prev, (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o) && (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(l) ? (s = o, (r = l).__first = s.__first, r.__last = s.__last, r.__size = s.__size, r.__format = s.__format, r.__indent = s.__indent, r.__dir = s.__dir, r) : (0, $f3de35ce60b0ef48$export$471953706258be2b)(o) && (0, $f3de35ce60b0ef48$export$471953706258be2b)(l) ? function(e, t) {
        return e.__format = t.__format, e.__style = t.__style, e.__mode = t.__mode, e.__detail = t.__detail, e;
    }(l, o) : (0, $f3de35ce60b0ef48$export$1fdda795300c79c6)(o) && (0, $f3de35ce60b0ef48$export$1fdda795300c79c6)(l) ? function(e, t) {
        return e.__textFormat = t.__textFormat, e;
    }(l, o) : l;
}
function $5c8bb1dc4167c577$export$56763a00ff6960e6(e, t) {
    const n = e.getStartEndPoints();
    if (t.isSelected(e) && !t.isSegmented() && !t.isToken() && null !== n) {
        const [l, r] = n, s = e.isBackward(), i = l.getNode(), c = r.getNode(), f = t.is(i), u = t.is(c);
        if (f || u) {
            const [n, l] = (0, $f3de35ce60b0ef48$export$5a33b5b9a9d5db8f)(e), r = i.is(c), f = t.is(s ? c : i), u = t.is(s ? i : c);
            let a, g = 0;
            if (r) g = n > l ? l : n, a = n > l ? n : l;
            else if (f) g = s ? l : n, a = void 0;
            else if (u) g = 0, a = s ? n : l;
            return t.__text = t.__text.slice(g, a), t;
        }
    }
    return t;
}
function $5c8bb1dc4167c577$export$899bddb8773a1c9e(e) {
    if ("text" === e.type) return e.offset === e.getNode().getTextContentSize();
    const n = e.getNode();
    return (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(n) || $5c8bb1dc4167c577$var$y(177), e.offset === n.getChildrenSize();
}
function $5c8bb1dc4167c577$export$440ba083e0a4348(n, o, f) {
    let u = o.getNode(), a = f;
    if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(u)) {
        const e = u.getDescendantByIndex(o.offset);
        null !== e && (u = e);
    }
    for(; a > 0 && null !== u;){
        if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(u)) {
            const e = u.getLastDescendant();
            null !== e && (u = e);
        }
        let f = u.getPreviousSibling(), g = 0;
        if (null === f) {
            let e = u.getParentOrThrow(), t = e.getPreviousSibling();
            for(; null === t;){
                if (e = e.getParent(), null === e) {
                    f = null;
                    break;
                }
                t = e.getPreviousSibling();
            }
            null !== e && (g = e.isInline() ? 0 : 2, f = t);
        }
        let d = u.getTextContent();
        "" === d && (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(u) && !u.isInline() && (d = "\n\n");
        const p = d.length;
        if (!(0, $f3de35ce60b0ef48$export$471953706258be2b)(u) || a >= p) {
            const e = u.getParent();
            u.remove(), null == e || 0 !== e.getChildrenSize() || (0, $f3de35ce60b0ef48$export$5b29ca560c2fedab)(e) || e.remove(), a -= p + g, u = f;
        } else {
            const t = u.getKey(), l = n.getEditorState().read(()=>{
                const n = (0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(t);
                return (0, $f3de35ce60b0ef48$export$471953706258be2b)(n) && n.isSimpleText() ? n.getTextContent() : null;
            }), f = p - a, g = d.slice(0, f);
            if (null !== l && l !== d) {
                const e = (0, $f3de35ce60b0ef48$export$846e9407a8b5d98c)();
                let t = u;
                if (u.isSimpleText()) u.setTextContent(l);
                else {
                    const e = (0, $f3de35ce60b0ef48$export$2785f39dcdec0078)(l);
                    u.replace(e), t = e;
                }
                if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && e.isCollapsed()) {
                    const n = e.anchor.offset;
                    t.select(n, n);
                }
            } else if (u.isSimpleText()) {
                const e = o.key === t;
                let n = o.offset;
                n < a && (n = p);
                const l = e ? n - a : 0, r = e ? n : f;
                if (e && 0 === l) {
                    const [e] = u.splitText(l, r);
                    e.remove();
                } else {
                    const [, e] = u.splitText(l, r);
                    e.remove();
                }
            } else {
                const e = (0, $f3de35ce60b0ef48$export$2785f39dcdec0078)(g);
                u.replace(e);
            }
            a = 0;
        }
    }
}
function $5c8bb1dc4167c577$export$2c70ac68e537db45(e) {
    const t = e.getStyle(), n = $5c8bb1dc4167c577$var$w(t);
    $5c8bb1dc4167c577$var$x.set(t, n);
}
function $5c8bb1dc4167c577$var$O(e, t) {
    const n = $5c8bb1dc4167c577$export$2ce8a4767ed9993e("getStyle" in e ? e.getStyle() : e.style), o = Object.entries(t).reduce((e, [t, o])=>(o instanceof Function ? e[t] = o(n[t]) : null === o ? delete e[t] : e[t] = o, e), {
        ...n
    }), l = function(e) {
        let t = "";
        for(const n in e)n && (t += `${n}: ${e[n]};`);
        return t;
    }(o);
    e.setStyle(l), $5c8bb1dc4167c577$var$x.set(l, o);
}
function $5c8bb1dc4167c577$export$77e498d7a92e253c(t, n) {
    const o = t.getNodes(), l = o.length, r = t.getStartEndPoints();
    if (null === r) return;
    const [s, i] = r, f = l - 1;
    let u = o[0], a = o[f];
    if (t.isCollapsed() && (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t)) return void $5c8bb1dc4167c577$var$O(t, n);
    const g = u.getTextContent().length, d = i.offset;
    let p = s.offset;
    const h = s.isBefore(i);
    let _ = h ? p : d, m = h ? d : p;
    const y = h ? s.type : i.type, x = h ? i.type : s.type, T = h ? i.key : s.key;
    if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(u) && _ === g) {
        const t = u.getNextSibling();
        (0, $f3de35ce60b0ef48$export$471953706258be2b)(t) && (p = 0, _ = 0, u = t);
    }
    if (1 === o.length) {
        if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(u) && u.canHaveFormat()) {
            if (_ = "element" === y ? 0 : p > d ? d : p, m = "element" === x ? g : p > d ? p : d, _ === m) return;
            if (0 === _ && m === g) $5c8bb1dc4167c577$var$O(u, n), u.select(_, m);
            else {
                const e = u.splitText(_, m), t = 0 === _ ? e[0] : e[1];
                $5c8bb1dc4167c577$var$O(t, n), t.select(0, m - _);
            }
        }
    } else {
        if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(u) && _ < u.getTextContentSize() && u.canHaveFormat() && (0 !== _ && (u = u.splitText(_)[1], _ = 0, h ? s.set(u.getKey(), _, "text") : i.set(u.getKey(), _, "text")), $5c8bb1dc4167c577$var$O(u, n)), (0, $f3de35ce60b0ef48$export$471953706258be2b)(a) && a.canHaveFormat()) {
            const e = a.getTextContent().length;
            a.__key !== T && 0 !== m && (m = e), m !== e && ([a] = a.splitText(m)), 0 === m && "element" !== x || $5c8bb1dc4167c577$var$O(a, n);
        }
        for(let t = 1; t < f; t++){
            const l = o[t], r = l.getKey();
            (0, $f3de35ce60b0ef48$export$471953706258be2b)(l) && l.canHaveFormat() && r !== u.getKey() && r !== a.getKey() && !l.isToken() && $5c8bb1dc4167c577$var$O(l, n);
        }
    }
}
function $5c8bb1dc4167c577$export$b298cd49550a7619(e, n) {
    if (null === e) return;
    const o = e.getStartEndPoints(), l = o ? o[0] : null;
    if (null !== l && "root" === l.key) {
        const e = n(), t = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)(), o = t.getFirstChild();
        return void (o ? o.replace(e, !0) : t.append(e));
    }
    const r = e.getNodes(), s = null !== l && function(e, t) {
        let n = e;
        for(; null !== n && null !== n.getParent() && !t(n);)n = n.getParentOrThrow();
        return t(n) ? n : null;
    }(l.getNode(), $5c8bb1dc4167c577$var$X);
    s && -1 === r.indexOf(s) && r.push(s);
    for(let e = 0; e < r.length; e++){
        const o = r[e];
        if (!$5c8bb1dc4167c577$var$X(o)) continue;
        (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o) || $5c8bb1dc4167c577$var$y(178);
        const l = n();
        l.setFormat(o.getFormatType()), l.setIndent(o.getIndent()), o.replace(l, !0);
    }
}
function $5c8bb1dc4167c577$var$b(e) {
    return e.getNode().isAttached();
}
function $5c8bb1dc4167c577$var$z(e) {
    let t = e;
    for(; null !== t && !(0, $f3de35ce60b0ef48$export$6f851a24c61146af)(t);){
        const e = t.getLatest(), n = t.getParent();
        0 === e.getChildrenSize() && t.remove(!0), t = n;
    }
}
function $5c8bb1dc4167c577$export$bb69554bb07b9f3d(e, t, n = null) {
    const o = e.getStartEndPoints(), l = o ? o[0] : null, r = e.getNodes(), s = r.length;
    if (null !== l && (0 === s || 1 === s && "element" === l.type && 0 === l.getNode().getChildrenSize())) {
        const e = "text" === l.type ? l.getNode().getParentOrThrow() : l.getNode(), o = e.getChildren();
        let r = t();
        return r.setFormat(e.getFormatType()), r.setIndent(e.getIndent()), o.forEach((e)=>r.append(e)), n && (r = n.append(r)), void e.replace(r);
    }
    let i = null, c = [];
    for(let o = 0; o < s; o++){
        const l = r[o];
        (0, $f3de35ce60b0ef48$export$6f851a24c61146af)(l) ? ($5c8bb1dc4167c577$var$A(e, c, c.length, t, n), c = [], i = l) : null === i || null !== i && (0, $f3de35ce60b0ef48$export$e3d4b782f65c81f1)(l, i) ? c.push(l) : ($5c8bb1dc4167c577$var$A(e, c, c.length, t, n), c = [
            l
        ]);
    }
    $5c8bb1dc4167c577$var$A(e, c, c.length, t, n);
}
function $5c8bb1dc4167c577$var$A(e, n, o, l, r = null) {
    if (0 === n.length) return;
    const i = n[0], f = new Map, a = [];
    let p = (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(i) ? i : i.getParentOrThrow();
    p.isInline() && (p = p.getParentOrThrow());
    let h = !1;
    for(; null !== p;){
        const e = p.getPreviousSibling();
        if (null !== e) {
            p = e, h = !0;
            break;
        }
        if (p = p.getParentOrThrow(), (0, $f3de35ce60b0ef48$export$6f851a24c61146af)(p)) break;
    }
    const _ = new Set;
    for(let e = 0; e < o; e++){
        const o = n[e];
        (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o) && 0 === o.getChildrenSize() && _.add(o.getKey());
    }
    const m = new Set;
    for(let e = 0; e < o; e++){
        const o = n[e];
        let r = o.getParent();
        if (null !== r && r.isInline() && (r = r.getParent()), null !== r && (0, $f3de35ce60b0ef48$export$8d016e0592201ace)(o) && !m.has(o.getKey())) {
            const e = r.getKey();
            if (void 0 === f.get(e)) {
                const n = l();
                n.setFormat(r.getFormatType()), n.setIndent(r.getIndent()), a.push(n), f.set(e, n), r.getChildren().forEach((e)=>{
                    n.append(e), m.add(e.getKey()), (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && e.getChildrenKeys().forEach((e)=>m.add(e));
                }), $5c8bb1dc4167c577$var$z(r);
            }
        } else if (_.has(o.getKey())) {
            (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o) || $5c8bb1dc4167c577$var$y(179);
            const e = l();
            e.setFormat(o.getFormatType()), e.setIndent(o.getIndent()), a.push(e), o.remove(!0);
        }
    }
    if (null !== r) for(let e = 0; e < a.length; e++){
        const t = a[e];
        r.append(t);
    }
    let x = null;
    if ((0, $f3de35ce60b0ef48$export$6f851a24c61146af)(p)) {
        if (h) {
            if (null !== r) p.insertAfter(r);
            else for(let e = a.length - 1; e >= 0; e--){
                const t = a[e];
                p.insertAfter(t);
            }
        } else {
            const e = p.getFirstChild();
            if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && (p = e), null === e) {
                if (r) p.append(r);
                else for(let e = 0; e < a.length; e++){
                    const t = a[e];
                    p.append(t), x = t;
                }
            } else if (null !== r) e.insertBefore(r);
            else for(let t = 0; t < a.length; t++){
                const n = a[t];
                e.insertBefore(n), x = n;
            }
        }
    } else if (r) p.insertAfter(r);
    else for(let e = a.length - 1; e >= 0; e--){
        const t = a[e];
        p.insertAfter(t), x = t;
    }
    const T = (0, $f3de35ce60b0ef48$export$846e9407a8b5d98c)();
    (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(T) && $5c8bb1dc4167c577$var$b(T.anchor) && $5c8bb1dc4167c577$var$b(T.focus) ? (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(T.clone()) : null !== x ? x.selectEnd() : e.dirty = !0;
}
function $5c8bb1dc4167c577$export$d0018f657aae1e58(e, n) {
    const o = (0, $f3de35ce60b0ef48$export$c4b907be1879d8c1)(e.focus, n);
    return (0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(o) && !o.isIsolated() || (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o) && !o.isInline() && !o.canBeEmpty();
}
function $5c8bb1dc4167c577$export$fe8c741023d35787(e, t, n, o) {
    e.modify(t ? "extend" : "move", n, o);
}
function $5c8bb1dc4167c577$export$4e1eaaa3c34f8a7(e) {
    const t = e.anchor.getNode();
    return "rtl" === ((0, $f3de35ce60b0ef48$export$5b29ca560c2fedab)(t) ? t : t.getParentOrThrow()).getDirection();
}
function $5c8bb1dc4167c577$export$2ced31adbb83549a(e, t, n) {
    const o = $5c8bb1dc4167c577$export$4e1eaaa3c34f8a7(e);
    $5c8bb1dc4167c577$export$fe8c741023d35787(e, t, n ? !o : o, "character");
}
function $5c8bb1dc4167c577$export$824f075b28fd7b6c(n) {
    const o = n.anchor, l = n.focus, r = o.getNode().getTopLevelElementOrThrow().getParentOrThrow();
    let s = r.getFirstDescendant(), i = r.getLastDescendant(), c = "element", f = "element", u = 0;
    (0, $f3de35ce60b0ef48$export$471953706258be2b)(s) ? c = "text" : (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(s) || null === s || (s = s.getParentOrThrow()), (0, $f3de35ce60b0ef48$export$471953706258be2b)(i) ? (f = "text", u = i.getTextContentSize()) : (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(i) || null === i || (i = i.getParentOrThrow()), s && i && (o.set(s.getKey(), 0, c), l.set(i.getKey(), u, f));
}
function $5c8bb1dc4167c577$var$j(e, t, n) {
    const o = $5c8bb1dc4167c577$export$2ce8a4767ed9993e(e.getStyle());
    return null !== o && o[t] || n;
}
function $5c8bb1dc4167c577$export$195af47f5349a5ae(t, n, o = "") {
    let l = null;
    const r = t.getNodes(), s = t.anchor, i = t.focus, f = t.isBackward(), u = f ? i.offset : s.offset, a = f ? i.getNode() : s.getNode();
    if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) && t.isCollapsed() && "" !== t.style) {
        const e = $5c8bb1dc4167c577$export$2ce8a4767ed9993e(t.style);
        if (null !== e && n in e) return e[n];
    }
    for(let t = 0; t < r.length; t++){
        const s = r[t];
        if ((0 === t || 0 !== u || !s.is(a)) && (0, $f3de35ce60b0ef48$export$471953706258be2b)(s)) {
            const e = $5c8bb1dc4167c577$var$j(s, n, o);
            if (null === l) l = e;
            else if (l !== e) {
                l = "";
                break;
            }
        }
    }
    return null === l ? o : l;
}
function $5c8bb1dc4167c577$var$X(n) {
    if ((0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(n)) return !1;
    if (!(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(n) || (0, $f3de35ce60b0ef48$export$6f851a24c61146af)(n)) return !1;
    const o = n.getFirstChild(), l = null === o || (0, $f3de35ce60b0ef48$export$b16330e40aa25c4e)(o) || (0, $f3de35ce60b0ef48$export$471953706258be2b)(o) || o.isInline();
    return !n.isInline() && !1 !== n.canBeEmpty() && l;
}
const $5c8bb1dc4167c577$export$fc113f24dcf7dc = $5c8bb1dc4167c577$export$440ba083e0a4348;


const $af76071cb3cbd572$var$mod = $5c8bb1dc4167c577$exports;
const $af76071cb3cbd572$export$2c70ac68e537db45 = $af76071cb3cbd572$var$mod.$addNodeStyle;
const $af76071cb3cbd572$export$10b12fb9e226edf0 = $af76071cb3cbd572$var$mod.$cloneWithProperties;
const $af76071cb3cbd572$export$195af47f5349a5ae = $af76071cb3cbd572$var$mod.$getSelectionStyleValueForProperty;
const $af76071cb3cbd572$export$899bddb8773a1c9e = $af76071cb3cbd572$var$mod.$isAtNodeEnd;
const $af76071cb3cbd572$export$4e1eaaa3c34f8a7 = $af76071cb3cbd572$var$mod.$isParentElementRTL;
const $af76071cb3cbd572$export$fe8c741023d35787 = $af76071cb3cbd572$var$mod.$moveCaretSelection;
const $af76071cb3cbd572$export$2ced31adbb83549a = $af76071cb3cbd572$var$mod.$moveCharacter;
const $af76071cb3cbd572$export$77e498d7a92e253c = $af76071cb3cbd572$var$mod.$patchStyleText;
const $af76071cb3cbd572$export$824f075b28fd7b6c = $af76071cb3cbd572$var$mod.$selectAll;
const $af76071cb3cbd572$export$b298cd49550a7619 = $af76071cb3cbd572$var$mod.$setBlocksType;
const $af76071cb3cbd572$export$d0018f657aae1e58 = $af76071cb3cbd572$var$mod.$shouldOverrideDefaultCharacterSelection;
const $af76071cb3cbd572$export$56763a00ff6960e6 = $af76071cb3cbd572$var$mod.$sliceSelectedTextNodeContent;
const $af76071cb3cbd572$export$440ba083e0a4348 = $af76071cb3cbd572$var$mod.$trimTextContentFromAnchor;
const $af76071cb3cbd572$export$bb69554bb07b9f3d = $af76071cb3cbd572$var$mod.$wrapNodes;
const $af76071cb3cbd572$export$b5835907b026f0bc = $af76071cb3cbd572$var$mod.createDOMRange;
const $af76071cb3cbd572$export$3021984b31d6d2e2 = $af76071cb3cbd572$var$mod.createRectsFromDOMRange;
const $af76071cb3cbd572$export$2ce8a4767ed9993e = $af76071cb3cbd572$var$mod.getStyleObjectFromCSS;
const $af76071cb3cbd572$export$fc113f24dcf7dc = $af76071cb3cbd572$var$mod.trimTextContentFromAnchor;



function $5f90891a4bf12a6d$var$g(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $5f90891a4bf12a6d$var$p = $5f90891a4bf12a6d$var$g(function(e) {
    const t = new URLSearchParams;
    t.append("code", e);
    for(let e = 1; e < arguments.length; e++)t.append("v", arguments[e]);
    throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const $5f90891a4bf12a6d$var$h = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement, $5f90891a4bf12a6d$var$m = $5f90891a4bf12a6d$var$h && "documentMode" in document ? document.documentMode : null, $5f90891a4bf12a6d$var$v = $5f90891a4bf12a6d$var$h && /Mac|iPod|iPhone|iPad/.test(navigator.platform), $5f90891a4bf12a6d$var$y = $5f90891a4bf12a6d$var$h && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), $5f90891a4bf12a6d$var$w = !(!$5f90891a4bf12a6d$var$h || !("InputEvent" in window) || $5f90891a4bf12a6d$var$m) && "getTargetRanges" in new window.InputEvent("input"), $5f90891a4bf12a6d$var$E = $5f90891a4bf12a6d$var$h && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), $5f90891a4bf12a6d$var$x = $5f90891a4bf12a6d$var$h && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, $5f90891a4bf12a6d$var$P = $5f90891a4bf12a6d$var$h && /Android/.test(navigator.userAgent), $5f90891a4bf12a6d$var$S = $5f90891a4bf12a6d$var$h && /^(?=.*Chrome).*/i.test(navigator.userAgent), $5f90891a4bf12a6d$var$N = $5f90891a4bf12a6d$var$h && $5f90891a4bf12a6d$var$P && $5f90891a4bf12a6d$var$S, $5f90891a4bf12a6d$var$A = $5f90891a4bf12a6d$var$h && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !$5f90891a4bf12a6d$var$S;
function $5f90891a4bf12a6d$var$L(...e) {
    const t = [];
    for (const n of e)if (n && "string" == typeof n) for (const [e] of n.matchAll(/\S+/g))t.push(e);
    return t;
}
function $5f90891a4bf12a6d$export$d64d64f541cc1835(...e) {
    return ()=>{
        for(let t = e.length - 1; t >= 0; t--)e[t]();
        e.length = 0;
    };
}
function $5f90891a4bf12a6d$var$T(e) {
    return `${e}px`;
}
const $5f90891a4bf12a6d$var$_ = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
};
function $5f90891a4bf12a6d$export$27d1076112acf609(t, n, o) {
    let r = null, l = null, i = null, s = [];
    const u = document.createElement("div");
    function c() {
        null === r && $5f90891a4bf12a6d$var$p(182), null === l && $5f90891a4bf12a6d$var$p(183);
        const { left: i, top: c } = r.getBoundingClientRect(), f = l, a = (0, $af76071cb3cbd572$export$3021984b31d6d2e2)(t, n);
        u.isConnected || f.append(u);
        let d = !1;
        for(let e = 0; e < a.length; e++){
            const t = a[e], n = s[e] || document.createElement("div"), o = n.style;
            "absolute" !== o.position && (o.position = "absolute", d = !0);
            const r = $5f90891a4bf12a6d$var$T(t.left - i);
            o.left !== r && (o.left = r, d = !0);
            const l = $5f90891a4bf12a6d$var$T(t.top - c);
            o.top !== l && (n.style.top = l, d = !0);
            const f = $5f90891a4bf12a6d$var$T(t.width);
            o.width !== f && (n.style.width = f, d = !0);
            const g = $5f90891a4bf12a6d$var$T(t.height);
            o.height !== g && (n.style.height = g, d = !0), n.parentNode !== u && (u.append(n), d = !0), s[e] = n;
        }
        for(; s.length > a.length;)s.pop();
        d && o(s);
    }
    function f() {
        l = null, r = null, null !== i && i.disconnect(), i = null, u.remove();
        for (const e of s)e.remove();
        s = [];
    }
    const a = t.registerRootListener(function e() {
        const n = t.getRootElement();
        if (null === n) return f();
        const o = n.parentElement;
        if (!(o instanceof HTMLElement)) return f();
        f(), r = n, l = o, i = new MutationObserver((n)=>{
            const o = t.getRootElement(), i = o && o.parentElement;
            if (o !== r || i !== l) return e();
            for (const e of n)if (!u.contains(e.target)) return c();
        }), i.observe(o, $5f90891a4bf12a6d$var$_), c();
    });
    return ()=>{
        a(), f();
    };
}
function $5f90891a4bf12a6d$export$3ba48467d3728463(e, t) {
    let l = null, i = null, s = null, u = null, c = ()=>{};
    function f(f) {
        f.read(()=>{
            const f = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
            if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(f)) return l = null, i = null, s = null, u = null, c(), void (c = ()=>{});
            const { anchor: a, focus: d } = f, g = a.getNode(), h = g.getKey(), m = a.offset, v = d.getNode(), y = v.getKey(), w = d.offset, E = e.getElementByKey(h), x = e.getElementByKey(y), P = null === l || null === E || m !== i || h !== l.getKey() || g !== l && (!(l instanceof (0, $f3de35ce60b0ef48$export$f0a25ea3087686aa)) || g.updateDOM(l, E, e._config)), S = null === s || null === x || w !== u || y !== s.getKey() || v !== s && (!(s instanceof (0, $f3de35ce60b0ef48$export$f0a25ea3087686aa)) || v.updateDOM(s, x, e._config));
            if (P || S) {
                const n = e.getElementByKey(a.getNode().getKey()), o = e.getElementByKey(d.getNode().getKey());
                if (null !== n && null !== o && "SPAN" === n.tagName && "SPAN" === o.tagName) {
                    const r = document.createRange();
                    let l, i, s, u;
                    d.isBefore(a) ? (l = o, i = d.offset, s = n, u = a.offset) : (l = n, i = a.offset, s = o, u = d.offset);
                    const f = l.firstChild;
                    null === f && $5f90891a4bf12a6d$var$p(181);
                    const g = s.firstChild;
                    null === g && $5f90891a4bf12a6d$var$p(181), r.setStart(f, i), r.setEnd(g, u), c(), c = $5f90891a4bf12a6d$export$27d1076112acf609(e, r, (e)=>{
                        for (const t of e){
                            const e = t.style;
                            "Highlight" !== e.background && (e.background = "Highlight"), "HighlightText" !== e.color && (e.color = "HighlightText"), "-1" !== e.zIndex && (e.zIndex = "-1"), "none" !== e.pointerEvents && (e.pointerEvents = "none"), e.marginTop !== $5f90891a4bf12a6d$var$T(-1.5) && (e.marginTop = $5f90891a4bf12a6d$var$T(-1.5)), e.paddingTop !== $5f90891a4bf12a6d$var$T(4) && (e.paddingTop = $5f90891a4bf12a6d$var$T(4)), e.paddingBottom !== $5f90891a4bf12a6d$var$T(0) && (e.paddingBottom = $5f90891a4bf12a6d$var$T(0));
                        }
                        void 0 !== t && t(e);
                    });
                }
            }
            l = g, i = m, s = v, u = w;
        });
    }
    return f(e.getEditorState()), $5f90891a4bf12a6d$export$d64d64f541cc1835(e.registerUpdateListener(({ editorState: e })=>f(e)), c, ()=>{
        c();
    });
}
const $5f90891a4bf12a6d$export$7596791c42a3094d = $5f90891a4bf12a6d$var$w, $5f90891a4bf12a6d$export$37d2f1e98a187e61 = $5f90891a4bf12a6d$var$h, $5f90891a4bf12a6d$export$2760ddee6a71ee7d = $5f90891a4bf12a6d$var$P, $5f90891a4bf12a6d$export$129f916e5a4d8e94 = $5f90891a4bf12a6d$var$N, $5f90891a4bf12a6d$export$d093bd80dddd0842 = $5f90891a4bf12a6d$var$v, $5f90891a4bf12a6d$export$e9250b0198928087 = $5f90891a4bf12a6d$var$A, $5f90891a4bf12a6d$export$265e05392e08df49 = $5f90891a4bf12a6d$var$S, $5f90891a4bf12a6d$export$fa35291248be714f = $5f90891a4bf12a6d$var$y, $5f90891a4bf12a6d$export$9135b5fce2a2854d = $5f90891a4bf12a6d$var$x, $5f90891a4bf12a6d$export$af54264dae9065e6 = $5f90891a4bf12a6d$var$E;
function $5f90891a4bf12a6d$export$71781797876b07d6(e, ...t) {
    const n = $5f90891a4bf12a6d$var$L(...t);
    n.length > 0 && e.classList.add(...n);
}
function $5f90891a4bf12a6d$export$b59af601940ff389(e, ...t) {
    const n = $5f90891a4bf12a6d$var$L(...t);
    n.length > 0 && e.classList.remove(...n);
}
function $5f90891a4bf12a6d$export$fdc4ce7158f86e77(e, t) {
    for (const n of t)if (e.type.startsWith(n)) return !0;
    return !1;
}
function $5f90891a4bf12a6d$export$d7187ecdab7ff06e(e, t) {
    const n = e[Symbol.iterator]();
    return new Promise((e, o)=>{
        const r = [], l = ()=>{
            const { done: i, value: s } = n.next();
            if (i) return e(r);
            const u = new FileReader;
            u.addEventListener("error", o), u.addEventListener("load", ()=>{
                const e = u.result;
                "string" == typeof e && r.push({
                    file: s,
                    result: e
                }), l();
            }), $5f90891a4bf12a6d$export$fdc4ce7158f86e77(s, t) ? u.readAsDataURL(s) : l();
        };
        l();
    });
}
function $5f90891a4bf12a6d$export$a96b5f91cc4d807b(e, t) {
    const n = [], o = (e || (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)()).getLatest(), r = t || (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o) && o.getLastDescendant() || o;
    let s = o, u = function(e) {
        let t = e, n = 0;
        for(; null !== (t = t.getParent());)n++;
        return n;
    }(s);
    for(; null !== s && !s.is(r);)if (n.push({
        depth: u,
        node: s
    }), (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(s) && s.getChildrenSize() > 0) s = s.getFirstChild(), u++;
    else {
        let e = null;
        for(; null === e && null !== s;)e = s.getNextSibling(), null === e ? (s = s.getParent(), u--) : s = e;
    }
    return null !== s && s.is(r) && n.push({
        depth: u,
        node: s
    }), n;
}
function $5f90891a4bf12a6d$export$4e6d9091ca9005b4(e) {
    let t = e;
    if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(t) && t.getChildrenSize() > 0) t = t.getLastChild();
    else {
        let e = null;
        for(; null === e && null !== t;)e = t.getPreviousSibling(), t = null === e ? t.getParent() : e;
    }
    return t;
}
function $5f90891a4bf12a6d$export$9f980e09b7e30818(e, t) {
    let n = e;
    for(; null != n;){
        if (n instanceof t) return n;
        n = n.getParent();
    }
    return null;
}
function $5f90891a4bf12a6d$export$87243b8185b18f91(e) {
    const t = $5f90891a4bf12a6d$export$57101724ca611500(e, (e)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && !e.isInline());
    return (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(t) || $5f90891a4bf12a6d$var$p(4, e.__key), t;
}
const $5f90891a4bf12a6d$export$57101724ca611500 = (e, t)=>{
    let n = e;
    for(; n !== (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)() && null != n;){
        if (t(n)) return n;
        n = n.getParent();
    }
    return null;
};
function $5f90891a4bf12a6d$export$91c210fb70675873(e, t, n, o) {
    const r = (e)=>e instanceof t;
    return e.registerNodeTransform(t, (e)=>{
        const t = ((e)=>{
            const t = e.getChildren();
            for(let e = 0; e < t.length; e++){
                const n = t[e];
                if (r(n)) return null;
            }
            let n = e, o = e;
            for(; null !== n;)if (o = n, n = n.getParent(), r(n)) return {
                child: o,
                parent: n
            };
            return null;
        })(e);
        if (null !== t) {
            const { child: r, parent: l } = t;
            if (r.is(e)) {
                o(l, e);
                const t = r.getNextSiblings(), i = t.length;
                if (l.insertAfter(r), 0 !== i) {
                    const e = n(l);
                    r.insertAfter(e);
                    for(let n = 0; n < i; n++)e.append(t[n]);
                }
                l.canBeEmpty() || 0 !== l.getChildrenSize() || l.remove();
            }
        }
    });
}
function $5f90891a4bf12a6d$export$695042680df6d70a(e, n) {
    const o = new Map, r = e._pendingEditorState;
    for (const [e, r] of n._nodeMap){
        const n = (0, $af76071cb3cbd572$export$10b12fb9e226edf0)(r);
        (0, $f3de35ce60b0ef48$export$471953706258be2b)(n) && ((0, $f3de35ce60b0ef48$export$471953706258be2b)(r) || $5f90891a4bf12a6d$var$p(180), n.__text = r.__text), o.set(e, n);
    }
    r && (r._nodeMap = o), e._dirtyType = 2;
    const l = n._selection;
    (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(null === l ? null : l.clone());
}
function $5f90891a4bf12a6d$export$4ec669795a8ed6b(e) {
    const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)() || (0, $f3de35ce60b0ef48$export$846e9407a8b5d98c)();
    if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t)) {
        const { focus: n } = t, o = n.getNode(), r = n.offset;
        if ((0, $f3de35ce60b0ef48$export$6f851a24c61146af)(o)) {
            const t = o.getChildAtIndex(r);
            null == t ? o.append(e) : t.insertBefore(e), e.selectNext();
        } else {
            let t, n;
            (0, $f3de35ce60b0ef48$export$471953706258be2b)(o) ? (t = o.getParentOrThrow(), n = o.getIndexWithinParent(), r > 0 && (n += 1, o.splitText(r))) : (t = o, n = r);
            const [, l] = (0, $f3de35ce60b0ef48$export$cc2d53c74c1fb2b2)(t, n);
            l.insertBefore(e), l.selectStart();
        }
    } else {
        if (null != t) {
            const n = t.getNodes();
            n[n.length - 1].getTopLevelElementOrThrow().insertAfter(e);
        } else (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().append(e);
        const n = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)();
        e.insertAfter(n), n.select();
    }
    return e.getLatest();
}
function $5f90891a4bf12a6d$export$4de868a07eee3cf0(e, t) {
    const n = t();
    return e.replace(n), n.append(e), n;
}
function $5f90891a4bf12a6d$export$266ae88fb619dc2e(e, t) {
    return null !== e && Object.getPrototypeOf(e).constructor.name === t.name;
}
function $5f90891a4bf12a6d$export$f8463c20f5fd3ddc(e, t) {
    const n = [];
    for(let o = 0; o < e.length; o++){
        const r = t(e[o]);
        null !== r && n.push(r);
    }
    return n;
}
function $5f90891a4bf12a6d$export$8cc97bf6a3616a50(e, t) {
    const n = e.getFirstChild();
    null !== n ? n.insertBefore(t) : e.append(t);
}
function $5f90891a4bf12a6d$export$8c73aeb81b5c13e3(e) {
    if ($5f90891a4bf12a6d$export$fa35291248be714f) return 1;
    let t = 1;
    for(; e;)t *= Number(window.getComputedStyle(e).getPropertyValue("zoom")), e = e.parentElement;
    return t;
}
function $5f90891a4bf12a6d$export$bbe8eaa4f00d1da0(e) {
    return null !== e._parentEditor;
}


const $70f33588e7e4964f$var$mod = $5f90891a4bf12a6d$exports;
const $70f33588e7e4964f$export$a96b5f91cc4d807b = $70f33588e7e4964f$var$mod.$dfs;
const $70f33588e7e4964f$export$f8463c20f5fd3ddc = $70f33588e7e4964f$var$mod.$filter;
const $70f33588e7e4964f$export$57101724ca611500 = $70f33588e7e4964f$var$mod.$findMatchingParent;
const $70f33588e7e4964f$export$87243b8185b18f91 = $70f33588e7e4964f$var$mod.$getNearestBlockElementAncestorOrThrow;
const $70f33588e7e4964f$export$9f980e09b7e30818 = $70f33588e7e4964f$var$mod.$getNearestNodeOfType;
const $70f33588e7e4964f$export$4e6d9091ca9005b4 = $70f33588e7e4964f$var$mod.$getNextRightPreorderNode;
const $70f33588e7e4964f$export$8cc97bf6a3616a50 = $70f33588e7e4964f$var$mod.$insertFirst;
const $70f33588e7e4964f$export$4ec669795a8ed6b = $70f33588e7e4964f$var$mod.$insertNodeToNearestRoot;
const $70f33588e7e4964f$export$bbe8eaa4f00d1da0 = $70f33588e7e4964f$var$mod.$isEditorIsNestedEditor;
const $70f33588e7e4964f$export$695042680df6d70a = $70f33588e7e4964f$var$mod.$restoreEditorState;
const $70f33588e7e4964f$export$cc2d53c74c1fb2b2 = $70f33588e7e4964f$var$mod.$splitNode;
const $70f33588e7e4964f$export$4de868a07eee3cf0 = $70f33588e7e4964f$var$mod.$wrapNodeInElement;
const $70f33588e7e4964f$export$7596791c42a3094d = $70f33588e7e4964f$var$mod.CAN_USE_BEFORE_INPUT;
const $70f33588e7e4964f$export$37d2f1e98a187e61 = $70f33588e7e4964f$var$mod.CAN_USE_DOM;
const $70f33588e7e4964f$export$2760ddee6a71ee7d = $70f33588e7e4964f$var$mod.IS_ANDROID;
const $70f33588e7e4964f$export$129f916e5a4d8e94 = $70f33588e7e4964f$var$mod.IS_ANDROID_CHROME;
const $70f33588e7e4964f$export$d093bd80dddd0842 = $70f33588e7e4964f$var$mod.IS_APPLE;
const $70f33588e7e4964f$export$e9250b0198928087 = $70f33588e7e4964f$var$mod.IS_APPLE_WEBKIT;
const $70f33588e7e4964f$export$265e05392e08df49 = $70f33588e7e4964f$var$mod.IS_CHROME;
const $70f33588e7e4964f$export$fa35291248be714f = $70f33588e7e4964f$var$mod.IS_FIREFOX;
const $70f33588e7e4964f$export$9135b5fce2a2854d = $70f33588e7e4964f$var$mod.IS_IOS;
const $70f33588e7e4964f$export$af54264dae9065e6 = $70f33588e7e4964f$var$mod.IS_SAFARI;
const $70f33588e7e4964f$export$71781797876b07d6 = $70f33588e7e4964f$var$mod.addClassNamesToElement;
const $70f33588e7e4964f$export$8c73aeb81b5c13e3 = $70f33588e7e4964f$var$mod.calculateZoomLevel;
const $70f33588e7e4964f$export$5ef1a5ca687c7168 = $70f33588e7e4964f$var$mod.isBlockDomNode;
const $70f33588e7e4964f$export$f5326d78d8d21e1f = $70f33588e7e4964f$var$mod.isHTMLAnchorElement;
const $70f33588e7e4964f$export$1b3bfaa9684536aa = $70f33588e7e4964f$var$mod.isHTMLElement;
const $70f33588e7e4964f$export$456fd4e5e0a7123d = $70f33588e7e4964f$var$mod.isInlineDomNode;
const $70f33588e7e4964f$export$fdc4ce7158f86e77 = $70f33588e7e4964f$var$mod.isMimeType;
const $70f33588e7e4964f$export$3ba48467d3728463 = $70f33588e7e4964f$var$mod.markSelection;
const $70f33588e7e4964f$export$d7187ecdab7ff06e = $70f33588e7e4964f$var$mod.mediaFileReader;
const $70f33588e7e4964f$export$d64d64f541cc1835 = $70f33588e7e4964f$var$mod.mergeRegister;
const $70f33588e7e4964f$export$266ae88fb619dc2e = $70f33588e7e4964f$var$mod.objectKlassEquals;
const $70f33588e7e4964f$export$27d1076112acf609 = $70f33588e7e4964f$var$mod.positionNodeOnRange;
const $70f33588e7e4964f$export$91c210fb70675873 = $70f33588e7e4964f$var$mod.registerNestedElementResolver;
const $70f33588e7e4964f$export$b59af601940ff389 = $70f33588e7e4964f$var$mod.removeClassNamesFromElement;



var $lldlC = parcelRequire("lldlC");


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $322652e45ad081b8$exports = {};

$parcel$export($322652e45ad081b8$exports, "registerDragonSupport", () => $322652e45ad081b8$export$14cafee2f188b8bc);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
function $322652e45ad081b8$export$14cafee2f188b8bc(o) {
    const i = window.location.origin, a = (a)=>{
        if (a.origin !== i) return;
        const r = o.getRootElement();
        if (document.activeElement !== r) return;
        const s = a.data;
        if ("string" == typeof s) {
            let i;
            try {
                i = JSON.parse(s);
            } catch (e) {
                return;
            }
            if (i && "nuanria_messaging" === i.protocol && "request" === i.type) {
                const r = i.payload;
                if (r && "makeChanges" === r.functionId) {
                    const i = r.args;
                    if (i) {
                        const [r, s, c, g, d, f] = i;
                        o.update(()=>{
                            const o = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
                            if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(o)) {
                                const e = o.anchor;
                                let t = e.getNode(), i = 0, f = 0;
                                if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(t) && r >= 0 && s >= 0 && (i = r, f = r + s, o.setTextNodeRange(t, i, t, f)), i === f && "" === c || (o.insertRawText(c), t = e.getNode()), (0, $f3de35ce60b0ef48$export$471953706258be2b)(t)) {
                                    i = g, f = g + d;
                                    const e = t.getTextContentSize();
                                    i = i > e ? e : i, f = f > e ? e : f, o.setTextNodeRange(t, i, t, f);
                                }
                                a.stopImmediatePropagation();
                            }
                        });
                    }
                }
            }
        }
    };
    return window.addEventListener("message", a, !0), ()=>{
        window.removeEventListener("message", a, !0);
    };
}


const $e2ac9c7565518cf7$var$mod = $322652e45ad081b8$exports;
const $e2ac9c7565518cf7$export$14cafee2f188b8bc = $e2ac9c7565518cf7$var$mod.registerDragonSupport;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $e6accc392cd3bc5a$exports = {};

$parcel$export($e6accc392cd3bc5a$exports, "DRAG_DROP_PASTE", () => $e6accc392cd3bc5a$export$d4a62c60df78432);
$parcel$export($e6accc392cd3bc5a$exports, "QuoteNode", () => $e6accc392cd3bc5a$export$c64d7b2153096538);
$parcel$export($e6accc392cd3bc5a$exports, "$createQuoteNode", () => $e6accc392cd3bc5a$export$b8120bbdf1338c27);
$parcel$export($e6accc392cd3bc5a$exports, "$isQuoteNode", () => $e6accc392cd3bc5a$export$1c183570990c020a);
$parcel$export($e6accc392cd3bc5a$exports, "HeadingNode", () => $e6accc392cd3bc5a$export$90fecd23277fcde2);
$parcel$export($e6accc392cd3bc5a$exports, "$createHeadingNode", () => $e6accc392cd3bc5a$export$29cdf7c75bd686cc);
$parcel$export($e6accc392cd3bc5a$exports, "$isHeadingNode", () => $e6accc392cd3bc5a$export$78b6c84a5d5b8b31);
$parcel$export($e6accc392cd3bc5a$exports, "eventFiles", () => $e6accc392cd3bc5a$export$1faf88b1db1d6bb9);
$parcel$export($e6accc392cd3bc5a$exports, "registerRichText", () => $e6accc392cd3bc5a$export$8d6ed18fd12861da);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $fc265dd3ee912112$exports = {};

$parcel$export($fc265dd3ee912112$exports, "$getHtmlContent", () => $fc265dd3ee912112$export$492f5b1e57660d71);
$parcel$export($fc265dd3ee912112$exports, "$getLexicalContent", () => $fc265dd3ee912112$export$431c00b4f604f022);
$parcel$export($fc265dd3ee912112$exports, "$generateJSONFromSelectedNodes", () => $fc265dd3ee912112$export$f84df9bec41e6d85);
$parcel$export($fc265dd3ee912112$exports, "$insertDataTransferForPlainText", () => $fc265dd3ee912112$export$f4723b67d276bbb7);
$parcel$export($fc265dd3ee912112$exports, "$insertDataTransferForRichText", () => $fc265dd3ee912112$export$ca1422672b17f174);
$parcel$export($fc265dd3ee912112$exports, "$insertGeneratedNodes", () => $fc265dd3ee912112$export$9201304b1e00ff59);
$parcel$export($fc265dd3ee912112$exports, "$generateNodesFromSerializedNodes", () => $fc265dd3ee912112$export$c5c00050c34078e0);
$parcel$export($fc265dd3ee912112$exports, "copyToClipboard", () => $fc265dd3ee912112$export$2cdf1b96a9f86d16);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $2157cf7c2d35dd91$exports = {};

$parcel$export($2157cf7c2d35dd91$exports, "$generateNodesFromDOM", () => $2157cf7c2d35dd91$export$4b20ea127dfd853d);
$parcel$export($2157cf7c2d35dd91$exports, "$generateHtmlFromNodes", () => $2157cf7c2d35dd91$export$a1c399724d359ef8);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


function $2157cf7c2d35dd91$export$4b20ea127dfd853d(e, n) {
    const t = n.body ? n.body.childNodes : [];
    let o = [];
    const l = [];
    for(let n = 0; n < t.length; n++){
        const r = t[n];
        if (!$2157cf7c2d35dd91$var$m.has(r.nodeName)) {
            const n = $2157cf7c2d35dd91$var$g(r, e, l, !1);
            null !== n && (o = o.concat(n));
        }
    }
    return function(e) {
        for (const n of e)n.getNextSibling() instanceof (0, $f3de35ce60b0ef48$export$82a585c2442a6dd6) && n.insertAfter((0, $f3de35ce60b0ef48$export$4ccaf7d0d16ab4c)());
        for (const n of e){
            const e = n.getChildren();
            for (const t of e)n.insertBefore(t);
            n.remove();
        }
    }(l), o;
}
function $2157cf7c2d35dd91$export$a1c399724d359ef8(e, n) {
    if ("undefined" == typeof document || "undefined" == typeof window && void 0 === $parcel$global.window) throw new Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
    const t = document.createElement("div"), o = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getChildren();
    for(let l = 0; l < o.length; l++)$2157cf7c2d35dd91$var$p(e, o[l], t, n);
    return t.innerHTML;
}
function $2157cf7c2d35dd91$var$p(o, l, s, c = null) {
    let u = null === c || l.isSelected(c);
    const f = (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(l) && l.excludeFromCopy("html");
    let a = l;
    if (null !== c) {
        let t = (0, $af76071cb3cbd572$export$10b12fb9e226edf0)(l);
        t = (0, $f3de35ce60b0ef48$export$471953706258be2b)(t) && null !== c ? (0, $af76071cb3cbd572$export$56763a00ff6960e6)(c, t) : t, a = t;
    }
    const d = (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(a) ? a.getChildren() : [], h = o._nodes.get(a.getType());
    let m;
    m = h && void 0 !== h.exportDOM ? h.exportDOM(o, a) : a.exportDOM(o);
    const { element: g, after: y } = m;
    if (!g) return !1;
    const w = document.createDocumentFragment();
    for(let e = 0; e < d.length; e++){
        const n = d[e], t = $2157cf7c2d35dd91$var$p(o, n, w, c);
        !u && (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(l) && t && l.extractWithChild(n, c, "html") && (u = !0);
    }
    if (u && !f) {
        if ((0, $70f33588e7e4964f$export$1b3bfaa9684536aa)(g) && g.append(w), s.append(g), y) {
            const e = y.call(a, g);
            e && g.replaceWith(e);
        }
    } else s.append(w);
    return u;
}
const $2157cf7c2d35dd91$var$m = new Set([
    "STYLE",
    "SCRIPT"
]);
function $2157cf7c2d35dd91$var$g(e, n, t, l, i = new Map, f) {
    let d = [];
    if ($2157cf7c2d35dd91$var$m.has(e.nodeName)) return d;
    let h = null;
    const p = function(e, n) {
        const { nodeName: t } = e, o = n._htmlConversions.get(t.toLowerCase());
        let l = null;
        if (void 0 !== o) for (const n of o){
            const t = n(e);
            null !== t && (null === l || (l.priority || 0) < (t.priority || 0)) && (l = t);
        }
        return null !== l ? l.conversion : null;
    }(e, n), w = p ? p(e) : null;
    let x = null;
    if (null !== w) {
        x = w.after;
        const n = w.node;
        if (h = Array.isArray(n) ? n[n.length - 1] : n, null !== h) {
            for (const [, e] of i)if (h = e(h, f), !h) break;
            h && d.push(...Array.isArray(n) ? n : [
                h
            ]);
        }
        null != w.forChild && i.set(e.nodeName, w.forChild);
    }
    const C = e.childNodes;
    let N = [];
    const b = (null == h || !(0, $f3de35ce60b0ef48$export$6f851a24c61146af)(h)) && (null != h && (0, $f3de35ce60b0ef48$export$de078facd4ee1560)(h) || l);
    for(let e = 0; e < C.length; e++)N.push(...$2157cf7c2d35dd91$var$g(C[e], n, t, b, new Map(i), h));
    return null != x && (N = x(N)), (0, $70f33588e7e4964f$export$5ef1a5ca687c7168)(e) && (N = $2157cf7c2d35dd91$var$y(e, N, b ? ()=>{
        const e = new (0, $f3de35ce60b0ef48$export$82a585c2442a6dd6);
        return t.push(e), e;
    } : (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d))), null == h ? d = d.concat(N) : (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(h) && h.append(...N), d;
}
function $2157cf7c2d35dd91$var$y(e, n, t) {
    const o = e.style.textAlign, l = [];
    let r = [];
    for(let e = 0; e < n.length; e++){
        const i = n[e];
        if ((0, $f3de35ce60b0ef48$export$de078facd4ee1560)(i)) o && !i.getFormat() && i.setFormat(o), l.push(i);
        else if (r.push(i), e === n.length - 1 || e < n.length - 1 && (0, $f3de35ce60b0ef48$export$de078facd4ee1560)(n[e + 1])) {
            const e = t();
            e.setFormat(o), e.append(...r), l.push(e), r = [];
        }
    }
    return l;
}


const $cbd277723cf81bcc$var$mod = $2157cf7c2d35dd91$exports;
const $cbd277723cf81bcc$export$a1c399724d359ef8 = $cbd277723cf81bcc$var$mod.$generateHtmlFromNodes;
const $cbd277723cf81bcc$export$4b20ea127dfd853d = $cbd277723cf81bcc$var$mod.$generateNodesFromDOM;





function $fc265dd3ee912112$var$x(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $fc265dd3ee912112$var$w = $fc265dd3ee912112$var$x(function(t) {
    const e = new URLSearchParams;
    e.append("code", t);
    for(let t = 1; t < arguments.length; t++)e.append("v", arguments[t]);
    throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const $fc265dd3ee912112$var$y = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement, $fc265dd3ee912112$var$v = (t)=>$fc265dd3ee912112$var$y ? (t || window).getSelection() : null;
function $fc265dd3ee912112$export$492f5b1e57660d71(e) {
    const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    return null == n && $fc265dd3ee912112$var$w(166), (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n) && n.isCollapsed() || 0 === n.getNodes().length ? "" : (0, $cbd277723cf81bcc$export$a1c399724d359ef8)(e, n);
}
function $fc265dd3ee912112$export$431c00b4f604f022(t) {
    const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    return null == e && $fc265dd3ee912112$var$w(166), (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && e.isCollapsed() || 0 === e.getNodes().length ? null : JSON.stringify($fc265dd3ee912112$export$f84df9bec41e6d85(t, e));
}
function $fc265dd3ee912112$export$f4723b67d276bbb7(t, e) {
    const n = t.getData("text/plain") || t.getData("text/uri-list");
    null != n && e.insertRawText(n);
}
function $fc265dd3ee912112$export$ca1422672b17f174(t, n, o) {
    const l = t.getData("application/x-lexical-editor");
    if (l) try {
        const t = JSON.parse(l);
        if (t.namespace === o._config.namespace && Array.isArray(t.nodes)) return $fc265dd3ee912112$export$9201304b1e00ff59(o, $fc265dd3ee912112$export$c5c00050c34078e0(t.nodes), n);
    } catch (t) {}
    const r = t.getData("text/html");
    if (r) try {
        const t = (new DOMParser).parseFromString(r, "text/html");
        return $fc265dd3ee912112$export$9201304b1e00ff59(o, (0, $cbd277723cf81bcc$export$4b20ea127dfd853d)(o, t), n);
    } catch (t) {}
    const c = t.getData("text/plain") || t.getData("text/uri-list");
    if (null != c) {
        if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n)) {
            const t = c.split(/(\r?\n|\t)/);
            "" === t[t.length - 1] && t.pop();
            for(let e = 0; e < t.length; e++){
                const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
                if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n)) {
                    const o = t[e];
                    "\n" === o || "\r\n" === o ? n.insertParagraph() : "\t" === o ? n.insertNodes([
                        (0, $f3de35ce60b0ef48$export$5bde9d58a1da0796)()
                    ]) : n.insertText(o);
                }
            }
        } else n.insertRawText(c);
    }
}
function $fc265dd3ee912112$export$9201304b1e00ff59(t, e, n) {
    t.dispatchCommand((0, $f3de35ce60b0ef48$export$e47bb493817ec5f6), {
        nodes: e,
        selection: n
    }) || n.insertNodes(e);
}
function $fc265dd3ee912112$var$S(t, e, n, r = []) {
    let i = null === e || n.isSelected(e);
    const s = (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(n) && n.excludeFromCopy("html");
    let a = n;
    if (null !== e) {
        let t = (0, $af76071cb3cbd572$export$10b12fb9e226edf0)(n);
        t = (0, $f3de35ce60b0ef48$export$471953706258be2b)(t) && null !== e ? (0, $af76071cb3cbd572$export$56763a00ff6960e6)(e, t) : t, a = t;
    }
    const c = (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(a) ? a.getChildren() : [], u = function(t) {
        const e = t.exportJSON(), n = t.constructor;
        if (e.type !== n.getType() && $fc265dd3ee912112$var$w(58, n.name), (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(t)) {
            const t = e.children;
            Array.isArray(t) || $fc265dd3ee912112$var$w(59, n.name);
        }
        return e;
    }(a);
    if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(a)) {
        const t = a.__text;
        t.length > 0 ? u.text = t : i = !1;
    }
    for(let o = 0; o < c.length; o++){
        const l = c[o], r = $fc265dd3ee912112$var$S(t, e, l, u.children);
        !i && (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(n) && r && n.extractWithChild(l, e, "clone") && (i = !0);
    }
    if (i && !s) r.push(u);
    else if (Array.isArray(u.children)) for(let t = 0; t < u.children.length; t++){
        const e = u.children[t];
        r.push(e);
    }
    return i;
}
function $fc265dd3ee912112$export$f84df9bec41e6d85(t, e) {
    const n = [], o = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getChildren();
    for(let l = 0; l < o.length; l++)$fc265dd3ee912112$var$S(t, e, o[l], n);
    return {
        namespace: t._config.namespace,
        nodes: n
    };
}
function $fc265dd3ee912112$export$c5c00050c34078e0(t) {
    const e = [];
    for(let o = 0; o < t.length; o++){
        const l = t[o], r = (0, $f3de35ce60b0ef48$export$e1d3a194df5be556)(l);
        (0, $f3de35ce60b0ef48$export$471953706258be2b)(r) && (0, $af76071cb3cbd572$export$2c70ac68e537db45)(r), e.push(r);
    }
    return e;
}
let $fc265dd3ee912112$var$E = null;
async function $fc265dd3ee912112$export$2cdf1b96a9f86d16(t, e) {
    if (null !== $fc265dd3ee912112$var$E) return !1;
    if (null !== e) return new Promise((n, o)=>{
        t.update(()=>{
            n($fc265dd3ee912112$var$P(t, e));
        });
    });
    const n = t.getRootElement(), o = null == t._window ? window.document : t._window.document, l = $fc265dd3ee912112$var$v(t._window);
    if (null === n || null === l) return !1;
    const i = o.createElement("span");
    i.style.cssText = "position: fixed; top: -1000px;", i.append(o.createTextNode("#")), n.append(i);
    const s = new Range;
    return s.setStart(i, 0), s.setEnd(i, 1), l.removeAllRanges(), l.addRange(s), new Promise((e, n)=>{
        const l = t.registerCommand((0, $f3de35ce60b0ef48$export$3435fcfb1f59ef96), (n)=>((0, $70f33588e7e4964f$export$266ae88fb619dc2e)(n, ClipboardEvent) && (l(), null !== $fc265dd3ee912112$var$E && (window.clearTimeout($fc265dd3ee912112$var$E), $fc265dd3ee912112$var$E = null), e($fc265dd3ee912112$var$P(t, n))), !0), (0, $f3de35ce60b0ef48$export$6afdf194f304e546));
        $fc265dd3ee912112$var$E = window.setTimeout(()=>{
            l(), $fc265dd3ee912112$var$E = null, e(!1);
        }, 50), o.execCommand("copy"), i.remove();
    });
}
function $fc265dd3ee912112$var$P(t, e) {
    const n = $fc265dd3ee912112$var$v(t._window);
    if (!n) return !1;
    const o = n.anchorNode, l = n.focusNode;
    if (null !== o && null !== l && !(0, $f3de35ce60b0ef48$export$f1b377b21cd6350b)(t, o, l)) return !1;
    e.preventDefault();
    const r = e.clipboardData, s = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    if (null === r || null === s) return !1;
    const a = $fc265dd3ee912112$export$492f5b1e57660d71(t), c = $fc265dd3ee912112$export$431c00b4f604f022(t);
    let u = "";
    return null !== s && (u = s.getTextContent()), null !== a && r.setData("text/html", a), null !== c && r.setData("application/x-lexical-editor", c), r.setData("text/plain", u), !0;
}


const $cd27498671d2b539$var$mod = $fc265dd3ee912112$exports;
const $cd27498671d2b539$export$f84df9bec41e6d85 = $cd27498671d2b539$var$mod.$generateJSONFromSelectedNodes;
const $cd27498671d2b539$export$c5c00050c34078e0 = $cd27498671d2b539$var$mod.$generateNodesFromSerializedNodes;
const $cd27498671d2b539$export$492f5b1e57660d71 = $cd27498671d2b539$var$mod.$getHtmlContent;
const $cd27498671d2b539$export$431c00b4f604f022 = $cd27498671d2b539$var$mod.$getLexicalContent;
const $cd27498671d2b539$export$f4723b67d276bbb7 = $cd27498671d2b539$var$mod.$insertDataTransferForPlainText;
const $cd27498671d2b539$export$ca1422672b17f174 = $cd27498671d2b539$var$mod.$insertDataTransferForRichText;
const $cd27498671d2b539$export$9201304b1e00ff59 = $cd27498671d2b539$var$mod.$insertGeneratedNodes;
const $cd27498671d2b539$export$2cdf1b96a9f86d16 = $cd27498671d2b539$var$mod.copyToClipboard;





function $e6accc392cd3bc5a$var$st(t, e) {
    if (void 0 !== document.caretRangeFromPoint) {
        const n = document.caretRangeFromPoint(t, e);
        return null === n ? null : {
            node: n.startContainer,
            offset: n.startOffset
        };
    }
    if ("undefined" !== document.caretPositionFromPoint) {
        const n = document.caretPositionFromPoint(t, e);
        return null === n ? null : {
            node: n.offsetNode,
            offset: n.offset
        };
    }
    return null;
}
const $e6accc392cd3bc5a$var$ct = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement, $e6accc392cd3bc5a$var$at = $e6accc392cd3bc5a$var$ct && "documentMode" in document ? document.documentMode : null, $e6accc392cd3bc5a$var$ut = !(!$e6accc392cd3bc5a$var$ct || !("InputEvent" in window) || $e6accc392cd3bc5a$var$at) && "getTargetRanges" in new window.InputEvent("input"), $e6accc392cd3bc5a$var$lt = $e6accc392cd3bc5a$var$ct && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), $e6accc392cd3bc5a$var$dt = $e6accc392cd3bc5a$var$ct && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, $e6accc392cd3bc5a$var$mt = $e6accc392cd3bc5a$var$ct && /^(?=.*Chrome).*/i.test(navigator.userAgent), $e6accc392cd3bc5a$var$ft = $e6accc392cd3bc5a$var$ct && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !$e6accc392cd3bc5a$var$mt, $e6accc392cd3bc5a$export$d4a62c60df78432 = (0, $f3de35ce60b0ef48$export$8d4021544bdece00)("DRAG_DROP_PASTE_FILE");
class $e6accc392cd3bc5a$export$c64d7b2153096538 extends (0, $f3de35ce60b0ef48$export$dc064fe9e59310fd) {
    static getType() {
        return "quote";
    }
    static clone(t) {
        return new $e6accc392cd3bc5a$export$c64d7b2153096538(t.__key);
    }
    constructor(t){
        super(t);
    }
    createDOM(t) {
        const e = document.createElement("blockquote");
        return (0, $70f33588e7e4964f$export$71781797876b07d6)(e, t.theme.quote), e;
    }
    updateDOM(t, e) {
        return !1;
    }
    static importDOM() {
        return {
            blockquote: (t)=>({
                    conversion: $e6accc392cd3bc5a$var$xt,
                    priority: 0
                })
        };
    }
    exportDOM(t) {
        const { element: e } = super.exportDOM(t);
        if (e && (0, $70f33588e7e4964f$export$1b3bfaa9684536aa)(e)) {
            this.isEmpty() && e.append(document.createElement("br"));
            const t = this.getFormatType();
            e.style.textAlign = t;
            const n = this.getDirection();
            n && (e.dir = n);
        }
        return {
            element: e
        };
    }
    static importJSON(t) {
        const e = $e6accc392cd3bc5a$export$b8120bbdf1338c27();
        return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "quote"
        };
    }
    insertNewAfter(t, e) {
        const n = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)(), r = this.getDirection();
        return n.setDirection(r), this.insertAfter(n, e), n;
    }
    collapseAtStart() {
        const t = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)();
        return this.getChildren().forEach((e)=>t.append(e)), this.replace(t), !0;
    }
}
function $e6accc392cd3bc5a$export$b8120bbdf1338c27() {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $e6accc392cd3bc5a$export$c64d7b2153096538);
}
function $e6accc392cd3bc5a$export$1c183570990c020a(t) {
    return t instanceof $e6accc392cd3bc5a$export$c64d7b2153096538;
}
class $e6accc392cd3bc5a$export$90fecd23277fcde2 extends (0, $f3de35ce60b0ef48$export$dc064fe9e59310fd) {
    static getType() {
        return "heading";
    }
    static clone(t) {
        return new $e6accc392cd3bc5a$export$90fecd23277fcde2(t.__tag, t.__key);
    }
    constructor(t, e){
        super(e), this.__tag = t;
    }
    getTag() {
        return this.__tag;
    }
    createDOM(t) {
        const e = this.__tag, n = document.createElement(e), r = t.theme.heading;
        if (void 0 !== r) {
            const t = r[e];
            (0, $70f33588e7e4964f$export$71781797876b07d6)(n, t);
        }
        return n;
    }
    updateDOM(t, e) {
        return !1;
    }
    static importDOM() {
        return {
            h1: (t)=>({
                    conversion: $e6accc392cd3bc5a$var$Dt,
                    priority: 0
                }),
            h2: (t)=>({
                    conversion: $e6accc392cd3bc5a$var$Dt,
                    priority: 0
                }),
            h3: (t)=>({
                    conversion: $e6accc392cd3bc5a$var$Dt,
                    priority: 0
                }),
            h4: (t)=>({
                    conversion: $e6accc392cd3bc5a$var$Dt,
                    priority: 0
                }),
            h5: (t)=>({
                    conversion: $e6accc392cd3bc5a$var$Dt,
                    priority: 0
                }),
            h6: (t)=>({
                    conversion: $e6accc392cd3bc5a$var$Dt,
                    priority: 0
                }),
            p: (t)=>{
                const e = t.firstChild;
                return null !== e && $e6accc392cd3bc5a$var$yt(e) ? {
                    conversion: ()=>({
                            node: null
                        }),
                    priority: 3
                } : null;
            },
            span: (t)=>$e6accc392cd3bc5a$var$yt(t) ? {
                    conversion: (t)=>({
                            node: $e6accc392cd3bc5a$export$29cdf7c75bd686cc("h1")
                        }),
                    priority: 3
                } : null
        };
    }
    exportDOM(t) {
        const { element: e } = super.exportDOM(t);
        if (e && (0, $70f33588e7e4964f$export$1b3bfaa9684536aa)(e)) {
            this.isEmpty() && e.append(document.createElement("br"));
            const t = this.getFormatType();
            e.style.textAlign = t;
            const n = this.getDirection();
            n && (e.dir = n);
        }
        return {
            element: e
        };
    }
    static importJSON(t) {
        const e = $e6accc392cd3bc5a$export$29cdf7c75bd686cc(t.tag);
        return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            tag: this.getTag(),
            type: "heading",
            version: 1
        };
    }
    insertNewAfter(t, e = !0) {
        const n = t ? t.anchor.offset : 0, r = n !== this.getTextContentSize() && t ? $e6accc392cd3bc5a$export$29cdf7c75bd686cc(this.getTag()) : (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)(), o = this.getDirection();
        if (r.setDirection(o), this.insertAfter(r, e), 0 === n && !this.isEmpty() && t) {
            const t = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)();
            t.select(), this.replace(t, !0);
        }
        return r;
    }
    collapseAtStart() {
        const t = this.isEmpty() ? (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)() : $e6accc392cd3bc5a$export$29cdf7c75bd686cc(this.getTag());
        return this.getChildren().forEach((e)=>t.append(e)), this.replace(t), !0;
    }
    extractWithChild() {
        return !0;
    }
}
function $e6accc392cd3bc5a$var$yt(t) {
    return "span" === t.nodeName.toLowerCase() && "26pt" === t.style.fontSize;
}
function $e6accc392cd3bc5a$var$Dt(t) {
    const e = t.nodeName.toLowerCase();
    let n = null;
    return "h1" !== e && "h2" !== e && "h3" !== e && "h4" !== e && "h5" !== e && "h6" !== e || (n = $e6accc392cd3bc5a$export$29cdf7c75bd686cc(e), null !== t.style && n.setFormat(t.style.textAlign)), {
        node: n
    };
}
function $e6accc392cd3bc5a$var$xt(t) {
    const e = $e6accc392cd3bc5a$export$b8120bbdf1338c27();
    return null !== t.style && e.setFormat(t.style.textAlign), {
        node: e
    };
}
function $e6accc392cd3bc5a$export$29cdf7c75bd686cc(t) {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $e6accc392cd3bc5a$export$90fecd23277fcde2(t));
}
function $e6accc392cd3bc5a$export$78b6c84a5d5b8b31(t) {
    return t instanceof $e6accc392cd3bc5a$export$90fecd23277fcde2;
}
function $e6accc392cd3bc5a$export$1faf88b1db1d6bb9(t) {
    let e = null;
    if ((0, $70f33588e7e4964f$export$266ae88fb619dc2e)(t, DragEvent) ? e = t.dataTransfer : (0, $70f33588e7e4964f$export$266ae88fb619dc2e)(t, ClipboardEvent) && (e = t.clipboardData), null === e) return [
        !1,
        [],
        !1
    ];
    const n = e.types, r = n.includes("Files"), o = n.includes("text/html") || n.includes("text/plain");
    return [
        r,
        Array.from(e.files),
        o
    ];
}
function $e6accc392cd3bc5a$var$It(t) {
    const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) return !1;
    const n = new Set, r = e.getNodes();
    for(let e = 0; e < r.length; e++){
        const o = r[e], i = o.getKey();
        if (n.has(i)) continue;
        const s = (0, $70f33588e7e4964f$export$57101724ca611500)(o, (t)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(t) && !t.isInline());
        if (null === s) continue;
        const c = s.getKey();
        s.canIndent() && !n.has(c) && (n.add(c), t(s));
    }
    return n.size > 0;
}
function $e6accc392cd3bc5a$var$Ot(t) {
    const e = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(t);
    return (0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(e);
}
function $e6accc392cd3bc5a$export$8d6ed18fd12861da(o) {
    return (0, $70f33588e7e4964f$export$d64d64f541cc1835)(o.registerCommand((0, $f3de35ce60b0ef48$export$c1a2de6c823e5f82), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(e) && (e.clear(), !0);
    }, 0), o.registerCommand((0, $f3de35ce60b0ef48$export$35595bf6d7e36fd5), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && (e.deleteCharacter(t), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$8e315b175631384c), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && (e.deleteWord(t), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$d77fad8fb8747fd), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && (e.deleteLine(t), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$6f67c758bb657857), (e)=>{
        const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if ("string" == typeof e) null !== n && n.insertText(e);
        else {
            if (null === n) return !1;
            const r = e.dataTransfer;
            if (null != r) (0, $cd27498671d2b539$export$ca1422672b17f174)(r, n, o);
            else if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n)) {
                const t = e.data;
                return t && n.insertText(t), !0;
            }
        }
        return !0;
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$9cc285f2a3ff220c), ()=>{
        const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) && (t.removeText(), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$85443a1a9543f043), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && (e.formatText(t), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$d394dc6514823b18), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && !(0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(e)) return !1;
        const n = e.getNodes();
        for (const e of n){
            const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, (t)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(t) && !t.isInline());
            null !== n && n.setFormat(t);
        }
        return !0;
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$64e35ce26e025724), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && (e.insertLineBreak(t), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$24f4fea65b096b4), ()=>{
        const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) && (t.insertParagraph(), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$926ce4da2c89d118), ()=>((0, $f3de35ce60b0ef48$export$d773017360b45449)([
            (0, $f3de35ce60b0ef48$export$5bde9d58a1da0796)()
        ]), !0), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$2f74f6a2d927e6bd), ()=>$e6accc392cd3bc5a$var$It((t)=>{
            const e = t.getIndent();
            t.setIndent(e + 1);
        }), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$ecf9caa19e96e40d), ()=>$e6accc392cd3bc5a$var$It((t)=>{
            const e = t.getIndent();
            e > 0 && t.setIndent(e - 1);
        }), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$7833c2a33ae81d3d), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if ((0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(e) && !$e6accc392cd3bc5a$var$Ot(t.target)) {
            const t = e.getNodes();
            if (t.length > 0) return t[0].selectPrevious(), !0;
        } else if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) {
            const n = (0, $f3de35ce60b0ef48$export$c4b907be1879d8c1)(e.focus, !0);
            if (!t.shiftKey && (0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(n) && !n.isIsolated() && !n.isInline()) return n.selectPrevious(), t.preventDefault(), !0;
        }
        return !1;
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$baa60daa2ca402b3), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if ((0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(e)) {
            const t = e.getNodes();
            if (t.length > 0) return t[0].selectNext(0, 0), !0;
        } else if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) {
            if (function(t) {
                const e = t.focus;
                return "root" === e.key && e.offset === (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getChildrenSize();
            }(e)) return t.preventDefault(), !0;
            const n = (0, $f3de35ce60b0ef48$export$c4b907be1879d8c1)(e.focus, !1);
            if (!t.shiftKey && (0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(n) && !n.isIsolated() && !n.isInline()) return n.selectNext(), t.preventDefault(), !0;
        }
        return !1;
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$7525f8f8ab44508), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if ((0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(e)) {
            const n = e.getNodes();
            if (n.length > 0) return t.preventDefault(), n[0].selectPrevious(), !0;
        }
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) return !1;
        if ((0, $af76071cb3cbd572$export$d0018f657aae1e58)(e, !0)) {
            const n = t.shiftKey;
            return t.preventDefault(), (0, $af76071cb3cbd572$export$2ced31adbb83549a)(e, n, !0), !0;
        }
        return !1;
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$217ec2281ac1c53b), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if ((0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(e) && !$e6accc392cd3bc5a$var$Ot(t.target)) {
            const n = e.getNodes();
            if (n.length > 0) return t.preventDefault(), n[0].selectNext(0, 0), !0;
        }
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) return !1;
        const o = t.shiftKey;
        return !!(0, $af76071cb3cbd572$export$d0018f657aae1e58)(e, !1) && (t.preventDefault(), (0, $af76071cb3cbd572$export$2ced31adbb83549a)(e, o, !1), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$24bbba9bfa830f78), (t)=>{
        if ($e6accc392cd3bc5a$var$Ot(t.target)) return !1;
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) return !1;
        t.preventDefault();
        const { anchor: n } = e, r = n.getNode();
        if (e.isCollapsed() && 0 === n.offset && !(0, $f3de35ce60b0ef48$export$5b29ca560c2fedab)(r)) {
            if ((0, $70f33588e7e4964f$export$87243b8185b18f91)(r).getIndent() > 0) return o.dispatchCommand((0, $f3de35ce60b0ef48$export$ecf9caa19e96e40d), void 0);
        }
        return o.dispatchCommand((0, $f3de35ce60b0ef48$export$35595bf6d7e36fd5), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$13a0e72b5c0146bb), (t)=>{
        if ($e6accc392cd3bc5a$var$Ot(t.target)) return !1;
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) && (t.preventDefault(), o.dispatchCommand((0, $f3de35ce60b0ef48$export$35595bf6d7e36fd5), !1));
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$2cdb7cdd6fccb293), (t)=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) return !1;
        if (null !== t) {
            if (($e6accc392cd3bc5a$var$dt || $e6accc392cd3bc5a$var$lt || $e6accc392cd3bc5a$var$ft) && $e6accc392cd3bc5a$var$ut) return !1;
            if (t.preventDefault(), t.shiftKey) return o.dispatchCommand((0, $f3de35ce60b0ef48$export$64e35ce26e025724), !1);
        }
        return o.dispatchCommand((0, $f3de35ce60b0ef48$export$24f4fea65b096b4), void 0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$53589e422a755d59), ()=>{
        const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) && (o.blur(), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$eac1e4b16b80d3ea), (t)=>{
        const [, e] = $e6accc392cd3bc5a$export$1faf88b1db1d6bb9(t);
        if (e.length > 0) {
            const n = $e6accc392cd3bc5a$var$st(t.clientX, t.clientY);
            if (null !== n) {
                const { offset: t, node: r } = n, i = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(r);
                if (null !== i) {
                    const e = (0, $f3de35ce60b0ef48$export$1ccc217b9831b072)();
                    if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(i)) e.anchor.set(i.getKey(), t, "text"), e.focus.set(i.getKey(), t, "text");
                    else {
                        const t = i.getParentOrThrow().getKey(), n = i.getIndexWithinParent() + 1;
                        e.anchor.set(t, n, "element"), e.focus.set(t, n, "element");
                    }
                    const n = (0, $f3de35ce60b0ef48$export$db10bc6ba67ffcb5)(e);
                    (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(n);
                }
                o.dispatchCommand($e6accc392cd3bc5a$export$d4a62c60df78432, e);
            }
            return t.preventDefault(), !0;
        }
        const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$2e0fd45fde1da719), (t)=>{
        const [e] = $e6accc392cd3bc5a$export$1faf88b1db1d6bb9(t), n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return !(e && !(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n));
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$b62c1cce98fa7223), (t)=>{
        const [e] = $e6accc392cd3bc5a$export$1faf88b1db1d6bb9(t), n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (e && !(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n)) return !1;
        const r = $e6accc392cd3bc5a$var$st(t.clientX, t.clientY);
        if (null !== r) {
            const e = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(r.node);
            (0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(e) && t.preventDefault();
        }
        return !0;
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$185c218616045e75), ()=>((0, $f3de35ce60b0ef48$export$824f075b28fd7b6c)(), !0), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$3435fcfb1f59ef96), (t)=>((0, $cd27498671d2b539$export$2cdf1b96a9f86d16)(o, (0, $70f33588e7e4964f$export$266ae88fb619dc2e)(t, ClipboardEvent) ? t : null), !0), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$4dc8a35a083beec4), (t)=>((async function(t, n) {
            await (0, $cd27498671d2b539$export$2cdf1b96a9f86d16)(n, (0, $70f33588e7e4964f$export$266ae88fb619dc2e)(t, ClipboardEvent) ? t : null), n.update(()=>{
                const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
                (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) ? t.removeText() : (0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(t) && t.getNodes().forEach((t)=>t.remove());
            });
        })(t, o), !0), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), o.registerCommand((0, $f3de35ce60b0ef48$export$7fb70c61b3bcc883), (e)=>{
        const [, n, r] = $e6accc392cd3bc5a$export$1faf88b1db1d6bb9(e);
        if (n.length > 0 && !r) return o.dispatchCommand($e6accc392cd3bc5a$export$d4a62c60df78432, n), !0;
        if ((0, $f3de35ce60b0ef48$export$340cc5df988bf401)(e.target)) return !1;
        return null !== (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)() && (function(e, n) {
            e.preventDefault(), n.update(()=>{
                const r = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)(), o = (0, $70f33588e7e4964f$export$266ae88fb619dc2e)(e, InputEvent) || (0, $70f33588e7e4964f$export$266ae88fb619dc2e)(e, KeyboardEvent) ? null : e.clipboardData;
                null != o && null !== r && (0, $cd27498671d2b539$export$ca1422672b17f174)(o, r, n);
            }, {
                tag: "paste"
            });
        }(e, o), !0);
    }, (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)));
}


const $9c8f26caa7247d1b$var$mod = $e6accc392cd3bc5a$exports;
const $9c8f26caa7247d1b$export$29cdf7c75bd686cc = $9c8f26caa7247d1b$var$mod.$createHeadingNode;
const $9c8f26caa7247d1b$export$b8120bbdf1338c27 = $9c8f26caa7247d1b$var$mod.$createQuoteNode;
const $9c8f26caa7247d1b$export$78b6c84a5d5b8b31 = $9c8f26caa7247d1b$var$mod.$isHeadingNode;
const $9c8f26caa7247d1b$export$1c183570990c020a = $9c8f26caa7247d1b$var$mod.$isQuoteNode;
const $9c8f26caa7247d1b$export$d4a62c60df78432 = $9c8f26caa7247d1b$var$mod.DRAG_DROP_PASTE;
const $9c8f26caa7247d1b$export$90fecd23277fcde2 = $9c8f26caa7247d1b$var$mod.HeadingNode;
const $9c8f26caa7247d1b$export$c64d7b2153096538 = $9c8f26caa7247d1b$var$mod.QuoteNode;
const $9c8f26caa7247d1b$export$1faf88b1db1d6bb9 = $9c8f26caa7247d1b$var$mod.eventFiles;
const $9c8f26caa7247d1b$export$8d6ed18fd12861da = $9c8f26caa7247d1b$var$mod.registerRichText;


const $437602ae74a2acce$var$g = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? (0, $lldlC.useLayoutEffect) : (0, $lldlC.useEffect);
function $437602ae74a2acce$var$E(t) {
    return t.getEditorState().read((0, $c0aa6092a78d41a4$export$91992121baced35b)(t.isComposing()));
}
function $437602ae74a2acce$export$26ad95729aab2c7a({ contentEditable: e, placeholder: r, ErrorBoundary: n }) {
    const [E] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)(), h = function(t, e) {
        const [r, o] = (0, $lldlC.useState)(()=>t.getDecorators());
        return $437602ae74a2acce$var$g(()=>t.registerDecoratorListener((t)=>{
                (0, $a47646e093dbda8d$exports.flushSync)(()=>{
                    o(t);
                });
            }), [
            t
        ]), (0, $lldlC.useEffect)(()=>{
            o(t.getDecorators());
        }, [
            t
        ]), (0, $lldlC.useMemo)(()=>{
            const o = [], n = Object.keys(r);
            for(let i = 0; i < n.length; i++){
                const c = n[i], l = (0, $c53f8b07b96ee0c5$exports.jsx)(e, {
                    onError: (e)=>t._onError(e),
                    children: (0, $c53f8b07b96ee0c5$exports.jsx)((0, $lldlC.Suspense), {
                        fallback: null,
                        children: r[c]
                    })
                }), m = t.getElementByKey(c);
                null !== m && o.push((0, $a47646e093dbda8d$exports.createPortal)(l, m, c));
            }
            return o;
        }, [
            e,
            r,
            t
        ]);
    }(E, n);
    return function(t) {
        $437602ae74a2acce$var$g(()=>(0, $70f33588e7e4964f$export$d64d64f541cc1835)((0, $9c8f26caa7247d1b$export$8d6ed18fd12861da)(t), (0, $e2ac9c7565518cf7$export$14cafee2f188b8bc)(t)), [
            t
        ]);
    }(E), (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
        children: [
            e,
            (0, $c53f8b07b96ee0c5$exports.jsx)($437602ae74a2acce$var$w, {
                content: r
            }),
            h
        ]
    });
}
function $437602ae74a2acce$var$w({ content: r }) {
    const [n] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)(), i = function(t) {
        const [e, r] = (0, $lldlC.useState)(()=>$437602ae74a2acce$var$E(t));
        return $437602ae74a2acce$var$g(()=>{
            function e() {
                const e = $437602ae74a2acce$var$E(t);
                r(e);
            }
            return e(), (0, $70f33588e7e4964f$export$d64d64f541cc1835)(t.registerUpdateListener(()=>{
                e();
            }), t.registerEditableListener(()=>{
                e();
            }));
        }, [
            t
        ]), e;
    }(n), l = (0, $95e8cca9146e50d7$export$216c7470de8af95b)();
    return i ? "function" == typeof r ? r(l) : r : null;
}


const $56d9cf49beb0ea47$var$mod = $437602ae74a2acce$exports;
const $56d9cf49beb0ea47$export$26ad95729aab2c7a = $56d9cf49beb0ea47$var$mod.RichTextPlugin;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $9a7c0e281a2d9beb$exports = {};

$parcel$export($9a7c0e281a2d9beb$exports, "ContentEditable", () => $9a7c0e281a2d9beb$export$15d656b6f5aa1ba8);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

var $lldlC = parcelRequire("lldlC");

const $9a7c0e281a2d9beb$var$d = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? (0, $lldlC.useLayoutEffect) : (0, $lldlC.useEffect);
function $9a7c0e281a2d9beb$export$15d656b6f5aa1ba8({ ariaActiveDescendant: a, ariaAutoComplete: i, ariaControls: n, ariaDescribedBy: l, ariaExpanded: c, ariaLabel: s, ariaLabelledBy: m, ariaMultiline: u, ariaOwns: b, ariaRequired: p, autoCapitalize: x, className: w, id: v, role: f = "textbox", spellCheck: y = !0, style: C, tabIndex: E, "data-testid": D, ...L }) {
    const [h] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)(), [k, q] = (0, $lldlC.useState)(!1), z = (0, $lldlC.useCallback)((e)=>{
        e && e.ownerDocument && e.ownerDocument.defaultView && h.setRootElement(e);
    }, [
        h
    ]);
    return $9a7c0e281a2d9beb$var$d(()=>(q(h.isEditable()), h.registerEditableListener((e)=>{
            q(e);
        })), [
        h
    ]), (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        ...L,
        "aria-activedescendant": k ? a : void 0,
        "aria-autocomplete": k ? i : "none",
        "aria-controls": k ? n : void 0,
        "aria-describedby": l,
        "aria-expanded": k && "combobox" === f ? !!c : void 0,
        "aria-label": s,
        "aria-labelledby": m,
        "aria-multiline": u,
        "aria-owns": k ? b : void 0,
        "aria-readonly": !k || void 0,
        "aria-required": p,
        autoCapitalize: x,
        className: w,
        contentEditable: k,
        "data-testid": D,
        id: v,
        ref: z,
        role: f,
        spellCheck: y,
        style: C,
        tabIndex: E
    });
}


const $c92843f35f23b6dc$var$mod = $9a7c0e281a2d9beb$exports;
const $c92843f35f23b6dc$export$15d656b6f5aa1ba8 = $c92843f35f23b6dc$var$mod.ContentEditable;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $257a6d8e3d83ff33$exports = {};

$parcel$export($257a6d8e3d83ff33$exports, "HistoryPlugin", () => $257a6d8e3d83ff33$export$71f666dd3362399);
$parcel$export($257a6d8e3d83ff33$exports, "createEmptyHistoryState", () => $cdf77bca7c31bcc3$export$feb7d16028f7b237);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $48aba35dc37a2cea$exports = {};

$parcel$export($48aba35dc37a2cea$exports, "registerHistory", () => $48aba35dc37a2cea$export$296432d298e27831);
$parcel$export($48aba35dc37a2cea$exports, "createEmptyHistoryState", () => $48aba35dc37a2cea$export$feb7d16028f7b237);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

const $48aba35dc37a2cea$var$l = 0, $48aba35dc37a2cea$var$_ = 1, $48aba35dc37a2cea$var$f = 2, $48aba35dc37a2cea$var$p = 0, $48aba35dc37a2cea$var$h = 1, $48aba35dc37a2cea$var$m = 2, $48aba35dc37a2cea$var$g = 3, $48aba35dc37a2cea$var$y = 4;
function $48aba35dc37a2cea$var$S(t, e, n, o, r) {
    if (null === t || 0 === n.size && 0 === o.size && !r) return $48aba35dc37a2cea$var$p;
    const i = e._selection, s = t._selection;
    if (r) return $48aba35dc37a2cea$var$h;
    if (!((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(i) && (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(s) && s.isCollapsed() && i.isCollapsed())) return $48aba35dc37a2cea$var$p;
    const c = function(t, e, n) {
        const o = t._nodeMap, r = [];
        for (const t of e){
            const e = o.get(t);
            void 0 !== e && r.push(e);
        }
        for (const [t, e] of n){
            if (!e) continue;
            const n = o.get(t);
            void 0 === n || (0, $f3de35ce60b0ef48$export$5b29ca560c2fedab)(n) || r.push(n);
        }
        return r;
    }(e, n, o);
    if (0 === c.length) return $48aba35dc37a2cea$var$p;
    if (c.length > 1) {
        const n = e._nodeMap, o = n.get(i.anchor.key), r = n.get(s.anchor.key);
        return o && r && !t._nodeMap.has(o.__key) && (0, $f3de35ce60b0ef48$export$471953706258be2b)(o) && 1 === o.__text.length && 1 === i.anchor.offset ? $48aba35dc37a2cea$var$m : $48aba35dc37a2cea$var$p;
    }
    const l = c[0], _ = t._nodeMap.get(l.__key);
    if (!(0, $f3de35ce60b0ef48$export$471953706258be2b)(_) || !(0, $f3de35ce60b0ef48$export$471953706258be2b)(l) || _.__mode !== l.__mode) return $48aba35dc37a2cea$var$p;
    const f = _.__text, S = l.__text;
    if (f === S) return $48aba35dc37a2cea$var$p;
    const k = i.anchor, C = s.anchor;
    if (k.key !== C.key || "text" !== k.type) return $48aba35dc37a2cea$var$p;
    const x = k.offset, M = C.offset, z = S.length - f.length;
    return 1 === z && M === x - 1 ? $48aba35dc37a2cea$var$m : -1 === z && M === x + 1 ? $48aba35dc37a2cea$var$g : -1 === z && M === x ? $48aba35dc37a2cea$var$y : $48aba35dc37a2cea$var$p;
}
function $48aba35dc37a2cea$var$k(t, e) {
    let n = Date.now(), o = $48aba35dc37a2cea$var$p;
    return (r, i, s, c, d, h)=>{
        const m = Date.now();
        if (h.has("historic")) return o = $48aba35dc37a2cea$var$p, n = m, $48aba35dc37a2cea$var$f;
        const g = $48aba35dc37a2cea$var$S(r, i, c, d, t.isComposing()), y = (()=>{
            const y = null === s || s.editor === t, S = h.has("history-push");
            if (!S && y && h.has("history-merge")) return $48aba35dc37a2cea$var$l;
            if (null === r) return $48aba35dc37a2cea$var$_;
            const k = i._selection;
            if (!(c.size > 0 || d.size > 0)) return null !== k ? $48aba35dc37a2cea$var$l : $48aba35dc37a2cea$var$f;
            if (!1 === S && g !== $48aba35dc37a2cea$var$p && g === o && m < n + e && y) return $48aba35dc37a2cea$var$l;
            if (1 === c.size) {
                if (function(t, e, n) {
                    const o = e._nodeMap.get(t), r = n._nodeMap.get(t), i = e._selection, s = n._selection;
                    let c = !1;
                    return (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(i) && (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(s) && (c = "element" === i.anchor.type && "element" === i.focus.type && "text" === s.anchor.type && "text" === s.focus.type), !(c || !(0, $f3de35ce60b0ef48$export$471953706258be2b)(o) || !(0, $f3de35ce60b0ef48$export$471953706258be2b)(r)) && o.__type === r.__type && o.__text === r.__text && o.__mode === r.__mode && o.__detail === r.__detail && o.__style === r.__style && o.__format === r.__format && o.__parent === r.__parent;
                }(Array.from(c)[0], r, i)) return $48aba35dc37a2cea$var$l;
            }
            return $48aba35dc37a2cea$var$_;
        })();
        return n = m, o = g, y;
    };
}
function $48aba35dc37a2cea$var$C(t) {
    t.undoStack = [], t.redoStack = [], t.current = null;
}
function $48aba35dc37a2cea$export$296432d298e27831(a, u, d) {
    const l = $48aba35dc37a2cea$var$k(a, d), p = (0, $70f33588e7e4964f$export$d64d64f541cc1835)(a.registerCommand((0, $f3de35ce60b0ef48$export$34722a4946cb641e), ()=>((function(t, e) {
            const n = e.redoStack, o = e.undoStack;
            if (0 !== o.length) {
                const r = e.current, i = o.pop();
                null !== r && (n.push(r), t.dispatchCommand((0, $f3de35ce60b0ef48$export$e36aacf84f559bb3), !0)), 0 === o.length && t.dispatchCommand((0, $f3de35ce60b0ef48$export$9fd9dd31dd6ebdf5), !1), e.current = i || null, i && i.editor.setEditorState(i.editorState, {
                    tag: "historic"
                });
            }
        })(a, u), !0), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), a.registerCommand((0, $f3de35ce60b0ef48$export$8c4a0748d31d9941), ()=>((function(t, e) {
            const n = e.redoStack, o = e.undoStack;
            if (0 !== n.length) {
                const r = e.current;
                null !== r && (o.push(r), t.dispatchCommand((0, $f3de35ce60b0ef48$export$9fd9dd31dd6ebdf5), !0));
                const i = n.pop();
                0 === n.length && t.dispatchCommand((0, $f3de35ce60b0ef48$export$e36aacf84f559bb3), !1), e.current = i || null, i && i.editor.setEditorState(i.editorState, {
                    tag: "historic"
                });
            }
        })(a, u), !0), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), a.registerCommand((0, $f3de35ce60b0ef48$export$4926ce1a5702fdc7), ()=>($48aba35dc37a2cea$var$C(u), !1), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), a.registerCommand((0, $f3de35ce60b0ef48$export$d3f69a65bbe7edc), ()=>($48aba35dc37a2cea$var$C(u), a.dispatchCommand((0, $f3de35ce60b0ef48$export$e36aacf84f559bb3), !1), a.dispatchCommand((0, $f3de35ce60b0ef48$export$9fd9dd31dd6ebdf5), !1), !0), (0, $f3de35ce60b0ef48$export$11c61e12af5e1f41)), a.registerUpdateListener(({ editorState: t, prevEditorState: e, dirtyLeaves: n, dirtyElements: o, tags: r })=>{
        const i = u.current, d = u.redoStack, p = u.undoStack, h = null === i ? null : i.editorState;
        if (null !== i && t === h) return;
        const m = l(e, t, i, n, o, r);
        if (m === $48aba35dc37a2cea$var$_) 0 !== d.length && (u.redoStack = [], a.dispatchCommand((0, $f3de35ce60b0ef48$export$e36aacf84f559bb3), !1)), null !== i && (p.push({
            ...i
        }), a.dispatchCommand((0, $f3de35ce60b0ef48$export$9fd9dd31dd6ebdf5), !0));
        else if (m === $48aba35dc37a2cea$var$f) return;
        u.current = {
            editor: a,
            editorState: t
        };
    }));
    return p;
}
function $48aba35dc37a2cea$export$feb7d16028f7b237() {
    return {
        current: null,
        redoStack: [],
        undoStack: []
    };
}


const $cdf77bca7c31bcc3$var$mod = $48aba35dc37a2cea$exports;
const $cdf77bca7c31bcc3$export$feb7d16028f7b237 = $cdf77bca7c31bcc3$var$mod.createEmptyHistoryState;
const $cdf77bca7c31bcc3$export$296432d298e27831 = $cdf77bca7c31bcc3$var$mod.registerHistory;



var $lldlC = parcelRequire("lldlC");
function $257a6d8e3d83ff33$export$71f666dd3362399({ externalHistoryState: c }) {
    const [a] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)();
    return function(t, c, a = 1e3) {
        const l = (0, $lldlC.useMemo)(()=>c || (0, $cdf77bca7c31bcc3$export$feb7d16028f7b237)(), [
            c
        ]);
        (0, $lldlC.useEffect)(()=>(0, $cdf77bca7c31bcc3$export$296432d298e27831)(t, l, a), [
            a,
            t,
            l
        ]);
    }(a, c), null;
}


const $40c589373bd9baa4$var$mod = $257a6d8e3d83ff33$exports;
const $40c589373bd9baa4$export$71f666dd3362399 = $40c589373bd9baa4$var$mod.HistoryPlugin;
const $40c589373bd9baa4$export$feb7d16028f7b237 = $40c589373bd9baa4$var$mod.createEmptyHistoryState;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $513db617b5d07b82$exports = {};

$parcel$export($513db617b5d07b82$exports, "AutoFocusPlugin", () => $513db617b5d07b82$export$a8eb6a441bc1c208);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

var $lldlC = parcelRequire("lldlC");
function $513db617b5d07b82$export$a8eb6a441bc1c208({ defaultSelection: o }) {
    const [l] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)();
    return (0, $lldlC.useEffect)(()=>{
        l.focus(()=>{
            const e = document.activeElement, t = l.getRootElement();
            null === t || null !== e && t.contains(e) || t.focus({
                preventScroll: !0
            });
        }, {
            defaultSelection: o
        });
    }, [
        o,
        l
    ]), null;
}


const $7f13a6655cf9df34$var$mod = $513db617b5d07b82$exports;
const $7f13a6655cf9df34$export$a8eb6a441bc1c208 = $7f13a6655cf9df34$var$mod.AutoFocusPlugin;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $dc5a1f4a48649c96$exports = {};

$parcel$export($dc5a1f4a48649c96$exports, "OnChangePlugin", () => $dc5a1f4a48649c96$export$db03ed1efce87e4b);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

var $lldlC = parcelRequire("lldlC");
const $dc5a1f4a48649c96$var$r = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? (0, $lldlC.useLayoutEffect) : (0, $lldlC.useEffect);
function $dc5a1f4a48649c96$export$db03ed1efce87e4b({ ignoreHistoryMergeTagChange: t = !0, ignoreSelectionChange: o = !1, onChange: i }) {
    const [n] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)();
    return $dc5a1f4a48649c96$var$r(()=>{
        if (i) return n.registerUpdateListener(({ editorState: e, dirtyElements: r, dirtyLeaves: a, prevEditorState: d, tags: s })=>{
            o && 0 === r.size && 0 === a.size || t && s.has("history-merge") || d.isEmpty() || i(e, n, s);
        });
    }, [
        n,
        t,
        o,
        i
    ]), null;
}


const $eb7acf1e2a4ecbb8$var$mod = $dc5a1f4a48649c96$exports;
const $eb7acf1e2a4ecbb8$export$db03ed1efce87e4b = $eb7acf1e2a4ecbb8$var$mod.OnChangePlugin;


const $a9379d78ef00eb74$export$164de7ab8df77ef0 = {
    code: "editor-code",
    heading: {
        h1: "editor-heading-h1",
        h2: "editor-heading-h2",
        h3: "editor-heading-h3",
        h4: "editor-heading-h4",
        h5: "editor-heading-h5"
    },
    image: "editor-image",
    link: "editor-link",
    list: {
        listitem: "editor-listitem",
        nested: {
            listitem: "editor-nested-listitem"
        },
        ol: "editor-list-ol",
        ul: "editor-list-ul"
    },
    ltr: "ltr",
    paragraph: "editor-paragraph",
    placeholder: "editor-placeholder",
    quote: "editor-quote",
    rtl: "rtl",
    text: {
        bold: "editor-text-bold",
        code: "editor-text-code",
        hashtag: "editor-text-hashtag",
        italic: "editor-text-italic",
        overflowed: "editor-text-overflowed",
        strikethrough: "editor-text-strikethrough",
        underline: "editor-text-underline",
        underlineStrikethrough: "editor-text-underlineStrikethrough"
    }
};







var $lldlC = parcelRequire("lldlC");
const $cb3f8ddb5bb538fc$var$LowPriority = 1;
function $cb3f8ddb5bb538fc$var$Divider() {
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "divider"
    });
}
const $cb3f8ddb5bb538fc$export$d8cca1874b1065b9 = ()=>{
    const [editor] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)();
    const toolbarRef = (0, $lldlC.useRef)(null);
    const [canUndo, setCanUndo] = (0, $lldlC.useState)(false);
    const [canRedo, setCanRedo] = (0, $lldlC.useState)(false);
    const [isBold, setIsBold] = (0, $lldlC.useState)(false);
    const [isItalic, setIsItalic] = (0, $lldlC.useState)(false);
    const [isUnderline, setIsUnderline] = (0, $lldlC.useState)(false);
    const [isStrikethrough, setIsStrikethrough] = (0, $lldlC.useState)(false);
    const $updateToolbar = (0, $lldlC.useCallback)(()=>{
        const selection = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(selection)) {
            // Update text format
            setIsBold(selection.hasFormat("bold"));
            setIsItalic(selection.hasFormat("italic"));
            setIsUnderline(selection.hasFormat("underline"));
            setIsStrikethrough(selection.hasFormat("strikethrough"));
        }
    }, []);
    (0, $lldlC.useEffect)(()=>{
        return (0, $70f33588e7e4964f$export$d64d64f541cc1835)(editor.registerUpdateListener(({ editorState: editorState })=>{
            editorState.read(()=>{
                $updateToolbar();
            });
        }), editor.registerCommand((0, $f3de35ce60b0ef48$export$e396fef71d2b56e5), (_payload, _newEditor)=>{
            $updateToolbar();
            return false;
        }, $cb3f8ddb5bb538fc$var$LowPriority), editor.registerCommand((0, $f3de35ce60b0ef48$export$9fd9dd31dd6ebdf5), (payload)=>{
            setCanUndo(payload);
            return false;
        }, $cb3f8ddb5bb538fc$var$LowPriority), editor.registerCommand((0, $f3de35ce60b0ef48$export$e36aacf84f559bb3), (payload)=>{
            setCanRedo(payload);
            return false;
        }, $cb3f8ddb5bb538fc$var$LowPriority));
    }, [
        editor,
        $updateToolbar
    ]);
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "toolbar",
        ref: toolbarRef,
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                disabled: !canUndo,
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$34722a4946cb641e), undefined);
                },
                className: "toolbar-item spaced",
                "aria-label": "Undo",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/arrow-counterclockwise.svg",
                    alt: "Undo"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                disabled: !canRedo,
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$8c4a0748d31d9941), undefined);
                },
                className: "toolbar-item",
                "aria-label": "Redo",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/arrow-clockwise.svg",
                    alt: "Redo"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($cb3f8ddb5bb538fc$var$Divider, {}),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$85443a1a9543f043), "bold");
                },
                className: "toolbar-item spaced " + (isBold ? "active" : ""),
                "aria-label": "Format Bold",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/type-bold.svg",
                    alt: "Bold"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$85443a1a9543f043), "italic");
                },
                className: "toolbar-item spaced " + (isItalic ? "active" : ""),
                "aria-label": "Format Italics",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/type-italic.svg",
                    alt: "Italic"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$85443a1a9543f043), "underline");
                },
                className: "toolbar-item spaced " + (isUnderline ? "active" : ""),
                "aria-label": "Format Underline",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/type-underline.svg",
                    alt: "Underline"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$85443a1a9543f043), "strikethrough");
                },
                className: "toolbar-item spaced " + (isStrikethrough ? "active" : ""),
                "aria-label": "Format Strikethrough",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/type-strikethrough.svg",
                    alt: "Strikethrough"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($cb3f8ddb5bb538fc$var$Divider, {}),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$d394dc6514823b18), "left");
                },
                className: "toolbar-item spaced",
                "aria-label": "Left Align",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/text-left.svg",
                    alt: "Left Align"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$d394dc6514823b18), "center");
                },
                className: "toolbar-item spaced",
                "aria-label": "Center Align",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/text-center.svg",
                    alt: "Center Align"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$d394dc6514823b18), "right");
                },
                className: "toolbar-item spaced",
                "aria-label": "Right Align",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/text-right.svg",
                    alt: "Right Align"
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    editor.dispatchCommand((0, $f3de35ce60b0ef48$export$d394dc6514823b18), "justify");
                },
                className: "toolbar-item spaced",
                "aria-label": "Justify Align",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "images/lexical/justify.svg",
                    alt: "Justify Align"
                })
            }),
            " "
        ]
    });
};






var $lldlC = parcelRequire("lldlC");
const $588d98e0b032b474$export$cd143eecf84f179a = ({ initHtml: initHtml = "" })=>{
    const [editor] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)();
    (0, $lldlC.useEffect)(()=>{
        if (editor && initHtml) editor.update(()=>{
            const root = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)();
            root.clear(); // Clear any existing content
            const parser = new DOMParser();
            const dom = parser.parseFromString(initHtml, "text/html");
            const nodes = (0, $cbd277723cf81bcc$export$4b20ea127dfd853d)(editor, dom);
            root.append(...nodes); // Append parsed nodes to the editor root
            editor.dispatchCommand((0, $f3de35ce60b0ef48$export$d3f69a65bbe7edc), null); // Clear history after setting the content
        });
    }, [
        editor,
        initHtml
    ]);
    return null;
};






var $lldlC = parcelRequire("lldlC");


var $lldlC = parcelRequire("lldlC");

class $864ec047e45786ae$export$cc9044e10fd11ba6 extends (0, $f3de35ce60b0ef48$export$8244b9efe04488e) {
    // Get the type of node
    static getType() {
        return "image";
    }
    // Clone the node
    static clone(node) {
        return new $864ec047e45786ae$export$cc9044e10fd11ba6(node.__src, node.__altText, node.__width, node.__height, node.__key);
    }
    // Constructor
    constructor(src, altText, width = 300, height = 200, key){
        super(key);
        this.__src = src;
        this.__altText = altText;
        this.__width = width;
        this.__height = height;
    }
    // Create DOM element
    createDOM() {
        return document.createElement("div");
    }
    // Update DOM
    updateDOM() {
        return false;
    }
    // Import serialized node
    static importJSON(serializedNode) {
        const { src: src, altText: altText, width: width, height: height } = serializedNode;
        return new $864ec047e45786ae$export$cc9044e10fd11ba6(src, altText, width, height);
    }
    // Export serialized node
    exportJSON() {
        return {
            src: this.__src,
            altText: this.__altText,
            width: this.__width,
            height: this.__height,
            type: $864ec047e45786ae$export$cc9044e10fd11ba6.getType(),
            version: 1
        };
    }
    // Export DOM representation
    exportDOM() {
        const img = document.createElement("img");
        img.src = this.__src;
        img.alt = this.__altText;
        img.width = this.__width;
        img.height = this.__height;
        return {
            element: img
        };
    }
    // Decorate component for rendering in the editor
    decorate(editor, config) {
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($864ec047e45786ae$var$ImageComponent, {
            src: this.__src,
            altText: this.__altText,
            width: this.__width,
            height: this.__height,
            nodeKey: this.getKey(),
            editor: editor
        });
    }
}
const $864ec047e45786ae$export$b7bec86fa2d4a855 = (src, altText, width, height)=>{
    return new $864ec047e45786ae$export$cc9044e10fd11ba6(src, altText, width, height);
};
// ImageComponent to handle rendering and resizing
const $864ec047e45786ae$var$ImageComponent = ({ src: src, altText: altText, width: width, height: height, nodeKey: nodeKey, editor: editor })=>{
    const [currentWidth, setCurrentWidth] = (0, $lldlC.useState)(width);
    const [currentHeight, setCurrentHeight] = (0, $lldlC.useState)(height);
    const [isSelected, setIsSelected] = (0, $lldlC.useState)(false);
    const aspectRatio = width / height;
    const imgRef = (0, $lldlC.useRef)(null);
    // Handle image resize
    const handleResize = (0, $lldlC.useCallback)((e, direction)=>{
        e.preventDefault();
        const startX = e.clientX;
        const startY = e.clientY;
        const startWidth = currentWidth;
        const startHeight = currentHeight;
        const onMouseMove = (moveEvent)=>{
            let newWidth = startWidth;
            let newHeight = startHeight;
            if ([
                "horizontal",
                "diagonal"
            ].includes(direction)) {
                newWidth = startWidth + moveEvent.clientX - startX;
                newHeight = newWidth / aspectRatio;
            }
            if ([
                "vertical",
                "diagonal"
            ].includes(direction)) {
                newHeight = startHeight + moveEvent.clientY - startY;
                newWidth = newHeight * aspectRatio;
            }
            setCurrentWidth(newWidth);
            setCurrentHeight(newHeight);
        };
        const onMouseUp = ()=>{
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
            const imageNode = (0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(nodeKey);
            if (imageNode) {
                imageNode.__width = currentWidth;
                imageNode.__height = currentHeight;
            }
        };
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    }, [
        currentWidth,
        currentHeight,
        aspectRatio,
        nodeKey
    ]);
    const handleClick = ()=>{
        setIsSelected(!isSelected);
    };
    // Handle delete key press
    const handleKeyDown = (0, $lldlC.useCallback)((e)=>{
        if (isSelected && (e.key === "Delete" || e.key === "Backspace")) editor.update(()=>{
            const imageNode = (0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(nodeKey);
            if (imageNode) imageNode.remove();
        });
    }, [
        isSelected,
        editor,
        nodeKey
    ]);
    (0, $lldlC.useEffect)(()=>{
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleKeyDown
    ]);
    const resizeHandleStyles = (0, $lldlC.useMemo)(()=>({
            position: "absolute",
            width: 10,
            height: 10,
            backgroundColor: "blue",
            cursor: "nwse-resize"
        }), []);
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        ref: imgRef,
        onClick: handleClick,
        style: {
            position: "relative",
            width: currentWidth,
            height: currentHeight,
            display: "inline-block",
            border: isSelected ? "2px solid blue" : "none"
        },
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                src: src,
                alt: altText,
                style: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                }
            }),
            isSelected && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        onMouseDown: (e)=>handleResize(e, "diagonal"),
                        style: {
                            ...resizeHandleStyles,
                            top: -5,
                            left: -5
                        }
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        onMouseDown: (e)=>handleResize(e, "diagonal"),
                        style: {
                            ...resizeHandleStyles,
                            top: -5,
                            right: -5
                        }
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        onMouseDown: (e)=>handleResize(e, "diagonal"),
                        style: {
                            ...resizeHandleStyles,
                            bottom: -5,
                            left: -5
                        }
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        onMouseDown: (e)=>handleResize(e, "diagonal"),
                        style: {
                            ...resizeHandleStyles,
                            bottom: -5,
                            right: -5
                        }
                    })
                ]
            })
        ]
    });
};


const $44af0f53bcb1ec89$export$cbf0dd79e59568ca = (0, $f3de35ce60b0ef48$export$8d4021544bdece00)();
// Helper function to handle image file reading and dispatch command
const $44af0f53bcb1ec89$var$readImageFile = (file, editor)=>{
    const reader = new FileReader();
    reader.onload = (event)=>{
        const base64Src = event.target?.result;
        if (base64Src) editor.dispatchCommand($44af0f53bcb1ec89$export$cbf0dd79e59568ca, {
            src: base64Src,
            altText: "Pasted Image",
            width: 300,
            height: 200
        });
    };
    reader.onerror = ()=>{
        console.error("Failed to read the image file.");
    };
    reader.readAsDataURL(file);
};
// Helper function to handle the paste event
const $44af0f53bcb1ec89$var$handlePaste = (event, editor)=>{
    const items = event.clipboardData?.items;
    if (!items) return;
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        if (item.type.startsWith("image/")) {
            const file = item.getAsFile();
            if (file) {
                $44af0f53bcb1ec89$var$readImageFile(file, editor);
                event.preventDefault(); // Prevent the default paste behavior
                break; // Stop after handling the first image
            }
        }
    }
};
const $44af0f53bcb1ec89$export$a521e3a22207fce0 = ()=>{
    const [editor] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)(); // Get the Lexical editor instance
    (0, $lldlC.useEffect)(()=>{
        // Register paste event listener
        const pasteHandler = (event)=>$44af0f53bcb1ec89$var$handlePaste(event, editor);
        document.addEventListener("paste", pasteHandler);
        // remove event listener when the component unmounts
        return ()=>{
            document.removeEventListener("paste", pasteHandler);
        };
    }, [
        editor
    ]); // Re-run the effect when the editor instance changes
    (0, $lldlC.useEffect)(()=>{
        // Command to insert an image into the editor
        const removeInsertImageCommand = editor.registerCommand($44af0f53bcb1ec89$export$cbf0dd79e59568ca, (payload)=>{
            const { src: src, altText: altText, width: width, height: height } = payload;
            const imageNode = (0, $864ec047e45786ae$export$b7bec86fa2d4a855)(src, altText, width, height);
            // Update the editor state to insert the image node
            editor.update(()=>{
                const selection = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
                if (selection) (0, $f3de35ce60b0ef48$export$d773017360b45449)([
                    imageNode
                ]);
            });
            return true; // Indicate the command was handled
        }, (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9));
        // Unregister the command when the component unmounts
        return ()=>removeInsertImageCommand();
    }, [
        editor
    ]);
    (0, $lldlC.useEffect)(()=>{
        // Command to handle deleting an image when selected
        const removeDeleteCommand = editor.registerCommand((0, $f3de35ce60b0ef48$export$13a0e72b5c0146bb), ()=>{
            const selection = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
            if ((0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(selection)) {
                const selectedNodes = selection.getNodes();
                // Remove selected image nodes
                editor.update(()=>{
                    selectedNodes.forEach((node)=>{
                        if (node.getType() === "image") node.remove();
                    });
                });
                return true; // Indicate the command was handled
            }
            return false; // Indicate no action was taken
        }, (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9));
        // Unregister the command when the component unmounts
        return ()=>removeDeleteCommand();
    }, [
        editor
    ]);
    return null;
};




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $a36bad105784d3f0$exports = {};

$parcel$export($a36bad105784d3f0$exports, "TreeView", () => $a36bad105784d3f0$export$6940b0d9c820eca7);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $d3ed32e1e38e75bc$exports = {};

$parcel$export($d3ed32e1e38e75bc$exports, "generateContent", () => $d3ed32e1e38e75bc$export$4edbeb3aa79c6b8a);
$parcel$export($d3ed32e1e38e75bc$exports, "TreeView", () => $d3ed32e1e38e75bc$export$6940b0d9c820eca7);
$parcel$export($d3ed32e1e38e75bc$exports, "registerLexicalCommandLogger", () => $d3ed32e1e38e75bc$export$2b33dd74ec751364);
$parcel$export($d3ed32e1e38e75bc$exports, "useLexicalCommandsLog", () => $d3ed32e1e38e75bc$export$1d225a6d44c41fc6);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $8162dcedd4d4e8b9$exports = {};

$parcel$export($8162dcedd4d4e8b9$exports, "LinkNode", () => $8162dcedd4d4e8b9$export$4341066b87270133);
$parcel$export($8162dcedd4d4e8b9$exports, "$createLinkNode", () => $8162dcedd4d4e8b9$export$5ec42376570ce194);
$parcel$export($8162dcedd4d4e8b9$exports, "$isLinkNode", () => $8162dcedd4d4e8b9$export$b46127abfd772033);
$parcel$export($8162dcedd4d4e8b9$exports, "AutoLinkNode", () => $8162dcedd4d4e8b9$export$1f3c6513e80fcb51);
$parcel$export($8162dcedd4d4e8b9$exports, "$createAutoLinkNode", () => $8162dcedd4d4e8b9$export$22b33a6815c95543);
$parcel$export($8162dcedd4d4e8b9$exports, "$isAutoLinkNode", () => $8162dcedd4d4e8b9$export$7fd828bfe44c7434);
$parcel$export($8162dcedd4d4e8b9$exports, "TOGGLE_LINK_COMMAND", () => $8162dcedd4d4e8b9$export$42da573aae2f70a);
$parcel$export($8162dcedd4d4e8b9$exports, "$toggleLink", () => $8162dcedd4d4e8b9$export$a051ad64de8be534);
$parcel$export($8162dcedd4d4e8b9$exports, "toggleLink", () => $8162dcedd4d4e8b9$export$b717c5e3c67fa0d4);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

const $8162dcedd4d4e8b9$var$_ = new Set([
    "http:",
    "https:",
    "mailto:",
    "sms:",
    "tel:"
]);
class $8162dcedd4d4e8b9$export$4341066b87270133 extends (0, $f3de35ce60b0ef48$export$dc064fe9e59310fd) {
    static getType() {
        return "link";
    }
    static clone(t) {
        return new $8162dcedd4d4e8b9$export$4341066b87270133(t.__url, {
            rel: t.__rel,
            target: t.__target,
            title: t.__title
        }, t.__key);
    }
    constructor(t, e = {}, r){
        super(r);
        const { target: n = null, rel: i = null, title: l = null } = e;
        this.__url = t, this.__target = n, this.__rel = i, this.__title = l;
    }
    createDOM(e) {
        const r = document.createElement("a");
        return r.href = this.sanitizeUrl(this.__url), null !== this.__target && (r.target = this.__target), null !== this.__rel && (r.rel = this.__rel), null !== this.__title && (r.title = this.__title), (0, $70f33588e7e4964f$export$71781797876b07d6)(r, e.theme.link), r;
    }
    updateDOM(t, e, r) {
        if (e instanceof HTMLAnchorElement) {
            const r = this.__url, n = this.__target, i = this.__rel, l = this.__title;
            r !== t.__url && (e.href = r), n !== t.__target && (n ? e.target = n : e.removeAttribute("target")), i !== t.__rel && (i ? e.rel = i : e.removeAttribute("rel")), l !== t.__title && (l ? e.title = l : e.removeAttribute("title"));
        }
        return !1;
    }
    static importDOM() {
        return {
            a: (t)=>({
                    conversion: $8162dcedd4d4e8b9$var$a,
                    priority: 1
                })
        };
    }
    static importJSON(t) {
        const e = $8162dcedd4d4e8b9$export$5ec42376570ce194(t.url, {
            rel: t.rel,
            target: t.target,
            title: t.title
        });
        return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e;
    }
    sanitizeUrl(t) {
        try {
            const e = new URL(t);
            if (!$8162dcedd4d4e8b9$var$_.has(e.protocol)) return "about:blank";
        } catch (e) {
            return t;
        }
        return t;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            rel: this.getRel(),
            target: this.getTarget(),
            title: this.getTitle(),
            type: "link",
            url: this.getURL(),
            version: 1
        };
    }
    getURL() {
        return this.getLatest().__url;
    }
    setURL(t) {
        this.getWritable().__url = t;
    }
    getTarget() {
        return this.getLatest().__target;
    }
    setTarget(t) {
        this.getWritable().__target = t;
    }
    getRel() {
        return this.getLatest().__rel;
    }
    setRel(t) {
        this.getWritable().__rel = t;
    }
    getTitle() {
        return this.getLatest().__title;
    }
    setTitle(t) {
        this.getWritable().__title = t;
    }
    insertNewAfter(t, e = !0) {
        const r = $8162dcedd4d4e8b9$export$5ec42376570ce194(this.__url, {
            rel: this.__rel,
            target: this.__target,
            title: this.__title
        });
        return this.insertAfter(r, e), r;
    }
    canInsertTextBefore() {
        return !1;
    }
    canInsertTextAfter() {
        return !1;
    }
    canBeEmpty() {
        return !1;
    }
    isInline() {
        return !0;
    }
    extractWithChild(t, e, r) {
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e)) return !1;
        const n = e.anchor.getNode(), l = e.focus.getNode();
        return this.isParentOf(n) && this.isParentOf(l) && e.getTextContent().length > 0;
    }
}
function $8162dcedd4d4e8b9$var$a(t) {
    let r = null;
    if ((0, $70f33588e7e4964f$export$f5326d78d8d21e1f)(t)) {
        const e = t.textContent;
        (null !== e && "" !== e || t.children.length > 0) && (r = $8162dcedd4d4e8b9$export$5ec42376570ce194(t.getAttribute("href") || "", {
            rel: t.getAttribute("rel"),
            target: t.getAttribute("target"),
            title: t.getAttribute("title")
        }));
    }
    return {
        node: r
    };
}
function $8162dcedd4d4e8b9$export$5ec42376570ce194(t, e) {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $8162dcedd4d4e8b9$export$4341066b87270133(t, e));
}
function $8162dcedd4d4e8b9$export$b46127abfd772033(t) {
    return t instanceof $8162dcedd4d4e8b9$export$4341066b87270133;
}
class $8162dcedd4d4e8b9$export$1f3c6513e80fcb51 extends $8162dcedd4d4e8b9$export$4341066b87270133 {
    constructor(t, e = {}, r){
        super(t, e, r), this.__isUnlinked = void 0 !== e.isUnlinked && null !== e.isUnlinked && e.isUnlinked;
    }
    static getType() {
        return "autolink";
    }
    static clone(t) {
        return new $8162dcedd4d4e8b9$export$1f3c6513e80fcb51(t.__url, {
            isUnlinked: t.__isUnlinked,
            rel: t.__rel,
            target: t.__target,
            title: t.__title
        }, t.__key);
    }
    getIsUnlinked() {
        return this.__isUnlinked;
    }
    setIsUnlinked(t) {
        const e = this.getWritable();
        return e.__isUnlinked = t, e;
    }
    createDOM(t) {
        return this.__isUnlinked ? document.createElement("span") : super.createDOM(t);
    }
    updateDOM(t, e, r) {
        return super.updateDOM(t, e, r) || t.__isUnlinked !== this.__isUnlinked;
    }
    static importJSON(t) {
        const e = $8162dcedd4d4e8b9$export$22b33a6815c95543(t.url, {
            isUnlinked: t.isUnlinked,
            rel: t.rel,
            target: t.target,
            title: t.title
        });
        return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e;
    }
    static importDOM() {
        return null;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            isUnlinked: this.__isUnlinked,
            type: "autolink",
            version: 1
        };
    }
    insertNewAfter(t, e = !0) {
        const r = this.getParentOrThrow().insertNewAfter(t, e);
        if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(r)) {
            const t = $8162dcedd4d4e8b9$export$22b33a6815c95543(this.__url, {
                isUnlinked: this.__isUnlinked,
                rel: this.__rel,
                target: this.__target,
                title: this.__title
            });
            return r.append(t), t;
        }
        return null;
    }
}
function $8162dcedd4d4e8b9$export$22b33a6815c95543(t, e) {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $8162dcedd4d4e8b9$export$1f3c6513e80fcb51(t, e));
}
function $8162dcedd4d4e8b9$export$7fd828bfe44c7434(t) {
    return t instanceof $8162dcedd4d4e8b9$export$1f3c6513e80fcb51;
}
const $8162dcedd4d4e8b9$export$42da573aae2f70a = (0, $f3de35ce60b0ef48$export$8d4021544bdece00)("TOGGLE_LINK_COMMAND");
function $8162dcedd4d4e8b9$export$a051ad64de8be534(t, e = {}) {
    const { target: r, title: n } = e, l = void 0 === e.rel ? "noreferrer" : e.rel, _ = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(_)) return;
    const o = _.extract();
    if (null === t) o.forEach((t)=>{
        const e = t.getParent();
        if (!$8162dcedd4d4e8b9$export$7fd828bfe44c7434(e) && $8162dcedd4d4e8b9$export$b46127abfd772033(e)) {
            const t = e.getChildren();
            for(let r = 0; r < t.length; r++)e.insertBefore(t[r]);
            e.remove();
        }
    });
    else {
        if (1 === o.length) {
            const e = function(t, e) {
                let r = t;
                for(; null !== r && null !== r.getParent() && !e(r);)r = r.getParentOrThrow();
                return e(r) ? r : null;
            }(o[0], $8162dcedd4d4e8b9$export$b46127abfd772033);
            if (null !== e) return e.setURL(t), void 0 !== r && e.setTarget(r), null !== l && e.setRel(l), void (void 0 !== n && e.setTitle(n));
        }
        let e = null, i = null;
        o.forEach((u)=>{
            const _ = u.getParent();
            if (_ !== i && null !== _ && (!(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(u) || u.isInline())) {
                if ($8162dcedd4d4e8b9$export$b46127abfd772033(_)) return i = _, _.setURL(t), void 0 !== r && _.setTarget(r), null !== l && i.setRel(l), void (void 0 !== n && i.setTitle(n));
                if (_.is(e) || (e = _, i = $8162dcedd4d4e8b9$export$5ec42376570ce194(t, {
                    rel: l,
                    target: r,
                    title: n
                }), $8162dcedd4d4e8b9$export$b46127abfd772033(_) ? null === u.getPreviousSibling() ? _.insertBefore(i) : _.insertAfter(i) : u.insertBefore(i)), $8162dcedd4d4e8b9$export$b46127abfd772033(u)) {
                    if (u.is(i)) return;
                    if (null !== i) {
                        const t = u.getChildren();
                        for(let e = 0; e < t.length; e++)i.append(t[e]);
                    }
                    u.remove();
                } else null !== i && i.append(u);
            }
        });
    }
}
const $8162dcedd4d4e8b9$export$b717c5e3c67fa0d4 = $8162dcedd4d4e8b9$export$a051ad64de8be534;


const $82257c13095f7911$var$mod = $8162dcedd4d4e8b9$exports;
const $82257c13095f7911$export$22b33a6815c95543 = $82257c13095f7911$var$mod.$createAutoLinkNode;
const $82257c13095f7911$export$5ec42376570ce194 = $82257c13095f7911$var$mod.$createLinkNode;
const $82257c13095f7911$export$7fd828bfe44c7434 = $82257c13095f7911$var$mod.$isAutoLinkNode;
const $82257c13095f7911$export$b46127abfd772033 = $82257c13095f7911$var$mod.$isLinkNode;
const $82257c13095f7911$export$a051ad64de8be534 = $82257c13095f7911$var$mod.$toggleLink;
const $82257c13095f7911$export$1f3c6513e80fcb51 = $82257c13095f7911$var$mod.AutoLinkNode;
const $82257c13095f7911$export$4341066b87270133 = $82257c13095f7911$var$mod.LinkNode;
const $82257c13095f7911$export$42da573aae2f70a = $82257c13095f7911$var$mod.TOGGLE_LINK_COMMAND;
const $82257c13095f7911$export$b717c5e3c67fa0d4 = $82257c13095f7911$var$mod.toggleLink;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $665498cf95a2a892$exports = {};

$parcel$export($665498cf95a2a892$exports, "MarkNode", () => $665498cf95a2a892$export$97fabeaea2789880);
$parcel$export($665498cf95a2a892$exports, "$createMarkNode", () => $665498cf95a2a892$export$cc4f7df5172be323);
$parcel$export($665498cf95a2a892$exports, "$isMarkNode", () => $665498cf95a2a892$export$b2b0559c9882d5d5);
$parcel$export($665498cf95a2a892$exports, "$unwrapMarkNode", () => $665498cf95a2a892$export$eabbe4185a8108c8);
$parcel$export($665498cf95a2a892$exports, "$wrapSelectionInMarkNode", () => $665498cf95a2a892$export$b94862eef5ed789a);
$parcel$export($665498cf95a2a892$exports, "$getMarkIDs", () => $665498cf95a2a892$export$6a6fb48556efc7dc);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

class $665498cf95a2a892$export$97fabeaea2789880 extends (0, $f3de35ce60b0ef48$export$dc064fe9e59310fd) {
    static getType() {
        return "mark";
    }
    static clone(t) {
        return new $665498cf95a2a892$export$97fabeaea2789880(Array.from(t.__ids), t.__key);
    }
    static importDOM() {
        return null;
    }
    static importJSON(t) {
        const e = $665498cf95a2a892$export$cc4f7df5172be323(t.ids);
        return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            ids: this.getIDs(),
            type: "mark",
            version: 1
        };
    }
    constructor(t, e){
        super(e), this.__ids = t || [];
    }
    createDOM(t) {
        const e = document.createElement("mark");
        return (0, $70f33588e7e4964f$export$71781797876b07d6)(e, t.theme.mark), this.__ids.length > 1 && (0, $70f33588e7e4964f$export$71781797876b07d6)(e, t.theme.markOverlap), e;
    }
    updateDOM(t, e, n) {
        const r = t.__ids, i = this.__ids, l = r.length, c = i.length, f = n.theme.markOverlap;
        return l !== c && (1 === l ? 2 === c && (0, $70f33588e7e4964f$export$71781797876b07d6)(e, f) : 1 === c && (0, $70f33588e7e4964f$export$b59af601940ff389)(e, f)), !1;
    }
    hasID(t) {
        const e = this.getIDs();
        for(let n = 0; n < e.length; n++)if (t === e[n]) return !0;
        return !1;
    }
    getIDs() {
        const t = this.getLatest();
        return $665498cf95a2a892$export$b2b0559c9882d5d5(t) ? t.__ids : [];
    }
    addID(t) {
        const e = this.getWritable();
        if ($665498cf95a2a892$export$b2b0559c9882d5d5(e)) {
            const n = e.__ids;
            e.__ids = n;
            for(let e = 0; e < n.length; e++)if (t === n[e]) return;
            n.push(t);
        }
    }
    deleteID(t) {
        const e = this.getWritable();
        if ($665498cf95a2a892$export$b2b0559c9882d5d5(e)) {
            const n = e.__ids;
            e.__ids = n;
            for(let e = 0; e < n.length; e++)if (t === n[e]) return void n.splice(e, 1);
        }
    }
    insertNewAfter(t, e = !0) {
        const n = $665498cf95a2a892$export$cc4f7df5172be323(this.__ids);
        return this.insertAfter(n, e), n;
    }
    canInsertTextBefore() {
        return !1;
    }
    canInsertTextAfter() {
        return !1;
    }
    canBeEmpty() {
        return !1;
    }
    isInline() {
        return !0;
    }
    extractWithChild(t, n, r) {
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n) || "html" === r) return !1;
        const i = n.anchor, s = n.focus, o = i.getNode(), l = s.getNode(), c = n.isBackward() ? i.offset - s.offset : s.offset - i.offset;
        return this.isParentOf(o) && this.isParentOf(l) && this.getTextContent().length === c;
    }
    excludeFromCopy(t) {
        return "clone" !== t;
    }
}
function $665498cf95a2a892$export$cc4f7df5172be323(t) {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $665498cf95a2a892$export$97fabeaea2789880(t));
}
function $665498cf95a2a892$export$b2b0559c9882d5d5(t) {
    return t instanceof $665498cf95a2a892$export$97fabeaea2789880;
}
function $665498cf95a2a892$export$eabbe4185a8108c8(t) {
    const e = t.getChildren();
    let n = null;
    for(let r = 0; r < e.length; r++){
        const i = e[r];
        null === n ? t.insertBefore(i) : n.insertAfter(i), n = i;
    }
    t.remove();
}
function $665498cf95a2a892$export$b94862eef5ed789a(t, e, n, s) {
    const o = t.getNodes(), l = t.anchor.offset, u = t.focus.offset, a = o.length, d = e ? u : l, h = e ? l : u;
    let g, m;
    for(let t = 0; t < a; t++){
        const e = o[t];
        if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(m) && m.isParentOf(e)) continue;
        const l = 0 === t, u = t === a - 1;
        let _ = null;
        if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(e)) {
            const t = e.getTextContentSize(), n = l ? d : 0, r = u ? h : t;
            if (0 === n && 0 === r) continue;
            const i = e.splitText(n, r);
            _ = i.length > 1 && (3 === i.length || l && !u || r === t) ? i[1] : i[0];
        } else {
            if ($665498cf95a2a892$export$b2b0559c9882d5d5(e)) continue;
            (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && e.isInline() && (_ = e);
        }
        if (null !== _) {
            if (_ && _.is(g)) continue;
            const t = _.getParent();
            if (null != t && t.is(g) || (m = void 0), g = t, void 0 === m) m = (s || $665498cf95a2a892$export$cc4f7df5172be323)([
                n
            ]), _.insertBefore(m);
            m.append(_);
        } else g = void 0, m = void 0;
    }
    (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(m) && (e ? m.selectStart() : m.selectEnd());
}
function $665498cf95a2a892$export$6a6fb48556efc7dc(t, e) {
    let n = t;
    for(; null !== n;){
        if ($665498cf95a2a892$export$b2b0559c9882d5d5(n)) return n.getIDs();
        if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(n) && e === n.getTextContentSize()) {
            const t = n.getNextSibling();
            if ($665498cf95a2a892$export$b2b0559c9882d5d5(t)) return t.getIDs();
        }
        n = n.getParent();
    }
    return null;
}


const $f800c74e328f5b36$var$mod = $665498cf95a2a892$exports;
const $f800c74e328f5b36$export$cc4f7df5172be323 = $f800c74e328f5b36$var$mod.$createMarkNode;
const $f800c74e328f5b36$export$6a6fb48556efc7dc = $f800c74e328f5b36$var$mod.$getMarkIDs;
const $f800c74e328f5b36$export$b2b0559c9882d5d5 = $f800c74e328f5b36$var$mod.$isMarkNode;
const $f800c74e328f5b36$export$eabbe4185a8108c8 = $f800c74e328f5b36$var$mod.$unwrapMarkNode;
const $f800c74e328f5b36$export$b94862eef5ed789a = $f800c74e328f5b36$var$mod.$wrapSelectionInMarkNode;
const $f800c74e328f5b36$export$97fabeaea2789880 = $f800c74e328f5b36$var$mod.MarkNode;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $4d3af2c0f2f64148$exports = {};

$parcel$export($4d3af2c0f2f64148$exports, "TableCellHeaderStates", () => $4d3af2c0f2f64148$export$142ccb127d8767e2);
$parcel$export($4d3af2c0f2f64148$exports, "TableCellNode", () => $4d3af2c0f2f64148$export$cff559758223b315);
$parcel$export($4d3af2c0f2f64148$exports, "$createTableCellNode", () => $4d3af2c0f2f64148$export$aa78f26693049118);
$parcel$export($4d3af2c0f2f64148$exports, "$isTableCellNode", () => $4d3af2c0f2f64148$export$37e4124cf69def13);
$parcel$export($4d3af2c0f2f64148$exports, "INSERT_TABLE_COMMAND", () => $4d3af2c0f2f64148$export$a8654016fb30b2db);
$parcel$export($4d3af2c0f2f64148$exports, "TableRowNode", () => $4d3af2c0f2f64148$export$ab6aefe5807855df);
$parcel$export($4d3af2c0f2f64148$exports, "$createTableRowNode", () => $4d3af2c0f2f64148$export$fe64b1c5681c66b9);
$parcel$export($4d3af2c0f2f64148$exports, "$isTableRowNode", () => $4d3af2c0f2f64148$export$380cf9ddb2e17840);
$parcel$export($4d3af2c0f2f64148$exports, "$createTableNodeWithDimensions", () => $4d3af2c0f2f64148$export$779ee990f9261336);
$parcel$export($4d3af2c0f2f64148$exports, "$createTableNode", () => $4d3af2c0f2f64148$export$16c8dff111f0446c);
$parcel$export($4d3af2c0f2f64148$exports, "$getTableCellNodeFromLexicalNode", () => $4d3af2c0f2f64148$export$c85815233d82a9bb);
$parcel$export($4d3af2c0f2f64148$exports, "$getTableRowNodeFromTableCellNodeOrThrow", () => $4d3af2c0f2f64148$export$59f9cec5d26569f1);
$parcel$export($4d3af2c0f2f64148$exports, "$getTableNodeFromLexicalNodeOrThrow", () => $4d3af2c0f2f64148$export$3fa7da0bc1772966);
$parcel$export($4d3af2c0f2f64148$exports, "$isTableNode", () => $4d3af2c0f2f64148$export$db59ee06e018b94f);
$parcel$export($4d3af2c0f2f64148$exports, "$getTableRowIndexFromTableCellNode", () => $4d3af2c0f2f64148$export$a25ca9146a0e3cac);
$parcel$export($4d3af2c0f2f64148$exports, "$getTableColumnIndexFromTableCellNode", () => $4d3af2c0f2f64148$export$8131c19b47539bba);
$parcel$export($4d3af2c0f2f64148$exports, "$removeTableRowAtIndex", () => $4d3af2c0f2f64148$export$f6fbda822bda5eb7);
$parcel$export($4d3af2c0f2f64148$exports, "$insertTableRow", () => $4d3af2c0f2f64148$export$f470fe73ec207356);
$parcel$export($4d3af2c0f2f64148$exports, "$insertTableRow__EXPERIMENTAL", () => $4d3af2c0f2f64148$export$7dd0aeb62c44d08);
$parcel$export($4d3af2c0f2f64148$exports, "$isTableSelection", () => $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c);
$parcel$export($4d3af2c0f2f64148$exports, "$getNodeTriplet", () => $4d3af2c0f2f64148$export$9431145ef3ef4099);
$parcel$export($4d3af2c0f2f64148$exports, "$computeTableMap", () => $4d3af2c0f2f64148$export$1c59f281edec2b86);
$parcel$export($4d3af2c0f2f64148$exports, "$insertTableColumn", () => $4d3af2c0f2f64148$export$78950918166cf524);
$parcel$export($4d3af2c0f2f64148$exports, "$insertTableColumn__EXPERIMENTAL", () => $4d3af2c0f2f64148$export$2f7773fc13b040e7);
$parcel$export($4d3af2c0f2f64148$exports, "$deleteTableColumn", () => $4d3af2c0f2f64148$export$af544ccf4e522e05);
$parcel$export($4d3af2c0f2f64148$exports, "$deleteTableRow__EXPERIMENTAL", () => $4d3af2c0f2f64148$export$82817182bd48bf97);
$parcel$export($4d3af2c0f2f64148$exports, "$deleteTableColumn__EXPERIMENTAL", () => $4d3af2c0f2f64148$export$3bb7b62f9f7d4bf2);
$parcel$export($4d3af2c0f2f64148$exports, "$unmergeCell", () => $4d3af2c0f2f64148$export$b25beed809ac054);
$parcel$export($4d3af2c0f2f64148$exports, "$computeTableMapSkipCellCheck", () => $4d3af2c0f2f64148$export$abbd98cd5b856945);
$parcel$export($4d3af2c0f2f64148$exports, "$getTableCellNodeRect", () => $4d3af2c0f2f64148$export$6b3a2ccf13eac62);
$parcel$export($4d3af2c0f2f64148$exports, "$createTableSelection", () => $4d3af2c0f2f64148$export$85a297e4ba376eca);
$parcel$export($4d3af2c0f2f64148$exports, "TableObserver", () => $4d3af2c0f2f64148$export$8b18b72f25fa6ef);
$parcel$export($4d3af2c0f2f64148$exports, "$findTableNode", () => $4d3af2c0f2f64148$export$d67cd9d452481c4a);
$parcel$export($4d3af2c0f2f64148$exports, "applyTableHandlers", () => $4d3af2c0f2f64148$export$bee333d0db884dfe);
$parcel$export($4d3af2c0f2f64148$exports, "getDOMCellFromTarget", () => $4d3af2c0f2f64148$export$1e92feb5449fa455);
$parcel$export($4d3af2c0f2f64148$exports, "$findCellNode", () => $4d3af2c0f2f64148$export$c7ed92c9d4f2dd54);
$parcel$export($4d3af2c0f2f64148$exports, "getTableObserverFromTableElement", () => $4d3af2c0f2f64148$export$44afec1ea4a7d093);
$parcel$export($4d3af2c0f2f64148$exports, "TableNode", () => $4d3af2c0f2f64148$export$8afae231582c1ea2);
$parcel$export($4d3af2c0f2f64148$exports, "$getElementForTableNode", () => $4d3af2c0f2f64148$export$238642e231418640);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

const $4d3af2c0f2f64148$var$J = /^(\d+(?:\.\d+)?)px$/, $4d3af2c0f2f64148$export$142ccb127d8767e2 = {
    BOTH: 3,
    COLUMN: 2,
    NO_STATUS: 0,
    ROW: 1
};
class $4d3af2c0f2f64148$export$cff559758223b315 extends (0, $f3de35ce60b0ef48$export$dc064fe9e59310fd) {
    static getType() {
        return "tablecell";
    }
    static clone(e) {
        const t = new $4d3af2c0f2f64148$export$cff559758223b315(e.__headerState, e.__colSpan, e.__width, e.__key);
        return t.__rowSpan = e.__rowSpan, t.__backgroundColor = e.__backgroundColor, t;
    }
    static importDOM() {
        return {
            td: (e)=>({
                    conversion: $4d3af2c0f2f64148$var$q,
                    priority: 0
                }),
            th: (e)=>({
                    conversion: $4d3af2c0f2f64148$var$q,
                    priority: 0
                })
        };
    }
    static importJSON(e) {
        const t = e.colSpan || 1, n = e.rowSpan || 1, o = $4d3af2c0f2f64148$export$aa78f26693049118(e.headerState, t, e.width || void 0);
        return o.__rowSpan = n, o.__backgroundColor = e.backgroundColor || null, o;
    }
    constructor(e = $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS, t = 1, n, o){
        super(o), this.__colSpan = t, this.__rowSpan = 1, this.__headerState = e, this.__width = n, this.__backgroundColor = null;
    }
    createDOM(t) {
        const n = document.createElement(this.getTag());
        return this.__width && (n.style.width = `${this.__width}px`), this.__colSpan > 1 && (n.colSpan = this.__colSpan), this.__rowSpan > 1 && (n.rowSpan = this.__rowSpan), null !== this.__backgroundColor && (n.style.backgroundColor = this.__backgroundColor), (0, $70f33588e7e4964f$export$71781797876b07d6)(n, t.theme.tableCell, this.hasHeader() && t.theme.tableCellHeader), n;
    }
    exportDOM(e) {
        const { element: t } = super.exportDOM(e);
        if (t) {
            const e = t;
            e.style.border = "1px solid black", this.__colSpan > 1 && (e.colSpan = this.__colSpan), this.__rowSpan > 1 && (e.rowSpan = this.__rowSpan), e.style.width = `${this.getWidth() || 75}px`, e.style.verticalAlign = "top", e.style.textAlign = "start";
            const n = this.getBackgroundColor();
            null !== n ? e.style.backgroundColor = n : this.hasHeader() && (e.style.backgroundColor = "#f2f3f5");
        }
        return {
            element: t
        };
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            backgroundColor: this.getBackgroundColor(),
            colSpan: this.__colSpan,
            headerState: this.__headerState,
            rowSpan: this.__rowSpan,
            type: "tablecell",
            width: this.getWidth()
        };
    }
    getColSpan() {
        return this.__colSpan;
    }
    setColSpan(e) {
        return this.getWritable().__colSpan = e, this;
    }
    getRowSpan() {
        return this.__rowSpan;
    }
    setRowSpan(e) {
        return this.getWritable().__rowSpan = e, this;
    }
    getTag() {
        return this.hasHeader() ? "th" : "td";
    }
    setHeaderStyles(e) {
        return this.getWritable().__headerState = e, this.__headerState;
    }
    getHeaderStyles() {
        return this.getLatest().__headerState;
    }
    setWidth(e) {
        return this.getWritable().__width = e, this.__width;
    }
    getWidth() {
        return this.getLatest().__width;
    }
    getBackgroundColor() {
        return this.getLatest().__backgroundColor;
    }
    setBackgroundColor(e) {
        this.getWritable().__backgroundColor = e;
    }
    toggleHeaderStyle(e) {
        const t = this.getWritable();
        return (t.__headerState & e) === e ? t.__headerState -= e : t.__headerState += e, t;
    }
    hasHeaderState(e) {
        return (this.getHeaderStyles() & e) === e;
    }
    hasHeader() {
        return this.getLatest().__headerState !== $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS;
    }
    updateDOM(e) {
        return e.__headerState !== this.__headerState || e.__width !== this.__width || e.__colSpan !== this.__colSpan || e.__rowSpan !== this.__rowSpan || e.__backgroundColor !== this.__backgroundColor;
    }
    isShadowRoot() {
        return !0;
    }
    collapseAtStart() {
        return !0;
    }
    canBeEmpty() {
        return !1;
    }
    canIndent() {
        return !1;
    }
}
function $4d3af2c0f2f64148$var$q(e) {
    const t = e, n = e.nodeName.toLowerCase();
    let o;
    $4d3af2c0f2f64148$var$J.test(t.style.width) && (o = parseFloat(t.style.width));
    const r = $4d3af2c0f2f64148$export$aa78f26693049118("th" === n ? $4d3af2c0f2f64148$export$142ccb127d8767e2.ROW : $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS, t.colSpan, o);
    r.__rowSpan = t.rowSpan;
    const a = t.style.backgroundColor;
    "" !== a && (r.__backgroundColor = a);
    const d = t.style, u = d.textDecoration.split(" "), h = "700" === d.fontWeight || "bold" === d.fontWeight, g = u.includes("line-through"), f = "italic" === d.fontStyle, m = u.includes("underline");
    return {
        after: (e)=>(0 === e.length && e.push((0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)()), e),
        forChild: (e, t)=>{
            if ($4d3af2c0f2f64148$export$37e4124cf69def13(t) && !(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e)) {
                const t = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)();
                return (0, $f3de35ce60b0ef48$export$b16330e40aa25c4e)(e) && "\n" === e.getTextContent() ? null : ((0, $f3de35ce60b0ef48$export$471953706258be2b)(e) && (h && e.toggleFormat("bold"), g && e.toggleFormat("strikethrough"), f && e.toggleFormat("italic"), m && e.toggleFormat("underline")), t.append(e), t);
            }
            return e;
        },
        node: r
    };
}
function $4d3af2c0f2f64148$export$aa78f26693049118(e, t = 1, n) {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $4d3af2c0f2f64148$export$cff559758223b315(e, t, n));
}
function $4d3af2c0f2f64148$export$37e4124cf69def13(e) {
    return e instanceof $4d3af2c0f2f64148$export$cff559758223b315;
}
const $4d3af2c0f2f64148$export$a8654016fb30b2db = (0, $f3de35ce60b0ef48$export$8d4021544bdece00)("INSERT_TABLE_COMMAND");
class $4d3af2c0f2f64148$export$ab6aefe5807855df extends (0, $f3de35ce60b0ef48$export$dc064fe9e59310fd) {
    static getType() {
        return "tablerow";
    }
    static clone(e) {
        return new $4d3af2c0f2f64148$export$ab6aefe5807855df(e.__height, e.__key);
    }
    static importDOM() {
        return {
            tr: (e)=>({
                    conversion: $4d3af2c0f2f64148$var$ee,
                    priority: 0
                })
        };
    }
    static importJSON(e) {
        return $4d3af2c0f2f64148$export$fe64b1c5681c66b9(e.height);
    }
    constructor(e, t){
        super(t), this.__height = e;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            ...this.getHeight() && {
                height: this.getHeight()
            },
            type: "tablerow",
            version: 1
        };
    }
    createDOM(t) {
        const n = document.createElement("tr");
        return this.__height && (n.style.height = `${this.__height}px`), (0, $70f33588e7e4964f$export$71781797876b07d6)(n, t.theme.tableRow), n;
    }
    isShadowRoot() {
        return !0;
    }
    setHeight(e) {
        return this.getWritable().__height = e, this.__height;
    }
    getHeight() {
        return this.getLatest().__height;
    }
    updateDOM(e) {
        return e.__height !== this.__height;
    }
    canBeEmpty() {
        return !1;
    }
    canIndent() {
        return !1;
    }
}
function $4d3af2c0f2f64148$var$ee(e) {
    const t = e;
    let n;
    return $4d3af2c0f2f64148$var$J.test(t.style.height) && (n = parseFloat(t.style.height)), {
        node: $4d3af2c0f2f64148$export$fe64b1c5681c66b9(n)
    };
}
function $4d3af2c0f2f64148$export$fe64b1c5681c66b9(e) {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $4d3af2c0f2f64148$export$ab6aefe5807855df(e));
}
function $4d3af2c0f2f64148$export$380cf9ddb2e17840(e) {
    return e instanceof $4d3af2c0f2f64148$export$ab6aefe5807855df;
}
function $4d3af2c0f2f64148$var$oe(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $4d3af2c0f2f64148$var$re = $4d3af2c0f2f64148$var$oe(function(e) {
    const t = new URLSearchParams;
    t.append("code", e);
    for(let e = 1; e < arguments.length; e++)t.append("v", arguments[e]);
    throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const $4d3af2c0f2f64148$var$le = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement;
function $4d3af2c0f2f64148$export$779ee990f9261336(e, t, n = !0) {
    const o = $4d3af2c0f2f64148$export$16c8dff111f0446c();
    for(let r = 0; r < e; r++){
        const e = $4d3af2c0f2f64148$export$fe64b1c5681c66b9();
        for(let o = 0; o < t; o++){
            let t = $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS;
            "object" == typeof n ? (0 === r && n.rows && (t |= $4d3af2c0f2f64148$export$142ccb127d8767e2.ROW), 0 === o && n.columns && (t |= $4d3af2c0f2f64148$export$142ccb127d8767e2.COLUMN)) : n && (0 === r && (t |= $4d3af2c0f2f64148$export$142ccb127d8767e2.ROW), 0 === o && (t |= $4d3af2c0f2f64148$export$142ccb127d8767e2.COLUMN));
            const s = $4d3af2c0f2f64148$export$aa78f26693049118(t), i = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)();
            i.append((0, $f3de35ce60b0ef48$export$2785f39dcdec0078)()), s.append(i), e.append(s);
        }
        o.append(e);
    }
    return o;
}
function $4d3af2c0f2f64148$export$c85815233d82a9bb(e) {
    const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e));
    return $4d3af2c0f2f64148$export$37e4124cf69def13(n) ? n : null;
}
function $4d3af2c0f2f64148$export$59f9cec5d26569f1(e) {
    const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, (e)=>$4d3af2c0f2f64148$export$380cf9ddb2e17840(e));
    if ($4d3af2c0f2f64148$export$380cf9ddb2e17840(n)) return n;
    throw new Error("Expected table cell to be inside of table row.");
}
function $4d3af2c0f2f64148$export$3fa7da0bc1772966(e) {
    const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, (e)=>$4d3af2c0f2f64148$export$db59ee06e018b94f(e));
    if ($4d3af2c0f2f64148$export$db59ee06e018b94f(n)) return n;
    throw new Error("Expected table cell to be inside of table.");
}
function $4d3af2c0f2f64148$export$a25ca9146a0e3cac(e) {
    const t = $4d3af2c0f2f64148$export$59f9cec5d26569f1(e);
    return $4d3af2c0f2f64148$export$3fa7da0bc1772966(t).getChildren().findIndex((e)=>e.is(t));
}
function $4d3af2c0f2f64148$export$8131c19b47539bba(e) {
    return $4d3af2c0f2f64148$export$59f9cec5d26569f1(e).getChildren().findIndex((t)=>t.is(e));
}
function $4d3af2c0f2f64148$var$he(e, t) {
    const n = $4d3af2c0f2f64148$export$3fa7da0bc1772966(e), { x: o, y: r } = n.getCordsFromCellNode(e, t);
    return {
        above: n.getCellNodeFromCords(o, r - 1, t),
        below: n.getCellNodeFromCords(o, r + 1, t),
        left: n.getCellNodeFromCords(o - 1, r, t),
        right: n.getCellNodeFromCords(o + 1, r, t)
    };
}
function $4d3af2c0f2f64148$export$f6fbda822bda5eb7(e, t) {
    const n = e.getChildren();
    if (t >= n.length || t < 0) throw new Error("Expected table cell to be inside of table row.");
    return n[t].remove(), e;
}
function $4d3af2c0f2f64148$export$f470fe73ec207356(e, t, n = !0, o, r) {
    const s = e.getChildren();
    if (t >= s.length || t < 0) throw new Error("Table row target index out of range");
    const i = s[t];
    if (!$4d3af2c0f2f64148$export$380cf9ddb2e17840(i)) throw new Error("Row before insertion index does not exist.");
    for(let e = 0; e < o; e++){
        const e = i.getChildren(), t = e.length, o = $4d3af2c0f2f64148$export$fe64b1c5681c66b9();
        for(let n = 0; n < t; n++){
            const t = e[n];
            $4d3af2c0f2f64148$export$37e4124cf69def13(t) || $4d3af2c0f2f64148$var$re(12);
            const { above: s, below: i } = $4d3af2c0f2f64148$var$he(t, r);
            let c = $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS;
            const a = s && s.getWidth() || i && i.getWidth() || void 0;
            (s && s.hasHeaderState($4d3af2c0f2f64148$export$142ccb127d8767e2.COLUMN) || i && i.hasHeaderState($4d3af2c0f2f64148$export$142ccb127d8767e2.COLUMN)) && (c |= $4d3af2c0f2f64148$export$142ccb127d8767e2.COLUMN);
            const d = $4d3af2c0f2f64148$export$aa78f26693049118(c, 1, a);
            d.append((0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)()), o.append(d);
        }
        n ? i.insertAfter(o) : i.insertBefore(o);
    }
    return e;
}
const $4d3af2c0f2f64148$var$me = (e, t)=>e === $4d3af2c0f2f64148$export$142ccb127d8767e2.BOTH || e === t ? t : $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS;
function $4d3af2c0f2f64148$export$7dd0aeb62c44d08(e = !0) {
    const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) || $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) || $4d3af2c0f2f64148$var$re(118);
    const n = t.focus.getNode(), [o, , r] = $4d3af2c0f2f64148$export$9431145ef3ef4099(n), [s, i] = $4d3af2c0f2f64148$export$1c59f281edec2b86(r, o, o), c = s[0].length, { startRow: a } = i;
    if (e) {
        const e = a + o.__rowSpan - 1, t = s[e], n = $4d3af2c0f2f64148$export$fe64b1c5681c66b9();
        for(let o = 0; o < c; o++){
            const { cell: r, startRow: s } = t[o];
            if (s + r.__rowSpan - 1 <= e) {
                const e = t[o].cell.__headerState, r = $4d3af2c0f2f64148$var$me(e, $4d3af2c0f2f64148$export$142ccb127d8767e2.COLUMN);
                n.append($4d3af2c0f2f64148$export$aa78f26693049118(r).append((0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)()));
            } else r.setRowSpan(r.__rowSpan + 1);
        }
        const i = r.getChildAtIndex(e);
        $4d3af2c0f2f64148$export$380cf9ddb2e17840(i) || $4d3af2c0f2f64148$var$re(145), i.insertAfter(n);
    } else {
        const e = s[a], t = $4d3af2c0f2f64148$export$fe64b1c5681c66b9();
        for(let n = 0; n < c; n++){
            const { cell: o, startRow: r } = e[n];
            if (r === a) {
                const o = e[n].cell.__headerState, r = $4d3af2c0f2f64148$var$me(o, $4d3af2c0f2f64148$export$142ccb127d8767e2.COLUMN);
                t.append($4d3af2c0f2f64148$export$aa78f26693049118(r).append((0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)()));
            } else o.setRowSpan(o.__rowSpan + 1);
        }
        const n = r.getChildAtIndex(a);
        $4d3af2c0f2f64148$export$380cf9ddb2e17840(n) || $4d3af2c0f2f64148$var$re(145), n.insertBefore(t);
    }
}
function $4d3af2c0f2f64148$export$78950918166cf524(e, t, n = !0, o, r) {
    const s = e.getChildren(), i = [];
    for(let e = 0; e < s.length; e++){
        const n = s[e];
        if ($4d3af2c0f2f64148$export$380cf9ddb2e17840(n)) for(let e = 0; e < o; e++){
            const e = n.getChildren();
            if (t >= e.length || t < 0) throw new Error("Table column target index out of range");
            const o = e[t];
            $4d3af2c0f2f64148$export$37e4124cf69def13(o) || $4d3af2c0f2f64148$var$re(12);
            const { left: s, right: c } = $4d3af2c0f2f64148$var$he(o, r);
            let a = $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS;
            (s && s.hasHeaderState($4d3af2c0f2f64148$export$142ccb127d8767e2.ROW) || c && c.hasHeaderState($4d3af2c0f2f64148$export$142ccb127d8767e2.ROW)) && (a |= $4d3af2c0f2f64148$export$142ccb127d8767e2.ROW);
            const d = $4d3af2c0f2f64148$export$aa78f26693049118(a);
            d.append((0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)()), i.push({
                newTableCell: d,
                targetCell: o
            });
        }
    }
    return i.forEach(({ newTableCell: e, targetCell: t })=>{
        n ? t.insertAfter(e) : t.insertBefore(e);
    }), e;
}
function $4d3af2c0f2f64148$export$2f7773fc13b040e7(e = !0) {
    const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) || $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) || $4d3af2c0f2f64148$var$re(118);
    const n = t.anchor.getNode(), o = t.focus.getNode(), [r] = $4d3af2c0f2f64148$export$9431145ef3ef4099(n), [s, , i] = $4d3af2c0f2f64148$export$9431145ef3ef4099(o), [c, a, d] = $4d3af2c0f2f64148$export$1c59f281edec2b86(i, s, r), u = c.length, f = e ? Math.max(a.startColumn, d.startColumn) : Math.min(a.startColumn, d.startColumn), m = e ? f + s.__colSpan - 1 : f - 1, p = i.getFirstChild();
    $4d3af2c0f2f64148$export$380cf9ddb2e17840(p) || $4d3af2c0f2f64148$var$re(120);
    let C = null;
    function S(e = $4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS) {
        const t = $4d3af2c0f2f64148$export$aa78f26693049118(e).append((0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)());
        return null === C && (C = t), t;
    }
    let _ = p;
    e: for(let e = 0; e < u; e++){
        if (0 !== e) {
            const e = _.getNextSibling();
            $4d3af2c0f2f64148$export$380cf9ddb2e17840(e) || $4d3af2c0f2f64148$var$re(121), _ = e;
        }
        const t = c[e], n = t[m < 0 ? 0 : m].cell.__headerState, o = $4d3af2c0f2f64148$var$me(n, $4d3af2c0f2f64148$export$142ccb127d8767e2.ROW);
        if (m < 0) {
            $4d3af2c0f2f64148$var$Ne(_, S(o));
            continue;
        }
        const { cell: r, startColumn: l, startRow: s } = t[m];
        if (l + r.__colSpan - 1 <= m) {
            let n = r, l = s, i = m;
            for(; l !== e && n.__rowSpan > 1;){
                if (i -= r.__colSpan, !(i >= 0)) {
                    _.append(S(o));
                    continue e;
                }
                {
                    const { cell: e, startRow: o } = t[i];
                    n = e, l = o;
                }
            }
            n.insertAfter(S(o));
        } else r.setColSpan(r.__colSpan + 1);
    }
    null !== C && $4d3af2c0f2f64148$var$ye(C);
}
function $4d3af2c0f2f64148$export$af544ccf4e522e05(e, t) {
    const n = e.getChildren();
    for(let e = 0; e < n.length; e++){
        const o = n[e];
        if ($4d3af2c0f2f64148$export$380cf9ddb2e17840(o)) {
            const e = o.getChildren();
            if (t >= e.length || t < 0) throw new Error("Table column target index out of range");
            e[t].remove();
        }
    }
    return e;
}
function $4d3af2c0f2f64148$export$82817182bd48bf97() {
    const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) || $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(e) || $4d3af2c0f2f64148$var$re(118);
    const t = e.anchor.getNode(), n = e.focus.getNode(), [o, , r] = $4d3af2c0f2f64148$export$9431145ef3ef4099(t), [l] = $4d3af2c0f2f64148$export$9431145ef3ef4099(n), [s, i, c] = $4d3af2c0f2f64148$export$1c59f281edec2b86(r, o, l), { startRow: a } = i, { startRow: d } = c, u = d + l.__rowSpan - 1;
    if (s.length === u - a + 1) return void r.remove();
    const f = s[0].length, m = s[u + 1], p = r.getChildAtIndex(u + 1);
    for(let e = u; e >= a; e--){
        for(let t = f - 1; t >= 0; t--){
            const { cell: n, startRow: o, startColumn: r } = s[e][t];
            if (r === t && (e === a && o < a && n.setRowSpan(n.__rowSpan - (o - a)), o >= a && o + n.__rowSpan - 1 > u)) {
                if (n.setRowSpan(n.__rowSpan - (u - o + 1)), null === p && $4d3af2c0f2f64148$var$re(122), 0 === t) $4d3af2c0f2f64148$var$Ne(p, n);
                else {
                    const { cell: e } = m[t - 1];
                    e.insertAfter(n);
                }
            }
        }
        const t = r.getChildAtIndex(e);
        $4d3af2c0f2f64148$export$380cf9ddb2e17840(t) || $4d3af2c0f2f64148$var$re(123, String(e)), t.remove();
    }
    if (void 0 !== m) {
        const { cell: e } = m[0];
        $4d3af2c0f2f64148$var$ye(e);
    } else {
        const e = s[a - 1], { cell: t } = e[0];
        $4d3af2c0f2f64148$var$ye(t);
    }
}
function $4d3af2c0f2f64148$export$3bb7b62f9f7d4bf2() {
    const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) || $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(e) || $4d3af2c0f2f64148$var$re(118);
    const t = e.anchor.getNode(), n = e.focus.getNode(), [o, , r] = $4d3af2c0f2f64148$export$9431145ef3ef4099(t), [l] = $4d3af2c0f2f64148$export$9431145ef3ef4099(n), [s, i, c] = $4d3af2c0f2f64148$export$1c59f281edec2b86(r, o, l), { startColumn: a } = i, { startRow: d, startColumn: u } = c, f = Math.min(a, u), m = Math.max(a + o.__colSpan - 1, u + l.__colSpan - 1), p = m - f + 1;
    if (s[0].length === m - f + 1) return r.selectPrevious(), void r.remove();
    const C = s.length;
    for(let e = 0; e < C; e++)for(let t = f; t <= m; t++){
        const { cell: n, startColumn: o } = s[e][t];
        if (o < f) {
            if (t === f) {
                const e = f - o;
                n.setColSpan(n.__colSpan - Math.min(p, n.__colSpan - e));
            }
        } else if (o + n.__colSpan - 1 > m) {
            if (t === m) {
                const e = m - o + 1;
                n.setColSpan(n.__colSpan - e);
            }
        } else n.remove();
    }
    const S = s[d], _ = a > u ? S[a + o.__colSpan] : S[u + l.__colSpan];
    if (void 0 !== _) {
        const { cell: e } = _;
        $4d3af2c0f2f64148$var$ye(e);
    } else {
        const e = u < a ? S[u - 1] : S[a - 1], { cell: t } = e;
        $4d3af2c0f2f64148$var$ye(t);
    }
}
function $4d3af2c0f2f64148$var$ye(e) {
    const t = e.getFirstDescendant();
    null == t ? e.selectStart() : t.getParentOrThrow().selectStart();
}
function $4d3af2c0f2f64148$var$Ne(e, t) {
    const n = e.getFirstChild();
    null !== n ? n.insertBefore(t) : e.append(t);
}
function $4d3af2c0f2f64148$export$b25beed809ac054() {
    const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) || $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(e) || $4d3af2c0f2f64148$var$re(118);
    const t = e.anchor.getNode(), [n, o, r] = $4d3af2c0f2f64148$export$9431145ef3ef4099(t), l = n.__colSpan, s = n.__rowSpan;
    if (l > 1) {
        for(let e = 1; e < l; e++)n.insertAfter($4d3af2c0f2f64148$export$aa78f26693049118($4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS));
        n.setColSpan(1);
    }
    if (s > 1) {
        const [e, t] = $4d3af2c0f2f64148$export$1c59f281edec2b86(r, n, n), { startColumn: i, startRow: c } = t;
        let a;
        for(let t = 1; t < s; t++){
            const n = c + t, r = e[n];
            a = (a || o).getNextSibling(), $4d3af2c0f2f64148$export$380cf9ddb2e17840(a) || $4d3af2c0f2f64148$var$re(125);
            let s = null;
            for(let e = 0; e < i; e++){
                const t = r[e], o = t.cell;
                t.startRow === n && (s = o), o.__colSpan > 1 && (e += o.__colSpan - 1);
            }
            if (null === s) for(let e = 0; e < l; e++)$4d3af2c0f2f64148$var$Ne(a, $4d3af2c0f2f64148$export$aa78f26693049118($4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS));
            else for(let e = 0; e < l; e++)s.insertAfter($4d3af2c0f2f64148$export$aa78f26693049118($4d3af2c0f2f64148$export$142ccb127d8767e2.NO_STATUS));
        }
        n.setRowSpan(1);
    }
}
function $4d3af2c0f2f64148$export$1c59f281edec2b86(e, t, n) {
    const [o, r, l] = $4d3af2c0f2f64148$export$abbd98cd5b856945(e, t, n);
    return null === r && $4d3af2c0f2f64148$var$re(110), null === l && $4d3af2c0f2f64148$var$re(111), [
        o,
        r,
        l
    ];
}
function $4d3af2c0f2f64148$export$abbd98cd5b856945(e, t, n) {
    const o = [];
    let r = null, l = null;
    function s(e, s, i) {
        const c = {
            cell: i,
            startColumn: s,
            startRow: e
        }, a = i.__rowSpan, d = i.__colSpan;
        for(let t = 0; t < a; t++){
            void 0 === o[e + t] && (o[e + t] = []);
            for(let n = 0; n < d; n++)o[e + t][s + n] = c;
        }
        null !== t && t.is(i) && (r = c), null !== n && n.is(i) && (l = c);
    }
    function i(e, t) {
        return void 0 === o[e] || void 0 === o[e][t];
    }
    const c = e.getChildren();
    for(let e = 0; e < c.length; e++){
        const t = c[e];
        $4d3af2c0f2f64148$export$380cf9ddb2e17840(t) || $4d3af2c0f2f64148$var$re(146);
        const n = t.getChildren();
        let o = 0;
        for (const t of n){
            for($4d3af2c0f2f64148$export$37e4124cf69def13(t) || $4d3af2c0f2f64148$var$re(147); !i(e, o);)o++;
            s(e, o, t), o += t.__colSpan;
        }
    }
    return [
        o,
        r,
        l
    ];
}
function $4d3af2c0f2f64148$export$9431145ef3ef4099(e) {
    let n;
    if (e instanceof $4d3af2c0f2f64148$export$cff559758223b315) n = e;
    else if ("__type" in e) {
        const o = (0, $70f33588e7e4964f$export$57101724ca611500)(e, $4d3af2c0f2f64148$export$37e4124cf69def13);
        $4d3af2c0f2f64148$export$37e4124cf69def13(o) || $4d3af2c0f2f64148$var$re(148), n = o;
    } else {
        const o = (0, $70f33588e7e4964f$export$57101724ca611500)(e.getNode(), $4d3af2c0f2f64148$export$37e4124cf69def13);
        $4d3af2c0f2f64148$export$37e4124cf69def13(o) || $4d3af2c0f2f64148$var$re(148), n = o;
    }
    const o = n.getParent();
    $4d3af2c0f2f64148$export$380cf9ddb2e17840(o) || $4d3af2c0f2f64148$var$re(149);
    const r = o.getParent();
    return $4d3af2c0f2f64148$export$db59ee06e018b94f(r) || $4d3af2c0f2f64148$var$re(150), [
        n,
        o,
        r
    ];
}
function $4d3af2c0f2f64148$export$6b3a2ccf13eac62(e) {
    const [t, , n] = $4d3af2c0f2f64148$export$9431145ef3ef4099(e), o = n.getChildren(), r = o.length, l = o[0].getChildren().length, s = new Array(r);
    for(let e = 0; e < r; e++)s[e] = new Array(l);
    for(let e = 0; e < r; e++){
        const n = o[e].getChildren();
        let r = 0;
        for(let o = 0; o < n.length; o++){
            for(; s[e][r];)r++;
            const l = n[o], i = l.__rowSpan || 1, c = l.__colSpan || 1;
            for(let t = 0; t < i; t++)for(let n = 0; n < c; n++)s[e + t][r + n] = l;
            if (t === l) return {
                colSpan: c,
                columnIndex: r,
                rowIndex: e,
                rowSpan: i
            };
            r += c;
        }
    }
    return null;
}
class $4d3af2c0f2f64148$var$Me {
    constructor(e, t, n){
        this.anchor = t, this.focus = n, t._selection = this, n._selection = this, this._cachedNodes = null, this.dirty = !1, this.tableKey = e;
    }
    getStartEndPoints() {
        return [
            this.anchor,
            this.focus
        ];
    }
    isBackward() {
        return this.focus.isBefore(this.anchor);
    }
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(e) {
        this._cachedNodes = e;
    }
    is(e) {
        return !!$4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(e) && this.tableKey === e.tableKey && this.anchor.is(e.anchor) && this.focus.is(e.focus);
    }
    set(e, t, n) {
        this.dirty = !0, this.tableKey = e, this.anchor.key = t, this.focus.key = n, this._cachedNodes = null;
    }
    clone() {
        return new $4d3af2c0f2f64148$var$Me(this.tableKey, this.anchor, this.focus);
    }
    isCollapsed() {
        return !1;
    }
    extract() {
        return this.getNodes();
    }
    insertRawText(e) {}
    insertText() {}
    insertNodes(e) {
        const t = this.focus.getNode();
        (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(t) || $4d3af2c0f2f64148$var$re(151);
        (0, $f3de35ce60b0ef48$export$db10bc6ba67ffcb5)(t.select(0, t.getChildrenSize())).insertNodes(e);
    }
    getShape() {
        const e = (0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(this.anchor.key);
        $4d3af2c0f2f64148$export$37e4124cf69def13(e) || $4d3af2c0f2f64148$var$re(152);
        const t = $4d3af2c0f2f64148$export$6b3a2ccf13eac62(e);
        null === t && $4d3af2c0f2f64148$var$re(153);
        const n = (0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(this.focus.key);
        $4d3af2c0f2f64148$export$37e4124cf69def13(n) || $4d3af2c0f2f64148$var$re(154);
        const o = $4d3af2c0f2f64148$export$6b3a2ccf13eac62(n);
        null === o && $4d3af2c0f2f64148$var$re(155);
        const r = Math.min(t.columnIndex, o.columnIndex), l = Math.max(t.columnIndex, o.columnIndex), s = Math.min(t.rowIndex, o.rowIndex), i = Math.max(t.rowIndex, o.rowIndex);
        return {
            fromX: Math.min(r, l),
            fromY: Math.min(s, i),
            toX: Math.max(r, l),
            toY: Math.max(s, i)
        };
    }
    getNodes() {
        const e = this._cachedNodes;
        if (null !== e) return e;
        const n = this.anchor.getNode(), o = this.focus.getNode(), r = (0, $70f33588e7e4964f$export$57101724ca611500)(n, $4d3af2c0f2f64148$export$37e4124cf69def13), l = (0, $70f33588e7e4964f$export$57101724ca611500)(o, $4d3af2c0f2f64148$export$37e4124cf69def13);
        $4d3af2c0f2f64148$export$37e4124cf69def13(r) || $4d3af2c0f2f64148$var$re(152), $4d3af2c0f2f64148$export$37e4124cf69def13(l) || $4d3af2c0f2f64148$var$re(154);
        const s = r.getParent();
        $4d3af2c0f2f64148$export$380cf9ddb2e17840(s) || $4d3af2c0f2f64148$var$re(156);
        const i = s.getParent();
        $4d3af2c0f2f64148$export$db59ee06e018b94f(i) || $4d3af2c0f2f64148$var$re(157);
        const c = l.getParents()[1];
        if (c !== i) {
            if (i.isParentOf(l)) {
                const e = c.getParent();
                null == e && $4d3af2c0f2f64148$var$re(159), this.set(this.tableKey, l.getKey(), e.getKey());
            } else {
                const e = i.getParent();
                null == e && $4d3af2c0f2f64148$var$re(158), this.set(this.tableKey, e.getKey(), l.getKey());
            }
            return this.getNodes();
        }
        const [a, d, u] = $4d3af2c0f2f64148$export$1c59f281edec2b86(i, r, l);
        let h = Math.min(d.startColumn, u.startColumn), g = Math.min(d.startRow, u.startRow), f = Math.max(d.startColumn + d.cell.__colSpan - 1, u.startColumn + u.cell.__colSpan - 1), m = Math.max(d.startRow + d.cell.__rowSpan - 1, u.startRow + u.cell.__rowSpan - 1), p = h, S = g, _ = h, w = g;
        function b(e) {
            const { cell: t, startColumn: n, startRow: o } = e;
            h = Math.min(h, n), g = Math.min(g, o), f = Math.max(f, n + t.__colSpan - 1), m = Math.max(m, o + t.__rowSpan - 1);
        }
        for(; h < p || g < S || f > _ || m > w;){
            if (h < p) {
                const e = w - S, t = p - 1;
                for(let n = 0; n <= e; n++)b(a[S + n][t]);
                p = t;
            }
            if (g < S) {
                const e = _ - p, t = S - 1;
                for(let n = 0; n <= e; n++)b(a[t][p + n]);
                S = t;
            }
            if (f > _) {
                const e = w - S, t = _ + 1;
                for(let n = 0; n <= e; n++)b(a[S + n][t]);
                _ = t;
            }
            if (m > w) {
                const e = _ - p, t = w + 1;
                for(let n = 0; n <= e; n++)b(a[t][p + n]);
                w = t;
            }
        }
        const y = [
            i
        ];
        let N = null;
        for(let e = g; e <= m; e++)for(let t = h; t <= f; t++){
            const { cell: n } = a[e][t], o = n.getParent();
            $4d3af2c0f2f64148$export$380cf9ddb2e17840(o) || $4d3af2c0f2f64148$var$re(160), o !== N && y.push(o), y.push(n, ...$4d3af2c0f2f64148$var$Fe(n)), N = o;
        }
        return (0, $f3de35ce60b0ef48$export$761df28585b755e8)() || (this._cachedNodes = y), y;
    }
    getTextContent() {
        const e = this.getNodes();
        let t = "";
        for(let n = 0; n < e.length; n++)t += e[n].getTextContent();
        return t;
    }
}
function $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(e) {
    return e instanceof $4d3af2c0f2f64148$var$Me;
}
function $4d3af2c0f2f64148$export$85a297e4ba376eca() {
    const e = (0, $f3de35ce60b0ef48$export$9b3f8d373c057995)("root", 0, "element"), t = (0, $f3de35ce60b0ef48$export$9b3f8d373c057995)("root", 0, "element");
    return new $4d3af2c0f2f64148$var$Me("root", e, t);
}
function $4d3af2c0f2f64148$var$Fe(e) {
    const t = [], n = [
        e
    ];
    for(; n.length > 0;){
        const o = n.pop();
        void 0 === o && $4d3af2c0f2f64148$var$re(112), (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(o) && n.unshift(...o.getChildren()), o !== e && t.push(o);
    }
    return t;
}
class $4d3af2c0f2f64148$export$8b18b72f25fa6ef {
    constructor(e, t){
        this.isHighlightingCells = !1, this.anchorX = -1, this.anchorY = -1, this.focusX = -1, this.focusY = -1, this.listenersToRemove = new Set, this.tableNodeKey = t, this.editor = e, this.table = {
            columns: 0,
            domRows: [],
            rows: 0
        }, this.tableSelection = null, this.anchorCellNodeKey = null, this.focusCellNodeKey = null, this.anchorCell = null, this.focusCell = null, this.hasHijackedSelectionStyles = !1, this.trackTable(), this.isSelecting = !1;
    }
    getTable() {
        return this.table;
    }
    removeListeners() {
        Array.from(this.listenersToRemove).forEach((e)=>e());
    }
    trackTable() {
        const e = new MutationObserver((e)=>{
            this.editor.update(()=>{
                let t = !1;
                for(let n = 0; n < e.length; n++){
                    const o = e[n].target.nodeName;
                    if ("TABLE" === o || "TBODY" === o || "THEAD" === o || "TR" === o) {
                        t = !0;
                        break;
                    }
                }
                if (!t) return;
                const n = this.editor.getElementByKey(this.tableNodeKey);
                if (!n) throw new Error("Expected to find TableElement in DOM");
                this.table = $4d3af2c0f2f64148$var$Le(n);
            });
        });
        this.editor.update(()=>{
            const t = this.editor.getElementByKey(this.tableNodeKey);
            if (!t) throw new Error("Expected to find TableElement in DOM");
            this.table = $4d3af2c0f2f64148$var$Le(t), e.observe(t, {
                childList: !0,
                subtree: !0
            });
        });
    }
    clearHighlight() {
        const e = this.editor;
        this.isHighlightingCells = !1, this.anchorX = -1, this.anchorY = -1, this.focusX = -1, this.focusY = -1, this.tableSelection = null, this.anchorCellNodeKey = null, this.focusCellNodeKey = null, this.anchorCell = null, this.focusCell = null, this.hasHijackedSelectionStyles = !1, this.enableHighlightStyle(), e.update(()=>{
            if (!$4d3af2c0f2f64148$export$db59ee06e018b94f((0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(this.tableNodeKey))) throw new Error("Expected TableNode.");
            const t = e.getElementByKey(this.tableNodeKey);
            if (!t) throw new Error("Expected to find TableElement in DOM");
            const n = $4d3af2c0f2f64148$var$Le(t);
            $4d3af2c0f2f64148$var$Ie(e, n, null), (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(null), e.dispatchCommand((0, $f3de35ce60b0ef48$export$e396fef71d2b56e5), void 0);
        });
    }
    enableHighlightStyle() {
        const e = this.editor;
        e.update(()=>{
            const t = e.getElementByKey(this.tableNodeKey);
            if (!t) throw new Error("Expected to find TableElement in DOM");
            (0, $70f33588e7e4964f$export$b59af601940ff389)(t, e._config.theme.tableSelection), t.classList.remove("disable-selection"), this.hasHijackedSelectionStyles = !1;
        });
    }
    disableHighlightStyle() {
        const t = this.editor;
        t.update(()=>{
            const n = t.getElementByKey(this.tableNodeKey);
            if (!n) throw new Error("Expected to find TableElement in DOM");
            (0, $70f33588e7e4964f$export$71781797876b07d6)(n, t._config.theme.tableSelection), this.hasHijackedSelectionStyles = !0;
        });
    }
    updateTableTableSelection(e) {
        if (null !== e && e.tableKey === this.tableNodeKey) {
            const t = this.editor;
            this.tableSelection = e, this.isHighlightingCells = !0, this.disableHighlightStyle(), $4d3af2c0f2f64148$var$Ie(t, this.table, this.tableSelection);
        } else null == e ? this.clearHighlight() : (this.tableNodeKey = e.tableKey, this.updateTableTableSelection(e));
    }
    setFocusCellForSelection(e, t = !1) {
        const n = this.editor;
        n.update(()=>{
            const o = (0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(this.tableNodeKey);
            if (!$4d3af2c0f2f64148$export$db59ee06e018b94f(o)) throw new Error("Expected TableNode.");
            if (!n.getElementByKey(this.tableNodeKey)) throw new Error("Expected to find TableElement in DOM");
            const r = e.x, l = e.y;
            if (this.focusCell = e, null !== this.anchorCell) {
                const e = $4d3af2c0f2f64148$var$Pe(n._window);
                e && e.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
            }
            if (this.isHighlightingCells || this.anchorX === r && this.anchorY === l && !t) {
                if (r === this.focusX && l === this.focusY) return;
            } else this.isHighlightingCells = !0, this.disableHighlightStyle();
            if (this.focusX = r, this.focusY = l, this.isHighlightingCells) {
                const t = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(e.elem);
                if (null != this.tableSelection && null != this.anchorCellNodeKey && $4d3af2c0f2f64148$export$37e4124cf69def13(t) && o.is($4d3af2c0f2f64148$export$d67cd9d452481c4a(t))) {
                    const e = t.getKey();
                    this.tableSelection = this.tableSelection.clone() || $4d3af2c0f2f64148$export$85a297e4ba376eca(), this.focusCellNodeKey = e, this.tableSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(this.tableSelection), n.dispatchCommand((0, $f3de35ce60b0ef48$export$e396fef71d2b56e5), void 0), $4d3af2c0f2f64148$var$Ie(n, this.table, this.tableSelection);
                }
            }
        });
    }
    setAnchorCellForSelection(e) {
        this.isHighlightingCells = !1, this.anchorCell = e, this.anchorX = e.x, this.anchorY = e.y, this.editor.update(()=>{
            const t = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(e.elem);
            if ($4d3af2c0f2f64148$export$37e4124cf69def13(t)) {
                const e = t.getKey();
                this.tableSelection = null != this.tableSelection ? this.tableSelection.clone() : $4d3af2c0f2f64148$export$85a297e4ba376eca(), this.anchorCellNodeKey = e;
            }
        });
    }
    formatCells(e) {
        this.editor.update(()=>{
            const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
            $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) || $4d3af2c0f2f64148$var$re(11);
            const n = (0, $f3de35ce60b0ef48$export$1ccc217b9831b072)(), o = n.anchor, r = n.focus;
            t.getNodes().forEach((t)=>{
                $4d3af2c0f2f64148$export$37e4124cf69def13(t) && 0 !== t.getTextContentSize() && (o.set(t.getKey(), 0, "element"), r.set(t.getKey(), t.getChildrenSize(), "element"), n.formatText(e));
            }), (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(t), this.editor.dispatchCommand((0, $f3de35ce60b0ef48$export$e396fef71d2b56e5), void 0);
        });
    }
    clearText() {
        const e = this.editor;
        e.update(()=>{
            const t = (0, $f3de35ce60b0ef48$export$e725f93d4d48c6d8)(this.tableNodeKey);
            if (!$4d3af2c0f2f64148$export$db59ee06e018b94f(t)) throw new Error("Expected TableNode.");
            const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
            $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(n) || $4d3af2c0f2f64148$var$re(11);
            const o = n.getNodes().filter($4d3af2c0f2f64148$export$37e4124cf69def13);
            if (o.length !== this.table.columns * this.table.rows) o.forEach((e)=>{
                if ((0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e)) {
                    const t = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)(), n = (0, $f3de35ce60b0ef48$export$2785f39dcdec0078)();
                    t.append(n), e.append(t), e.getChildren().forEach((e)=>{
                        e !== t && e.remove();
                    });
                }
            }), $4d3af2c0f2f64148$var$Ie(e, this.table, null), (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(null), e.dispatchCommand((0, $f3de35ce60b0ef48$export$e396fef71d2b56e5), void 0);
            else {
                t.selectPrevious(), t.remove();
                (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().selectStart();
            }
        });
    }
}
const $4d3af2c0f2f64148$var$Ae = "__lexicalTableSelection", $4d3af2c0f2f64148$var$Pe = (e)=>$4d3af2c0f2f64148$var$le ? (e || window).getSelection() : null;
function $4d3af2c0f2f64148$export$bee333d0db884dfe(e, n, o, r) {
    const i = o.getRootElement();
    if (null === i) throw new Error("No root element.");
    const a = new $4d3af2c0f2f64148$export$8b18b72f25fa6ef(o, e.getKey()), d = o._window || window;
    !function(e, t) {
        e[$4d3af2c0f2f64148$var$Ae] = t;
    }(n, a);
    const f = ()=>{
        const e = ()=>{
            a.isSelecting = !1, d.removeEventListener("mouseup", e), d.removeEventListener("mousemove", t);
        }, t = (n)=>{
            setTimeout(()=>{
                if (1 & ~n.buttons && a.isSelecting) return a.isSelecting = !1, d.removeEventListener("mouseup", e), void d.removeEventListener("mousemove", t);
                const o = $4d3af2c0f2f64148$export$1e92feb5449fa455(n.target);
                null === o || a.anchorX === o.x && a.anchorY === o.y || (n.preventDefault(), a.setFocusCellForSelection(o));
            }, 0);
        };
        return {
            onMouseMove: t,
            onMouseUp: e
        };
    };
    n.addEventListener("mousedown", (e)=>{
        setTimeout(()=>{
            if (0 !== e.button) return;
            if (!d) return;
            const t = $4d3af2c0f2f64148$export$1e92feb5449fa455(e.target);
            null !== t && ($4d3af2c0f2f64148$var$Ze(e), a.setAnchorCellForSelection(t));
            const { onMouseUp: n, onMouseMove: o } = f();
            a.isSelecting = !0, d.addEventListener("mouseup", n), d.addEventListener("mousemove", o);
        }, 0);
    });
    const m = (e)=>{
        0 === e.button && o.update(()=>{
            const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)(), n = e.target;
            $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) && t.tableKey === a.tableNodeKey && i.contains(n) && a.clearHighlight();
        });
    };
    d.addEventListener("mousedown", m), a.listenersToRemove.add(()=>d.removeEventListener("mousedown", m)), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$baa60daa2ca402b3), (t)=>$4d3af2c0f2f64148$var$Ve(o, t, "down", e, a), (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$7833c2a33ae81d3d), (t)=>$4d3af2c0f2f64148$var$Ve(o, t, "up", e, a), (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$7525f8f8ab44508), (t)=>$4d3af2c0f2f64148$var$Ve(o, t, "backward", e, a), (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$217ec2281ac1c53b), (t)=>$4d3af2c0f2f64148$var$Ve(o, t, "forward", e, a), (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$53589e422a755d59), (e)=>{
        const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(n)) {
            const o = (0, $70f33588e7e4964f$export$57101724ca611500)(n.focus.getNode(), $4d3af2c0f2f64148$export$37e4124cf69def13);
            if ($4d3af2c0f2f64148$export$37e4124cf69def13(o)) return $4d3af2c0f2f64148$var$Ze(e), o.selectEnd(), !0;
        }
        return !1;
    }, (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9)));
    [
        (0, $f3de35ce60b0ef48$export$8e315b175631384c),
        (0, $f3de35ce60b0ef48$export$d77fad8fb8747fd),
        (0, $f3de35ce60b0ef48$export$35595bf6d7e36fd5)
    ].forEach((n)=>{
        a.listenersToRemove.add(o.registerCommand(n, ((n)=>()=>{
                const o = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
                if (!$4d3af2c0f2f64148$var$Xe(o, e)) return !1;
                if ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(o)) return a.clearText(), !0;
                if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(o)) {
                    const r = (0, $70f33588e7e4964f$export$57101724ca611500)(o.anchor.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e));
                    if (!$4d3af2c0f2f64148$export$37e4124cf69def13(r)) return !1;
                    const l = o.anchor.getNode(), i = o.focus.getNode(), c = e.isParentOf(l), d = e.isParentOf(i);
                    if (c && !d || d && !c) return a.clearText(), !0;
                    const u = (0, $70f33588e7e4964f$export$57101724ca611500)(o.anchor.getNode(), (e)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e)), h = u && (0, $70f33588e7e4964f$export$57101724ca611500)(u, (e)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && $4d3af2c0f2f64148$export$37e4124cf69def13(e.getParent()));
                    if (!(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(h) || !(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(u)) return !1;
                    if (n === (0, $f3de35ce60b0ef48$export$d77fad8fb8747fd) && null === h.getPreviousSibling()) return !0;
                }
                return !1;
            })(n), (0, $f3de35ce60b0ef48$export$6afdf194f304e546)));
    });
    const p = (n)=>{
        const o = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!$4d3af2c0f2f64148$var$Xe(o, e)) {
            const e = o ? o.getNodes() : null;
            if (e) {
                const t = e.find((e)=>$4d3af2c0f2f64148$export$db59ee06e018b94f(e) && e.getKey() === a.tableNodeKey);
                if ($4d3af2c0f2f64148$export$db59ee06e018b94f(t)) {
                    const e = t.getParent();
                    if (!e) return !1;
                    const n = t.getNextSibling() || t.getPreviousSibling();
                    t.remove(), n ? n.selectStart() : e.selectStart();
                }
            }
            return !0;
        }
        if ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(o)) return n.preventDefault(), n.stopPropagation(), a.clearText(), !0;
        if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(o)) {
            const e = (0, $70f33588e7e4964f$export$57101724ca611500)(o.anchor.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e));
            if (!$4d3af2c0f2f64148$export$37e4124cf69def13(e)) return !1;
        }
        return !1;
    };
    function C(t) {
        const n = e.getCordsFromCellNode(t, a.table);
        return e.getDOMCellFromCordsOrThrow(n.x, n.y, a.table);
    }
    return a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$24bbba9bfa830f78), p, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$13a0e72b5c0146bb), p, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$85443a1a9543f043), (n)=>{
        const o = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!$4d3af2c0f2f64148$var$Xe(o, e)) return !1;
        if ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(o)) return a.formatCells(n), !0;
        if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(o)) {
            const e = (0, $70f33588e7e4964f$export$57101724ca611500)(o.anchor.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e));
            if (!$4d3af2c0f2f64148$export$37e4124cf69def13(e)) return !1;
        }
        return !1;
    }, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$d394dc6514823b18), (t)=>{
        const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!$4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(n) || !$4d3af2c0f2f64148$var$Xe(n, e)) return !1;
        const o = n.anchor.getNode(), r = n.focus.getNode();
        if (!$4d3af2c0f2f64148$export$37e4124cf69def13(o) || !$4d3af2c0f2f64148$export$37e4124cf69def13(r)) return !1;
        const [l, i, c] = $4d3af2c0f2f64148$export$1c59f281edec2b86(e, o, r), a = Math.max(i.startRow, c.startRow), d = Math.max(i.startColumn, c.startColumn), u = Math.min(i.startRow, c.startRow), g = Math.min(i.startColumn, c.startColumn);
        for(let e = u; e <= a; e++)for(let n = g; n <= d; n++){
            const o = l[e][n].cell;
            o.setFormat(t);
            const r = o.getChildren();
            for(let e = 0; e < r.length; e++){
                const n = r[e];
                (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(n) && !n.isInline() && n.setFormat(t);
            }
        }
        return !0;
    }, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$6f67c758bb657857), (n)=>{
        const r = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!$4d3af2c0f2f64148$var$Xe(r, e)) return !1;
        if ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(r)) return a.clearHighlight(), !1;
        if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(r)) {
            const l = (0, $70f33588e7e4964f$export$57101724ca611500)(r.anchor.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e));
            if (!$4d3af2c0f2f64148$export$37e4124cf69def13(l)) return !1;
            if ("string" == typeof n) {
                const t = $4d3af2c0f2f64148$var$tt(o, r, e);
                if (t) return $4d3af2c0f2f64148$var$et(t, e, [
                    (0, $f3de35ce60b0ef48$export$2785f39dcdec0078)(n)
                ]), !0;
            }
        }
        return !1;
    }, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), r && a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$b321bdc226ccdcde), (t)=>{
        const n = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(n) || !n.isCollapsed() || !$4d3af2c0f2f64148$var$Xe(n, e)) return !1;
        const o = $4d3af2c0f2f64148$export$c7ed92c9d4f2dd54(n.anchor.getNode());
        if (null === o) return !1;
        $4d3af2c0f2f64148$var$Ze(t);
        const r = e.getCordsFromCellNode(o, a.table);
        return $4d3af2c0f2f64148$var$ze(a, e, r.x, r.y, t.shiftKey ? "backward" : "forward"), !0;
    }, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$cafe35f35e77bf56), (t)=>e.isSelected(), (0, $f3de35ce60b0ef48$export$e8fb7042985cd2e9))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$e47bb493817ec5f6), (e)=>{
        const { nodes: n, selection: o } = e, r = o.getStartEndPoints(), s = $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(o), i = (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(o) && null !== (0, $70f33588e7e4964f$export$57101724ca611500)(o.anchor.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e)) && null !== (0, $70f33588e7e4964f$export$57101724ca611500)(o.focus.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e)) || s;
        if (1 !== n.length || !$4d3af2c0f2f64148$export$db59ee06e018b94f(n[0]) || !i || null === r) return !1;
        const [a] = r, d = n[0], u = d.getChildren(), h = d.getFirstChildOrThrow().getChildrenSize(), f = d.getChildrenSize(), m = (0, $70f33588e7e4964f$export$57101724ca611500)(a.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e)), p = m && (0, $70f33588e7e4964f$export$57101724ca611500)(m, (e)=>$4d3af2c0f2f64148$export$380cf9ddb2e17840(e)), C = p && (0, $70f33588e7e4964f$export$57101724ca611500)(p, (e)=>$4d3af2c0f2f64148$export$db59ee06e018b94f(e));
        if (!$4d3af2c0f2f64148$export$37e4124cf69def13(m) || !$4d3af2c0f2f64148$export$380cf9ddb2e17840(p) || !$4d3af2c0f2f64148$export$db59ee06e018b94f(C)) return !1;
        const _ = p.getIndexWithinParent(), w = Math.min(C.getChildrenSize() - 1, _ + f - 1), b = m.getIndexWithinParent(), y = Math.min(p.getChildrenSize() - 1, b + h - 1), N = Math.min(b, y), T = Math.min(_, w), x = Math.max(b, y), v = Math.max(_, w), E = C.getChildren();
        let O, M, R = 0;
        for(let e = T; e <= v; e++){
            const t = E[e];
            if (!$4d3af2c0f2f64148$export$380cf9ddb2e17840(t)) return !1;
            const n = u[R];
            if (!$4d3af2c0f2f64148$export$380cf9ddb2e17840(n)) return !1;
            const o = t.getChildren(), r = n.getChildren();
            let s = 0;
            for(let t = N; t <= x; t++){
                const n = o[t];
                if (!$4d3af2c0f2f64148$export$37e4124cf69def13(n)) return !1;
                const i = r[s];
                if (!$4d3af2c0f2f64148$export$37e4124cf69def13(i)) return !1;
                e === T && t === N ? O = n.getKey() : e === v && t === x && (M = n.getKey());
                const a = n.getChildren();
                i.getChildren().forEach((e)=>{
                    if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(e)) (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)().append(e), n.append(e);
                    else n.append(e);
                }), a.forEach((e)=>e.remove()), s++;
            }
            R++;
        }
        if (O && M) {
            const e = $4d3af2c0f2f64148$export$85a297e4ba376eca();
            e.set(n[0].getKey(), O, M), (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(e);
        }
        return !0;
    }, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$e396fef71d2b56e5), ()=>{
        const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)(), n = (0, $f3de35ce60b0ef48$export$846e9407a8b5d98c)();
        if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t)) {
            const { anchor: n, focus: r } = t, l = n.getNode(), s = r.getNode(), i = $4d3af2c0f2f64148$export$c7ed92c9d4f2dd54(l), c = $4d3af2c0f2f64148$export$c7ed92c9d4f2dd54(s), u = !(!i || !e.is($4d3af2c0f2f64148$export$d67cd9d452481c4a(i))), h = !(!c || !e.is($4d3af2c0f2f64148$export$d67cd9d452481c4a(c))), g = u !== h, m = u && h, p = t.isBackward();
            if (g) {
                const n = t.clone();
                if (h) {
                    const [t] = $4d3af2c0f2f64148$export$1c59f281edec2b86(e, c, c), o = t[0][0].cell, r = t[t.length - 1].at(-1).cell;
                    n.focus.set(p ? o.getKey() : r.getKey(), p ? o.getChildrenSize() : r.getChildrenSize(), "element");
                } else n.anchor.set(e.getParentOrThrow().getKey(), p ? e.getIndexWithinParent() + 1 : e.getIndexWithinParent(), "element");
                (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(n), $4d3af2c0f2f64148$var$Ue(o, a);
            } else m && (i.is(c) || (a.setAnchorCellForSelection(C(i)), a.setFocusCellForSelection(C(c), !0), a.isSelecting || setTimeout(()=>{
                const { onMouseUp: e, onMouseMove: t } = f();
                a.isSelecting = !0, d.addEventListener("mouseup", e), d.addEventListener("mousemove", t);
            }, 0)));
        } else if (t && $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) && t.is(n) && t.tableKey === e.getKey()) {
            const n = $4d3af2c0f2f64148$var$Pe(o._window);
            if (n && n.anchorNode && n.focusNode) {
                const r = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(n.focusNode), l = r && !e.is($4d3af2c0f2f64148$export$d67cd9d452481c4a(r)), s = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(n.anchorNode), i = s && e.is($4d3af2c0f2f64148$export$d67cd9d452481c4a(s));
                if (l && i && n.rangeCount > 0) {
                    const r = (0, $f3de35ce60b0ef48$export$68ac2b736ac647aa)(n, o);
                    r && (r.anchor.set(e.getKey(), t.isBackward() ? e.getChildrenSize() : 0, "element"), n.removeAllRanges(), (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(r));
                }
            }
        }
        return t && !t.is(n) && ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) || $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(n)) && a.tableSelection && !a.tableSelection.is(n) ? ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) && t.tableKey === a.tableNodeKey ? a.updateTableTableSelection(t) : !$4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(t) && $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(n) && n.tableKey === a.tableNodeKey && a.updateTableTableSelection(null), !1) : (a.hasHijackedSelectionStyles && !e.isSelected() ? function(e, t) {
            t.enableHighlightStyle(), $4d3af2c0f2f64148$var$We(t.table, (t)=>{
                const n = t.elem;
                t.highlighted = !1, $4d3af2c0f2f64148$var$qe(e, t), n.getAttribute("style") || n.removeAttribute("style");
            });
        }(o, a) : !a.hasHijackedSelectionStyles && e.isSelected() && $4d3af2c0f2f64148$var$Ue(o, a), !1);
    }, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a.listenersToRemove.add(o.registerCommand((0, $f3de35ce60b0ef48$export$24f4fea65b096b4), ()=>{
        const t = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        if (!(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(t) || !t.isCollapsed() || !$4d3af2c0f2f64148$var$Xe(t, e)) return !1;
        const n = $4d3af2c0f2f64148$var$tt(o, t, e);
        return !!n && ($4d3af2c0f2f64148$var$et(n, e), !0);
    }, (0, $f3de35ce60b0ef48$export$6afdf194f304e546))), a;
}
function $4d3af2c0f2f64148$export$44afec1ea4a7d093(e) {
    return e[$4d3af2c0f2f64148$var$Ae];
}
function $4d3af2c0f2f64148$export$1e92feb5449fa455(e) {
    let t = e;
    for(; null != t;){
        const e = t.nodeName;
        if ("TD" === e || "TH" === e) {
            const e = t._cell;
            return void 0 === e ? null : e;
        }
        t = t.parentNode;
    }
    return null;
}
function $4d3af2c0f2f64148$var$Le(e) {
    const t = [], n = {
        columns: 0,
        domRows: t,
        rows: 0
    };
    let o = e.firstChild, r = 0, l = 0;
    for(t.length = 0; null != o;){
        const e = o.nodeName;
        if ("TD" === e || "TH" === e) {
            const e = {
                elem: o,
                hasBackgroundColor: "" !== o.style.backgroundColor,
                highlighted: !1,
                x: r,
                y: l
            };
            o._cell = e;
            let n = t[l];
            void 0 === n && (n = t[l] = []), n[r] = e;
        } else {
            const e = o.firstChild;
            if (null != e) {
                o = e;
                continue;
            }
        }
        const n = o.nextSibling;
        if (null != n) {
            r++, o = n;
            continue;
        }
        const s = o.parentNode;
        if (null != s) {
            const e = s.nextSibling;
            if (null == e) break;
            l++, r = 0, o = e;
        }
    }
    return n.columns = r + 1, n.rows = l + 1, n;
}
function $4d3af2c0f2f64148$var$Ie(e, t, n) {
    const o = new Set(n ? n.getNodes() : []);
    $4d3af2c0f2f64148$var$We(t, (t, n)=>{
        const r = t.elem;
        o.has(n) ? (t.highlighted = !0, $4d3af2c0f2f64148$var$je(e, t)) : (t.highlighted = !1, $4d3af2c0f2f64148$var$qe(e, t), r.getAttribute("style") || r.removeAttribute("style"));
    });
}
function $4d3af2c0f2f64148$var$We(e, t) {
    const { domRows: n } = e;
    for(let e = 0; e < n.length; e++){
        const o = n[e];
        if (o) for(let n = 0; n < o.length; n++){
            const r = o[n];
            if (!r) continue;
            const l = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(r.elem);
            null !== l && t(r, l, {
                x: n,
                y: e
            });
        }
    }
}
function $4d3af2c0f2f64148$var$Ue(e, t) {
    t.disableHighlightStyle(), $4d3af2c0f2f64148$var$We(t.table, (t)=>{
        t.highlighted = !0, $4d3af2c0f2f64148$var$je(e, t);
    });
}
const $4d3af2c0f2f64148$var$ze = (e, t, n, o, r)=>{
    const l = "forward" === r;
    switch(r){
        case "backward":
        case "forward":
            return n !== (l ? e.table.columns - 1 : 0) ? $4d3af2c0f2f64148$var$Je(t.getCellNodeFromCordsOrThrow(n + (l ? 1 : -1), o, e.table), l) : o !== (l ? e.table.rows - 1 : 0) ? $4d3af2c0f2f64148$var$Je(t.getCellNodeFromCordsOrThrow(l ? 0 : e.table.columns - 1, o + (l ? 1 : -1), e.table), l) : l ? t.selectNext() : t.selectPrevious(), !0;
        case "up":
            return 0 !== o ? $4d3af2c0f2f64148$var$Je(t.getCellNodeFromCordsOrThrow(n, o - 1, e.table), !1) : t.selectPrevious(), !0;
        case "down":
            return o !== e.table.rows - 1 ? $4d3af2c0f2f64148$var$Je(t.getCellNodeFromCordsOrThrow(n, o + 1, e.table), !0) : t.selectNext(), !0;
        default:
            return !1;
    }
}, $4d3af2c0f2f64148$var$Ye = (e, t, n, o, r)=>{
    const l = "forward" === r;
    switch(r){
        case "backward":
        case "forward":
            return n !== (l ? e.table.columns - 1 : 0) && e.setFocusCellForSelection(t.getDOMCellFromCordsOrThrow(n + (l ? 1 : -1), o, e.table)), !0;
        case "up":
            return 0 !== o && (e.setFocusCellForSelection(t.getDOMCellFromCordsOrThrow(n, o - 1, e.table)), !0);
        case "down":
            return o !== e.table.rows - 1 && (e.setFocusCellForSelection(t.getDOMCellFromCordsOrThrow(n, o + 1, e.table)), !0);
        default:
            return !1;
    }
};
function $4d3af2c0f2f64148$var$Xe(e, t) {
    if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) || $4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(e)) {
        const n = t.isParentOf(e.anchor.getNode()), o = t.isParentOf(e.focus.getNode());
        return n && o;
    }
    return !1;
}
function $4d3af2c0f2f64148$var$Je(e, t) {
    t ? e.selectStart() : e.selectEnd();
}
const $4d3af2c0f2f64148$var$$e = "172,206,247";
function $4d3af2c0f2f64148$var$je(e, t) {
    const n = t.elem, o = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(n);
    $4d3af2c0f2f64148$export$37e4124cf69def13(o) || $4d3af2c0f2f64148$var$re(131);
    null === o.getBackgroundColor() ? n.style.setProperty("background-color", `rgb(${$4d3af2c0f2f64148$var$$e})`) : n.style.setProperty("background-image", `linear-gradient(to right, rgba(${$4d3af2c0f2f64148$var$$e},0.85), rgba(${$4d3af2c0f2f64148$var$$e},0.85))`), n.style.setProperty("caret-color", "transparent");
}
function $4d3af2c0f2f64148$var$qe(e, t) {
    const n = t.elem, o = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(n);
    $4d3af2c0f2f64148$export$37e4124cf69def13(o) || $4d3af2c0f2f64148$var$re(131);
    null === o.getBackgroundColor() && n.style.removeProperty("background-color"), n.style.removeProperty("background-image"), n.style.removeProperty("caret-color");
}
function $4d3af2c0f2f64148$export$c7ed92c9d4f2dd54(e) {
    const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, $4d3af2c0f2f64148$export$37e4124cf69def13);
    return $4d3af2c0f2f64148$export$37e4124cf69def13(n) ? n : null;
}
function $4d3af2c0f2f64148$export$d67cd9d452481c4a(e) {
    const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, $4d3af2c0f2f64148$export$db59ee06e018b94f);
    return $4d3af2c0f2f64148$export$db59ee06e018b94f(n) ? n : null;
}
function $4d3af2c0f2f64148$var$Ve(e, n, o, r, l) {
    if (("up" === o || "down" === o) && function(e) {
        const t = e.getRootElement();
        if (!t) return !1;
        return t.hasAttribute("aria-controls") && "typeahead-menu" === t.getAttribute("aria-controls");
    }(e)) return !1;
    const i = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
    if (!$4d3af2c0f2f64148$var$Xe(i, r)) {
        if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(i)) {
            if (i.isCollapsed() && "backward" === o) {
                const e = i.anchor.type, o = i.anchor.offset;
                if ("element" !== e && ("text" !== e || 0 !== o)) return !1;
                const r = i.anchor.getNode();
                if (!r) return !1;
                const l = (0, $70f33588e7e4964f$export$57101724ca611500)(r, (e)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && !e.isInline());
                if (!l) return !1;
                const c = l.getPreviousSibling();
                return !(!c || !$4d3af2c0f2f64148$export$db59ee06e018b94f(c)) && ($4d3af2c0f2f64148$var$Ze(n), c.selectEnd(), !0);
            }
            if (n.shiftKey && ("up" === o || "down" === o)) {
                const e = i.anchor.getNode();
                if ((0, $f3de35ce60b0ef48$export$6f851a24c61146af)(e)) {
                    const e = i.getNodes()[0];
                    if (e) {
                        const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, $4d3af2c0f2f64148$export$37e4124cf69def13);
                        if (n && r.isParentOf(n)) {
                            const e = r.getFirstDescendant(), t = r.getLastDescendant();
                            if (!e || !t) return !1;
                            const [n] = $4d3af2c0f2f64148$export$9431145ef3ef4099(e), [o] = $4d3af2c0f2f64148$export$9431145ef3ef4099(t), s = r.getCordsFromCellNode(n, l.table), i = r.getCordsFromCellNode(o, l.table), c = r.getDOMCellFromCordsOrThrow(s.x, s.y, l.table), a = r.getDOMCellFromCordsOrThrow(i.x, i.y, l.table);
                            return l.setAnchorCellForSelection(c), l.setFocusCellForSelection(a, !0), !0;
                        }
                    }
                    return !1;
                }
                {
                    const n = (0, $70f33588e7e4964f$export$57101724ca611500)(e, (e)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && !e.isInline());
                    if (!n) return !1;
                    const r = "down" === o ? n.getNextSibling() : n.getPreviousSibling();
                    if ($4d3af2c0f2f64148$export$db59ee06e018b94f(r) && l.tableNodeKey === r.getKey()) {
                        const e = r.getFirstDescendant(), t = r.getLastDescendant();
                        if (!e || !t) return !1;
                        const [n] = $4d3af2c0f2f64148$export$9431145ef3ef4099(e), [l] = $4d3af2c0f2f64148$export$9431145ef3ef4099(t), s = i.clone();
                        return s.focus.set(("up" === o ? n : l).getKey(), "up" === o ? 0 : l.getChildrenSize(), "element"), (0, $f3de35ce60b0ef48$export$2aad78c37810bca9)(s), !0;
                    }
                }
            }
        }
        return !1;
    }
    if ((0, $f3de35ce60b0ef48$export$181b63acea8a0224)(i) && i.isCollapsed()) {
        const { anchor: c, focus: a } = i, d = (0, $70f33588e7e4964f$export$57101724ca611500)(c.getNode(), $4d3af2c0f2f64148$export$37e4124cf69def13), u = (0, $70f33588e7e4964f$export$57101724ca611500)(a.getNode(), $4d3af2c0f2f64148$export$37e4124cf69def13);
        if (!$4d3af2c0f2f64148$export$37e4124cf69def13(d) || !d.is(u)) return !1;
        const h = $4d3af2c0f2f64148$export$d67cd9d452481c4a(d);
        if (h !== r && null != h) {
            const t = e.getElementByKey(h.getKey());
            if (null != t) return l.table = $4d3af2c0f2f64148$var$Le(t), $4d3af2c0f2f64148$var$Ve(e, n, o, h, l);
        }
        if ("backward" === o || "forward" === o) {
            const e = c.type, l = c.offset, a = c.getNode();
            if (!a) return !1;
            const d = i.getNodes();
            return (1 !== d.length || !(0, $f3de35ce60b0ef48$export$60aa03725ce41b1c)(d[0])) && !!function(e, n, o, r) {
                return function(e, t, n) {
                    return "element" === e && ("backward" === n ? null === t.getPreviousSibling() : null === t.getNextSibling());
                }(e, o, r) || function(e, n, o, r) {
                    const l = (0, $70f33588e7e4964f$export$57101724ca611500)(o, (e)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && !e.isInline());
                    if (!l) return !1;
                    const i = "backward" === r ? 0 === n : n === o.getTextContentSize();
                    return "text" === e && i && ("backward" === r ? null === l.getPreviousSibling() : null === l.getNextSibling());
                }(e, n, o, r);
            }(e, l, a, o) && function(e, n, o, r) {
                const l = (0, $70f33588e7e4964f$export$57101724ca611500)(n, $4d3af2c0f2f64148$export$37e4124cf69def13);
                if (!$4d3af2c0f2f64148$export$37e4124cf69def13(l)) return !1;
                const [i, c] = $4d3af2c0f2f64148$export$1c59f281edec2b86(o, l, l);
                if (!function(e, t, n) {
                    const o = e[0][0], r = e[e.length - 1][e[0].length - 1], { startColumn: l, startRow: s } = t;
                    return "backward" === n ? l === o.startColumn && s === o.startRow : l === r.startColumn && s === r.startRow;
                }(i, c, r)) return !1;
                const a = function(e, n, o) {
                    const r = (0, $70f33588e7e4964f$export$57101724ca611500)(e, (e)=>(0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && !e.isInline());
                    if (!r) return;
                    const l = "backward" === n ? r.getPreviousSibling() : r.getNextSibling();
                    return l && $4d3af2c0f2f64148$export$db59ee06e018b94f(l) ? l : "backward" === n ? o.getPreviousSibling() : o.getNextSibling();
                }(n, r, o);
                if (!a || $4d3af2c0f2f64148$export$db59ee06e018b94f(a)) return !1;
                $4d3af2c0f2f64148$var$Ze(e), "backward" === r ? a.selectEnd() : a.selectStart();
                return !0;
            }(n, a, r, o);
        }
        const g = e.getElementByKey(d.__key), f = e.getElementByKey(c.key);
        if (null == f || null == g) return !1;
        let m;
        if ("element" === c.type) m = f.getBoundingClientRect();
        else {
            const e = window.getSelection();
            if (null === e || 0 === e.rangeCount) return !1;
            m = e.getRangeAt(0).getBoundingClientRect();
        }
        const p = "up" === o ? d.getFirstChild() : d.getLastChild();
        if (null == p) return !1;
        const C = e.getElementByKey(p.__key);
        if (null == C) return !1;
        const S = C.getBoundingClientRect();
        if ("up" === o ? S.top > m.top - m.height : m.bottom + m.height > S.bottom) {
            $4d3af2c0f2f64148$var$Ze(n);
            const e = r.getCordsFromCellNode(d, l.table);
            if (!n.shiftKey) return $4d3af2c0f2f64148$var$ze(l, r, e.x, e.y, o);
            {
                const t = r.getDOMCellFromCordsOrThrow(e.x, e.y, l.table);
                l.setAnchorCellForSelection(t), l.setFocusCellForSelection(t, !0);
            }
            return !0;
        }
    } else if ($4d3af2c0f2f64148$export$a02ea9cdbbaf2e8c(i)) {
        const { anchor: s, focus: c } = i, a = (0, $70f33588e7e4964f$export$57101724ca611500)(s.getNode(), $4d3af2c0f2f64148$export$37e4124cf69def13), d = (0, $70f33588e7e4964f$export$57101724ca611500)(c.getNode(), $4d3af2c0f2f64148$export$37e4124cf69def13), [u] = i.getNodes(), h = e.getElementByKey(u.getKey());
        if (!$4d3af2c0f2f64148$export$37e4124cf69def13(a) || !$4d3af2c0f2f64148$export$37e4124cf69def13(d) || !$4d3af2c0f2f64148$export$db59ee06e018b94f(u) || null == h) return !1;
        l.updateTableTableSelection(i);
        const g = $4d3af2c0f2f64148$var$Le(h), f = r.getCordsFromCellNode(a, g), m = r.getDOMCellFromCordsOrThrow(f.x, f.y, g);
        if (l.setAnchorCellForSelection(m), $4d3af2c0f2f64148$var$Ze(n), n.shiftKey) {
            const e = r.getCordsFromCellNode(d, g);
            return $4d3af2c0f2f64148$var$Ye(l, u, e.x, e.y, o);
        }
        return d.selectEnd(), !0;
    }
    return !1;
}
function $4d3af2c0f2f64148$var$Ze(e) {
    e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
}
function $4d3af2c0f2f64148$var$et(e, t, n) {
    const o = (0, $f3de35ce60b0ef48$export$7f0c05ffb7ced90d)();
    "first" === e ? t.insertBefore(o) : t.insertAfter(o), o.append(...n || []), o.selectEnd();
}
function $4d3af2c0f2f64148$var$tt(e, n, o) {
    const r = o.getParent();
    if (!r) return;
    const l = e.getElementByKey(r.getKey());
    if (!l) return;
    const s = window.getSelection();
    if (!s || s.anchorNode !== l) return;
    const i = (0, $70f33588e7e4964f$export$57101724ca611500)(n.anchor.getNode(), (e)=>$4d3af2c0f2f64148$export$37e4124cf69def13(e));
    if (!i) return;
    const c = (0, $70f33588e7e4964f$export$57101724ca611500)(i, (e)=>$4d3af2c0f2f64148$export$db59ee06e018b94f(e));
    if (!$4d3af2c0f2f64148$export$db59ee06e018b94f(c) || !c.is(o)) return;
    const [a, d] = $4d3af2c0f2f64148$export$1c59f281edec2b86(o, i, i), u = a[0][0], h = a[a.length - 1][a[0].length - 1], { startRow: g, startColumn: f } = d, m = g === u.startRow && f === u.startColumn, p = g === h.startRow && f === h.startColumn;
    return m ? "first" : p ? "last" : void 0;
}
class $4d3af2c0f2f64148$export$8afae231582c1ea2 extends (0, $f3de35ce60b0ef48$export$dc064fe9e59310fd) {
    static getType() {
        return "table";
    }
    static clone(e) {
        return new $4d3af2c0f2f64148$export$8afae231582c1ea2(e.__key);
    }
    static importDOM() {
        return {
            table: (e)=>({
                    conversion: $4d3af2c0f2f64148$var$rt,
                    priority: 1
                })
        };
    }
    static importJSON(e) {
        return $4d3af2c0f2f64148$export$16c8dff111f0446c();
    }
    constructor(e){
        super(e);
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "table",
            version: 1
        };
    }
    createDOM(t, n) {
        const o = document.createElement("table");
        return (0, $70f33588e7e4964f$export$71781797876b07d6)(o, t.theme.table), o;
    }
    updateDOM() {
        return !1;
    }
    exportDOM(e) {
        return {
            ...super.exportDOM(e),
            after: (e)=>{
                if (e) {
                    const t = e.cloneNode(), n = document.createElement("colgroup"), r = document.createElement("tbody");
                    (0, $70f33588e7e4964f$export$1b3bfaa9684536aa)(e) && r.append(...e.children);
                    const l = this.getFirstChildOrThrow();
                    if (!$4d3af2c0f2f64148$export$380cf9ddb2e17840(l)) throw new Error("Expected to find row node.");
                    const s = l.getChildrenSize();
                    for(let e = 0; e < s; e++){
                        const e = document.createElement("col");
                        n.append(e);
                    }
                    return t.replaceChildren(n, r), t;
                }
            }
        };
    }
    canBeEmpty() {
        return !1;
    }
    isShadowRoot() {
        return !0;
    }
    getCordsFromCellNode(e, t) {
        const { rows: n, domRows: o } = t;
        for(let t = 0; t < n; t++){
            const n = o[t];
            if (null == n) continue;
            const r = n.findIndex((t)=>{
                if (!t) return;
                const { elem: n } = t;
                return (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(n) === e;
            });
            if (-1 !== r) return {
                x: r,
                y: t
            };
        }
        throw new Error("Cell not found in table.");
    }
    getDOMCellFromCords(e, t, n) {
        const { domRows: o } = n, r = o[t];
        if (null == r) return null;
        const l = r[e];
        return null == l ? null : l;
    }
    getDOMCellFromCordsOrThrow(e, t, n) {
        const o = this.getDOMCellFromCords(e, t, n);
        if (!o) throw new Error("Cell not found at cords.");
        return o;
    }
    getCellNodeFromCords(e, t, n) {
        const o = this.getDOMCellFromCords(e, t, n);
        if (null == o) return null;
        const r = (0, $f3de35ce60b0ef48$export$fef265f0d2fcffdd)(o.elem);
        return $4d3af2c0f2f64148$export$37e4124cf69def13(r) ? r : null;
    }
    getCellNodeFromCordsOrThrow(e, t, n) {
        const o = this.getCellNodeFromCords(e, t, n);
        if (!o) throw new Error("Node at cords not TableCellNode.");
        return o;
    }
    canSelectBefore() {
        return !0;
    }
    canIndent() {
        return !1;
    }
}
function $4d3af2c0f2f64148$export$238642e231418640(e, t) {
    const n = e.getElementByKey(t.getKey());
    if (null == n) throw new Error("Table Element Not Found");
    return $4d3af2c0f2f64148$var$Le(n);
}
function $4d3af2c0f2f64148$var$rt(e) {
    return {
        node: $4d3af2c0f2f64148$export$16c8dff111f0446c()
    };
}
function $4d3af2c0f2f64148$export$16c8dff111f0446c() {
    return (0, $f3de35ce60b0ef48$export$2f5beb31df92ea57)(new $4d3af2c0f2f64148$export$8afae231582c1ea2);
}
function $4d3af2c0f2f64148$export$db59ee06e018b94f(e) {
    return e instanceof $4d3af2c0f2f64148$export$8afae231582c1ea2;
}


const $016146dbb619d259$var$mod = $4d3af2c0f2f64148$exports;
const $016146dbb619d259$export$1c59f281edec2b86 = $016146dbb619d259$var$mod.$computeTableMap;
const $016146dbb619d259$export$abbd98cd5b856945 = $016146dbb619d259$var$mod.$computeTableMapSkipCellCheck;
const $016146dbb619d259$export$aa78f26693049118 = $016146dbb619d259$var$mod.$createTableCellNode;
const $016146dbb619d259$export$16c8dff111f0446c = $016146dbb619d259$var$mod.$createTableNode;
const $016146dbb619d259$export$779ee990f9261336 = $016146dbb619d259$var$mod.$createTableNodeWithDimensions;
const $016146dbb619d259$export$fe64b1c5681c66b9 = $016146dbb619d259$var$mod.$createTableRowNode;
const $016146dbb619d259$export$85a297e4ba376eca = $016146dbb619d259$var$mod.$createTableSelection;
const $016146dbb619d259$export$af544ccf4e522e05 = $016146dbb619d259$var$mod.$deleteTableColumn;
const $016146dbb619d259$export$3bb7b62f9f7d4bf2 = $016146dbb619d259$var$mod.$deleteTableColumn__EXPERIMENTAL;
const $016146dbb619d259$export$82817182bd48bf97 = $016146dbb619d259$var$mod.$deleteTableRow__EXPERIMENTAL;
const $016146dbb619d259$export$c7ed92c9d4f2dd54 = $016146dbb619d259$var$mod.$findCellNode;
const $016146dbb619d259$export$d67cd9d452481c4a = $016146dbb619d259$var$mod.$findTableNode;
const $016146dbb619d259$export$238642e231418640 = $016146dbb619d259$var$mod.$getElementForTableNode;
const $016146dbb619d259$export$9431145ef3ef4099 = $016146dbb619d259$var$mod.$getNodeTriplet;
const $016146dbb619d259$export$c85815233d82a9bb = $016146dbb619d259$var$mod.$getTableCellNodeFromLexicalNode;
const $016146dbb619d259$export$6b3a2ccf13eac62 = $016146dbb619d259$var$mod.$getTableCellNodeRect;
const $016146dbb619d259$export$8131c19b47539bba = $016146dbb619d259$var$mod.$getTableColumnIndexFromTableCellNode;
const $016146dbb619d259$export$3fa7da0bc1772966 = $016146dbb619d259$var$mod.$getTableNodeFromLexicalNodeOrThrow;
const $016146dbb619d259$export$a25ca9146a0e3cac = $016146dbb619d259$var$mod.$getTableRowIndexFromTableCellNode;
const $016146dbb619d259$export$59f9cec5d26569f1 = $016146dbb619d259$var$mod.$getTableRowNodeFromTableCellNodeOrThrow;
const $016146dbb619d259$export$78950918166cf524 = $016146dbb619d259$var$mod.$insertTableColumn;
const $016146dbb619d259$export$2f7773fc13b040e7 = $016146dbb619d259$var$mod.$insertTableColumn__EXPERIMENTAL;
const $016146dbb619d259$export$f470fe73ec207356 = $016146dbb619d259$var$mod.$insertTableRow;
const $016146dbb619d259$export$7dd0aeb62c44d08 = $016146dbb619d259$var$mod.$insertTableRow__EXPERIMENTAL;
const $016146dbb619d259$export$37e4124cf69def13 = $016146dbb619d259$var$mod.$isTableCellNode;
const $016146dbb619d259$export$db59ee06e018b94f = $016146dbb619d259$var$mod.$isTableNode;
const $016146dbb619d259$export$380cf9ddb2e17840 = $016146dbb619d259$var$mod.$isTableRowNode;
const $016146dbb619d259$export$a02ea9cdbbaf2e8c = $016146dbb619d259$var$mod.$isTableSelection;
const $016146dbb619d259$export$f6fbda822bda5eb7 = $016146dbb619d259$var$mod.$removeTableRowAtIndex;
const $016146dbb619d259$export$b25beed809ac054 = $016146dbb619d259$var$mod.$unmergeCell;
const $016146dbb619d259$export$a8654016fb30b2db = $016146dbb619d259$var$mod.INSERT_TABLE_COMMAND;
const $016146dbb619d259$export$142ccb127d8767e2 = $016146dbb619d259$var$mod.TableCellHeaderStates;
const $016146dbb619d259$export$cff559758223b315 = $016146dbb619d259$var$mod.TableCellNode;
const $016146dbb619d259$export$8afae231582c1ea2 = $016146dbb619d259$var$mod.TableNode;
const $016146dbb619d259$export$8b18b72f25fa6ef = $016146dbb619d259$var$mod.TableObserver;
const $016146dbb619d259$export$ab6aefe5807855df = $016146dbb619d259$var$mod.TableRowNode;
const $016146dbb619d259$export$bee333d0db884dfe = $016146dbb619d259$var$mod.applyTableHandlers;
const $016146dbb619d259$export$1e92feb5449fa455 = $016146dbb619d259$var$mod.getDOMCellFromTarget;
const $016146dbb619d259$export$44afec1ea4a7d093 = $016146dbb619d259$var$mod.getTableObserverFromTableElement;




var $lldlC = parcelRequire("lldlC");

const $d3ed32e1e38e75bc$var$C = Object.freeze({
    "\t": "\\t",
    "\n": "\\n"
}), $d3ed32e1e38e75bc$var$$ = new RegExp(Object.keys($d3ed32e1e38e75bc$var$C).join("|"), "g"), $d3ed32e1e38e75bc$var$N = Object.freeze({
    ancestorHasNextSibling: "|",
    ancestorIsLastChild: " ",
    hasNextSibling: "\u251C",
    isLastChild: "\u2514",
    selectedChar: "^",
    selectedLine: ">"
}), $d3ed32e1e38e75bc$var$S = [
    (e)=>e.hasFormat("bold") && "Bold",
    (e)=>e.hasFormat("code") && "Code",
    (e)=>e.hasFormat("italic") && "Italic",
    (e)=>e.hasFormat("strikethrough") && "Strikethrough",
    (e)=>e.hasFormat("subscript") && "Subscript",
    (e)=>e.hasFormat("superscript") && "Superscript",
    (e)=>e.hasFormat("underline") && "Underline"
], $d3ed32e1e38e75bc$var$T = [
    (e)=>e.hasTextFormat("bold") && "Bold",
    (e)=>e.hasTextFormat("code") && "Code",
    (e)=>e.hasTextFormat("italic") && "Italic",
    (e)=>e.hasTextFormat("strikethrough") && "Strikethrough",
    (e)=>e.hasTextFormat("subscript") && "Subscript",
    (e)=>e.hasTextFormat("superscript") && "Superscript",
    (e)=>e.hasTextFormat("underline") && "Underline"
], $d3ed32e1e38e75bc$var$k = [
    (e)=>e.isDirectionless() && "Directionless",
    (e)=>e.isUnmergeable() && "Unmergeable"
], $d3ed32e1e38e75bc$var$j = [
    (e)=>e.isToken() && "Token",
    (e)=>e.isSegmented() && "Segmented"
];
function $d3ed32e1e38e75bc$export$4edbeb3aa79c6b8a(f, d, m, h, g = !1) {
    const p = f.getEditorState(), y = f._config, b = f._compositionKey, x = f._editable;
    if (m) {
        let t = "";
        return p.read(()=>{
            t = function(e) {
                const t = document.createElement("div");
                return t.innerHTML = e.trim(), $d3ed32e1e38e75bc$var$A(t, 0).innerHTML;
            }((0, $cbd277723cf81bcc$export$a1c399724d359ef8)(f));
        }), t;
    }
    let C = " root\n";
    const S = p.read(()=>{
        const e = (0, $f3de35ce60b0ef48$export$63a3201b3a5c7d90)();
        return $d3ed32e1e38e75bc$var$v((0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)(), (r, o)=>{
            const i = `(${r.getKey()})`, f = r.getType() || "", d = r.isSelected();
            C += `${d ? $d3ed32e1e38e75bc$var$N.selectedLine : " "} ${o.join(" ")} ${i} ${f} ${function(e, r, o = !1) {
                const i = r ? r(e, o) : void 0;
                if (void 0 !== i && i.length > 0) return i;
                if ((0, $f3de35ce60b0ef48$export$471953706258be2b)(e)) {
                    const t = e.getTextContent(), n = 0 === t.length ? "(empty)" : `"${$d3ed32e1e38e75bc$var$B(t, o)}"`, r = function(e) {
                        return [
                            $d3ed32e1e38e75bc$var$F(e),
                            $d3ed32e1e38e75bc$var$E(e),
                            $d3ed32e1e38e75bc$var$w(e)
                        ].filter(Boolean).join(", ");
                    }(e);
                    return [
                        n,
                        0 !== r.length ? `{ ${r} }` : null
                    ].filter(Boolean).join(" ").trim();
                }
                if ((0, $82257c13095f7911$export$b46127abfd772033)(e)) {
                    const t = e.getURL(), n = 0 === t.length ? "(empty)" : `"${$d3ed32e1e38e75bc$var$B(t, o)}"`, r = function(e) {
                        return [
                            $d3ed32e1e38e75bc$var$D(e),
                            $d3ed32e1e38e75bc$var$K(e),
                            $d3ed32e1e38e75bc$var$O(e)
                        ].filter(Boolean).join(", ");
                    }(e);
                    return [
                        n,
                        0 !== r.length ? `{ ${r} }` : null
                    ].filter(Boolean).join(" ").trim();
                }
                if ((0, $f800c74e328f5b36$export$b2b0559c9882d5d5)(e)) return `ids: [ ${e.getIDs().join(", ")} ]`;
                if ((0, $f3de35ce60b0ef48$export$1fdda795300c79c6)(e)) {
                    const t = function(e) {
                        let t = $d3ed32e1e38e75bc$var$T.map((t)=>t(e)).filter(Boolean).join(", ").toLocaleLowerCase();
                        "" !== t && (t = "format: " + t);
                        return t;
                    }(e);
                    return "" !== t ? `{ ${t} }` : "";
                }
                return "";
            }(r, h, g)}\n`, C += function({ indent: e, isSelected: t, node: n, nodeKeyDisplay: r, selection: o, typeDisplay: i }) {
                if (!(0, $f3de35ce60b0ef48$export$471953706258be2b)(n) || !(0, $f3de35ce60b0ef48$export$181b63acea8a0224)(o) || !t || (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(n)) return "";
                const u = o.anchor, f = o.focus;
                if ("" === n.getTextContent() || u.getNode() === o.focus.getNode() && u.offset === f.offset) return "";
                const [d, m] = function(e, t) {
                    const n = t.getStartEndPoints();
                    if ((0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(t) || null === n) return [
                        -1,
                        -1
                    ];
                    const [r, o] = n, i = e.getTextContent(), l = i.length;
                    let a = -1, c = -1;
                    if ("text" === r.type && "text" === o.type) {
                        const t = r.getNode(), n = o.getNode();
                        t === n && e === t && r.offset !== o.offset ? [a, c] = r.offset < o.offset ? [
                            r.offset,
                            o.offset
                        ] : [
                            o.offset,
                            r.offset
                        ] : [a, c] = e === t ? t.isBefore(n) ? [
                            r.offset,
                            l
                        ] : [
                            0,
                            r.offset
                        ] : e === n ? n.isBefore(t) ? [
                            o.offset,
                            l
                        ] : [
                            0,
                            o.offset
                        ] : [
                            0,
                            l
                        ];
                    }
                    const u = (i.slice(0, a).match($d3ed32e1e38e75bc$var$$) || []).length, f = (i.slice(a, c).match($d3ed32e1e38e75bc$var$$) || []).length;
                    return [
                        a + u,
                        c + u + f
                    ];
                }(n, o);
                if (d === m) return "";
                const h = e[e.length - 1] === $d3ed32e1e38e75bc$var$N.hasNextSibling ? $d3ed32e1e38e75bc$var$N.ancestorHasNextSibling : $d3ed32e1e38e75bc$var$N.ancestorIsLastChild, g = [
                    ...e.slice(0, e.length - 1),
                    h
                ], p = Array(d + 1).fill(" "), y = Array(m - d).fill($d3ed32e1e38e75bc$var$N.selectedChar), b = i.length + 2, x = Array(r.length + b).fill(" ");
                return [
                    $d3ed32e1e38e75bc$var$N.selectedLine,
                    g.join(" "),
                    [
                        ...x,
                        ...p,
                        ...y
                    ].join("")
                ].join(" ") + "\n";
            }({
                indent: o,
                isSelected: d,
                node: r,
                nodeKeyDisplay: i,
                selection: e,
                typeDisplay: f
            });
        }), null === e ? ": null" : (0, $f3de35ce60b0ef48$export$181b63acea8a0224)(e) ? function(e) {
            let t = "";
            const n = $d3ed32e1e38e75bc$var$F(e);
            t += `: range ${"" !== n ? `{ ${n} }` : ""} ${"" !== e.style ? `{ style: ${e.style} } ` : ""}`;
            const r = e.anchor, o = e.focus, i = r.offset, l = o.offset;
            return t += `
  \u{251C} anchor { key: ${r.key}, offset: ${null === i ? "null" : i}, type: ${r.type} }`, t += `
  \u{2514} focus { key: ${o.key}, offset: ${null === l ? "null" : l}, type: ${o.type} }`, t;
        }(e) : (0, $016146dbb619d259$export$a02ea9cdbbaf2e8c)(e) ? function(e) {
            return `: table
  \u{2514} { table: ${e.tableKey}, anchorCell: ${e.anchor.key}, focusCell: ${e.focus.key} }`;
        }(e) : function(e) {
            if (!(0, $f3de35ce60b0ef48$export$7257e4181651a7c3)(e)) return "";
            return `: node
  \u{2514} [${Array.from(e._nodes).join(", ")}]`;
        }(e);
    });
    if (C += "\n selection" + S, C += "\n\n commands:", d.length) for (const { index: e, type: t, payload: n } of d)C += `
  \u{2514} ${e}. { type: ${t}, payload: ${n instanceof Event ? n.constructor.name : n} }`;
    else C += "\n  \u2514 None dispatched.";
    return C += "\n\n editor:", C += `
  \u{2514} namespace ${y.namespace}`, null !== b && (C += `
  \u{2514} compositionKey ${b}`), C += `
  \u{2514} editable ${String(x)}`, C;
}
function $d3ed32e1e38e75bc$var$v(e, t, n = []) {
    const r = e.getChildren(), o = r.length;
    r.forEach((e, r)=>{
        t(e, n.concat(r === o - 1 ? $d3ed32e1e38e75bc$var$N.isLastChild : $d3ed32e1e38e75bc$var$N.hasNextSibling)), (0, $f3de35ce60b0ef48$export$923a058ef54437a4)(e) && $d3ed32e1e38e75bc$var$v(e, t, n.concat(r === o - 1 ? $d3ed32e1e38e75bc$var$N.ancestorIsLastChild : $d3ed32e1e38e75bc$var$N.ancestorHasNextSibling));
    });
}
function $d3ed32e1e38e75bc$var$B(e, t = !1) {
    const n = Object.entries($d3ed32e1e38e75bc$var$C).reduce((e, [t, n])=>e.replace(new RegExp(t, "g"), String(n)), e);
    return t ? n.replace(/[^\s]/g, "*") : n;
}
function $d3ed32e1e38e75bc$var$E(e) {
    let t = $d3ed32e1e38e75bc$var$k.map((t)=>t(e)).filter(Boolean).join(", ").toLocaleLowerCase();
    return "" !== t && (t = "detail: " + t), t;
}
function $d3ed32e1e38e75bc$var$w(e) {
    let t = $d3ed32e1e38e75bc$var$j.map((t)=>t(e)).filter(Boolean).join(", ").toLocaleLowerCase();
    return "" !== t && (t = "mode: " + t), t;
}
function $d3ed32e1e38e75bc$var$F(e) {
    let t = $d3ed32e1e38e75bc$var$S.map((t)=>t(e)).filter(Boolean).join(", ").toLocaleLowerCase();
    return "" !== t && (t = "format: " + t), t;
}
function $d3ed32e1e38e75bc$var$D(e) {
    let t = e.getTarget();
    return null != t && (t = "target: " + t), t;
}
function $d3ed32e1e38e75bc$var$K(e) {
    let t = e.getRel();
    return null != t && (t = "rel: " + t), t;
}
function $d3ed32e1e38e75bc$var$O(e) {
    let t = e.getTitle();
    return null != t && (t = "title: " + t), t;
}
function $d3ed32e1e38e75bc$var$A(e, t) {
    const n = new Array(1 + t++).join("  "), r = new Array(t - 1).join("  ");
    let o;
    for(let i = 0; i < e.children.length; i++)o = document.createTextNode("\n" + n), e.insertBefore(o, e.children[i]), $d3ed32e1e38e75bc$var$A(e.children[i], t), e.lastElementChild === e.children[i] && (o = document.createTextNode("\n" + r), e.appendChild(o));
    return e;
}
const $d3ed32e1e38e75bc$export$6940b0d9c820eca7 = (0, $lldlC.forwardRef)(function({ treeTypeButtonClassName: e, timeTravelButtonClassName: t, timeTravelPanelSliderClassName: n, timeTravelPanelButtonClassName: r, viewClassName: o, timeTravelPanelClassName: i, editorState: l, setEditorState: s, setEditorReadOnly: a, generateContent: c }, u) {
    const [f, d] = (0, $lldlC.useState)([]), [y, C] = (0, $lldlC.useState)(""), [$, N] = (0, $lldlC.useState)(!1), [S, T] = (0, $lldlC.useState)(!1), k = (0, $lldlC.useRef)(0), j = (0, $lldlC.useRef)(null), [L, v] = (0, $lldlC.useState)(!1), [B, E] = (0, $lldlC.useState)(!1), [w, F] = (0, $lldlC.useState)(!1), D = (0, $lldlC.useRef)(), K = (0, $lldlC.useRef)(0), O = (0, $lldlC.useCallback)((e)=>{
        const t = ++K.current;
        c(e).then((e)=>{
            t === K.current && C(e);
        }).catch((e)=>{
            t === K.current && C(`Error rendering tree: ${e.message}\n\nStack:\n${e.stack}`);
        });
    }, [
        c
    ]);
    (0, $lldlC.useEffect)(()=>{
        !w && l._nodeMap.size > 1e3 && (E(!0), !w) || D.current !== l && (D.current = l, O(S), $ || d((e)=>[
                ...e,
                [
                    Date.now(),
                    l
                ]
            ]));
    }, [
        l,
        O,
        S,
        w,
        $
    ]);
    const A = f.length;
    (0, $lldlC.useEffect)(()=>{
        if (L) {
            let e;
            const t = ()=>{
                const n = k.current;
                if (n === A - 1) return void v(!1);
                const r = f[n][0], o = f[n + 1][0];
                e = setTimeout(()=>{
                    k.current++;
                    const e = k.current, n = j.current;
                    null !== n && (n.value = String(e)), s(f[e][1]), t();
                }, o - r);
            };
            return t(), ()=>{
                clearTimeout(e);
            };
        }
    }, [
        f,
        L,
        A,
        s
    ]);
    return (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: o,
        children: [
            !w && B ? (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                style: {
                    padding: 20
                },
                children: [
                    (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                        style: {
                            marginRight: 20
                        },
                        children: "Detected large EditorState, this can impact debugging performance."
                    }),
                    (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        onClick: ()=>{
                            F(!0);
                        },
                        style: {
                            background: "transparent",
                            border: "1px solid white",
                            color: "white",
                            cursor: "pointer",
                            padding: 5
                        },
                        children: "Show full tree"
                    })
                ]
            }) : null,
            w ? null : (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>(O(!S), void T(!S)),
                className: e,
                type: "button",
                children: S ? "Tree" : "Export DOM"
            }),
            !$ && (w || !B) && A > 2 && (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                onClick: ()=>{
                    a(!0), k.current = A - 1, N(!0);
                },
                className: t,
                type: "button",
                children: "Time Travel"
            }),
            (w || !B) && (0, $c53f8b07b96ee0c5$exports.jsx)("pre", {
                ref: u,
                children: y
            }),
            $ && (w || !B) && (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: i,
                children: [
                    (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: r,
                        onClick: ()=>{
                            k.current === A - 1 && (k.current = 1), v(!L);
                        },
                        type: "button",
                        children: L ? "Pause" : "Play"
                    }),
                    (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                        className: n,
                        ref: j,
                        onChange: (e)=>{
                            const t = Number(e.target.value), n = f[t];
                            n && (k.current = t, s(n[1]));
                        },
                        type: "range",
                        min: "1",
                        max: A - 1
                    }),
                    (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: r,
                        onClick: ()=>{
                            a(!1);
                            const e = f.length - 1, t = f[e];
                            s(t[1]);
                            const n = j.current;
                            null !== n && (n.value = String(e)), N(!1), v(!1);
                        },
                        type: "button",
                        children: "Exit"
                    })
                ]
            })
        ]
    });
});
function $d3ed32e1e38e75bc$export$2b33dd74ec751364(e, t) {
    const n = new Set;
    let r = 0;
    for (const [o] of e._commands)n.add(e.registerCommand(o, (e)=>(t((t)=>{
            r += 1;
            const n = [
                ...t
            ];
            return n.push({
                index: r,
                payload: e,
                type: o.type ? o.type : "UNKNOWN"
            }), n.length > 10 && n.shift(), n;
        }), !1), (0, $f3de35ce60b0ef48$export$6afdf194f304e546)));
    return ()=>n.forEach((e)=>e());
}
function $d3ed32e1e38e75bc$export$1d225a6d44c41fc6(e) {
    const [t, n] = (0, $lldlC.useState)([]);
    return (0, $lldlC.useEffect)(()=>$d3ed32e1e38e75bc$export$2b33dd74ec751364(e, n), [
        e
    ]), (0, $lldlC.useMemo)(()=>t, [
        t
    ]);
}


const $22e45ac03d1cae91$var$mod = $d3ed32e1e38e75bc$exports;
const $22e45ac03d1cae91$export$6940b0d9c820eca7 = $22e45ac03d1cae91$var$mod.TreeView;
const $22e45ac03d1cae91$export$4edbeb3aa79c6b8a = $22e45ac03d1cae91$var$mod.generateContent;
const $22e45ac03d1cae91$export$2b33dd74ec751364 = $22e45ac03d1cae91$var$mod.registerLexicalCommandLogger;
const $22e45ac03d1cae91$export$1d225a6d44c41fc6 = $22e45ac03d1cae91$var$mod.useLexicalCommandsLog;




var $lldlC = parcelRequire("lldlC");

function $a36bad105784d3f0$export$6940b0d9c820eca7({ treeTypeButtonClassName: n, timeTravelButtonClassName: m, timeTravelPanelSliderClassName: u, timeTravelPanelButtonClassName: c, viewClassName: d, timeTravelPanelClassName: C, editor: N, customPrintNode: f }) {
    const v = $lldlC.createRef(), [T, E] = (0, $lldlC.useState)(N.getEditorState()), p = (0, $22e45ac03d1cae91$export$1d225a6d44c41fc6)(N);
    (0, $lldlC.useEffect)(()=>(0, $70f33588e7e4964f$export$d64d64f541cc1835)(N.registerUpdateListener(({ editorState: e })=>{
            E(e);
        }), N.registerEditableListener(()=>{
            E(N.getEditorState());
        })), [
        N
    ]), (0, $lldlC.useEffect)(()=>{
        const e = v.current;
        if (null !== e) return e.__lexicalEditor = N, ()=>{
            e.__lexicalEditor = null;
        };
    }, [
        N,
        v
    ]);
    return (0, $c53f8b07b96ee0c5$exports.jsx)((0, $22e45ac03d1cae91$export$6940b0d9c820eca7), {
        treeTypeButtonClassName: n,
        timeTravelButtonClassName: m,
        timeTravelPanelSliderClassName: u,
        timeTravelPanelButtonClassName: c,
        viewClassName: d,
        timeTravelPanelClassName: C,
        setEditorReadOnly: (e)=>{
            const t = N.getRootElement();
            null != t && (t.contentEditable = e ? "false" : "true");
        },
        editorState: T,
        setEditorState: (e)=>N.setEditorState(e),
        generateContent: async function(e) {
            return (0, $22e45ac03d1cae91$export$4edbeb3aa79c6b8a)(N, p, e, f);
        },
        ref: v
    });
}


const $d04c774ff24b4685$var$mod = $a36bad105784d3f0$exports;
const $d04c774ff24b4685$export$6940b0d9c820eca7 = $d04c774ff24b4685$var$mod.TreeView;


const $9b54490d250ed09d$export$43cc9c0d5e3249b3 = ()=>{
    const [editor] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)();
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d04c774ff24b4685$export$6940b0d9c820eca7), {
        viewClassName: "tree-view-output",
        treeTypeButtonClassName: "debug-treetype-button",
        timeTravelPanelClassName: "debug-timetravel-panel",
        timeTravelButtonClassName: "debug-timetravel-button",
        timeTravelPanelSliderClassName: "debug-timetravel-panel-slider",
        timeTravelPanelButtonClassName: "debug-timetravel-panel-button",
        editor: editor
    });
};




// Editor configuration with theme, namespace, and custom nodes
const $17a7e23cd205e7f9$var$editorConfig = {
    namespace: "LexicalEditorNamespace",
    nodes: [
        (0, $864ec047e45786ae$export$cc9044e10fd11ba6)
    ],
    onError (error) {
        throw error; // Error boundary for Lexical editor
    },
    theme: (0, $a9379d78ef00eb74$export$164de7ab8df77ef0)
};
// Component to render a placeholder in the editor when it's empty
const $17a7e23cd205e7f9$var$Placeholder = ({ children: children })=>{
    const [editor] = (0, $594140ffbcb49f97$export$6aeca6bab7b7edbc)();
    const [showPlaceholder, setShowPlaceholder] = (0, $lldlC.useState)(true);
    (0, $lldlC.useEffect)(()=>{
        // Update visibility of the placeholder based on editor content
        const update = ()=>{
            editor.getEditorState().read(()=>{
                const rootText = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getTextContent();
                setShowPlaceholder(rootText.trim() === ""); // Show placeholder if the content is empty
            });
        };
        // Register update listener
        const unsubscribe = editor.registerUpdateListener(update);
        update();
        return ()=>unsubscribe(); // Cleanup listener on component unmount
    }, [
        editor
    ]);
    return showPlaceholder ? /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "editor-placeholder",
        children: children
    }) : null;
};
const $17a7e23cd205e7f9$export$f59e465f96e674ee = /*#__PURE__*/ (0, $lldlC.forwardRef)(({ initialHtml: initialHtml = "", onChange: onChange }, ref)=>{
    const editorRef = (0, $lldlC.useRef)(null);
    // Expose a method to get the editor's current state to the parent component
    (0, $lldlC.useImperativeHandle)(ref, ()=>({
            getEditorState: ()=>{
                let editorContent = "";
                editorRef.current?.getEditorState().read(()=>{
                    editorContent = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getTextContent();
                });
                return editorContent;
            }
        }));
    // Handle content change and pass updated content to the parent
    const handleChange = (editorState)=>{
        editorState.read(()=>{
            const content = (0, $f3de35ce60b0ef48$export$8d83ea843c4eea9a)().getTextContent(); // Extract text content from the editor
            onChange(content); // Trigger parent onChange callback with updated content
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $6c8cca9abc369701$export$97615ad7610e68cc), {
        initialConfig: {
            ...$17a7e23cd205e7f9$var$editorConfig,
            editorState: null
        },
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "editor-container",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $cb3f8ddb5bb538fc$export$d8cca1874b1065b9), {}),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "editor-inner",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $56d9cf49beb0ea47$export$26ad95729aab2c7a), {
                            contentEditable: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $c92843f35f23b6dc$export$15d656b6f5aa1ba8), {
                                className: "editor-input"
                            }),
                            placeholder: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($17a7e23cd205e7f9$var$Placeholder, {
                                children: "Enter your reply..."
                            }),
                            ErrorBoundary: (0, $721ffc860e2471af$export$a8147b707c252e29)
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $40c589373bd9baa4$export$71f666dd3362399), {}),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $7f13a6655cf9df34$export$a8eb6a441bc1c208), {}),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $44af0f53bcb1ec89$export$a521e3a22207fce0), {}),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $9b54490d250ed09d$export$43cc9c0d5e3249b3), {}),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $eb7acf1e2a4ecbb8$export$db03ed1efce87e4b), {
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $588d98e0b032b474$export$cd143eecf84f179a), {
                            initHtml: initialHtml
                        })
                    ]
                })
            ]
        })
    });
});




var $lldlC = parcelRequire("lldlC");

const $fdd2fbc855c6b00a$export$c4a9d90eb427f09c = /*#__PURE__*/ (0, $lldlC.createContext)({});
const $fdd2fbc855c6b00a$export$35eae644bb87870c = (props)=>{
    //
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [org, setOrg] = (0, $lldlC.useState)(undefined);
    const getMyOrg = (0, $lldlC.useCallback)(()=>{
        setOrg(undefined);
        // get org
        (0, $ead54b3c845eba59$export$64fa523eeab26787).getMyOrg({}).then((org)=>{
            setOrg(org);
        }).catch((e)=>{
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error("Error getting org.");
            console.error(e);
        });
    }, [
        user.email
    ]);
    (0, $lldlC.useEffect)(()=>{
        getMyOrg();
    }, [
        getMyOrg
    ]);
    if (org === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading org ..."
    });
    if (org === null) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Org not found."
    });
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($fdd2fbc855c6b00a$export$c4a9d90eb427f09c.Provider, {
        value: {
            org: org
        },
        children: props.children
    });
};
function $fdd2fbc855c6b00a$export$7f785727a26e156() {
    return (0, $lldlC.useContext)($fdd2fbc855c6b00a$export$c4a9d90eb427f09c);
}



var $lldlC = parcelRequire("lldlC");



var $ec875ec52581da02$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["success"] = "Success";
    Status["failure"] = "Failure";
    return Status;
}({});





const $a99cf1e9ec04ed13$export$7c3d578662763a63 = async (args)=>{
    const { contents: contents, gcsBucket: bucket, gcsFolder: folder, filename: filename } = args;
    const id = (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createFileId();
    const path = `${folder}`;
    const gcsUri = (0, $910976a52b10d76a$export$24588512e87d8b80)({
        bucket: bucket,
        path: path
    });
    const storageRef = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)((0, $6713bbb530aa5272$export$f5b1a83e9c7f7f6c), gcsUri);
    await (0, $3fab5dd6ec5d4e72$export$d885b2eb178808b3)(storageRef, contents, "raw", {
        contentType: args.contentType
    });
    return {
        id: id,
        bucket: bucket,
        path: path,
        filename: filename
    };
};


var $bde177b748eb2687$exports = {};
var $1f672fed7efed57e$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1f672fed7efed57e$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$1f672fed7efed57e$exports = $1f672fed7efed57e$var$isObject;


var $ff73c6230a06e510$exports = {};
var $e1f29a94f3202822$exports = {};
var $2c9229a3504a6578$exports = {};
/** Detect free variable `global` from Node.js. */ var $2c9229a3504a6578$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$2c9229a3504a6578$exports = $2c9229a3504a6578$var$freeGlobal;


/** Detect free variable `self`. */ var $e1f29a94f3202822$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e1f29a94f3202822$var$root = $2c9229a3504a6578$exports || $e1f29a94f3202822$var$freeSelf || Function('return this')();
$e1f29a94f3202822$exports = $e1f29a94f3202822$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ff73c6230a06e510$var$now = function() {
    return $e1f29a94f3202822$exports.Date.now();
};
$ff73c6230a06e510$exports = $ff73c6230a06e510$var$now;


var $185374bfa30f0a8e$exports = {};
var $ca1ef1e21735539c$exports = {};
var $3e113ae5edd4a751$exports = {};
/** Used to match a single whitespace character. */ var $3e113ae5edd4a751$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3e113ae5edd4a751$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3e113ae5edd4a751$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$3e113ae5edd4a751$exports = $3e113ae5edd4a751$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $ca1ef1e21735539c$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $ca1ef1e21735539c$var$baseTrim(string) {
    return string ? string.slice(0, $3e113ae5edd4a751$exports(string) + 1).replace($ca1ef1e21735539c$var$reTrimStart, '') : string;
}
$ca1ef1e21735539c$exports = $ca1ef1e21735539c$var$baseTrim;



var $8b4462bc4faef8d5$exports = {};
var $a417b04763129f1c$exports = {};
var $24222c5e026539d1$exports = {};

/** Built-in value references. */ var $24222c5e026539d1$var$Symbol = $e1f29a94f3202822$exports.Symbol;
$24222c5e026539d1$exports = $24222c5e026539d1$var$Symbol;


var $d5a2c4cb9feb0d76$exports = {};

/** Used for built-in method references. */ var $d5a2c4cb9feb0d76$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5a2c4cb9feb0d76$var$hasOwnProperty = $d5a2c4cb9feb0d76$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d5a2c4cb9feb0d76$var$nativeObjectToString = $d5a2c4cb9feb0d76$var$objectProto.toString;
/** Built-in value references. */ var $d5a2c4cb9feb0d76$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d5a2c4cb9feb0d76$var$getRawTag(value) {
    var isOwn = $d5a2c4cb9feb0d76$var$hasOwnProperty.call(value, $d5a2c4cb9feb0d76$var$symToStringTag), tag = value[$d5a2c4cb9feb0d76$var$symToStringTag];
    try {
        value[$d5a2c4cb9feb0d76$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d5a2c4cb9feb0d76$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d5a2c4cb9feb0d76$var$symToStringTag] = tag;
        else delete value[$d5a2c4cb9feb0d76$var$symToStringTag];
    }
    return result;
}
$d5a2c4cb9feb0d76$exports = $d5a2c4cb9feb0d76$var$getRawTag;


var $b787ae3208ebc449$exports = {};
/** Used for built-in method references. */ var $b787ae3208ebc449$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b787ae3208ebc449$var$nativeObjectToString = $b787ae3208ebc449$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b787ae3208ebc449$var$objectToString(value) {
    return $b787ae3208ebc449$var$nativeObjectToString.call(value);
}
$b787ae3208ebc449$exports = $b787ae3208ebc449$var$objectToString;


/** `Object#toString` result references. */ var $a417b04763129f1c$var$nullTag = '[object Null]', $a417b04763129f1c$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a417b04763129f1c$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a417b04763129f1c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a417b04763129f1c$var$undefinedTag : $a417b04763129f1c$var$nullTag;
    return $a417b04763129f1c$var$symToStringTag && $a417b04763129f1c$var$symToStringTag in Object(value) ? $d5a2c4cb9feb0d76$exports(value) : $b787ae3208ebc449$exports(value);
}
$a417b04763129f1c$exports = $a417b04763129f1c$var$baseGetTag;


var $34a8c8cbd9ebf965$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $34a8c8cbd9ebf965$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$34a8c8cbd9ebf965$exports = $34a8c8cbd9ebf965$var$isObjectLike;


/** `Object#toString` result references. */ var $8b4462bc4faef8d5$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8b4462bc4faef8d5$var$isSymbol(value) {
    return typeof value == 'symbol' || $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $8b4462bc4faef8d5$var$symbolTag;
}
$8b4462bc4faef8d5$exports = $8b4462bc4faef8d5$var$isSymbol;


/** Used as references for various `Number` constants. */ var $185374bfa30f0a8e$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $185374bfa30f0a8e$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $185374bfa30f0a8e$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $185374bfa30f0a8e$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $185374bfa30f0a8e$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $185374bfa30f0a8e$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($8b4462bc4faef8d5$exports(value)) return $185374bfa30f0a8e$var$NAN;
    if ($1f672fed7efed57e$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $1f672fed7efed57e$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $ca1ef1e21735539c$exports(value);
    var isBinary = $185374bfa30f0a8e$var$reIsBinary.test(value);
    return isBinary || $185374bfa30f0a8e$var$reIsOctal.test(value) ? $185374bfa30f0a8e$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $185374bfa30f0a8e$var$reIsBadHex.test(value) ? $185374bfa30f0a8e$var$NAN : +value;
}
$185374bfa30f0a8e$exports = $185374bfa30f0a8e$var$toNumber;


/** Error message constants. */ var $bde177b748eb2687$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bde177b748eb2687$var$nativeMax = Math.max, $bde177b748eb2687$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $bde177b748eb2687$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($bde177b748eb2687$var$FUNC_ERROR_TEXT);
    wait = $185374bfa30f0a8e$exports(wait) || 0;
    if ($1f672fed7efed57e$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $bde177b748eb2687$var$nativeMax($185374bfa30f0a8e$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $bde177b748eb2687$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ff73c6230a06e510$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ff73c6230a06e510$exports());
    }
    function debounced() {
        var time = $ff73c6230a06e510$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$bde177b748eb2687$exports = $bde177b748eb2687$var$debounce;



var $d6c2a27c8436e441$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode["Compose"] = "compose";
    Mode["Drafts"] = "drafts";
    return Mode;
}({});
const $d6c2a27c8436e441$export$ec1ed5c0651cbbdf = (props)=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [draftEmail, setDraftEmail] = (0, $lldlC.useState)({
        text: null,
        to: null,
        subject: null,
        attachedFiles: []
    });
    const [uploadProgress, setUploadProgress] = (0, $lldlC.useState)({});
    const [draftEmailId, setDraftEmailId] = (0, $lldlC.useState)(null);
    const [busyFlag, setBusyFlag] = (0, $lldlC.useState)(false);
    const [editorHasContent, setEditorHasContent] = (0, $lldlC.useState)(false);
    // Populate fields from draft data or initialize new draft
    (0, $lldlC.useEffect)(()=>{
        if (props.mode === "drafts" && props.currentDraft) {
            // Load current draft data.
            setDraftEmailId(props.currentDraft.id);
            setDraftEmail({
                to: props.currentDraft.to || null,
                subject: props.currentDraft.subject || null,
                text: props.currentDraft.text || null,
                attachedFiles: props.currentDraft.attachedFiles || []
            });
        } else if (props.mode === "compose" && !draftEmailId && (draftEmail.subject || draftEmail.to || editorHasContent)) {
            const newDraftEmailId = (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId();
            setDraftEmailId(newDraftEmailId);
            const emailKey = {
                orgId: org.id,
                uid: user.uid,
                emailId: newDraftEmailId
            };
            const placeholderHtmlContent = {
                path: (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundEmailHtmlContentPath({
                    ...emailKey
                }),
                id: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId(),
                bucket: (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket,
                filename: "placeholder.html"
            };
            initializeDraftEmail(newDraftEmailId, placeholderHtmlContent, []);
        }
    }, [
        props.mode,
        props.currentDraft,
        editorHasContent,
        draftEmailId
    ]);
    // Auto-save draft functionality
    (0, $lldlC.useEffect)(()=>{
        if (!draftEmailId) return;
        const debouncedSave = (0, (/*@__PURE__*/$parcel$interopDefault($bde177b748eb2687$exports)))(saveDraft, 1000);
        debouncedSave();
        return ()=>debouncedSave.cancel();
    }, [
        draftEmail.text,
        draftEmail.attachedFiles,
        draftEmail.to,
        draftEmail.subject,
        editorHasContent
    ]);
    const initializeDraftEmail = async (draftId, htmlContent, attachments)=>{
        const initialDraft = {
            id: draftId,
            uid: user.uid,
            orgId: org.id,
            from: user.email,
            to: draftEmail.to,
            subject: draftEmail.subject,
            htmlContentGcsFile: htmlContent,
            text: "",
            attachedFiles: attachments || [],
            lastModified: new Date().toISOString()
        };
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $abf2d4628a1238d4$export$2b8e1946228932b7).draftEmail.set({
                    orgId: org.id,
                    uid: user.uid,
                    emailId: draftId
                }, initialDraft),
            onError: (e)=>console.error("Error initializing draft:", e)
        });
    };
    const uploadAttachments = async (files)=>{
        const transformedFiles = files.map((file)=>transformRawFileToAttachment(file, org.id, user.uid, draftEmailId));
        const newDraftAttachments = transformedFiles.filter((file)=>!draftEmail.attachedFiles.some((uploadedAttachments)=>uploadedAttachments.gcsFile.filename === file.gcsFile.filename));
        const uploadPromises = newDraftAttachments.map(async (attachment)=>{
            const newUploadedFile = files.find((file)=>file.name === attachment.gcsFile.filename);
            if (!newUploadedFile) return;
            try {
                await (0, $fce4445636ac7988$export$6c5453569d966c6d)({
                    file: newUploadedFile,
                    path: attachment.gcsFile.path,
                    bucket: (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket,
                    onProgress: (percentage)=>{
                        setUploadProgress((prev)=>({
                                ...prev,
                                [newUploadedFile.name]: percentage
                            }));
                    }
                });
            } catch (error) {
                console.error(`Error uploading file ${newUploadedFile.name}:`, error);
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error(`Failed to upload attachment: ${newUploadedFile.name}`);
            }
        });
        await Promise.all(uploadPromises);
        setDraftEmail((prev)=>({
                ...prev,
                attachedFiles: [
                    ...prev.attachedFiles || [],
                    ...newDraftAttachments
                ]
            }));
    };
    // Save draft with attachment handling
    const saveDraft = async ()=>{
        if (!draftEmailId) return;
        const updatedDraft = {
            text: draftEmail.text,
            attachedFiles: [
                ...draftEmail.attachedFiles
            ],
            lastModified: new Date().toISOString(),
            to: draftEmail.to,
            subject: draftEmail.subject
        };
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $abf2d4628a1238d4$export$2b8e1946228932b7).draftEmail.merge({
                    orgId: org.id,
                    uid: user.uid,
                    emailId: draftEmailId
                }, updatedDraft),
            onError: (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Failed to save draft.")
        });
    };
    // Send email process
    const onSend = async ()=>{
        const outboundEmailId = draftEmailId || (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId();
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                // Upload HTML content
                const htmlContent = await (0, $a99cf1e9ec04ed13$export$7c3d578662763a63)({
                    contents: draftEmail.text,
                    gcsBucket: (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket,
                    gcsFolder: (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundEmailHtmlContentPath({
                        orgId: org.id,
                        uid: user.uid,
                        emailId: outboundEmailId
                    }),
                    fileExtension: "html",
                    contentType: "html",
                    filename: "html_content"
                });
                // Create outbound email entity
                const outboundEmail = {
                    id: outboundEmailId,
                    uid: user.uid,
                    orgId: org.id,
                    from: user.email,
                    to: draftEmail.to,
                    subject: draftEmail.subject,
                    status: (0, $ec875ec52581da02$export$96e9906d6d93a972).failure,
                    htmlContent: htmlContent,
                    attachedFiles: draftEmail.attachedFiles
                };
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).outboundEmail.set({
                    uid: user.uid,
                    orgId: org.id,
                    emailId: outboundEmailId
                }, outboundEmail);
                // Delete draft after sending
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).draftEmail.remove({
                    orgId: org.id,
                    uid: user.uid,
                    emailId: draftEmailId
                });
            },
            loadingMessage: "Sending email...",
            setBusyFlag: setBusyFlag,
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email sent successfully!");
            },
            onError: (error)=>{
                console.error("Error sending reply:", error);
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error sending reply");
            }
        });
    };
    // Download attachment method
    const onDownloadAttachment = (attachment)=>{
        const storage = (0, $3fab5dd6ec5d4e72$export$fbd9b57a66480737)();
        const pathReference = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)(storage, attachment.gcsFile.path);
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const url = await (0, $3fab5dd6ec5d4e72$export$c8bf645a0c2a7d9f)(pathReference);
                const response = await fetch(url);
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                return {
                    blobUrl: blobUrl,
                    filename: attachment.gcsFile.filename || "file"
                };
            },
            onSuccess: ({ blobUrl: blobUrl, filename: filename })=>{
                const link = document.createElement("a");
                link.href = blobUrl;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.style.display = "none";
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            },
            onError: (error)=>{
                console.error("Error downloading attachment:", error);
                (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error("Error downloading attachment.");
            },
            loadingMessage: "Downloading attachment..."
        });
    };
    // Render attachments method
    const renderAttachments = ()=>{
        if (!draftEmail.attachedFiles || draftEmail.attachedFiles.length === 0 || props.mode === "compose") return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("h2", {
                    children: "Attachments"
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "attachments-div",
                    children: draftEmail.attachedFiles.map((attachment, index)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            style: {
                                textAlign: "center"
                            },
                            onClick: ()=>onDownloadAttachment(attachment),
                            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                className: "email-attachment-text",
                                children: `Attachment ${index + 1}: ${attachment.gcsFile.filename}`
                            })
                        }, attachment.gcsFile.id))
                })
            ]
        });
    };
    // Transform file to attachment
    const transformRawFileToAttachment = (file, orgId, uid, emailId)=>({
            gcsFile: {
                path: (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundAttachmentPath({
                    orgId: orgId,
                    uid: uid,
                    emailId: emailId || (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId(),
                    attachmentId: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId()
                }),
                id: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId(),
                bucket: (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket,
                filename: file.name
            },
            contentType: file.type,
            contentDisposition: "attachment",
            size: file.size
        });
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                children: [
                    props.mode === "drafts" && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("h3", {
                        children: "Edit Draft"
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "recipient-input",
                        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                            type: "email",
                            value: draftEmail.to || "",
                            onChange: (e)=>setDraftEmail((prev)=>({
                                        ...prev,
                                        to: e.target.value
                                    })),
                            placeholder: "Enter recipient's email",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "subject",
                        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                            type: "text",
                            value: draftEmail.subject || "",
                            onChange: (e)=>setDraftEmail((prev)=>({
                                        ...prev,
                                        subject: e.target.value
                                    })),
                            placeholder: "Enter subject"
                        })
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $17a7e23cd205e7f9$export$f59e465f96e674ee), {
                        initialHtml: props.mode === "drafts" && draftEmail.text ? `<p>${draftEmail.text}</p>` : "",
                        onChange: (text)=>{
                            setDraftEmail((prev)=>({
                                    ...prev,
                                    text: text
                                }));
                            setEditorHasContent(!!text.trim());
                        }
                    }),
                    renderAttachments()
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "attachments-section",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                        type: "file",
                        multiple: true,
                        onChange: (e)=>{
                            const files = Array.from(e.target.files || []);
                            uploadAttachments(files);
                        }
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "attachments-progress",
                        children: draftEmail.attachedFiles.map((file)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                children: [
                                    file.gcsFile.filename,
                                    ": ",
                                    uploadProgress[file.gcsFile.filename]?.toFixed(2) || 0,
                                    "% uploaded"
                                ]
                            }, file.gcsFile.filename))
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                        className: "send-button",
                        onClick: onSend,
                        disabled: !draftEmail.text || !draftEmail.to || busyFlag,
                        children: "Send"
                    })
                ]
            })
        ]
    });
};


const $92b9211e2af40749$export$fe28394a32231fdf = ()=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("h1", {
                children: "Compose"
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d6c2a27c8436e441$export$ec1ed5c0651cbbdf), {
                mode: (0, $d6c2a27c8436e441$export$9484bbecc3c49a2e).Compose
            })
        ]
    });
};







var $lldlC = parcelRequire("lldlC");





const $913c22c810ebadea$export$54543ea8ce25dd5a = (props)=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const { email: email, onSelectEmail: onSelectEmail } = props;
    const { headers: headers, previewSnippet: previewSnippet } = email;
    const senderName = headers.from?.name || "Unknown Sender";
    const subject = headers.subject || "No Subject";
    const snippet = previewSnippet || "No preview available";
    const markEmailAsRead = (emailId)=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: org.id,
                    uid: user.uid
                };
                return (0, $abf2d4628a1238d4$export$2b8e1946228932b7).inboundEmail.merge(emailKey, {
                    isRead: true
                });
            }
        });
    };
    const handleEmailClick = ()=>{
        onSelectEmail();
        if (!email.isRead) setTimeout(()=>{
            markEmailAsRead(email.id);
        }, 3000);
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "email-list-item-widget-container",
        onClick: handleEmailClick,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "email-list-item-widget",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "heading",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                            className: "sender",
                            children: [
                                senderName,
                                !email.isRead && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                    className: "unread-dot"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "time",
                            children: "9 months ago"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "subject",
                    children: subject
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "mail-snippet",
                    children: [
                        snippet,
                        " . . . "
                    ]
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "tags",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "meeting-tag",
                            children: "meeting"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "work-tag",
                            children: "work"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "important-tag",
                            children: "important"
                        })
                    ]
                })
            ]
        })
    });
};


const $22debc56734d8b81$export$2254b0989e55311a = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "list-container",
        children: props.filteredEmails.length === 0 ? /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "no-emails-message",
            children: "No emails available."
        }) : props.filteredEmails.map((email)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $913c22c810ebadea$export$54543ea8ce25dd5a), {
                email: email,
                onSelectEmail: ()=>props.onSelectEmail(email)
            }, email.id))
    });
};







var $lldlC = parcelRequire("lldlC");





const $0293bafd0b0f345e$export$abfd25e9b055f9f7 = ({ email: email })=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [htmlContentUrl, setHtmlContentUrl] = (0, $lldlC.useState)(null);
    const [formattedDate, setFormattedDate] = (0, $lldlC.useState)(null);
    const [htmlContent, setHtmlContent] = (0, $lldlC.useState)(null);
    const [replyText, setReplyText] = (0, $lldlC.useState)(null);
    const [attachments, setAttachments] = (0, $lldlC.useState)([]);
    const [uploadProgress, setUploadProgress] = (0, $lldlC.useState)({});
    const [busyFlag, setBusyFlag] = (0, $lldlC.useState)(false);
    const getHtmlContentUrl = (0, $lldlC.useCallback)(()=>{
        const storage = (0, $3fab5dd6ec5d4e72$export$fbd9b57a66480737)();
        const pathReference = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)(storage, (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).inboundEmailHtmlContentPath({
            orgId: org.id,
            emailId: email?.id,
            uid: user.uid
        }));
        if (email !== undefined && email !== null) (0, $3fab5dd6ec5d4e72$export$c8bf645a0c2a7d9f)(pathReference).then(async (url)=>{
            setHtmlContentUrl(url);
            const response = await fetch(url);
            const text = await response.text();
            setHtmlContent(text);
            setHtmlContentUrl(url);
        }).catch((e)=>{
            console.error(e);
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error("Error loading email content.");
        });
    }, [
        email
    ]);
    const formatDate = (inputDateStr)=>{
        const date = new Date(inputDateStr);
        const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true
        };
        setFormattedDate(date.toLocaleString("en-US", options));
    };
    (0, $lldlC.useEffect)(()=>{
        getHtmlContentUrl();
        // formatDate(email?.createdIsoDateTimeUtc);
        formatDate(email?.headers?.dateIsoDateTimeUtc);
    }, [
        getHtmlContentUrl
    ]);
    const replaceCidLinks = (0, $lldlC.useCallback)(async (element)=>{
        const attachedFiles = email.attachedFiles;
        const inlineAttachments = attachedFiles.filter((file)=>file.contentId);
        for (const attachment of inlineAttachments){
            const cid = `cid:${attachment.contentId}`;
            const element = document.querySelector(`img[src='${cid}']`);
            if (element) {
                // get download url
                const downloadUrl = await (0, $29a77eb925234970$export$7097499bf5735f0a)((0, $0a8d0e62beb81aa5$export$f5c0819de731e325).inboundAttachmentPath({
                    orgId: org.id,
                    emailId: email?.id,
                    attachmentId: attachment.gcsFile.id,
                    uid: user.uid
                }));
                // replace src with download url
                element.src = downloadUrl;
            }
        }
    }, (0, $9820bd08d81ab8cb$export$853a255c1abddbf0)([
        org,
        email,
        user
    ]));
    if (email === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading..."
    });
    if (email === null) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Email not found."
    });
    const onDownloadAttachment = (attachment)=>{
        const storage = (0, $3fab5dd6ec5d4e72$export$fbd9b57a66480737)();
        const pathReference = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)(storage, attachment.gcsFile.path);
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const url = await (0, $3fab5dd6ec5d4e72$export$c8bf645a0c2a7d9f)(pathReference); // Get the download URL
                const response = await fetch(url); // Fetch the file as a Blob
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob); // Create a Blob URL for the download
                return {
                    blobUrl: blobUrl,
                    filename: attachment.gcsFile.filename || "file.pdf"
                };
            },
            onSuccess: ({ blobUrl: blobUrl, filename: filename })=>{
                const link = document.createElement("a");
                link.href = blobUrl;
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Append the link to the DOM, trigger the download, and clean up
                link.style.display = "none";
                link.click(); // Trigger the download
                document.body.removeChild(link); // Remove the link from DOM
                window.URL.revokeObjectURL(blobUrl); // Release the blob URL
            },
            onError: (error)=>{
                console.error("Error downloading attachment:", error);
                (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error("Error downloading attachment.");
            },
            loadingMessage: "Downloading attachment..."
        });
    };
    const renderAttachments = ()=>{
        if (!email.attachedFiles || email.attachedFiles.length === 0) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("h2", {
                    children: "Attachments"
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "attachments-div",
                    children: email.attachedFiles.filter((e)=>e.contentDisposition === "attachment").map((attachment, index)=>{
                        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                onClick: ()=>onDownloadAttachment(attachment),
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                    className: "email-attachment-text",
                                    children: `Attachment ${index + 1}`
                                })
                            })
                        }, attachment.gcsFile.id);
                    })
                })
            ]
        });
    };
    const renderHtmlContent = ()=>{
        if (!htmlContent) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: htmlContent
            },
            ref: replaceCidLinks
        });
    };
    const uploadHtmlContent = async (outboundEmailId)=>{
        const bucketName = (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket;
        const emailKey = {
            orgId: org.id,
            uid: user.uid,
            emailId: outboundEmailId
        };
        const folderPath = (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundEmailHtmlContentPath({
            ...emailKey
        });
        const result = await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $a99cf1e9ec04ed13$export$7c3d578662763a63)({
                    contents: replyText,
                    gcsBucket: bucketName,
                    gcsFolder: folderPath,
                    fileExtension: "html",
                    contentType: "html",
                    filename: "html_content"
                }),
            loadingMessage: `Uploading file`
        });
        return result;
    };
    const uploadAttachments = async (outboundEmailId)=>{
        const bucketName = (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket;
        const uploadAttachmentMetadata = [];
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            loadingMessage: "Uploading attachments...",
            successMessage: "Attachments uploaded successfully!",
            fn: async ()=>{
                await Promise.all(attachments.map(async (file)=>{
                    const path = (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundAttachmentPath({
                        orgId: org.id,
                        uid: user.uid,
                        emailId: outboundEmailId,
                        attachmentId: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId()
                    });
                    // Upload file to GCS
                    await (0, $fce4445636ac7988$export$6c5453569d966c6d)({
                        file: file,
                        path: path,
                        bucket: bucketName,
                        onProgress: (percentage)=>{
                            setUploadProgress((prev)=>({
                                    ...prev,
                                    [file.name]: percentage
                                }));
                        }
                    });
                    // Collect file metadata
                    const metadata = {
                        gcsFile: {
                            path: path,
                            id: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId(),
                            bucket: bucketName,
                            filename: file.name || ""
                        },
                        contentType: file.type,
                        contentDisposition: "attachment",
                        size: file.size
                    };
                    uploadAttachmentMetadata.push(metadata);
                }));
            },
            onError: (e)=>console.error("Failed to upload attachments:", e),
            onComplete: ()=>console.log("Upload process completed.")
        });
        return uploadAttachmentMetadata;
    };
    const createOutboundEmailEntity = async (outboundEmailId, htmlContent, attachments)=>{
        const outboundEmail = {
            id: outboundEmailId,
            uid: user.uid,
            orgId: org.id,
            from: user.email,
            to: email.headers?.from.email,
            subject: email.headers?.subject,
            status: (0, $ec875ec52581da02$export$96e9906d6d93a972).failure,
            htmlContent: htmlContent,
            attachedFiles: attachments || []
        };
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $abf2d4628a1238d4$export$2b8e1946228932b7).outboundEmail.set({
                    uid: user.uid,
                    orgId: org.id,
                    emailId: outboundEmail.id
                }, outboundEmail),
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Reply sent successfully!");
            }
        });
    };
    const onSendReply = async ()=>{
        const outboundEmailId = (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId();
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const htmlContent = await uploadHtmlContent(outboundEmailId); // Upload HTML content
                const outboundAttachmentMetadata = await uploadAttachments(outboundEmailId); // Upload attachments
                await createOutboundEmailEntity(outboundEmailId, htmlContent, outboundAttachmentMetadata); // Create outbound email entry
            },
            loadingMessage: "Sending reply...",
            setBusyFlag: setBusyFlag,
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Reply sent successfully!");
            },
            onError: (error)=>{
                console.error("Error sending reply:", error);
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error sending reply.");
            }
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "mail-header-container",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "name-timestamp-container",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                children: email.headers?.from.name
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "timestamp",
                                children: formattedDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "subject",
                        children: email.headers?.subject
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "sender",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                children: "Reply To:"
                            }),
                            " ",
                            email.headers?.from.email
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "mail-content",
                children: renderHtmlContent()
            }),
            renderAttachments(),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "reply-section",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("textarea", {
                        placeholder: "Reply...",
                        className: "text-area",
                        onChange: (e)=>setReplyText(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "send-button-container",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "upload-attachments",
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                                    type: "file",
                                    multiple: true,
                                    onChange: (e)=>setAttachments((prev)=>[
                                                ...prev,
                                                ...Array.from(e.target.files || [])
                                            ])
                                })
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "attachments-progress",
                                children: attachments.map((file)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                        children: [
                                            file.name,
                                            ": ",
                                            uploadProgress[file.name]?.toFixed(2) || 0,
                                            "% uploaded"
                                        ]
                                    }, file.name))
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                                className: "send-button",
                                onClick: onSendReply,
                                disabled: !replyText || busyFlag,
                                children: "Send"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f12f1155aadc5539$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Archive", [
    [
        "rect",
        {
            width: "20",
            height: "5",
            x: "2",
            y: "3",
            rx: "1",
            key: "1wp1u1"
        }
    ],
    [
        "path",
        {
            d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
            key: "1s80jp"
        }
    ],
    [
        "path",
        {
            d: "M10 12h4",
            key: "a56b0p"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d3cf15f05a45b5f1$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Clock3", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16.5 12",
            key: "1aq6pp"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e2aac91a83df5208$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("CornerUpLeft", [
    [
        "polyline",
        {
            points: "9 14 4 9 9 4",
            key: "881910"
        }
    ],
    [
        "path",
        {
            d: "M20 20v-7a4 4 0 0 0-4-4H4",
            key: "1nkjon"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $74a355a98cbe0193$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("CornerUpRight", [
    [
        "polyline",
        {
            points: "15 14 20 9 15 4",
            key: "1tbx3s"
        }
    ],
    [
        "path",
        {
            d: "M4 20v-7a4 4 0 0 1 4-4h12",
            key: "1lu4f8"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fcc43edb3befdd80$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("EllipsisVertical", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "5",
            r: "1",
            key: "gxeob9"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "19",
            r: "1",
            key: "lyex9k"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $08d99fd9a80399e4$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("ReplyAll", [
    [
        "polyline",
        {
            points: "7 17 2 12 7 7",
            key: "t83bqg"
        }
    ],
    [
        "polyline",
        {
            points: "12 17 7 12 12 7",
            key: "1g4ajm"
        }
    ],
    [
        "path",
        {
            d: "M22 18v-2a4 4 0 0 0-4-4H7",
            key: "1fcyog"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4a3e3b31eaf267f5$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Trash2", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
]);



const $3dbdfbf7a6468e70$export$17e4068f9ad0565b = ()=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [searchParams, setSearchParams] = (0, $5eed20d16fad0e34$export$f1a78c17382fe22a)();
    const [selectedEmail, setSelectedEmail] = (0, $lldlC.useState)();
    const emailId = searchParams.get("emailId");
    const { list: emailList = [] } = (0, $02a6a4d8defc9d58$export$280a58d17031e34d)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).inbox, {
        key: {
            orgId: org.id,
            uid: user.uid
        },
        orderByField: "createdIsoDateTimeUtc",
        orderByDirection: "desc",
        limit: 10
    });
    (0, $lldlC.useEffect)(()=>{
        if (!selectedEmail && emailList.length > 0) {
            const firstEmail = emailList[0];
            setSearchParams({
                emailId: firstEmail.id
            });
            setSelectedEmail(firstEmail);
        } else if (selectedEmail) setSearchParams({
            emailId: selectedEmail.id
        });
    }, [
        selectedEmail,
        emailList,
        setSearchParams,
        setSelectedEmail
    ]);
    if (emailList === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading emails..."
    });
    const [filterUnreadEmails, setFilterUnreadEmails] = (0, $lldlC.useState)(false);
    const filteredEmails = filterUnreadEmails ? emailList.filter((email)=>!email.isRead) : emailList;
    const moveToArchive = async (emailKey, email)=>{
        await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).archiveEmail.set(emailKey, email);
        await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).inboundEmail.remove(emailKey);
    };
    const archiveEmail = async ()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid
                };
                await moveToArchive(emailKey, selectedEmail);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email moved to Archive.");
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error moving email to Archive.");
            }
        });
    };
    const onDeleteEmail = ()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid
                };
                const trashEmail = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid,
                    email: selectedEmail,
                    deletedIsoDateTimeUtc: new Date().toISOString(),
                    type: "InboundEmail"
                };
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).trashEmail.set(emailKey, trashEmail);
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).inboundEmail.remove(emailKey);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email Deleted Successfully");
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error in deleting email.");
            }
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "inbox-page",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-list-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-list-header",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "inbox-heading",
                                children: "Inbox"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "switch-button",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: `all-mail ${!filterUnreadEmails ? "active" : ""}`,
                                        onClick: ()=>setFilterUnreadEmails(false),
                                        children: "All Mail"
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: `unread ${filterUnreadEmails ? "active" : ""}`,
                                        onClick: ()=>setFilterUnreadEmails(true),
                                        children: "Unread"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $22debc56734d8b81$export$2254b0989e55311a), {
                        emailList: emailList,
                        onSelectEmail: (email)=>setSelectedEmail(email),
                        filteredEmails: filteredEmails
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-view-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-action-items",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $f12f1155aadc5539$export$2e2bcd8739ae039), {
                                        onClick: archiveEmail,
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $4a3e3b31eaf267f5$export$2e2bcd8739ae039), {
                                        onClick: onDeleteEmail,
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d3cf15f05a45b5f1$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "reply-actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $e2aac91a83df5208$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $08d99fd9a80399e4$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $74a355a98cbe0193$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fcc43edb3befdd80$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $0293bafd0b0f345e$export$abfd25e9b055f9f7), {
                        email: selectedEmail
                    })
                ]
            })
        ]
    });
};







var $lldlC = parcelRequire("lldlC");



/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $aeccf260e1d80429$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("ArchiveX", [
    [
        "rect",
        {
            width: "20",
            height: "5",
            x: "2",
            y: "3",
            rx: "1",
            key: "1wp1u1"
        }
    ],
    [
        "path",
        {
            d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
            key: "1s80jp"
        }
    ],
    [
        "path",
        {
            d: "m9.5 17 5-5",
            key: "nakeu6"
        }
    ],
    [
        "path",
        {
            d: "m9.5 12 5 5",
            key: "1hccrj"
        }
    ]
]);



const $713e32c6eae25ee8$export$ea490c2795d126e1 = ()=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [searchParams, setSearchParams] = (0, $5eed20d16fad0e34$export$f1a78c17382fe22a)();
    const [selectedEmail, setSelectedEmail] = (0, $lldlC.useState)();
    const emailId = searchParams.get("emailId");
    // Fetch the archived emails
    const { list: emailList = [] } = (0, $02a6a4d8defc9d58$export$280a58d17031e34d)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).archive, {
        key: {
            orgId: org.id,
            uid: user.uid
        },
        orderByField: "createdIsoDateTimeUtc",
        orderByDirection: "desc",
        limit: 10
    });
    (0, $lldlC.useEffect)(()=>{
        if (!selectedEmail && emailList.length > 0) {
            const firstEmail = emailList[0];
            setSearchParams({
                emailId: firstEmail.id
            });
            setSelectedEmail(firstEmail);
        } else if (selectedEmail) setSearchParams({
            emailId: selectedEmail.id
        });
    }, [
        selectedEmail,
        emailList,
        setSearchParams,
        setSelectedEmail
    ]);
    if (emailList === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading archived emails..."
    });
    const [filterUnreadEmails, setFilterUnreadEmails] = (0, $lldlC.useState)(false);
    const filteredEmails = filterUnreadEmails ? emailList.filter((email)=>!email.isRead) : emailList;
    const moveToInbox = async (emailKey, email)=>{
        await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).inboundEmail.set(emailKey, email);
        await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).archiveEmail.remove(emailKey);
    };
    const unarchiveEmail = async ()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid
                };
                await moveToInbox(emailKey, selectedEmail);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email moved to Inbox.");
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error moving email to Inbox.");
            }
        });
    };
    const onDeleteEmail = ()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid
                };
                const trashEmail = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid,
                    email: selectedEmail,
                    deletedIsoDateTimeUtc: new Date().toISOString(),
                    type: "InboundEmail"
                };
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).trashEmail.set(emailKey, trashEmail);
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).archiveEmail.remove(emailKey);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email Deleted Successfully");
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error in deleting email.");
            }
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "inbox-page",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-list-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-list-header",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "inbox-heading",
                                children: "Archive"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "switch-button",
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                    className: `all-mail ${!filterUnreadEmails ? "active" : ""}`,
                                    onClick: ()=>setFilterUnreadEmails(false),
                                    children: "All Mail"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $22debc56734d8b81$export$2254b0989e55311a), {
                        emailList: emailList,
                        onSelectEmail: (email)=>setSelectedEmail(email),
                        filteredEmails: filteredEmails
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-view-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-action-items",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $aeccf260e1d80429$export$2e2bcd8739ae039), {
                                        onClick: unarchiveEmail,
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $4a3e3b31eaf267f5$export$2e2bcd8739ae039), {
                                        onClick: onDeleteEmail,
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d3cf15f05a45b5f1$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "reply-actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $e2aac91a83df5208$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $08d99fd9a80399e4$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $74a355a98cbe0193$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fcc43edb3befdd80$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $0293bafd0b0f345e$export$abfd25e9b055f9f7), {
                        email: selectedEmail
                    })
                ]
            })
        ]
    });
};



(function(emailPortalRoutes) {
    emailPortalRoutes.home = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)("/");
    emailPortalRoutes.archive = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)("/archive");
    emailPortalRoutes.trash = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)("/trash");
    emailPortalRoutes.outbox = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)("/outbox");
    emailPortalRoutes.drafts = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)("/drafts");
    emailPortalRoutes.compose = (0, $e404b4293f3fed4b$export$857b1a87d5c023b8)("/compose");
})($8824c6d408f1dcf5$export$dbfe4c5a60859fdc || ($8824c6d408f1dcf5$export$dbfe4c5a60859fdc = {}));
var $8824c6d408f1dcf5$export$dbfe4c5a60859fdc;





/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $809dddba6fd4fe2e$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Inbox", [
    [
        "polyline",
        {
            points: "22 12 16 12 14 15 10 15 8 12 2 12",
            key: "o97t9d"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $822da6a70da6ab85$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Info", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2666246f8608ff05$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("MessageSquare", [
    [
        "path",
        {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
            key: "1lielz"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9619887429029277$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Plus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f505464562c9b27b$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Send", [
    [
        "path",
        {
            d: "m22 2-7 20-4-9-9-4Z",
            key: "1q3vgg"
        }
    ],
    [
        "path",
        {
            d: "M22 2 11 13",
            key: "nzbqef"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $777d2e0e1a9f662b$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("ShoppingCart", [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30877290b230a66b$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("StickyNote", [
    [
        "path",
        {
            d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z",
            key: "qazsjp"
        }
    ],
    [
        "path",
        {
            d: "M15 3v4a2 2 0 0 0 2 2h4",
            key: "40519r"
        }
    ]
]);

/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34872732570c4353$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("Users", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "path",
        {
            d: "M16 3.13a4 4 0 0 1 0 7.75",
            key: "1da9ce"
        }
    ]
]);



var $lldlC = parcelRequire("lldlC");




// Function to render individual sidebar links
const $b14ae70f620f620d$var$renderSidebarLinks = (props)=>{
    // Styles for the selected mailbox link
    const linkStyle = props.isSelected ? {
        backgroundColor: "black",
        color: "white"
    } : {};
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "sidebar-links",
        onClick: props.onClick,
        style: {
            ...linkStyle
        },
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "link-icon",
                children: [
                    props.icon,
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "text",
                        style: {
                            color: props.isSelected ? "white" : "black"
                        },
                        children: props.mailboxName
                    })
                ]
            }),
            props.count !== 0 && /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "count",
                style: {
                    color: props.isSelected ? "white" : "black"
                },
                children: JSON.stringify(props.count)
            })
        ]
    });
};
const $b14ae70f620f620d$export$94caefe5d2e4140b = ()=>{
    const auth = (0, $45ef3258e41ae9d6$export$1d39dc5b47e56ff0)();
    const navigateTo = (0, $20bbbf7d5bcb0a93$export$9770f232ac06a008)();
    const location = useLocation();
    // Get the current path and convert it to a mailbox name
    const initialSelectedMailbox = ()=>{
        const path = location.pathname.slice(1); // Remove leading slash
        if (path === "") return "Inbox";
        return path.charAt(0).toUpperCase() + path.slice(1); // Capitalize first letter
    };
    // State variables to hold email counts and selected mailbox
    const [inboxCount, setInboxCount] = (0, $lldlC.useState)(null);
    const [archiveCount, setArchiveCount] = (0, $lldlC.useState)(null);
    const [draftsCount, setDraftsCount] = (0, $lldlC.useState)(null);
    const [selectedMailbox, setSelectedMailbox] = (0, $lldlC.useState)(initialSelectedMailbox());
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    // Update selected mailbox when URL changes
    (0, $lldlC.useEffect)(()=>{
        setSelectedMailbox(initialSelectedMailbox());
    }, [
        location.pathname
    ]);
    // Fetch the count of emails in the inbox
    const fetchInboxCount = (0, $lldlC.useCallback)(async ()=>{
        try {
            const count = await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).inbox.getCount({
                key: {
                    orgId: org.id,
                    uid: user.uid
                }
            });
            setInboxCount(count ?? 0); // Set inbox count or default to 0
        } catch (error) {
            console.error("Failed to fetch inbox count:", error);
            setInboxCount(0); // Default to 0 in case of an error
        }
    }, [
        org,
        user
    ]);
    // Fetch the count of emails in the archive
    const fetchArchiveCount = (0, $lldlC.useCallback)(async ()=>{
        try {
            const count = await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).archive.getCount({
                key: {
                    orgId: org.id,
                    uid: user.uid
                }
            });
            setArchiveCount(count ?? 0); // Set archive count or default to 0
        } catch (error) {
            console.error("Failed to fetch archive count:", error);
            setArchiveCount(0); // Default to 0 in case of an error
        }
    }, [
        org,
        user
    ]);
    const fetchDraftsCount = (0, $lldlC.useCallback)(async ()=>{
        try {
            const count = await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).drafts.getCount({
                key: {
                    orgId: org.id,
                    uid: user.uid
                }
            });
            setDraftsCount(count ?? 0); // Set drafts count or default to 0
        } catch (error) {
            console.error("Failed to fetch drafts count:", error);
            setDraftsCount(0); // Default to 0 in case of an error
        }
    }, [
        org,
        user
    ]);
    // Use effect to fetch email counts on component mount and whenever org/user changes
    (0, $lldlC.useEffect)(()=>{
        fetchInboxCount();
        fetchArchiveCount();
        fetchDraftsCount();
    }, [
        fetchInboxCount,
        fetchArchiveCount,
        fetchDraftsCount,
        org,
        user
    ]);
    // Logout function
    const logout = ()=>{
        auth.logout();
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "sidebar",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "zickko-logo-container",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("img", {
                    src: "/images/logo-small-zickko.svg",
                    className: "zickko-logo",
                    onClick: ()=>navigateTo("/")
                })
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "mailboxes",
                children: [
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Compose",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $9619887429029277$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 0,
                        isSelected: selectedMailbox === "Compose",
                        onClick: ()=>{
                            setSelectedMailbox("Compose");
                            navigateTo((0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).compose.link({}, {}));
                        }
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Inbox",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $809dddba6fd4fe2e$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: inboxCount ?? 0,
                        isSelected: selectedMailbox === "Inbox",
                        onClick: ()=>{
                            setSelectedMailbox("Inbox");
                            navigateTo((0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).home.link({}, {}));
                        }
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Drafts",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $30877290b230a66b$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: draftsCount ?? 0,
                        isSelected: selectedMailbox === "Drafts",
                        onClick: ()=>{
                            setSelectedMailbox("Drafts");
                            navigateTo((0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).drafts.link({}, {}));
                        }
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Sent",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $f505464562c9b27b$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 0,
                        isSelected: selectedMailbox === "Sent",
                        onClick: ()=>{
                            setSelectedMailbox("Sent");
                            navigateTo((0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).outbox.link({}, {}));
                        }
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Junk",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $aeccf260e1d80429$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 23,
                        isSelected: selectedMailbox === "Junk",
                        onClick: ()=>setSelectedMailbox("Junk")
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Trash",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $4a3e3b31eaf267f5$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 0,
                        isSelected: selectedMailbox === "Trash",
                        onClick: ()=>{
                            setSelectedMailbox("Trash");
                            navigateTo((0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).trash.link({}, {}));
                        }
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Archive",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $f12f1155aadc5539$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: archiveCount ?? 0,
                        isSelected: selectedMailbox === "Archive",
                        onClick: ()=>{
                            setSelectedMailbox("Archive");
                            navigateTo((0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).archive.link({}, {}));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "categories",
                children: [
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Social",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $34872732570c4353$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 972,
                        isSelected: selectedMailbox === "Social",
                        onClick: ()=>setSelectedMailbox("Social")
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Updates",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $822da6a70da6ab85$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 342,
                        isSelected: selectedMailbox === "Updates",
                        onClick: ()=>setSelectedMailbox("Updates")
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Forums",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $2666246f8608ff05$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 128,
                        isSelected: selectedMailbox === "Forums",
                        onClick: ()=>setSelectedMailbox("Forums")
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Shopping",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $777d2e0e1a9f662b$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 8,
                        isSelected: selectedMailbox === "Shopping",
                        onClick: ()=>setSelectedMailbox("Shopping")
                    }),
                    $b14ae70f620f620d$var$renderSidebarLinks({
                        mailboxName: "Promotions",
                        icon: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $f12f1155aadc5539$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        count: 21,
                        isSelected: selectedMailbox === "Promotions",
                        onClick: ()=>setSelectedMailbox("Promotions")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "logout-button-container",
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    onClick: logout,
                    className: "logout-button",
                    style: {
                        backgroundColor: "black",
                        color: "white"
                    },
                    children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "logout-icon",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "text",
                                children: "Log Out"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("i", {
                                className: "las la-sign-out-alt"
                            })
                        ]
                    })
                })
            })
        ]
    });
};



const $eec03822ac56ea7b$export$abc2f46d9111e3f5 = ()=>{
    //
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $23510c92e640383c$export$c84671f46d6a1ca), {
        name: "email-portal layout-sidebar",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $b14ae70f620f620d$export$94caefe5d2e4140b), {}),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$910ae8079b2c2852), {})
        ]
    });
};








var $lldlC = parcelRequire("lldlC");



const $da526389afbfdafc$export$96a4b5ae04e022c6 = (props)=>{
    const { email: email, onSelectEmail: onSelectEmail } = props;
    const snippet = "No preview available";
    const handleEmailClick = ()=>{
        onSelectEmail();
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "email-list-item-widget-container",
        onClick: handleEmailClick,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "email-list-item-widget",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "heading",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "sender",
                            children: email.from
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "time",
                            children: "9 months ago"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "subject",
                    children: email.subject
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "mail-snippet",
                    children: [
                        snippet,
                        " . . . "
                    ]
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "tags",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "meeting-tag",
                            children: "meeting"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "work-tag",
                            children: "work"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "important-tag",
                            children: "important"
                        })
                    ]
                })
            ]
        })
    });
};


const $44d5acc291a47f3e$export$8e88b1b000794a6d = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "list-container",
        children: props.emailList.length === 0 ? /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "no-emails-message",
            children: "No emails available."
        }) : props.emailList.map((email)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $da526389afbfdafc$export$96a4b5ae04e022c6), {
                email: email,
                onSelectEmail: ()=>props.onSelectEmail(email)
            }, email.id))
    });
};







var $lldlC = parcelRequire("lldlC");





const $cd0f2ecd23850246$export$40275496566f18b2 = (props)=>{
    const { email: email } = props;
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [htmlContentUrl, setHtmlContentUrl] = (0, $lldlC.useState)(null);
    const [formattedDate, setFormattedDate] = (0, $lldlC.useState)(null);
    const [htmlContent, setHtmlContent] = (0, $lldlC.useState)(null);
    const [replyText, setReplyText] = (0, $lldlC.useState)(null);
    const [attachments, setAttachments] = (0, $lldlC.useState)([]);
    const [uploadProgress, setUploadProgress] = (0, $lldlC.useState)({});
    const [busyFlag, setBusyFlag] = (0, $lldlC.useState)(false);
    const getHtmlContentUrl = (0, $lldlC.useCallback)(()=>{
        const storage = (0, $3fab5dd6ec5d4e72$export$fbd9b57a66480737)();
        const pathReference = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)(storage, (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundEmailHtmlContentPath({
            orgId: org.id,
            emailId: email?.id,
            uid: user.uid
        }));
        if (email !== undefined && email !== null) (0, $3fab5dd6ec5d4e72$export$c8bf645a0c2a7d9f)(pathReference).then(async (url)=>{
            setHtmlContentUrl(url);
            const response = await fetch(url);
            const text = await response.text();
            setHtmlContent(text);
            setHtmlContentUrl(url);
        }).catch((e)=>{
            (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error("Error loading email content.");
        });
    }, [
        email
    ]);
    const formatDate = (inputDateStr)=>{
        const date = new Date(inputDateStr);
        const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true
        };
        setFormattedDate(date.toLocaleString("en-US", options));
    };
    (0, $lldlC.useEffect)(()=>{
        getHtmlContentUrl();
        formatDate(email?.createdIsoDateTimeUtc);
    }, [
        getHtmlContentUrl
    ]);
    if (email === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading..."
    });
    if (email === null) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Email not found."
    });
    const onDownloadAttachment = (attachment)=>{
        const storage = (0, $3fab5dd6ec5d4e72$export$fbd9b57a66480737)();
        const pathReference = (0, $3fab5dd6ec5d4e72$export$eff4d24c3ff7876e)(storage, attachment.gcsFile.path);
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const url = await (0, $3fab5dd6ec5d4e72$export$c8bf645a0c2a7d9f)(pathReference); // Get the download URL
                const response = await fetch(url); // Fetch the file as a Blob
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob); // Create a Blob URL for the download
                return {
                    blobUrl: blobUrl,
                    filename: attachment.gcsFile.filename || "file.pdf"
                };
            },
            onSuccess: ({ blobUrl: blobUrl, filename: filename })=>{
                const link = document.createElement("a");
                link.href = blobUrl;
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Append the link to the DOM, trigger the download, and clean up
                link.style.display = "none";
                link.click(); // Trigger the download
                document.body.removeChild(link); // Remove the link from DOM
                window.URL.revokeObjectURL(blobUrl); // Release the blob URL
            },
            onError: (error)=>{
                console.error("Error downloading attachment:", error);
                (0, $b6d41c69473fd19b$export$e80fa18a42ed98ef).error("Error downloading attachment.");
            },
            loadingMessage: "Downloading attachment..."
        });
    };
    const renderAttachments = ()=>{
        if (!email.attachedFiles || email.attachedFiles.length === 0) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("h2", {
                    children: "Attachments"
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "attachments-div",
                    children: email.attachedFiles.filter((e)=>e.contentDisposition === "attachment").map((attachment, index)=>{
                        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                onClick: ()=>onDownloadAttachment(attachment),
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                    className: "email-attachment-text",
                                    children: `Attachment ${index + 1}`
                                })
                            })
                        }, attachment.gcsFile.id);
                    })
                })
            ]
        });
    };
    const renderHtmlContent = ()=>{
        if (!htmlContent) return null;
        return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: htmlContent
            }
        });
    };
    const uploadHtmlContent = async (outboundEmailId)=>{
        const bucketName = (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket;
        const emailKey = {
            orgId: org.id,
            uid: user.uid,
            emailId: outboundEmailId
        };
        const folderPath = (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundEmailHtmlContentPath({
            ...emailKey
        });
        const result = await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $a99cf1e9ec04ed13$export$7c3d578662763a63)({
                    contents: replyText,
                    gcsBucket: bucketName,
                    gcsFolder: folderPath,
                    fileExtension: "html",
                    contentType: "html",
                    filename: "html_content"
                }),
            loadingMessage: `Uploading file`
        });
        return result;
    };
    const uploadAttachments = async (outboundEmailId)=>{
        const bucketName = (0, $22fc247a044a5f09$export$26cc430c2fed42ce).storageBucket;
        const uploadAttachmentMetadata = [];
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            loadingMessage: "Uploading attachments...",
            successMessage: "Attachments uploaded successfully!",
            fn: async ()=>{
                await Promise.all(attachments.map(async (file)=>{
                    const path = (0, $0a8d0e62beb81aa5$export$f5c0819de731e325).outboundAttachmentPath({
                        orgId: org.id,
                        uid: user.uid,
                        emailId: outboundEmailId,
                        attachmentId: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId()
                    });
                    // Upload file to GCS
                    await (0, $fce4445636ac7988$export$6c5453569d966c6d)({
                        file: file,
                        path: path,
                        bucket: bucketName,
                        onProgress: (percentage)=>{
                            setUploadProgress((prev)=>({
                                    ...prev,
                                    [file.name]: percentage
                                }));
                        }
                    });
                    // Collect file metadata
                    const metadata = {
                        gcsFile: {
                            path: path,
                            id: (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId(),
                            bucket: bucketName,
                            filename: file.name || ""
                        },
                        contentType: file.type,
                        contentDisposition: "attachment",
                        size: file.size
                    };
                    uploadAttachmentMetadata.push(metadata);
                }));
            },
            onError: (e)=>console.error("Failed to upload attachments:", e),
            onComplete: ()=>console.log("Upload process completed.")
        });
        return uploadAttachmentMetadata;
    };
    const createOutboundEmailEntity = async (outboundEmailId, htmlContent, attachments)=>{
        const outboundEmail = {
            id: outboundEmailId,
            uid: user.uid,
            orgId: org.id,
            from: user.email,
            to: email.from,
            subject: email.subject,
            status: (0, $ec875ec52581da02$export$96e9906d6d93a972).failure,
            htmlContent: htmlContent,
            attachedFiles: attachments || []
        };
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>(0, $abf2d4628a1238d4$export$2b8e1946228932b7).outboundEmail.set({
                    uid: user.uid,
                    orgId: org.id,
                    emailId: outboundEmail.id
                }, outboundEmail),
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Reply sent successfully!");
            }
        });
    };
    const onSendReply = async ()=>{
        const outboundEmailId = (0, $d0a2c8f56fdc7af2$export$609c6c141bd766ba).createId();
        await (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const htmlContent = await uploadHtmlContent(outboundEmailId); // Upload HTML content
                const outboundAttachmentMetadata = await uploadAttachments(outboundEmailId); // Upload attachments
                await createOutboundEmailEntity(outboundEmailId, htmlContent, outboundAttachmentMetadata); // Create outbound email entry
            },
            loadingMessage: "Sending reply...",
            setBusyFlag: setBusyFlag,
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Reply sent successfully!");
            },
            onError: (error)=>{
                console.error("Error sending reply:", error);
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error sending reply.");
            }
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "mail-header-container",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "name-timestamp-container",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                children: email.from
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "timestamp",
                                children: formattedDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "subject",
                        children: email.subject
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "sender",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("span", {
                                children: "Reply To:"
                            }),
                            " ",
                            email.to
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "mail-content",
                children: renderHtmlContent()
            }),
            renderAttachments(),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "reply-section",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("textarea", {
                        placeholder: "Reply...",
                        className: "text-area",
                        onChange: (e)=>setReplyText(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "send-button-container",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "upload-attachments",
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("input", {
                                    type: "file",
                                    multiple: true,
                                    onChange: (e)=>setAttachments((prev)=>[
                                                ...prev,
                                                ...Array.from(e.target.files || [])
                                            ])
                                })
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "attachments-progress",
                                children: attachments.map((file)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                        children: [
                                            file.name,
                                            ": ",
                                            uploadProgress[file.name]?.toFixed(2) || 0,
                                            "% uploaded"
                                        ]
                                    }, file.name))
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("button", {
                                className: "send-button",
                                onClick: onSendReply,
                                children: "Send"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




const $43352e848c91fbe8$export$67a75564b39737f6 = ()=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [searchParams, setSearchParams] = (0, $5eed20d16fad0e34$export$f1a78c17382fe22a)();
    const [selectedEmail, setSelectedEmail] = (0, $lldlC.useState)();
    const emailId = searchParams.get("emailId");
    const { list: emailList = [] } = (0, $02a6a4d8defc9d58$export$280a58d17031e34d)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).outbox, {
        key: {
            orgId: org.id,
            uid: user.uid
        },
        orderByField: "uid",
        orderByDirection: "desc"
    });
    (0, $lldlC.useEffect)(()=>{
        if (!selectedEmail && emailList.length > 0) {
            const firstEmail = emailList[0];
            setSearchParams({
                emailId: firstEmail.id
            });
            setSelectedEmail(firstEmail);
        } else if (selectedEmail) setSearchParams({
            emailId: selectedEmail.id
        });
    }, [
        selectedEmail,
        emailList,
        setSearchParams,
        setSelectedEmail
    ]);
    if (emailList === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading emails..."
    });
    const onDeleteEmail = ()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid
                };
                const trashEmail = {
                    emailId: emailId,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid,
                    email: selectedEmail,
                    deletedIsoDateTimeUtc: new Date().toISOString(),
                    type: "OutboundEmail"
                };
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).trashEmail.set(emailKey, trashEmail);
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).outboundEmail.remove(emailKey);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email Deleted Successfully");
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error in deleting email.");
            }
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "inbox-page",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-list-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-list-header",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "inbox-heading",
                                children: "Outbox"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "switch-button",
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                    className: `all-mail`,
                                    children: "All Mail"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $44d5acc291a47f3e$export$8e88b1b000794a6d), {
                        emailList: emailList,
                        onSelectEmail: (email)=>setSelectedEmail(email)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-view-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-action-items",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $4a3e3b31eaf267f5$export$2e2bcd8739ae039), {
                                        onClick: onDeleteEmail,
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d3cf15f05a45b5f1$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "reply-actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $e2aac91a83df5208$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $08d99fd9a80399e4$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $74a355a98cbe0193$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fcc43edb3befdd80$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $cd0f2ecd23850246$export$40275496566f18b2), {
                        email: selectedEmail
                    })
                ]
            })
        ]
    });
};







var $lldlC = parcelRequire("lldlC");




const $61f7568e260de960$export$7ba135f5715c9ffd = (props)=>{
    const { email: email, onSelectEmail: onSelectEmail } = props;
    const senderName = email.headers?.from?.name || email.from || "Unknown Sender";
    const subject = email.headers?.subject || email.subject || "No Subject";
    const snippet = email?.previewSnippet || "No preview available";
    const handleEmailClick = ()=>{
        onSelectEmail();
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "email-list-item-widget-container",
        onClick: handleEmailClick,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "email-list-item-widget",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "heading",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "sender",
                            children: senderName
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "time",
                            children: "9 months ago"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "subject",
                    children: subject
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "mail-snippet",
                    children: [
                        snippet,
                        " . . . "
                    ]
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "tags",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "meeting-tag",
                            children: "meeting"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "work-tag",
                            children: "work"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "important-tag",
                            children: "important"
                        })
                    ]
                })
            ]
        })
    });
};


const $dd9df04008d2e446$export$8c361bf97991267a = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "list-container",
        children: props.emailList.length === 0 ? /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "no-emails-message",
            children: "No emails available."
        }) : props.emailList.map((email)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $61f7568e260de960$export$7ba135f5715c9ffd), {
                email: email.email,
                onSelectEmail: ()=>props.onSelectEmail(email)
            }, email.emailId))
    });
};


/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ed9e8828f1f28c6f$export$2e2bcd8739ae039 = (0, $5ffb589cfd67dd25$export$2e2bcd8739ae039)("BookPlus", [
    [
        "path",
        {
            d: "M12 7v6",
            key: "lw1j43"
        }
    ],
    [
        "path",
        {
            d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
            key: "k3hazp"
        }
    ],
    [
        "path",
        {
            d: "M9 10h6",
            key: "9gxzsh"
        }
    ]
]);




const $9fc411d0766dd3be$export$dd453bc503b691c9 = ()=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [searchParams, setSearchParams] = (0, $5eed20d16fad0e34$export$f1a78c17382fe22a)();
    const [selectedEmail, setSelectedEmail] = (0, $lldlC.useState)();
    const emailId = searchParams.get("emailId");
    const { list: emailList = [] } = (0, $02a6a4d8defc9d58$export$280a58d17031e34d)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).trash, {
        key: {
            orgId: org.id,
            uid: user.uid
        },
        orderByField: "uid",
        orderByDirection: "desc"
    });
    (0, $lldlC.useEffect)(()=>{
        if (!selectedEmail && emailList.length > 0) {
            const firstEmail = emailList[0];
            setSearchParams({
                emailId: firstEmail.emailId
            });
            setSelectedEmail(firstEmail);
        } else if (selectedEmail) setSearchParams({
            emailId: selectedEmail.emailId
        });
    }, [
        selectedEmail,
        emailList,
        setSearchParams,
        setSelectedEmail
    ]);
    if (emailList === undefined) return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        children: "Loading emails..."
    });
    const onDeleteEmailFromTrash = ()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: selectedEmail.email.orgId,
                    uid: selectedEmail.email.uid
                };
                return (0, $abf2d4628a1238d4$export$2b8e1946228932b7).trashEmail.remove(emailKey);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email Deleted Successfully");
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error in deleting email.");
            }
        });
    };
    const onRestoreEmailFromTrash = ()=>{
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: async ()=>{
                const emailKey = {
                    emailId: emailId,
                    orgId: selectedEmail.email.orgId,
                    uid: selectedEmail.email.uid
                };
                const trashEmail = await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).trashEmail.get(emailKey);
                if (!trashEmail) throw new Error("Email not found in trash.");
                switch(trashEmail.type){
                    case "InboundEmail":
                        await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).inboundEmail.set(emailKey, trashEmail.email);
                        break;
                    case "OutboundEmail":
                        await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).outboundEmail.set(emailKey, trashEmail.email);
                        break;
                    default:
                        throw new Error("Unsupported email type.");
                }
                await (0, $abf2d4628a1238d4$export$2b8e1946228932b7).trashEmail.remove(emailKey);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Email Successfully restored from Trash");
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error in restoring email.");
            }
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "inbox-page",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-list-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-list-header",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "inbox-heading",
                                children: "Trash"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "switch-button",
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                    className: `all-mail`,
                                    children: "All Mail"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $dd9df04008d2e446$export$8c361bf97991267a), {
                        emailList: emailList,
                        onSelectEmail: (email)=>setSelectedEmail(email)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-view-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-action-items",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $4a3e3b31eaf267f5$export$2e2bcd8739ae039), {
                                        onClick: onDeleteEmailFromTrash,
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $ed9e8828f1f28c6f$export$2e2bcd8739ae039), {
                                        onClick: onRestoreEmailFromTrash,
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d3cf15f05a45b5f1$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                className: "reply-actions",
                                children: [
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $e2aac91a83df5208$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $08d99fd9a80399e4$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $74a355a98cbe0193$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                        className: "vertical-line",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fcc43edb3befdd80$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                ]
                            })
                        ]
                    }),
                    selectedEmail?.type === "InboundEmail" ? /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $0293bafd0b0f345e$export$abfd25e9b055f9f7), {
                        email: selectedEmail?.email
                    }) : /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $cd0f2ecd23850246$export$40275496566f18b2), {
                        email: selectedEmail?.email
                    })
                ]
            })
        ]
    });
};







var $lldlC = parcelRequire("lldlC");





const $abe8fa0637109151$export$e01175dbe40b3943 = (props)=>{
    const { email: email, onSelectEmail: onSelectEmail } = props;
    const subject = email.subject || "No Subject";
    const handleEmailClick = ()=>{
        onSelectEmail();
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "email-list-item-widget-container",
        onClick: handleEmailClick,
        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
            className: "email-list-item-widget",
            children: [
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "heading",
                    children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                        className: "time",
                        children: "9 months ago"
                    })
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "subject",
                    children: subject
                }),
                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                    className: "tags",
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "meeting-tag",
                            children: "meeting"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "work-tag",
                            children: "work"
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                            className: "important-tag",
                            children: "important"
                        })
                    ]
                })
            ]
        })
    });
};


const $b7429d0e084201c7$export$57a743177c011f4e = (props)=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
        className: "list-container",
        children: props.emailList.length === 0 ? /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
            className: "no-emails-message",
            children: "No drafts available."
        }) : props.emailList.map((email)=>/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $abe8fa0637109151$export$e01175dbe40b3943), {
                email: email,
                onSelectEmail: ()=>props.onSelectEmail(email)
            }, email.id))
    });
};



const $6aace062f7b5e549$export$b38332414a529c83 = ()=>{
    const { org: org } = (0, $fdd2fbc855c6b00a$export$7f785727a26e156)();
    const { user: user } = (0, $7916f3d550438e18$export$23bbbc4533528f03)();
    const [searchParams, setSearchParams] = (0, $5eed20d16fad0e34$export$f1a78c17382fe22a)();
    const [selectedEmail, setSelectedEmail] = (0, $lldlC.useState)(null);
    const emailId = searchParams.get("emailId");
    const { list: emailList = [] } = (0, $02a6a4d8defc9d58$export$280a58d17031e34d)((0, $15fd4ed8634ba885$export$12a1c52a4bb19f32).drafts, {
        key: {
            orgId: org.id,
            uid: user.uid
        },
        orderByField: "lastModified",
        orderByDirection: "desc",
        limit: 10
    });
    (0, $lldlC.useEffect)(()=>{
        if (!selectedEmail && emailList.length > 0) {
            const firstEmail = emailList[0];
            setSearchParams({
                emailId: firstEmail.id
            });
            setSelectedEmail(firstEmail);
        } else if (selectedEmail) setSearchParams({
            emailId: selectedEmail.id
        });
    }, [
        selectedEmail,
        emailList,
        setSearchParams,
        setSelectedEmail
    ]);
    const onDeleteEmail = ()=>{
        if (!selectedEmail) return;
        (0, $3b62bcaeb57932ae$export$fb792135d445702e)({
            fn: ()=>{
                const emailKey = {
                    emailId: selectedEmail.id,
                    orgId: selectedEmail.orgId,
                    uid: selectedEmail.uid
                };
                return (0, $abf2d4628a1238d4$export$2b8e1946228932b7).draftEmail.remove(emailKey);
            },
            onSuccess: ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).success("Draft Deleted Successfully");
                setSelectedEmail(null); // Reset selection after deletion
            },
            onError (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4d0abda1dc9c23ff$exports))).error("Error in deleting draft.");
            }
        });
    };
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        className: "inbox-page",
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                className: "email-list-widget",
                children: [
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                        className: "email-list-header",
                        children: [
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "inbox-heading",
                                children: "Drafts"
                            }),
                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                className: "switch-button",
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                    className: `all-mail`,
                                    children: "All Mail"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $b7429d0e084201c7$export$57a743177c011f4e), {
                        emailList: emailList,
                        onSelectEmail: (email)=>setSelectedEmail(email)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                className: "email-view-widget",
                children: emailList.length === 0 ? /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                    className: "no-drafts-message",
                    children: "No drafts to see"
                }) : /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $c53f8b07b96ee0c5$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                            className: "email-action-items",
                            children: [
                                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                    className: "actions",
                                    children: [
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $4a3e3b31eaf267f5$export$2e2bcd8739ae039), {
                                            onClick: onDeleteEmail,
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                            className: "vertical-line"
                                        }),
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d3cf15f05a45b5f1$export$2e2bcd8739ae039), {
                                            size: 18
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
                                    className: "reply-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $e2aac91a83df5208$export$2e2bcd8739ae039), {
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $08d99fd9a80399e4$export$2e2bcd8739ae039), {
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $74a355a98cbe0193$export$2e2bcd8739ae039), {
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)("div", {
                                            className: "vertical-line"
                                        }),
                                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fcc43edb3befdd80$export$2e2bcd8739ae039), {
                                            size: 18
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $d6c2a27c8436e441$export$ec1ed5c0651cbbdf), {
                            mode: (0, $d6c2a27c8436e441$export$9484bbecc3c49a2e).Drafts,
                            currentDraft: selectedEmail
                        })
                    ]
                })
            })
        ]
    });
};


// TODO:SCSS import "../../../library/client/src/scss/style.scss";
const $1a66a1346b503be0$var$EmailPortal = ()=>{
    return /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $4d0abda1dc9c23ff$exports.Toaster), {}),
            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $5eed20d16fad0e34$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $45ef3258e41ae9d6$export$87091915187a1a85), {
                    children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $592a0f3ddb09dd65$export$6df4068a17305b10), {
                        isAdminPortal: false,
                        children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $7916f3d550438e18$export$88f24fd8fcfab6ca), {
                            children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $fdd2fbc855c6b00a$export$35eae644bb87870c), {
                                children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$3565eb3d00ca5a74), {
                                    children: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsxs)((0, $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $eec03822ac56ea7b$export$abc2f46d9111e3f5), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6), {
                                                path: (0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).home.template,
                                                element: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $3dbdfbf7a6468e70$export$17e4068f9ad0565b), {})
                                            }),
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6), {
                                                path: (0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).compose.template,
                                                element: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $92b9211e2af40749$export$fe28394a32231fdf), {})
                                            }),
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6), {
                                                path: (0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).archive.template,
                                                element: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $713e32c6eae25ee8$export$ea490c2795d126e1), {})
                                            }),
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6), {
                                                path: (0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).trash.template,
                                                element: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $9fc411d0766dd3be$export$dd453bc503b691c9), {})
                                            }),
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6), {
                                                path: (0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).outbox.template,
                                                element: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $43352e848c91fbe8$export$67a75564b39737f6), {})
                                            }),
                                            /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $20bbbf7d5bcb0a93$export$e7b0ac011bb776c6), {
                                                path: (0, $8824c6d408f1dcf5$export$dbfe4c5a60859fdc).drafts.template,
                                                element: /*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)((0, $6aace062f7b5e549$export$b38332414a529c83), {})
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
(0, $dba17d0653e4af30$export$882461b6382ed46c)(document.getElementById("app")).render(/*#__PURE__*/ (0, $c53f8b07b96ee0c5$exports.jsx)($1a66a1346b503be0$var$EmailPortal, {}));


//# sourceMappingURL=index.8e26d276.js.map
